
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree8ef"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree8ef"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
'use strict';

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $92f4fea5bc247620$export$3ba232387fd5d6dd; }, function (v) { return $92f4fea5bc247620$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$3ba232387fd5d6dd;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
'use strict';
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
function $92f4fea5bc247620$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$3ba232387fd5d6dd = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
'use strict';

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$Lg(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$Lg(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$Sg(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Ug = $b36288e2db101ba3$var$Og(!0), $b36288e2db101ba3$var$Vg = $b36288e2db101ba3$var$Og(!1), $b36288e2db101ba3$var$Wg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Xg = null, $b36288e2db101ba3$var$Yg = null, $b36288e2db101ba3$var$Zg = null;
function $b36288e2db101ba3$var$$g() {
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Xg = null;
}
function $b36288e2db101ba3$var$ah(a) {
    var b = $b36288e2db101ba3$var$Wg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$ch(a, b) {
    $b36288e2db101ba3$var$Xg = a;
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$dh = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$eh(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Yg) {
            if (null === $b36288e2db101ba3$var$Xg) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Yg = a;
            $b36288e2db101ba3$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Yg.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$fh = null;
function $b36288e2db101ba3$var$gh(a) {
    null === $b36288e2db101ba3$var$fh ? $b36288e2db101ba3$var$fh = [
        a
    ] : $b36288e2db101ba3$var$fh.push(a);
}
function $b36288e2db101ba3$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$ih(a, d);
}
function $b36288e2db101ba3$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$jh = !1;
function $b36288e2db101ba3$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$ih(a, c);
}
function $b36288e2db101ba3$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$th = {}, $b36288e2db101ba3$var$uh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$vh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$wh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th);
function $b36288e2db101ba3$var$xh(a) {
    if (a === $b36288e2db101ba3$var$th) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$yh(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$wh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, $b36288e2db101ba3$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, b);
}
function $b36288e2db101ba3$var$zh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$wh);
}
function $b36288e2db101ba3$var$Ah(a) {
    $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
    var b = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, c));
}
function $b36288e2db101ba3$var$Bh(a) {
    $b36288e2db101ba3$var$vh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh));
}
var $b36288e2db101ba3$var$L = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Dh = [];
function $b36288e2db101ba3$var$Eh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Dh.length; a++)$b36288e2db101ba3$var$Dh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Dh.length = 0;
}
var $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Hh = 0, $b36288e2db101ba3$var$M = null, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$Ih = !1, $b36288e2db101ba3$var$Jh = !1, $b36288e2db101ba3$var$Kh = 0, $b36288e2db101ba3$var$Lh = 0;
function $b36288e2db101ba3$var$P() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Nh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Hh = f;
    $b36288e2db101ba3$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Fh.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Oh : $b36288e2db101ba3$var$Ph;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Jh) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Qh;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Jh);
    }
    $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
    b = null !== $b36288e2db101ba3$var$N && null !== $b36288e2db101ba3$var$N.next;
    $b36288e2db101ba3$var$Hh = 0;
    $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
    $b36288e2db101ba3$var$Ih = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$Sh() {
    var a = 0 !== $b36288e2db101ba3$var$Kh;
    $b36288e2db101ba3$var$Kh = 0;
    return a;
}
function $b36288e2db101ba3$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Uh() {
    if (null === $b36288e2db101ba3$var$N) {
        var a = $b36288e2db101ba3$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$N.next;
    var b = null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState : $b36288e2db101ba3$var$O.next;
    if (null !== b) $b36288e2db101ba3$var$O = b, $b36288e2db101ba3$var$N = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$N = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$N.memoizedState,
            baseState: $b36288e2db101ba3$var$N.baseState,
            baseQueue: $b36288e2db101ba3$var$N.baseQueue,
            queue: $b36288e2db101ba3$var$N.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    }
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$Wh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$M.lanes |= m;
                $b36288e2db101ba3$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$M.lanes |= f, $b36288e2db101ba3$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$Xh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$Yh() {}
function $b36288e2db101ba3$var$Zh(a, b) {
    var c = $b36288e2db101ba3$var$M, d = $b36288e2db101ba3$var$Uh(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$dh = !0);
    d = d.queue;
    $b36288e2db101ba3$var$$h($b36288e2db101ba3$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$O && $b36288e2db101ba3$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
}
function $b36288e2db101ba3$var$ai(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
    });
}
function $b36288e2db101ba3$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$ih(a, 1);
    null !== b && $b36288e2db101ba3$var$gi(b, a, 1, -1);
}
function $b36288e2db101ba3$var$hi(a) {
    var b = $b36288e2db101ba3$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ii.bind(null, $b36288e2db101ba3$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$ji() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$ki(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Th();
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$N) {
        var g = $b36288e2db101ba3$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Mh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$bi(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$mi(a, b) {
    return $b36288e2db101ba3$var$ki(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$$h(a, b) {
    return $b36288e2db101ba3$var$li(2048, 8, a, b);
}
function $b36288e2db101ba3$var$ni(a, b) {
    return $b36288e2db101ba3$var$li(4, 2, a, b);
}
function $b36288e2db101ba3$var$oi(a, b) {
    return $b36288e2db101ba3$var$li(4, 4, a, b);
}
function $b36288e2db101ba3$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$li(4, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$ri() {}
function $b36288e2db101ba3$var$si(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ti(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ui(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$dh = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$M.lanes |= c, $b36288e2db101ba3$var$rh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$vi(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Gh.transition;
    $b36288e2db101ba3$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Gh.transition = d;
    }
}
function $b36288e2db101ba3$var$wi() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$xi(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, c);
    else if (c = $b36288e2db101ba3$var$hh(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$R();
        $b36288e2db101ba3$var$gi(c, a, d, e);
        $b36288e2db101ba3$var$Bi(c, b, d);
    }
}
function $b36288e2db101ba3$var$ii(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$hh(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$R(), $b36288e2db101ba3$var$gi(c, a, d, e), $b36288e2db101ba3$var$Bi(c, b, d));
    }
}
function $b36288e2db101ba3$var$zi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$M || null !== b && b === $b36288e2db101ba3$var$M;
}
function $b36288e2db101ba3$var$Ai(a, b) {
    $b36288e2db101ba3$var$Jh = $b36288e2db101ba3$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$Rh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$P,
    useContext: $b36288e2db101ba3$var$P,
    useEffect: $b36288e2db101ba3$var$P,
    useImperativeHandle: $b36288e2db101ba3$var$P,
    useInsertionEffect: $b36288e2db101ba3$var$P,
    useLayoutEffect: $b36288e2db101ba3$var$P,
    useMemo: $b36288e2db101ba3$var$P,
    useReducer: $b36288e2db101ba3$var$P,
    useRef: $b36288e2db101ba3$var$P,
    useState: $b36288e2db101ba3$var$P,
    useDebugValue: $b36288e2db101ba3$var$P,
    useDeferredValue: $b36288e2db101ba3$var$P,
    useTransition: $b36288e2db101ba3$var$P,
    useMutableSource: $b36288e2db101ba3$var$P,
    useSyncExternalStore: $b36288e2db101ba3$var$P,
    useId: $b36288e2db101ba3$var$P,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Oh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ki(4194308, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$xi.bind(null, $b36288e2db101ba3$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$hi,
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$hi(!1), b = a[0];
        a = $b36288e2db101ba3$var$vi.bind(null, a[1]);
        $b36288e2db101ba3$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$M, e = $b36288e2db101ba3$var$Th();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$mi($b36288e2db101ba3$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$Th(), b = $b36288e2db101ba3$var$Q.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Ph = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Wh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Qh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Xh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return null === $b36288e2db101ba3$var$N ? b.memoizedState = a : $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b36288e2db101ba3$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$R(), d = $b36288e2db101ba3$var$yi(a), e = $b36288e2db101ba3$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$nh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, d, c), $b36288e2db101ba3$var$oh(b, a, d));
    }
};
function $b36288e2db101ba3$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$eh(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b36288e2db101ba3$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$eh(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$Ei.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Ni(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Oi || ($b36288e2db101ba3$var$Oi = !0, $b36288e2db101ba3$var$Pi = d);
        $b36288e2db101ba3$var$Li(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Qi(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Li(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Ri ? $b36288e2db101ba3$var$Ri = new Set([
            this
        ]) : $b36288e2db101ba3$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$mh(-1, 1), b.tag = 2, $b36288e2db101ba3$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Wi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$dh = !1;
function $b36288e2db101ba3$var$Xi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Vg(b, null, c, d) : $b36288e2db101ba3$var$Ug(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$ch(b, e);
    d = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$bj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$dh = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$Zi(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$cj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj);
            $b36288e2db101ba3$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= d;
    $b36288e2db101ba3$var$Xi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$ch(b, e);
    c = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$ch(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$ij(a, b), $b36288e2db101ba3$var$Gi(b, c, d), $b36288e2db101ba3$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$eh(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$Hi(b, g, d, l);
        $b36288e2db101ba3$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof m && ($b36288e2db101ba3$var$Di(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$eh(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$Hi(b, g, d, k);
        $b36288e2db101ba3$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof y && ($b36288e2db101ba3$var$Di(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$jj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$jj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$Zi(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Ug(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Ug(b, null, h, f)) : $b36288e2db101ba3$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$yh(a, b.containerInfo);
}
function $b36288e2db101ba3$var$lj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Xi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$pj(g, d, 0, null), a = $b36288e2db101ba3$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$nj(c), b.memoizedState = $b36288e2db101ba3$var$mj, a) : $b36288e2db101ba3$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$Pg(h, f) : (f = $b36288e2db101ba3$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$qj(a, b) {
    b = $b36288e2db101ba3$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$sj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Ug(b, a.child, null, c);
    a = $b36288e2db101ba3$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$nj(g);
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Ki(f, d, void 0);
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$dh || h) {
        d = $b36288e2db101ba3$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$ih(a, e), $b36288e2db101ba3$var$gi(d, a, e, -1));
        }
        $b36288e2db101ba3$var$tj();
        d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$bh(a.return, b, c);
}
function $b36288e2db101ba3$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Xi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$vj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$kj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Ah(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$oj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
                a = $b36288e2db101ba3$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$dj(a, b, c);
    }
    return $b36288e2db101ba3$var$Zi(a, b, c);
}
var $b36288e2db101ba3$var$zj, $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj;
$b36288e2db101ba3$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Aj = function() {};
$b36288e2db101ba3$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Dj(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$zh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Aj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Bh(b);
            var e = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
                $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$L.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$Aj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Dj(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Gj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$L.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$fj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Ij(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Bh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L), null;
        case 4:
            return $b36288e2db101ba3$var$zh(), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Jj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Nj = !1;
function $b36288e2db101ba3$var$Oj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Nj;
    $b36288e2db101ba3$var$Nj = !1;
    return n;
}
function $b36288e2db101ba3$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Xj = !1;
function $b36288e2db101ba3$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$Zj(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$Zj(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Lj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Xj = !0;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Mj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Yj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Yj(a, b, c);
    }
}
function $b36288e2db101ba3$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Kj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Xj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$Zj(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$dk(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Pj(3, a, a.return), $b36288e2db101ba3$var$Qj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Pj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            break;
        case 13:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$fk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$ek(a);
    }
}
function $b36288e2db101ba3$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$hk(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$ik(a, b, c);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Jj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Jj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$jk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$jk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$ik(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Jj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$kk(a, b, c);
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Rj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$gk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$jk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Qj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$lk = Math.ceil, $b36288e2db101ba3$var$mk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$fj = 0, $b36288e2db101ba3$var$ej = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$pk = null, $b36288e2db101ba3$var$rh = 0, $b36288e2db101ba3$var$qk = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = null, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$fk = 0, $b36288e2db101ba3$var$Gj = Infinity, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Oi = !1, $b36288e2db101ba3$var$Pi = null, $b36288e2db101ba3$var$Ri = null, $b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = null, $b36288e2db101ba3$var$xk = 0, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, $b36288e2db101ba3$var$Ak = -1, $b36288e2db101ba3$var$Bk = 0;
function $b36288e2db101ba3$var$R() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$Ak : $b36288e2db101ba3$var$Ak = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Bk && ($b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Bk;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$gi(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$yk) throw $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$Q) a === $b36288e2db101ba3$var$Q && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$qk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Ck(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Dk(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Dk(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Ek.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Ek.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Fk(c, $b36288e2db101ba3$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Gk(a, b) {
    $b36288e2db101ba3$var$Ak = -1;
    $b36288e2db101ba3$var$Bk = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Hk() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Ik(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Jk();
        if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Kk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Lk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Mk(a, h);
        }
        $b36288e2db101ba3$var$$g();
        $b36288e2db101ba3$var$mk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Nk(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Ok(e) && (b = $b36288e2db101ba3$var$Ik(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Nk(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$fk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Gk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    var c = $b36288e2db101ba3$var$sk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Kk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Ik(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$tk = c, null !== b && $b36288e2db101ba3$var$Fj(b));
    return a;
}
function $b36288e2db101ba3$var$Fj(a) {
    null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = a : $b36288e2db101ba3$var$tk.push.apply($b36288e2db101ba3$var$tk, a);
}
function $b36288e2db101ba3$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Ck(a, b) {
    b &= ~$b36288e2db101ba3$var$rk;
    b &= ~$b36288e2db101ba3$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Ek(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Nk(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, b), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Qk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Rk(a) {
    null !== $b36288e2db101ba3$var$wk && 0 === $b36288e2db101ba3$var$wk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$ok.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$ok.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Hj() {
    $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$ej.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$ej);
}
function $b36288e2db101ba3$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$zh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Eh();
                break;
            case 5:
                $b36288e2db101ba3$var$Bh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$zh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 10:
                $b36288e2db101ba3$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Hj();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$Q = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$Pg(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$fj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$pk = null;
    $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$qk = $b36288e2db101ba3$var$rh = 0;
    $b36288e2db101ba3$var$tk = $b36288e2db101ba3$var$sk = null;
    if (null !== $b36288e2db101ba3$var$fh) {
        for(b = 0; b < $b36288e2db101ba3$var$fh.length; b++)if (c = $b36288e2db101ba3$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$fh = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Mk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$$g();
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
            if ($b36288e2db101ba3$var$Ih) {
                for(var d = $b36288e2db101ba3$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Ih = !1;
            }
            $b36288e2db101ba3$var$Hh = 0;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            $b36288e2db101ba3$var$nk.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$pk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Si(f, l, b);
                            $b36288e2db101ba3$var$tj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Vi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ji(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$sk ? $b36288e2db101ba3$var$sk = [
                    f
                ] : $b36288e2db101ba3$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Ni(f, k, b);
                            $b36288e2db101ba3$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Qi(f, h, b);
                                $b36288e2db101ba3$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Sk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Jk() {
    var a = $b36288e2db101ba3$var$mk.current;
    $b36288e2db101ba3$var$mk.current = $b36288e2db101ba3$var$Rh;
    return null === a ? $b36288e2db101ba3$var$Rh : a;
}
function $b36288e2db101ba3$var$tj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$Q || 0 === ($b36288e2db101ba3$var$rh & 268435455) && 0 === ($b36288e2db101ba3$var$qk & 268435455) || $b36288e2db101ba3$var$Ck($b36288e2db101ba3$var$Q, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Ik(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Jk();
    if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Kk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Tk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Mk(a, e);
    }
    $b36288e2db101ba3$var$$g();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$mk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$Q = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Tk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Lk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Uk(a) {
    var b = $b36288e2db101ba3$var$Vk(a.alternate, a, $b36288e2db101ba3$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Sk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$nk.current = null;
}
function $b36288e2db101ba3$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Ej(c, b, $b36288e2db101ba3$var$fj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Pk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$ok.transition;
    try {
        $b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Wk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$ok.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Wk(a, b, c, d) {
    do $b36288e2db101ba3$var$Hk();
    while (null !== $b36288e2db101ba3$var$wk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$Q && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$vk || ($b36288e2db101ba3$var$vk = !0, $b36288e2db101ba3$var$Fk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$ok.transition;
        $b36288e2db101ba3$var$ok.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$nk.current = null;
        $b36288e2db101ba3$var$Oj(a, c);
        $b36288e2db101ba3$var$dk(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$hk(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$ok.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$vk && ($b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = a, $b36288e2db101ba3$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Ri = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Oi) throw $b36288e2db101ba3$var$Oi = !1, a = $b36288e2db101ba3$var$Pi, $b36288e2db101ba3$var$Pi = null, a;
    0 !== ($b36288e2db101ba3$var$xk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$zk ? $b36288e2db101ba3$var$yk++ : ($b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = a) : $b36288e2db101ba3$var$yk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Hk() {
    if (null !== $b36288e2db101ba3$var$wk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$xk), b = $b36288e2db101ba3$var$ok.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$ok.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$wk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$wk;
                $b36288e2db101ba3$var$wk = null;
                $b36288e2db101ba3$var$xk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Sj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$ok.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Xk(a, b, c) {
    b = $b36288e2db101ba3$var$Ji(c, b);
    b = $b36288e2db101ba3$var$Ni(a, b, 1);
    a = $b36288e2db101ba3$var$nh(a, b, 1);
    b = $b36288e2db101ba3$var$R();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Dk(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(d))) {
                a = $b36288e2db101ba3$var$Ji(c, a);
                a = $b36288e2db101ba3$var$Qi(b, a, 1);
                b = $b36288e2db101ba3$var$nh(b, a, 1);
                a = $b36288e2db101ba3$var$R();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$Q === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$fk ? $b36288e2db101ba3$var$Kk(a, 0) : $b36288e2db101ba3$var$rk |= c);
    $b36288e2db101ba3$var$Dk(a, b);
}
function $b36288e2db101ba3$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$R();
    a = $b36288e2db101ba3$var$ih(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Dk(a, c));
}
function $b36288e2db101ba3$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Yk(a, c);
}
function $b36288e2db101ba3$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Yk(a, c);
}
var $b36288e2db101ba3$var$Vk;
$b36288e2db101ba3$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$yj(a, b, c);
            $b36288e2db101ba3$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$ij(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$ch(b, c);
            e = $b36288e2db101ba3$var$Nh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$kh(b), e.updater = $b36288e2db101ba3$var$Ei, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$Ii(b, d, a, c), b = $b36288e2db101ba3$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$Zk(d);
                a = $b36288e2db101ba3$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$$i(null, b, d, $b36288e2db101ba3$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$kj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$lh(a, b);
                $b36288e2db101ba3$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$Zi(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Ah(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$gj(a, b), $b36288e2db101ba3$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$oj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Ug(b, null, d, c) : $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$Yi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$ch(b, c), e = $b36288e2db101ba3$var$eh(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Ci(d, b.pendingProps), e = $b36288e2db101ba3$var$Ci(d.type, e), $b36288e2db101ba3$var$$i(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$ij(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$ch(b, c), $b36288e2db101ba3$var$Gi(b, d, e), $b36288e2db101ba3$var$Ii(b, d, e, c), $b36288e2db101ba3$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$xj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$dj(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Fk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$$k(a, b, c, d);
}
function $b36288e2db101ba3$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$Zk(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Tg(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Tg(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$pj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$Qg(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$kh(f);
    return a;
}
function $b36288e2db101ba3$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$dl(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$dl(null);
    c = a.current;
    d = $b36288e2db101ba3$var$R();
    e = $b36288e2db101ba3$var$yi(c);
    f = $b36288e2db101ba3$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$nh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Dk(a, d);
    return a;
}
function $b36288e2db101ba3$var$fl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$R(), g = $b36288e2db101ba3$var$yi(e);
    c = $b36288e2db101ba3$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$nh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$gi(a, e, g, f), $b36288e2db101ba3$var$oh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    $b36288e2db101ba3$var$hl(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$hl(a, b);
}
function $b36288e2db101ba3$var$jl() {
    return null;
}
var $b36288e2db101ba3$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ll(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.render = $b36288e2db101ba3$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$fl(a, b, null, null);
};
$b36288e2db101ba3$var$ml.prototype.unmount = $b36288e2db101ba3$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Rk(function() {
            $b36288e2db101ba3$var$fl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$pl() {}
function $b36288e2db101ba3$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$el(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$pl);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$gl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$bl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$pl);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$fl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$fl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$ql(c, b, a, e, d);
    return $b36288e2db101ba3$var$gl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Dk(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Rk(function() {
                var b = $b36288e2db101ba3$var$ih(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$R();
                    $b36288e2db101ba3$var$gi(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$il(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$il(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$yi(a), c = $b36288e2db101ba3$var$ih(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(c, a, b, d);
        }
        $b36288e2db101ba3$var$il(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Rk;
var $b36288e2db101ba3$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Qk
    ]
}, $b36288e2db101ba3$var$tl = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$ul = {
    bundleType: $b36288e2db101ba3$var$tl.bundleType,
    version: $b36288e2db101ba3$var$tl.version,
    rendererPackageName: $b36288e2db101ba3$var$tl.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$tl.findFiberByHostInstance || $b36288e2db101ba3$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$vl.isDisabled && $b36288e2db101ba3$var$vl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$vl.inject($b36288e2db101ba3$var$ul), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$vl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$sl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$nl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$cl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ll(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Rk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$ol(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$rl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("4LCdk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
'use strict';
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRegister("2tbKl", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $c3YnH = parcelRequire("c3YnH");
function $1cc766ccf0672393$var$emptyFunction() {}
function $1cc766ccf0672393$var$emptyFunctionWithReset() {}
$1cc766ccf0672393$var$emptyFunctionWithReset.resetWarningCache = $1cc766ccf0672393$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $c3YnH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1cc766ccf0672393$var$emptyFunctionWithReset,
        resetWarningCache: $1cc766ccf0672393$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("c3YnH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $8c849a51633fc8b0$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $8c849a51633fc8b0$var$ReactPropTypesSecret;

});


parcelRegister("lL2uv", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $fd6feb675d02976e$export$2b8d127b894957b9; }, function (v) { return $fd6feb675d02976e$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $fd6feb675d02976e$export$cea3a54a6425200c; }, function (v) { return $fd6feb675d02976e$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $fd6feb675d02976e$export$a7c73072b1a182ae; }, function (v) { return $fd6feb675d02976e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $fd6feb675d02976e$export$9f27bc3417b4524d; }, function (v) { return $fd6feb675d02976e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $fd6feb675d02976e$export$db77ccec0bb4ccac; }, function (v) { return $fd6feb675d02976e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $fd6feb675d02976e$export$8392c0c9d3dcbd35; }, function (v) { return $fd6feb675d02976e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $fd6feb675d02976e$export$ffb0004e005737fa; }, function (v) { return $fd6feb675d02976e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $fd6feb675d02976e$export$b624eff549462981; }, function (v) { return $fd6feb675d02976e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $fd6feb675d02976e$export$7897aa7841a5380c; }, function (v) { return $fd6feb675d02976e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $fd6feb675d02976e$export$602eac185826482c; }, function (v) { return $fd6feb675d02976e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $fd6feb675d02976e$export$e2c29f18771995cb; }, function (v) { return $fd6feb675d02976e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $fd6feb675d02976e$export$5f8d39834fd61797; }, function (v) { return $fd6feb675d02976e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $fd6feb675d02976e$export$74bf444e3cd11ea5; }, function (v) { return $fd6feb675d02976e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $fd6feb675d02976e$export$92387174baf9b227; }, function (v) { return $fd6feb675d02976e$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $fd6feb675d02976e$export$ec112efeb987d9c6; }, function (v) { return $fd6feb675d02976e$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $fd6feb675d02976e$export$b706b080d889d2c9; }, function (v) { return $fd6feb675d02976e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $fd6feb675d02976e$export$5be5a87408f70ddc; }, function (v) { return $fd6feb675d02976e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $fd6feb675d02976e$export$45a5e7f76e0caa8d; }, function (v) { return $fd6feb675d02976e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $fd6feb675d02976e$export$455c2e768291efa6; }, function (v) { return $fd6feb675d02976e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $fd6feb675d02976e$export$9522e17588c12572; }, function (v) { return $fd6feb675d02976e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $fd6feb675d02976e$export$2110ac352bb060b9; }, function (v) { return $fd6feb675d02976e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $fd6feb675d02976e$export$56885ab8b9c456ab; }, function (v) { return $fd6feb675d02976e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $fd6feb675d02976e$export$d927fcb6adf8f9de; }, function (v) { return $fd6feb675d02976e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $fd6feb675d02976e$export$b82d16f27459e05a; }, function (v) { return $fd6feb675d02976e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $fd6feb675d02976e$export$522c17b4f5e123e8; }, function (v) { return $fd6feb675d02976e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $fd6feb675d02976e$export$1aabd8a0274ecfd6; }, function (v) { return $fd6feb675d02976e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $fd6feb675d02976e$export$9b621391a187a31a; }, function (v) { return $fd6feb675d02976e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $fd6feb675d02976e$export$f5bbd400c2f4426f; }, function (v) { return $fd6feb675d02976e$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fd6feb675d02976e$export$2b8d127b894957b9;
var $fd6feb675d02976e$export$cea3a54a6425200c;
var $fd6feb675d02976e$export$a7c73072b1a182ae;
var $fd6feb675d02976e$export$9f27bc3417b4524d;
var $fd6feb675d02976e$export$db77ccec0bb4ccac;
var $fd6feb675d02976e$export$8392c0c9d3dcbd35;
var $fd6feb675d02976e$export$ffb0004e005737fa;
var $fd6feb675d02976e$export$b624eff549462981;
var $fd6feb675d02976e$export$7897aa7841a5380c;
var $fd6feb675d02976e$export$602eac185826482c;
var $fd6feb675d02976e$export$e2c29f18771995cb;
var $fd6feb675d02976e$export$5f8d39834fd61797;
var $fd6feb675d02976e$export$74bf444e3cd11ea5;
var $fd6feb675d02976e$export$92387174baf9b227;
var $fd6feb675d02976e$export$ec112efeb987d9c6;
var $fd6feb675d02976e$export$b706b080d889d2c9;
var $fd6feb675d02976e$export$5be5a87408f70ddc;
var $fd6feb675d02976e$export$45a5e7f76e0caa8d;
var $fd6feb675d02976e$export$455c2e768291efa6;
var $fd6feb675d02976e$export$9522e17588c12572;
var $fd6feb675d02976e$export$2110ac352bb060b9;
var $fd6feb675d02976e$export$56885ab8b9c456ab;
var $fd6feb675d02976e$export$d927fcb6adf8f9de;
var $fd6feb675d02976e$export$b82d16f27459e05a;
var $fd6feb675d02976e$export$522c17b4f5e123e8;
var $fd6feb675d02976e$export$1aabd8a0274ecfd6;
var $fd6feb675d02976e$export$9b621391a187a31a;
var $fd6feb675d02976e$export$f5bbd400c2f4426f;
'use strict';
var $fd6feb675d02976e$var$b = "function" === typeof Symbol && Symbol.for, $fd6feb675d02976e$var$c = $fd6feb675d02976e$var$b ? Symbol.for("react.element") : 60103, $fd6feb675d02976e$var$d = $fd6feb675d02976e$var$b ? Symbol.for("react.portal") : 60106, $fd6feb675d02976e$var$e = $fd6feb675d02976e$var$b ? Symbol.for("react.fragment") : 60107, $fd6feb675d02976e$var$f = $fd6feb675d02976e$var$b ? Symbol.for("react.strict_mode") : 60108, $fd6feb675d02976e$var$g = $fd6feb675d02976e$var$b ? Symbol.for("react.profiler") : 60114, $fd6feb675d02976e$var$h = $fd6feb675d02976e$var$b ? Symbol.for("react.provider") : 60109, $fd6feb675d02976e$var$k = $fd6feb675d02976e$var$b ? Symbol.for("react.context") : 60110, $fd6feb675d02976e$var$l = $fd6feb675d02976e$var$b ? Symbol.for("react.async_mode") : 60111, $fd6feb675d02976e$var$m = $fd6feb675d02976e$var$b ? Symbol.for("react.concurrent_mode") : 60111, $fd6feb675d02976e$var$n = $fd6feb675d02976e$var$b ? Symbol.for("react.forward_ref") : 60112, $fd6feb675d02976e$var$p = $fd6feb675d02976e$var$b ? Symbol.for("react.suspense") : 60113, $fd6feb675d02976e$var$q = $fd6feb675d02976e$var$b ? Symbol.for("react.suspense_list") : 60120, $fd6feb675d02976e$var$r = $fd6feb675d02976e$var$b ? Symbol.for("react.memo") : 60115, $fd6feb675d02976e$var$t = $fd6feb675d02976e$var$b ? Symbol.for("react.lazy") : 60116, $fd6feb675d02976e$var$v = $fd6feb675d02976e$var$b ? Symbol.for("react.block") : 60121, $fd6feb675d02976e$var$w = $fd6feb675d02976e$var$b ? Symbol.for("react.fundamental") : 60117, $fd6feb675d02976e$var$x = $fd6feb675d02976e$var$b ? Symbol.for("react.responder") : 60118, $fd6feb675d02976e$var$y = $fd6feb675d02976e$var$b ? Symbol.for("react.scope") : 60119;
function $fd6feb675d02976e$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $fd6feb675d02976e$var$c:
                switch(a = a.type, a){
                    case $fd6feb675d02976e$var$l:
                    case $fd6feb675d02976e$var$m:
                    case $fd6feb675d02976e$var$e:
                    case $fd6feb675d02976e$var$g:
                    case $fd6feb675d02976e$var$f:
                    case $fd6feb675d02976e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $fd6feb675d02976e$var$k:
                            case $fd6feb675d02976e$var$n:
                            case $fd6feb675d02976e$var$t:
                            case $fd6feb675d02976e$var$r:
                            case $fd6feb675d02976e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $fd6feb675d02976e$var$d:
                return u;
        }
    }
}
function $fd6feb675d02976e$var$A(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$m;
}
$fd6feb675d02976e$export$2b8d127b894957b9 = $fd6feb675d02976e$var$l;
$fd6feb675d02976e$export$cea3a54a6425200c = $fd6feb675d02976e$var$m;
$fd6feb675d02976e$export$a7c73072b1a182ae = $fd6feb675d02976e$var$k;
$fd6feb675d02976e$export$9f27bc3417b4524d = $fd6feb675d02976e$var$h;
$fd6feb675d02976e$export$db77ccec0bb4ccac = $fd6feb675d02976e$var$c;
$fd6feb675d02976e$export$8392c0c9d3dcbd35 = $fd6feb675d02976e$var$n;
$fd6feb675d02976e$export$ffb0004e005737fa = $fd6feb675d02976e$var$e;
$fd6feb675d02976e$export$b624eff549462981 = $fd6feb675d02976e$var$t;
$fd6feb675d02976e$export$7897aa7841a5380c = $fd6feb675d02976e$var$r;
$fd6feb675d02976e$export$602eac185826482c = $fd6feb675d02976e$var$d;
$fd6feb675d02976e$export$e2c29f18771995cb = $fd6feb675d02976e$var$g;
$fd6feb675d02976e$export$5f8d39834fd61797 = $fd6feb675d02976e$var$f;
$fd6feb675d02976e$export$74bf444e3cd11ea5 = $fd6feb675d02976e$var$p;
$fd6feb675d02976e$export$92387174baf9b227 = function(a) {
    return $fd6feb675d02976e$var$A(a) || $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$l;
};
$fd6feb675d02976e$export$ec112efeb987d9c6 = $fd6feb675d02976e$var$A;
$fd6feb675d02976e$export$b706b080d889d2c9 = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$k;
};
$fd6feb675d02976e$export$5be5a87408f70ddc = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$h;
};
$fd6feb675d02976e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $fd6feb675d02976e$var$c;
};
$fd6feb675d02976e$export$455c2e768291efa6 = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$n;
};
$fd6feb675d02976e$export$9522e17588c12572 = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$e;
};
$fd6feb675d02976e$export$2110ac352bb060b9 = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$t;
};
$fd6feb675d02976e$export$56885ab8b9c456ab = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$r;
};
$fd6feb675d02976e$export$d927fcb6adf8f9de = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$d;
};
$fd6feb675d02976e$export$b82d16f27459e05a = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$g;
};
$fd6feb675d02976e$export$522c17b4f5e123e8 = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$f;
};
$fd6feb675d02976e$export$1aabd8a0274ecfd6 = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$p;
};
$fd6feb675d02976e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $fd6feb675d02976e$var$e || a === $fd6feb675d02976e$var$m || a === $fd6feb675d02976e$var$g || a === $fd6feb675d02976e$var$f || a === $fd6feb675d02976e$var$p || a === $fd6feb675d02976e$var$q || "object" === typeof a && null !== a && (a.$$typeof === $fd6feb675d02976e$var$t || a.$$typeof === $fd6feb675d02976e$var$r || a.$$typeof === $fd6feb675d02976e$var$h || a.$$typeof === $fd6feb675d02976e$var$k || a.$$typeof === $fd6feb675d02976e$var$n || a.$$typeof === $fd6feb675d02976e$var$w || a.$$typeof === $fd6feb675d02976e$var$x || a.$$typeof === $fd6feb675d02976e$var$y || a.$$typeof === $fd6feb675d02976e$var$v);
};
$fd6feb675d02976e$export$f5bbd400c2f4426f = $fd6feb675d02976e$var$z;

});

parcelRegister("4aTru", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $30a31a517a2d5cc7$export$2b8d127b894957b9; }, function (v) { return $30a31a517a2d5cc7$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $30a31a517a2d5cc7$export$cea3a54a6425200c; }, function (v) { return $30a31a517a2d5cc7$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $30a31a517a2d5cc7$export$a7c73072b1a182ae; }, function (v) { return $30a31a517a2d5cc7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $30a31a517a2d5cc7$export$9f27bc3417b4524d; }, function (v) { return $30a31a517a2d5cc7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $30a31a517a2d5cc7$export$db77ccec0bb4ccac; }, function (v) { return $30a31a517a2d5cc7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $30a31a517a2d5cc7$export$8392c0c9d3dcbd35; }, function (v) { return $30a31a517a2d5cc7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $30a31a517a2d5cc7$export$ffb0004e005737fa; }, function (v) { return $30a31a517a2d5cc7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $30a31a517a2d5cc7$export$b624eff549462981; }, function (v) { return $30a31a517a2d5cc7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $30a31a517a2d5cc7$export$7897aa7841a5380c; }, function (v) { return $30a31a517a2d5cc7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $30a31a517a2d5cc7$export$602eac185826482c; }, function (v) { return $30a31a517a2d5cc7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $30a31a517a2d5cc7$export$e2c29f18771995cb; }, function (v) { return $30a31a517a2d5cc7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $30a31a517a2d5cc7$export$5f8d39834fd61797; }, function (v) { return $30a31a517a2d5cc7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $30a31a517a2d5cc7$export$74bf444e3cd11ea5; }, function (v) { return $30a31a517a2d5cc7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $30a31a517a2d5cc7$export$92387174baf9b227; }, function (v) { return $30a31a517a2d5cc7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $30a31a517a2d5cc7$export$ec112efeb987d9c6; }, function (v) { return $30a31a517a2d5cc7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $30a31a517a2d5cc7$export$b706b080d889d2c9; }, function (v) { return $30a31a517a2d5cc7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $30a31a517a2d5cc7$export$5be5a87408f70ddc; }, function (v) { return $30a31a517a2d5cc7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $30a31a517a2d5cc7$export$45a5e7f76e0caa8d; }, function (v) { return $30a31a517a2d5cc7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $30a31a517a2d5cc7$export$455c2e768291efa6; }, function (v) { return $30a31a517a2d5cc7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $30a31a517a2d5cc7$export$9522e17588c12572; }, function (v) { return $30a31a517a2d5cc7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $30a31a517a2d5cc7$export$2110ac352bb060b9; }, function (v) { return $30a31a517a2d5cc7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $30a31a517a2d5cc7$export$56885ab8b9c456ab; }, function (v) { return $30a31a517a2d5cc7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $30a31a517a2d5cc7$export$d927fcb6adf8f9de; }, function (v) { return $30a31a517a2d5cc7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $30a31a517a2d5cc7$export$b82d16f27459e05a; }, function (v) { return $30a31a517a2d5cc7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $30a31a517a2d5cc7$export$522c17b4f5e123e8; }, function (v) { return $30a31a517a2d5cc7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $30a31a517a2d5cc7$export$1aabd8a0274ecfd6; }, function (v) { return $30a31a517a2d5cc7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $30a31a517a2d5cc7$export$9b621391a187a31a; }, function (v) { return $30a31a517a2d5cc7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $30a31a517a2d5cc7$export$f5bbd400c2f4426f; }, function (v) { return $30a31a517a2d5cc7$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $30a31a517a2d5cc7$export$2b8d127b894957b9;
var $30a31a517a2d5cc7$export$cea3a54a6425200c;
var $30a31a517a2d5cc7$export$a7c73072b1a182ae;
var $30a31a517a2d5cc7$export$9f27bc3417b4524d;
var $30a31a517a2d5cc7$export$db77ccec0bb4ccac;
var $30a31a517a2d5cc7$export$8392c0c9d3dcbd35;
var $30a31a517a2d5cc7$export$ffb0004e005737fa;
var $30a31a517a2d5cc7$export$b624eff549462981;
var $30a31a517a2d5cc7$export$7897aa7841a5380c;
var $30a31a517a2d5cc7$export$602eac185826482c;
var $30a31a517a2d5cc7$export$e2c29f18771995cb;
var $30a31a517a2d5cc7$export$5f8d39834fd61797;
var $30a31a517a2d5cc7$export$74bf444e3cd11ea5;
var $30a31a517a2d5cc7$export$92387174baf9b227;
var $30a31a517a2d5cc7$export$ec112efeb987d9c6;
var $30a31a517a2d5cc7$export$b706b080d889d2c9;
var $30a31a517a2d5cc7$export$5be5a87408f70ddc;
var $30a31a517a2d5cc7$export$45a5e7f76e0caa8d;
var $30a31a517a2d5cc7$export$455c2e768291efa6;
var $30a31a517a2d5cc7$export$9522e17588c12572;
var $30a31a517a2d5cc7$export$2110ac352bb060b9;
var $30a31a517a2d5cc7$export$56885ab8b9c456ab;
var $30a31a517a2d5cc7$export$d927fcb6adf8f9de;
var $30a31a517a2d5cc7$export$b82d16f27459e05a;
var $30a31a517a2d5cc7$export$522c17b4f5e123e8;
var $30a31a517a2d5cc7$export$1aabd8a0274ecfd6;
var $30a31a517a2d5cc7$export$9b621391a187a31a;
var $30a31a517a2d5cc7$export$f5bbd400c2f4426f;
'use strict';
var $30a31a517a2d5cc7$var$b = "function" === typeof Symbol && Symbol.for, $30a31a517a2d5cc7$var$c = $30a31a517a2d5cc7$var$b ? Symbol.for("react.element") : 60103, $30a31a517a2d5cc7$var$d = $30a31a517a2d5cc7$var$b ? Symbol.for("react.portal") : 60106, $30a31a517a2d5cc7$var$e = $30a31a517a2d5cc7$var$b ? Symbol.for("react.fragment") : 60107, $30a31a517a2d5cc7$var$f = $30a31a517a2d5cc7$var$b ? Symbol.for("react.strict_mode") : 60108, $30a31a517a2d5cc7$var$g = $30a31a517a2d5cc7$var$b ? Symbol.for("react.profiler") : 60114, $30a31a517a2d5cc7$var$h = $30a31a517a2d5cc7$var$b ? Symbol.for("react.provider") : 60109, $30a31a517a2d5cc7$var$k = $30a31a517a2d5cc7$var$b ? Symbol.for("react.context") : 60110, $30a31a517a2d5cc7$var$l = $30a31a517a2d5cc7$var$b ? Symbol.for("react.async_mode") : 60111, $30a31a517a2d5cc7$var$m = $30a31a517a2d5cc7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $30a31a517a2d5cc7$var$n = $30a31a517a2d5cc7$var$b ? Symbol.for("react.forward_ref") : 60112, $30a31a517a2d5cc7$var$p = $30a31a517a2d5cc7$var$b ? Symbol.for("react.suspense") : 60113, $30a31a517a2d5cc7$var$q = $30a31a517a2d5cc7$var$b ? Symbol.for("react.suspense_list") : 60120, $30a31a517a2d5cc7$var$r = $30a31a517a2d5cc7$var$b ? Symbol.for("react.memo") : 60115, $30a31a517a2d5cc7$var$t = $30a31a517a2d5cc7$var$b ? Symbol.for("react.lazy") : 60116, $30a31a517a2d5cc7$var$v = $30a31a517a2d5cc7$var$b ? Symbol.for("react.block") : 60121, $30a31a517a2d5cc7$var$w = $30a31a517a2d5cc7$var$b ? Symbol.for("react.fundamental") : 60117, $30a31a517a2d5cc7$var$x = $30a31a517a2d5cc7$var$b ? Symbol.for("react.responder") : 60118, $30a31a517a2d5cc7$var$y = $30a31a517a2d5cc7$var$b ? Symbol.for("react.scope") : 60119;
function $30a31a517a2d5cc7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $30a31a517a2d5cc7$var$c:
                switch(a = a.type, a){
                    case $30a31a517a2d5cc7$var$l:
                    case $30a31a517a2d5cc7$var$m:
                    case $30a31a517a2d5cc7$var$e:
                    case $30a31a517a2d5cc7$var$g:
                    case $30a31a517a2d5cc7$var$f:
                    case $30a31a517a2d5cc7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $30a31a517a2d5cc7$var$k:
                            case $30a31a517a2d5cc7$var$n:
                            case $30a31a517a2d5cc7$var$t:
                            case $30a31a517a2d5cc7$var$r:
                            case $30a31a517a2d5cc7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $30a31a517a2d5cc7$var$d:
                return u;
        }
    }
}
function $30a31a517a2d5cc7$var$A(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$m;
}
$30a31a517a2d5cc7$export$2b8d127b894957b9 = $30a31a517a2d5cc7$var$l;
$30a31a517a2d5cc7$export$cea3a54a6425200c = $30a31a517a2d5cc7$var$m;
$30a31a517a2d5cc7$export$a7c73072b1a182ae = $30a31a517a2d5cc7$var$k;
$30a31a517a2d5cc7$export$9f27bc3417b4524d = $30a31a517a2d5cc7$var$h;
$30a31a517a2d5cc7$export$db77ccec0bb4ccac = $30a31a517a2d5cc7$var$c;
$30a31a517a2d5cc7$export$8392c0c9d3dcbd35 = $30a31a517a2d5cc7$var$n;
$30a31a517a2d5cc7$export$ffb0004e005737fa = $30a31a517a2d5cc7$var$e;
$30a31a517a2d5cc7$export$b624eff549462981 = $30a31a517a2d5cc7$var$t;
$30a31a517a2d5cc7$export$7897aa7841a5380c = $30a31a517a2d5cc7$var$r;
$30a31a517a2d5cc7$export$602eac185826482c = $30a31a517a2d5cc7$var$d;
$30a31a517a2d5cc7$export$e2c29f18771995cb = $30a31a517a2d5cc7$var$g;
$30a31a517a2d5cc7$export$5f8d39834fd61797 = $30a31a517a2d5cc7$var$f;
$30a31a517a2d5cc7$export$74bf444e3cd11ea5 = $30a31a517a2d5cc7$var$p;
$30a31a517a2d5cc7$export$92387174baf9b227 = function(a) {
    return $30a31a517a2d5cc7$var$A(a) || $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$l;
};
$30a31a517a2d5cc7$export$ec112efeb987d9c6 = $30a31a517a2d5cc7$var$A;
$30a31a517a2d5cc7$export$b706b080d889d2c9 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$k;
};
$30a31a517a2d5cc7$export$5be5a87408f70ddc = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$h;
};
$30a31a517a2d5cc7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $30a31a517a2d5cc7$var$c;
};
$30a31a517a2d5cc7$export$455c2e768291efa6 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$n;
};
$30a31a517a2d5cc7$export$9522e17588c12572 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$e;
};
$30a31a517a2d5cc7$export$2110ac352bb060b9 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$t;
};
$30a31a517a2d5cc7$export$56885ab8b9c456ab = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$r;
};
$30a31a517a2d5cc7$export$d927fcb6adf8f9de = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$d;
};
$30a31a517a2d5cc7$export$b82d16f27459e05a = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$g;
};
$30a31a517a2d5cc7$export$522c17b4f5e123e8 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$f;
};
$30a31a517a2d5cc7$export$1aabd8a0274ecfd6 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$p;
};
$30a31a517a2d5cc7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $30a31a517a2d5cc7$var$e || a === $30a31a517a2d5cc7$var$m || a === $30a31a517a2d5cc7$var$g || a === $30a31a517a2d5cc7$var$f || a === $30a31a517a2d5cc7$var$p || a === $30a31a517a2d5cc7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $30a31a517a2d5cc7$var$t || a.$$typeof === $30a31a517a2d5cc7$var$r || a.$$typeof === $30a31a517a2d5cc7$var$h || a.$$typeof === $30a31a517a2d5cc7$var$k || a.$$typeof === $30a31a517a2d5cc7$var$n || a.$$typeof === $30a31a517a2d5cc7$var$w || a.$$typeof === $30a31a517a2d5cc7$var$x || a.$$typeof === $30a31a517a2d5cc7$var$y || a.$$typeof === $30a31a517a2d5cc7$var$v);
};
$30a31a517a2d5cc7$export$f5bbd400c2f4426f = $30a31a517a2d5cc7$var$z;

});

parcelRegister("jSyln", function(module, exports) {

var $2TGdH = parcelRequire("2TGdH");
module.exports = function(jwt, options) {
    options = options || {};
    var decoded = $2TGdH.decode(jwt, options);
    if (!decoded) return null;
    var payload = decoded.payload;
    //try parse the payload
    if (typeof payload === 'string') try {
        var obj = JSON.parse(payload);
        if (obj !== null && typeof obj === 'object') payload = obj;
    } catch (e) {}
    //return header if `complete` option is enabled.  header includes claims
    //such as `kid` and `alg` used to select the key within a JWKS needed to
    //verify the signature
    if (options.complete === true) return {
        header: decoded.header,
        payload: payload,
        signature: decoded.signature
    };
    return payload;
};

});
parcelRegister("2TGdH", function(module, exports) {

$parcel$export(module.exports, "sign", function () { return $21c177d3e10fd648$export$c5552dfdbc7cec71; }, function (v) { return $21c177d3e10fd648$export$c5552dfdbc7cec71 = v; });
$parcel$export(module.exports, "verify", function () { return $21c177d3e10fd648$export$532244b5b8b0b4b6; }, function (v) { return $21c177d3e10fd648$export$532244b5b8b0b4b6 = v; });
$parcel$export(module.exports, "decode", function () { return $21c177d3e10fd648$export$2f872c0f2117be69; }, function (v) { return $21c177d3e10fd648$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "createSign", function () { return $21c177d3e10fd648$export$45df7cae684751af; }, function (v) { return $21c177d3e10fd648$export$45df7cae684751af = v; });
/*global exports*/ var $21c177d3e10fd648$export$6f6fa4628974a579;
var $21c177d3e10fd648$export$c5552dfdbc7cec71;
var $21c177d3e10fd648$export$532244b5b8b0b4b6;
var $21c177d3e10fd648$export$2f872c0f2117be69;
var $21c177d3e10fd648$export$1ea939691cdc45b8;
var $21c177d3e10fd648$export$45df7cae684751af;
var $21c177d3e10fd648$export$6f65485f87568e37;

var $d4x4J = parcelRequire("d4x4J");

var $j76Aa = parcelRequire("j76Aa");
var $21c177d3e10fd648$var$ALGORITHMS = [
    'HS256',
    'HS384',
    'HS512',
    'RS256',
    'RS384',
    'RS512',
    'PS256',
    'PS384',
    'PS512',
    'ES256',
    'ES384',
    'ES512'
];
$21c177d3e10fd648$export$6f6fa4628974a579 = $21c177d3e10fd648$var$ALGORITHMS;
$21c177d3e10fd648$export$c5552dfdbc7cec71 = $d4x4J.sign;
$21c177d3e10fd648$export$532244b5b8b0b4b6 = $j76Aa.verify;
$21c177d3e10fd648$export$2f872c0f2117be69 = $j76Aa.decode;
$21c177d3e10fd648$export$1ea939691cdc45b8 = $j76Aa.isValid;
$21c177d3e10fd648$export$45df7cae684751af = function createSign(opts) {
    return new $d4x4J(opts);
};
$21c177d3e10fd648$export$6f65485f87568e37 = function createVerify(opts) {
    return new $j76Aa(opts);
};

});
parcelRegister("d4x4J", function(module, exports) {
/*global module*/ 
var $6U9mG = parcelRequire("6U9mG");
var $98454e2915cb88ef$require$Buffer = $6U9mG.Buffer;

var $jMPFS = parcelRequire("jMPFS");

var $gWIRK = parcelRequire("gWIRK");

var $bks2w = parcelRequire("bks2w");

var $kJYhQ = parcelRequire("kJYhQ");

var $4zyeF = parcelRequire("4zyeF");
function $98454e2915cb88ef$var$base64url(string, encoding) {
    return $98454e2915cb88ef$require$Buffer.from(string, encoding).toString('base64').replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $98454e2915cb88ef$var$jwsSecuredInput(header, payload, encoding) {
    encoding = encoding || 'utf8';
    var encodedHeader = $98454e2915cb88ef$var$base64url($kJYhQ(header), 'binary');
    var encodedPayload = $98454e2915cb88ef$var$base64url($kJYhQ(payload), encoding);
    return $4zyeF.format('%s.%s', encodedHeader, encodedPayload);
}
function $98454e2915cb88ef$var$jwsSign(opts) {
    var header = opts.header;
    var payload = opts.payload;
    var secretOrKey = opts.secret || opts.privateKey;
    var encoding = opts.encoding;
    var algo = $gWIRK(header.alg);
    var securedInput = $98454e2915cb88ef$var$jwsSecuredInput(header, payload, encoding);
    var signature = algo.sign(securedInput, secretOrKey);
    return $4zyeF.format('%s.%s', securedInput, signature);
}
function $98454e2915cb88ef$var$SignStream(opts) {
    var secret = opts.secret;
    secret = secret == null ? opts.privateKey : secret;
    secret = secret == null ? opts.key : secret;
    if (/^hs/i.test(opts.header.alg) === true && secret == null) throw new TypeError('secret must be a string or buffer or a KeyObject');
    var secretStream = new $jMPFS(secret);
    this.readable = true;
    this.header = opts.header;
    this.encoding = opts.encoding;
    this.secret = this.privateKey = this.key = secretStream;
    this.payload = new $jMPFS(opts.payload);
    this.secret.once('close', (function() {
        if (!this.payload.writable && this.readable) this.sign();
    }).bind(this));
    this.payload.once('close', (function() {
        if (!this.secret.writable && this.readable) this.sign();
    }).bind(this));
}
$4zyeF.inherits($98454e2915cb88ef$var$SignStream, $bks2w);
$98454e2915cb88ef$var$SignStream.prototype.sign = function sign() {
    try {
        var signature = $98454e2915cb88ef$var$jwsSign({
            header: this.header,
            payload: this.payload.buffer,
            secret: this.secret.buffer,
            encoding: this.encoding
        });
        this.emit('done', signature);
        this.emit('data', signature);
        this.emit('end');
        this.readable = false;
        return signature;
    } catch (e) {
        this.readable = false;
        this.emit('error', e);
        this.emit('close');
    }
};
$98454e2915cb88ef$var$SignStream.sign = $98454e2915cb88ef$var$jwsSign;
module.exports = $98454e2915cb88ef$var$SignStream;

});
parcelRegister("6U9mG", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $ihoyg = parcelRequire("ihoyg");
var $506f3cb9e9ae23e7$var$Buffer = $ihoyg.Buffer;
// alternative to using Object.keys for old browsers
function $506f3cb9e9ae23e7$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($506f3cb9e9ae23e7$var$Buffer.from && $506f3cb9e9ae23e7$var$Buffer.alloc && $506f3cb9e9ae23e7$var$Buffer.allocUnsafe && $506f3cb9e9ae23e7$var$Buffer.allocUnsafeSlow) module.exports = $ihoyg;
else {
    // Copy properties from require('buffer')
    $506f3cb9e9ae23e7$var$copyProps($ihoyg, module.exports);
    module.exports.Buffer = $506f3cb9e9ae23e7$var$SafeBuffer;
}
function $506f3cb9e9ae23e7$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $506f3cb9e9ae23e7$var$Buffer(arg, encodingOrOffset, length);
}
$506f3cb9e9ae23e7$var$SafeBuffer.prototype = Object.create($506f3cb9e9ae23e7$var$Buffer.prototype);
// Copy static methods from Buffer
$506f3cb9e9ae23e7$var$copyProps($506f3cb9e9ae23e7$var$Buffer, $506f3cb9e9ae23e7$var$SafeBuffer);
$506f3cb9e9ae23e7$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $506f3cb9e9ae23e7$var$Buffer(arg, encodingOrOffset, length);
};
$506f3cb9e9ae23e7$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $506f3cb9e9ae23e7$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$506f3cb9e9ae23e7$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $506f3cb9e9ae23e7$var$Buffer(size);
};
$506f3cb9e9ae23e7$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $ihoyg.SlowBuffer(size);
};

});
parcelRegister("ihoyg", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d4ecdbf520e63dca$export$a143d493d941bafc; }, function (v) { return $d4ecdbf520e63dca$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a; }, function (v) { return $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d4ecdbf520e63dca$export$f99ded8fe4b79145; }, function (v) { return $d4ecdbf520e63dca$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $d4ecdbf520e63dca$export$599f31c3813fae4d; }, function (v) { return $d4ecdbf520e63dca$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
'use strict';

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
var $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
var $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        var len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        var buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $d4ecdbf520e63dca$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case 'base64':
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("hqZtu", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $034686670a8a195b$export$d622b2ad8d90c771; }, function (v) { return $034686670a8a195b$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $034686670a8a195b$export$6100ba28696e12de; }, function (v) { return $034686670a8a195b$export$6100ba28696e12de = v; });
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
'use strict';
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $034686670a8a195b$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup['-'.charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup['_'.charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("5WQj6", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $454af19f7384844b$export$aafa59e2e03f2942; }, function (v) { return $454af19f7384844b$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $454af19f7384844b$export$68d8715fc104d294; }, function (v) { return $454af19f7384844b$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("jMPFS", function(module, exports) {
/*global module, process*/ 
var $4TNnu = parcelRequire("4TNnu");

var $6U9mG = parcelRequire("6U9mG");
var $e67a9581c87b0572$require$Buffer = $6U9mG.Buffer;

var $bks2w = parcelRequire("bks2w");

var $4zyeF = parcelRequire("4zyeF");
function $e67a9581c87b0572$var$DataStream(data) {
    this.buffer = null;
    this.writable = true;
    this.readable = true;
    // No input
    if (!data) {
        this.buffer = $e67a9581c87b0572$require$Buffer.alloc(0);
        return this;
    }
    // Stream
    if (typeof data.pipe === 'function') {
        this.buffer = $e67a9581c87b0572$require$Buffer.alloc(0);
        data.pipe(this);
        return this;
    }
    // Buffer or String
    // or Object (assumedly a passworded key)
    if (data.length || typeof data === 'object') {
        this.buffer = data;
        this.writable = false;
        $4TNnu.nextTick((function() {
            this.emit('end', data);
            this.readable = false;
            this.emit('close');
        }).bind(this));
        return this;
    }
    throw new TypeError('Unexpected data type (' + typeof data + ')');
}
$4zyeF.inherits($e67a9581c87b0572$var$DataStream, $bks2w);
$e67a9581c87b0572$var$DataStream.prototype.write = function write(data) {
    this.buffer = $e67a9581c87b0572$require$Buffer.concat([
        this.buffer,
        $e67a9581c87b0572$require$Buffer.from(data)
    ]);
    this.emit('data', data);
};
$e67a9581c87b0572$var$DataStream.prototype.end = function end(data) {
    if (data) this.write(data);
    this.emit('end', data);
    this.emit('close');
    this.writable = false;
    this.readable = false;
};
module.exports = $e67a9581c87b0572$var$DataStream;

});
parcelRegister("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = 'browser';
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ''; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$391299e0893a3dfa$var$process.cwd = function() {
    return '/';
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});

parcelRegister("bks2w", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $83f7500f17fcc367$var$Stream;

var $jMc9N = parcelRequire("jMc9N");
var $83f7500f17fcc367$require$EE = $jMc9N.EventEmitter;

var $eSHUL = parcelRequire("eSHUL");
$eSHUL($83f7500f17fcc367$var$Stream, $83f7500f17fcc367$require$EE);

$83f7500f17fcc367$var$Stream.Readable = (parcelRequire("gbyK3"));

$83f7500f17fcc367$var$Stream.Writable = (parcelRequire("7OiFs"));

$83f7500f17fcc367$var$Stream.Duplex = (parcelRequire("gb1AQ"));

$83f7500f17fcc367$var$Stream.Transform = (parcelRequire("7ozOp"));

$83f7500f17fcc367$var$Stream.PassThrough = (parcelRequire("6qwr0"));

$83f7500f17fcc367$var$Stream.finished = (parcelRequire("bMXnq"));

$83f7500f17fcc367$var$Stream.pipeline = (parcelRequire("46RH2"));
// Backwards-compat with node 0.4.x
$83f7500f17fcc367$var$Stream.Stream = $83f7500f17fcc367$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $83f7500f17fcc367$var$Stream() {
    $83f7500f17fcc367$require$EE.call(this);
}
$83f7500f17fcc367$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($83f7500f17fcc367$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("jMc9N", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $e65bee21a7cdc3da$var$R = typeof Reflect === 'object' ? Reflect : null;
var $e65bee21a7cdc3da$var$ReflectApply = $e65bee21a7cdc3da$var$R && typeof $e65bee21a7cdc3da$var$R.apply === 'function' ? $e65bee21a7cdc3da$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $e65bee21a7cdc3da$var$ReflectOwnKeys;
if ($e65bee21a7cdc3da$var$R && typeof $e65bee21a7cdc3da$var$R.ownKeys === 'function') $e65bee21a7cdc3da$var$ReflectOwnKeys = $e65bee21a7cdc3da$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $e65bee21a7cdc3da$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $e65bee21a7cdc3da$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $e65bee21a7cdc3da$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $e65bee21a7cdc3da$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $e65bee21a7cdc3da$var$EventEmitter() {
    $e65bee21a7cdc3da$var$EventEmitter.init.call(this);
}
module.exports = $e65bee21a7cdc3da$var$EventEmitter;
module.exports.once = $e65bee21a7cdc3da$var$once;
// Backwards-compat with node 0.10.x
$e65bee21a7cdc3da$var$EventEmitter.EventEmitter = $e65bee21a7cdc3da$var$EventEmitter;
$e65bee21a7cdc3da$var$EventEmitter.prototype._events = undefined;
$e65bee21a7cdc3da$var$EventEmitter.prototype._eventsCount = 0;
$e65bee21a7cdc3da$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $e65bee21a7cdc3da$var$defaultMaxListeners = 10;
function $e65bee21a7cdc3da$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($e65bee21a7cdc3da$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $e65bee21a7cdc3da$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $e65bee21a7cdc3da$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $e65bee21a7cdc3da$var$defaultMaxListeners = arg;
    }
});
$e65bee21a7cdc3da$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$e65bee21a7cdc3da$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $e65bee21a7cdc3da$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $e65bee21a7cdc3da$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $e65bee21a7cdc3da$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $e65bee21a7cdc3da$var$_getMaxListeners(this);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $e65bee21a7cdc3da$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $e65bee21a7cdc3da$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$e65bee21a7cdc3da$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $e65bee21a7cdc3da$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $e65bee21a7cdc3da$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $e65bee21a7cdc3da$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $e65bee21a7cdc3da$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $e65bee21a7cdc3da$var$_addListener(this, type, listener, false);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.on = $e65bee21a7cdc3da$var$EventEmitter.prototype.addListener;
$e65bee21a7cdc3da$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $e65bee21a7cdc3da$var$_addListener(this, type, listener, true);
};
function $e65bee21a7cdc3da$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $e65bee21a7cdc3da$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $e65bee21a7cdc3da$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.once = function once(type, listener) {
    $e65bee21a7cdc3da$var$checkListener(listener);
    this.on(type, $e65bee21a7cdc3da$var$_onceWrap(this, type, listener));
    return this;
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $e65bee21a7cdc3da$var$checkListener(listener);
    this.prependListener(type, $e65bee21a7cdc3da$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$e65bee21a7cdc3da$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $e65bee21a7cdc3da$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $e65bee21a7cdc3da$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.off = $e65bee21a7cdc3da$var$EventEmitter.prototype.removeListener;
$e65bee21a7cdc3da$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $e65bee21a7cdc3da$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $e65bee21a7cdc3da$var$unwrapListeners(evlistener) : $e65bee21a7cdc3da$var$arrayClone(evlistener, evlistener.length);
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $e65bee21a7cdc3da$var$_listeners(this, type, true);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $e65bee21a7cdc3da$var$_listeners(this, type, false);
};
$e65bee21a7cdc3da$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $e65bee21a7cdc3da$var$listenerCount.call(emitter, type);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.listenerCount = $e65bee21a7cdc3da$var$listenerCount;
function $e65bee21a7cdc3da$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $e65bee21a7cdc3da$var$ReflectOwnKeys(this._events) : [];
};
function $e65bee21a7cdc3da$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $e65bee21a7cdc3da$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $e65bee21a7cdc3da$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $e65bee21a7cdc3da$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $e65bee21a7cdc3da$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $e65bee21a7cdc3da$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("eSHUL", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("gbyK3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TNnu = parcelRequire("4TNnu");
'use strict';
module.exports = $bc889f6f92aedec0$var$Readable;
/*<replacement>*/ var $bc889f6f92aedec0$var$Duplex;
/*</replacement>*/ $bc889f6f92aedec0$var$Readable.ReadableState = $bc889f6f92aedec0$var$ReadableState;

var $jMc9N = parcelRequire("jMc9N");
var $bc889f6f92aedec0$require$EE = $jMc9N.EventEmitter;
var $bc889f6f92aedec0$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jzO5Y = parcelRequire("jzO5Y");

var $ihoyg = parcelRequire("ihoyg");
var $bc889f6f92aedec0$require$Buffer = $ihoyg.Buffer;
var $bc889f6f92aedec0$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $bc889f6f92aedec0$var$_uint8ArrayToBuffer(chunk) {
    return $bc889f6f92aedec0$require$Buffer.from(chunk);
}
function $bc889f6f92aedec0$var$_isUint8Array(obj) {
    return $bc889f6f92aedec0$require$Buffer.isBuffer(obj) || obj instanceof $bc889f6f92aedec0$var$OurUint8Array;
}

var $5Io6y = parcelRequire("5Io6y");
var $bc889f6f92aedec0$var$debug;
if ($5Io6y && $5Io6y.debuglog) $bc889f6f92aedec0$var$debug = $5Io6y.debuglog('stream');
else $bc889f6f92aedec0$var$debug = function debug() {};

var $6OboF = parcelRequire("6OboF");

var $hgvHE = parcelRequire("hgvHE");

var $1qNnQ = parcelRequire("1qNnQ");
var $bc889f6f92aedec0$var$getHighWaterMark = $1qNnQ.getHighWaterMark;

var $dRF2w = parcelRequire("dRF2w");
var $bc889f6f92aedec0$require$_require$codes = $dRF2w.codes;
var $bc889f6f92aedec0$var$ERR_INVALID_ARG_TYPE = $bc889f6f92aedec0$require$_require$codes.ERR_INVALID_ARG_TYPE, $bc889f6f92aedec0$var$ERR_STREAM_PUSH_AFTER_EOF = $bc889f6f92aedec0$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $bc889f6f92aedec0$var$ERR_METHOD_NOT_IMPLEMENTED = $bc889f6f92aedec0$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $bc889f6f92aedec0$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $bc889f6f92aedec0$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $bc889f6f92aedec0$var$StringDecoder;
var $bc889f6f92aedec0$var$createReadableStreamAsyncIterator;
var $bc889f6f92aedec0$var$from;

(parcelRequire("eSHUL"))($bc889f6f92aedec0$var$Readable, $jzO5Y);
var $bc889f6f92aedec0$var$errorOrDestroy = $hgvHE.errorOrDestroy;
var $bc889f6f92aedec0$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $bc889f6f92aedec0$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $bc889f6f92aedec0$var$ReadableState(options, stream, isDuplex) {
    $bc889f6f92aedec0$var$Duplex = $bc889f6f92aedec0$var$Duplex || (parcelRequire("gb1AQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $bc889f6f92aedec0$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $bc889f6f92aedec0$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $6OboF();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$bc889f6f92aedec0$var$StringDecoder) $bc889f6f92aedec0$var$StringDecoder = (parcelRequire("lEpDX")).StringDecoder;
        this.decoder = new $bc889f6f92aedec0$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $bc889f6f92aedec0$var$Readable(options) {
    $bc889f6f92aedec0$var$Duplex = $bc889f6f92aedec0$var$Duplex || (parcelRequire("gb1AQ"));
    if (!(this instanceof $bc889f6f92aedec0$var$Readable)) return new $bc889f6f92aedec0$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $bc889f6f92aedec0$var$Duplex;
    this._readableState = new $bc889f6f92aedec0$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $jzO5Y.call(this);
}
Object.defineProperty($bc889f6f92aedec0$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$bc889f6f92aedec0$var$Readable.prototype.destroy = $hgvHE.destroy;
$bc889f6f92aedec0$var$Readable.prototype._undestroy = $hgvHE.undestroy;
$bc889f6f92aedec0$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$bc889f6f92aedec0$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $bc889f6f92aedec0$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $bc889f6f92aedec0$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$bc889f6f92aedec0$var$Readable.prototype.unshift = function(chunk) {
    return $bc889f6f92aedec0$var$readableAddChunk(this, chunk, null, true, false);
};
function $bc889f6f92aedec0$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $bc889f6f92aedec0$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $bc889f6f92aedec0$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $bc889f6f92aedec0$var$chunkInvalid(state, chunk);
        if (er) $bc889f6f92aedec0$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $bc889f6f92aedec0$require$Buffer.prototype) chunk = $bc889f6f92aedec0$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $bc889f6f92aedec0$var$errorOrDestroy(stream, new $bc889f6f92aedec0$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $bc889f6f92aedec0$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $bc889f6f92aedec0$var$errorOrDestroy(stream, new $bc889f6f92aedec0$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $bc889f6f92aedec0$var$addChunk(stream, state, chunk, false);
                    else $bc889f6f92aedec0$var$maybeReadMore(stream, state);
                } else $bc889f6f92aedec0$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $bc889f6f92aedec0$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $bc889f6f92aedec0$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $bc889f6f92aedec0$var$emitReadable(stream);
    }
    $bc889f6f92aedec0$var$maybeReadMore(stream, state);
}
function $bc889f6f92aedec0$var$chunkInvalid(state, chunk) {
    var er;
    if (!$bc889f6f92aedec0$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $bc889f6f92aedec0$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$bc889f6f92aedec0$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$bc889f6f92aedec0$var$Readable.prototype.setEncoding = function(enc) {
    if (!$bc889f6f92aedec0$var$StringDecoder) $bc889f6f92aedec0$var$StringDecoder = (parcelRequire("lEpDX")).StringDecoder;
    var decoder = new $bc889f6f92aedec0$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $bc889f6f92aedec0$var$MAX_HWM = 0x40000000;
function $bc889f6f92aedec0$var$computeNewHighWaterMark(n) {
    if (n >= $bc889f6f92aedec0$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $bc889f6f92aedec0$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bc889f6f92aedec0$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $bc889f6f92aedec0$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$bc889f6f92aedec0$var$Readable.prototype.read = function(n) {
    $bc889f6f92aedec0$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $bc889f6f92aedec0$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $bc889f6f92aedec0$var$endReadable(this);
        else $bc889f6f92aedec0$var$emitReadable(this);
        return null;
    }
    n = $bc889f6f92aedec0$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $bc889f6f92aedec0$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $bc889f6f92aedec0$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $bc889f6f92aedec0$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $bc889f6f92aedec0$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $bc889f6f92aedec0$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $bc889f6f92aedec0$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $bc889f6f92aedec0$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $bc889f6f92aedec0$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $bc889f6f92aedec0$var$onEofChunk(stream, state) {
    $bc889f6f92aedec0$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $bc889f6f92aedec0$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $bc889f6f92aedec0$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $bc889f6f92aedec0$var$emitReadable(stream) {
    var state = stream._readableState;
    $bc889f6f92aedec0$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $bc889f6f92aedec0$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $4TNnu.nextTick($bc889f6f92aedec0$var$emitReadable_, stream);
    }
}
function $bc889f6f92aedec0$var$emitReadable_(stream) {
    var state = stream._readableState;
    $bc889f6f92aedec0$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $bc889f6f92aedec0$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $bc889f6f92aedec0$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $4TNnu.nextTick($bc889f6f92aedec0$var$maybeReadMore_, stream, state);
    }
}
function $bc889f6f92aedec0$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $bc889f6f92aedec0$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$bc889f6f92aedec0$var$Readable.prototype._read = function(n) {
    $bc889f6f92aedec0$var$errorOrDestroy(this, new $bc889f6f92aedec0$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$bc889f6f92aedec0$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $bc889f6f92aedec0$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4TNnu.stdout && dest !== $4TNnu.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $4TNnu.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $bc889f6f92aedec0$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $bc889f6f92aedec0$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $bc889f6f92aedec0$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $bc889f6f92aedec0$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $bc889f6f92aedec0$var$debug('ondata');
        var ret = dest.write(chunk);
        $bc889f6f92aedec0$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $bc889f6f92aedec0$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $bc889f6f92aedec0$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $bc889f6f92aedec0$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($bc889f6f92aedec0$var$EElistenerCount(dest, 'error') === 0) $bc889f6f92aedec0$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $bc889f6f92aedec0$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $bc889f6f92aedec0$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $bc889f6f92aedec0$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $bc889f6f92aedec0$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $bc889f6f92aedec0$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $bc889f6f92aedec0$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $bc889f6f92aedec0$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $bc889f6f92aedec0$var$flow(src);
        }
    };
}
$bc889f6f92aedec0$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $bc889f6f92aedec0$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$bc889f6f92aedec0$var$Readable.prototype.on = function(ev, fn) {
    var res = $jzO5Y.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $bc889f6f92aedec0$var$debug('on readable', state.length, state.reading);
            if (state.length) $bc889f6f92aedec0$var$emitReadable(this);
            else if (!state.reading) $4TNnu.nextTick($bc889f6f92aedec0$var$nReadingNextTick, this);
        }
    }
    return res;
};
$bc889f6f92aedec0$var$Readable.prototype.addListener = $bc889f6f92aedec0$var$Readable.prototype.on;
$bc889f6f92aedec0$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jzO5Y.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4TNnu.nextTick($bc889f6f92aedec0$var$updateReadableListening, this);
    return res;
};
$bc889f6f92aedec0$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jzO5Y.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4TNnu.nextTick($bc889f6f92aedec0$var$updateReadableListening, this);
    return res;
};
function $bc889f6f92aedec0$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $bc889f6f92aedec0$var$nReadingNextTick(self1) {
    $bc889f6f92aedec0$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$bc889f6f92aedec0$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $bc889f6f92aedec0$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $bc889f6f92aedec0$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $bc889f6f92aedec0$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $4TNnu.nextTick($bc889f6f92aedec0$var$resume_, stream, state);
    }
}
function $bc889f6f92aedec0$var$resume_(stream, state) {
    $bc889f6f92aedec0$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $bc889f6f92aedec0$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$bc889f6f92aedec0$var$Readable.prototype.pause = function() {
    $bc889f6f92aedec0$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $bc889f6f92aedec0$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $bc889f6f92aedec0$var$flow(stream) {
    var state = stream._readableState;
    $bc889f6f92aedec0$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$bc889f6f92aedec0$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $bc889f6f92aedec0$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $bc889f6f92aedec0$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $bc889f6f92aedec0$var$kProxyEvents.length; n++)stream.on($bc889f6f92aedec0$var$kProxyEvents[n], this.emit.bind(this, $bc889f6f92aedec0$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $bc889f6f92aedec0$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $bc889f6f92aedec0$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($bc889f6f92aedec0$var$createReadableStreamAsyncIterator === undefined) $bc889f6f92aedec0$var$createReadableStreamAsyncIterator = (parcelRequire("j2AXH"));
    return $bc889f6f92aedec0$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($bc889f6f92aedec0$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($bc889f6f92aedec0$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($bc889f6f92aedec0$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$bc889f6f92aedec0$var$Readable._fromList = $bc889f6f92aedec0$var$fromList;
Object.defineProperty($bc889f6f92aedec0$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bc889f6f92aedec0$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $bc889f6f92aedec0$var$endReadable(stream) {
    var state = stream._readableState;
    $bc889f6f92aedec0$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $4TNnu.nextTick($bc889f6f92aedec0$var$endReadableNT, state, stream);
    }
}
function $bc889f6f92aedec0$var$endReadableNT(state, stream) {
    $bc889f6f92aedec0$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $bc889f6f92aedec0$var$Readable.from = function(iterable, opts) {
    if ($bc889f6f92aedec0$var$from === undefined) $bc889f6f92aedec0$var$from = (parcelRequire("9fR9D"));
    return $bc889f6f92aedec0$var$from($bc889f6f92aedec0$var$Readable, iterable, opts);
};
function $bc889f6f92aedec0$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jzO5Y", function(module, exports) {

module.exports = (parcelRequire("jMc9N")).EventEmitter;

});

parcelRegister("5Io6y", function(module, exports) {
"use strict";

});

parcelRegister("6OboF", function(module, exports) {
'use strict';
function $4f5040c8913da7e7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4f5040c8913da7e7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4f5040c8913da7e7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4f5040c8913da7e7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4f5040c8913da7e7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4f5040c8913da7e7$var$_defineProperty(obj, key, value) {
    key = $4f5040c8913da7e7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4f5040c8913da7e7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4f5040c8913da7e7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4f5040c8913da7e7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4f5040c8913da7e7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4f5040c8913da7e7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4f5040c8913da7e7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4f5040c8913da7e7$var$_toPropertyKey(arg) {
    var key = $4f5040c8913da7e7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $4f5040c8913da7e7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $ihoyg = parcelRequire("ihoyg");
var $4f5040c8913da7e7$var$Buffer = $ihoyg.Buffer;

var $5Io6y = parcelRequire("5Io6y");
var $4f5040c8913da7e7$var$inspect = $5Io6y.inspect;
var $4f5040c8913da7e7$var$custom = $4f5040c8913da7e7$var$inspect && $4f5040c8913da7e7$var$inspect.custom || 'inspect';
function $4f5040c8913da7e7$var$copyBuffer(src, target, offset) {
    $4f5040c8913da7e7$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $4f5040c8913da7e7$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $4f5040c8913da7e7$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $4f5040c8913da7e7$var$Buffer.alloc(0);
                var ret = $4f5040c8913da7e7$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $4f5040c8913da7e7$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $4f5040c8913da7e7$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $4f5040c8913da7e7$var$custom,
            value: function value(_, options) {
                return $4f5040c8913da7e7$var$inspect(this, $4f5040c8913da7e7$var$_objectSpread($4f5040c8913da7e7$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("hgvHE", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $c91c85d93ea50665$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $4TNnu.nextTick($c91c85d93ea50665$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $4TNnu.nextTick($c91c85d93ea50665$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $4TNnu.nextTick($c91c85d93ea50665$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $4TNnu.nextTick($c91c85d93ea50665$var$emitErrorAndCloseNT, _this, err);
            } else $4TNnu.nextTick($c91c85d93ea50665$var$emitCloseNT, _this);
        } else if (cb) {
            $4TNnu.nextTick($c91c85d93ea50665$var$emitCloseNT, _this);
            cb(err);
        } else $4TNnu.nextTick($c91c85d93ea50665$var$emitCloseNT, _this);
    });
    return this;
}
function $c91c85d93ea50665$var$emitErrorAndCloseNT(self, err) {
    $c91c85d93ea50665$var$emitErrorNT(self, err);
    $c91c85d93ea50665$var$emitCloseNT(self);
}
function $c91c85d93ea50665$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $c91c85d93ea50665$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $c91c85d93ea50665$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $c91c85d93ea50665$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $c91c85d93ea50665$var$destroy,
    undestroy: $c91c85d93ea50665$var$undestroy,
    errorOrDestroy: $c91c85d93ea50665$var$errorOrDestroy
};

});

parcelRegister("1qNnQ", function(module, exports) {
'use strict';

var $10ae86b99ba11b35$var$ERR_INVALID_OPT_VALUE = (parcelRequire("dRF2w")).codes.ERR_INVALID_OPT_VALUE;
function $10ae86b99ba11b35$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $10ae86b99ba11b35$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $10ae86b99ba11b35$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $10ae86b99ba11b35$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $10ae86b99ba11b35$var$getHighWaterMark
};

});
parcelRegister("dRF2w", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $a1800f36e40daaed$export$e45cb6485273080e; }, function (v) { return $a1800f36e40daaed$export$e45cb6485273080e = v; });
var $a1800f36e40daaed$export$e45cb6485273080e;
'use strict';
function $a1800f36e40daaed$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $a1800f36e40daaed$var$codes = {};
function $a1800f36e40daaed$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $a1800f36e40daaed$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $a1800f36e40daaed$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $a1800f36e40daaed$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $a1800f36e40daaed$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $a1800f36e40daaed$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $a1800f36e40daaed$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$a1800f36e40daaed$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$a1800f36e40daaed$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $a1800f36e40daaed$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($a1800f36e40daaed$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($a1800f36e40daaed$var$oneOf(expected, 'type'));
    else {
        var type = $a1800f36e40daaed$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($a1800f36e40daaed$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$a1800f36e40daaed$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$a1800f36e40daaed$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$a1800f36e40daaed$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$a1800f36e40daaed$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$a1800f36e40daaed$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$a1800f36e40daaed$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$a1800f36e40daaed$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$a1800f36e40daaed$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$a1800f36e40daaed$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$a1800f36e40daaed$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$a1800f36e40daaed$export$e45cb6485273080e = $a1800f36e40daaed$var$codes;

});


parcelRegister("gb1AQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $4TNnu = parcelRequire("4TNnu");
'use strict';
/*<replacement>*/ var $bc6ee8cc9ce4fb49$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $bc6ee8cc9ce4fb49$var$Duplex;

var $gbyK3 = parcelRequire("gbyK3");

var $7OiFs = parcelRequire("7OiFs");

(parcelRequire("eSHUL"))($bc6ee8cc9ce4fb49$var$Duplex, $gbyK3);
// Allow the keys array to be GC'ed.
var $bc6ee8cc9ce4fb49$var$keys = $bc6ee8cc9ce4fb49$var$objectKeys($7OiFs.prototype);
for(var $bc6ee8cc9ce4fb49$var$v = 0; $bc6ee8cc9ce4fb49$var$v < $bc6ee8cc9ce4fb49$var$keys.length; $bc6ee8cc9ce4fb49$var$v++){
    var $bc6ee8cc9ce4fb49$var$method = $bc6ee8cc9ce4fb49$var$keys[$bc6ee8cc9ce4fb49$var$v];
    if (!$bc6ee8cc9ce4fb49$var$Duplex.prototype[$bc6ee8cc9ce4fb49$var$method]) $bc6ee8cc9ce4fb49$var$Duplex.prototype[$bc6ee8cc9ce4fb49$var$method] = $7OiFs.prototype[$bc6ee8cc9ce4fb49$var$method];
}
function $bc6ee8cc9ce4fb49$var$Duplex(options) {
    if (!(this instanceof $bc6ee8cc9ce4fb49$var$Duplex)) return new $bc6ee8cc9ce4fb49$var$Duplex(options);
    $gbyK3.call(this, options);
    $7OiFs.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $bc6ee8cc9ce4fb49$var$onend);
        }
    }
}
Object.defineProperty($bc6ee8cc9ce4fb49$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($bc6ee8cc9ce4fb49$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($bc6ee8cc9ce4fb49$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $bc6ee8cc9ce4fb49$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $4TNnu.nextTick($bc6ee8cc9ce4fb49$var$onEndNT, this);
}
function $bc6ee8cc9ce4fb49$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($bc6ee8cc9ce4fb49$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("7OiFs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $4TNnu = parcelRequire("4TNnu");
'use strict';
module.exports = $5afbaee75d9861fc$var$Writable;
/* <replacement> */ function $5afbaee75d9861fc$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5afbaee75d9861fc$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5afbaee75d9861fc$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5afbaee75d9861fc$var$Duplex;
/*</replacement>*/ $5afbaee75d9861fc$var$Writable.WritableState = $5afbaee75d9861fc$var$WritableState;

/*<replacement>*/ var $5afbaee75d9861fc$var$internalUtil = {
    deprecate: (parcelRequire("l4FQK"))
};

var $jzO5Y = parcelRequire("jzO5Y");

var $ihoyg = parcelRequire("ihoyg");
var $5afbaee75d9861fc$require$Buffer = $ihoyg.Buffer;
var $5afbaee75d9861fc$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $5afbaee75d9861fc$var$_uint8ArrayToBuffer(chunk) {
    return $5afbaee75d9861fc$require$Buffer.from(chunk);
}
function $5afbaee75d9861fc$var$_isUint8Array(obj) {
    return $5afbaee75d9861fc$require$Buffer.isBuffer(obj) || obj instanceof $5afbaee75d9861fc$var$OurUint8Array;
}

var $hgvHE = parcelRequire("hgvHE");

var $1qNnQ = parcelRequire("1qNnQ");
var $5afbaee75d9861fc$var$getHighWaterMark = $1qNnQ.getHighWaterMark;

var $dRF2w = parcelRequire("dRF2w");
var $5afbaee75d9861fc$require$_require$codes = $dRF2w.codes;
var $5afbaee75d9861fc$var$ERR_INVALID_ARG_TYPE = $5afbaee75d9861fc$require$_require$codes.ERR_INVALID_ARG_TYPE, $5afbaee75d9861fc$var$ERR_METHOD_NOT_IMPLEMENTED = $5afbaee75d9861fc$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5afbaee75d9861fc$var$ERR_MULTIPLE_CALLBACK = $5afbaee75d9861fc$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5afbaee75d9861fc$var$ERR_STREAM_CANNOT_PIPE = $5afbaee75d9861fc$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $5afbaee75d9861fc$var$ERR_STREAM_DESTROYED = $5afbaee75d9861fc$require$_require$codes.ERR_STREAM_DESTROYED, $5afbaee75d9861fc$var$ERR_STREAM_NULL_VALUES = $5afbaee75d9861fc$require$_require$codes.ERR_STREAM_NULL_VALUES, $5afbaee75d9861fc$var$ERR_STREAM_WRITE_AFTER_END = $5afbaee75d9861fc$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $5afbaee75d9861fc$var$ERR_UNKNOWN_ENCODING = $5afbaee75d9861fc$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $5afbaee75d9861fc$var$errorOrDestroy = $hgvHE.errorOrDestroy;

(parcelRequire("eSHUL"))($5afbaee75d9861fc$var$Writable, $jzO5Y);
function $5afbaee75d9861fc$var$nop() {}

function $5afbaee75d9861fc$var$WritableState(options, stream, isDuplex) {
    $5afbaee75d9861fc$var$Duplex = $5afbaee75d9861fc$var$Duplex || (parcelRequire("gb1AQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $5afbaee75d9861fc$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $5afbaee75d9861fc$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5afbaee75d9861fc$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5afbaee75d9861fc$var$CorkedRequest(this);
}
$5afbaee75d9861fc$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5afbaee75d9861fc$var$WritableState.prototype, 'buffer', {
            get: $5afbaee75d9861fc$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5afbaee75d9861fc$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $5afbaee75d9861fc$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5afbaee75d9861fc$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($5afbaee75d9861fc$var$realHasInstance.call(this, object)) return true;
            if (this !== $5afbaee75d9861fc$var$Writable) return false;
            return object && object._writableState instanceof $5afbaee75d9861fc$var$WritableState;
        }
    });
} else $5afbaee75d9861fc$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $5afbaee75d9861fc$var$Writable(options) {
    $5afbaee75d9861fc$var$Duplex = $5afbaee75d9861fc$var$Duplex || (parcelRequire("gb1AQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5afbaee75d9861fc$var$Duplex;
    if (!isDuplex && !$5afbaee75d9861fc$var$realHasInstance.call($5afbaee75d9861fc$var$Writable, this)) return new $5afbaee75d9861fc$var$Writable(options);
    this._writableState = new $5afbaee75d9861fc$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $jzO5Y.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5afbaee75d9861fc$var$Writable.prototype.pipe = function() {
    $5afbaee75d9861fc$var$errorOrDestroy(this, new $5afbaee75d9861fc$var$ERR_STREAM_CANNOT_PIPE());
};
function $5afbaee75d9861fc$var$writeAfterEnd(stream, cb) {
    var er = new $5afbaee75d9861fc$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $5afbaee75d9861fc$var$errorOrDestroy(stream, er);
    $4TNnu.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5afbaee75d9861fc$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $5afbaee75d9861fc$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $5afbaee75d9861fc$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $5afbaee75d9861fc$var$errorOrDestroy(stream, er);
        $4TNnu.nextTick(cb, er);
        return false;
    }
    return true;
}
$5afbaee75d9861fc$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5afbaee75d9861fc$var$_isUint8Array(chunk);
    if (isBuf && !$5afbaee75d9861fc$require$Buffer.isBuffer(chunk)) chunk = $5afbaee75d9861fc$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $5afbaee75d9861fc$var$nop;
    if (state.ending) $5afbaee75d9861fc$var$writeAfterEnd(this, cb);
    else if (isBuf || $5afbaee75d9861fc$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5afbaee75d9861fc$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5afbaee75d9861fc$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5afbaee75d9861fc$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5afbaee75d9861fc$var$clearBuffer(this, state);
    }
};
$5afbaee75d9861fc$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $5afbaee75d9861fc$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($5afbaee75d9861fc$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $5afbaee75d9861fc$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $5afbaee75d9861fc$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5afbaee75d9861fc$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5afbaee75d9861fc$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5afbaee75d9861fc$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5afbaee75d9861fc$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5afbaee75d9861fc$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5afbaee75d9861fc$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5afbaee75d9861fc$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $4TNnu.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $4TNnu.nextTick($5afbaee75d9861fc$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $5afbaee75d9861fc$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $5afbaee75d9861fc$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $5afbaee75d9861fc$var$finishMaybe(stream, state);
    }
}
function $5afbaee75d9861fc$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5afbaee75d9861fc$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $5afbaee75d9861fc$var$ERR_MULTIPLE_CALLBACK();
    $5afbaee75d9861fc$var$onwriteStateUpdate(state);
    if (er) $5afbaee75d9861fc$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5afbaee75d9861fc$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5afbaee75d9861fc$var$clearBuffer(stream, state);
        if (sync) $4TNnu.nextTick($5afbaee75d9861fc$var$afterWrite, stream, state, finished, cb);
        else $5afbaee75d9861fc$var$afterWrite(stream, state, finished, cb);
    }
}
function $5afbaee75d9861fc$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5afbaee75d9861fc$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5afbaee75d9861fc$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5afbaee75d9861fc$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $5afbaee75d9861fc$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5afbaee75d9861fc$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5afbaee75d9861fc$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5afbaee75d9861fc$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5afbaee75d9861fc$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $5afbaee75d9861fc$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$5afbaee75d9861fc$var$Writable.prototype._writev = null;
$5afbaee75d9861fc$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5afbaee75d9861fc$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($5afbaee75d9861fc$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $5afbaee75d9861fc$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5afbaee75d9861fc$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $5afbaee75d9861fc$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $5afbaee75d9861fc$var$finishMaybe(stream, state);
    });
}
function $5afbaee75d9861fc$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $4TNnu.nextTick($5afbaee75d9861fc$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $5afbaee75d9861fc$var$finishMaybe(stream, state) {
    var need = $5afbaee75d9861fc$var$needFinish(state);
    if (need) {
        $5afbaee75d9861fc$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $5afbaee75d9861fc$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5afbaee75d9861fc$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $4TNnu.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5afbaee75d9861fc$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5afbaee75d9861fc$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5afbaee75d9861fc$var$Writable.prototype.destroy = $hgvHE.destroy;
$5afbaee75d9861fc$var$Writable.prototype._undestroy = $hgvHE.undestroy;
$5afbaee75d9861fc$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("l4FQK", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $f57a6f356a44cf08$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $f57a6f356a44cf08$var$deprecate(fn, msg) {
    if ($f57a6f356a44cf08$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($f57a6f356a44cf08$var$config('throwDeprecation')) throw new Error(msg);
            else if ($f57a6f356a44cf08$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $f57a6f356a44cf08$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("lEpDX", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $fc3139ad3bf9c399$export$63a7aa211a91ed69; }, function (v) { return $fc3139ad3bf9c399$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $fc3139ad3bf9c399$export$63a7aa211a91ed69;
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $fc3139ad3bf9c399$require$Buffer = $6U9mG.Buffer;
/*</replacement>*/ var $fc3139ad3bf9c399$var$isEncoding = $fc3139ad3bf9c399$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $fc3139ad3bf9c399$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $fc3139ad3bf9c399$var$normalizeEncoding(enc) {
    var nenc = $fc3139ad3bf9c399$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($fc3139ad3bf9c399$require$Buffer.isEncoding === $fc3139ad3bf9c399$var$isEncoding || !$fc3139ad3bf9c399$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$fc3139ad3bf9c399$export$63a7aa211a91ed69 = $fc3139ad3bf9c399$var$StringDecoder;
function $fc3139ad3bf9c399$var$StringDecoder(encoding) {
    this.encoding = $fc3139ad3bf9c399$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $fc3139ad3bf9c399$var$utf16Text;
            this.end = $fc3139ad3bf9c399$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $fc3139ad3bf9c399$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $fc3139ad3bf9c399$var$base64Text;
            this.end = $fc3139ad3bf9c399$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $fc3139ad3bf9c399$var$simpleWrite;
            this.end = $fc3139ad3bf9c399$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $fc3139ad3bf9c399$require$Buffer.allocUnsafe(nb);
}
$fc3139ad3bf9c399$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$fc3139ad3bf9c399$var$StringDecoder.prototype.end = $fc3139ad3bf9c399$var$utf8End;
// Returns only complete characters in a Buffer
$fc3139ad3bf9c399$var$StringDecoder.prototype.text = $fc3139ad3bf9c399$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$fc3139ad3bf9c399$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $fc3139ad3bf9c399$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $fc3139ad3bf9c399$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $fc3139ad3bf9c399$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $fc3139ad3bf9c399$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $fc3139ad3bf9c399$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $fc3139ad3bf9c399$var$utf8Text(buf, i) {
    var total = $fc3139ad3bf9c399$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $fc3139ad3bf9c399$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $fc3139ad3bf9c399$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $fc3139ad3bf9c399$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $fc3139ad3bf9c399$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $fc3139ad3bf9c399$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $fc3139ad3bf9c399$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $fc3139ad3bf9c399$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("j2AXH", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
'use strict';
var $ddcae0115fad8035$var$_Object$setPrototypeO;
function $ddcae0115fad8035$var$_defineProperty(obj, key, value) {
    key = $ddcae0115fad8035$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ddcae0115fad8035$var$_toPropertyKey(arg) {
    var key = $ddcae0115fad8035$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $ddcae0115fad8035$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $bMXnq = parcelRequire("bMXnq");
var $ddcae0115fad8035$var$kLastResolve = Symbol('lastResolve');
var $ddcae0115fad8035$var$kLastReject = Symbol('lastReject');
var $ddcae0115fad8035$var$kError = Symbol('error');
var $ddcae0115fad8035$var$kEnded = Symbol('ended');
var $ddcae0115fad8035$var$kLastPromise = Symbol('lastPromise');
var $ddcae0115fad8035$var$kHandlePromise = Symbol('handlePromise');
var $ddcae0115fad8035$var$kStream = Symbol('stream');
function $ddcae0115fad8035$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $ddcae0115fad8035$var$readAndResolve(iter) {
    var resolve = iter[$ddcae0115fad8035$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$ddcae0115fad8035$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$ddcae0115fad8035$var$kLastPromise] = null;
            iter[$ddcae0115fad8035$var$kLastResolve] = null;
            iter[$ddcae0115fad8035$var$kLastReject] = null;
            resolve($ddcae0115fad8035$var$createIterResult(data, false));
        }
    }
}
function $ddcae0115fad8035$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $4TNnu.nextTick($ddcae0115fad8035$var$readAndResolve, iter);
}
function $ddcae0115fad8035$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$ddcae0115fad8035$var$kEnded]) {
                resolve($ddcae0115fad8035$var$createIterResult(undefined, true));
                return;
            }
            iter[$ddcae0115fad8035$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $ddcae0115fad8035$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $ddcae0115fad8035$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($ddcae0115fad8035$var$_Object$setPrototypeO = {
    get stream () {
        return this[$ddcae0115fad8035$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$ddcae0115fad8035$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$ddcae0115fad8035$var$kEnded]) return Promise.resolve($ddcae0115fad8035$var$createIterResult(undefined, true));
        if (this[$ddcae0115fad8035$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $4TNnu.nextTick(function() {
                if (_this[$ddcae0115fad8035$var$kError]) reject(_this[$ddcae0115fad8035$var$kError]);
                else resolve($ddcae0115fad8035$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$ddcae0115fad8035$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($ddcae0115fad8035$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$ddcae0115fad8035$var$kStream].read();
            if (data !== null) return Promise.resolve($ddcae0115fad8035$var$createIterResult(data, false));
            promise = new Promise(this[$ddcae0115fad8035$var$kHandlePromise]);
        }
        this[$ddcae0115fad8035$var$kLastPromise] = promise;
        return promise;
    }
}, $ddcae0115fad8035$var$_defineProperty($ddcae0115fad8035$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $ddcae0115fad8035$var$_defineProperty($ddcae0115fad8035$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$ddcae0115fad8035$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($ddcae0115fad8035$var$createIterResult(undefined, true));
        });
    });
}), $ddcae0115fad8035$var$_Object$setPrototypeO), $ddcae0115fad8035$var$AsyncIteratorPrototype);
var $ddcae0115fad8035$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($ddcae0115fad8035$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $ddcae0115fad8035$var$_defineProperty(_Object$create, $ddcae0115fad8035$var$kStream, {
        value: stream,
        writable: true
    }), $ddcae0115fad8035$var$_defineProperty(_Object$create, $ddcae0115fad8035$var$kLastResolve, {
        value: null,
        writable: true
    }), $ddcae0115fad8035$var$_defineProperty(_Object$create, $ddcae0115fad8035$var$kLastReject, {
        value: null,
        writable: true
    }), $ddcae0115fad8035$var$_defineProperty(_Object$create, $ddcae0115fad8035$var$kError, {
        value: null,
        writable: true
    }), $ddcae0115fad8035$var$_defineProperty(_Object$create, $ddcae0115fad8035$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $ddcae0115fad8035$var$_defineProperty(_Object$create, $ddcae0115fad8035$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$ddcae0115fad8035$var$kStream].read();
            if (data) {
                iterator[$ddcae0115fad8035$var$kLastPromise] = null;
                iterator[$ddcae0115fad8035$var$kLastResolve] = null;
                iterator[$ddcae0115fad8035$var$kLastReject] = null;
                resolve($ddcae0115fad8035$var$createIterResult(data, false));
            } else {
                iterator[$ddcae0115fad8035$var$kLastResolve] = resolve;
                iterator[$ddcae0115fad8035$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$ddcae0115fad8035$var$kLastPromise] = null;
    $bMXnq(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$ddcae0115fad8035$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$ddcae0115fad8035$var$kLastPromise] = null;
                iterator[$ddcae0115fad8035$var$kLastResolve] = null;
                iterator[$ddcae0115fad8035$var$kLastReject] = null;
                reject(err);
            }
            iterator[$ddcae0115fad8035$var$kError] = err;
            return;
        }
        var resolve = iterator[$ddcae0115fad8035$var$kLastResolve];
        if (resolve !== null) {
            iterator[$ddcae0115fad8035$var$kLastPromise] = null;
            iterator[$ddcae0115fad8035$var$kLastResolve] = null;
            iterator[$ddcae0115fad8035$var$kLastReject] = null;
            resolve($ddcae0115fad8035$var$createIterResult(undefined, true));
        }
        iterator[$ddcae0115fad8035$var$kEnded] = true;
    });
    stream.on('readable', $ddcae0115fad8035$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $ddcae0115fad8035$var$createReadableStreamAsyncIterator;

});
parcelRegister("bMXnq", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $89523c68c4325aec$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("dRF2w")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $89523c68c4325aec$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $89523c68c4325aec$var$noop() {}
function $89523c68c4325aec$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $89523c68c4325aec$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $89523c68c4325aec$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $89523c68c4325aec$var$once(callback || $89523c68c4325aec$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $89523c68c4325aec$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $89523c68c4325aec$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($89523c68c4325aec$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $89523c68c4325aec$var$eos;

});


parcelRegister("9fR9D", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("7ozOp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $56268dd0da6eb5b6$var$Transform;

var $dRF2w = parcelRequire("dRF2w");
var $56268dd0da6eb5b6$require$_require$codes = $dRF2w.codes;
var $56268dd0da6eb5b6$var$ERR_METHOD_NOT_IMPLEMENTED = $56268dd0da6eb5b6$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $56268dd0da6eb5b6$var$ERR_MULTIPLE_CALLBACK = $56268dd0da6eb5b6$require$_require$codes.ERR_MULTIPLE_CALLBACK, $56268dd0da6eb5b6$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $56268dd0da6eb5b6$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $56268dd0da6eb5b6$var$ERR_TRANSFORM_WITH_LENGTH_0 = $56268dd0da6eb5b6$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $gb1AQ = parcelRequire("gb1AQ");

(parcelRequire("eSHUL"))($56268dd0da6eb5b6$var$Transform, $gb1AQ);
function $56268dd0da6eb5b6$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $56268dd0da6eb5b6$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $56268dd0da6eb5b6$var$Transform(options) {
    if (!(this instanceof $56268dd0da6eb5b6$var$Transform)) return new $56268dd0da6eb5b6$var$Transform(options);
    $gb1AQ.call(this, options);
    this._transformState = {
        afterTransform: $56268dd0da6eb5b6$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $56268dd0da6eb5b6$var$prefinish);
}
function $56268dd0da6eb5b6$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $56268dd0da6eb5b6$var$done(_this, er, data);
    });
    else $56268dd0da6eb5b6$var$done(this, null, null);
}
$56268dd0da6eb5b6$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $gb1AQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$56268dd0da6eb5b6$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $56268dd0da6eb5b6$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$56268dd0da6eb5b6$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$56268dd0da6eb5b6$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$56268dd0da6eb5b6$var$Transform.prototype._destroy = function(err, cb) {
    $gb1AQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $56268dd0da6eb5b6$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $56268dd0da6eb5b6$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $56268dd0da6eb5b6$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("6qwr0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $4ade549c8d3aaa92$var$PassThrough;

var $7ozOp = parcelRequire("7ozOp");

(parcelRequire("eSHUL"))($4ade549c8d3aaa92$var$PassThrough, $7ozOp);
function $4ade549c8d3aaa92$var$PassThrough(options) {
    if (!(this instanceof $4ade549c8d3aaa92$var$PassThrough)) return new $4ade549c8d3aaa92$var$PassThrough(options);
    $7ozOp.call(this, options);
}
$4ade549c8d3aaa92$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("46RH2", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $2fe15f5371d1165f$var$eos;
function $2fe15f5371d1165f$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $dRF2w = parcelRequire("dRF2w");
var $2fe15f5371d1165f$require$_require$codes = $dRF2w.codes;
var $2fe15f5371d1165f$var$ERR_MISSING_ARGS = $2fe15f5371d1165f$require$_require$codes.ERR_MISSING_ARGS, $2fe15f5371d1165f$var$ERR_STREAM_DESTROYED = $2fe15f5371d1165f$require$_require$codes.ERR_STREAM_DESTROYED;
function $2fe15f5371d1165f$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $2fe15f5371d1165f$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $2fe15f5371d1165f$var$destroyer(stream, reading, writing, callback) {
    callback = $2fe15f5371d1165f$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($2fe15f5371d1165f$var$eos === undefined) $2fe15f5371d1165f$var$eos = (parcelRequire("bMXnq"));
    $2fe15f5371d1165f$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($2fe15f5371d1165f$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $2fe15f5371d1165f$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $2fe15f5371d1165f$var$call(fn) {
    fn();
}
function $2fe15f5371d1165f$var$pipe(from, to) {
    return from.pipe(to);
}
function $2fe15f5371d1165f$var$popCallback(streams) {
    if (!streams.length) return $2fe15f5371d1165f$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $2fe15f5371d1165f$var$noop;
    return streams.pop();
}
function $2fe15f5371d1165f$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $2fe15f5371d1165f$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $2fe15f5371d1165f$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $2fe15f5371d1165f$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($2fe15f5371d1165f$var$call);
            if (reading) return;
            destroys.forEach($2fe15f5371d1165f$var$call);
            callback(error);
        });
    });
    return streams.reduce($2fe15f5371d1165f$var$pipe);
}
module.exports = $2fe15f5371d1165f$var$pipeline;

});


parcelRegister("4zyeF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TNnu = parcelRequire("4TNnu");
var $3544fccbcc6ce858$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $3544fccbcc6ce858$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$3544fccbcc6ce858$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($3544fccbcc6ce858$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($3544fccbcc6ce858$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($3544fccbcc6ce858$var$isNull(x) || !$3544fccbcc6ce858$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $3544fccbcc6ce858$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($4TNnu.throwDeprecation) throw new Error(msg);
            else if ($4TNnu.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $3544fccbcc6ce858$var$debugs = {};
var $3544fccbcc6ce858$var$debugEnvRegex = /^$/;
var $3544fccbcc6ce858$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$3544fccbcc6ce858$var$debugs[set]) {
        if ($3544fccbcc6ce858$var$debugEnvRegex.test(set)) {
            var pid = $4TNnu.pid;
            $3544fccbcc6ce858$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $3544fccbcc6ce858$var$debugs[set] = function() {};
    }
    return $3544fccbcc6ce858$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $3544fccbcc6ce858$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $3544fccbcc6ce858$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($3544fccbcc6ce858$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($3544fccbcc6ce858$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($3544fccbcc6ce858$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($3544fccbcc6ce858$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($3544fccbcc6ce858$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $3544fccbcc6ce858$var$stylizeWithColor;
    return $3544fccbcc6ce858$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $3544fccbcc6ce858$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$3544fccbcc6ce858$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$3544fccbcc6ce858$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $3544fccbcc6ce858$var$stylizeWithColor(str, styleType) {
    var style = $3544fccbcc6ce858$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $3544fccbcc6ce858$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $3544fccbcc6ce858$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $3544fccbcc6ce858$var$stylizeNoColor(str, styleType) {
    return str;
}
function $3544fccbcc6ce858$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $3544fccbcc6ce858$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $3544fccbcc6ce858$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$3544fccbcc6ce858$var$isString(ret)) ret = $3544fccbcc6ce858$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $3544fccbcc6ce858$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $3544fccbcc6ce858$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($3544fccbcc6ce858$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $3544fccbcc6ce858$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($3544fccbcc6ce858$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($3544fccbcc6ce858$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($3544fccbcc6ce858$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($3544fccbcc6ce858$var$isError(value)) return $3544fccbcc6ce858$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($3544fccbcc6ce858$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($3544fccbcc6ce858$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($3544fccbcc6ce858$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($3544fccbcc6ce858$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($3544fccbcc6ce858$var$isError(value)) base = ' ' + $3544fccbcc6ce858$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($3544fccbcc6ce858$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $3544fccbcc6ce858$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $3544fccbcc6ce858$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $3544fccbcc6ce858$var$reduceToSingleString(output, base, braces);
}
function $3544fccbcc6ce858$var$formatPrimitive(ctx, value) {
    if ($3544fccbcc6ce858$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($3544fccbcc6ce858$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($3544fccbcc6ce858$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($3544fccbcc6ce858$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($3544fccbcc6ce858$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $3544fccbcc6ce858$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $3544fccbcc6ce858$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($3544fccbcc6ce858$var$hasOwnProperty(value, String(i))) output.push($3544fccbcc6ce858$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($3544fccbcc6ce858$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $3544fccbcc6ce858$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$3544fccbcc6ce858$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($3544fccbcc6ce858$var$isNull(recurseTimes)) str = $3544fccbcc6ce858$var$formatValue(ctx, desc.value, null);
            else str = $3544fccbcc6ce858$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($3544fccbcc6ce858$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $3544fccbcc6ce858$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("kPQSU"));
function $3544fccbcc6ce858$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $3544fccbcc6ce858$var$isArray;
function $3544fccbcc6ce858$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $3544fccbcc6ce858$var$isBoolean;
function $3544fccbcc6ce858$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $3544fccbcc6ce858$var$isNull;
function $3544fccbcc6ce858$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $3544fccbcc6ce858$var$isNullOrUndefined;
function $3544fccbcc6ce858$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $3544fccbcc6ce858$var$isNumber;
function $3544fccbcc6ce858$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $3544fccbcc6ce858$var$isString;
function $3544fccbcc6ce858$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $3544fccbcc6ce858$var$isSymbol;
function $3544fccbcc6ce858$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $3544fccbcc6ce858$var$isUndefined;
function $3544fccbcc6ce858$var$isRegExp(re) {
    return $3544fccbcc6ce858$var$isObject(re) && $3544fccbcc6ce858$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $3544fccbcc6ce858$var$isRegExp;
module.exports.types.isRegExp = $3544fccbcc6ce858$var$isRegExp;
function $3544fccbcc6ce858$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $3544fccbcc6ce858$var$isObject;
function $3544fccbcc6ce858$var$isDate(d) {
    return $3544fccbcc6ce858$var$isObject(d) && $3544fccbcc6ce858$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $3544fccbcc6ce858$var$isDate;
module.exports.types.isDate = $3544fccbcc6ce858$var$isDate;
function $3544fccbcc6ce858$var$isError(e) {
    return $3544fccbcc6ce858$var$isObject(e) && ($3544fccbcc6ce858$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $3544fccbcc6ce858$var$isError;
module.exports.types.isNativeError = $3544fccbcc6ce858$var$isError;
function $3544fccbcc6ce858$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $3544fccbcc6ce858$var$isFunction;
function $3544fccbcc6ce858$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $3544fccbcc6ce858$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kieVX"));
function $3544fccbcc6ce858$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $3544fccbcc6ce858$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $3544fccbcc6ce858$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $3544fccbcc6ce858$var$timestamp() {
    var d = new Date();
    var time = [
        $3544fccbcc6ce858$var$pad(d.getHours()),
        $3544fccbcc6ce858$var$pad(d.getMinutes()),
        $3544fccbcc6ce858$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $3544fccbcc6ce858$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $3544fccbcc6ce858$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("eSHUL"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$3544fccbcc6ce858$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $3544fccbcc6ce858$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $3544fccbcc6ce858$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($3544fccbcc6ce858$var$kCustomPromisifiedSymbol && original[$3544fccbcc6ce858$var$kCustomPromisifiedSymbol]) {
        var fn = original[$3544fccbcc6ce858$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $3544fccbcc6ce858$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($3544fccbcc6ce858$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $3544fccbcc6ce858$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $3544fccbcc6ce858$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $3544fccbcc6ce858$var$kCustomPromisifiedSymbol;
function $3544fccbcc6ce858$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $3544fccbcc6ce858$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $4TNnu.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $4TNnu.nextTick($3544fccbcc6ce858$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $3544fccbcc6ce858$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $3544fccbcc6ce858$var$callbackify;

});
parcelRegister("kPQSU", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $6LFJs = parcelRequire("6LFJs");

var $lhqXC = parcelRequire("lhqXC");

var $nBFK4 = parcelRequire("nBFK4");

var $htkB6 = parcelRequire("htkB6");
function $f2b197d61b88f951$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $f2b197d61b88f951$var$BigIntSupported = typeof BigInt !== 'undefined';
var $f2b197d61b88f951$var$SymbolSupported = typeof Symbol !== 'undefined';
var $f2b197d61b88f951$var$ObjectToString = $f2b197d61b88f951$var$uncurryThis(Object.prototype.toString);
var $f2b197d61b88f951$var$numberValue = $f2b197d61b88f951$var$uncurryThis(Number.prototype.valueOf);
var $f2b197d61b88f951$var$stringValue = $f2b197d61b88f951$var$uncurryThis(String.prototype.valueOf);
var $f2b197d61b88f951$var$booleanValue = $f2b197d61b88f951$var$uncurryThis(Boolean.prototype.valueOf);
if ($f2b197d61b88f951$var$BigIntSupported) var $f2b197d61b88f951$var$bigIntValue = $f2b197d61b88f951$var$uncurryThis(BigInt.prototype.valueOf);
if ($f2b197d61b88f951$var$SymbolSupported) var $f2b197d61b88f951$var$symbolValue = $f2b197d61b88f951$var$uncurryThis(Symbol.prototype.valueOf);
function $f2b197d61b88f951$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $6LFJs;
module.exports.isGeneratorFunction = $lhqXC;
module.exports.isTypedArray = $htkB6;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $f2b197d61b88f951$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $f2b197d61b88f951$var$isPromise;
function $f2b197d61b88f951$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $htkB6(value) || $f2b197d61b88f951$var$isDataView(value);
}
module.exports.isArrayBufferView = $f2b197d61b88f951$var$isArrayBufferView;
function $f2b197d61b88f951$var$isUint8Array(value) {
    return $nBFK4(value) === 'Uint8Array';
}
module.exports.isUint8Array = $f2b197d61b88f951$var$isUint8Array;
function $f2b197d61b88f951$var$isUint8ClampedArray(value) {
    return $nBFK4(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $f2b197d61b88f951$var$isUint8ClampedArray;
function $f2b197d61b88f951$var$isUint16Array(value) {
    return $nBFK4(value) === 'Uint16Array';
}
module.exports.isUint16Array = $f2b197d61b88f951$var$isUint16Array;
function $f2b197d61b88f951$var$isUint32Array(value) {
    return $nBFK4(value) === 'Uint32Array';
}
module.exports.isUint32Array = $f2b197d61b88f951$var$isUint32Array;
function $f2b197d61b88f951$var$isInt8Array(value) {
    return $nBFK4(value) === 'Int8Array';
}
module.exports.isInt8Array = $f2b197d61b88f951$var$isInt8Array;
function $f2b197d61b88f951$var$isInt16Array(value) {
    return $nBFK4(value) === 'Int16Array';
}
module.exports.isInt16Array = $f2b197d61b88f951$var$isInt16Array;
function $f2b197d61b88f951$var$isInt32Array(value) {
    return $nBFK4(value) === 'Int32Array';
}
module.exports.isInt32Array = $f2b197d61b88f951$var$isInt32Array;
function $f2b197d61b88f951$var$isFloat32Array(value) {
    return $nBFK4(value) === 'Float32Array';
}
module.exports.isFloat32Array = $f2b197d61b88f951$var$isFloat32Array;
function $f2b197d61b88f951$var$isFloat64Array(value) {
    return $nBFK4(value) === 'Float64Array';
}
module.exports.isFloat64Array = $f2b197d61b88f951$var$isFloat64Array;
function $f2b197d61b88f951$var$isBigInt64Array(value) {
    return $nBFK4(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $f2b197d61b88f951$var$isBigInt64Array;
function $f2b197d61b88f951$var$isBigUint64Array(value) {
    return $nBFK4(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $f2b197d61b88f951$var$isBigUint64Array;
function $f2b197d61b88f951$var$isMapToString(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === '[object Map]';
}
$f2b197d61b88f951$var$isMapToString.working = typeof Map !== 'undefined' && $f2b197d61b88f951$var$isMapToString(new Map());
function $f2b197d61b88f951$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $f2b197d61b88f951$var$isMapToString.working ? $f2b197d61b88f951$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $f2b197d61b88f951$var$isMap;
function $f2b197d61b88f951$var$isSetToString(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === '[object Set]';
}
$f2b197d61b88f951$var$isSetToString.working = typeof Set !== 'undefined' && $f2b197d61b88f951$var$isSetToString(new Set());
function $f2b197d61b88f951$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $f2b197d61b88f951$var$isSetToString.working ? $f2b197d61b88f951$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $f2b197d61b88f951$var$isSet;
function $f2b197d61b88f951$var$isWeakMapToString(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === '[object WeakMap]';
}
$f2b197d61b88f951$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $f2b197d61b88f951$var$isWeakMapToString(new WeakMap());
function $f2b197d61b88f951$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $f2b197d61b88f951$var$isWeakMapToString.working ? $f2b197d61b88f951$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $f2b197d61b88f951$var$isWeakMap;
function $f2b197d61b88f951$var$isWeakSetToString(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === '[object WeakSet]';
}
$f2b197d61b88f951$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $f2b197d61b88f951$var$isWeakSetToString(new WeakSet());
function $f2b197d61b88f951$var$isWeakSet(value) {
    return $f2b197d61b88f951$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $f2b197d61b88f951$var$isWeakSet;
function $f2b197d61b88f951$var$isArrayBufferToString(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$f2b197d61b88f951$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $f2b197d61b88f951$var$isArrayBufferToString(new ArrayBuffer());
function $f2b197d61b88f951$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $f2b197d61b88f951$var$isArrayBufferToString.working ? $f2b197d61b88f951$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $f2b197d61b88f951$var$isArrayBuffer;
function $f2b197d61b88f951$var$isDataViewToString(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === '[object DataView]';
}
$f2b197d61b88f951$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $f2b197d61b88f951$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $f2b197d61b88f951$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $f2b197d61b88f951$var$isDataViewToString.working ? $f2b197d61b88f951$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $f2b197d61b88f951$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $f2b197d61b88f951$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $f2b197d61b88f951$var$isSharedArrayBufferToString(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $f2b197d61b88f951$var$isSharedArrayBuffer(value) {
    if (typeof $f2b197d61b88f951$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $f2b197d61b88f951$var$isSharedArrayBufferToString.working === 'undefined') $f2b197d61b88f951$var$isSharedArrayBufferToString.working = $f2b197d61b88f951$var$isSharedArrayBufferToString(new $f2b197d61b88f951$var$SharedArrayBufferCopy());
    return $f2b197d61b88f951$var$isSharedArrayBufferToString.working ? $f2b197d61b88f951$var$isSharedArrayBufferToString(value) : value instanceof $f2b197d61b88f951$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $f2b197d61b88f951$var$isSharedArrayBuffer;
function $f2b197d61b88f951$var$isAsyncFunction(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $f2b197d61b88f951$var$isAsyncFunction;
function $f2b197d61b88f951$var$isMapIterator(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $f2b197d61b88f951$var$isMapIterator;
function $f2b197d61b88f951$var$isSetIterator(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $f2b197d61b88f951$var$isSetIterator;
function $f2b197d61b88f951$var$isGeneratorObject(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $f2b197d61b88f951$var$isGeneratorObject;
function $f2b197d61b88f951$var$isWebAssemblyCompiledModule(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $f2b197d61b88f951$var$isWebAssemblyCompiledModule;
function $f2b197d61b88f951$var$isNumberObject(value) {
    return $f2b197d61b88f951$var$checkBoxedPrimitive(value, $f2b197d61b88f951$var$numberValue);
}
module.exports.isNumberObject = $f2b197d61b88f951$var$isNumberObject;
function $f2b197d61b88f951$var$isStringObject(value) {
    return $f2b197d61b88f951$var$checkBoxedPrimitive(value, $f2b197d61b88f951$var$stringValue);
}
module.exports.isStringObject = $f2b197d61b88f951$var$isStringObject;
function $f2b197d61b88f951$var$isBooleanObject(value) {
    return $f2b197d61b88f951$var$checkBoxedPrimitive(value, $f2b197d61b88f951$var$booleanValue);
}
module.exports.isBooleanObject = $f2b197d61b88f951$var$isBooleanObject;
function $f2b197d61b88f951$var$isBigIntObject(value) {
    return $f2b197d61b88f951$var$BigIntSupported && $f2b197d61b88f951$var$checkBoxedPrimitive(value, $f2b197d61b88f951$var$bigIntValue);
}
module.exports.isBigIntObject = $f2b197d61b88f951$var$isBigIntObject;
function $f2b197d61b88f951$var$isSymbolObject(value) {
    return $f2b197d61b88f951$var$SymbolSupported && $f2b197d61b88f951$var$checkBoxedPrimitive(value, $f2b197d61b88f951$var$symbolValue);
}
module.exports.isSymbolObject = $f2b197d61b88f951$var$isSymbolObject;
function $f2b197d61b88f951$var$isBoxedPrimitive(value) {
    return $f2b197d61b88f951$var$isNumberObject(value) || $f2b197d61b88f951$var$isStringObject(value) || $f2b197d61b88f951$var$isBooleanObject(value) || $f2b197d61b88f951$var$isBigIntObject(value) || $f2b197d61b88f951$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $f2b197d61b88f951$var$isBoxedPrimitive;
function $f2b197d61b88f951$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($f2b197d61b88f951$var$isArrayBuffer(value) || $f2b197d61b88f951$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $f2b197d61b88f951$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("6LFJs", function(module, exports) {
'use strict';

var $4ed781073515e0c4$var$hasToStringTag = (parcelRequire("65kqK"))();

var $bhqNG = parcelRequire("bhqNG");
var $4ed781073515e0c4$var$$toString = $bhqNG('Object.prototype.toString');
/** @type {import('.')} */ var $4ed781073515e0c4$var$isStandardArguments = function isArguments(value) {
    if ($4ed781073515e0c4$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $4ed781073515e0c4$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $4ed781073515e0c4$var$isLegacyArguments = function isArguments(value) {
    if ($4ed781073515e0c4$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $4ed781073515e0c4$var$$toString(value) !== '[object Array]' && 'callee' in value && $4ed781073515e0c4$var$$toString(value.callee) === '[object Function]';
};
var $4ed781073515e0c4$var$supportsStandardArguments = function() {
    return $4ed781073515e0c4$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$4ed781073515e0c4$var$isStandardArguments.isLegacyArguments = $4ed781073515e0c4$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $4ed781073515e0c4$var$supportsStandardArguments ? $4ed781073515e0c4$var$isStandardArguments : $4ed781073515e0c4$var$isLegacyArguments;

});
parcelRegister("65kqK", function(module, exports) {
'use strict';

var $fNdnD = parcelRequire("fNdnD");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $fNdnD() && !!Symbol.toStringTag;
};

});
parcelRegister("fNdnD", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("bhqNG", function(module, exports) {
'use strict';

var $avqmt = parcelRequire("avqmt");

var $csNIY = parcelRequire("csNIY");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $8366123d1c7410f8$var$$indexOf = $csNIY([
    $avqmt('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $avqmt(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $8366123d1c7410f8$var$$indexOf(name, '.prototype.') > -1) return $csNIY(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("avqmt", function(module, exports) {
'use strict';
var $7a613f7503e09dde$var$undefined1;

var $7KrI3 = parcelRequire("7KrI3");

var $ki6v4 = parcelRequire("ki6v4");

var $6ZF4E = parcelRequire("6ZF4E");

var $jFaeR = parcelRequire("jFaeR");

var $aNqH3 = parcelRequire("aNqH3");

var $iOgL8 = parcelRequire("iOgL8");

var $eDiIz = parcelRequire("eDiIz");

var $guz3A = parcelRequire("guz3A");

var $db7xm = parcelRequire("db7xm");

var $gKnEJ = parcelRequire("gKnEJ");

var $42MO3 = parcelRequire("42MO3");

var $daBYy = parcelRequire("daBYy");

var $7VgwK = parcelRequire("7VgwK");

var $6GICW = parcelRequire("6GICW");

var $lj3GK = parcelRequire("lj3GK");
var $7a613f7503e09dde$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $7a613f7503e09dde$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $7a613f7503e09dde$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $crSdH = parcelRequire("crSdH");

var $4jAFO = parcelRequire("4jAFO");
var $7a613f7503e09dde$var$throwTypeError = function() {
    throw new $eDiIz();
};
var $7a613f7503e09dde$var$ThrowTypeError = $crSdH ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $7a613f7503e09dde$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $crSdH(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $7a613f7503e09dde$var$throwTypeError;
        }
    }
}() : $7a613f7503e09dde$var$throwTypeError;

var $7a613f7503e09dde$var$hasSymbols = (parcelRequire("5CmBX"))();

var $agKAf = parcelRequire("agKAf");

var $e351b = parcelRequire("e351b");

var $kF6dV = parcelRequire("kF6dV");

var $hsI1I = parcelRequire("hsI1I");

var $9RlYm = parcelRequire("9RlYm");
var $7a613f7503e09dde$var$needsEval = {};
var $7a613f7503e09dde$var$TypedArray = typeof Uint8Array === 'undefined' || !$agKAf ? undefined : $agKAf(Uint8Array);
var $7a613f7503e09dde$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $agKAf ? $agKAf([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $7a613f7503e09dde$var$needsEval,
    '%AsyncGenerator%': $7a613f7503e09dde$var$needsEval,
    '%AsyncGeneratorFunction%': $7a613f7503e09dde$var$needsEval,
    '%AsyncIteratorPrototype%': $7a613f7503e09dde$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $ki6v4,
    '%eval%': eval,
    '%EvalError%': $6ZF4E,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $7a613f7503e09dde$var$$Function,
    '%GeneratorFunction%': $7a613f7503e09dde$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $agKAf ? $agKAf($agKAf([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$7a613f7503e09dde$var$hasSymbols || !$agKAf ? undefined : $agKAf(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $7KrI3,
    '%Object.getOwnPropertyDescriptor%': $crSdH,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $jFaeR,
    '%ReferenceError%': $aNqH3,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$7a613f7503e09dde$var$hasSymbols || !$agKAf ? undefined : $agKAf(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $agKAf ? $agKAf(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $7a613f7503e09dde$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $iOgL8,
    '%ThrowTypeError%': $7a613f7503e09dde$var$ThrowTypeError,
    '%TypedArray%': $7a613f7503e09dde$var$TypedArray,
    '%TypeError%': $eDiIz,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $guz3A,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9RlYm,
    '%Function.prototype.apply%': $hsI1I,
    '%Object.defineProperty%': $4jAFO,
    '%Object.getPrototypeOf%': $e351b,
    '%Math.abs%': $db7xm,
    '%Math.floor%': $gKnEJ,
    '%Math.max%': $42MO3,
    '%Math.min%': $daBYy,
    '%Math.pow%': $7VgwK,
    '%Math.round%': $6GICW,
    '%Math.sign%': $lj3GK,
    '%Reflect.getPrototypeOf%': $kF6dV
};
if ($agKAf) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $7a613f7503e09dde$var$errorProto = $agKAf($agKAf(e));
    $7a613f7503e09dde$var$INTRINSICS['%Error.prototype%'] = $7a613f7503e09dde$var$errorProto;
}
var $7a613f7503e09dde$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $agKAf) value = $agKAf(gen.prototype);
    }
    $7a613f7503e09dde$var$INTRINSICS[name] = value;
    return value;
};
var $7a613f7503e09dde$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $a7ABz = parcelRequire("a7ABz");

var $7Dte4 = parcelRequire("7Dte4");
var $7a613f7503e09dde$var$$concat = $a7ABz.call($9RlYm, Array.prototype.concat);
var $7a613f7503e09dde$var$$spliceApply = $a7ABz.call($hsI1I, Array.prototype.splice);
var $7a613f7503e09dde$var$$replace = $a7ABz.call($9RlYm, String.prototype.replace);
var $7a613f7503e09dde$var$$strSlice = $a7ABz.call($9RlYm, String.prototype.slice);
var $7a613f7503e09dde$var$$exec = $a7ABz.call($9RlYm, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $7a613f7503e09dde$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $7a613f7503e09dde$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $7a613f7503e09dde$var$stringToPath = function stringToPath(string) {
    var first = $7a613f7503e09dde$var$$strSlice(string, 0, 1);
    var last = $7a613f7503e09dde$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $iOgL8('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $iOgL8('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $7a613f7503e09dde$var$$replace(string, $7a613f7503e09dde$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $7a613f7503e09dde$var$$replace(subString, $7a613f7503e09dde$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $7a613f7503e09dde$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7Dte4($7a613f7503e09dde$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $7a613f7503e09dde$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($7Dte4($7a613f7503e09dde$var$INTRINSICS, intrinsicName)) {
        var value = $7a613f7503e09dde$var$INTRINSICS[intrinsicName];
        if (value === $7a613f7503e09dde$var$needsEval) value = $7a613f7503e09dde$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eDiIz('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $iOgL8('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eDiIz('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eDiIz('"allowMissing" argument must be a boolean');
    if ($7a613f7503e09dde$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $iOgL8('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $7a613f7503e09dde$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $7a613f7503e09dde$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $7a613f7503e09dde$var$$spliceApply(parts, $7a613f7503e09dde$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $7a613f7503e09dde$var$$strSlice(part, 0, 1);
        var last = $7a613f7503e09dde$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $iOgL8('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($7Dte4($7a613f7503e09dde$var$INTRINSICS, intrinsicRealName)) value = $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eDiIz('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($crSdH && i + 1 >= parts.length) {
                var desc = $crSdH(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7Dte4(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("7KrI3", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("ki6v4", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("6ZF4E", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("jFaeR", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("aNqH3", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("iOgL8", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eDiIz", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("guz3A", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("db7xm", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("gKnEJ", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("42MO3", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("daBYy", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("7VgwK", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("6GICW", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("lj3GK", function(module, exports) {
'use strict';

var $jhjZ6 = parcelRequire("jhjZ6");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($jhjZ6(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("jhjZ6", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("crSdH", function(module, exports) {
'use strict';

var $gRO4r = parcelRequire("gRO4r");
var $9102109fbf1ea315$require$$gOPD = $gRO4r;
if ($9102109fbf1ea315$require$$gOPD) try {
    $9102109fbf1ea315$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $9102109fbf1ea315$require$$gOPD = null;
}
module.exports = $9102109fbf1ea315$require$$gOPD;

});
parcelRegister("gRO4r", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("4jAFO", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $3245625cab00454b$var$$defineProperty = Object.defineProperty || false;
if ($3245625cab00454b$var$$defineProperty) try {
    $3245625cab00454b$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $3245625cab00454b$var$$defineProperty = false;
}
module.exports = $3245625cab00454b$var$$defineProperty;

});

parcelRegister("5CmBX", function(module, exports) {
'use strict';
var $41720a79fda68d9e$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $fNdnD = parcelRequire("fNdnD");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $41720a79fda68d9e$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $41720a79fda68d9e$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $fNdnD();
};

});

parcelRegister("agKAf", function(module, exports) {
'use strict';

var $kF6dV = parcelRequire("kF6dV");

var $e351b = parcelRequire("e351b");

var $lMT7N = parcelRequire("lMT7N");
/** @type {import('.')} */ module.exports = $kF6dV ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $kF6dV(O);
} : $e351b ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $e351b(O);
} : $lMT7N ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $lMT7N(O);
} : null;

});
parcelRegister("kF6dV", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("e351b", function(module, exports) {
'use strict';

var $7KrI3 = parcelRequire("7KrI3");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $7KrI3.getPrototypeOf || null;

});

parcelRegister("lMT7N", function(module, exports) {
'use strict';

var $csNIY = parcelRequire("csNIY");

var $crSdH = parcelRequire("crSdH");
var $fdc8d75150bf6587$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $fdc8d75150bf6587$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $fdc8d75150bf6587$var$desc = !!$fdc8d75150bf6587$var$hasProtoAccessor && $crSdH && $crSdH(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $fdc8d75150bf6587$var$$Object = Object;
var $fdc8d75150bf6587$var$$getPrototypeOf = $fdc8d75150bf6587$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $fdc8d75150bf6587$var$desc && typeof $fdc8d75150bf6587$var$desc.get === 'function' ? $csNIY([
    $fdc8d75150bf6587$var$desc.get
]) : typeof $fdc8d75150bf6587$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $fdc8d75150bf6587$var$$getPrototypeOf(value == null ? value : $fdc8d75150bf6587$var$$Object(value));
} : false;

});
parcelRegister("csNIY", function(module, exports) {
'use strict';

var $a7ABz = parcelRequire("a7ABz");

var $eDiIz = parcelRequire("eDiIz");

var $9RlYm = parcelRequire("9RlYm");

var $2Y4BE = parcelRequire("2Y4BE");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eDiIz('a function is required');
    return $2Y4BE($a7ABz, $9RlYm, args);
};

});
parcelRegister("a7ABz", function(module, exports) {
'use strict';

var $cytJY = parcelRequire("cytJY");
module.exports = Function.prototype.bind || $cytJY;

});
parcelRegister("cytJY", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $923fbadf1e720976$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $923fbadf1e720976$var$toStr = Object.prototype.toString;
var $923fbadf1e720976$var$max = Math.max;
var $923fbadf1e720976$var$funcType = '[object Function]';
var $923fbadf1e720976$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $923fbadf1e720976$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $923fbadf1e720976$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $923fbadf1e720976$var$toStr.apply(target) !== $923fbadf1e720976$var$funcType) throw new TypeError($923fbadf1e720976$var$ERROR_MESSAGE + target);
    var args = $923fbadf1e720976$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $923fbadf1e720976$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $923fbadf1e720976$var$concatty(args, arguments));
    };
    var boundLength = $923fbadf1e720976$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $923fbadf1e720976$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9RlYm", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("2Y4BE", function(module, exports) {
'use strict';

var $a7ABz = parcelRequire("a7ABz");

var $hsI1I = parcelRequire("hsI1I");

var $9RlYm = parcelRequire("9RlYm");

var $cnaFh = parcelRequire("cnaFh");
/** @type {import('./actualApply')} */ module.exports = $cnaFh || $a7ABz.call($9RlYm, $hsI1I);

});
parcelRegister("hsI1I", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("cnaFh", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("7Dte4", function(module, exports) {
'use strict';
var $58f2d89a35f5270b$var$call = Function.prototype.call;
var $58f2d89a35f5270b$var$$hasOwn = Object.prototype.hasOwnProperty;

var $a7ABz = parcelRequire("a7ABz");
/** @type {import('.')} */ module.exports = $a7ABz.call($58f2d89a35f5270b$var$call, $58f2d89a35f5270b$var$$hasOwn);

});




parcelRegister("lhqXC", function(module, exports) {
'use strict';

var $bhqNG = parcelRequire("bhqNG");

var $aa702 = parcelRequire("aa702");
var $f7e0195071cf767f$var$isFnRegex = $aa702(/^\s*(?:function)?\*/);

var $f7e0195071cf767f$var$hasToStringTag = (parcelRequire("65kqK"))();

var $agKAf = parcelRequire("agKAf");
var $f7e0195071cf767f$var$toStr = $bhqNG('Object.prototype.toString');
var $f7e0195071cf767f$var$fnToStr = $bhqNG('Function.prototype.toString');

var $66G5x = parcelRequire("66G5x");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($f7e0195071cf767f$var$isFnRegex($f7e0195071cf767f$var$fnToStr(fn))) return true;
    if (!$f7e0195071cf767f$var$hasToStringTag) {
        var str = $f7e0195071cf767f$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$agKAf) return false;
    var GeneratorFunction = $66G5x();
    return GeneratorFunction && $agKAf(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("aa702", function(module, exports) {
'use strict';

var $bhqNG = parcelRequire("bhqNG");

var $bsdRm = parcelRequire("bsdRm");
var $7660448bbc39c578$var$$exec = $bhqNG('RegExp.prototype.exec');

var $eDiIz = parcelRequire("eDiIz");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$bsdRm(regex)) throw new $eDiIz('`regex` must be a RegExp');
    return function test(s) {
        return $7660448bbc39c578$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("bsdRm", function(module, exports) {
'use strict';

var $bhqNG = parcelRequire("bhqNG");

var $856d0f74c962aa1b$var$hasToStringTag = (parcelRequire("65kqK"))();

var $7Dte4 = parcelRequire("7Dte4");

var $crSdH = parcelRequire("crSdH");
/** @type {import('.')} */ var $856d0f74c962aa1b$var$fn;
if ($856d0f74c962aa1b$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $856d0f74c962aa1b$var$$exec = $bhqNG('RegExp.prototype.exec');
    /** @type {object} */ var $856d0f74c962aa1b$var$isRegexMarker = {};
    var $856d0f74c962aa1b$var$throwRegexMarker = function() {
        throw $856d0f74c962aa1b$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $856d0f74c962aa1b$var$badStringifier = {
        toString: $856d0f74c962aa1b$var$throwRegexMarker,
        valueOf: $856d0f74c962aa1b$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $856d0f74c962aa1b$var$badStringifier[Symbol.toPrimitive] = $856d0f74c962aa1b$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $856d0f74c962aa1b$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $crSdH(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $7Dte4(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $856d0f74c962aa1b$var$$exec(value, /** @type {unknown} */ $856d0f74c962aa1b$var$badStringifier);
        } catch (e) {
            return e === $856d0f74c962aa1b$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $856d0f74c962aa1b$var$$toString = $bhqNG('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $856d0f74c962aa1b$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $856d0f74c962aa1b$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $856d0f74c962aa1b$var$$toString(value) === $856d0f74c962aa1b$var$regexClass;
    };
}
module.exports = $856d0f74c962aa1b$var$fn;

});


parcelRegister("66G5x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9c82d9558a722990$export$2e2bcd8739ae039; });

var $5YQxN = parcelRequire("5YQxN");
var /** @type {import('./index.d.mts').default} */ $9c82d9558a722990$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($5YQxN)));

});
parcelRegister("5YQxN", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $45ab50849f83346f$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$45ab50849f83346f$var$cached;

});



parcelRegister("nBFK4", function(module, exports) {
'use strict';

var $lF3bv = parcelRequire("lF3bv");

var $lUXdk = parcelRequire("lUXdk");

var $e9CQ6 = parcelRequire("e9CQ6");

var $bhqNG = parcelRequire("bhqNG");

var $crSdH = parcelRequire("crSdH");

var $agKAf = parcelRequire("agKAf");
var $046f5f05efc793ca$var$$toString = $bhqNG('Object.prototype.toString');

var $046f5f05efc793ca$var$hasToStringTag = (parcelRequire("65kqK"))();
var $046f5f05efc793ca$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $046f5f05efc793ca$var$typedArrays = $lUXdk();
var $046f5f05efc793ca$var$$slice = $bhqNG('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $046f5f05efc793ca$var$$indexOf = $bhqNG('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $046f5f05efc793ca$var$cache = {
    __proto__: null
};
if ($046f5f05efc793ca$var$hasToStringTag && $crSdH && $agKAf) $lF3bv($046f5f05efc793ca$var$typedArrays, function(typedArray) {
    var arr = new $046f5f05efc793ca$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $agKAf) {
        var proto = $agKAf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $crSdH(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $agKAf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $crSdH(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $046f5f05efc793ca$var$cache['$' + typedArray] = $e9CQ6(descriptor.get);
    }
});
else $lF3bv($046f5f05efc793ca$var$typedArrays, function(typedArray) {
    var arr = new $046f5f05efc793ca$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $046f5f05efc793ca$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $e9CQ6(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $046f5f05efc793ca$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $lF3bv(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $046f5f05efc793ca$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $046f5f05efc793ca$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $046f5f05efc793ca$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $lF3bv(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $046f5f05efc793ca$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $046f5f05efc793ca$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$046f5f05efc793ca$var$hasToStringTag) {
        /** @type {string} */ var tag = $046f5f05efc793ca$var$$slice($046f5f05efc793ca$var$$toString(value), 8, -1);
        if ($046f5f05efc793ca$var$$indexOf($046f5f05efc793ca$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $046f5f05efc793ca$var$trySlices(value);
    }
    if (!$crSdH) return null;
     // unknown engine
    return $046f5f05efc793ca$var$tryTypedArrays(value);
};

});
parcelRegister("lF3bv", function(module, exports) {
'use strict';

var $8pyWb = parcelRequire("8pyWb");
var $fc4fe5af5b35393c$var$toStr = Object.prototype.toString;
var $fc4fe5af5b35393c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $fc4fe5af5b35393c$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($fc4fe5af5b35393c$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $fc4fe5af5b35393c$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $fc4fe5af5b35393c$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($fc4fe5af5b35393c$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $fc4fe5af5b35393c$var$isArray(x) {
    return $fc4fe5af5b35393c$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$8pyWb(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($fc4fe5af5b35393c$var$isArray(list)) $fc4fe5af5b35393c$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $fc4fe5af5b35393c$var$forEachString(list, iterator, receiver);
    else $fc4fe5af5b35393c$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("8pyWb", function(module, exports) {
'use strict';
var $61fbc2635a6bc632$var$fnToStr = Function.prototype.toString;
var $61fbc2635a6bc632$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $61fbc2635a6bc632$var$badArrayLike;
var $61fbc2635a6bc632$var$isCallableMarker;
if (typeof $61fbc2635a6bc632$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $61fbc2635a6bc632$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $61fbc2635a6bc632$var$isCallableMarker;
        }
    });
    $61fbc2635a6bc632$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $61fbc2635a6bc632$var$reflectApply(function() {
        throw 42;
    }, null, $61fbc2635a6bc632$var$badArrayLike);
} catch (_) {
    if (_ !== $61fbc2635a6bc632$var$isCallableMarker) $61fbc2635a6bc632$var$reflectApply = null;
}
else $61fbc2635a6bc632$var$reflectApply = null;
var $61fbc2635a6bc632$var$constructorRegex = /^\s*class\b/;
var $61fbc2635a6bc632$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $61fbc2635a6bc632$var$fnToStr.call(value);
        return $61fbc2635a6bc632$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $61fbc2635a6bc632$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($61fbc2635a6bc632$var$isES6ClassFn(value)) return false;
        $61fbc2635a6bc632$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $61fbc2635a6bc632$var$toStr = Object.prototype.toString;
var $61fbc2635a6bc632$var$objectClass = '[object Object]';
var $61fbc2635a6bc632$var$fnClass = '[object Function]';
var $61fbc2635a6bc632$var$genClass = '[object GeneratorFunction]';
var $61fbc2635a6bc632$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $61fbc2635a6bc632$var$ddaClass2 = '[object HTML document.all class]';
var $61fbc2635a6bc632$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $61fbc2635a6bc632$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $61fbc2635a6bc632$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $61fbc2635a6bc632$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $61fbc2635a6bc632$var$all = document.all;
    if ($61fbc2635a6bc632$var$toStr.call($61fbc2635a6bc632$var$all) === $61fbc2635a6bc632$var$toStr.call(document.all)) $61fbc2635a6bc632$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($61fbc2635a6bc632$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $61fbc2635a6bc632$var$toStr.call(value);
            return (str === $61fbc2635a6bc632$var$ddaClass || str === $61fbc2635a6bc632$var$ddaClass2 || str === $61fbc2635a6bc632$var$ddaClass3 // opera 12.16
             || str === $61fbc2635a6bc632$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $61fbc2635a6bc632$var$reflectApply ? function isCallable(value) {
    if ($61fbc2635a6bc632$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $61fbc2635a6bc632$var$reflectApply(value, null, $61fbc2635a6bc632$var$badArrayLike);
    } catch (e) {
        if (e !== $61fbc2635a6bc632$var$isCallableMarker) return false;
    }
    return !$61fbc2635a6bc632$var$isES6ClassFn(value) && $61fbc2635a6bc632$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($61fbc2635a6bc632$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($61fbc2635a6bc632$var$hasToStringTag) return $61fbc2635a6bc632$var$tryFunctionObject(value);
    if ($61fbc2635a6bc632$var$isES6ClassFn(value)) return false;
    var strClass = $61fbc2635a6bc632$var$toStr.call(value);
    if (strClass !== $61fbc2635a6bc632$var$fnClass && strClass !== $61fbc2635a6bc632$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $61fbc2635a6bc632$var$tryFunctionObject(value);
};

});


parcelRegister("lUXdk", function(module, exports) {
'use strict';

var $2gCm2 = parcelRequire("2gCm2");
var $ff4cc296ed9551f0$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $2gCm2.length; i++)if (typeof $ff4cc296ed9551f0$var$g[$2gCm2[i]] === 'function') // @ts-expect-error
    out[out.length] = $2gCm2[i];
    return out;
};

});
parcelRegister("2gCm2", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("e9CQ6", function(module, exports) {
'use strict';

var $64wPI = parcelRequire("64wPI");

var $4jAFO = parcelRequire("4jAFO");

var $csNIY = parcelRequire("csNIY");

var $2EMpq = parcelRequire("2EMpq");
module.exports = function callBind(originalFunction) {
    var func = $csNIY(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $64wPI(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($4jAFO) $4jAFO(module.exports, 'apply', {
    value: $2EMpq
});
else module.exports.apply = $2EMpq;

});
parcelRegister("64wPI", function(module, exports) {
'use strict';

var $avqmt = parcelRequire("avqmt");

var $26m4v = parcelRequire("26m4v");

var $46bc95c30a58fa4c$var$hasDescriptors = (parcelRequire("73hDB"))();

var $crSdH = parcelRequire("crSdH");

var $eDiIz = parcelRequire("eDiIz");
var $46bc95c30a58fa4c$var$$floor = $avqmt('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $eDiIz('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $46bc95c30a58fa4c$var$$floor(length) !== length) throw new $eDiIz('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $crSdH) {
        var desc = $crSdH(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($46bc95c30a58fa4c$var$hasDescriptors) $26m4v(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $26m4v(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("26m4v", function(module, exports) {
'use strict';

var $4jAFO = parcelRequire("4jAFO");

var $iOgL8 = parcelRequire("iOgL8");

var $eDiIz = parcelRequire("eDiIz");

var $crSdH = parcelRequire("crSdH");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $eDiIz('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $eDiIz('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $eDiIz('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $eDiIz('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $eDiIz('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $eDiIz('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$crSdH && $crSdH(obj, property);
    if ($4jAFO) $4jAFO(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $iOgL8('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("73hDB", function(module, exports) {
'use strict';

var $4jAFO = parcelRequire("4jAFO");
var $52267eb4294466ed$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$4jAFO;
};
$52267eb4294466ed$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$4jAFO) return null;
    try {
        return $4jAFO([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $52267eb4294466ed$var$hasPropertyDescriptors;

});


parcelRegister("2EMpq", function(module, exports) {
'use strict';

var $a7ABz = parcelRequire("a7ABz");

var $hsI1I = parcelRequire("hsI1I");

var $2Y4BE = parcelRequire("2Y4BE");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $2Y4BE($a7ABz, $hsI1I, arguments);
};

});



parcelRegister("htkB6", function(module, exports) {
'use strict';

var $nBFK4 = parcelRequire("nBFK4");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$nBFK4(value);
};

});


parcelRegister("kieVX", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});



parcelRegister("gWIRK", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $c564dd8b02425d14$require$Buffer = $6U9mG.Buffer;

var $aO8Ot = parcelRequire("aO8Ot");

var $aWVB1 = parcelRequire("aWVB1");

var $4zyeF = parcelRequire("4zyeF");
var $c564dd8b02425d14$var$MSG_INVALID_ALGORITHM = '"%s" is not a valid algorithm.\n  Supported algorithms are:\n  "HS256", "HS384", "HS512", "RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512" and "none".';
var $c564dd8b02425d14$var$MSG_INVALID_SECRET = 'secret must be a string or buffer';
var $c564dd8b02425d14$var$MSG_INVALID_VERIFIER_KEY = 'key must be a string or a buffer';
var $c564dd8b02425d14$var$MSG_INVALID_SIGNER_KEY = 'key must be a string, a buffer or an object';
var $c564dd8b02425d14$var$supportsKeyObjects = typeof $aO8Ot.createPublicKey === 'function';
if ($c564dd8b02425d14$var$supportsKeyObjects) {
    $c564dd8b02425d14$var$MSG_INVALID_VERIFIER_KEY += ' or a KeyObject';
    $c564dd8b02425d14$var$MSG_INVALID_SECRET += 'or a KeyObject';
}
function $c564dd8b02425d14$var$checkIsPublicKey(key) {
    if ($c564dd8b02425d14$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return;
    if (!$c564dd8b02425d14$var$supportsKeyObjects) throw $c564dd8b02425d14$var$typeError($c564dd8b02425d14$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key !== 'object') throw $c564dd8b02425d14$var$typeError($c564dd8b02425d14$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.type !== 'string') throw $c564dd8b02425d14$var$typeError($c564dd8b02425d14$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.asymmetricKeyType !== 'string') throw $c564dd8b02425d14$var$typeError($c564dd8b02425d14$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.export !== 'function') throw $c564dd8b02425d14$var$typeError($c564dd8b02425d14$var$MSG_INVALID_VERIFIER_KEY);
}
function $c564dd8b02425d14$var$checkIsPrivateKey(key) {
    if ($c564dd8b02425d14$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return;
    if (typeof key === 'object') return;
    throw $c564dd8b02425d14$var$typeError($c564dd8b02425d14$var$MSG_INVALID_SIGNER_KEY);
}
function $c564dd8b02425d14$var$checkIsSecretKey(key) {
    if ($c564dd8b02425d14$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return key;
    if (!$c564dd8b02425d14$var$supportsKeyObjects) throw $c564dd8b02425d14$var$typeError($c564dd8b02425d14$var$MSG_INVALID_SECRET);
    if (typeof key !== 'object') throw $c564dd8b02425d14$var$typeError($c564dd8b02425d14$var$MSG_INVALID_SECRET);
    if (key.type !== 'secret') throw $c564dd8b02425d14$var$typeError($c564dd8b02425d14$var$MSG_INVALID_SECRET);
    if (typeof key.export !== 'function') throw $c564dd8b02425d14$var$typeError($c564dd8b02425d14$var$MSG_INVALID_SECRET);
}
function $c564dd8b02425d14$var$fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $c564dd8b02425d14$var$toBase64(base64url) {
    base64url = base64url.toString();
    var padding = 4 - base64url.length % 4;
    if (padding !== 4) for(var i = 0; i < padding; ++i)base64url += '=';
    return base64url.replace(/\-/g, '+').replace(/_/g, '/');
}
function $c564dd8b02425d14$var$typeError(template) {
    var args = [].slice.call(arguments, 1);
    var errMsg = $4zyeF.format.bind($4zyeF, template).apply(null, args);
    return new TypeError(errMsg);
}
function $c564dd8b02425d14$var$bufferOrString(obj) {
    return $c564dd8b02425d14$require$Buffer.isBuffer(obj) || typeof obj === 'string';
}
function $c564dd8b02425d14$var$normalizeInput(thing) {
    if (!$c564dd8b02425d14$var$bufferOrString(thing)) thing = JSON.stringify(thing);
    return thing;
}
function $c564dd8b02425d14$var$createHmacSigner(bits) {
    return function sign(thing, secret) {
        $c564dd8b02425d14$var$checkIsSecretKey(secret);
        thing = $c564dd8b02425d14$var$normalizeInput(thing);
        var hmac = $aO8Ot.createHmac('sha' + bits, secret);
        var sig = (hmac.update(thing), hmac.digest('base64'));
        return $c564dd8b02425d14$var$fromBase64(sig);
    };
}
var $c564dd8b02425d14$var$bufferEqual;

var $c564dd8b02425d14$var$timingSafeEqual = 'timingSafeEqual' in $aO8Ot ? function timingSafeEqual(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $aO8Ot.timingSafeEqual(a, b);
} : function timingSafeEqual(a, b) {
    if (!$c564dd8b02425d14$var$bufferEqual) $c564dd8b02425d14$var$bufferEqual = (parcelRequire("jdJWE"));
    return $c564dd8b02425d14$var$bufferEqual(a, b);
};
function $c564dd8b02425d14$var$createHmacVerifier(bits) {
    return function verify(thing, signature, secret) {
        var computedSig = $c564dd8b02425d14$var$createHmacSigner(bits)(thing, secret);
        return $c564dd8b02425d14$var$timingSafeEqual($c564dd8b02425d14$require$Buffer.from(signature), $c564dd8b02425d14$require$Buffer.from(computedSig));
    };
}
function $c564dd8b02425d14$var$createKeySigner(bits) {
    return function sign(thing, privateKey) {
        $c564dd8b02425d14$var$checkIsPrivateKey(privateKey);
        thing = $c564dd8b02425d14$var$normalizeInput(thing);
        // Even though we are specifying "RSA" here, this works with ECDSA
        // keys as well.
        var signer = $aO8Ot.createSign('RSA-SHA' + bits);
        var sig = (signer.update(thing), signer.sign(privateKey, 'base64'));
        return $c564dd8b02425d14$var$fromBase64(sig);
    };
}
function $c564dd8b02425d14$var$createKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $c564dd8b02425d14$var$checkIsPublicKey(publicKey);
        thing = $c564dd8b02425d14$var$normalizeInput(thing);
        signature = $c564dd8b02425d14$var$toBase64(signature);
        var verifier = $aO8Ot.createVerify('RSA-SHA' + bits);
        verifier.update(thing);
        return verifier.verify(publicKey, signature, 'base64');
    };
}
function $c564dd8b02425d14$var$createPSSKeySigner(bits) {
    return function sign(thing, privateKey) {
        $c564dd8b02425d14$var$checkIsPrivateKey(privateKey);
        thing = $c564dd8b02425d14$var$normalizeInput(thing);
        var signer = $aO8Ot.createSign('RSA-SHA' + bits);
        var sig = (signer.update(thing), signer.sign({
            key: privateKey,
            padding: $aO8Ot.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $aO8Ot.constants.RSA_PSS_SALTLEN_DIGEST
        }, 'base64'));
        return $c564dd8b02425d14$var$fromBase64(sig);
    };
}
function $c564dd8b02425d14$var$createPSSKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $c564dd8b02425d14$var$checkIsPublicKey(publicKey);
        thing = $c564dd8b02425d14$var$normalizeInput(thing);
        signature = $c564dd8b02425d14$var$toBase64(signature);
        var verifier = $aO8Ot.createVerify('RSA-SHA' + bits);
        verifier.update(thing);
        return verifier.verify({
            key: publicKey,
            padding: $aO8Ot.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $aO8Ot.constants.RSA_PSS_SALTLEN_DIGEST
        }, signature, 'base64');
    };
}
function $c564dd8b02425d14$var$createECDSASigner(bits) {
    var inner = $c564dd8b02425d14$var$createKeySigner(bits);
    return function sign() {
        var signature = inner.apply(null, arguments);
        signature = $aWVB1.derToJose(signature, 'ES' + bits);
        return signature;
    };
}
function $c564dd8b02425d14$var$createECDSAVerifer(bits) {
    var inner = $c564dd8b02425d14$var$createKeyVerifier(bits);
    return function verify(thing, signature, publicKey) {
        signature = $aWVB1.joseToDer(signature, 'ES' + bits).toString('base64');
        var result = inner(thing, signature, publicKey);
        return result;
    };
}
function $c564dd8b02425d14$var$createNoneSigner() {
    return function sign() {
        return '';
    };
}
function $c564dd8b02425d14$var$createNoneVerifier() {
    return function verify(thing, signature) {
        return signature === '';
    };
}
module.exports = function jwa(algorithm) {
    var signerFactories = {
        hs: $c564dd8b02425d14$var$createHmacSigner,
        rs: $c564dd8b02425d14$var$createKeySigner,
        ps: $c564dd8b02425d14$var$createPSSKeySigner,
        es: $c564dd8b02425d14$var$createECDSASigner,
        none: $c564dd8b02425d14$var$createNoneSigner
    };
    var verifierFactories = {
        hs: $c564dd8b02425d14$var$createHmacVerifier,
        rs: $c564dd8b02425d14$var$createKeyVerifier,
        ps: $c564dd8b02425d14$var$createPSSKeyVerifier,
        es: $c564dd8b02425d14$var$createECDSAVerifer,
        none: $c564dd8b02425d14$var$createNoneVerifier
    };
    var match = algorithm.match(/^(RS|PS|ES|HS)(256|384|512)$|^(none)$/);
    if (!match) throw $c564dd8b02425d14$var$typeError($c564dd8b02425d14$var$MSG_INVALID_ALGORITHM, algorithm);
    var algo = (match[1] || match[3]).toLowerCase();
    var bits = match[2];
    return {
        sign: signerFactories[algo](bits),
        verify: verifierFactories[algo](bits)
    };
};

});
parcelRegister("aO8Ot", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $7de568f77242e9e6$export$5f828d93ff035aa8; }, function (v) { return $7de568f77242e9e6$export$5f828d93ff035aa8 = v; });
$parcel$export(module.exports, "rng", function () { return $7de568f77242e9e6$export$cd94982b18c6332c; }, function (v) { return $7de568f77242e9e6$export$cd94982b18c6332c = v; });
$parcel$export(module.exports, "pseudoRandomBytes", function () { return $7de568f77242e9e6$export$1d518568e4f529b0; }, function (v) { return $7de568f77242e9e6$export$1d518568e4f529b0 = v; });
$parcel$export(module.exports, "prng", function () { return $7de568f77242e9e6$export$5285b6d41c912b41; }, function (v) { return $7de568f77242e9e6$export$5285b6d41c912b41 = v; });
$parcel$export(module.exports, "createHash", function () { return $7de568f77242e9e6$export$2fb37efbf6ae0c0e; }, function (v) { return $7de568f77242e9e6$export$2fb37efbf6ae0c0e = v; });
$parcel$export(module.exports, "Hash", function () { return $7de568f77242e9e6$export$ab85ecd77ce6a5cd; }, function (v) { return $7de568f77242e9e6$export$ab85ecd77ce6a5cd = v; });
$parcel$export(module.exports, "createHmac", function () { return $7de568f77242e9e6$export$da39cf97e1eb7c91; }, function (v) { return $7de568f77242e9e6$export$da39cf97e1eb7c91 = v; });
$parcel$export(module.exports, "Hmac", function () { return $7de568f77242e9e6$export$52a9039d7177394f; }, function (v) { return $7de568f77242e9e6$export$52a9039d7177394f = v; });
$parcel$export(module.exports, "getHashes", function () { return $7de568f77242e9e6$export$f7201db400317331; }, function (v) { return $7de568f77242e9e6$export$f7201db400317331 = v; });
$parcel$export(module.exports, "pbkdf2", function () { return $7de568f77242e9e6$export$448fa22aedc9dbca; }, function (v) { return $7de568f77242e9e6$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $7de568f77242e9e6$export$b80c7ba289c8fa56; }, function (v) { return $7de568f77242e9e6$export$b80c7ba289c8fa56 = v; });
$parcel$export(module.exports, "Cipher", function () { return $7de568f77242e9e6$export$26e5786e8ac8e530; }, function (v) { return $7de568f77242e9e6$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipher", function () { return $7de568f77242e9e6$export$bdd223f16383713e; }, function (v) { return $7de568f77242e9e6$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $7de568f77242e9e6$export$20533d26f07f1ee0; }, function (v) { return $7de568f77242e9e6$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $7de568f77242e9e6$export$2f64596b8cbf08b4; }, function (v) { return $7de568f77242e9e6$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Decipher", function () { return $7de568f77242e9e6$export$2ce6d8d0e8b04e1a; }, function (v) { return $7de568f77242e9e6$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipher", function () { return $7de568f77242e9e6$export$12ada9414fbc594c; }, function (v) { return $7de568f77242e9e6$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $7de568f77242e9e6$export$f5e7e39d57cd9700; }, function (v) { return $7de568f77242e9e6$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $7de568f77242e9e6$export$36b6d6ef312eab39; }, function (v) { return $7de568f77242e9e6$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $7de568f77242e9e6$export$58a258485f1e49f6; }, function (v) { return $7de568f77242e9e6$export$58a258485f1e49f6 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $7de568f77242e9e6$export$dedd8dc3dc62b370; }, function (v) { return $7de568f77242e9e6$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $7de568f77242e9e6$export$971862a2fcb1bb40; }, function (v) { return $7de568f77242e9e6$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $7de568f77242e9e6$export$c6ff6a88acbeaf40; }, function (v) { return $7de568f77242e9e6$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $7de568f77242e9e6$export$fdc27893e98845cc; }, function (v) { return $7de568f77242e9e6$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $7de568f77242e9e6$export$6671fb9a1323bed; }, function (v) { return $7de568f77242e9e6$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $7de568f77242e9e6$export$d74daf141a551db; }, function (v) { return $7de568f77242e9e6$export$d74daf141a551db = v; });
$parcel$export(module.exports, "createSign", function () { return $7de568f77242e9e6$export$45df7cae684751af; }, function (v) { return $7de568f77242e9e6$export$45df7cae684751af = v; });
$parcel$export(module.exports, "Sign", function () { return $7de568f77242e9e6$export$1db683ad541682f6; }, function (v) { return $7de568f77242e9e6$export$1db683ad541682f6 = v; });
$parcel$export(module.exports, "createVerify", function () { return $7de568f77242e9e6$export$6f65485f87568e37; }, function (v) { return $7de568f77242e9e6$export$6f65485f87568e37 = v; });
$parcel$export(module.exports, "Verify", function () { return $7de568f77242e9e6$export$91a8e56769aeb334; }, function (v) { return $7de568f77242e9e6$export$91a8e56769aeb334 = v; });
$parcel$export(module.exports, "createECDH", function () { return $7de568f77242e9e6$export$2d4117e99c2179e4; }, function (v) { return $7de568f77242e9e6$export$2d4117e99c2179e4 = v; });
$parcel$export(module.exports, "publicEncrypt", function () { return $7de568f77242e9e6$export$512823e338ddb1b7; }, function (v) { return $7de568f77242e9e6$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $7de568f77242e9e6$export$9d0e0c0c4a8d30f3; }, function (v) { return $7de568f77242e9e6$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $7de568f77242e9e6$export$b9d55ff329113abd; }, function (v) { return $7de568f77242e9e6$export$b9d55ff329113abd = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $7de568f77242e9e6$export$7efb24e2fddf99b9; }, function (v) { return $7de568f77242e9e6$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "randomFill", function () { return $7de568f77242e9e6$export$bb1abf2ce84fc7e8; }, function (v) { return $7de568f77242e9e6$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $7de568f77242e9e6$export$2f7171e78e524d5e; }, function (v) { return $7de568f77242e9e6$export$2f7171e78e524d5e = v; });
$parcel$export(module.exports, "createCredentials", function () { return $7de568f77242e9e6$export$e1d879b482f37d98; }, function (v) { return $7de568f77242e9e6$export$e1d879b482f37d98 = v; });
$parcel$export(module.exports, "constants", function () { return $7de568f77242e9e6$export$1a988e7317c65621; }, function (v) { return $7de568f77242e9e6$export$1a988e7317c65621 = v; });
// eslint-disable-next-line no-multi-assign
var $7de568f77242e9e6$export$5f828d93ff035aa8;
var $7de568f77242e9e6$export$cd94982b18c6332c;
var $7de568f77242e9e6$export$1d518568e4f529b0;
var $7de568f77242e9e6$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $7de568f77242e9e6$export$2fb37efbf6ae0c0e;
var $7de568f77242e9e6$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $7de568f77242e9e6$export$da39cf97e1eb7c91;
var $7de568f77242e9e6$export$52a9039d7177394f;
var $7de568f77242e9e6$export$f7201db400317331;
var $7de568f77242e9e6$export$448fa22aedc9dbca;
var $7de568f77242e9e6$export$b80c7ba289c8fa56;
var $7de568f77242e9e6$export$26e5786e8ac8e530;
var $7de568f77242e9e6$export$bdd223f16383713e;
var $7de568f77242e9e6$export$20533d26f07f1ee0;
var $7de568f77242e9e6$export$2f64596b8cbf08b4;
var $7de568f77242e9e6$export$2ce6d8d0e8b04e1a;
var $7de568f77242e9e6$export$12ada9414fbc594c;
var $7de568f77242e9e6$export$f5e7e39d57cd9700;
var $7de568f77242e9e6$export$36b6d6ef312eab39;
var $7de568f77242e9e6$export$58a258485f1e49f6;
var $7de568f77242e9e6$export$dedd8dc3dc62b370;
var $7de568f77242e9e6$export$971862a2fcb1bb40;
var $7de568f77242e9e6$export$c6ff6a88acbeaf40;
var $7de568f77242e9e6$export$fdc27893e98845cc;
var $7de568f77242e9e6$export$6671fb9a1323bed;
var $7de568f77242e9e6$export$d74daf141a551db;
var $7de568f77242e9e6$export$45df7cae684751af;
var $7de568f77242e9e6$export$1db683ad541682f6;
var $7de568f77242e9e6$export$6f65485f87568e37;
var $7de568f77242e9e6$export$91a8e56769aeb334;
var $7de568f77242e9e6$export$2d4117e99c2179e4;
var $7de568f77242e9e6$export$512823e338ddb1b7;
var $7de568f77242e9e6$export$9d0e0c0c4a8d30f3;
var $7de568f77242e9e6$export$b9d55ff329113abd;
var $7de568f77242e9e6$export$7efb24e2fddf99b9;
var $7de568f77242e9e6$export$bb1abf2ce84fc7e8;
var $7de568f77242e9e6$export$2f7171e78e524d5e;
var $7de568f77242e9e6$export$e1d879b482f37d98;
var $7de568f77242e9e6$export$1a988e7317c65621;
'use strict';

$7de568f77242e9e6$export$5f828d93ff035aa8 = $7de568f77242e9e6$export$cd94982b18c6332c = $7de568f77242e9e6$export$1d518568e4f529b0 = $7de568f77242e9e6$export$5285b6d41c912b41 = (parcelRequire("5rfiH"));

$7de568f77242e9e6$export$2fb37efbf6ae0c0e = $7de568f77242e9e6$export$ab85ecd77ce6a5cd = (parcelRequire("3FiLE"));

$7de568f77242e9e6$export$da39cf97e1eb7c91 = $7de568f77242e9e6$export$52a9039d7177394f = (parcelRequire("cUvgf"));

var $fAh7A = parcelRequire("fAh7A");
var $7de568f77242e9e6$var$algoKeys = Object.keys($fAh7A);
var $7de568f77242e9e6$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($7de568f77242e9e6$var$algoKeys);
$7de568f77242e9e6$export$f7201db400317331 = function() {
    return $7de568f77242e9e6$var$hashes;
};

var $1UZ5c = parcelRequire("1UZ5c");
$7de568f77242e9e6$export$448fa22aedc9dbca = $1UZ5c.pbkdf2;
$7de568f77242e9e6$export$b80c7ba289c8fa56 = $1UZ5c.pbkdf2Sync;

var $3lJ0u = parcelRequire("3lJ0u");
$7de568f77242e9e6$export$26e5786e8ac8e530 = $3lJ0u.Cipher;
$7de568f77242e9e6$export$bdd223f16383713e = $3lJ0u.createCipher;
$7de568f77242e9e6$export$20533d26f07f1ee0 = $3lJ0u.Cipheriv;
$7de568f77242e9e6$export$2f64596b8cbf08b4 = $3lJ0u.createCipheriv;
$7de568f77242e9e6$export$2ce6d8d0e8b04e1a = $3lJ0u.Decipher;
$7de568f77242e9e6$export$12ada9414fbc594c = $3lJ0u.createDecipher;
$7de568f77242e9e6$export$f5e7e39d57cd9700 = $3lJ0u.Decipheriv;
$7de568f77242e9e6$export$36b6d6ef312eab39 = $3lJ0u.createDecipheriv;
$7de568f77242e9e6$export$58a258485f1e49f6 = $3lJ0u.getCiphers;
$7de568f77242e9e6$export$dedd8dc3dc62b370 = $3lJ0u.listCiphers;

var $4evoR = parcelRequire("4evoR");
$7de568f77242e9e6$export$971862a2fcb1bb40 = $4evoR.DiffieHellmanGroup;
$7de568f77242e9e6$export$c6ff6a88acbeaf40 = $4evoR.createDiffieHellmanGroup;
$7de568f77242e9e6$export$fdc27893e98845cc = $4evoR.getDiffieHellman;
$7de568f77242e9e6$export$6671fb9a1323bed = $4evoR.createDiffieHellman;
$7de568f77242e9e6$export$d74daf141a551db = $4evoR.DiffieHellman;

var $bOCXe = parcelRequire("bOCXe");
$7de568f77242e9e6$export$45df7cae684751af = $bOCXe.createSign;
$7de568f77242e9e6$export$1db683ad541682f6 = $bOCXe.Sign;
$7de568f77242e9e6$export$6f65485f87568e37 = $bOCXe.createVerify;
$7de568f77242e9e6$export$91a8e56769aeb334 = $bOCXe.Verify;

$7de568f77242e9e6$export$2d4117e99c2179e4 = (parcelRequire("bpRNH"));

var $e8Hvp = parcelRequire("e8Hvp");
$7de568f77242e9e6$export$512823e338ddb1b7 = $e8Hvp.publicEncrypt;
$7de568f77242e9e6$export$9d0e0c0c4a8d30f3 = $e8Hvp.privateEncrypt;
$7de568f77242e9e6$export$b9d55ff329113abd = $e8Hvp.publicDecrypt;
$7de568f77242e9e6$export$7efb24e2fddf99b9 = $e8Hvp.privateDecrypt;

var $6zHAr = parcelRequire("6zHAr");
$7de568f77242e9e6$export$bb1abf2ce84fc7e8 = $6zHAr.randomFill;
$7de568f77242e9e6$export$2f7171e78e524d5e = $6zHAr.randomFillSync;
$7de568f77242e9e6$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$7de568f77242e9e6$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("5rfiH", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $3f5b57c5e5054ef5$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $3f5b57c5e5054ef5$var$MAX_UINT32 = 4294967295;
function $3f5b57c5e5054ef5$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $6U9mG = parcelRequire("6U9mG");
var $3f5b57c5e5054ef5$require$Buffer = $6U9mG.Buffer;
var $3f5b57c5e5054ef5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($3f5b57c5e5054ef5$var$crypto && $3f5b57c5e5054ef5$var$crypto.getRandomValues) module.exports = $3f5b57c5e5054ef5$var$randomBytes;
else module.exports = $3f5b57c5e5054ef5$var$oldBrowser;
function $3f5b57c5e5054ef5$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $3f5b57c5e5054ef5$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $3f5b57c5e5054ef5$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $3f5b57c5e5054ef5$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $3f5b57c5e5054ef5$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $3f5b57c5e5054ef5$var$crypto.getRandomValues(bytes.slice(generated, generated + $3f5b57c5e5054ef5$var$MAX_BYTES));
        else $3f5b57c5e5054ef5$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $4TNnu.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("3FiLE", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $cvCaQ = parcelRequire("cvCaQ");

var $cjuEr = parcelRequire("cjuEr");

var $fkJVr = parcelRequire("fkJVr");

var $fpHcA = parcelRequire("fpHcA");
function $2ab3c24d6f7239f3$var$Hash(hash) {
    $fpHcA.call(this, 'digest');
    this._hash = hash;
}
$eSHUL($2ab3c24d6f7239f3$var$Hash, $fpHcA);
$2ab3c24d6f7239f3$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$2ab3c24d6f7239f3$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $cvCaQ();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $cjuEr();
    return new $2ab3c24d6f7239f3$var$Hash($fkJVr(alg));
};

});
parcelRegister("cvCaQ", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $9aUYR = parcelRequire("9aUYR");

var $6U9mG = parcelRequire("6U9mG");
var $91b5fdd475e07956$require$Buffer = $6U9mG.Buffer;
var $91b5fdd475e07956$var$ARRAY16 = new Array(16);
function $91b5fdd475e07956$var$MD5() {
    $9aUYR.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$eSHUL($91b5fdd475e07956$var$MD5, $9aUYR);
$91b5fdd475e07956$var$MD5.prototype._update = function() {
    var M = $91b5fdd475e07956$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$91b5fdd475e07956$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $91b5fdd475e07956$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $91b5fdd475e07956$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $91b5fdd475e07956$var$fnF(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnG(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnH(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnI(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $91b5fdd475e07956$var$MD5;

});
parcelRegister("9aUYR", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $6ae13f602076a4da$require$Buffer = $6U9mG.Buffer;

var $bks2w = parcelRequire("bks2w");
var $6ae13f602076a4da$require$Transform = $bks2w.Transform;

var $eSHUL = parcelRequire("eSHUL");
function $6ae13f602076a4da$var$HashBase(blockSize) {
    $6ae13f602076a4da$require$Transform.call(this);
    this._block = $6ae13f602076a4da$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$eSHUL($6ae13f602076a4da$var$HashBase, $6ae13f602076a4da$require$Transform);
$6ae13f602076a4da$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$6ae13f602076a4da$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var $6ae13f602076a4da$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $6ae13f602076a4da$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($6ae13f602076a4da$require$Buffer.prototype instanceof Uint8Array || $6ae13f602076a4da$require$Buffer.TYPED_ARRAY_SUPPORT);
function $6ae13f602076a4da$var$toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof $6ae13f602076a4da$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $6ae13f602076a4da$require$Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if ($6ae13f602076a4da$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return $6ae13f602076a4da$require$Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = $6ae13f602076a4da$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if ($6ae13f602076a4da$var$useUint8Array && data instanceof Uint8Array) return $6ae13f602076a4da$require$Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if ($6ae13f602076a4da$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $6ae13f602076a4da$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$6ae13f602076a4da$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = $6ae13f602076a4da$var$toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$6ae13f602076a4da$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$6ae13f602076a4da$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$6ae13f602076a4da$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $6ae13f602076a4da$var$HashBase;

});


parcelRegister("cjuEr", function(module, exports) {
'use strict';

var $ihoyg = parcelRequire("ihoyg");
var $8f6f09199cc1903f$require$Buffer = $ihoyg.Buffer;

var $eSHUL = parcelRequire("eSHUL");

var $6Nkl4 = parcelRequire("6Nkl4");
var $8f6f09199cc1903f$var$ARRAY16 = new Array(16);
var $8f6f09199cc1903f$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $8f6f09199cc1903f$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $8f6f09199cc1903f$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $8f6f09199cc1903f$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $8f6f09199cc1903f$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $8f6f09199cc1903f$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $8f6f09199cc1903f$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $8f6f09199cc1903f$var$fn1(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn2(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn3(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn4(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn5(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$RIPEMD160() {
    $6Nkl4.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$eSHUL($8f6f09199cc1903f$var$RIPEMD160, $6Nkl4);
$8f6f09199cc1903f$var$RIPEMD160.prototype._update = function() {
    var words = $8f6f09199cc1903f$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $8f6f09199cc1903f$var$fn1(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[0], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn5(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[0], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 32) {
            tl = $8f6f09199cc1903f$var$fn2(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[1], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn4(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[1], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 48) {
            tl = $8f6f09199cc1903f$var$fn3(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[2], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn3(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[2], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 64) {
            tl = $8f6f09199cc1903f$var$fn4(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[3], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn2(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[3], $8f6f09199cc1903f$var$sr[i]);
        } else {
            tl = $8f6f09199cc1903f$var$fn5(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[4], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn1(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[4], $8f6f09199cc1903f$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $8f6f09199cc1903f$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $8f6f09199cc1903f$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$8f6f09199cc1903f$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $8f6f09199cc1903f$require$Buffer.alloc ? $8f6f09199cc1903f$require$Buffer.alloc(20) : new $8f6f09199cc1903f$require$Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = $8f6f09199cc1903f$var$RIPEMD160;

});
parcelRegister("6Nkl4", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $4f271886f9517859$require$Buffer = $6U9mG.Buffer;

var $1QCyQ = parcelRequire("1QCyQ");

var $9AddZ = parcelRequire("9AddZ");
var $4f271886f9517859$require$Transform = $9AddZ.Transform;

var $eSHUL = parcelRequire("eSHUL");
function $4f271886f9517859$var$HashBase(blockSize) {
    $4f271886f9517859$require$Transform.call(this);
    this._block = $4f271886f9517859$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$eSHUL($4f271886f9517859$var$HashBase, $4f271886f9517859$require$Transform);
$4f271886f9517859$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$4f271886f9517859$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$4f271886f9517859$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $1QCyQ(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$4f271886f9517859$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$4f271886f9517859$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$4f271886f9517859$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $4f271886f9517859$var$HashBase;

});
parcelRegister("1QCyQ", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $15888f359faa2342$require$Buffer = $6U9mG.Buffer;

var $lePHA = parcelRequire("lePHA");
var $15888f359faa2342$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $15888f359faa2342$var$useArrayBuffer = $15888f359faa2342$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $15888f359faa2342$var$isView = $15888f359faa2342$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $15888f359faa2342$require$Buffer.isBuffer(thing) || $15888f359faa2342$var$useUint8Array && thing instanceof Uint8Array || $15888f359faa2342$var$isView && $15888f359faa2342$var$isView(thing)) return $lePHA(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("lePHA", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $03fd77c92c6f79f5$require$Buffer = $6U9mG.Buffer;

var $vRaFH = parcelRequire("vRaFH");

var $gIvYr = parcelRequire("gIvYr");
var $03fd77c92c6f79f5$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $gIvYr(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $03fd77c92c6f79f5$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $03fd77c92c6f79f5$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $03fd77c92c6f79f5$var$useFromArrayBuffer = $03fd77c92c6f79f5$var$useArrayBuffer && ($03fd77c92c6f79f5$require$Buffer.prototype instanceof Uint8Array || $03fd77c92c6f79f5$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($03fd77c92c6f79f5$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $03fd77c92c6f79f5$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $03fd77c92c6f79f5$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($03fd77c92c6f79f5$var$useArrayBuffer && $03fd77c92c6f79f5$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $03fd77c92c6f79f5$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($03fd77c92c6f79f5$var$useFromArrayBuffer) {
            var res = $03fd77c92c6f79f5$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $03fd77c92c6f79f5$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($03fd77c92c6f79f5$var$useUint8Array && data instanceof Uint8Array) return $03fd77c92c6f79f5$require$Buffer.from(data);
    var isArr = $vRaFH(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $03fd77c92c6f79f5$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $03fd77c92c6f79f5$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("vRaFH", function(module, exports) {
var $05fc240ad729c571$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $05fc240ad729c571$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("gIvYr", function(module, exports) {
'use strict';

var $eDiIz = parcelRequire("eDiIz");

var $bhqNG = parcelRequire("bhqNG");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $c2b98eb82cec83ce$var$$typedArrayBuffer = $bhqNG('TypedArray.prototype.buffer', true);

var $htkB6 = parcelRequire("htkB6");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $c2b98eb82cec83ce$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$htkB6(x)) throw new $eDiIz('Not a Typed Array');
    return x.buffer;
};

});



parcelRegister("9AddZ", function(module, exports) {

exports = module.exports = (parcelRequire("cEnbP"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("cuAoD"));

exports.Duplex = (parcelRequire("2Hlr9"));

exports.Transform = (parcelRequire("l7DDn"));

exports.PassThrough = (parcelRequire("6VFzs"));

});
parcelRegister("cEnbP", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TNnu = parcelRequire("4TNnu");
'use strict';

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ module.exports = $935b35782dc2f587$var$Readable;

var $6oWpx = parcelRequire("6oWpx");
/*</replacement>*/ /*<replacement>*/ var $935b35782dc2f587$var$Duplex;
/*</replacement>*/ $935b35782dc2f587$var$Readable.ReadableState = $935b35782dc2f587$var$ReadableState;

var $jMc9N = parcelRequire("jMc9N");
var $935b35782dc2f587$require$EE = $jMc9N.EventEmitter;
var $935b35782dc2f587$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $j5tZS = parcelRequire("j5tZS");

var $4QuJf = parcelRequire("4QuJf");
var $935b35782dc2f587$require$Buffer = $4QuJf.Buffer;
var $935b35782dc2f587$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $935b35782dc2f587$var$_uint8ArrayToBuffer(chunk) {
    return $935b35782dc2f587$require$Buffer.from(chunk);
}
function $935b35782dc2f587$var$_isUint8Array(obj) {
    return $935b35782dc2f587$require$Buffer.isBuffer(obj) || obj instanceof $935b35782dc2f587$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $935b35782dc2f587$var$util = Object.create((parcelRequire("iItjM")));

$935b35782dc2f587$var$util.inherits = (parcelRequire("eSHUL"));

var $5Io6y = parcelRequire("5Io6y");
var $935b35782dc2f587$var$debug = void 0;
if ($5Io6y && $5Io6y.debuglog) $935b35782dc2f587$var$debug = $5Io6y.debuglog('stream');
else $935b35782dc2f587$var$debug = function() {};

var $BfQF8 = parcelRequire("BfQF8");

var $kZIsm = parcelRequire("kZIsm");
var $935b35782dc2f587$var$StringDecoder;
$935b35782dc2f587$var$util.inherits($935b35782dc2f587$var$Readable, $j5tZS);
var $935b35782dc2f587$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $935b35782dc2f587$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($6oWpx(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $935b35782dc2f587$var$ReadableState(options, stream) {
    $935b35782dc2f587$var$Duplex = $935b35782dc2f587$var$Duplex || (parcelRequire("2Hlr9"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $935b35782dc2f587$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $BfQF8();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$935b35782dc2f587$var$StringDecoder) $935b35782dc2f587$var$StringDecoder = (parcelRequire("9TDPN")).StringDecoder;
        this.decoder = new $935b35782dc2f587$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $935b35782dc2f587$var$Readable(options) {
    $935b35782dc2f587$var$Duplex = $935b35782dc2f587$var$Duplex || (parcelRequire("2Hlr9"));
    if (!(this instanceof $935b35782dc2f587$var$Readable)) return new $935b35782dc2f587$var$Readable(options);
    this._readableState = new $935b35782dc2f587$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $j5tZS.call(this);
}
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$935b35782dc2f587$var$Readable.prototype.destroy = $kZIsm.destroy;
$935b35782dc2f587$var$Readable.prototype._undestroy = $kZIsm.undestroy;
$935b35782dc2f587$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$935b35782dc2f587$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $935b35782dc2f587$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $935b35782dc2f587$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$935b35782dc2f587$var$Readable.prototype.unshift = function(chunk) {
    return $935b35782dc2f587$var$readableAddChunk(this, chunk, null, true, false);
};
function $935b35782dc2f587$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $935b35782dc2f587$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $935b35782dc2f587$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $935b35782dc2f587$require$Buffer.prototype) chunk = $935b35782dc2f587$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $935b35782dc2f587$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $935b35782dc2f587$var$addChunk(stream, state, chunk, false);
                    else $935b35782dc2f587$var$maybeReadMore(stream, state);
                } else $935b35782dc2f587$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $935b35782dc2f587$var$needMoreData(state);
}
function $935b35782dc2f587$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $935b35782dc2f587$var$emitReadable(stream);
    }
    $935b35782dc2f587$var$maybeReadMore(stream, state);
}
function $935b35782dc2f587$var$chunkInvalid(state, chunk) {
    var er;
    if (!$935b35782dc2f587$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $935b35782dc2f587$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$935b35782dc2f587$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$935b35782dc2f587$var$Readable.prototype.setEncoding = function(enc) {
    if (!$935b35782dc2f587$var$StringDecoder) $935b35782dc2f587$var$StringDecoder = (parcelRequire("9TDPN")).StringDecoder;
    this._readableState.decoder = new $935b35782dc2f587$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $935b35782dc2f587$var$MAX_HWM = 0x800000;
function $935b35782dc2f587$var$computeNewHighWaterMark(n) {
    if (n >= $935b35782dc2f587$var$MAX_HWM) n = $935b35782dc2f587$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $935b35782dc2f587$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $935b35782dc2f587$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$935b35782dc2f587$var$Readable.prototype.read = function(n) {
    $935b35782dc2f587$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $935b35782dc2f587$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $935b35782dc2f587$var$endReadable(this);
        else $935b35782dc2f587$var$emitReadable(this);
        return null;
    }
    n = $935b35782dc2f587$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $935b35782dc2f587$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $935b35782dc2f587$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $935b35782dc2f587$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $935b35782dc2f587$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $935b35782dc2f587$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $935b35782dc2f587$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $935b35782dc2f587$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $935b35782dc2f587$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $935b35782dc2f587$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $935b35782dc2f587$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $935b35782dc2f587$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $935b35782dc2f587$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $kEUYA.nextTick($935b35782dc2f587$var$emitReadable_, stream);
        else $935b35782dc2f587$var$emitReadable_(stream);
    }
}
function $935b35782dc2f587$var$emitReadable_(stream) {
    $935b35782dc2f587$var$debug('emit readable');
    stream.emit('readable');
    $935b35782dc2f587$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $935b35782dc2f587$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $kEUYA.nextTick($935b35782dc2f587$var$maybeReadMore_, stream, state);
    }
}
function $935b35782dc2f587$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $935b35782dc2f587$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$935b35782dc2f587$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$935b35782dc2f587$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $935b35782dc2f587$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4TNnu.stdout && dest !== $4TNnu.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $kEUYA.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $935b35782dc2f587$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $935b35782dc2f587$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $935b35782dc2f587$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $935b35782dc2f587$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $935b35782dc2f587$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $935b35782dc2f587$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $935b35782dc2f587$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $935b35782dc2f587$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($935b35782dc2f587$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $935b35782dc2f587$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $935b35782dc2f587$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $935b35782dc2f587$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $935b35782dc2f587$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $935b35782dc2f587$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $935b35782dc2f587$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $935b35782dc2f587$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $935b35782dc2f587$var$flow(src);
        }
    };
}
$935b35782dc2f587$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $935b35782dc2f587$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$935b35782dc2f587$var$Readable.prototype.on = function(ev, fn) {
    var res = $j5tZS.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $kEUYA.nextTick($935b35782dc2f587$var$nReadingNextTick, this);
            else if (state.length) $935b35782dc2f587$var$emitReadable(this);
        }
    }
    return res;
};
$935b35782dc2f587$var$Readable.prototype.addListener = $935b35782dc2f587$var$Readable.prototype.on;
function $935b35782dc2f587$var$nReadingNextTick(self1) {
    $935b35782dc2f587$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$935b35782dc2f587$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $935b35782dc2f587$var$debug('resume');
        state.flowing = true;
        $935b35782dc2f587$var$resume(this, state);
    }
    return this;
};
function $935b35782dc2f587$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $kEUYA.nextTick($935b35782dc2f587$var$resume_, stream, state);
    }
}
function $935b35782dc2f587$var$resume_(stream, state) {
    if (!state.reading) {
        $935b35782dc2f587$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $935b35782dc2f587$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$935b35782dc2f587$var$Readable.prototype.pause = function() {
    $935b35782dc2f587$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $935b35782dc2f587$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $935b35782dc2f587$var$flow(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$935b35782dc2f587$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $935b35782dc2f587$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $935b35782dc2f587$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $935b35782dc2f587$var$kProxyEvents.length; n++)stream.on($935b35782dc2f587$var$kProxyEvents[n], this.emit.bind(this, $935b35782dc2f587$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $935b35782dc2f587$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$935b35782dc2f587$var$Readable._fromList = $935b35782dc2f587$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $935b35782dc2f587$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $935b35782dc2f587$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $935b35782dc2f587$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $935b35782dc2f587$var$copyFromBufferString(n, list) : $935b35782dc2f587$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $935b35782dc2f587$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $935b35782dc2f587$var$copyFromBuffer(n, list) {
    var ret = $935b35782dc2f587$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $935b35782dc2f587$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $kEUYA.nextTick($935b35782dc2f587$var$endReadableNT, state, stream);
    }
}
function $935b35782dc2f587$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $935b35782dc2f587$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("kEUYA", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
'use strict';
module.exports = {
    nextTick: $f0a3bd5c7cdf9bcd$var$nextTick
};
function $f0a3bd5c7cdf9bcd$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $4TNnu.nextTick(fn);
        case 2:
            return $4TNnu.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $4TNnu.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $4TNnu.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $4TNnu.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("6oWpx", function(module, exports) {
var $4a924b236786bc1b$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $4a924b236786bc1b$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("j5tZS", function(module, exports) {

module.exports = (parcelRequire("jMc9N")).EventEmitter;

});

parcelRegister("4QuJf", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $ihoyg = parcelRequire("ihoyg");
var $3873dad5d422c413$var$Buffer = $ihoyg.Buffer;
// alternative to using Object.keys for old browsers
function $3873dad5d422c413$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($3873dad5d422c413$var$Buffer.from && $3873dad5d422c413$var$Buffer.alloc && $3873dad5d422c413$var$Buffer.allocUnsafe && $3873dad5d422c413$var$Buffer.allocUnsafeSlow) module.exports = $ihoyg;
else {
    // Copy properties from require('buffer')
    $3873dad5d422c413$var$copyProps($ihoyg, module.exports);
    module.exports.Buffer = $3873dad5d422c413$var$SafeBuffer;
}
function $3873dad5d422c413$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $3873dad5d422c413$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$3873dad5d422c413$var$copyProps($3873dad5d422c413$var$Buffer, $3873dad5d422c413$var$SafeBuffer);
$3873dad5d422c413$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $3873dad5d422c413$var$Buffer(arg, encodingOrOffset, length);
};
$3873dad5d422c413$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $3873dad5d422c413$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$3873dad5d422c413$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $3873dad5d422c413$var$Buffer(size);
};
$3873dad5d422c413$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $ihoyg.SlowBuffer(size);
};

});

parcelRegister("iItjM", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $da031406cd389190$export$43bee75e5e14138e; }, function (v) { return $da031406cd389190$export$43bee75e5e14138e = v; });
$parcel$export(module.exports, "isBoolean", function () { return $da031406cd389190$export$f9ce7b637dfbe238; }, function (v) { return $da031406cd389190$export$f9ce7b637dfbe238 = v; });
$parcel$export(module.exports, "isNull", function () { return $da031406cd389190$export$630801d484da15df; }, function (v) { return $da031406cd389190$export$630801d484da15df = v; });
$parcel$export(module.exports, "isNullOrUndefined", function () { return $da031406cd389190$export$bedb7023a7733221; }, function (v) { return $da031406cd389190$export$bedb7023a7733221 = v; });
$parcel$export(module.exports, "isNumber", function () { return $da031406cd389190$export$7e4aa119212bc614; }, function (v) { return $da031406cd389190$export$7e4aa119212bc614 = v; });
$parcel$export(module.exports, "isString", function () { return $da031406cd389190$export$844ec244b1367d54; }, function (v) { return $da031406cd389190$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSymbol", function () { return $da031406cd389190$export$a244864fd9645c7f; }, function (v) { return $da031406cd389190$export$a244864fd9645c7f = v; });
$parcel$export(module.exports, "isUndefined", function () { return $da031406cd389190$export$fce6876652108ab; }, function (v) { return $da031406cd389190$export$fce6876652108ab = v; });
$parcel$export(module.exports, "isRegExp", function () { return $da031406cd389190$export$49841c62b9eff15; }, function (v) { return $da031406cd389190$export$49841c62b9eff15 = v; });
$parcel$export(module.exports, "isObject", function () { return $da031406cd389190$export$a6cdc56e425d0d0a; }, function (v) { return $da031406cd389190$export$a6cdc56e425d0d0a = v; });
$parcel$export(module.exports, "isDate", function () { return $da031406cd389190$export$871608497c498473; }, function (v) { return $da031406cd389190$export$871608497c498473 = v; });
$parcel$export(module.exports, "isError", function () { return $da031406cd389190$export$e6127cc7fe7395c3; }, function (v) { return $da031406cd389190$export$e6127cc7fe7395c3 = v; });
$parcel$export(module.exports, "isFunction", function () { return $da031406cd389190$export$f6e2535fb5126e54; }, function (v) { return $da031406cd389190$export$f6e2535fb5126e54 = v; });
$parcel$export(module.exports, "isPrimitive", function () { return $da031406cd389190$export$c3825b437cbdea5c; }, function (v) { return $da031406cd389190$export$c3825b437cbdea5c = v; });
$parcel$export(module.exports, "isBuffer", function () { return $da031406cd389190$export$a7884ebc965f8f54; }, function (v) { return $da031406cd389190$export$a7884ebc965f8f54 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $da031406cd389190$export$43bee75e5e14138e;
var $da031406cd389190$export$f9ce7b637dfbe238;
var $da031406cd389190$export$630801d484da15df;
var $da031406cd389190$export$bedb7023a7733221;
var $da031406cd389190$export$7e4aa119212bc614;
var $da031406cd389190$export$844ec244b1367d54;
var $da031406cd389190$export$a244864fd9645c7f;
var $da031406cd389190$export$fce6876652108ab;
var $da031406cd389190$export$49841c62b9eff15;
var $da031406cd389190$export$a6cdc56e425d0d0a;
var $da031406cd389190$export$871608497c498473;
var $da031406cd389190$export$e6127cc7fe7395c3;
var $da031406cd389190$export$f6e2535fb5126e54;
var $da031406cd389190$export$c3825b437cbdea5c;
var $da031406cd389190$export$a7884ebc965f8f54;
function $da031406cd389190$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $da031406cd389190$var$objectToString(arg) === '[object Array]';
}
$da031406cd389190$export$43bee75e5e14138e = $da031406cd389190$var$isArray;
function $da031406cd389190$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$da031406cd389190$export$f9ce7b637dfbe238 = $da031406cd389190$var$isBoolean;
function $da031406cd389190$var$isNull(arg) {
    return arg === null;
}
$da031406cd389190$export$630801d484da15df = $da031406cd389190$var$isNull;
function $da031406cd389190$var$isNullOrUndefined(arg) {
    return arg == null;
}
$da031406cd389190$export$bedb7023a7733221 = $da031406cd389190$var$isNullOrUndefined;
function $da031406cd389190$var$isNumber(arg) {
    return typeof arg === 'number';
}
$da031406cd389190$export$7e4aa119212bc614 = $da031406cd389190$var$isNumber;
function $da031406cd389190$var$isString(arg) {
    return typeof arg === 'string';
}
$da031406cd389190$export$844ec244b1367d54 = $da031406cd389190$var$isString;
function $da031406cd389190$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$da031406cd389190$export$a244864fd9645c7f = $da031406cd389190$var$isSymbol;
function $da031406cd389190$var$isUndefined(arg) {
    return arg === void 0;
}
$da031406cd389190$export$fce6876652108ab = $da031406cd389190$var$isUndefined;
function $da031406cd389190$var$isRegExp(re) {
    return $da031406cd389190$var$objectToString(re) === '[object RegExp]';
}
$da031406cd389190$export$49841c62b9eff15 = $da031406cd389190$var$isRegExp;
function $da031406cd389190$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$da031406cd389190$export$a6cdc56e425d0d0a = $da031406cd389190$var$isObject;
function $da031406cd389190$var$isDate(d) {
    return $da031406cd389190$var$objectToString(d) === '[object Date]';
}
$da031406cd389190$export$871608497c498473 = $da031406cd389190$var$isDate;
function $da031406cd389190$var$isError(e) {
    return $da031406cd389190$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$da031406cd389190$export$e6127cc7fe7395c3 = $da031406cd389190$var$isError;
function $da031406cd389190$var$isFunction(arg) {
    return typeof arg === 'function';
}
$da031406cd389190$export$f6e2535fb5126e54 = $da031406cd389190$var$isFunction;
function $da031406cd389190$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$da031406cd389190$export$c3825b437cbdea5c = $da031406cd389190$var$isPrimitive;

$da031406cd389190$export$a7884ebc965f8f54 = (parcelRequire("ihoyg")).Buffer.isBuffer;
function $da031406cd389190$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("BfQF8", function(module, exports) {
'use strict';
function $06ffbffa17040f37$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $4QuJf = parcelRequire("4QuJf");
var $06ffbffa17040f37$require$Buffer = $4QuJf.Buffer;

var $5Io6y = parcelRequire("5Io6y");
function $06ffbffa17040f37$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $06ffbffa17040f37$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $06ffbffa17040f37$require$Buffer.alloc(0);
        var ret = $06ffbffa17040f37$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $06ffbffa17040f37$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($5Io6y && $5Io6y.inspect && $5Io6y.inspect.custom) module.exports.prototype[$5Io6y.inspect.custom] = function() {
    var obj = $5Io6y.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("kZIsm", function(module, exports) {
'use strict';

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $f48bfd4745615c07$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $kEUYA.nextTick($f48bfd4745615c07$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $kEUYA.nextTick($f48bfd4745615c07$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $kEUYA.nextTick($f48bfd4745615c07$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $kEUYA.nextTick($f48bfd4745615c07$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $f48bfd4745615c07$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $f48bfd4745615c07$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $f48bfd4745615c07$var$destroy,
    undestroy: $f48bfd4745615c07$var$undestroy
};

});

parcelRegister("2Hlr9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ /*<replacement>*/ var $1f7039dea5b1b29a$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $1f7039dea5b1b29a$var$Duplex;

/*<replacement>*/ var $1f7039dea5b1b29a$var$util = Object.create((parcelRequire("iItjM")));

$1f7039dea5b1b29a$var$util.inherits = (parcelRequire("eSHUL"));

var $cEnbP = parcelRequire("cEnbP");

var $cuAoD = parcelRequire("cuAoD");
$1f7039dea5b1b29a$var$util.inherits($1f7039dea5b1b29a$var$Duplex, $cEnbP);
// avoid scope creep, the keys array can then be collected
var $1f7039dea5b1b29a$var$keys = $1f7039dea5b1b29a$var$objectKeys($cuAoD.prototype);
for(var $1f7039dea5b1b29a$var$v = 0; $1f7039dea5b1b29a$var$v < $1f7039dea5b1b29a$var$keys.length; $1f7039dea5b1b29a$var$v++){
    var $1f7039dea5b1b29a$var$method = $1f7039dea5b1b29a$var$keys[$1f7039dea5b1b29a$var$v];
    if (!$1f7039dea5b1b29a$var$Duplex.prototype[$1f7039dea5b1b29a$var$method]) $1f7039dea5b1b29a$var$Duplex.prototype[$1f7039dea5b1b29a$var$method] = $cuAoD.prototype[$1f7039dea5b1b29a$var$method];
}
function $1f7039dea5b1b29a$var$Duplex(options) {
    if (!(this instanceof $1f7039dea5b1b29a$var$Duplex)) return new $1f7039dea5b1b29a$var$Duplex(options);
    $cEnbP.call(this, options);
    $cuAoD.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $1f7039dea5b1b29a$var$onend);
}
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $1f7039dea5b1b29a$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $kEUYA.nextTick($1f7039dea5b1b29a$var$onEndNT, this);
}
function $1f7039dea5b1b29a$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$1f7039dea5b1b29a$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $kEUYA.nextTick(cb, err);
};

});
parcelRegister("cuAoD", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ module.exports = $918484e8c698b555$var$Writable;
/* <replacement> */ function $918484e8c698b555$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $918484e8c698b555$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $918484e8c698b555$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $918484e8c698b555$var$asyncWrite = (0, $kEUYA.nextTick);
/*</replacement>*/ /*<replacement>*/ var $918484e8c698b555$var$Duplex;
/*</replacement>*/ $918484e8c698b555$var$Writable.WritableState = $918484e8c698b555$var$WritableState;

/*<replacement>*/ var $918484e8c698b555$var$util = Object.create((parcelRequire("iItjM")));

$918484e8c698b555$var$util.inherits = (parcelRequire("eSHUL"));

/*</replacement>*/ /*<replacement>*/ var $918484e8c698b555$var$internalUtil = {
    deprecate: (parcelRequire("l4FQK"))
};

var $j5tZS = parcelRequire("j5tZS");

var $4QuJf = parcelRequire("4QuJf");
var $918484e8c698b555$require$Buffer = $4QuJf.Buffer;
var $918484e8c698b555$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $918484e8c698b555$var$_uint8ArrayToBuffer(chunk) {
    return $918484e8c698b555$require$Buffer.from(chunk);
}
function $918484e8c698b555$var$_isUint8Array(obj) {
    return $918484e8c698b555$require$Buffer.isBuffer(obj) || obj instanceof $918484e8c698b555$var$OurUint8Array;
}

var $kZIsm = parcelRequire("kZIsm");
$918484e8c698b555$var$util.inherits($918484e8c698b555$var$Writable, $j5tZS);
function $918484e8c698b555$var$nop() {}

function $918484e8c698b555$var$WritableState(options, stream) {
    $918484e8c698b555$var$Duplex = $918484e8c698b555$var$Duplex || (parcelRequire("2Hlr9"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $918484e8c698b555$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $918484e8c698b555$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $918484e8c698b555$var$CorkedRequest(this);
}
$918484e8c698b555$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($918484e8c698b555$var$WritableState.prototype, 'buffer', {
            get: $918484e8c698b555$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $918484e8c698b555$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $918484e8c698b555$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($918484e8c698b555$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($918484e8c698b555$var$realHasInstance.call(this, object)) return true;
            if (this !== $918484e8c698b555$var$Writable) return false;
            return object && object._writableState instanceof $918484e8c698b555$var$WritableState;
        }
    });
} else $918484e8c698b555$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $918484e8c698b555$var$Writable(options) {
    $918484e8c698b555$var$Duplex = $918484e8c698b555$var$Duplex || (parcelRequire("2Hlr9"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$918484e8c698b555$var$realHasInstance.call($918484e8c698b555$var$Writable, this) && !(this instanceof $918484e8c698b555$var$Duplex)) return new $918484e8c698b555$var$Writable(options);
    this._writableState = new $918484e8c698b555$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $j5tZS.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$918484e8c698b555$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $918484e8c698b555$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $kEUYA.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $918484e8c698b555$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $kEUYA.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$918484e8c698b555$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $918484e8c698b555$var$_isUint8Array(chunk);
    if (isBuf && !$918484e8c698b555$require$Buffer.isBuffer(chunk)) chunk = $918484e8c698b555$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $918484e8c698b555$var$nop;
    if (state.ended) $918484e8c698b555$var$writeAfterEnd(this, cb);
    else if (isBuf || $918484e8c698b555$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $918484e8c698b555$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$918484e8c698b555$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$918484e8c698b555$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $918484e8c698b555$var$clearBuffer(this, state);
    }
};
$918484e8c698b555$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $918484e8c698b555$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $918484e8c698b555$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($918484e8c698b555$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $918484e8c698b555$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $918484e8c698b555$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $918484e8c698b555$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $918484e8c698b555$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $918484e8c698b555$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $kEUYA.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $kEUYA.nextTick($918484e8c698b555$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $918484e8c698b555$var$finishMaybe(stream, state);
    }
}
function $918484e8c698b555$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $918484e8c698b555$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $918484e8c698b555$var$onwriteStateUpdate(state);
    if (er) $918484e8c698b555$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $918484e8c698b555$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $918484e8c698b555$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $918484e8c698b555$var$asyncWrite($918484e8c698b555$var$afterWrite, stream, state, finished, cb);
        else $918484e8c698b555$var$afterWrite(stream, state, finished, cb);
    }
}
function $918484e8c698b555$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $918484e8c698b555$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $918484e8c698b555$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $918484e8c698b555$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $918484e8c698b555$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $918484e8c698b555$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $918484e8c698b555$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $918484e8c698b555$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$918484e8c698b555$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$918484e8c698b555$var$Writable.prototype._writev = null;
$918484e8c698b555$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $918484e8c698b555$var$endWritable(this, state, cb);
};
function $918484e8c698b555$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $918484e8c698b555$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $918484e8c698b555$var$finishMaybe(stream, state);
    });
}
function $918484e8c698b555$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $kEUYA.nextTick($918484e8c698b555$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $918484e8c698b555$var$finishMaybe(stream, state) {
    var need = $918484e8c698b555$var$needFinish(state);
    if (need) {
        $918484e8c698b555$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $918484e8c698b555$var$endWritable(stream, state, cb) {
    state.ending = true;
    $918484e8c698b555$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $kEUYA.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $918484e8c698b555$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($918484e8c698b555$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$918484e8c698b555$var$Writable.prototype.destroy = $kZIsm.destroy;
$918484e8c698b555$var$Writable.prototype._undestroy = $kZIsm.undestroy;
$918484e8c698b555$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("9TDPN", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $73482663e84b74f4$export$63a7aa211a91ed69; }, function (v) { return $73482663e84b74f4$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $73482663e84b74f4$export$63a7aa211a91ed69;
'use strict';

var $4QuJf = parcelRequire("4QuJf");
var $73482663e84b74f4$require$Buffer = $4QuJf.Buffer;
/*</replacement>*/ var $73482663e84b74f4$var$isEncoding = $73482663e84b74f4$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $73482663e84b74f4$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $73482663e84b74f4$var$normalizeEncoding(enc) {
    var nenc = $73482663e84b74f4$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($73482663e84b74f4$require$Buffer.isEncoding === $73482663e84b74f4$var$isEncoding || !$73482663e84b74f4$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$73482663e84b74f4$export$63a7aa211a91ed69 = $73482663e84b74f4$var$StringDecoder;
function $73482663e84b74f4$var$StringDecoder(encoding) {
    this.encoding = $73482663e84b74f4$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $73482663e84b74f4$var$utf16Text;
            this.end = $73482663e84b74f4$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $73482663e84b74f4$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $73482663e84b74f4$var$base64Text;
            this.end = $73482663e84b74f4$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $73482663e84b74f4$var$simpleWrite;
            this.end = $73482663e84b74f4$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $73482663e84b74f4$require$Buffer.allocUnsafe(nb);
}
$73482663e84b74f4$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$73482663e84b74f4$var$StringDecoder.prototype.end = $73482663e84b74f4$var$utf8End;
// Returns only complete characters in a Buffer
$73482663e84b74f4$var$StringDecoder.prototype.text = $73482663e84b74f4$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$73482663e84b74f4$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $73482663e84b74f4$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $73482663e84b74f4$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $73482663e84b74f4$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $73482663e84b74f4$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $73482663e84b74f4$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $73482663e84b74f4$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $73482663e84b74f4$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $73482663e84b74f4$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $73482663e84b74f4$var$utf8Text(buf, i) {
    var total = $73482663e84b74f4$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $73482663e84b74f4$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $73482663e84b74f4$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $73482663e84b74f4$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $73482663e84b74f4$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $73482663e84b74f4$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $73482663e84b74f4$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $73482663e84b74f4$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("l7DDn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $f608fef10a5347dd$var$Transform;

var $2Hlr9 = parcelRequire("2Hlr9");

/*<replacement>*/ var $f608fef10a5347dd$var$util = Object.create((parcelRequire("iItjM")));

$f608fef10a5347dd$var$util.inherits = (parcelRequire("eSHUL"));
/*</replacement>*/ $f608fef10a5347dd$var$util.inherits($f608fef10a5347dd$var$Transform, $2Hlr9);
function $f608fef10a5347dd$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $f608fef10a5347dd$var$Transform(options) {
    if (!(this instanceof $f608fef10a5347dd$var$Transform)) return new $f608fef10a5347dd$var$Transform(options);
    $2Hlr9.call(this, options);
    this._transformState = {
        afterTransform: $f608fef10a5347dd$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $f608fef10a5347dd$var$prefinish);
}
function $f608fef10a5347dd$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $f608fef10a5347dd$var$done(_this, er, data);
    });
    else $f608fef10a5347dd$var$done(this, null, null);
}
$f608fef10a5347dd$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $2Hlr9.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$f608fef10a5347dd$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$f608fef10a5347dd$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$f608fef10a5347dd$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$f608fef10a5347dd$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $2Hlr9.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $f608fef10a5347dd$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("6VFzs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $50b8500ab5b3088d$var$PassThrough;

var $l7DDn = parcelRequire("l7DDn");

/*<replacement>*/ var $50b8500ab5b3088d$var$util = Object.create((parcelRequire("iItjM")));

$50b8500ab5b3088d$var$util.inherits = (parcelRequire("eSHUL"));
/*</replacement>*/ $50b8500ab5b3088d$var$util.inherits($50b8500ab5b3088d$var$PassThrough, $l7DDn);
function $50b8500ab5b3088d$var$PassThrough(options) {
    if (!(this instanceof $50b8500ab5b3088d$var$PassThrough)) return new $50b8500ab5b3088d$var$PassThrough(options);
    $l7DDn.call(this, options);
}
$50b8500ab5b3088d$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("fkJVr", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("g2uoB"));

module.exports.sha1 = (parcelRequire("lyJtz"));

module.exports.sha224 = (parcelRequire("cwjAo"));

module.exports.sha256 = (parcelRequire("1o1iT"));

module.exports.sha384 = (parcelRequire("kWtXA"));

module.exports.sha512 = (parcelRequire("1HQNC"));

});
parcelRegister("g2uoB", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $bad46934fbfe816d$require$Buffer = $6U9mG.Buffer;
var $bad46934fbfe816d$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $bad46934fbfe816d$var$W = new Array(80);
function $bad46934fbfe816d$var$Sha() {
    this.init();
    this._w = $bad46934fbfe816d$var$W;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($bad46934fbfe816d$var$Sha, $6fUHB);
$bad46934fbfe816d$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $bad46934fbfe816d$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $bad46934fbfe816d$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $bad46934fbfe816d$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$bad46934fbfe816d$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $bad46934fbfe816d$var$rotl5(a) + $bad46934fbfe816d$var$ft(s, b, c, d) + e + w[j] + $bad46934fbfe816d$var$K[s] | 0;
        e = d;
        d = c;
        c = $bad46934fbfe816d$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$bad46934fbfe816d$var$Sha.prototype._hash = function() {
    var H = $bad46934fbfe816d$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $bad46934fbfe816d$var$Sha;

});
parcelRegister("6fUHB", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $48e020b2c4716d14$require$Buffer = $6U9mG.Buffer;

var $lePHA = parcelRequire("lePHA");
// prototype class for hash functions
function $48e020b2c4716d14$var$Hash(blockSize, finalSize) {
    this._block = $48e020b2c4716d14$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$48e020b2c4716d14$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $lePHA(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$48e020b2c4716d14$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$48e020b2c4716d14$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $48e020b2c4716d14$var$Hash;

});


parcelRegister("lyJtz", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $fb200c8a1442e09f$require$Buffer = $6U9mG.Buffer;
var $fb200c8a1442e09f$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $fb200c8a1442e09f$var$W = new Array(80);
function $fb200c8a1442e09f$var$Sha1() {
    this.init();
    this._w = $fb200c8a1442e09f$var$W;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($fb200c8a1442e09f$var$Sha1, $6fUHB);
$fb200c8a1442e09f$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $fb200c8a1442e09f$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $fb200c8a1442e09f$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $fb200c8a1442e09f$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $fb200c8a1442e09f$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$fb200c8a1442e09f$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $fb200c8a1442e09f$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $fb200c8a1442e09f$var$rotl5(a) + $fb200c8a1442e09f$var$ft(s, b, c, d) + e + w[j] + $fb200c8a1442e09f$var$K[s] | 0;
        e = d;
        d = c;
        c = $fb200c8a1442e09f$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$fb200c8a1442e09f$var$Sha1.prototype._hash = function() {
    var H = $fb200c8a1442e09f$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $fb200c8a1442e09f$var$Sha1;

});

parcelRegister("cwjAo", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $1o1iT = parcelRequire("1o1iT");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $91d7aa8b17a16320$require$Buffer = $6U9mG.Buffer;
var $91d7aa8b17a16320$var$W = new Array(64);
function $91d7aa8b17a16320$var$Sha224() {
    this.init();
    this._w = $91d7aa8b17a16320$var$W; // new Array(64)
    $6fUHB.call(this, 64, 56);
}
$eSHUL($91d7aa8b17a16320$var$Sha224, $1o1iT);
$91d7aa8b17a16320$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$91d7aa8b17a16320$var$Sha224.prototype._hash = function() {
    var H = $91d7aa8b17a16320$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $91d7aa8b17a16320$var$Sha224;

});
parcelRegister("1o1iT", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $10290b3c9978cdf8$require$Buffer = $6U9mG.Buffer;
var $10290b3c9978cdf8$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $10290b3c9978cdf8$var$W = new Array(64);
function $10290b3c9978cdf8$var$Sha256() {
    this.init();
    this._w = $10290b3c9978cdf8$var$W; // new Array(64)
    $6fUHB.call(this, 64, 56);
}
$eSHUL($10290b3c9978cdf8$var$Sha256, $6fUHB);
$10290b3c9978cdf8$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $10290b3c9978cdf8$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $10290b3c9978cdf8$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $10290b3c9978cdf8$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $10290b3c9978cdf8$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $10290b3c9978cdf8$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $10290b3c9978cdf8$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$10290b3c9978cdf8$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $10290b3c9978cdf8$var$gamma1(w[i - 2]) + w[i - 7] + $10290b3c9978cdf8$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $10290b3c9978cdf8$var$sigma1(e) + $10290b3c9978cdf8$var$ch(e, f, g) + $10290b3c9978cdf8$var$K[j] + w[j] | 0;
        var T2 = $10290b3c9978cdf8$var$sigma0(a) + $10290b3c9978cdf8$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$10290b3c9978cdf8$var$Sha256.prototype._hash = function() {
    var H = $10290b3c9978cdf8$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $10290b3c9978cdf8$var$Sha256;

});


parcelRegister("kWtXA", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $1HQNC = parcelRequire("1HQNC");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $f3f076e48793fba5$require$Buffer = $6U9mG.Buffer;
var $f3f076e48793fba5$var$W = new Array(160);
function $f3f076e48793fba5$var$Sha384() {
    this.init();
    this._w = $f3f076e48793fba5$var$W;
    $6fUHB.call(this, 128, 112);
}
$eSHUL($f3f076e48793fba5$var$Sha384, $1HQNC);
$f3f076e48793fba5$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$f3f076e48793fba5$var$Sha384.prototype._hash = function() {
    var H = $f3f076e48793fba5$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $f3f076e48793fba5$var$Sha384;

});
parcelRegister("1HQNC", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $13e2c371a41c8789$require$Buffer = $6U9mG.Buffer;
var $13e2c371a41c8789$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $13e2c371a41c8789$var$W = new Array(160);
function $13e2c371a41c8789$var$Sha512() {
    this.init();
    this._w = $13e2c371a41c8789$var$W;
    $6fUHB.call(this, 128, 112);
}
$eSHUL($13e2c371a41c8789$var$Sha512, $6fUHB);
$13e2c371a41c8789$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $13e2c371a41c8789$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $13e2c371a41c8789$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $13e2c371a41c8789$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $13e2c371a41c8789$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $13e2c371a41c8789$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $13e2c371a41c8789$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $13e2c371a41c8789$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $13e2c371a41c8789$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $13e2c371a41c8789$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$13e2c371a41c8789$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $13e2c371a41c8789$var$Gamma0(xh, xl);
        var gamma0l = $13e2c371a41c8789$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $13e2c371a41c8789$var$Gamma1(xh, xl);
        var gamma1l = $13e2c371a41c8789$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $13e2c371a41c8789$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $13e2c371a41c8789$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $13e2c371a41c8789$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $13e2c371a41c8789$var$maj(ah, bh, ch);
        var majl = $13e2c371a41c8789$var$maj(al, bl, cl);
        var sigma0h = $13e2c371a41c8789$var$sigma0(ah, al);
        var sigma0l = $13e2c371a41c8789$var$sigma0(al, ah);
        var sigma1h = $13e2c371a41c8789$var$sigma1(eh, el);
        var sigma1l = $13e2c371a41c8789$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $13e2c371a41c8789$var$K[j];
        var Kil = $13e2c371a41c8789$var$K[j + 1];
        var chh = $13e2c371a41c8789$var$Ch(eh, fh, gh);
        var chl = $13e2c371a41c8789$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $13e2c371a41c8789$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $13e2c371a41c8789$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $13e2c371a41c8789$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $13e2c371a41c8789$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $13e2c371a41c8789$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $13e2c371a41c8789$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $13e2c371a41c8789$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $13e2c371a41c8789$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $13e2c371a41c8789$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $13e2c371a41c8789$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $13e2c371a41c8789$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $13e2c371a41c8789$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $13e2c371a41c8789$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $13e2c371a41c8789$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $13e2c371a41c8789$var$getCarry(this._hl, hl) | 0;
};
$13e2c371a41c8789$var$Sha512.prototype._hash = function() {
    var H = $13e2c371a41c8789$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $13e2c371a41c8789$var$Sha512;

});



parcelRegister("fpHcA", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $b38ab3d1a7f86ec9$require$Buffer = $6U9mG.Buffer;

var $bks2w = parcelRequire("bks2w");
var $b38ab3d1a7f86ec9$require$Transform = $bks2w.Transform;

var $lEpDX = parcelRequire("lEpDX");
var $b38ab3d1a7f86ec9$require$StringDecoder = $lEpDX.StringDecoder;

var $eSHUL = parcelRequire("eSHUL");

var $lePHA = parcelRequire("lePHA");
function $b38ab3d1a7f86ec9$var$CipherBase(hashMode) {
    $b38ab3d1a7f86ec9$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$eSHUL($b38ab3d1a7f86ec9$var$CipherBase, $b38ab3d1a7f86ec9$require$Transform);
$b38ab3d1a7f86ec9$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $lePHA(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAutoPadding = function() {};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $b38ab3d1a7f86ec9$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $b38ab3d1a7f86ec9$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $b38ab3d1a7f86ec9$var$CipherBase;

});


parcelRegister("cUvgf", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $bRBTe = parcelRequire("bRBTe");

var $fpHcA = parcelRequire("fpHcA");

var $6U9mG = parcelRequire("6U9mG");
var $9662f6cbdeac7c49$require$Buffer = $6U9mG.Buffer;

var $5GY4Y = parcelRequire("5GY4Y");

var $cjuEr = parcelRequire("cjuEr");

var $fkJVr = parcelRequire("fkJVr");
var $9662f6cbdeac7c49$var$ZEROS = $9662f6cbdeac7c49$require$Buffer.alloc(128);
function $9662f6cbdeac7c49$var$Hmac(alg, key) {
    $fpHcA.call(this, 'digest');
    if (typeof key === 'string') key = $9662f6cbdeac7c49$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $cjuEr() : $fkJVr(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $9662f6cbdeac7c49$require$Buffer.concat([
        key,
        $9662f6cbdeac7c49$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $9662f6cbdeac7c49$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $9662f6cbdeac7c49$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $cjuEr() : $fkJVr(alg);
    this._hash.update(ipad);
}
$eSHUL($9662f6cbdeac7c49$var$Hmac, $fpHcA);
$9662f6cbdeac7c49$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$9662f6cbdeac7c49$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $cjuEr() : $fkJVr(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $9662f6cbdeac7c49$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $bRBTe($5GY4Y, key);
    return new $9662f6cbdeac7c49$var$Hmac(alg, key);
};

});
parcelRegister("bRBTe", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $6U9mG = parcelRequire("6U9mG");
var $8a32091105b403f5$require$Buffer = $6U9mG.Buffer;

var $fpHcA = parcelRequire("fpHcA");
var $8a32091105b403f5$var$ZEROS = $8a32091105b403f5$require$Buffer.alloc(128);
var $8a32091105b403f5$var$blocksize = 64;
function $8a32091105b403f5$var$Hmac(alg, key) {
    $fpHcA.call(this, 'digest');
    if (typeof key === 'string') key = $8a32091105b403f5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $8a32091105b403f5$var$blocksize) key = alg(key);
    else if (key.length < $8a32091105b403f5$var$blocksize) key = $8a32091105b403f5$require$Buffer.concat([
        key,
        $8a32091105b403f5$var$ZEROS
    ], $8a32091105b403f5$var$blocksize);
    var ipad = this._ipad = $8a32091105b403f5$require$Buffer.allocUnsafe($8a32091105b403f5$var$blocksize);
    var opad = this._opad = $8a32091105b403f5$require$Buffer.allocUnsafe($8a32091105b403f5$var$blocksize);
    for(var i = 0; i < $8a32091105b403f5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$eSHUL($8a32091105b403f5$var$Hmac, $fpHcA);
$8a32091105b403f5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$8a32091105b403f5$var$Hmac.prototype._final = function() {
    var h = this._alg($8a32091105b403f5$require$Buffer.concat(this._hash));
    return this._alg($8a32091105b403f5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $8a32091105b403f5$var$Hmac;

});

parcelRegister("5GY4Y", function(module, exports) {

var $cvCaQ = parcelRequire("cvCaQ");
module.exports = function(buffer) {
    return new $cvCaQ().update(buffer).digest();
};

});


parcelRegister("fAh7A", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jdVex"));

});
parcelRegister("jdVex", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("1UZ5c", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $165a6736bece551e$export$448fa22aedc9dbca; }, function (v) { return $165a6736bece551e$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $165a6736bece551e$export$b80c7ba289c8fa56; }, function (v) { return $165a6736bece551e$export$b80c7ba289c8fa56 = v; });
var $165a6736bece551e$export$448fa22aedc9dbca;
var $165a6736bece551e$export$b80c7ba289c8fa56;
'use strict';

$165a6736bece551e$export$448fa22aedc9dbca = (parcelRequire("dIhCC"));

$165a6736bece551e$export$b80c7ba289c8fa56 = (parcelRequire("6LmVU"));

});
parcelRegister("dIhCC", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $9fbd0dc1d3c42e2b$require$Buffer = $6U9mG.Buffer;

var $1iCjP = parcelRequire("1iCjP");

var $d5AyT = parcelRequire("d5AyT");

var $6LmVU = parcelRequire("6LmVU");

var $dq9GI = parcelRequire("dq9GI");
var $9fbd0dc1d3c42e2b$var$ZERO_BUF;
var $9fbd0dc1d3c42e2b$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $9fbd0dc1d3c42e2b$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $9fbd0dc1d3c42e2b$var$checks = [];
var $9fbd0dc1d3c42e2b$var$nextTick;
function $9fbd0dc1d3c42e2b$var$getNextTick() {
    if ($9fbd0dc1d3c42e2b$var$nextTick) return $9fbd0dc1d3c42e2b$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.setImmediate;
    else $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.setTimeout;
    return $9fbd0dc1d3c42e2b$var$nextTick;
}
function $9fbd0dc1d3c42e2b$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $9fbd0dc1d3c42e2b$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $9fbd0dc1d3c42e2b$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $9fbd0dc1d3c42e2b$require$Buffer.from(res);
    });
}
function $9fbd0dc1d3c42e2b$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$9fbd0dc1d3c42e2b$var$subtle || !$9fbd0dc1d3c42e2b$var$subtle.importKey || !$9fbd0dc1d3c42e2b$var$subtle.deriveBits) return Promise.resolve(false);
    if ($9fbd0dc1d3c42e2b$var$checks[algo] !== undefined) return $9fbd0dc1d3c42e2b$var$checks[algo];
    $9fbd0dc1d3c42e2b$var$ZERO_BUF = $9fbd0dc1d3c42e2b$var$ZERO_BUF || $9fbd0dc1d3c42e2b$require$Buffer.alloc(8);
    var prom = $9fbd0dc1d3c42e2b$var$browserPbkdf2($9fbd0dc1d3c42e2b$var$ZERO_BUF, $9fbd0dc1d3c42e2b$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $9fbd0dc1d3c42e2b$var$checks[algo] = prom;
    return prom;
}
function $9fbd0dc1d3c42e2b$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $9fbd0dc1d3c42e2b$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $9fbd0dc1d3c42e2b$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    $1iCjP(iterations, keylen);
    password = $dq9GI(password, $d5AyT, 'Password');
    salt = $dq9GI(salt, $d5AyT, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $9fbd0dc1d3c42e2b$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $9fbd0dc1d3c42e2b$var$getNextTick()(function() {
            var out;
            try {
                out = $6LmVU(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $9fbd0dc1d3c42e2b$var$resolvePromise($9fbd0dc1d3c42e2b$var$checkNative(algo).then(function(resp) {
        if (resp) return $9fbd0dc1d3c42e2b$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $6LmVU(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("1iCjP", function(module, exports) {
'use strict';
var $0f253230941a725c$var$$isFinite = isFinite;
var $0f253230941a725c$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$0f253230941a725c$var$$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $0f253230941a725c$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("d5AyT", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
'use strict';
var $98781a6615686185$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $98781a6615686185$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $98781a6615686185$var$pVersionMajor = parseInt($4TNnu.version.split('.')[0].slice(1), 10);
    $98781a6615686185$var$defaultEncoding = $98781a6615686185$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $98781a6615686185$var$defaultEncoding = 'utf-8';
module.exports = $98781a6615686185$var$defaultEncoding;

});

parcelRegister("6LmVU", function(module, exports) {
'use strict';

var $5GY4Y = parcelRequire("5GY4Y");

var $cjuEr = parcelRequire("cjuEr");

var $fkJVr = parcelRequire("fkJVr");

var $6U9mG = parcelRequire("6U9mG");
var $4ec8ebe845b2b457$require$Buffer = $6U9mG.Buffer;

var $1iCjP = parcelRequire("1iCjP");

var $d5AyT = parcelRequire("d5AyT");

var $dq9GI = parcelRequire("dq9GI");
var $4ec8ebe845b2b457$var$ZEROS = $4ec8ebe845b2b457$require$Buffer.alloc(128);
var $4ec8ebe845b2b457$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $4ec8ebe845b2b457$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $4ec8ebe845b2b457$var$rmd160Func(data) {
    return new $cjuEr().update(data).digest();
}
function $4ec8ebe845b2b457$var$getDigest(alg) {
    function shaFunc(data) {
        return $fkJVr(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $4ec8ebe845b2b457$var$rmd160Func;
    if (alg === 'md5') return $5GY4Y;
    return shaFunc;
}
function $4ec8ebe845b2b457$var$Hmac(alg, key, saltLen) {
    var hash = $4ec8ebe845b2b457$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $4ec8ebe845b2b457$require$Buffer.concat([
        key,
        $4ec8ebe845b2b457$var$ZEROS
    ], blocksize);
    var ipad = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(blocksize + $4ec8ebe845b2b457$var$sizes[alg]);
    var opad = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(blocksize + $4ec8ebe845b2b457$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $4ec8ebe845b2b457$var$sizes[alg];
}
$4ec8ebe845b2b457$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $4ec8ebe845b2b457$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $1iCjP(iterations, keylen);
    password = $dq9GI(password, $d5AyT, 'Password');
    salt = $dq9GI(salt, $d5AyT, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $4ec8ebe845b2b457$var$mapping[lowerDigest] || lowerDigest;
    var size = $4ec8ebe845b2b457$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $4ec8ebe845b2b457$var$Hmac(mappedDigest, password, salt.length);
    var DK = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(keylen);
    var block1 = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $4ec8ebe845b2b457$var$pbkdf2;

});
parcelRegister("dq9GI", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $9c5537e46f7ed310$require$Buffer = $6U9mG.Buffer;

var $lePHA = parcelRequire("lePHA");
var $9c5537e46f7ed310$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $9c5537e46f7ed310$var$useArrayBuffer = $9c5537e46f7ed310$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $9c5537e46f7ed310$var$isView = $9c5537e46f7ed310$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $9c5537e46f7ed310$require$Buffer.isBuffer(thing) || $9c5537e46f7ed310$var$useUint8Array && thing instanceof Uint8Array || $9c5537e46f7ed310$var$isView && $9c5537e46f7ed310$var$isView(thing)) return $lePHA(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});




parcelRegister("3lJ0u", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $27063eb805988425$export$bdd223f16383713e; }, function (v) { return $27063eb805988425$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $27063eb805988425$export$26e5786e8ac8e530; }, function (v) { return $27063eb805988425$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $27063eb805988425$export$2f64596b8cbf08b4; }, function (v) { return $27063eb805988425$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $27063eb805988425$export$20533d26f07f1ee0; }, function (v) { return $27063eb805988425$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $27063eb805988425$export$12ada9414fbc594c; }, function (v) { return $27063eb805988425$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $27063eb805988425$export$2ce6d8d0e8b04e1a; }, function (v) { return $27063eb805988425$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $27063eb805988425$export$36b6d6ef312eab39; }, function (v) { return $27063eb805988425$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $27063eb805988425$export$f5e7e39d57cd9700; }, function (v) { return $27063eb805988425$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $27063eb805988425$export$dedd8dc3dc62b370; }, function (v) { return $27063eb805988425$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $27063eb805988425$export$58a258485f1e49f6; }, function (v) { return $27063eb805988425$export$58a258485f1e49f6 = v; });
var $27063eb805988425$export$bdd223f16383713e;
var $27063eb805988425$export$26e5786e8ac8e530;
var $27063eb805988425$export$2f64596b8cbf08b4;
var $27063eb805988425$export$20533d26f07f1ee0;
var $27063eb805988425$export$12ada9414fbc594c;
var $27063eb805988425$export$2ce6d8d0e8b04e1a;
var $27063eb805988425$export$36b6d6ef312eab39;
var $27063eb805988425$export$f5e7e39d57cd9700;
var $27063eb805988425$export$dedd8dc3dc62b370;
var $27063eb805988425$export$58a258485f1e49f6;

var $5e4Jl = parcelRequire("5e4Jl");

var $k1gB1 = parcelRequire("k1gB1");

var $saHx5 = parcelRequire("saHx5");

var $hqhSB = parcelRequire("hqhSB");

var $5uIwM = parcelRequire("5uIwM");
function $27063eb805988425$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($saHx5[suite]) {
        keyLen = $saHx5[suite].key;
        ivLen = $saHx5[suite].iv;
    } else if ($hqhSB[suite]) {
        keyLen = $hqhSB[suite].key * 8;
        ivLen = $hqhSB[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $5uIwM(password, false, keyLen, ivLen);
    return $27063eb805988425$var$createCipheriv(suite, keys.key, keys.iv);
}
function $27063eb805988425$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($saHx5[suite]) {
        keyLen = $saHx5[suite].key;
        ivLen = $saHx5[suite].iv;
    } else if ($hqhSB[suite]) {
        keyLen = $hqhSB[suite].key * 8;
        ivLen = $hqhSB[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $5uIwM(password, false, keyLen, ivLen);
    return $27063eb805988425$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $27063eb805988425$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($saHx5[suite]) return $k1gB1.createCipheriv(suite, key, iv);
    if ($hqhSB[suite]) return new $5e4Jl({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $27063eb805988425$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($saHx5[suite]) return $k1gB1.createDecipheriv(suite, key, iv);
    if ($hqhSB[suite]) return new $5e4Jl({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $27063eb805988425$var$getCiphers() {
    return Object.keys($hqhSB).concat($k1gB1.getCiphers());
}
$27063eb805988425$export$bdd223f16383713e = $27063eb805988425$export$26e5786e8ac8e530 = $27063eb805988425$var$createCipher;
$27063eb805988425$export$2f64596b8cbf08b4 = $27063eb805988425$export$20533d26f07f1ee0 = $27063eb805988425$var$createCipheriv;
$27063eb805988425$export$12ada9414fbc594c = $27063eb805988425$export$2ce6d8d0e8b04e1a = $27063eb805988425$var$createDecipher;
$27063eb805988425$export$36b6d6ef312eab39 = $27063eb805988425$export$f5e7e39d57cd9700 = $27063eb805988425$var$createDecipheriv;
$27063eb805988425$export$dedd8dc3dc62b370 = $27063eb805988425$export$58a258485f1e49f6 = $27063eb805988425$var$getCiphers;

});
parcelRegister("5e4Jl", function(module, exports) {

var $fpHcA = parcelRequire("fpHcA");

var $lCSZA = parcelRequire("lCSZA");

var $eSHUL = parcelRequire("eSHUL");

var $6U9mG = parcelRequire("6U9mG");
var $3ce1edebcff63bba$require$Buffer = $6U9mG.Buffer;
var $3ce1edebcff63bba$var$modes = {
    'des-ede3-cbc': $lCSZA.CBC.instantiate($lCSZA.EDE),
    'des-ede3': $lCSZA.EDE,
    'des-ede-cbc': $lCSZA.CBC.instantiate($lCSZA.EDE),
    'des-ede': $lCSZA.EDE,
    'des-cbc': $lCSZA.CBC.instantiate($lCSZA.DES),
    'des-ecb': $lCSZA.DES
};
$3ce1edebcff63bba$var$modes.des = $3ce1edebcff63bba$var$modes['des-cbc'];
$3ce1edebcff63bba$var$modes.des3 = $3ce1edebcff63bba$var$modes['des-ede3-cbc'];
module.exports = $3ce1edebcff63bba$var$DES;
$eSHUL($3ce1edebcff63bba$var$DES, $fpHcA);
function $3ce1edebcff63bba$var$DES(opts) {
    $fpHcA.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $3ce1edebcff63bba$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$3ce1edebcff63bba$require$Buffer.isBuffer(key)) key = $3ce1edebcff63bba$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $3ce1edebcff63bba$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$3ce1edebcff63bba$require$Buffer.isBuffer(iv)) iv = $3ce1edebcff63bba$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$3ce1edebcff63bba$var$DES.prototype._update = function(data) {
    return $3ce1edebcff63bba$require$Buffer.from(this._des.update(data));
};
$3ce1edebcff63bba$var$DES.prototype._final = function() {
    return $3ce1edebcff63bba$require$Buffer.from(this._des.final());
};

});
parcelRegister("lCSZA", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $fbe7cdeec3c8acd6$export$cc8859615686b300; }, function (v) { return $fbe7cdeec3c8acd6$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $fbe7cdeec3c8acd6$export$8ad3f227af08fcc5; }, function (v) { return $fbe7cdeec3c8acd6$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $fbe7cdeec3c8acd6$export$947646e34766044f; }, function (v) { return $fbe7cdeec3c8acd6$export$947646e34766044f = v; });
var $fbe7cdeec3c8acd6$export$eab97d15b1788b8d;
var $fbe7cdeec3c8acd6$export$26e5786e8ac8e530;
var $fbe7cdeec3c8acd6$export$cc8859615686b300;
var $fbe7cdeec3c8acd6$export$8ad3f227af08fcc5;
var $fbe7cdeec3c8acd6$export$947646e34766044f;
'use strict';

$fbe7cdeec3c8acd6$export$eab97d15b1788b8d = (parcelRequire("amxhE"));

$fbe7cdeec3c8acd6$export$26e5786e8ac8e530 = (parcelRequire("aAaZT"));

$fbe7cdeec3c8acd6$export$cc8859615686b300 = (parcelRequire("lbpyh"));

$fbe7cdeec3c8acd6$export$8ad3f227af08fcc5 = (parcelRequire("4KVAb"));

$fbe7cdeec3c8acd6$export$947646e34766044f = (parcelRequire("ipB6Y"));

});
parcelRegister("amxhE", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $78b5c6e404207be9$export$cfaef8ed399428b0; }, function (v) { return $78b5c6e404207be9$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $78b5c6e404207be9$export$a80c7deaea7cbd80; }, function (v) { return $78b5c6e404207be9$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $78b5c6e404207be9$export$ed7577ae6e1cd0ef; }, function (v) { return $78b5c6e404207be9$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $78b5c6e404207be9$export$5dcbef3aa594f567; }, function (v) { return $78b5c6e404207be9$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $78b5c6e404207be9$export$5bc8001ca71ed9c5; }, function (v) { return $78b5c6e404207be9$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $78b5c6e404207be9$export$3e714e2c5d5d8cb2; }, function (v) { return $78b5c6e404207be9$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $78b5c6e404207be9$export$94c3e544fd062b7f; }, function (v) { return $78b5c6e404207be9$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $78b5c6e404207be9$export$9f77e0932fb78f72; }, function (v) { return $78b5c6e404207be9$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $78b5c6e404207be9$export$d865ce2836f5927f; }, function (v) { return $78b5c6e404207be9$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $78b5c6e404207be9$export$95e62ad65da8b7d2; }, function (v) { return $78b5c6e404207be9$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $78b5c6e404207be9$export$209139ff098c441a; }, function (v) { return $78b5c6e404207be9$export$209139ff098c441a = v; });
var $78b5c6e404207be9$export$cfaef8ed399428b0;
var $78b5c6e404207be9$export$a80c7deaea7cbd80;
var $78b5c6e404207be9$export$ed7577ae6e1cd0ef;
var $78b5c6e404207be9$export$5dcbef3aa594f567;
var $78b5c6e404207be9$export$5bc8001ca71ed9c5;
var $78b5c6e404207be9$export$3e714e2c5d5d8cb2;
var $78b5c6e404207be9$export$94c3e544fd062b7f;
var $78b5c6e404207be9$export$9f77e0932fb78f72;
var $78b5c6e404207be9$export$d865ce2836f5927f;
var $78b5c6e404207be9$export$95e62ad65da8b7d2;
var $78b5c6e404207be9$export$209139ff098c441a;
'use strict';
$78b5c6e404207be9$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$78b5c6e404207be9$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$78b5c6e404207be9$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $78b5c6e404207be9$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$78b5c6e404207be9$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $78b5c6e404207be9$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $78b5c6e404207be9$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $78b5c6e404207be9$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $78b5c6e404207be9$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $78b5c6e404207be9$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$78b5c6e404207be9$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $78b5c6e404207be9$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $78b5c6e404207be9$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $78b5c6e404207be9$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$78b5c6e404207be9$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $78b5c6e404207be9$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $78b5c6e404207be9$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$78b5c6e404207be9$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("aAaZT", function(module, exports) {
'use strict';

var $aJt1P = parcelRequire("aJt1P");
function $7b45cbfb22d7466a$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $7b45cbfb22d7466a$var$Cipher;
$7b45cbfb22d7466a$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$7b45cbfb22d7466a$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$7b45cbfb22d7466a$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$7b45cbfb22d7466a$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$7b45cbfb22d7466a$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$7b45cbfb22d7466a$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$7b45cbfb22d7466a$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$7b45cbfb22d7466a$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$7b45cbfb22d7466a$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$7b45cbfb22d7466a$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$7b45cbfb22d7466a$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $aJt1P.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("aJt1P", function(module, exports) {
module.exports = $7d049fca35679f9f$var$assert;
function $7d049fca35679f9f$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$7d049fca35679f9f$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("lbpyh", function(module, exports) {
'use strict';

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");

var $amxhE = parcelRequire("amxhE");

var $aAaZT = parcelRequire("aAaZT");
function $f6be72270bafa6fd$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $f6be72270bafa6fd$var$DES(options) {
    $aAaZT.call(this, options);
    var state = new $f6be72270bafa6fd$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$eSHUL($f6be72270bafa6fd$var$DES, $aAaZT);
module.exports = $f6be72270bafa6fd$var$DES;
$f6be72270bafa6fd$var$DES.create = function create(options) {
    return new $f6be72270bafa6fd$var$DES(options);
};
var $f6be72270bafa6fd$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$f6be72270bafa6fd$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $aJt1P.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $amxhE.readUInt32BE(key, 0);
    var kR = $amxhE.readUInt32BE(key, 4);
    $amxhE.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $f6be72270bafa6fd$var$shiftTable[i >>> 1];
        kL = $amxhE.r28shl(kL, shift);
        kR = $amxhE.r28shl(kR, shift);
        $amxhE.pc2(kL, kR, state.keys, i);
    }
};
$f6be72270bafa6fd$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $amxhE.readUInt32BE(inp, inOff);
    var r = $amxhE.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $amxhE.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $amxhE.writeUInt32BE(out, l, outOff);
    $amxhE.writeUInt32BE(out, r, outOff + 4);
};
$f6be72270bafa6fd$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$f6be72270bafa6fd$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$aJt1P.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$f6be72270bafa6fd$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $amxhE.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $amxhE.substitute(keyL, keyR);
        var f = $amxhE.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $amxhE.rip(r, l, out, off);
};
$f6be72270bafa6fd$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $amxhE.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $amxhE.substitute(keyL, keyR);
        var f = $amxhE.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $amxhE.rip(l, r, out, off);
};

});

parcelRegister("4KVAb", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $37681ffc4c67db45$export$f9bb8d20ccc7477a; }, function (v) { return $37681ffc4c67db45$export$f9bb8d20ccc7477a = v; });
var $37681ffc4c67db45$export$f9bb8d20ccc7477a;
'use strict';

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");
var $37681ffc4c67db45$var$proto = {};
function $37681ffc4c67db45$var$CBCState(iv) {
    $aJt1P.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $37681ffc4c67db45$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $eSHUL(CBC, Base);
    var keys = Object.keys($37681ffc4c67db45$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $37681ffc4c67db45$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$37681ffc4c67db45$export$f9bb8d20ccc7477a = $37681ffc4c67db45$var$instantiate;
$37681ffc4c67db45$var$proto._cbcInit = function _cbcInit() {
    var state = new $37681ffc4c67db45$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$37681ffc4c67db45$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("ipB6Y", function(module, exports) {
'use strict';

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");

var $aAaZT = parcelRequire("aAaZT");

var $lbpyh = parcelRequire("lbpyh");
function $d677595fc0ef2155$var$EDEState(type, key) {
    $aJt1P.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $lbpyh.create({
            type: 'encrypt',
            key: k1
        }),
        $lbpyh.create({
            type: 'decrypt',
            key: k2
        }),
        $lbpyh.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $lbpyh.create({
            type: 'decrypt',
            key: k3
        }),
        $lbpyh.create({
            type: 'encrypt',
            key: k2
        }),
        $lbpyh.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $d677595fc0ef2155$var$EDE(options) {
    $aAaZT.call(this, options);
    var state = new $d677595fc0ef2155$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$eSHUL($d677595fc0ef2155$var$EDE, $aAaZT);
module.exports = $d677595fc0ef2155$var$EDE;
$d677595fc0ef2155$var$EDE.create = function create(options) {
    return new $d677595fc0ef2155$var$EDE(options);
};
$d677595fc0ef2155$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$d677595fc0ef2155$var$EDE.prototype._pad = $lbpyh.prototype._pad;
$d677595fc0ef2155$var$EDE.prototype._unpad = $lbpyh.prototype._unpad;

});



parcelRegister("k1gB1", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $e930c647c2b036f8$export$2f64596b8cbf08b4; }, function (v) { return $e930c647c2b036f8$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $e930c647c2b036f8$export$36b6d6ef312eab39; }, function (v) { return $e930c647c2b036f8$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $e930c647c2b036f8$export$58a258485f1e49f6; }, function (v) { return $e930c647c2b036f8$export$58a258485f1e49f6 = v; });
var $e930c647c2b036f8$export$bdd223f16383713e;
var $e930c647c2b036f8$export$26e5786e8ac8e530;
var $e930c647c2b036f8$export$2f64596b8cbf08b4;
var $e930c647c2b036f8$export$20533d26f07f1ee0;
var $e930c647c2b036f8$export$12ada9414fbc594c;
var $e930c647c2b036f8$export$2ce6d8d0e8b04e1a;
var $e930c647c2b036f8$export$36b6d6ef312eab39;
var $e930c647c2b036f8$export$f5e7e39d57cd9700;
var $e930c647c2b036f8$export$dedd8dc3dc62b370;
var $e930c647c2b036f8$export$58a258485f1e49f6;

var $5lUqw = parcelRequire("5lUqw");

var $gQor2 = parcelRequire("gQor2");

var $hPX1p = parcelRequire("hPX1p");
function $e930c647c2b036f8$var$getCiphers() {
    return Object.keys($hPX1p);
}
$e930c647c2b036f8$export$bdd223f16383713e = $e930c647c2b036f8$export$26e5786e8ac8e530 = $5lUqw.createCipher;
$e930c647c2b036f8$export$2f64596b8cbf08b4 = $e930c647c2b036f8$export$20533d26f07f1ee0 = $5lUqw.createCipheriv;
$e930c647c2b036f8$export$12ada9414fbc594c = $e930c647c2b036f8$export$2ce6d8d0e8b04e1a = $gQor2.createDecipher;
$e930c647c2b036f8$export$36b6d6ef312eab39 = $e930c647c2b036f8$export$f5e7e39d57cd9700 = $gQor2.createDecipheriv;
$e930c647c2b036f8$export$dedd8dc3dc62b370 = $e930c647c2b036f8$export$58a258485f1e49f6 = $e930c647c2b036f8$var$getCiphers;

});
parcelRegister("5lUqw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $3e5aaf1af369121b$export$2f64596b8cbf08b4; }, function (v) { return $3e5aaf1af369121b$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $3e5aaf1af369121b$export$bdd223f16383713e; }, function (v) { return $3e5aaf1af369121b$export$bdd223f16383713e = v; });
var $3e5aaf1af369121b$export$2f64596b8cbf08b4;
var $3e5aaf1af369121b$export$bdd223f16383713e;

var $saHx5 = parcelRequire("saHx5");

var $iEPe6 = parcelRequire("iEPe6");

var $6U9mG = parcelRequire("6U9mG");
var $3e5aaf1af369121b$require$Buffer = $6U9mG.Buffer;

var $aKCeN = parcelRequire("aKCeN");

var $fpHcA = parcelRequire("fpHcA");

var $4Nfih = parcelRequire("4Nfih");

var $5uIwM = parcelRequire("5uIwM");

var $eSHUL = parcelRequire("eSHUL");
function $3e5aaf1af369121b$var$Cipher(mode, key, iv) {
    $fpHcA.call(this);
    this._cache = new $3e5aaf1af369121b$var$Splitter();
    this._cipher = new $4Nfih.AES(key);
    this._prev = $3e5aaf1af369121b$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$eSHUL($3e5aaf1af369121b$var$Cipher, $fpHcA);
$3e5aaf1af369121b$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $3e5aaf1af369121b$require$Buffer.concat(out);
};
var $3e5aaf1af369121b$var$PADDING = $3e5aaf1af369121b$require$Buffer.alloc(16, 0x10);
$3e5aaf1af369121b$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($3e5aaf1af369121b$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$3e5aaf1af369121b$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $3e5aaf1af369121b$var$Splitter() {
    this.cache = $3e5aaf1af369121b$require$Buffer.allocUnsafe(0);
}
$3e5aaf1af369121b$var$Splitter.prototype.add = function(data) {
    this.cache = $3e5aaf1af369121b$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$3e5aaf1af369121b$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$3e5aaf1af369121b$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $3e5aaf1af369121b$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $3e5aaf1af369121b$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $3e5aaf1af369121b$var$createCipheriv(suite, password, iv) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $3e5aaf1af369121b$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $3e5aaf1af369121b$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $aKCeN(config.module, password, iv);
    else if (config.type === 'auth') return new $iEPe6(config.module, password, iv);
    return new $3e5aaf1af369121b$var$Cipher(config.module, password, iv);
}
function $3e5aaf1af369121b$var$createCipher(suite, password) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $5uIwM(password, false, config.key, config.iv);
    return $3e5aaf1af369121b$var$createCipheriv(suite, keys.key, keys.iv);
}
$3e5aaf1af369121b$export$2f64596b8cbf08b4 = $3e5aaf1af369121b$var$createCipheriv;
$3e5aaf1af369121b$export$bdd223f16383713e = $3e5aaf1af369121b$var$createCipher;

});
parcelRegister("saHx5", function(module, exports) {








var $054aeaa9bab312d6$var$modeModules = {
    ECB: (parcelRequire("l764o")),
    CBC: (parcelRequire("gXYn1")),
    CFB: (parcelRequire("UMnWk")),
    CFB8: (parcelRequire("00tcX")),
    CFB1: (parcelRequire("6r7x9")),
    OFB: (parcelRequire("anS7G")),
    CTR: (parcelRequire("1z9Wt")),
    GCM: (parcelRequire("1z9Wt"))
};

var $hPX1p = parcelRequire("hPX1p");
for(var $054aeaa9bab312d6$var$key in $hPX1p)$hPX1p[$054aeaa9bab312d6$var$key].module = $054aeaa9bab312d6$var$modeModules[$hPX1p[$054aeaa9bab312d6$var$key].mode];
module.exports = $hPX1p;

});
parcelRegister("l764o", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $f5eef5c6e22a602a$export$5b0f6292f11d1d18; }, function (v) { return $f5eef5c6e22a602a$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $f5eef5c6e22a602a$export$e85a0c9a1067c5d3; }, function (v) { return $f5eef5c6e22a602a$export$e85a0c9a1067c5d3 = v; });
var $f5eef5c6e22a602a$export$5b0f6292f11d1d18;
var $f5eef5c6e22a602a$export$e85a0c9a1067c5d3;
$f5eef5c6e22a602a$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$f5eef5c6e22a602a$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("gXYn1", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $c5a0fc56dc7b26c3$export$5b0f6292f11d1d18; }, function (v) { return $c5a0fc56dc7b26c3$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3; }, function (v) { return $c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3 = v; });
var $c5a0fc56dc7b26c3$export$5b0f6292f11d1d18;
var $c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3;

var $fDcjW = parcelRequire("fDcjW");
$c5a0fc56dc7b26c3$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $fDcjW(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $fDcjW(out, pad);
};

});
parcelRegister("fDcjW", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $b6140e2d47be3780$require$Buffer = $ihoyg.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $b6140e2d47be3780$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("UMnWk", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $0aaac35ae317ce1a$export$5b0f6292f11d1d18; }, function (v) { return $0aaac35ae317ce1a$export$5b0f6292f11d1d18 = v; });
var $0aaac35ae317ce1a$export$5b0f6292f11d1d18;

var $6U9mG = parcelRequire("6U9mG");
var $0aaac35ae317ce1a$require$Buffer = $6U9mG.Buffer;

var $fDcjW = parcelRequire("fDcjW");
function $0aaac35ae317ce1a$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $fDcjW(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $0aaac35ae317ce1a$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$0aaac35ae317ce1a$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $0aaac35ae317ce1a$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $0aaac35ae317ce1a$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $0aaac35ae317ce1a$require$Buffer.concat([
                out,
                $0aaac35ae317ce1a$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $0aaac35ae317ce1a$require$Buffer.concat([
                out,
                $0aaac35ae317ce1a$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("00tcX", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $00005d8db091e94d$export$5b0f6292f11d1d18; }, function (v) { return $00005d8db091e94d$export$5b0f6292f11d1d18 = v; });
var $00005d8db091e94d$export$5b0f6292f11d1d18;

var $6U9mG = parcelRequire("6U9mG");
var $00005d8db091e94d$require$Buffer = $6U9mG.Buffer;
function $00005d8db091e94d$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00005d8db091e94d$require$Buffer.concat([
        self._prev.slice(1),
        $00005d8db091e94d$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00005d8db091e94d$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00005d8db091e94d$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00005d8db091e94d$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("6r7x9", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $4afb1bbda820b619$export$5b0f6292f11d1d18; }, function (v) { return $4afb1bbda820b619$export$5b0f6292f11d1d18 = v; });
var $4afb1bbda820b619$export$5b0f6292f11d1d18;

var $6U9mG = parcelRequire("6U9mG");
var $4afb1bbda820b619$require$Buffer = $6U9mG.Buffer;
function $4afb1bbda820b619$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $4afb1bbda820b619$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $4afb1bbda820b619$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $4afb1bbda820b619$require$Buffer.allocUnsafe(buffer.length);
    buffer = $4afb1bbda820b619$require$Buffer.concat([
        buffer,
        $4afb1bbda820b619$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$4afb1bbda820b619$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $4afb1bbda820b619$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $4afb1bbda820b619$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("anS7G", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $78f6090cb273111f$export$5b0f6292f11d1d18; }, function (v) { return $78f6090cb273111f$export$5b0f6292f11d1d18 = v; });
var $78f6090cb273111f$export$5b0f6292f11d1d18;

var $ihoyg = parcelRequire("ihoyg");
var $78f6090cb273111f$require$Buffer = $ihoyg.Buffer;

var $fDcjW = parcelRequire("fDcjW");
function $78f6090cb273111f$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$78f6090cb273111f$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $78f6090cb273111f$require$Buffer.concat([
        self._cache,
        $78f6090cb273111f$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $fDcjW(chunk, pad);
};

});

parcelRegister("1z9Wt", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $1240c5a5b7a9d372$export$5b0f6292f11d1d18; }, function (v) { return $1240c5a5b7a9d372$export$5b0f6292f11d1d18 = v; });
var $1240c5a5b7a9d372$export$5b0f6292f11d1d18;

var $fDcjW = parcelRequire("fDcjW");

var $6U9mG = parcelRequire("6U9mG");
var $1240c5a5b7a9d372$require$Buffer = $6U9mG.Buffer;

var $b0v5s = parcelRequire("b0v5s");
function $1240c5a5b7a9d372$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $b0v5s(self._prev);
    return out;
}
var $1240c5a5b7a9d372$var$blockSize = 16;
$1240c5a5b7a9d372$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $1240c5a5b7a9d372$var$blockSize);
    var start = self._cache.length;
    self._cache = $1240c5a5b7a9d372$require$Buffer.concat([
        self._cache,
        $1240c5a5b7a9d372$require$Buffer.allocUnsafe(chunkNum * $1240c5a5b7a9d372$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $1240c5a5b7a9d372$var$getBlock(self);
        var offset = start + i * $1240c5a5b7a9d372$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $fDcjW(chunk, pad);
};

});
parcelRegister("b0v5s", function(module, exports) {
function $8037cf0dcb3400de$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $8037cf0dcb3400de$var$incr32;

});


parcelRegister("hPX1p", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("iEPe6", function(module, exports) {

var $4Nfih = parcelRequire("4Nfih");

var $6U9mG = parcelRequire("6U9mG");
var $d953b2ef02a1977a$require$Buffer = $6U9mG.Buffer;

var $fpHcA = parcelRequire("fpHcA");

var $eSHUL = parcelRequire("eSHUL");

var $eqhe5 = parcelRequire("eqhe5");

var $fDcjW = parcelRequire("fDcjW");

var $b0v5s = parcelRequire("b0v5s");
function $d953b2ef02a1977a$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $d953b2ef02a1977a$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $d953b2ef02a1977a$require$Buffer.concat([
            iv,
            $d953b2ef02a1977a$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $d953b2ef02a1977a$require$Buffer.concat([
            iv,
            $d953b2ef02a1977a$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $eqhe5(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($d953b2ef02a1977a$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($d953b2ef02a1977a$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $d953b2ef02a1977a$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $d953b2ef02a1977a$require$Buffer.from(self._finID);
    $b0v5s(out);
    return out;
}
function $d953b2ef02a1977a$var$StreamCipher(mode, key, iv, decrypt) {
    $fpHcA.call(this);
    var h = $d953b2ef02a1977a$require$Buffer.alloc(4, 0);
    this._cipher = new $4Nfih.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $eqhe5(ck);
    iv = $d953b2ef02a1977a$var$calcIv(this, iv, ck);
    this._prev = $d953b2ef02a1977a$require$Buffer.from(iv);
    this._cache = $d953b2ef02a1977a$require$Buffer.allocUnsafe(0);
    this._secCache = $d953b2ef02a1977a$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$eSHUL($d953b2ef02a1977a$var$StreamCipher, $fpHcA);
$d953b2ef02a1977a$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $d953b2ef02a1977a$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$d953b2ef02a1977a$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $fDcjW(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $d953b2ef02a1977a$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$d953b2ef02a1977a$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$d953b2ef02a1977a$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$d953b2ef02a1977a$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$d953b2ef02a1977a$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $d953b2ef02a1977a$var$StreamCipher;

});
parcelRegister("4Nfih", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $37d79a127135d0aa$export$b80fbe1c3a2b92b5; }, function (v) { return $37d79a127135d0aa$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $37d79a127135d0aa$export$b80fbe1c3a2b92b5;

var $6U9mG = parcelRequire("6U9mG");
var $37d79a127135d0aa$require$Buffer = $6U9mG.Buffer;
function $37d79a127135d0aa$var$asUInt32Array(buf) {
    if (!$37d79a127135d0aa$require$Buffer.isBuffer(buf)) buf = $37d79a127135d0aa$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $37d79a127135d0aa$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $37d79a127135d0aa$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $37d79a127135d0aa$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $37d79a127135d0aa$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $37d79a127135d0aa$var$AES(key) {
    this._key = $37d79a127135d0aa$var$asUInt32Array(key);
    this._reset();
}
$37d79a127135d0aa$var$AES.blockSize = 16;
$37d79a127135d0aa$var$AES.keySize = 32;
$37d79a127135d0aa$var$AES.prototype.blockSize = $37d79a127135d0aa$var$AES.blockSize;
$37d79a127135d0aa$var$AES.prototype.keySize = $37d79a127135d0aa$var$AES.keySize;
$37d79a127135d0aa$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $37d79a127135d0aa$var$G.SBOX[t >>> 24] << 24 | $37d79a127135d0aa$var$G.SBOX[t >>> 16 & 0xff] << 16 | $37d79a127135d0aa$var$G.SBOX[t >>> 8 & 0xff] << 8 | $37d79a127135d0aa$var$G.SBOX[t & 0xff];
            t ^= $37d79a127135d0aa$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $37d79a127135d0aa$var$G.SBOX[t >>> 24] << 24 | $37d79a127135d0aa$var$G.SBOX[t >>> 16 & 0xff] << 16 | $37d79a127135d0aa$var$G.SBOX[t >>> 8 & 0xff] << 8 | $37d79a127135d0aa$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $37d79a127135d0aa$var$G.INV_SUB_MIX[0][$37d79a127135d0aa$var$G.SBOX[tt >>> 24]] ^ $37d79a127135d0aa$var$G.INV_SUB_MIX[1][$37d79a127135d0aa$var$G.SBOX[tt >>> 16 & 0xff]] ^ $37d79a127135d0aa$var$G.INV_SUB_MIX[2][$37d79a127135d0aa$var$G.SBOX[tt >>> 8 & 0xff]] ^ $37d79a127135d0aa$var$G.INV_SUB_MIX[3][$37d79a127135d0aa$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$37d79a127135d0aa$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $37d79a127135d0aa$var$asUInt32Array(M);
    return $37d79a127135d0aa$var$cryptBlock(M, this._keySchedule, $37d79a127135d0aa$var$G.SUB_MIX, $37d79a127135d0aa$var$G.SBOX, this._nRounds);
};
$37d79a127135d0aa$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $37d79a127135d0aa$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$37d79a127135d0aa$var$AES.prototype.decryptBlock = function(M) {
    M = $37d79a127135d0aa$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $37d79a127135d0aa$var$cryptBlock(M, this._invKeySchedule, $37d79a127135d0aa$var$G.INV_SUB_MIX, $37d79a127135d0aa$var$G.INV_SBOX, this._nRounds);
    var buf = $37d79a127135d0aa$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$37d79a127135d0aa$var$AES.prototype.scrub = function() {
    $37d79a127135d0aa$var$scrubVec(this._keySchedule);
    $37d79a127135d0aa$var$scrubVec(this._invKeySchedule);
    $37d79a127135d0aa$var$scrubVec(this._key);
};
$37d79a127135d0aa$export$b80fbe1c3a2b92b5 = $37d79a127135d0aa$var$AES;

});

parcelRegister("eqhe5", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $a800db270fade44b$require$Buffer = $6U9mG.Buffer;
var $a800db270fade44b$var$ZEROES = $a800db270fade44b$require$Buffer.alloc(16, 0);
function $a800db270fade44b$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $a800db270fade44b$var$fromArray(out) {
    var buf = $a800db270fade44b$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $a800db270fade44b$var$GHASH(key) {
    this.h = key;
    this.state = $a800db270fade44b$require$Buffer.alloc(16, 0);
    this.cache = $a800db270fade44b$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$a800db270fade44b$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$a800db270fade44b$var$GHASH.prototype._multiply = function() {
    var Vi = $a800db270fade44b$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $a800db270fade44b$var$fromArray(Zi);
};
$a800db270fade44b$var$GHASH.prototype.update = function(buf) {
    this.cache = $a800db270fade44b$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$a800db270fade44b$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($a800db270fade44b$require$Buffer.concat([
        this.cache,
        $a800db270fade44b$var$ZEROES
    ], 16));
    this.ghash($a800db270fade44b$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $a800db270fade44b$var$GHASH;

});


parcelRegister("aKCeN", function(module, exports) {

var $4Nfih = parcelRequire("4Nfih");

var $6U9mG = parcelRequire("6U9mG");
var $7d3bdc7569c86a8c$require$Buffer = $6U9mG.Buffer;

var $fpHcA = parcelRequire("fpHcA");

var $eSHUL = parcelRequire("eSHUL");
function $7d3bdc7569c86a8c$var$StreamCipher(mode, key, iv, decrypt) {
    $fpHcA.call(this);
    this._cipher = new $4Nfih.AES(key);
    this._prev = $7d3bdc7569c86a8c$require$Buffer.from(iv);
    this._cache = $7d3bdc7569c86a8c$require$Buffer.allocUnsafe(0);
    this._secCache = $7d3bdc7569c86a8c$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$eSHUL($7d3bdc7569c86a8c$var$StreamCipher, $fpHcA);
$7d3bdc7569c86a8c$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$7d3bdc7569c86a8c$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $7d3bdc7569c86a8c$var$StreamCipher;

});

parcelRegister("5uIwM", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $40024b5f4411b288$require$Buffer = $6U9mG.Buffer;

var $cvCaQ = parcelRequire("cvCaQ");
/* eslint-disable camelcase */ function $40024b5f4411b288$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$40024b5f4411b288$require$Buffer.isBuffer(password)) password = $40024b5f4411b288$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$40024b5f4411b288$require$Buffer.isBuffer(salt)) salt = $40024b5f4411b288$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $40024b5f4411b288$require$Buffer.alloc(keyLen);
    var iv = $40024b5f4411b288$require$Buffer.alloc(ivLen || 0);
    var tmp = $40024b5f4411b288$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $cvCaQ();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $40024b5f4411b288$var$EVP_BytesToKey;

});


parcelRegister("gQor2", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $c43474f95c9fc530$export$12ada9414fbc594c; }, function (v) { return $c43474f95c9fc530$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $c43474f95c9fc530$export$36b6d6ef312eab39; }, function (v) { return $c43474f95c9fc530$export$36b6d6ef312eab39 = v; });
var $c43474f95c9fc530$export$12ada9414fbc594c;
var $c43474f95c9fc530$export$36b6d6ef312eab39;

var $iEPe6 = parcelRequire("iEPe6");

var $6U9mG = parcelRequire("6U9mG");
var $c43474f95c9fc530$require$Buffer = $6U9mG.Buffer;

var $saHx5 = parcelRequire("saHx5");

var $aKCeN = parcelRequire("aKCeN");

var $fpHcA = parcelRequire("fpHcA");

var $4Nfih = parcelRequire("4Nfih");

var $5uIwM = parcelRequire("5uIwM");

var $eSHUL = parcelRequire("eSHUL");
function $c43474f95c9fc530$var$Decipher(mode, key, iv) {
    $fpHcA.call(this);
    this._cache = new $c43474f95c9fc530$var$Splitter();
    this._last = void 0;
    this._cipher = new $4Nfih.AES(key);
    this._prev = $c43474f95c9fc530$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$eSHUL($c43474f95c9fc530$var$Decipher, $fpHcA);
$c43474f95c9fc530$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $c43474f95c9fc530$require$Buffer.concat(out);
};
$c43474f95c9fc530$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $c43474f95c9fc530$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$c43474f95c9fc530$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $c43474f95c9fc530$var$Splitter() {
    this.cache = $c43474f95c9fc530$require$Buffer.allocUnsafe(0);
}
$c43474f95c9fc530$var$Splitter.prototype.add = function(data) {
    this.cache = $c43474f95c9fc530$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$c43474f95c9fc530$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$c43474f95c9fc530$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $c43474f95c9fc530$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $c43474f95c9fc530$var$createDecipheriv(suite, password, iv) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $c43474f95c9fc530$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $c43474f95c9fc530$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $aKCeN(config.module, password, iv, true);
    else if (config.type === 'auth') return new $iEPe6(config.module, password, iv, true);
    return new $c43474f95c9fc530$var$Decipher(config.module, password, iv);
}
function $c43474f95c9fc530$var$createDecipher(suite, password) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $5uIwM(password, false, config.key, config.iv);
    return $c43474f95c9fc530$var$createDecipheriv(suite, keys.key, keys.iv);
}
$c43474f95c9fc530$export$12ada9414fbc594c = $c43474f95c9fc530$var$createDecipher;
$c43474f95c9fc530$export$36b6d6ef312eab39 = $c43474f95c9fc530$var$createDecipheriv;

});


parcelRegister("hqhSB", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $caf2bbe4b8db6f3b$export$116f8a5cee447347; }, function (v) { return $caf2bbe4b8db6f3b$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $caf2bbe4b8db6f3b$export$7483c4066bfb7ae9; }, function (v) { return $caf2bbe4b8db6f3b$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $caf2bbe4b8db6f3b$export$e7a565d2e588bb06; }, function (v) { return $caf2bbe4b8db6f3b$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8; }, function (v) { return $caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $caf2bbe4b8db6f3b$export$eba20568dde4ada; }, function (v) { return $caf2bbe4b8db6f3b$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $caf2bbe4b8db6f3b$export$d3b5e5996938f5ae; }, function (v) { return $caf2bbe4b8db6f3b$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $caf2bbe4b8db6f3b$export$57c08356130bc99b; }, function (v) { return $caf2bbe4b8db6f3b$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $caf2bbe4b8db6f3b$export$c7169791d5c1e65d; }, function (v) { return $caf2bbe4b8db6f3b$export$c7169791d5c1e65d = v; });
var $caf2bbe4b8db6f3b$export$116f8a5cee447347;
var $caf2bbe4b8db6f3b$export$7483c4066bfb7ae9;
var $caf2bbe4b8db6f3b$export$e7a565d2e588bb06;
var $caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8;
var $caf2bbe4b8db6f3b$export$eba20568dde4ada;
var $caf2bbe4b8db6f3b$export$d3b5e5996938f5ae;
var $caf2bbe4b8db6f3b$export$57c08356130bc99b;
var $caf2bbe4b8db6f3b$export$c7169791d5c1e65d;
$caf2bbe4b8db6f3b$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$caf2bbe4b8db6f3b$export$7483c4066bfb7ae9 = $caf2bbe4b8db6f3b$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8 = $caf2bbe4b8db6f3b$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$caf2bbe4b8db6f3b$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$caf2bbe4b8db6f3b$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$caf2bbe4b8db6f3b$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("4evoR", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $3150d39cd6c438f1$export$971862a2fcb1bb40; }, function (v) { return $3150d39cd6c438f1$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $3150d39cd6c438f1$export$c6ff6a88acbeaf40; }, function (v) { return $3150d39cd6c438f1$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $3150d39cd6c438f1$export$fdc27893e98845cc; }, function (v) { return $3150d39cd6c438f1$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $3150d39cd6c438f1$export$6671fb9a1323bed; }, function (v) { return $3150d39cd6c438f1$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $3150d39cd6c438f1$export$d74daf141a551db; }, function (v) { return $3150d39cd6c438f1$export$d74daf141a551db = v; });
var $3150d39cd6c438f1$export$971862a2fcb1bb40;
var $3150d39cd6c438f1$export$c6ff6a88acbeaf40;
var $3150d39cd6c438f1$export$fdc27893e98845cc;
var $3150d39cd6c438f1$export$6671fb9a1323bed;
var $3150d39cd6c438f1$export$d74daf141a551db;

var $ihoyg = parcelRequire("ihoyg");
var $3150d39cd6c438f1$require$Buffer = $ihoyg.Buffer;

var $lNmPw = parcelRequire("lNmPw");

var $fsr3h = parcelRequire("fsr3h");

var $2kgCI = parcelRequire("2kgCI");
function $3150d39cd6c438f1$var$getDiffieHellman(mod) {
    var prime = new $3150d39cd6c438f1$require$Buffer($fsr3h[mod].prime, 'hex');
    var gen = new $3150d39cd6c438f1$require$Buffer($fsr3h[mod].gen, 'hex');
    return new $2kgCI(prime, gen);
}
var $3150d39cd6c438f1$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $3150d39cd6c438f1$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($3150d39cd6c438f1$require$Buffer.isBuffer(enc) || $3150d39cd6c438f1$var$ENCODINGS[enc] === undefined) return $3150d39cd6c438f1$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $3150d39cd6c438f1$require$Buffer([
        2
    ]);
    if (!$3150d39cd6c438f1$require$Buffer.isBuffer(generator)) generator = new $3150d39cd6c438f1$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $2kgCI($lNmPw(prime, generator), generator, true);
    if (!$3150d39cd6c438f1$require$Buffer.isBuffer(prime)) prime = new $3150d39cd6c438f1$require$Buffer(prime, enc);
    return new $2kgCI(prime, generator, true);
}
$3150d39cd6c438f1$export$971862a2fcb1bb40 = $3150d39cd6c438f1$export$c6ff6a88acbeaf40 = $3150d39cd6c438f1$export$fdc27893e98845cc = $3150d39cd6c438f1$var$getDiffieHellman;
$3150d39cd6c438f1$export$6671fb9a1323bed = $3150d39cd6c438f1$export$d74daf141a551db = $3150d39cd6c438f1$var$createDiffieHellman;

});
parcelRegister("lNmPw", function(module, exports) {

var $5rfiH = parcelRequire("5rfiH");
module.exports = $fddfe224e234e046$var$findPrime;
$fddfe224e234e046$var$findPrime.simpleSieve = $fddfe224e234e046$var$simpleSieve;
$fddfe224e234e046$var$findPrime.fermatTest = $fddfe224e234e046$var$fermatTest;

var $5P1Ui = parcelRequire("5P1Ui");
var $fddfe224e234e046$var$TWENTYFOUR = new $5P1Ui(24);

var $4hcaz = parcelRequire("4hcaz");
var $fddfe224e234e046$var$millerRabin = new $4hcaz();
var $fddfe224e234e046$var$ONE = new $5P1Ui(1);
var $fddfe224e234e046$var$TWO = new $5P1Ui(2);
var $fddfe224e234e046$var$FIVE = new $5P1Ui(5);
var $fddfe224e234e046$var$SIXTEEN = new $5P1Ui(16);
var $fddfe224e234e046$var$EIGHT = new $5P1Ui(8);
var $fddfe224e234e046$var$TEN = new $5P1Ui(10);
var $fddfe224e234e046$var$THREE = new $5P1Ui(3);
var $fddfe224e234e046$var$SEVEN = new $5P1Ui(7);
var $fddfe224e234e046$var$ELEVEN = new $5P1Ui(11);
var $fddfe224e234e046$var$FOUR = new $5P1Ui(4);
var $fddfe224e234e046$var$TWELVE = new $5P1Ui(12);
var $fddfe224e234e046$var$primes = null;
function $fddfe224e234e046$var$_getPrimes() {
    if ($fddfe224e234e046$var$primes !== null) return $fddfe224e234e046$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $fddfe224e234e046$var$primes = res;
    return res;
}
function $fddfe224e234e046$var$simpleSieve(p) {
    var primes = $fddfe224e234e046$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $fddfe224e234e046$var$fermatTest(p) {
    var red = $5P1Ui.mont(p);
    return $fddfe224e234e046$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $fddfe224e234e046$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $5P1Ui([
            0x8c,
            0x7b
        ]);
        else return new $5P1Ui([
            0x8c,
            0x27
        ]);
    }
    gen = new $5P1Ui(gen);
    var num, n2;
    while(true){
        num = new $5P1Ui($5rfiH(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($fddfe224e234e046$var$ONE);
        if (!num.testn(1)) num.iadd($fddfe224e234e046$var$TWO);
        if (!gen.cmp($fddfe224e234e046$var$TWO)) while(num.mod($fddfe224e234e046$var$TWENTYFOUR).cmp($fddfe224e234e046$var$ELEVEN))num.iadd($fddfe224e234e046$var$FOUR);
        else if (!gen.cmp($fddfe224e234e046$var$FIVE)) while(num.mod($fddfe224e234e046$var$TEN).cmp($fddfe224e234e046$var$THREE))num.iadd($fddfe224e234e046$var$FOUR);
        n2 = num.shrn(1);
        if ($fddfe224e234e046$var$simpleSieve(n2) && $fddfe224e234e046$var$simpleSieve(num) && $fddfe224e234e046$var$fermatTest(n2) && $fddfe224e234e046$var$fermatTest(num) && $fddfe224e234e046$var$millerRabin.test(n2) && $fddfe224e234e046$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("5P1Ui", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4hcaz", function(module, exports) {

var $dK6jB = parcelRequire("dK6jB");

var $9JRha = parcelRequire("9JRha");
function $31d2308cd740d826$var$MillerRabin(rand) {
    this.rand = rand || new $9JRha.Rand();
}
module.exports = $31d2308cd740d826$var$MillerRabin;
$31d2308cd740d826$var$MillerRabin.create = function create(rand) {
    return new $31d2308cd740d826$var$MillerRabin(rand);
};
$31d2308cd740d826$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $dK6jB(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$31d2308cd740d826$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$31d2308cd740d826$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $dK6jB.mont(n);
    var rone = new $dK6jB(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $dK6jB(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$31d2308cd740d826$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $dK6jB.mont(n);
    var rone = new $dK6jB(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $dK6jB(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("dK6jB", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("9JRha", function(module, exports) {
var $7171a486633c2eed$var$r;
module.exports = function rand(len) {
    if (!$7171a486633c2eed$var$r) $7171a486633c2eed$var$r = new $7171a486633c2eed$var$Rand(null);
    return $7171a486633c2eed$var$r.generate(len);
};
function $7171a486633c2eed$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $7171a486633c2eed$var$Rand;
$7171a486633c2eed$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $7171a486633c2eed$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $7171a486633c2eed$var$crypto = (parcelRequire("5Io6y"));
    if (typeof $7171a486633c2eed$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        return $7171a486633c2eed$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("fsr3h", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("2kgCI", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $1b1a581faa6d58f2$require$Buffer = $ihoyg.Buffer;

var $5P1Ui = parcelRequire("5P1Ui");

var $4hcaz = parcelRequire("4hcaz");
var $1b1a581faa6d58f2$var$millerRabin = new $4hcaz();
var $1b1a581faa6d58f2$var$TWENTYFOUR = new $5P1Ui(24);
var $1b1a581faa6d58f2$var$ELEVEN = new $5P1Ui(11);
var $1b1a581faa6d58f2$var$TEN = new $5P1Ui(10);
var $1b1a581faa6d58f2$var$THREE = new $5P1Ui(3);
var $1b1a581faa6d58f2$var$SEVEN = new $5P1Ui(7);

var $lNmPw = parcelRequire("lNmPw");

var $5rfiH = parcelRequire("5rfiH");
module.exports = $1b1a581faa6d58f2$var$DH;
function $1b1a581faa6d58f2$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$1b1a581faa6d58f2$require$Buffer.isBuffer(pub)) pub = new $1b1a581faa6d58f2$require$Buffer(pub, enc);
    this._pub = new $5P1Ui(pub);
    return this;
}
function $1b1a581faa6d58f2$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$1b1a581faa6d58f2$require$Buffer.isBuffer(priv)) priv = new $1b1a581faa6d58f2$require$Buffer(priv, enc);
    this._priv = new $5P1Ui(priv);
    return this;
}
var $1b1a581faa6d58f2$var$primeCache = {};
function $1b1a581faa6d58f2$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $1b1a581faa6d58f2$var$primeCache) return $1b1a581faa6d58f2$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$lNmPw.simpleSieve || !$lNmPw.fermatTest(prime) || !$1b1a581faa6d58f2$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $1b1a581faa6d58f2$var$primeCache[hex] = error;
        return error;
    }
    if (!$1b1a581faa6d58f2$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($1b1a581faa6d58f2$var$TWENTYFOUR).cmp($1b1a581faa6d58f2$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($1b1a581faa6d58f2$var$TEN);
            if (rem.cmp($1b1a581faa6d58f2$var$THREE) && rem.cmp($1b1a581faa6d58f2$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $1b1a581faa6d58f2$var$primeCache[hex] = error;
    return error;
}
function $1b1a581faa6d58f2$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $5P1Ui(prime);
    this._prime = $5P1Ui.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $1b1a581faa6d58f2$var$setPublicKey;
        this.setPrivateKey = $1b1a581faa6d58f2$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($1b1a581faa6d58f2$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $1b1a581faa6d58f2$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$1b1a581faa6d58f2$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $5P1Ui($5rfiH(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$1b1a581faa6d58f2$var$DH.prototype.computeSecret = function(other) {
    other = new $5P1Ui(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $1b1a581faa6d58f2$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $1b1a581faa6d58f2$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $1b1a581faa6d58f2$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$1b1a581faa6d58f2$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this._pub, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this._priv, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.getPrime = function(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this.__prime, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.getGenerator = function(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this._gen, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$1b1a581faa6d58f2$require$Buffer.isBuffer(gen)) gen = new $1b1a581faa6d58f2$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $5P1Ui(gen);
    return this;
};
function $1b1a581faa6d58f2$var$formatReturnValue(bn, enc) {
    var buf = new $1b1a581faa6d58f2$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("bOCXe", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $89a294bd7a4a7e9a$require$Buffer = $6U9mG.Buffer;

var $3FiLE = parcelRequire("3FiLE");

var $9AddZ = parcelRequire("9AddZ");

var $eSHUL = parcelRequire("eSHUL");

var $ar1Lb = parcelRequire("ar1Lb");

var $eri43 = parcelRequire("eri43");

var $jdVex = parcelRequire("jdVex");
Object.keys($jdVex).forEach(function(key) {
    $jdVex[key].id = $89a294bd7a4a7e9a$require$Buffer.from($jdVex[key].id, 'hex');
    $jdVex[key.toLowerCase()] = $jdVex[key];
});
function $89a294bd7a4a7e9a$var$Sign(algorithm) {
    $9AddZ.Writable.call(this);
    var data = $jdVex[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $3FiLE(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$eSHUL($89a294bd7a4a7e9a$var$Sign, $9AddZ.Writable);
$89a294bd7a4a7e9a$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$89a294bd7a4a7e9a$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $89a294bd7a4a7e9a$require$Buffer.from(data, enc) : data);
    return this;
};
$89a294bd7a4a7e9a$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $ar1Lb(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $89a294bd7a4a7e9a$var$Verify(algorithm) {
    $9AddZ.Writable.call(this);
    var data = $jdVex[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $3FiLE(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$eSHUL($89a294bd7a4a7e9a$var$Verify, $9AddZ.Writable);
$89a294bd7a4a7e9a$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$89a294bd7a4a7e9a$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $89a294bd7a4a7e9a$require$Buffer.from(data, enc) : data);
    return this;
};
$89a294bd7a4a7e9a$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $89a294bd7a4a7e9a$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $eri43(sigBuffer, hash, key, this._signType, this._tag);
};
function $89a294bd7a4a7e9a$var$createSign(algorithm) {
    return new $89a294bd7a4a7e9a$var$Sign(algorithm);
}
function $89a294bd7a4a7e9a$var$createVerify(algorithm) {
    return new $89a294bd7a4a7e9a$var$Verify(algorithm);
}
module.exports = {
    Sign: $89a294bd7a4a7e9a$var$createSign,
    Verify: $89a294bd7a4a7e9a$var$createVerify,
    createSign: $89a294bd7a4a7e9a$var$createSign,
    createVerify: $89a294bd7a4a7e9a$var$createVerify
};

});
parcelRegister("ar1Lb", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $798dca7f522a1f11$require$Buffer = $6U9mG.Buffer;

var $cUvgf = parcelRequire("cUvgf");

var $hG1cM = parcelRequire("hG1cM");

var $8J1ou = parcelRequire("8J1ou");
var $798dca7f522a1f11$require$EC = $8J1ou.ec;

var $7vYz3 = parcelRequire("7vYz3");

var $579Op = parcelRequire("579Op");

var $i66tY = parcelRequire("i66tY");
var $798dca7f522a1f11$var$RSA_PKCS1_PADDING = 1;
function $798dca7f522a1f11$var$sign(hash, key, hashType, signType, tag) {
    var priv = $579Op(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $798dca7f522a1f11$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $798dca7f522a1f11$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $798dca7f522a1f11$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $798dca7f522a1f11$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $hG1cM(pad, priv);
    return out;
}
function $798dca7f522a1f11$var$ecSign(hash, priv) {
    var curveId = $i66tY[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $798dca7f522a1f11$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $798dca7f522a1f11$require$Buffer.from(out.toDER());
}
function $798dca7f522a1f11$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $7vYz3(0);
    var k;
    var H = $798dca7f522a1f11$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $798dca7f522a1f11$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $798dca7f522a1f11$var$makeKey(q, kv, algo);
        r = $798dca7f522a1f11$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $7vYz3(0);
        }
    }
    return $798dca7f522a1f11$var$toDER(r, s);
}
function $798dca7f522a1f11$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $798dca7f522a1f11$require$Buffer.from(res);
}
function $798dca7f522a1f11$var$getKey(x, q, hash, algo) {
    x = $798dca7f522a1f11$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $798dca7f522a1f11$require$Buffer.alloc(q.byteLength() - x.length);
        x = $798dca7f522a1f11$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $798dca7f522a1f11$var$bits2octets(hash, q);
    var v = $798dca7f522a1f11$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $798dca7f522a1f11$require$Buffer.alloc(hlen);
    k = $cUvgf(algo, k).update(v).update($798dca7f522a1f11$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $cUvgf(algo, k).update(v).digest();
    k = $cUvgf(algo, k).update(v).update($798dca7f522a1f11$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $cUvgf(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $798dca7f522a1f11$var$bits2int(obits, q) {
    var bits = new $7vYz3(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $798dca7f522a1f11$var$bits2octets(bits, q) {
    bits = $798dca7f522a1f11$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $798dca7f522a1f11$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $798dca7f522a1f11$require$Buffer.alloc(q.byteLength() - out.length);
        out = $798dca7f522a1f11$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $798dca7f522a1f11$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $798dca7f522a1f11$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $cUvgf(algo, kv.k).update(kv.v).digest();
            t = $798dca7f522a1f11$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $798dca7f522a1f11$var$bits2int(t, q);
        kv.k = $cUvgf(algo, kv.k).update(kv.v).update($798dca7f522a1f11$require$Buffer.from([
            0
        ])).digest();
        kv.v = $cUvgf(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $798dca7f522a1f11$var$makeR(g, k, p, q) {
    return g.toRed($7vYz3.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $798dca7f522a1f11$var$sign;
module.exports.getKey = $798dca7f522a1f11$var$getKey;
module.exports.makeKey = $798dca7f522a1f11$var$makeKey;

});
parcelRegister("hG1cM", function(module, exports) {
'use strict';

var $7vYz3 = parcelRequire("7vYz3");

var $5rfiH = parcelRequire("5rfiH");

var $6U9mG = parcelRequire("6U9mG");
var $03522ea20c8c4eb1$require$Buffer = $6U9mG.Buffer;
function $03522ea20c8c4eb1$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $7vYz3($5rfiH(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $03522ea20c8c4eb1$var$blind(priv) {
    var r = $03522ea20c8c4eb1$var$getr(priv);
    var blinder = r.toRed($7vYz3.mont(priv.modulus)).redPow(new $7vYz3(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $03522ea20c8c4eb1$var$crt(msg, priv) {
    var blinds = $03522ea20c8c4eb1$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $7vYz3(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($7vYz3.mont(priv.prime1));
    var c2 = blinded.toRed($7vYz3.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($03522ea20c8c4eb1$require$Buffer, 'be', len);
}
$03522ea20c8c4eb1$var$crt.getr = $03522ea20c8c4eb1$var$getr;
module.exports = $03522ea20c8c4eb1$var$crt;

});
parcelRegister("7vYz3", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("8J1ou", function(module, exports) {
'use strict';
var $65a39b84537b61c7$var$elliptic = module.exports;

$65a39b84537b61c7$var$elliptic.version = (parcelRequire("jfwBV")).version;

$65a39b84537b61c7$var$elliptic.utils = (parcelRequire("ZdcNb"));

$65a39b84537b61c7$var$elliptic.rand = (parcelRequire("9JRha"));

$65a39b84537b61c7$var$elliptic.curve = (parcelRequire("fYJT3"));

$65a39b84537b61c7$var$elliptic.curves = (parcelRequire("hwVHR"));

// Protocols
$65a39b84537b61c7$var$elliptic.ec = (parcelRequire("9lW0h"));

$65a39b84537b61c7$var$elliptic.eddsa = (parcelRequire("96jZE"));

});
parcelRegister("jfwBV", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("ZdcNb", function(module, exports) {
'use strict';
var $0b7ff0ec21b47efd$var$utils = module.exports;

var $6soDQ = parcelRequire("6soDQ");

var $aJt1P = parcelRequire("aJt1P");

var $6J8qY = parcelRequire("6J8qY");
$0b7ff0ec21b47efd$var$utils.assert = $aJt1P;
$0b7ff0ec21b47efd$var$utils.toArray = $6J8qY.toArray;
$0b7ff0ec21b47efd$var$utils.zero2 = $6J8qY.zero2;
$0b7ff0ec21b47efd$var$utils.toHex = $6J8qY.toHex;
$0b7ff0ec21b47efd$var$utils.encode = $6J8qY.encode;
// Represent num in a w-NAF form
function $0b7ff0ec21b47efd$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$0b7ff0ec21b47efd$var$utils.getNAF = $0b7ff0ec21b47efd$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $0b7ff0ec21b47efd$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$0b7ff0ec21b47efd$var$utils.getJSF = $0b7ff0ec21b47efd$var$getJSF;
function $0b7ff0ec21b47efd$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$0b7ff0ec21b47efd$var$utils.cachedProperty = $0b7ff0ec21b47efd$var$cachedProperty;
function $0b7ff0ec21b47efd$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $0b7ff0ec21b47efd$var$utils.toArray(bytes, 'hex') : bytes;
}
$0b7ff0ec21b47efd$var$utils.parseBytes = $0b7ff0ec21b47efd$var$parseBytes;
function $0b7ff0ec21b47efd$var$intFromLE(bytes) {
    return new $6soDQ(bytes, 'hex', 'le');
}
$0b7ff0ec21b47efd$var$utils.intFromLE = $0b7ff0ec21b47efd$var$intFromLE;

});
parcelRegister("6soDQ", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("6J8qY", function(module, exports) {
'use strict';
var $4e5d7ce234b4cbb5$var$utils = module.exports;
function $4e5d7ce234b4cbb5$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$4e5d7ce234b4cbb5$var$utils.toArray = $4e5d7ce234b4cbb5$var$toArray;
function $4e5d7ce234b4cbb5$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$4e5d7ce234b4cbb5$var$utils.zero2 = $4e5d7ce234b4cbb5$var$zero2;
function $4e5d7ce234b4cbb5$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $4e5d7ce234b4cbb5$var$zero2(msg[i].toString(16));
    return res;
}
$4e5d7ce234b4cbb5$var$utils.toHex = $4e5d7ce234b4cbb5$var$toHex;
$4e5d7ce234b4cbb5$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $4e5d7ce234b4cbb5$var$toHex(arr);
    else return arr;
};

});


parcelRegister("fYJT3", function(module, exports) {
'use strict';
var $ba200dd58ee56ab1$var$curve = module.exports;

$ba200dd58ee56ab1$var$curve.base = (parcelRequire("1dHTG"));

$ba200dd58ee56ab1$var$curve.short = (parcelRequire("laKc8"));

$ba200dd58ee56ab1$var$curve.mont = (parcelRequire("3uGhx"));

$ba200dd58ee56ab1$var$curve.edwards = (parcelRequire("a0HUE"));

});
parcelRegister("1dHTG", function(module, exports) {
'use strict';

var $6soDQ = parcelRequire("6soDQ");

var $ZdcNb = parcelRequire("ZdcNb");
var $0e390e60fe847ab5$var$getNAF = $ZdcNb.getNAF;
var $0e390e60fe847ab5$var$getJSF = $ZdcNb.getJSF;
var $0e390e60fe847ab5$var$assert = $ZdcNb.assert;
function $0e390e60fe847ab5$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $6soDQ(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $6soDQ.red(conf.prime) : $6soDQ.mont(this.p);
    // Useful for many curves
    this.zero = new $6soDQ(0).toRed(this.red);
    this.one = new $6soDQ(1).toRed(this.red);
    this.two = new $6soDQ(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $6soDQ(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $0e390e60fe847ab5$var$BaseCurve;
$0e390e60fe847ab5$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$0e390e60fe847ab5$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$0e390e60fe847ab5$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $0e390e60fe847ab5$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $0e390e60fe847ab5$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$0e390e60fe847ab5$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $0e390e60fe847ab5$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $0e390e60fe847ab5$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$0e390e60fe847ab5$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $0e390e60fe847ab5$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $0e390e60fe847ab5$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $0e390e60fe847ab5$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $0e390e60fe847ab5$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$0e390e60fe847ab5$var$BaseCurve.BasePoint = $0e390e60fe847ab5$var$BasePoint;
$0e390e60fe847ab5$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$0e390e60fe847ab5$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$0e390e60fe847ab5$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $ZdcNb.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $0e390e60fe847ab5$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $0e390e60fe847ab5$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$0e390e60fe847ab5$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$0e390e60fe847ab5$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$0e390e60fe847ab5$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $ZdcNb.encode(this._encode(compact), enc);
};
$0e390e60fe847ab5$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$0e390e60fe847ab5$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$0e390e60fe847ab5$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$0e390e60fe847ab5$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$0e390e60fe847ab5$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$0e390e60fe847ab5$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("laKc8", function(module, exports) {
'use strict';

var $ZdcNb = parcelRequire("ZdcNb");

var $6soDQ = parcelRequire("6soDQ");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");
var $f69e5d783a5b036a$var$assert = $ZdcNb.assert;
function $f69e5d783a5b036a$var$ShortCurve(conf) {
    $1dHTG.call(this, 'short', conf);
    this.a = new $6soDQ(conf.a, 16).toRed(this.red);
    this.b = new $6soDQ(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$eSHUL($f69e5d783a5b036a$var$ShortCurve, $1dHTG);
module.exports = $f69e5d783a5b036a$var$ShortCurve;
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $6soDQ(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $6soDQ(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $f69e5d783a5b036a$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $6soDQ(vec.a, 16),
            b: new $6soDQ(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $6soDQ.mont(num);
    var tinv = new $6soDQ(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $6soDQ(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $6soDQ(1);
    var y1 = new $6soDQ(0);
    var x2 = new $6soDQ(0);
    var y2 = new $6soDQ(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$f69e5d783a5b036a$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$f69e5d783a5b036a$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $6soDQ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$f69e5d783a5b036a$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$f69e5d783a5b036a$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $f69e5d783a5b036a$var$Point(curve, x, y, isRed) {
    $1dHTG.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $6soDQ(x, 16);
        this.y = new $6soDQ(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$eSHUL($f69e5d783a5b036a$var$Point, $1dHTG.BasePoint);
$f69e5d783a5b036a$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $f69e5d783a5b036a$var$Point(this, x, y, isRed);
};
$f69e5d783a5b036a$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $f69e5d783a5b036a$var$Point.fromJSON(this, obj, red);
};
$f69e5d783a5b036a$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$f69e5d783a5b036a$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$f69e5d783a5b036a$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$f69e5d783a5b036a$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$f69e5d783a5b036a$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$f69e5d783a5b036a$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f69e5d783a5b036a$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f69e5d783a5b036a$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$f69e5d783a5b036a$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$f69e5d783a5b036a$var$Point.prototype.mul = function mul(k) {
    k = new $6soDQ(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$f69e5d783a5b036a$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$f69e5d783a5b036a$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$f69e5d783a5b036a$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$f69e5d783a5b036a$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$f69e5d783a5b036a$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $f69e5d783a5b036a$var$JPoint(curve, x, y, z) {
    $1dHTG.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $6soDQ(0);
    } else {
        this.x = new $6soDQ(x, 16);
        this.y = new $6soDQ(y, 16);
        this.z = new $6soDQ(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$eSHUL($f69e5d783a5b036a$var$JPoint, $1dHTG.BasePoint);
$f69e5d783a5b036a$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $f69e5d783a5b036a$var$JPoint(this, x, y, z);
};
$f69e5d783a5b036a$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$f69e5d783a5b036a$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$f69e5d783a5b036a$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$f69e5d783a5b036a$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$f69e5d783a5b036a$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $6soDQ(k, kbase);
    return this.curve._wnafMul(this, k);
};
$f69e5d783a5b036a$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$f69e5d783a5b036a$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$f69e5d783a5b036a$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$f69e5d783a5b036a$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("3uGhx", function(module, exports) {
'use strict';

var $6soDQ = parcelRequire("6soDQ");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");

var $ZdcNb = parcelRequire("ZdcNb");
function $28b4f8bfddf22eb4$var$MontCurve(conf) {
    $1dHTG.call(this, 'mont', conf);
    this.a = new $6soDQ(conf.a, 16).toRed(this.red);
    this.b = new $6soDQ(conf.b, 16).toRed(this.red);
    this.i4 = new $6soDQ(4).toRed(this.red).redInvm();
    this.two = new $6soDQ(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$eSHUL($28b4f8bfddf22eb4$var$MontCurve, $1dHTG);
module.exports = $28b4f8bfddf22eb4$var$MontCurve;
$28b4f8bfddf22eb4$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $28b4f8bfddf22eb4$var$Point(curve, x, z) {
    $1dHTG.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $6soDQ(x, 16);
        this.z = new $6soDQ(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$eSHUL($28b4f8bfddf22eb4$var$Point, $1dHTG.BasePoint);
$28b4f8bfddf22eb4$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($ZdcNb.toArray(bytes, enc), 1);
};
$28b4f8bfddf22eb4$var$MontCurve.prototype.point = function point(x, z) {
    return new $28b4f8bfddf22eb4$var$Point(this, x, z);
};
$28b4f8bfddf22eb4$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $28b4f8bfddf22eb4$var$Point.fromJSON(this, obj);
};
$28b4f8bfddf22eb4$var$Point.prototype.precompute = function precompute() {
// No-op
};
$28b4f8bfddf22eb4$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$28b4f8bfddf22eb4$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $28b4f8bfddf22eb4$var$Point(curve, obj[0], obj[1] || curve.one);
};
$28b4f8bfddf22eb4$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$28b4f8bfddf22eb4$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$28b4f8bfddf22eb4$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$28b4f8bfddf22eb4$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$28b4f8bfddf22eb4$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$28b4f8bfddf22eb4$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$28b4f8bfddf22eb4$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$28b4f8bfddf22eb4$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$28b4f8bfddf22eb4$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$28b4f8bfddf22eb4$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$28b4f8bfddf22eb4$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("a0HUE", function(module, exports) {
'use strict';

var $ZdcNb = parcelRequire("ZdcNb");

var $6soDQ = parcelRequire("6soDQ");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");
var $749bf799fac4284f$var$assert = $ZdcNb.assert;
function $749bf799fac4284f$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $1dHTG.call(this, 'edwards', conf);
    this.a = new $6soDQ(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $6soDQ(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $6soDQ(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $749bf799fac4284f$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$eSHUL($749bf799fac4284f$var$EdwardsCurve, $1dHTG);
module.exports = $749bf799fac4284f$var$EdwardsCurve;
$749bf799fac4284f$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$749bf799fac4284f$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$749bf799fac4284f$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $6soDQ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $6soDQ(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $749bf799fac4284f$var$Point(curve, x, y, z, t) {
    $1dHTG.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $6soDQ(x, 16);
        this.y = new $6soDQ(y, 16);
        this.z = z ? new $6soDQ(z, 16) : this.curve.one;
        this.t = t && new $6soDQ(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$eSHUL($749bf799fac4284f$var$Point, $1dHTG.BasePoint);
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $749bf799fac4284f$var$Point.fromJSON(this, obj);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $749bf799fac4284f$var$Point(this, x, y, z, t);
};
$749bf799fac4284f$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $749bf799fac4284f$var$Point(curve, obj[0], obj[1], obj[2]);
};
$749bf799fac4284f$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$749bf799fac4284f$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$749bf799fac4284f$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$749bf799fac4284f$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$749bf799fac4284f$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$749bf799fac4284f$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$749bf799fac4284f$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$749bf799fac4284f$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$749bf799fac4284f$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$749bf799fac4284f$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$749bf799fac4284f$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$749bf799fac4284f$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$749bf799fac4284f$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$749bf799fac4284f$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$749bf799fac4284f$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$749bf799fac4284f$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$749bf799fac4284f$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$749bf799fac4284f$var$Point.prototype.toP = $749bf799fac4284f$var$Point.prototype.normalize;
$749bf799fac4284f$var$Point.prototype.mixedAdd = $749bf799fac4284f$var$Point.prototype.add;

});


parcelRegister("hwVHR", function(module, exports) {
'use strict';
var $cc32301b3f482b8e$var$curves = module.exports;

var $leqJp = parcelRequire("leqJp");

var $fYJT3 = parcelRequire("fYJT3");

var $ZdcNb = parcelRequire("ZdcNb");
var $cc32301b3f482b8e$var$assert = $ZdcNb.assert;
function $cc32301b3f482b8e$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $fYJT3.short(options);
    else if (options.type === 'edwards') this.curve = new $fYJT3.edwards(options);
    else this.curve = new $fYJT3.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $cc32301b3f482b8e$var$assert(this.g.validate(), 'Invalid curve');
    $cc32301b3f482b8e$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$cc32301b3f482b8e$var$curves.PresetCurve = $cc32301b3f482b8e$var$PresetCurve;
function $cc32301b3f482b8e$var$defineCurve(name, options) {
    Object.defineProperty($cc32301b3f482b8e$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $cc32301b3f482b8e$var$PresetCurve(options);
            Object.defineProperty($cc32301b3f482b8e$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$cc32301b3f482b8e$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$cc32301b3f482b8e$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$cc32301b3f482b8e$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$cc32301b3f482b8e$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $leqJp.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$cc32301b3f482b8e$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $leqJp.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$cc32301b3f482b8e$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$cc32301b3f482b8e$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $cc32301b3f482b8e$var$pre;

try {
    $cc32301b3f482b8e$var$pre = (parcelRequire("63oZi"));
} catch (e) {
    $cc32301b3f482b8e$var$pre = undefined;
}
$cc32301b3f482b8e$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $leqJp.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $cc32301b3f482b8e$var$pre
    ]
});

});
parcelRegister("leqJp", function(module, exports) {
var $f74fa412f2053ea0$var$hash = module.exports;

$f74fa412f2053ea0$var$hash.utils = (parcelRequire("3vltz"));

$f74fa412f2053ea0$var$hash.common = (parcelRequire("hoO3s"));

$f74fa412f2053ea0$var$hash.sha = (parcelRequire("esJCG"));

$f74fa412f2053ea0$var$hash.ripemd = (parcelRequire("ak1PH"));

$f74fa412f2053ea0$var$hash.hmac = (parcelRequire("X5z30"));
// Proxy hash functions to the main object
$f74fa412f2053ea0$var$hash.sha1 = $f74fa412f2053ea0$var$hash.sha.sha1;
$f74fa412f2053ea0$var$hash.sha256 = $f74fa412f2053ea0$var$hash.sha.sha256;
$f74fa412f2053ea0$var$hash.sha224 = $f74fa412f2053ea0$var$hash.sha.sha224;
$f74fa412f2053ea0$var$hash.sha384 = $f74fa412f2053ea0$var$hash.sha.sha384;
$f74fa412f2053ea0$var$hash.sha512 = $f74fa412f2053ea0$var$hash.sha.sha512;
$f74fa412f2053ea0$var$hash.ripemd160 = $f74fa412f2053ea0$var$hash.ripemd.ripemd160;

});
parcelRegister("3vltz", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $28d4ed0635aac004$export$69f1b2dcda23c5f8; }, function (v) { return $28d4ed0635aac004$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $28d4ed0635aac004$export$45b10814cc054894; }, function (v) { return $28d4ed0635aac004$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $28d4ed0635aac004$export$7ea66e3774a60b67; }, function (v) { return $28d4ed0635aac004$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $28d4ed0635aac004$export$34a52f00f601f6f1; }, function (v) { return $28d4ed0635aac004$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $28d4ed0635aac004$export$812b0cbd5e8a72ab; }, function (v) { return $28d4ed0635aac004$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $28d4ed0635aac004$export$f24f9e11d63bb314; }, function (v) { return $28d4ed0635aac004$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $28d4ed0635aac004$export$b71357c7e07ca1f1; }, function (v) { return $28d4ed0635aac004$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $28d4ed0635aac004$export$2e58a4b541fdcbe8; }, function (v) { return $28d4ed0635aac004$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $28d4ed0635aac004$export$183b950bde9faab8; }, function (v) { return $28d4ed0635aac004$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $28d4ed0635aac004$export$4785c77169fea59e; }, function (v) { return $28d4ed0635aac004$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $28d4ed0635aac004$export$242a185dfcffac5b; }, function (v) { return $28d4ed0635aac004$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $28d4ed0635aac004$export$58c04ae0ae31877d; }, function (v) { return $28d4ed0635aac004$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $28d4ed0635aac004$export$d058ca695f8c6f11; }, function (v) { return $28d4ed0635aac004$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $28d4ed0635aac004$export$a1efd7fc3e986367; }, function (v) { return $28d4ed0635aac004$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $28d4ed0635aac004$export$bbfea4a2b5abaab4; }, function (v) { return $28d4ed0635aac004$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $28d4ed0635aac004$export$97ad4afc7de86152; }, function (v) { return $28d4ed0635aac004$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $28d4ed0635aac004$export$ce4673d9a79f6a4b; }, function (v) { return $28d4ed0635aac004$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $28d4ed0635aac004$export$786cc99fc6eedc0b; }, function (v) { return $28d4ed0635aac004$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $28d4ed0635aac004$export$45c59b9a1848dd0; }, function (v) { return $28d4ed0635aac004$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $28d4ed0635aac004$export$50d8f613e76d3034; }, function (v) { return $28d4ed0635aac004$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $28d4ed0635aac004$export$b8e83683c60ee162; }, function (v) { return $28d4ed0635aac004$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $28d4ed0635aac004$export$aeeb51790d1bcc4a; }, function (v) { return $28d4ed0635aac004$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $28d4ed0635aac004$export$bb7c616f719ad9c; }, function (v) { return $28d4ed0635aac004$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $28d4ed0635aac004$export$4d63290824f9d7df; }, function (v) { return $28d4ed0635aac004$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $28d4ed0635aac004$export$2f64ceb90ef28ea1; }, function (v) { return $28d4ed0635aac004$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $28d4ed0635aac004$export$8d2089d465f6d10d; }, function (v) { return $28d4ed0635aac004$export$8d2089d465f6d10d = v; });
var $28d4ed0635aac004$export$69f1b2dcda23c5f8;
var $28d4ed0635aac004$export$45b10814cc054894;
var $28d4ed0635aac004$export$7ea66e3774a60b67;
var $28d4ed0635aac004$export$34a52f00f601f6f1;
var $28d4ed0635aac004$export$812b0cbd5e8a72ab;
var $28d4ed0635aac004$export$f24f9e11d63bb314;
var $28d4ed0635aac004$export$b71357c7e07ca1f1;
var $28d4ed0635aac004$export$2e58a4b541fdcbe8;
var $28d4ed0635aac004$export$183b950bde9faab8;
var $28d4ed0635aac004$export$4785c77169fea59e;
var $28d4ed0635aac004$export$242a185dfcffac5b;
var $28d4ed0635aac004$export$58c04ae0ae31877d;
var $28d4ed0635aac004$export$d058ca695f8c6f11;
var $28d4ed0635aac004$export$a1efd7fc3e986367;
var $28d4ed0635aac004$export$bbfea4a2b5abaab4;
var $28d4ed0635aac004$export$97ad4afc7de86152;
var $28d4ed0635aac004$export$ce4673d9a79f6a4b;
var $28d4ed0635aac004$export$786cc99fc6eedc0b;
var $28d4ed0635aac004$export$45c59b9a1848dd0;
var $28d4ed0635aac004$export$50d8f613e76d3034;
var $28d4ed0635aac004$export$b8e83683c60ee162;
var $28d4ed0635aac004$export$aeeb51790d1bcc4a;
var $28d4ed0635aac004$export$bb7c616f719ad9c;
var $28d4ed0635aac004$export$4d63290824f9d7df;
var $28d4ed0635aac004$export$2f64ceb90ef28ea1;
var $28d4ed0635aac004$export$8d2089d465f6d10d;
'use strict';

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");
$28d4ed0635aac004$export$69f1b2dcda23c5f8 = $eSHUL;
function $28d4ed0635aac004$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $28d4ed0635aac004$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($28d4ed0635aac004$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$28d4ed0635aac004$export$45b10814cc054894 = $28d4ed0635aac004$var$toArray;
function $28d4ed0635aac004$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $28d4ed0635aac004$var$zero2(msg[i].toString(16));
    return res;
}
$28d4ed0635aac004$export$7ea66e3774a60b67 = $28d4ed0635aac004$var$toHex;
function $28d4ed0635aac004$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$28d4ed0635aac004$export$34a52f00f601f6f1 = $28d4ed0635aac004$var$htonl;
function $28d4ed0635aac004$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $28d4ed0635aac004$var$htonl(w);
        res += $28d4ed0635aac004$var$zero8(w.toString(16));
    }
    return res;
}
$28d4ed0635aac004$export$812b0cbd5e8a72ab = $28d4ed0635aac004$var$toHex32;
function $28d4ed0635aac004$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$28d4ed0635aac004$export$f24f9e11d63bb314 = $28d4ed0635aac004$var$zero2;
function $28d4ed0635aac004$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$28d4ed0635aac004$export$b71357c7e07ca1f1 = $28d4ed0635aac004$var$zero8;
function $28d4ed0635aac004$var$join32(msg, start, end, endian) {
    var len = end - start;
    $aJt1P(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$28d4ed0635aac004$export$2e58a4b541fdcbe8 = $28d4ed0635aac004$var$join32;
function $28d4ed0635aac004$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$28d4ed0635aac004$export$183b950bde9faab8 = $28d4ed0635aac004$var$split32;
function $28d4ed0635aac004$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$28d4ed0635aac004$export$4785c77169fea59e = $28d4ed0635aac004$var$rotr32;
function $28d4ed0635aac004$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$28d4ed0635aac004$export$242a185dfcffac5b = $28d4ed0635aac004$var$rotl32;
function $28d4ed0635aac004$var$sum32(a, b) {
    return a + b >>> 0;
}
$28d4ed0635aac004$export$58c04ae0ae31877d = $28d4ed0635aac004$var$sum32;
function $28d4ed0635aac004$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$28d4ed0635aac004$export$d058ca695f8c6f11 = $28d4ed0635aac004$var$sum32_3;
function $28d4ed0635aac004$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$28d4ed0635aac004$export$a1efd7fc3e986367 = $28d4ed0635aac004$var$sum32_4;
function $28d4ed0635aac004$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$28d4ed0635aac004$export$bbfea4a2b5abaab4 = $28d4ed0635aac004$var$sum32_5;
function $28d4ed0635aac004$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$28d4ed0635aac004$export$97ad4afc7de86152 = $28d4ed0635aac004$var$sum64;
function $28d4ed0635aac004$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$28d4ed0635aac004$export$ce4673d9a79f6a4b = $28d4ed0635aac004$var$sum64_hi;
function $28d4ed0635aac004$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$28d4ed0635aac004$export$786cc99fc6eedc0b = $28d4ed0635aac004$var$sum64_lo;
function $28d4ed0635aac004$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$28d4ed0635aac004$export$45c59b9a1848dd0 = $28d4ed0635aac004$var$sum64_4_hi;
function $28d4ed0635aac004$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$28d4ed0635aac004$export$50d8f613e76d3034 = $28d4ed0635aac004$var$sum64_4_lo;
function $28d4ed0635aac004$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$28d4ed0635aac004$export$b8e83683c60ee162 = $28d4ed0635aac004$var$sum64_5_hi;
function $28d4ed0635aac004$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$28d4ed0635aac004$export$aeeb51790d1bcc4a = $28d4ed0635aac004$var$sum64_5_lo;
function $28d4ed0635aac004$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$bb7c616f719ad9c = $28d4ed0635aac004$var$rotr64_hi;
function $28d4ed0635aac004$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$4d63290824f9d7df = $28d4ed0635aac004$var$rotr64_lo;
function $28d4ed0635aac004$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$28d4ed0635aac004$export$2f64ceb90ef28ea1 = $28d4ed0635aac004$var$shr64_hi;
function $28d4ed0635aac004$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$8d2089d465f6d10d = $28d4ed0635aac004$var$shr64_lo;

});

parcelRegister("hoO3s", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $caab81610dd48e7b$export$8687658379b577e6; }, function (v) { return $caab81610dd48e7b$export$8687658379b577e6 = v; });
var $caab81610dd48e7b$export$8687658379b577e6;
'use strict';

var $3vltz = parcelRequire("3vltz");

var $aJt1P = parcelRequire("aJt1P");
function $caab81610dd48e7b$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$caab81610dd48e7b$export$8687658379b577e6 = $caab81610dd48e7b$var$BlockHash;
$caab81610dd48e7b$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $3vltz.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $3vltz.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$caab81610dd48e7b$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $aJt1P(this.pending === null);
    return this._digest(enc);
};
$caab81610dd48e7b$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("esJCG", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $a87711fd35b0090f$export$5091bdda49ba90f5; }, function (v) { return $a87711fd35b0090f$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $a87711fd35b0090f$export$97b70509d4e397ea; }, function (v) { return $a87711fd35b0090f$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $a87711fd35b0090f$export$bced8d2aada2d1c9; }, function (v) { return $a87711fd35b0090f$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $a87711fd35b0090f$export$612d47d55dedde45; }, function (v) { return $a87711fd35b0090f$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $a87711fd35b0090f$export$a888d2532e6dc7bb; }, function (v) { return $a87711fd35b0090f$export$a888d2532e6dc7bb = v; });
var $a87711fd35b0090f$export$5091bdda49ba90f5;
var $a87711fd35b0090f$export$97b70509d4e397ea;
var $a87711fd35b0090f$export$bced8d2aada2d1c9;
var $a87711fd35b0090f$export$612d47d55dedde45;
var $a87711fd35b0090f$export$a888d2532e6dc7bb;
'use strict';

$a87711fd35b0090f$export$5091bdda49ba90f5 = (parcelRequire("4n9Qi"));

$a87711fd35b0090f$export$97b70509d4e397ea = (parcelRequire("2w2RS"));

$a87711fd35b0090f$export$bced8d2aada2d1c9 = (parcelRequire("6tl9X"));

$a87711fd35b0090f$export$612d47d55dedde45 = (parcelRequire("1zFKP"));

$a87711fd35b0090f$export$a888d2532e6dc7bb = (parcelRequire("b8Cnj"));

});
parcelRegister("4n9Qi", function(module, exports) {
'use strict';

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $7pXSD = parcelRequire("7pXSD");
var $32f0f1f12aa851fd$var$rotl32 = $3vltz.rotl32;
var $32f0f1f12aa851fd$var$sum32 = $3vltz.sum32;
var $32f0f1f12aa851fd$var$sum32_5 = $3vltz.sum32_5;
var $32f0f1f12aa851fd$var$ft_1 = $7pXSD.ft_1;
var $32f0f1f12aa851fd$var$BlockHash = $hoO3s.BlockHash;
var $32f0f1f12aa851fd$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $32f0f1f12aa851fd$var$SHA1() {
    if (!(this instanceof $32f0f1f12aa851fd$var$SHA1)) return new $32f0f1f12aa851fd$var$SHA1();
    $32f0f1f12aa851fd$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$3vltz.inherits($32f0f1f12aa851fd$var$SHA1, $32f0f1f12aa851fd$var$BlockHash);
module.exports = $32f0f1f12aa851fd$var$SHA1;
$32f0f1f12aa851fd$var$SHA1.blockSize = 512;
$32f0f1f12aa851fd$var$SHA1.outSize = 160;
$32f0f1f12aa851fd$var$SHA1.hmacStrength = 80;
$32f0f1f12aa851fd$var$SHA1.padLength = 64;
$32f0f1f12aa851fd$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $32f0f1f12aa851fd$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $32f0f1f12aa851fd$var$sum32_5($32f0f1f12aa851fd$var$rotl32(a, 5), $32f0f1f12aa851fd$var$ft_1(s, b, c, d), e, W[i], $32f0f1f12aa851fd$var$sha1_K[s]);
        e = d;
        d = c;
        c = $32f0f1f12aa851fd$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $32f0f1f12aa851fd$var$sum32(this.h[0], a);
    this.h[1] = $32f0f1f12aa851fd$var$sum32(this.h[1], b);
    this.h[2] = $32f0f1f12aa851fd$var$sum32(this.h[2], c);
    this.h[3] = $32f0f1f12aa851fd$var$sum32(this.h[3], d);
    this.h[4] = $32f0f1f12aa851fd$var$sum32(this.h[4], e);
};
$32f0f1f12aa851fd$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3vltz.toHex32(this.h, 'big');
    else return $3vltz.split32(this.h, 'big');
};

});
parcelRegister("7pXSD", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $5669512b21aa6962$export$5a92649d7ddb9f63; }, function (v) { return $5669512b21aa6962$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $5669512b21aa6962$export$c6d0d020c3a6269; }, function (v) { return $5669512b21aa6962$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $5669512b21aa6962$export$eb90c27fca05f956; }, function (v) { return $5669512b21aa6962$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $5669512b21aa6962$export$14a4a98e063b1999; }, function (v) { return $5669512b21aa6962$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $5669512b21aa6962$export$d20cecfa1564c686; }, function (v) { return $5669512b21aa6962$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $5669512b21aa6962$export$44fd472a12fc6db; }, function (v) { return $5669512b21aa6962$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $5669512b21aa6962$export$1ed238bb6ea1dd47; }, function (v) { return $5669512b21aa6962$export$1ed238bb6ea1dd47 = v; });
var $5669512b21aa6962$export$5a92649d7ddb9f63;
var $5669512b21aa6962$export$c6d0d020c3a6269;
var $5669512b21aa6962$export$eb90c27fca05f956;
var $5669512b21aa6962$export$cc992891a14496a1;
var $5669512b21aa6962$export$14a4a98e063b1999;
var $5669512b21aa6962$export$d20cecfa1564c686;
var $5669512b21aa6962$export$44fd472a12fc6db;
var $5669512b21aa6962$export$1ed238bb6ea1dd47;
'use strict';

var $3vltz = parcelRequire("3vltz");
var $5669512b21aa6962$var$rotr32 = $3vltz.rotr32;
function $5669512b21aa6962$var$ft_1(s, x, y, z) {
    if (s === 0) return $5669512b21aa6962$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $5669512b21aa6962$var$p32(x, y, z);
    if (s === 2) return $5669512b21aa6962$var$maj32(x, y, z);
}
$5669512b21aa6962$export$5a92649d7ddb9f63 = $5669512b21aa6962$var$ft_1;
function $5669512b21aa6962$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$5669512b21aa6962$export$c6d0d020c3a6269 = $5669512b21aa6962$var$ch32;
function $5669512b21aa6962$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$5669512b21aa6962$export$eb90c27fca05f956 = $5669512b21aa6962$var$maj32;
function $5669512b21aa6962$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$5669512b21aa6962$export$cc992891a14496a1 = $5669512b21aa6962$var$p32;
function $5669512b21aa6962$var$s0_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 2) ^ $5669512b21aa6962$var$rotr32(x, 13) ^ $5669512b21aa6962$var$rotr32(x, 22);
}
$5669512b21aa6962$export$14a4a98e063b1999 = $5669512b21aa6962$var$s0_256;
function $5669512b21aa6962$var$s1_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 6) ^ $5669512b21aa6962$var$rotr32(x, 11) ^ $5669512b21aa6962$var$rotr32(x, 25);
}
$5669512b21aa6962$export$d20cecfa1564c686 = $5669512b21aa6962$var$s1_256;
function $5669512b21aa6962$var$g0_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 7) ^ $5669512b21aa6962$var$rotr32(x, 18) ^ x >>> 3;
}
$5669512b21aa6962$export$44fd472a12fc6db = $5669512b21aa6962$var$g0_256;
function $5669512b21aa6962$var$g1_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 17) ^ $5669512b21aa6962$var$rotr32(x, 19) ^ x >>> 10;
}
$5669512b21aa6962$export$1ed238bb6ea1dd47 = $5669512b21aa6962$var$g1_256;

});


parcelRegister("2w2RS", function(module, exports) {
'use strict';

var $3vltz = parcelRequire("3vltz");

var $6tl9X = parcelRequire("6tl9X");
function $1d50cb6dff0ac7e1$var$SHA224() {
    if (!(this instanceof $1d50cb6dff0ac7e1$var$SHA224)) return new $1d50cb6dff0ac7e1$var$SHA224();
    $6tl9X.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$3vltz.inherits($1d50cb6dff0ac7e1$var$SHA224, $6tl9X);
module.exports = $1d50cb6dff0ac7e1$var$SHA224;
$1d50cb6dff0ac7e1$var$SHA224.blockSize = 512;
$1d50cb6dff0ac7e1$var$SHA224.outSize = 224;
$1d50cb6dff0ac7e1$var$SHA224.hmacStrength = 192;
$1d50cb6dff0ac7e1$var$SHA224.padLength = 64;
$1d50cb6dff0ac7e1$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $3vltz.toHex32(this.h.slice(0, 7), 'big');
    else return $3vltz.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("6tl9X", function(module, exports) {
'use strict';

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $7pXSD = parcelRequire("7pXSD");

var $aJt1P = parcelRequire("aJt1P");
var $4b65dd591dedf929$var$sum32 = $3vltz.sum32;
var $4b65dd591dedf929$var$sum32_4 = $3vltz.sum32_4;
var $4b65dd591dedf929$var$sum32_5 = $3vltz.sum32_5;
var $4b65dd591dedf929$var$ch32 = $7pXSD.ch32;
var $4b65dd591dedf929$var$maj32 = $7pXSD.maj32;
var $4b65dd591dedf929$var$s0_256 = $7pXSD.s0_256;
var $4b65dd591dedf929$var$s1_256 = $7pXSD.s1_256;
var $4b65dd591dedf929$var$g0_256 = $7pXSD.g0_256;
var $4b65dd591dedf929$var$g1_256 = $7pXSD.g1_256;
var $4b65dd591dedf929$var$BlockHash = $hoO3s.BlockHash;
var $4b65dd591dedf929$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $4b65dd591dedf929$var$SHA256() {
    if (!(this instanceof $4b65dd591dedf929$var$SHA256)) return new $4b65dd591dedf929$var$SHA256();
    $4b65dd591dedf929$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $4b65dd591dedf929$var$sha256_K;
    this.W = new Array(64);
}
$3vltz.inherits($4b65dd591dedf929$var$SHA256, $4b65dd591dedf929$var$BlockHash);
module.exports = $4b65dd591dedf929$var$SHA256;
$4b65dd591dedf929$var$SHA256.blockSize = 512;
$4b65dd591dedf929$var$SHA256.outSize = 256;
$4b65dd591dedf929$var$SHA256.hmacStrength = 192;
$4b65dd591dedf929$var$SHA256.padLength = 64;
$4b65dd591dedf929$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $4b65dd591dedf929$var$sum32_4($4b65dd591dedf929$var$g1_256(W[i - 2]), W[i - 7], $4b65dd591dedf929$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $aJt1P(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $4b65dd591dedf929$var$sum32_5(h, $4b65dd591dedf929$var$s1_256(e), $4b65dd591dedf929$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $4b65dd591dedf929$var$sum32($4b65dd591dedf929$var$s0_256(a), $4b65dd591dedf929$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $4b65dd591dedf929$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $4b65dd591dedf929$var$sum32(T1, T2);
    }
    this.h[0] = $4b65dd591dedf929$var$sum32(this.h[0], a);
    this.h[1] = $4b65dd591dedf929$var$sum32(this.h[1], b);
    this.h[2] = $4b65dd591dedf929$var$sum32(this.h[2], c);
    this.h[3] = $4b65dd591dedf929$var$sum32(this.h[3], d);
    this.h[4] = $4b65dd591dedf929$var$sum32(this.h[4], e);
    this.h[5] = $4b65dd591dedf929$var$sum32(this.h[5], f);
    this.h[6] = $4b65dd591dedf929$var$sum32(this.h[6], g);
    this.h[7] = $4b65dd591dedf929$var$sum32(this.h[7], h);
};
$4b65dd591dedf929$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3vltz.toHex32(this.h, 'big');
    else return $3vltz.split32(this.h, 'big');
};

});


parcelRegister("1zFKP", function(module, exports) {
'use strict';

var $3vltz = parcelRequire("3vltz");

var $b8Cnj = parcelRequire("b8Cnj");
function $125972e0f41acdab$var$SHA384() {
    if (!(this instanceof $125972e0f41acdab$var$SHA384)) return new $125972e0f41acdab$var$SHA384();
    $b8Cnj.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$3vltz.inherits($125972e0f41acdab$var$SHA384, $b8Cnj);
module.exports = $125972e0f41acdab$var$SHA384;
$125972e0f41acdab$var$SHA384.blockSize = 1024;
$125972e0f41acdab$var$SHA384.outSize = 384;
$125972e0f41acdab$var$SHA384.hmacStrength = 192;
$125972e0f41acdab$var$SHA384.padLength = 128;
$125972e0f41acdab$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3vltz.toHex32(this.h.slice(0, 12), 'big');
    else return $3vltz.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("b8Cnj", function(module, exports) {
'use strict';

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $aJt1P = parcelRequire("aJt1P");
var $81be358d8f6abcff$var$rotr64_hi = $3vltz.rotr64_hi;
var $81be358d8f6abcff$var$rotr64_lo = $3vltz.rotr64_lo;
var $81be358d8f6abcff$var$shr64_hi = $3vltz.shr64_hi;
var $81be358d8f6abcff$var$shr64_lo = $3vltz.shr64_lo;
var $81be358d8f6abcff$var$sum64 = $3vltz.sum64;
var $81be358d8f6abcff$var$sum64_hi = $3vltz.sum64_hi;
var $81be358d8f6abcff$var$sum64_lo = $3vltz.sum64_lo;
var $81be358d8f6abcff$var$sum64_4_hi = $3vltz.sum64_4_hi;
var $81be358d8f6abcff$var$sum64_4_lo = $3vltz.sum64_4_lo;
var $81be358d8f6abcff$var$sum64_5_hi = $3vltz.sum64_5_hi;
var $81be358d8f6abcff$var$sum64_5_lo = $3vltz.sum64_5_lo;
var $81be358d8f6abcff$var$BlockHash = $hoO3s.BlockHash;
var $81be358d8f6abcff$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $81be358d8f6abcff$var$SHA512() {
    if (!(this instanceof $81be358d8f6abcff$var$SHA512)) return new $81be358d8f6abcff$var$SHA512();
    $81be358d8f6abcff$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $81be358d8f6abcff$var$sha512_K;
    this.W = new Array(160);
}
$3vltz.inherits($81be358d8f6abcff$var$SHA512, $81be358d8f6abcff$var$BlockHash);
module.exports = $81be358d8f6abcff$var$SHA512;
$81be358d8f6abcff$var$SHA512.blockSize = 1024;
$81be358d8f6abcff$var$SHA512.outSize = 512;
$81be358d8f6abcff$var$SHA512.hmacStrength = 192;
$81be358d8f6abcff$var$SHA512.padLength = 128;
$81be358d8f6abcff$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $81be358d8f6abcff$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $81be358d8f6abcff$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $81be358d8f6abcff$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $81be358d8f6abcff$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $81be358d8f6abcff$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $81be358d8f6abcff$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$81be358d8f6abcff$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $aJt1P(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $81be358d8f6abcff$var$s1_512_hi(eh, el);
        var c1_lo = $81be358d8f6abcff$var$s1_512_lo(eh, el);
        var c2_hi = $81be358d8f6abcff$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $81be358d8f6abcff$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $81be358d8f6abcff$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $81be358d8f6abcff$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $81be358d8f6abcff$var$s0_512_hi(ah, al);
        c0_lo = $81be358d8f6abcff$var$s0_512_lo(ah, al);
        c1_hi = $81be358d8f6abcff$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $81be358d8f6abcff$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $81be358d8f6abcff$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $81be358d8f6abcff$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $81be358d8f6abcff$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $81be358d8f6abcff$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $81be358d8f6abcff$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $81be358d8f6abcff$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $81be358d8f6abcff$var$sum64(this.h, 0, ah, al);
    $81be358d8f6abcff$var$sum64(this.h, 2, bh, bl);
    $81be358d8f6abcff$var$sum64(this.h, 4, ch, cl);
    $81be358d8f6abcff$var$sum64(this.h, 6, dh, dl);
    $81be358d8f6abcff$var$sum64(this.h, 8, eh, el);
    $81be358d8f6abcff$var$sum64(this.h, 10, fh, fl);
    $81be358d8f6abcff$var$sum64(this.h, 12, gh, gl);
    $81be358d8f6abcff$var$sum64(this.h, 14, hh, hl);
};
$81be358d8f6abcff$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3vltz.toHex32(this.h, 'big');
    else return $3vltz.split32(this.h, 'big');
};
function $81be358d8f6abcff$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s0_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s0_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s1_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s1_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g0_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $81be358d8f6abcff$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g0_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $81be358d8f6abcff$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g1_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $81be358d8f6abcff$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g1_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $81be358d8f6abcff$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("ak1PH", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $783d3195a6b3253e$export$d1cea0ee4e3f0d3e; }, function (v) { return $783d3195a6b3253e$export$d1cea0ee4e3f0d3e = v; });
var $783d3195a6b3253e$export$d1cea0ee4e3f0d3e;
'use strict';

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");
var $783d3195a6b3253e$var$rotl32 = $3vltz.rotl32;
var $783d3195a6b3253e$var$sum32 = $3vltz.sum32;
var $783d3195a6b3253e$var$sum32_3 = $3vltz.sum32_3;
var $783d3195a6b3253e$var$sum32_4 = $3vltz.sum32_4;
var $783d3195a6b3253e$var$BlockHash = $hoO3s.BlockHash;
function $783d3195a6b3253e$var$RIPEMD160() {
    if (!(this instanceof $783d3195a6b3253e$var$RIPEMD160)) return new $783d3195a6b3253e$var$RIPEMD160();
    $783d3195a6b3253e$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$3vltz.inherits($783d3195a6b3253e$var$RIPEMD160, $783d3195a6b3253e$var$BlockHash);
$783d3195a6b3253e$export$d1cea0ee4e3f0d3e = $783d3195a6b3253e$var$RIPEMD160;
$783d3195a6b3253e$var$RIPEMD160.blockSize = 512;
$783d3195a6b3253e$var$RIPEMD160.outSize = 160;
$783d3195a6b3253e$var$RIPEMD160.hmacStrength = 192;
$783d3195a6b3253e$var$RIPEMD160.padLength = 64;
$783d3195a6b3253e$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $783d3195a6b3253e$var$sum32($783d3195a6b3253e$var$rotl32($783d3195a6b3253e$var$sum32_4(A, $783d3195a6b3253e$var$f(j, B, C, D), msg[$783d3195a6b3253e$var$r[j] + start], $783d3195a6b3253e$var$K(j)), $783d3195a6b3253e$var$s[j]), E);
        A = E;
        E = D;
        D = $783d3195a6b3253e$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $783d3195a6b3253e$var$sum32($783d3195a6b3253e$var$rotl32($783d3195a6b3253e$var$sum32_4(Ah, $783d3195a6b3253e$var$f(79 - j, Bh, Ch, Dh), msg[$783d3195a6b3253e$var$rh[j] + start], $783d3195a6b3253e$var$Kh(j)), $783d3195a6b3253e$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $783d3195a6b3253e$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $783d3195a6b3253e$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $783d3195a6b3253e$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $783d3195a6b3253e$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $783d3195a6b3253e$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $783d3195a6b3253e$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$783d3195a6b3253e$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3vltz.toHex32(this.h, 'little');
    else return $3vltz.split32(this.h, 'little');
};
function $783d3195a6b3253e$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $783d3195a6b3253e$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $783d3195a6b3253e$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $783d3195a6b3253e$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $783d3195a6b3253e$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $783d3195a6b3253e$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $783d3195a6b3253e$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("X5z30", function(module, exports) {
'use strict';

var $3vltz = parcelRequire("3vltz");

var $aJt1P = parcelRequire("aJt1P");
function $0b19d3c0f7d555a6$var$Hmac(hash, key, enc) {
    if (!(this instanceof $0b19d3c0f7d555a6$var$Hmac)) return new $0b19d3c0f7d555a6$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($3vltz.toArray(key, enc));
}
module.exports = $0b19d3c0f7d555a6$var$Hmac;
$0b19d3c0f7d555a6$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $aJt1P(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$0b19d3c0f7d555a6$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$0b19d3c0f7d555a6$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("63oZi", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("9lW0h", function(module, exports) {
'use strict';

var $6soDQ = parcelRequire("6soDQ");

var $5WFpm = parcelRequire("5WFpm");

var $ZdcNb = parcelRequire("ZdcNb");

var $hwVHR = parcelRequire("hwVHR");

var $9JRha = parcelRequire("9JRha");
var $6cf31182d56f3d95$var$assert = $ZdcNb.assert;

var $lE5ol = parcelRequire("lE5ol");

var $kQeFn = parcelRequire("kQeFn");
function $6cf31182d56f3d95$var$EC(options) {
    if (!(this instanceof $6cf31182d56f3d95$var$EC)) return new $6cf31182d56f3d95$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $6cf31182d56f3d95$var$assert(Object.prototype.hasOwnProperty.call($hwVHR, options), 'Unknown curve ' + options);
        options = $hwVHR[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $hwVHR.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $6cf31182d56f3d95$var$EC;
$6cf31182d56f3d95$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lE5ol(this, options);
};
$6cf31182d56f3d95$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lE5ol.fromPrivate(this, priv, enc);
};
$6cf31182d56f3d95$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lE5ol.fromPublic(this, pub, enc);
};
$6cf31182d56f3d95$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $5WFpm({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $9JRha(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $6soDQ(2));
    for(;;){
        var priv = new $6soDQ(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$6cf31182d56f3d95$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($6soDQ.isBN(msg) || typeof msg === 'number') {
        msg = new $6soDQ(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $6soDQ(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $6soDQ(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$6cf31182d56f3d95$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$6soDQ.isBN(msg)) {
        $6cf31182d56f3d95$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $6cf31182d56f3d95$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$6cf31182d56f3d95$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $6cf31182d56f3d95$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $6cf31182d56f3d95$var$assert(new $6soDQ(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $5WFpm({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $6soDQ(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $6soDQ(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $kQeFn({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$6cf31182d56f3d95$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $kQeFn(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$6cf31182d56f3d95$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $6cf31182d56f3d95$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $kQeFn(signature, enc);
    var n = this.n;
    var e = new $6soDQ(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$6cf31182d56f3d95$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $kQeFn(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("5WFpm", function(module, exports) {
'use strict';

var $leqJp = parcelRequire("leqJp");

var $6J8qY = parcelRequire("6J8qY");

var $aJt1P = parcelRequire("aJt1P");
function $45427d4f96da3b8c$var$HmacDRBG(options) {
    if (!(this instanceof $45427d4f96da3b8c$var$HmacDRBG)) return new $45427d4f96da3b8c$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $6J8qY.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $6J8qY.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $6J8qY.toArray(options.pers, options.persEnc || 'hex');
    $aJt1P(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $45427d4f96da3b8c$var$HmacDRBG;
$45427d4f96da3b8c$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$45427d4f96da3b8c$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $leqJp.hmac(this.hash, this.K);
};
$45427d4f96da3b8c$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$45427d4f96da3b8c$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $6J8qY.toArray(entropy, entropyEnc);
    add = $6J8qY.toArray(add, addEnc);
    $aJt1P(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$45427d4f96da3b8c$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $6J8qY.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $6J8qY.encode(res, enc);
};

});

parcelRegister("lE5ol", function(module, exports) {
'use strict';

var $6soDQ = parcelRequire("6soDQ");

var $ZdcNb = parcelRequire("ZdcNb");
var $fc21840fd53be280$var$assert = $ZdcNb.assert;
function $fc21840fd53be280$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fc21840fd53be280$var$KeyPair;
$fc21840fd53be280$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fc21840fd53be280$var$KeyPair) return pub;
    return new $fc21840fd53be280$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fc21840fd53be280$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fc21840fd53be280$var$KeyPair) return priv;
    return new $fc21840fd53be280$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fc21840fd53be280$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$fc21840fd53be280$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fc21840fd53be280$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$fc21840fd53be280$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $6soDQ(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fc21840fd53be280$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $fc21840fd53be280$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $fc21840fd53be280$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fc21840fd53be280$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fc21840fd53be280$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$fc21840fd53be280$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fc21840fd53be280$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$fc21840fd53be280$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("kQeFn", function(module, exports) {
'use strict';

var $6soDQ = parcelRequire("6soDQ");

var $ZdcNb = parcelRequire("ZdcNb");
var $f2c40a6448de4ea4$var$assert = $ZdcNb.assert;
function $f2c40a6448de4ea4$var$Signature(options, enc) {
    if (options instanceof $f2c40a6448de4ea4$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $f2c40a6448de4ea4$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $6soDQ(options.r, 16);
    this.s = new $6soDQ(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $f2c40a6448de4ea4$var$Signature;
function $f2c40a6448de4ea4$var$Position() {
    this.place = 0;
}
function $f2c40a6448de4ea4$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $f2c40a6448de4ea4$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$f2c40a6448de4ea4$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $ZdcNb.toArray(data, enc);
    var p = new $f2c40a6448de4ea4$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $f2c40a6448de4ea4$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $f2c40a6448de4ea4$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $f2c40a6448de4ea4$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $6soDQ(r);
    this.s = new $6soDQ(s);
    this.recoveryParam = null;
    return true;
};
function $f2c40a6448de4ea4$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$f2c40a6448de4ea4$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $f2c40a6448de4ea4$var$rmPadding(r);
    s = $f2c40a6448de4ea4$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $f2c40a6448de4ea4$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $f2c40a6448de4ea4$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $f2c40a6448de4ea4$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $ZdcNb.encode(res, enc);
};

});


parcelRegister("96jZE", function(module, exports) {
'use strict';

var $leqJp = parcelRequire("leqJp");

var $hwVHR = parcelRequire("hwVHR");

var $ZdcNb = parcelRequire("ZdcNb");
var $6a042ee1f208896f$var$assert = $ZdcNb.assert;
var $6a042ee1f208896f$var$parseBytes = $ZdcNb.parseBytes;

var $cR8ar = parcelRequire("cR8ar");

var $8zcvU = parcelRequire("8zcvU");
function $6a042ee1f208896f$var$EDDSA(curve) {
    $6a042ee1f208896f$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $6a042ee1f208896f$var$EDDSA)) return new $6a042ee1f208896f$var$EDDSA(curve);
    curve = $hwVHR[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $leqJp.sha512;
}
module.exports = $6a042ee1f208896f$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $6a042ee1f208896f$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $6a042ee1f208896f$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $6a042ee1f208896f$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $6a042ee1f208896f$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$6a042ee1f208896f$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $ZdcNb.intFromLE(hash.digest()).umod(this.curve.n);
};
$6a042ee1f208896f$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $cR8ar.fromPublic(this, pub);
};
$6a042ee1f208896f$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $cR8ar.fromSecret(this, secret);
};
$6a042ee1f208896f$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $8zcvU) return sig;
    return new $8zcvU(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $6a042ee1f208896f$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$6a042ee1f208896f$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $ZdcNb.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $ZdcNb.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$6a042ee1f208896f$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$6a042ee1f208896f$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $ZdcNb.intFromLE(bytes);
};
$6a042ee1f208896f$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("cR8ar", function(module, exports) {
'use strict';

var $ZdcNb = parcelRequire("ZdcNb");
var $95c0c52842c57a81$var$assert = $ZdcNb.assert;
var $95c0c52842c57a81$var$parseBytes = $ZdcNb.parseBytes;
var $95c0c52842c57a81$var$cachedProperty = $ZdcNb.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $95c0c52842c57a81$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $95c0c52842c57a81$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $95c0c52842c57a81$var$parseBytes(params.pub);
}
$95c0c52842c57a81$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $95c0c52842c57a81$var$KeyPair) return pub;
    return new $95c0c52842c57a81$var$KeyPair(eddsa, {
        pub: pub
    });
};
$95c0c52842c57a81$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $95c0c52842c57a81$var$KeyPair) return secret;
    return new $95c0c52842c57a81$var$KeyPair(eddsa, {
        secret: secret
    });
};
$95c0c52842c57a81$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$95c0c52842c57a81$var$KeyPair.prototype.sign = function sign(message) {
    $95c0c52842c57a81$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$95c0c52842c57a81$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$95c0c52842c57a81$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $95c0c52842c57a81$var$assert(this._secret, 'KeyPair is public only');
    return $ZdcNb.encode(this.secret(), enc);
};
$95c0c52842c57a81$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $ZdcNb.encode(this.pubBytes(), enc);
};
module.exports = $95c0c52842c57a81$var$KeyPair;

});

parcelRegister("8zcvU", function(module, exports) {
'use strict';

var $6soDQ = parcelRequire("6soDQ");

var $ZdcNb = parcelRequire("ZdcNb");
var $63cb4c939de36593$var$assert = $ZdcNb.assert;
var $63cb4c939de36593$var$cachedProperty = $ZdcNb.cachedProperty;
var $63cb4c939de36593$var$parseBytes = $ZdcNb.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $63cb4c939de36593$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $63cb4c939de36593$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $63cb4c939de36593$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $63cb4c939de36593$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $6soDQ) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$63cb4c939de36593$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$63cb4c939de36593$var$Signature.prototype.toHex = function toHex() {
    return $ZdcNb.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $63cb4c939de36593$var$Signature;

});



parcelRegister("579Op", function(module, exports) {
'use strict';

var $2FHZp = parcelRequire("2FHZp");

var $buRsR = parcelRequire("buRsR");

var $hpCup = parcelRequire("hpCup");

var $k1gB1 = parcelRequire("k1gB1");

var $1UZ5c = parcelRequire("1UZ5c");
var $3b9537b0914cb295$require$pbkdf2Sync = $1UZ5c.pbkdf2Sync;

var $6U9mG = parcelRequire("6U9mG");
var $3b9537b0914cb295$require$Buffer = $6U9mG.Buffer;
function $3b9537b0914cb295$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $buRsR[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $3b9537b0914cb295$require$pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $k1gB1.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $3b9537b0914cb295$require$Buffer.concat(out);
}
function $3b9537b0914cb295$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$3b9537b0914cb295$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $3b9537b0914cb295$require$Buffer.from(buffer);
    var stripped = $hpCup(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $2FHZp.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $2FHZp.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $2FHZp.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $2FHZp.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $2FHZp.EncryptedPrivateKey.decode(data, 'der');
            data = $3b9537b0914cb295$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $2FHZp.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $2FHZp.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $2FHZp.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $2FHZp.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $2FHZp.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $2FHZp.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $2FHZp.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $2FHZp.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$3b9537b0914cb295$var$parseKeys.signature = $2FHZp.signature;
module.exports = $3b9537b0914cb295$var$parseKeys;

});
parcelRegister("2FHZp", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $1f21887c987abd19$export$c98397a6eb8d0678; }, function (v) { return $1f21887c987abd19$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $1f21887c987abd19$export$f4aab6816f64fa6b; }, function (v) { return $1f21887c987abd19$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $1f21887c987abd19$export$4471f5c65d097c11; }, function (v) { return $1f21887c987abd19$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $1f21887c987abd19$export$ca8b6604d6ce14de; }, function (v) { return $1f21887c987abd19$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $1f21887c987abd19$export$8f54525b330fd87b; }, function (v) { return $1f21887c987abd19$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $1f21887c987abd19$export$23cd2842b44ca3e7; }, function (v) { return $1f21887c987abd19$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $1f21887c987abd19$export$245c9aaa9f5ce4ce; }, function (v) { return $1f21887c987abd19$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $1f21887c987abd19$export$8ad762e3e6399afe; }, function (v) { return $1f21887c987abd19$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $1f21887c987abd19$export$32ef6f92e22c6ab0; }, function (v) { return $1f21887c987abd19$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $1f21887c987abd19$export$c9cd164b539ebb63; }, function (v) { return $1f21887c987abd19$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $1f21887c987abd19$export$c98397a6eb8d0678;
var $1f21887c987abd19$export$f4aab6816f64fa6b;
var $1f21887c987abd19$export$4471f5c65d097c11;
var $1f21887c987abd19$export$ca8b6604d6ce14de;
var $1f21887c987abd19$export$8f54525b330fd87b;
var $1f21887c987abd19$export$23cd2842b44ca3e7;
var $1f21887c987abd19$export$245c9aaa9f5ce4ce;
var $1f21887c987abd19$export$8ad762e3e6399afe;
var $1f21887c987abd19$export$32ef6f92e22c6ab0;
var $1f21887c987abd19$export$c9cd164b539ebb63;
'use strict';

var $aMCkA = parcelRequire("aMCkA");

$1f21887c987abd19$export$c98397a6eb8d0678 = (parcelRequire("aa7wN"));
var $1f21887c987abd19$var$RSAPrivateKey = $aMCkA.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$1f21887c987abd19$export$f4aab6816f64fa6b = $1f21887c987abd19$var$RSAPrivateKey;
var $1f21887c987abd19$var$RSAPublicKey = $aMCkA.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$1f21887c987abd19$export$4471f5c65d097c11 = $1f21887c987abd19$var$RSAPublicKey;
var $1f21887c987abd19$var$AlgorithmIdentifier = $aMCkA.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $1f21887c987abd19$var$PublicKey = $aMCkA.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($1f21887c987abd19$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$1f21887c987abd19$export$ca8b6604d6ce14de = $1f21887c987abd19$var$PublicKey;
var $1f21887c987abd19$var$PrivateKeyInfo = $aMCkA.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($1f21887c987abd19$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$1f21887c987abd19$export$8f54525b330fd87b = $1f21887c987abd19$var$PrivateKeyInfo;
var $1f21887c987abd19$var$EncryptedPrivateKeyInfo = $aMCkA.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$1f21887c987abd19$export$23cd2842b44ca3e7 = $1f21887c987abd19$var$EncryptedPrivateKeyInfo;
var $1f21887c987abd19$var$DSAPrivateKey = $aMCkA.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$1f21887c987abd19$export$245c9aaa9f5ce4ce = $1f21887c987abd19$var$DSAPrivateKey;
$1f21887c987abd19$export$8ad762e3e6399afe = $aMCkA.define('DSAparam', function() {
    this['int']();
});
var $1f21887c987abd19$var$ECParameters = $aMCkA.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $1f21887c987abd19$var$ECPrivateKey = $aMCkA.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($1f21887c987abd19$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$1f21887c987abd19$export$32ef6f92e22c6ab0 = $1f21887c987abd19$var$ECPrivateKey;
$1f21887c987abd19$export$c9cd164b539ebb63 = $aMCkA.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("aMCkA", function(module, exports) {
var $7d9c1ed330ef59e6$var$asn1 = module.exports;

$7d9c1ed330ef59e6$var$asn1.bignum = (parcelRequire("cirLM"));

$7d9c1ed330ef59e6$var$asn1.define = (parcelRequire("jcRMx")).define;

$7d9c1ed330ef59e6$var$asn1.base = (parcelRequire("eMucS"));

$7d9c1ed330ef59e6$var$asn1.constants = (parcelRequire("2Qobq"));

$7d9c1ed330ef59e6$var$asn1.decoders = (parcelRequire("jTBMn"));

$7d9c1ed330ef59e6$var$asn1.encoders = (parcelRequire("8MqVr"));

});
parcelRegister("cirLM", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("jcRMx", function(module, exports) {

var $aMCkA = parcelRequire("aMCkA");

var $eSHUL = parcelRequire("eSHUL");
var $dfb8db4a4a86a3f4$var$api = module.exports;
$dfb8db4a4a86a3f4$var$api.define = function define(name, body) {
    return new $dfb8db4a4a86a3f4$var$Entity(name, body);
};
function $dfb8db4a4a86a3f4$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$dfb8db4a4a86a3f4$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = $dfb8db4a4a86a3f4$import$abb5b5bc854da1b1$11aaa88d3445a15('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $eSHUL(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$dfb8db4a4a86a3f4$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($aMCkA.decoders[enc]);
    return this.decoders[enc];
};
$dfb8db4a4a86a3f4$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$dfb8db4a4a86a3f4$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($aMCkA.encoders[enc]);
    return this.encoders[enc];
};
$dfb8db4a4a86a3f4$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});

parcelRegister("eMucS", function(module, exports) {
var $ac2cfaccb178df17$var$base = module.exports;

$ac2cfaccb178df17$var$base.Reporter = (parcelRequire("1NWy8")).Reporter;

$ac2cfaccb178df17$var$base.DecoderBuffer = (parcelRequire("hJsPi")).DecoderBuffer;

$ac2cfaccb178df17$var$base.EncoderBuffer = (parcelRequire("hJsPi")).EncoderBuffer;

$ac2cfaccb178df17$var$base.Node = (parcelRequire("aAKRg"));

});
parcelRegister("1NWy8", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $1507c8ca35a04511$export$957313a2f485e5ed; }, function (v) { return $1507c8ca35a04511$export$957313a2f485e5ed = v; });
var $1507c8ca35a04511$export$957313a2f485e5ed;

var $eSHUL = parcelRequire("eSHUL");
function $1507c8ca35a04511$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$1507c8ca35a04511$export$957313a2f485e5ed = $1507c8ca35a04511$var$Reporter;
$1507c8ca35a04511$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $1507c8ca35a04511$var$ReporterError;
};
$1507c8ca35a04511$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$1507c8ca35a04511$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$1507c8ca35a04511$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$1507c8ca35a04511$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$1507c8ca35a04511$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$1507c8ca35a04511$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$1507c8ca35a04511$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$1507c8ca35a04511$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$1507c8ca35a04511$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $1507c8ca35a04511$var$ReporterError;
    if (inherited) err = msg;
    else err = new $1507c8ca35a04511$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$1507c8ca35a04511$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $1507c8ca35a04511$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$eSHUL($1507c8ca35a04511$var$ReporterError, Error);
$1507c8ca35a04511$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $1507c8ca35a04511$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("hJsPi", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $ce8cfff3092e20f1$export$bf9f79cdc4a49163; }, function (v) { return $ce8cfff3092e20f1$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $ce8cfff3092e20f1$export$8ff24f7760c7a78e; }, function (v) { return $ce8cfff3092e20f1$export$8ff24f7760c7a78e = v; });
var $ce8cfff3092e20f1$export$bf9f79cdc4a49163;
var $ce8cfff3092e20f1$export$8ff24f7760c7a78e;

var $eSHUL = parcelRequire("eSHUL");

var $eMucS = parcelRequire("eMucS");
var $ce8cfff3092e20f1$require$Reporter = $eMucS.Reporter;

var $ihoyg = parcelRequire("ihoyg");
var $ce8cfff3092e20f1$require$Buffer = $ihoyg.Buffer;
function $ce8cfff3092e20f1$var$DecoderBuffer(base, options) {
    $ce8cfff3092e20f1$require$Reporter.call(this, options);
    if (!$ce8cfff3092e20f1$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$eSHUL($ce8cfff3092e20f1$var$DecoderBuffer, $ce8cfff3092e20f1$require$Reporter);
$ce8cfff3092e20f1$export$bf9f79cdc4a49163 = $ce8cfff3092e20f1$var$DecoderBuffer;
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $ce8cfff3092e20f1$require$Reporter.prototype.save.call(this)
    };
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $ce8cfff3092e20f1$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $ce8cfff3092e20f1$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $ce8cfff3092e20f1$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $ce8cfff3092e20f1$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $ce8cfff3092e20f1$var$EncoderBuffer)) item = new $ce8cfff3092e20f1$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $ce8cfff3092e20f1$require$Buffer.byteLength(value);
    } else if ($ce8cfff3092e20f1$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$ce8cfff3092e20f1$export$8ff24f7760c7a78e = $ce8cfff3092e20f1$var$EncoderBuffer;
$ce8cfff3092e20f1$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $ce8cfff3092e20f1$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($ce8cfff3092e20f1$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("aAKRg", function(module, exports) {

var $eMucS = parcelRequire("eMucS");
var $7b619d3ab2aa52ef$require$Reporter = $eMucS.Reporter;

var $eMucS = parcelRequire("eMucS");
var $7b619d3ab2aa52ef$require$EncoderBuffer = $eMucS.EncoderBuffer;

var $eMucS = parcelRequire("eMucS");
var $7b619d3ab2aa52ef$require$DecoderBuffer = $eMucS.DecoderBuffer;

var $aJt1P = parcelRequire("aJt1P");
// Supported tags
var $7b619d3ab2aa52ef$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $7b619d3ab2aa52ef$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($7b619d3ab2aa52ef$var$tags);
// Overrided methods list
var $7b619d3ab2aa52ef$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $7b619d3ab2aa52ef$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $7b619d3ab2aa52ef$var$Node;
var $7b619d3ab2aa52ef$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$7b619d3ab2aa52ef$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $7b619d3ab2aa52ef$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$7b619d3ab2aa52ef$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $7b619d3ab2aa52ef$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$7b619d3ab2aa52ef$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $aJt1P(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $aJt1P.equal(state.children.length, 1, 'Root node can have only one child');
};
$7b619d3ab2aa52ef$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $aJt1P(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $aJt1P(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$7b619d3ab2aa52ef$var$overrided.forEach(function(method) {
    $7b619d3ab2aa52ef$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$7b619d3ab2aa52ef$var$tags.forEach(function(tag) {
    $7b619d3ab2aa52ef$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $aJt1P(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$7b619d3ab2aa52ef$var$Node.prototype.use = function use(item) {
    $aJt1P(item);
    var state = this._baseState;
    $aJt1P(state.use === null);
    state.use = item;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $aJt1P(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $aJt1P(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $aJt1P(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $aJt1P(state.key === null);
    state.key = newKey;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $aJt1P(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $aJt1P(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$7b619d3ab2aa52ef$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $7b619d3ab2aa52ef$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$7b619d3ab2aa52ef$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$7b619d3ab2aa52ef$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $aJt1P(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$7b619d3ab2aa52ef$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$7b619d3ab2aa52ef$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $7b619d3ab2aa52ef$require$EncoderBuffer(data, this.reporter);
};
$7b619d3ab2aa52ef$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$7b619d3ab2aa52ef$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $7b619d3ab2aa52ef$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$7b619d3ab2aa52ef$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $aJt1P(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$7b619d3ab2aa52ef$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$7b619d3ab2aa52ef$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$7b619d3ab2aa52ef$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("2Qobq", function(module, exports) {
var $2123325f185a31d1$var$constants = module.exports;
// Helper
$2123325f185a31d1$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$2123325f185a31d1$var$constants.der = (parcelRequire("6SLsO"));

});
parcelRegister("6SLsO", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $502c9a8b0256715a$export$3584c46ed60baee8; }, function (v) { return $502c9a8b0256715a$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $502c9a8b0256715a$export$f18596ef8d632e49; }, function (v) { return $502c9a8b0256715a$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $502c9a8b0256715a$export$2b067c6666111485; }, function (v) { return $502c9a8b0256715a$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $502c9a8b0256715a$export$f17df38a421ab9e3; }, function (v) { return $502c9a8b0256715a$export$f17df38a421ab9e3 = v; });
var $502c9a8b0256715a$export$3584c46ed60baee8;
var $502c9a8b0256715a$export$f18596ef8d632e49;
var $502c9a8b0256715a$export$2b067c6666111485;
var $502c9a8b0256715a$export$f17df38a421ab9e3;

var $2Qobq = parcelRequire("2Qobq");
$502c9a8b0256715a$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$502c9a8b0256715a$export$f18596ef8d632e49 = $2Qobq._reverse($502c9a8b0256715a$export$3584c46ed60baee8);
$502c9a8b0256715a$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$502c9a8b0256715a$export$f17df38a421ab9e3 = $2Qobq._reverse($502c9a8b0256715a$export$2b067c6666111485);

});


parcelRegister("jTBMn", function(module, exports) {
var $e7c0758d361c90ed$var$decoders = module.exports;

$e7c0758d361c90ed$var$decoders.der = (parcelRequire("9Mx3V"));

$e7c0758d361c90ed$var$decoders.pem = (parcelRequire("3KeDh"));

});
parcelRegister("9Mx3V", function(module, exports) {

var $eSHUL = parcelRequire("eSHUL");

var $aMCkA = parcelRequire("aMCkA");
var $71f23e3d24920fc8$var$base = $aMCkA.base;
var $71f23e3d24920fc8$var$bignum = $aMCkA.bignum;
// Import DER constants
var $71f23e3d24920fc8$var$der = $aMCkA.constants.der;
function $71f23e3d24920fc8$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $71f23e3d24920fc8$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $71f23e3d24920fc8$var$DERDecoder;
$71f23e3d24920fc8$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $71f23e3d24920fc8$var$base.DecoderBuffer)) data = new $71f23e3d24920fc8$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $71f23e3d24920fc8$var$DERNode(parent) {
    $71f23e3d24920fc8$var$base.Node.call(this, 'der', parent);
}
$eSHUL($71f23e3d24920fc8$var$DERNode, $71f23e3d24920fc8$var$base.Node);
$71f23e3d24920fc8$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $71f23e3d24920fc8$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $71f23e3d24920fc8$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $71f23e3d24920fc8$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$71f23e3d24920fc8$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $71f23e3d24920fc8$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $71f23e3d24920fc8$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $71f23e3d24920fc8$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$71f23e3d24920fc8$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $71f23e3d24920fc8$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $71f23e3d24920fc8$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $71f23e3d24920fc8$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $71f23e3d24920fc8$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("3KeDh", function(module, exports) {

var $eSHUL = parcelRequire("eSHUL");

var $ihoyg = parcelRequire("ihoyg");
var $2ba104b685a3b739$require$Buffer = $ihoyg.Buffer;

var $9Mx3V = parcelRequire("9Mx3V");
function $2ba104b685a3b739$var$PEMDecoder(entity) {
    $9Mx3V.call(this, entity);
    this.enc = 'pem';
}
$eSHUL($2ba104b685a3b739$var$PEMDecoder, $9Mx3V);
module.exports = $2ba104b685a3b739$var$PEMDecoder;
$2ba104b685a3b739$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $2ba104b685a3b739$require$Buffer(base64, 'base64');
    return $9Mx3V.prototype.decode.call(this, input, options);
};

});


parcelRegister("8MqVr", function(module, exports) {
var $6647b13f24468e50$var$encoders = module.exports;

$6647b13f24468e50$var$encoders.der = (parcelRequire("44g7l"));

$6647b13f24468e50$var$encoders.pem = (parcelRequire("8MKvJ"));

});
parcelRegister("44g7l", function(module, exports) {

var $eSHUL = parcelRequire("eSHUL");

var $ihoyg = parcelRequire("ihoyg");
var $2f6409b794513848$require$Buffer = $ihoyg.Buffer;

var $aMCkA = parcelRequire("aMCkA");
var $2f6409b794513848$var$base = $aMCkA.base;
// Import DER constants
var $2f6409b794513848$var$der = $aMCkA.constants.der;
function $2f6409b794513848$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $2f6409b794513848$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $2f6409b794513848$var$DEREncoder;
$2f6409b794513848$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $2f6409b794513848$var$DERNode(parent) {
    $2f6409b794513848$var$base.Node.call(this, 'der', parent);
}
$eSHUL($2f6409b794513848$var$DERNode, $2f6409b794513848$var$base.Node);
$2f6409b794513848$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $2f6409b794513848$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $2f6409b794513848$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $2f6409b794513848$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$2f6409b794513848$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $2f6409b794513848$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$2f6409b794513848$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $2f6409b794513848$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $2f6409b794513848$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$2f6409b794513848$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $2f6409b794513848$var$two(date.getFullYear()),
        $2f6409b794513848$var$two(date.getUTCMonth() + 1),
        $2f6409b794513848$var$two(date.getUTCDate()),
        $2f6409b794513848$var$two(date.getUTCHours()),
        $2f6409b794513848$var$two(date.getUTCMinutes()),
        $2f6409b794513848$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $2f6409b794513848$var$two(date.getFullYear() % 100),
        $2f6409b794513848$var$two(date.getUTCMonth() + 1),
        $2f6409b794513848$var$two(date.getUTCDate()),
        $2f6409b794513848$var$two(date.getUTCHours()),
        $2f6409b794513848$var$two(date.getUTCMinutes()),
        $2f6409b794513848$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$2f6409b794513848$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$2f6409b794513848$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$2f6409b794513848$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $2f6409b794513848$require$Buffer(numArray);
    }
    if ($2f6409b794513848$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $2f6409b794513848$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $2f6409b794513848$require$Buffer(out));
};
$2f6409b794513848$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$2f6409b794513848$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$2f6409b794513848$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $2f6409b794513848$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($2f6409b794513848$var$der.tagByName.hasOwnProperty(tag)) res = $2f6409b794513848$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $2f6409b794513848$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("8MKvJ", function(module, exports) {

var $eSHUL = parcelRequire("eSHUL");

var $44g7l = parcelRequire("44g7l");
function $6656e2818f922400$var$PEMEncoder(entity) {
    $44g7l.call(this, entity);
    this.enc = 'pem';
}
$eSHUL($6656e2818f922400$var$PEMEncoder, $44g7l);
module.exports = $6656e2818f922400$var$PEMEncoder;
$6656e2818f922400$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $44g7l.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("aa7wN", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $aMCkA = parcelRequire("aMCkA");
var $7660ad76acc34f2e$var$Time = $aMCkA.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $7660ad76acc34f2e$var$AttributeTypeValue = $aMCkA.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $7660ad76acc34f2e$var$AlgorithmIdentifier = $aMCkA.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $7660ad76acc34f2e$var$SubjectPublicKeyInfo = $aMCkA.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($7660ad76acc34f2e$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $7660ad76acc34f2e$var$RelativeDistinguishedName = $aMCkA.define('RelativeDistinguishedName', function() {
    this.setof($7660ad76acc34f2e$var$AttributeTypeValue);
});
var $7660ad76acc34f2e$var$RDNSequence = $aMCkA.define('RDNSequence', function() {
    this.seqof($7660ad76acc34f2e$var$RelativeDistinguishedName);
});
var $7660ad76acc34f2e$var$Name = $aMCkA.define('Name', function() {
    this.choice({
        rdnSequence: this.use($7660ad76acc34f2e$var$RDNSequence)
    });
});
var $7660ad76acc34f2e$var$Validity = $aMCkA.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($7660ad76acc34f2e$var$Time), this.key('notAfter').use($7660ad76acc34f2e$var$Time));
});
var $7660ad76acc34f2e$var$Extension = $aMCkA.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $7660ad76acc34f2e$var$TBSCertificate = $aMCkA.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($7660ad76acc34f2e$var$AlgorithmIdentifier), this.key('issuer').use($7660ad76acc34f2e$var$Name), this.key('validity').use($7660ad76acc34f2e$var$Validity), this.key('subject').use($7660ad76acc34f2e$var$Name), this.key('subjectPublicKeyInfo').use($7660ad76acc34f2e$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($7660ad76acc34f2e$var$Extension).optional());
});
var $7660ad76acc34f2e$var$X509Certificate = $aMCkA.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($7660ad76acc34f2e$var$TBSCertificate), this.key('signatureAlgorithm').use($7660ad76acc34f2e$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $7660ad76acc34f2e$var$X509Certificate;

});


parcelRegister("buRsR", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("hpCup", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $cad2a0aed7a43a6b$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $cad2a0aed7a43a6b$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $cad2a0aed7a43a6b$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $5uIwM = parcelRequire("5uIwM");

var $k1gB1 = parcelRequire("k1gB1");

var $6U9mG = parcelRequire("6U9mG");
var $cad2a0aed7a43a6b$require$Buffer = $6U9mG.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($cad2a0aed7a43a6b$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($cad2a0aed7a43a6b$var$fullRegex);
        decrypted = $cad2a0aed7a43a6b$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $cad2a0aed7a43a6b$require$Buffer.from(match[2], 'hex');
        var cipherText = $cad2a0aed7a43a6b$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $5uIwM(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $k1gB1.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $cad2a0aed7a43a6b$require$Buffer.concat(out);
    }
    var tag = key.match($cad2a0aed7a43a6b$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("i66tY", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("eri43", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $a831998143a5cb0b$require$Buffer = $6U9mG.Buffer;

var $7vYz3 = parcelRequire("7vYz3");

var $8J1ou = parcelRequire("8J1ou");
var $a831998143a5cb0b$require$EC = $8J1ou.ec;

var $579Op = parcelRequire("579Op");

var $i66tY = parcelRequire("i66tY");
function $a831998143a5cb0b$var$verify(sig, hash, key, signType, tag) {
    var pub = $579Op(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $a831998143a5cb0b$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $a831998143a5cb0b$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $a831998143a5cb0b$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $a831998143a5cb0b$require$Buffer.from(pad);
    var red = $7vYz3.mont(pub.modulus);
    sig = new $7vYz3(sig).toRed(red);
    sig = sig.redPow(new $7vYz3(pub.publicExponent));
    sig = $a831998143a5cb0b$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $a831998143a5cb0b$var$ecVerify(sig, hash, pub) {
    var curveId = $i66tY[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $a831998143a5cb0b$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $a831998143a5cb0b$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $579Op.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $a831998143a5cb0b$var$checkValue(s, q);
    $a831998143a5cb0b$var$checkValue(r, q);
    var montp = $7vYz3.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $7vYz3(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $a831998143a5cb0b$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $a831998143a5cb0b$var$verify;

});


parcelRegister("bpRNH", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $84fbc32b9717e45c$require$Buffer = $ihoyg.Buffer;

var $8J1ou = parcelRequire("8J1ou");

var $8fQ9y = parcelRequire("8fQ9y");
module.exports = function createECDH(curve) {
    return new $84fbc32b9717e45c$var$ECDH(curve);
};
var $84fbc32b9717e45c$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$84fbc32b9717e45c$var$aliases.p224 = $84fbc32b9717e45c$var$aliases.secp224r1;
$84fbc32b9717e45c$var$aliases.p256 = $84fbc32b9717e45c$var$aliases.secp256r1 = $84fbc32b9717e45c$var$aliases.prime256v1;
$84fbc32b9717e45c$var$aliases.p192 = $84fbc32b9717e45c$var$aliases.secp192r1 = $84fbc32b9717e45c$var$aliases.prime192v1;
$84fbc32b9717e45c$var$aliases.p384 = $84fbc32b9717e45c$var$aliases.secp384r1;
$84fbc32b9717e45c$var$aliases.p521 = $84fbc32b9717e45c$var$aliases.secp521r1;
function $84fbc32b9717e45c$var$ECDH(curve) {
    this.curveType = $84fbc32b9717e45c$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $8J1ou.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$84fbc32b9717e45c$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$84fbc32b9717e45c$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$84fbc32b9717e45c$require$Buffer.isBuffer(other)) other = new $84fbc32b9717e45c$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $84fbc32b9717e45c$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$84fbc32b9717e45c$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $84fbc32b9717e45c$var$formatReturnValue(key, enc);
};
$84fbc32b9717e45c$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $84fbc32b9717e45c$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$84fbc32b9717e45c$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$84fbc32b9717e45c$require$Buffer.isBuffer(pub)) pub = new $84fbc32b9717e45c$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$84fbc32b9717e45c$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$84fbc32b9717e45c$require$Buffer.isBuffer(priv)) priv = new $84fbc32b9717e45c$require$Buffer(priv, enc);
    var _priv = new $8fQ9y(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $84fbc32b9717e45c$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $84fbc32b9717e45c$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $84fbc32b9717e45c$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $84fbc32b9717e45c$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("8fQ9y", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("e8Hvp", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $a4b38f5366ff7954$export$512823e338ddb1b7; }, function (v) { return $a4b38f5366ff7954$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $a4b38f5366ff7954$export$7efb24e2fddf99b9; }, function (v) { return $a4b38f5366ff7954$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $a4b38f5366ff7954$export$9d0e0c0c4a8d30f3; }, function (v) { return $a4b38f5366ff7954$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $a4b38f5366ff7954$export$b9d55ff329113abd; }, function (v) { return $a4b38f5366ff7954$export$b9d55ff329113abd = v; });
var $a4b38f5366ff7954$export$512823e338ddb1b7;
var $a4b38f5366ff7954$export$7efb24e2fddf99b9;
var $a4b38f5366ff7954$export$9d0e0c0c4a8d30f3;
var $a4b38f5366ff7954$export$b9d55ff329113abd;

$a4b38f5366ff7954$export$512823e338ddb1b7 = (parcelRequire("4XSWL"));

$a4b38f5366ff7954$export$7efb24e2fddf99b9 = (parcelRequire("JGlZv"));
$a4b38f5366ff7954$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $a4b38f5366ff7954$export$512823e338ddb1b7(key, buf, true);
};
$a4b38f5366ff7954$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $a4b38f5366ff7954$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("4XSWL", function(module, exports) {

var $579Op = parcelRequire("579Op");

var $5rfiH = parcelRequire("5rfiH");

var $3FiLE = parcelRequire("3FiLE");

var $lRbMS = parcelRequire("lRbMS");

var $65ECs = parcelRequire("65ECs");

var $acabN = parcelRequire("acabN");

var $d9Eed = parcelRequire("d9Eed");

var $hG1cM = parcelRequire("hG1cM");

var $6U9mG = parcelRequire("6U9mG");
var $39d74b68ba721c1e$require$Buffer = $6U9mG.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $579Op(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $39d74b68ba721c1e$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $39d74b68ba721c1e$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $acabN(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $hG1cM(paddedMsg, key);
    else return $d9Eed(paddedMsg, key);
};
function $39d74b68ba721c1e$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $3FiLE('sha1').update($39d74b68ba721c1e$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $39d74b68ba721c1e$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $5rfiH(hLen);
    var maskedDb = $65ECs($39d74b68ba721c1e$require$Buffer.concat([
        iHash,
        ps,
        $39d74b68ba721c1e$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $lRbMS(seed, dblen));
    var maskedSeed = $65ECs(seed, $lRbMS(maskedDb, hLen));
    return new $acabN($39d74b68ba721c1e$require$Buffer.concat([
        $39d74b68ba721c1e$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $39d74b68ba721c1e$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $39d74b68ba721c1e$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $39d74b68ba721c1e$var$nonZero(k - mLen - 3);
    return new $acabN($39d74b68ba721c1e$require$Buffer.concat([
        $39d74b68ba721c1e$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $39d74b68ba721c1e$require$Buffer.alloc(1),
        msg
    ], k));
}
function $39d74b68ba721c1e$var$nonZero(len) {
    var out = $39d74b68ba721c1e$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $5rfiH(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $5rfiH(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("lRbMS", function(module, exports) {

var $3FiLE = parcelRequire("3FiLE");

var $6U9mG = parcelRequire("6U9mG");
var $fe97b0ee2bc1dbf7$require$Buffer = $6U9mG.Buffer;
module.exports = function(seed, len) {
    var t = $fe97b0ee2bc1dbf7$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $fe97b0ee2bc1dbf7$var$i2ops(i++);
        t = $fe97b0ee2bc1dbf7$require$Buffer.concat([
            t,
            $3FiLE('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $fe97b0ee2bc1dbf7$var$i2ops(c) {
    var out = $fe97b0ee2bc1dbf7$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("65ECs", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("acabN", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("d9Eed", function(module, exports) {

var $acabN = parcelRequire("acabN");

var $6U9mG = parcelRequire("6U9mG");
var $993b521f149aacc0$require$Buffer = $6U9mG.Buffer;
function $993b521f149aacc0$var$withPublic(paddedMsg, key) {
    return $993b521f149aacc0$require$Buffer.from(paddedMsg.toRed($acabN.mont(key.modulus)).redPow(new $acabN(key.publicExponent)).fromRed().toArray());
}
module.exports = $993b521f149aacc0$var$withPublic;

});


parcelRegister("JGlZv", function(module, exports) {

var $579Op = parcelRequire("579Op");

var $lRbMS = parcelRequire("lRbMS");

var $65ECs = parcelRequire("65ECs");

var $acabN = parcelRequire("acabN");

var $hG1cM = parcelRequire("hG1cM");

var $3FiLE = parcelRequire("3FiLE");

var $d9Eed = parcelRequire("d9Eed");

var $6U9mG = parcelRequire("6U9mG");
var $08950ea5301bc0f1$require$Buffer = $6U9mG.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $579Op(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $acabN(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $d9Eed(new $acabN(enc), key);
    else msg = $hG1cM(enc, key);
    var zBuffer = $08950ea5301bc0f1$require$Buffer.alloc(k - msg.length);
    msg = $08950ea5301bc0f1$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $08950ea5301bc0f1$var$oaep(key, msg);
    else if (padding === 1) return $08950ea5301bc0f1$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $08950ea5301bc0f1$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $3FiLE('sha1').update($08950ea5301bc0f1$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $65ECs(maskedSeed, $lRbMS(maskedDb, hLen));
    var db = $65ECs(maskedDb, $lRbMS(seed, k - hLen - 1));
    if ($08950ea5301bc0f1$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $08950ea5301bc0f1$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $08950ea5301bc0f1$var$compare(a, b) {
    a = $08950ea5301bc0f1$require$Buffer.from(a);
    b = $08950ea5301bc0f1$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("6zHAr", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $4c97d268940b2c08$export$bb1abf2ce84fc7e8; }, function (v) { return $4c97d268940b2c08$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $4c97d268940b2c08$export$2f7171e78e524d5e; }, function (v) { return $4c97d268940b2c08$export$2f7171e78e524d5e = v; });
var $4c97d268940b2c08$export$bb1abf2ce84fc7e8;
var $4c97d268940b2c08$export$2f7171e78e524d5e;

var $4TNnu = parcelRequire("4TNnu");
'use strict';
function $4c97d268940b2c08$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $6U9mG = parcelRequire("6U9mG");

var $5rfiH = parcelRequire("5rfiH");
var $4c97d268940b2c08$var$Buffer = $6U9mG.Buffer;
var $4c97d268940b2c08$var$kBufferMaxLength = $6U9mG.kMaxLength;
var $4c97d268940b2c08$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $4c97d268940b2c08$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $4c97d268940b2c08$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $4c97d268940b2c08$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $4c97d268940b2c08$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $4c97d268940b2c08$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $4c97d268940b2c08$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $4c97d268940b2c08$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($4c97d268940b2c08$var$crypto && $4c97d268940b2c08$var$crypto.getRandomValues || false) {
    $4c97d268940b2c08$export$bb1abf2ce84fc7e8 = $4c97d268940b2c08$var$randomFill;
    $4c97d268940b2c08$export$2f7171e78e524d5e = $4c97d268940b2c08$var$randomFillSync;
} else {
    $4c97d268940b2c08$export$bb1abf2ce84fc7e8 = $4c97d268940b2c08$var$oldBrowser;
    $4c97d268940b2c08$export$2f7171e78e524d5e = $4c97d268940b2c08$var$oldBrowser;
}
function $4c97d268940b2c08$var$randomFill(buf, offset, size, cb) {
    if (!$4c97d268940b2c08$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $4c97d268940b2c08$var$assertOffset(offset, buf.length);
    $4c97d268940b2c08$var$assertSize(size, offset, buf.length);
    return $4c97d268940b2c08$var$actualFill(buf, offset, size, cb);
}
function $4c97d268940b2c08$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $4c97d268940b2c08$var$crypto.getRandomValues(uint);
    if (cb) {
        $4TNnu.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $5rfiH(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $5rfiH(size);
    bytes.copy(buf, offset);
    return buf;
}
function $4c97d268940b2c08$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$4c97d268940b2c08$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $4c97d268940b2c08$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $4c97d268940b2c08$var$assertSize(size, offset, buf.length);
    return $4c97d268940b2c08$var$actualFill(buf, offset, size);
}

});


parcelRegister("aWVB1", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $7f8bff889035a580$require$Buffer = $6U9mG.Buffer;

var $cNgnj = parcelRequire("cNgnj");
var $7f8bff889035a580$var$MAX_OCTET = 0x80, $7f8bff889035a580$var$CLASS_UNIVERSAL = 0, $7f8bff889035a580$var$PRIMITIVE_BIT = 0x20, $7f8bff889035a580$var$TAG_SEQ = 0x10, $7f8bff889035a580$var$TAG_INT = 0x02, $7f8bff889035a580$var$ENCODED_TAG_SEQ = $7f8bff889035a580$var$TAG_SEQ | $7f8bff889035a580$var$PRIMITIVE_BIT | $7f8bff889035a580$var$CLASS_UNIVERSAL << 6, $7f8bff889035a580$var$ENCODED_TAG_INT = $7f8bff889035a580$var$TAG_INT | $7f8bff889035a580$var$CLASS_UNIVERSAL << 6;
function $7f8bff889035a580$var$base64Url(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $7f8bff889035a580$var$signatureAsBuffer(signature) {
    if ($7f8bff889035a580$require$Buffer.isBuffer(signature)) return signature;
    else if ('string' === typeof signature) return $7f8bff889035a580$require$Buffer.from(signature, 'base64');
    throw new TypeError('ECDSA signature must be a Base64 string or a Buffer');
}
function $7f8bff889035a580$var$derToJose(signature, alg) {
    signature = $7f8bff889035a580$var$signatureAsBuffer(signature);
    var paramBytes = $cNgnj(alg);
    // the DER encoded param should at most be the param size, plus a padding
    // zero, since due to being a signed integer
    var maxEncodedParamLength = paramBytes + 1;
    var inputLength = signature.length;
    var offset = 0;
    if (signature[offset++] !== $7f8bff889035a580$var$ENCODED_TAG_SEQ) throw new Error('Could not find expected "seq"');
    var seqLength = signature[offset++];
    if (seqLength === ($7f8bff889035a580$var$MAX_OCTET | 1)) seqLength = signature[offset++];
    if (inputLength - offset < seqLength) throw new Error('"seq" specified length of "' + seqLength + '", only "' + (inputLength - offset) + '" remaining');
    if (signature[offset++] !== $7f8bff889035a580$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "r"');
    var rLength = signature[offset++];
    if (inputLength - offset - 2 < rLength) throw new Error('"r" specified length of "' + rLength + '", only "' + (inputLength - offset - 2) + '" available');
    if (maxEncodedParamLength < rLength) throw new Error('"r" specified length of "' + rLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var rOffset = offset;
    offset += rLength;
    if (signature[offset++] !== $7f8bff889035a580$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "s"');
    var sLength = signature[offset++];
    if (inputLength - offset !== sLength) throw new Error('"s" specified length of "' + sLength + '", expected "' + (inputLength - offset) + '"');
    if (maxEncodedParamLength < sLength) throw new Error('"s" specified length of "' + sLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var sOffset = offset;
    offset += sLength;
    if (offset !== inputLength) throw new Error('Expected to consume entire buffer, but "' + (inputLength - offset) + '" bytes remain');
    var rPadding = paramBytes - rLength, sPadding = paramBytes - sLength;
    var dst = $7f8bff889035a580$require$Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength);
    for(offset = 0; offset < rPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength);
    offset = paramBytes;
    for(var o = offset; offset < o + sPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength);
    dst = dst.toString('base64');
    dst = $7f8bff889035a580$var$base64Url(dst);
    return dst;
}
function $7f8bff889035a580$var$countPadding(buf, start, stop) {
    var padding = 0;
    while(start + padding < stop && buf[start + padding] === 0)++padding;
    var needsSign = buf[start + padding] >= $7f8bff889035a580$var$MAX_OCTET;
    if (needsSign) --padding;
    return padding;
}
function $7f8bff889035a580$var$joseToDer(signature, alg) {
    signature = $7f8bff889035a580$var$signatureAsBuffer(signature);
    var paramBytes = $cNgnj(alg);
    var signatureBytes = signature.length;
    if (signatureBytes !== paramBytes * 2) throw new TypeError('"' + alg + '" signatures must be "' + paramBytes * 2 + '" bytes, saw "' + signatureBytes + '"');
    var rPadding = $7f8bff889035a580$var$countPadding(signature, 0, paramBytes);
    var sPadding = $7f8bff889035a580$var$countPadding(signature, paramBytes, signature.length);
    var rLength = paramBytes - rPadding;
    var sLength = paramBytes - sPadding;
    var rsBytes = 2 + rLength + 1 + 1 + sLength;
    var shortLength = rsBytes < $7f8bff889035a580$var$MAX_OCTET;
    var dst = $7f8bff889035a580$require$Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes);
    var offset = 0;
    dst[offset++] = $7f8bff889035a580$var$ENCODED_TAG_SEQ;
    if (shortLength) // Bit 8 has value "0"
    // bits 7-1 give the length.
    dst[offset++] = rsBytes;
    else {
        // Bit 8 of first octet has value "1"
        // bits 7-1 give the number of additional length octets.
        dst[offset++] = $7f8bff889035a580$var$MAX_OCTET | 1;
        // length, base 256
        dst[offset++] = rsBytes & 0xff;
    }
    dst[offset++] = $7f8bff889035a580$var$ENCODED_TAG_INT;
    dst[offset++] = rLength;
    if (rPadding < 0) {
        dst[offset++] = 0;
        offset += signature.copy(dst, offset, 0, paramBytes);
    } else offset += signature.copy(dst, offset, rPadding, paramBytes);
    dst[offset++] = $7f8bff889035a580$var$ENCODED_TAG_INT;
    dst[offset++] = sLength;
    if (sPadding < 0) {
        dst[offset++] = 0;
        signature.copy(dst, offset, paramBytes);
    } else signature.copy(dst, offset, paramBytes + sPadding);
    return dst;
}
module.exports = {
    derToJose: $7f8bff889035a580$var$derToJose,
    joseToDer: $7f8bff889035a580$var$joseToDer
};

});
parcelRegister("cNgnj", function(module, exports) {
'use strict';
function $9506c3642027a0f2$var$getParamSize(keySize) {
    var result = (keySize / 8 | 0) + (keySize % 8 === 0 ? 0 : 1);
    return result;
}
var $9506c3642027a0f2$var$paramBytesForAlg = {
    ES256: $9506c3642027a0f2$var$getParamSize(256),
    ES384: $9506c3642027a0f2$var$getParamSize(384),
    ES512: $9506c3642027a0f2$var$getParamSize(521)
};
function $9506c3642027a0f2$var$getParamBytesForAlg(alg) {
    var paramBytes = $9506c3642027a0f2$var$paramBytesForAlg[alg];
    if (paramBytes) return paramBytes;
    throw new Error('Unknown algorithm "' + alg + '"');
}
module.exports = $9506c3642027a0f2$var$getParamBytesForAlg;

});


parcelRegister("jdJWE", function(module, exports) {
/*jshint node:true */ 'use strict';

var $ihoyg = parcelRequire("ihoyg");
var $039c6ef350cade04$require$Buffer = $ihoyg.Buffer;

var $ihoyg = parcelRequire("ihoyg");
var $039c6ef350cade04$require$SlowBuffer = $ihoyg.SlowBuffer;
module.exports = $039c6ef350cade04$var$bufferEq;
function $039c6ef350cade04$var$bufferEq(a, b) {
    // shortcutting on type is necessary for correctness
    if (!$039c6ef350cade04$require$Buffer.isBuffer(a) || !$039c6ef350cade04$require$Buffer.isBuffer(b)) return false;
    // buffer sizes should be well-known information, so despite this
    // shortcutting, it doesn't leak any information about the *contents* of the
    // buffers.
    if (a.length !== b.length) return false;
    var c = 0;
    for(var i = 0; i < a.length; i++)/*jshint bitwise:false */ c |= a[i] ^ b[i]; // XOR
    return c === 0;
}
$039c6ef350cade04$var$bufferEq.install = function() {
    $039c6ef350cade04$require$Buffer.prototype.equal = $039c6ef350cade04$require$SlowBuffer.prototype.equal = function equal(that) {
        return $039c6ef350cade04$var$bufferEq(this, that);
    };
};
var $039c6ef350cade04$var$origBufEqual = $039c6ef350cade04$require$Buffer.prototype.equal;
var $039c6ef350cade04$var$origSlowBufEqual = $039c6ef350cade04$require$SlowBuffer.prototype.equal;
$039c6ef350cade04$var$bufferEq.restore = function() {
    $039c6ef350cade04$require$Buffer.prototype.equal = $039c6ef350cade04$var$origBufEqual;
    $039c6ef350cade04$require$SlowBuffer.prototype.equal = $039c6ef350cade04$var$origSlowBufEqual;
};

});


parcelRegister("kJYhQ", function(module, exports) {
/*global module*/ 
var $ihoyg = parcelRequire("ihoyg");
var $f196c65514932e3c$require$Buffer = $ihoyg.Buffer;
module.exports = function toString(obj) {
    if (typeof obj === 'string') return obj;
    if (typeof obj === 'number' || $f196c65514932e3c$require$Buffer.isBuffer(obj)) return obj.toString();
    return JSON.stringify(obj);
};

});


parcelRegister("j76Aa", function(module, exports) {
/*global module*/ 
var $6U9mG = parcelRequire("6U9mG");
var $dea3c6e61c9c8e78$require$Buffer = $6U9mG.Buffer;

var $jMPFS = parcelRequire("jMPFS");

var $gWIRK = parcelRequire("gWIRK");

var $bks2w = parcelRequire("bks2w");

var $kJYhQ = parcelRequire("kJYhQ");

var $4zyeF = parcelRequire("4zyeF");
var $dea3c6e61c9c8e78$var$JWS_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;
function $dea3c6e61c9c8e78$var$isObject(thing) {
    return Object.prototype.toString.call(thing) === '[object Object]';
}
function $dea3c6e61c9c8e78$var$safeJsonParse(thing) {
    if ($dea3c6e61c9c8e78$var$isObject(thing)) return thing;
    try {
        return JSON.parse(thing);
    } catch (e) {
        return undefined;
    }
}
function $dea3c6e61c9c8e78$var$headerFromJWS(jwsSig) {
    var encodedHeader = jwsSig.split('.', 1)[0];
    return $dea3c6e61c9c8e78$var$safeJsonParse($dea3c6e61c9c8e78$require$Buffer.from(encodedHeader, 'base64').toString('binary'));
}
function $dea3c6e61c9c8e78$var$securedInputFromJWS(jwsSig) {
    return jwsSig.split('.', 2).join('.');
}
function $dea3c6e61c9c8e78$var$signatureFromJWS(jwsSig) {
    return jwsSig.split('.')[2];
}
function $dea3c6e61c9c8e78$var$payloadFromJWS(jwsSig, encoding) {
    encoding = encoding || 'utf8';
    var payload = jwsSig.split('.')[1];
    return $dea3c6e61c9c8e78$require$Buffer.from(payload, 'base64').toString(encoding);
}
function $dea3c6e61c9c8e78$var$isValidJws(string) {
    return $dea3c6e61c9c8e78$var$JWS_REGEX.test(string) && !!$dea3c6e61c9c8e78$var$headerFromJWS(string);
}
function $dea3c6e61c9c8e78$var$jwsVerify(jwsSig, algorithm, secretOrKey) {
    if (!algorithm) {
        var err = new Error("Missing algorithm parameter for jws.verify");
        err.code = "MISSING_ALGORITHM";
        throw err;
    }
    jwsSig = $kJYhQ(jwsSig);
    var signature = $dea3c6e61c9c8e78$var$signatureFromJWS(jwsSig);
    var securedInput = $dea3c6e61c9c8e78$var$securedInputFromJWS(jwsSig);
    var algo = $gWIRK(algorithm);
    return algo.verify(securedInput, signature, secretOrKey);
}
function $dea3c6e61c9c8e78$var$jwsDecode(jwsSig, opts) {
    opts = opts || {};
    jwsSig = $kJYhQ(jwsSig);
    if (!$dea3c6e61c9c8e78$var$isValidJws(jwsSig)) return null;
    var header = $dea3c6e61c9c8e78$var$headerFromJWS(jwsSig);
    if (!header) return null;
    var payload = $dea3c6e61c9c8e78$var$payloadFromJWS(jwsSig);
    if (header.typ === 'JWT' || opts.json) payload = JSON.parse(payload, opts.encoding);
    return {
        header: header,
        payload: payload,
        signature: $dea3c6e61c9c8e78$var$signatureFromJWS(jwsSig)
    };
}
function $dea3c6e61c9c8e78$var$VerifyStream(opts) {
    opts = opts || {};
    var secretOrKey = opts.secret;
    secretOrKey = secretOrKey == null ? opts.publicKey : secretOrKey;
    secretOrKey = secretOrKey == null ? opts.key : secretOrKey;
    if (/^hs/i.test(opts.algorithm) === true && secretOrKey == null) throw new TypeError('secret must be a string or buffer or a KeyObject');
    var secretStream = new $jMPFS(secretOrKey);
    this.readable = true;
    this.algorithm = opts.algorithm;
    this.encoding = opts.encoding;
    this.secret = this.publicKey = this.key = secretStream;
    this.signature = new $jMPFS(opts.signature);
    this.secret.once('close', (function() {
        if (!this.signature.writable && this.readable) this.verify();
    }).bind(this));
    this.signature.once('close', (function() {
        if (!this.secret.writable && this.readable) this.verify();
    }).bind(this));
}
$4zyeF.inherits($dea3c6e61c9c8e78$var$VerifyStream, $bks2w);
$dea3c6e61c9c8e78$var$VerifyStream.prototype.verify = function verify() {
    try {
        var valid = $dea3c6e61c9c8e78$var$jwsVerify(this.signature.buffer, this.algorithm, this.key.buffer);
        var obj = $dea3c6e61c9c8e78$var$jwsDecode(this.signature.buffer, this.encoding);
        this.emit('done', valid, obj);
        this.emit('data', valid);
        this.emit('end');
        this.readable = false;
        return valid;
    } catch (e) {
        this.readable = false;
        this.emit('error', e);
        this.emit('close');
    }
};
$dea3c6e61c9c8e78$var$VerifyStream.decode = $dea3c6e61c9c8e78$var$jwsDecode;
$dea3c6e61c9c8e78$var$VerifyStream.isValid = $dea3c6e61c9c8e78$var$isValidJws;
$dea3c6e61c9c8e78$var$VerifyStream.verify = $dea3c6e61c9c8e78$var$jwsVerify;
module.exports = $dea3c6e61c9c8e78$var$VerifyStream;

});



parcelRegister("4F4V4", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $364ecead373794c3$require$Buffer = $ihoyg.Buffer;

var $k16ui = parcelRequire("k16ui");

var $dRNC5 = parcelRequire("dRNC5");

var $2ptu6 = parcelRequire("2ptu6");

var $jSyln = parcelRequire("jSyln");

var $6AsMe = parcelRequire("6AsMe");

var $cKDCQ = parcelRequire("cKDCQ");

var $3YUTJ = parcelRequire("3YUTJ");

var $2TGdH = parcelRequire("2TGdH");

var $aO8Ot = parcelRequire("aO8Ot");
var $364ecead373794c3$require$KeyObject = $aO8Ot.KeyObject;
var $364ecead373794c3$require$createSecretKey = $aO8Ot.createSecretKey;
var $364ecead373794c3$require$createPublicKey = $aO8Ot.createPublicKey;
const $364ecead373794c3$var$PUB_KEY_ALGS = [
    'RS256',
    'RS384',
    'RS512'
];
const $364ecead373794c3$var$EC_KEY_ALGS = [
    'ES256',
    'ES384',
    'ES512'
];
const $364ecead373794c3$var$RSA_KEY_ALGS = [
    'RS256',
    'RS384',
    'RS512'
];
const $364ecead373794c3$var$HS_ALGS = [
    'HS256',
    'HS384',
    'HS512'
];
if ($3YUTJ) {
    $364ecead373794c3$var$PUB_KEY_ALGS.splice($364ecead373794c3$var$PUB_KEY_ALGS.length, 0, 'PS256', 'PS384', 'PS512');
    $364ecead373794c3$var$RSA_KEY_ALGS.splice($364ecead373794c3$var$RSA_KEY_ALGS.length, 0, 'PS256', 'PS384', 'PS512');
}
module.exports = function(jwtString, secretOrPublicKey, options, callback) {
    if (typeof options === 'function' && !callback) {
        callback = options;
        options = {};
    }
    if (!options) options = {};
    //clone this object since we are going to mutate it.
    options = Object.assign({}, options);
    let done;
    if (callback) done = callback;
    else done = function(err, data) {
        if (err) throw err;
        return data;
    };
    if (options.clockTimestamp && typeof options.clockTimestamp !== 'number') return done(new $k16ui('clockTimestamp must be a number'));
    if (options.nonce !== undefined && (typeof options.nonce !== 'string' || options.nonce.trim() === '')) return done(new $k16ui('nonce must be a non-empty string'));
    if (options.allowInvalidAsymmetricKeyTypes !== undefined && typeof options.allowInvalidAsymmetricKeyTypes !== 'boolean') return done(new $k16ui('allowInvalidAsymmetricKeyTypes must be a boolean'));
    const clockTimestamp = options.clockTimestamp || Math.floor(Date.now() / 1000);
    if (!jwtString) return done(new $k16ui('jwt must be provided'));
    if (typeof jwtString !== 'string') return done(new $k16ui('jwt must be a string'));
    const parts = jwtString.split('.');
    if (parts.length !== 3) return done(new $k16ui('jwt malformed'));
    let decodedToken;
    try {
        decodedToken = $jSyln(jwtString, {
            complete: true
        });
    } catch (err) {
        return done(err);
    }
    if (!decodedToken) return done(new $k16ui('invalid token'));
    const header = decodedToken.header;
    let getSecret;
    if (typeof secretOrPublicKey === 'function') {
        if (!callback) return done(new $k16ui('verify must be called asynchronous if secret or public key is provided as a callback'));
        getSecret = secretOrPublicKey;
    } else getSecret = function(header, secretCallback) {
        return secretCallback(null, secretOrPublicKey);
    };
    return getSecret(header, function(err, secretOrPublicKey) {
        if (err) return done(new $k16ui('error in secret or public key callback: ' + err.message));
        const hasSignature = parts[2].trim() !== '';
        if (!hasSignature && secretOrPublicKey) return done(new $k16ui('jwt signature is required'));
        if (hasSignature && !secretOrPublicKey) return done(new $k16ui('secret or public key must be provided'));
        if (!hasSignature && !options.algorithms) return done(new $k16ui('please specify "none" in "algorithms" to verify unsigned tokens'));
        if (secretOrPublicKey != null && !(secretOrPublicKey instanceof $364ecead373794c3$require$KeyObject)) try {
            secretOrPublicKey = $364ecead373794c3$require$createPublicKey(secretOrPublicKey);
        } catch (_) {
            try {
                secretOrPublicKey = $364ecead373794c3$require$createSecretKey(typeof secretOrPublicKey === 'string' ? $364ecead373794c3$require$Buffer.from(secretOrPublicKey) : secretOrPublicKey);
            } catch (_) {
                return done(new $k16ui('secretOrPublicKey is not valid key material'));
            }
        }
        if (!options.algorithms) {
            if (secretOrPublicKey.type === 'secret') options.algorithms = $364ecead373794c3$var$HS_ALGS;
            else if ([
                'rsa',
                'rsa-pss'
            ].includes(secretOrPublicKey.asymmetricKeyType)) options.algorithms = $364ecead373794c3$var$RSA_KEY_ALGS;
            else if (secretOrPublicKey.asymmetricKeyType === 'ec') options.algorithms = $364ecead373794c3$var$EC_KEY_ALGS;
            else options.algorithms = $364ecead373794c3$var$PUB_KEY_ALGS;
        }
        if (options.algorithms.indexOf(decodedToken.header.alg) === -1) return done(new $k16ui('invalid algorithm'));
        if (header.alg.startsWith('HS') && secretOrPublicKey.type !== 'secret') return done(new $k16ui(`secretOrPublicKey must be a symmetric key when using ${header.alg}`));
        else if (/^(?:RS|PS|ES)/.test(header.alg) && secretOrPublicKey.type !== 'public') return done(new $k16ui(`secretOrPublicKey must be an asymmetric key when using ${header.alg}`));
        if (!options.allowInvalidAsymmetricKeyTypes) try {
            $cKDCQ(header.alg, secretOrPublicKey);
        } catch (e) {
            return done(e);
        }
        let valid;
        try {
            valid = $2TGdH.verify(jwtString, decodedToken.header.alg, secretOrPublicKey);
        } catch (e) {
            return done(e);
        }
        if (!valid) return done(new $k16ui('invalid signature'));
        const payload = decodedToken.payload;
        if (typeof payload.nbf !== 'undefined' && !options.ignoreNotBefore) {
            if (typeof payload.nbf !== 'number') return done(new $k16ui('invalid nbf value'));
            if (payload.nbf > clockTimestamp + (options.clockTolerance || 0)) return done(new $dRNC5('jwt not active', new Date(payload.nbf * 1000)));
        }
        if (typeof payload.exp !== 'undefined' && !options.ignoreExpiration) {
            if (typeof payload.exp !== 'number') return done(new $k16ui('invalid exp value'));
            if (clockTimestamp >= payload.exp + (options.clockTolerance || 0)) return done(new $2ptu6('jwt expired', new Date(payload.exp * 1000)));
        }
        if (options.audience) {
            const audiences = Array.isArray(options.audience) ? options.audience : [
                options.audience
            ];
            const target = Array.isArray(payload.aud) ? payload.aud : [
                payload.aud
            ];
            const match = target.some(function(targetAudience) {
                return audiences.some(function(audience) {
                    return audience instanceof RegExp ? audience.test(targetAudience) : audience === targetAudience;
                });
            });
            if (!match) return done(new $k16ui('jwt audience invalid. expected: ' + audiences.join(' or ')));
        }
        if (options.issuer) {
            const invalid_issuer = typeof options.issuer === 'string' && payload.iss !== options.issuer || Array.isArray(options.issuer) && options.issuer.indexOf(payload.iss) === -1;
            if (invalid_issuer) return done(new $k16ui('jwt issuer invalid. expected: ' + options.issuer));
        }
        if (options.subject) {
            if (payload.sub !== options.subject) return done(new $k16ui('jwt subject invalid. expected: ' + options.subject));
        }
        if (options.jwtid) {
            if (payload.jti !== options.jwtid) return done(new $k16ui('jwt jwtid invalid. expected: ' + options.jwtid));
        }
        if (options.nonce) {
            if (payload.nonce !== options.nonce) return done(new $k16ui('jwt nonce invalid. expected: ' + options.nonce));
        }
        if (options.maxAge) {
            if (typeof payload.iat !== 'number') return done(new $k16ui('iat required when maxAge is specified'));
            const maxAgeTimestamp = $6AsMe(options.maxAge, payload.iat);
            if (typeof maxAgeTimestamp === 'undefined') return done(new $k16ui('"maxAge" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
            if (clockTimestamp >= maxAgeTimestamp + (options.clockTolerance || 0)) return done(new $2ptu6('maxAge exceeded', new Date(maxAgeTimestamp * 1000)));
        }
        if (options.complete === true) {
            const signature = decodedToken.signature;
            return done(null, {
                header: header,
                payload: payload,
                signature: signature
            });
        }
        return done(null, payload);
    });
};

});
parcelRegister("k16ui", function(module, exports) {
var $e928eef7575ec2bf$var$JsonWebTokenError = function(message, error) {
    Error.call(this, message);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    this.name = 'JsonWebTokenError';
    this.message = message;
    if (error) this.inner = error;
};
$e928eef7575ec2bf$var$JsonWebTokenError.prototype = Object.create(Error.prototype);
$e928eef7575ec2bf$var$JsonWebTokenError.prototype.constructor = $e928eef7575ec2bf$var$JsonWebTokenError;
module.exports = $e928eef7575ec2bf$var$JsonWebTokenError;

});

parcelRegister("dRNC5", function(module, exports) {

var $k16ui = parcelRequire("k16ui");
var $a186b5c2f6375822$var$NotBeforeError = function(message, date) {
    $k16ui.call(this, message);
    this.name = 'NotBeforeError';
    this.date = date;
};
$a186b5c2f6375822$var$NotBeforeError.prototype = Object.create($k16ui.prototype);
$a186b5c2f6375822$var$NotBeforeError.prototype.constructor = $a186b5c2f6375822$var$NotBeforeError;
module.exports = $a186b5c2f6375822$var$NotBeforeError;

});

parcelRegister("2ptu6", function(module, exports) {

var $k16ui = parcelRequire("k16ui");
var $1c14c9969c50b8fb$var$TokenExpiredError = function(message, expiredAt) {
    $k16ui.call(this, message);
    this.name = 'TokenExpiredError';
    this.expiredAt = expiredAt;
};
$1c14c9969c50b8fb$var$TokenExpiredError.prototype = Object.create($k16ui.prototype);
$1c14c9969c50b8fb$var$TokenExpiredError.prototype.constructor = $1c14c9969c50b8fb$var$TokenExpiredError;
module.exports = $1c14c9969c50b8fb$var$TokenExpiredError;

});

parcelRegister("6AsMe", function(module, exports) {

var $ihDXb = parcelRequire("ihDXb");
module.exports = function(time, iat) {
    var timestamp = iat || Math.floor(Date.now() / 1000);
    if (typeof time === 'string') {
        var milliseconds = $ihDXb(time);
        if (typeof milliseconds === 'undefined') return;
        return Math.floor(timestamp + milliseconds / 1000);
    } else if (typeof time === 'number') return timestamp + time;
    else return;
};

});
parcelRegister("ihDXb", function(module, exports) {
/**
 * Helpers.
 */ var $d4f8ce75742e0993$var$s = 1000;
var $d4f8ce75742e0993$var$m = $d4f8ce75742e0993$var$s * 60;
var $d4f8ce75742e0993$var$h = $d4f8ce75742e0993$var$m * 60;
var $d4f8ce75742e0993$var$d = $d4f8ce75742e0993$var$h * 24;
var $d4f8ce75742e0993$var$w = $d4f8ce75742e0993$var$d * 7;
var $d4f8ce75742e0993$var$y = $d4f8ce75742e0993$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $d4f8ce75742e0993$var$parse(val);
    else if (type === 'number' && isFinite(val)) return options.long ? $d4f8ce75742e0993$var$fmtLong(val) : $d4f8ce75742e0993$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $d4f8ce75742e0993$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $d4f8ce75742e0993$var$y;
        case 'weeks':
        case 'week':
        case 'w':
            return n * $d4f8ce75742e0993$var$w;
        case 'days':
        case 'day':
        case 'd':
            return n * $d4f8ce75742e0993$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $d4f8ce75742e0993$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $d4f8ce75742e0993$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $d4f8ce75742e0993$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $d4f8ce75742e0993$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $d4f8ce75742e0993$var$d) return Math.round(ms / $d4f8ce75742e0993$var$d) + 'd';
    if (msAbs >= $d4f8ce75742e0993$var$h) return Math.round(ms / $d4f8ce75742e0993$var$h) + 'h';
    if (msAbs >= $d4f8ce75742e0993$var$m) return Math.round(ms / $d4f8ce75742e0993$var$m) + 'm';
    if (msAbs >= $d4f8ce75742e0993$var$s) return Math.round(ms / $d4f8ce75742e0993$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $d4f8ce75742e0993$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $d4f8ce75742e0993$var$d) return $d4f8ce75742e0993$var$plural(ms, msAbs, $d4f8ce75742e0993$var$d, 'day');
    if (msAbs >= $d4f8ce75742e0993$var$h) return $d4f8ce75742e0993$var$plural(ms, msAbs, $d4f8ce75742e0993$var$h, 'hour');
    if (msAbs >= $d4f8ce75742e0993$var$m) return $d4f8ce75742e0993$var$plural(ms, msAbs, $d4f8ce75742e0993$var$m, 'minute');
    if (msAbs >= $d4f8ce75742e0993$var$s) return $d4f8ce75742e0993$var$plural(ms, msAbs, $d4f8ce75742e0993$var$s, 'second');
    return ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $d4f8ce75742e0993$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

});


parcelRegister("cKDCQ", function(module, exports) {

var $1dmQ2 = parcelRequire("1dmQ2");

var $dtadb = parcelRequire("dtadb");
const $948884ba57baf68e$var$allowedAlgorithmsForKeys = {
    'ec': [
        'ES256',
        'ES384',
        'ES512'
    ],
    'rsa': [
        'RS256',
        'PS256',
        'RS384',
        'PS384',
        'RS512',
        'PS512'
    ],
    'rsa-pss': [
        'PS256',
        'PS384',
        'PS512'
    ]
};
const $948884ba57baf68e$var$allowedCurves = {
    ES256: 'prime256v1',
    ES384: 'secp384r1',
    ES512: 'secp521r1'
};
module.exports = function(algorithm, key) {
    if (!algorithm || !key) return;
    const keyType = key.asymmetricKeyType;
    if (!keyType) return;
    const allowedAlgorithms = $948884ba57baf68e$var$allowedAlgorithmsForKeys[keyType];
    if (!allowedAlgorithms) throw new Error(`Unknown key type "${keyType}".`);
    if (!allowedAlgorithms.includes(algorithm)) throw new Error(`"alg" parameter for "${keyType}" key type must be one of: ${allowedAlgorithms.join(', ')}.`);
    /*
   * Ignore the next block from test coverage because it gets executed
   * conditionally depending on the Node version. Not ignoring it would
   * prevent us from reaching the target % of coverage for versions of
   * Node under 15.7.0.
   */ /* istanbul ignore next */ if ($1dmQ2) switch(keyType){
        case 'ec':
            const keyCurve = key.asymmetricKeyDetails.namedCurve;
            const allowedCurve = $948884ba57baf68e$var$allowedCurves[algorithm];
            if (keyCurve !== allowedCurve) throw new Error(`"alg" parameter "${algorithm}" requires curve "${allowedCurve}".`);
            break;
        case 'rsa-pss':
            if ($dtadb) {
                const length = parseInt(algorithm.slice(-3), 10);
                const { hashAlgorithm: hashAlgorithm, mgf1HashAlgorithm: mgf1HashAlgorithm, saltLength: saltLength } = key.asymmetricKeyDetails;
                if (hashAlgorithm !== `sha${length}` || mgf1HashAlgorithm !== hashAlgorithm) throw new Error(`Invalid key for this operation, its RSA-PSS parameters do not meet the requirements of "alg" ${algorithm}.`);
                if (saltLength !== undefined && saltLength > length >> 3) throw new Error(`Invalid key for this operation, its RSA-PSS parameter saltLength does not meet the requirements of "alg" ${algorithm}.`);
            }
            break;
    }
};

});
parcelRegister("1dmQ2", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");

var $6C34p = parcelRequire("6C34p");
module.exports = $6C34p.satisfies($4TNnu.version, '>=15.7.0');

});
parcelRegister("6C34p", function(module, exports) {
'use strict';

var $2Fn7f = parcelRequire("2Fn7f");

var $bxcIS = parcelRequire("bxcIS");

var $lsrf7 = parcelRequire("lsrf7");

var $1Okz0 = parcelRequire("1Okz0");

var $eGdKX = parcelRequire("eGdKX");

var $2WB3r = parcelRequire("2WB3r");

var $2WaYX = parcelRequire("2WaYX");

var $6hJSt = parcelRequire("6hJSt");

var $jpbFc = parcelRequire("jpbFc");

var $hJhOs = parcelRequire("hJhOs");

var $jFJyk = parcelRequire("jFJyk");

var $4swJJ = parcelRequire("4swJJ");

var $lC0tA = parcelRequire("lC0tA");

var $igifu = parcelRequire("igifu");

var $bc5zZ = parcelRequire("bc5zZ");

var $4lIKf = parcelRequire("4lIKf");

var $5FbVS = parcelRequire("5FbVS");

var $7ONNG = parcelRequire("7ONNG");

var $9x2kx = parcelRequire("9x2kx");

var $37Bc9 = parcelRequire("37Bc9");

var $fEJAw = parcelRequire("fEJAw");

var $d4j3n = parcelRequire("d4j3n");

var $5buXb = parcelRequire("5buXb");

var $j0r87 = parcelRequire("j0r87");

var $474UK = parcelRequire("474UK");

var $hdkAh = parcelRequire("hdkAh");

var $h385f = parcelRequire("h385f");

var $45Coa = parcelRequire("45Coa");

var $kmPI0 = parcelRequire("kmPI0");

var $ijgnV = parcelRequire("ijgnV");

var $30u73 = parcelRequire("30u73");

var $31c4J = parcelRequire("31c4J");

var $fR1pK = parcelRequire("fR1pK");

var $8KhX7 = parcelRequire("8KhX7");

var $ddxDA = parcelRequire("ddxDA");

var $6AKEC = parcelRequire("6AKEC");

var $azTB8 = parcelRequire("azTB8");

var $konvZ = parcelRequire("konvZ");

var $5FEXN = parcelRequire("5FEXN");

var $77dzh = parcelRequire("77dzh");

var $abdDP = parcelRequire("abdDP");
module.exports = {
    parse: $eGdKX,
    valid: $2WB3r,
    clean: $2WaYX,
    inc: $6hJSt,
    diff: $jpbFc,
    major: $hJhOs,
    minor: $jFJyk,
    patch: $4swJJ,
    prerelease: $lC0tA,
    compare: $igifu,
    rcompare: $bc5zZ,
    compareLoose: $4lIKf,
    compareBuild: $5FbVS,
    sort: $7ONNG,
    rsort: $9x2kx,
    gt: $37Bc9,
    lt: $fEJAw,
    eq: $d4j3n,
    neq: $5buXb,
    gte: $j0r87,
    lte: $474UK,
    cmp: $hdkAh,
    coerce: $h385f,
    Comparator: $45Coa,
    Range: $kmPI0,
    satisfies: $ijgnV,
    toComparators: $30u73,
    maxSatisfying: $31c4J,
    minSatisfying: $fR1pK,
    minVersion: $8KhX7,
    validRange: $ddxDA,
    outside: $6AKEC,
    gtr: $azTB8,
    ltr: $konvZ,
    intersects: $5FEXN,
    simplifyRange: $77dzh,
    subset: $abdDP,
    SemVer: $lsrf7,
    re: $2Fn7f.re,
    src: $2Fn7f.src,
    tokens: $2Fn7f.t,
    SEMVER_SPEC_VERSION: $bxcIS.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: $bxcIS.RELEASE_TYPES,
    compareIdentifiers: $1Okz0.compareIdentifiers,
    rcompareIdentifiers: $1Okz0.rcompareIdentifiers
};

});
parcelRegister("2Fn7f", function(module, exports) {
'use strict';

var $bxcIS = parcelRequire("bxcIS");
var $1f1157736ea12b24$require$MAX_SAFE_COMPONENT_LENGTH = $bxcIS.MAX_SAFE_COMPONENT_LENGTH;
var $1f1157736ea12b24$require$MAX_SAFE_BUILD_LENGTH = $bxcIS.MAX_SAFE_BUILD_LENGTH;
var $1f1157736ea12b24$require$MAX_LENGTH = $bxcIS.MAX_LENGTH;

var $6WnlW = parcelRequire("6WnlW");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const safeSrc = exports.safeSrc = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = '[a-zA-Z0-9-]';
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        '\\s',
        1
    ],
    [
        '\\d',
        $1f1157736ea12b24$require$MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        $1f1157736ea12b24$require$MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    $6WnlW(name, index, value);
    t[name] = index;
    src[index] = value;
    safeSrc[index] = safe;
    re[index] = new RegExp(value, isGlobal ? 'g' : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? 'g' : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken('NUMERICIDENTIFIER', '0|[1-9]\\d*');
createToken('NUMERICIDENTIFIERLOOSE', '\\d+');
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken('NONNUMERICIDENTIFIER', `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken('MAINVERSION', `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken('MAINVERSIONLOOSE', `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
// Non-numberic identifiers include numberic identifiers but can be longer.
// Therefore non-numberic identifiers must go first.
createToken('PRERELEASEIDENTIFIER', `(?:${src[t.NONNUMERICIDENTIFIER]}|${src[t.NUMERICIDENTIFIER]})`);
createToken('PRERELEASEIDENTIFIERLOOSE', `(?:${src[t.NONNUMERICIDENTIFIER]}|${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken('PRERELEASE', `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken('PRERELEASELOOSE', `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken('BUILDIDENTIFIER', `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken('BUILD', `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken('FULLPLAIN', `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken('FULL', `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken('LOOSEPLAIN', `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken('LOOSE', `^${src[t.LOOSEPLAIN]}$`);
createToken('GTLT', '((?:<|>)?=?)');
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken('XRANGEIDENTIFIERLOOSE', `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken('XRANGEIDENTIFIER', `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken('XRANGEPLAIN', `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGEPLAINLOOSE', `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken('XRANGELOOSE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken('COERCEPLAIN', `${"(^|[^\\d])(\\d{1,"}${$1f1157736ea12b24$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$1f1157736ea12b24$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$1f1157736ea12b24$require$MAX_SAFE_COMPONENT_LENGTH}}))?`);
createToken('COERCE', `${src[t.COERCEPLAIN]}(?:$|[^\\d])`);
createToken('COERCEFULL', src[t.COERCEPLAIN] + `(?:${src[t.PRERELEASE]})?` + `(?:${src[t.BUILD]})?` + `(?:$|[^\\d])`);
createToken('COERCERTL', src[t.COERCE], true);
createToken('COERCERTLFULL', src[t.COERCEFULL], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken('LONETILDE', '(?:~>?)');
createToken('TILDETRIM', `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = '$1~';
createToken('TILDE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken('TILDELOOSE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken('LONECARET', '(?:\\^)');
createToken('CARETTRIM', `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = '$1^';
createToken('CARET', `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken('CARETLOOSE', `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken('COMPARATORLOOSE', `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken('COMPARATOR', `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken('COMPARATORTRIM', `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = '$1$2$3';
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken('HYPHENRANGE', `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken('HYPHENRANGELOOSE', `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken('STAR', '(<|>)?=?\\s*\\*');
// >=0.0.0 is like a star
createToken('GTE0', '^\\s*>=\\s*0\\.0\\.0\\s*$');
createToken('GTE0PRE', '^\\s*>=\\s*0\\.0\\.0-0\\s*$');

});
parcelRegister("bxcIS", function(module, exports) {
'use strict';
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $865ca547efbbbfc7$var$SEMVER_SPEC_VERSION = '2.0.0';
const $865ca547efbbbfc7$var$MAX_LENGTH = 256;
const $865ca547efbbbfc7$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $865ca547efbbbfc7$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const $865ca547efbbbfc7$var$MAX_SAFE_BUILD_LENGTH = $865ca547efbbbfc7$var$MAX_LENGTH - 6;
const $865ca547efbbbfc7$var$RELEASE_TYPES = [
    'major',
    'premajor',
    'minor',
    'preminor',
    'patch',
    'prepatch',
    'prerelease'
];
module.exports = {
    MAX_LENGTH: $865ca547efbbbfc7$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $865ca547efbbbfc7$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH: $865ca547efbbbfc7$var$MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER: $865ca547efbbbfc7$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $865ca547efbbbfc7$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $865ca547efbbbfc7$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRegister("6WnlW", function(module, exports) {
'use strict';
const $50da46407bf9edc1$var$debug = ()=>{};
module.exports = $50da46407bf9edc1$var$debug;

});


parcelRegister("lsrf7", function(module, exports) {
'use strict';

var $6WnlW = parcelRequire("6WnlW");

var $bxcIS = parcelRequire("bxcIS");
var $f9f1585769a12528$require$MAX_LENGTH = $bxcIS.MAX_LENGTH;
var $f9f1585769a12528$require$MAX_SAFE_INTEGER = $bxcIS.MAX_SAFE_INTEGER;

var $2Fn7f = parcelRequire("2Fn7f");
var $f9f1585769a12528$require$re = $2Fn7f.safeRe;
var $f9f1585769a12528$require$t = $2Fn7f.t;

var $l2f9c = parcelRequire("l2f9c");

var $1Okz0 = parcelRequire("1Okz0");
var $f9f1585769a12528$require$compareIdentifiers = $1Okz0.compareIdentifiers;
class $f9f1585769a12528$var$SemVer {
    constructor(version, options){
        options = $l2f9c(options);
        if (version instanceof $f9f1585769a12528$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== 'string') throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > $f9f1585769a12528$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$f9f1585769a12528$require$MAX_LENGTH} characters`);
        $6WnlW('SemVer', version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $f9f1585769a12528$require$re[$f9f1585769a12528$require$t.LOOSE] : $f9f1585769a12528$require$re[$f9f1585769a12528$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $f9f1585769a12528$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError('Invalid major version');
        if (this.minor > $f9f1585769a12528$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError('Invalid minor version');
        if (this.patch > $f9f1585769a12528$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError('Invalid patch version');
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split('.').map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $f9f1585769a12528$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split('.') : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join('.')}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $6WnlW('SemVer.compare', this.version, this.options, other);
        if (!(other instanceof $f9f1585769a12528$var$SemVer)) {
            if (typeof other === 'string' && other === this.version) return 0;
            other = new $f9f1585769a12528$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $f9f1585769a12528$var$SemVer)) other = new $f9f1585769a12528$var$SemVer(other, this.options);
        if (this.major < other.major) return -1;
        if (this.major > other.major) return 1;
        if (this.minor < other.minor) return -1;
        if (this.minor > other.minor) return 1;
        if (this.patch < other.patch) return -1;
        if (this.patch > other.patch) return 1;
        return 0;
    }
    comparePre(other) {
        if (!(other instanceof $f9f1585769a12528$var$SemVer)) other = new $f9f1585769a12528$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $6WnlW('prerelease compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $f9f1585769a12528$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $f9f1585769a12528$var$SemVer)) other = new $f9f1585769a12528$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $6WnlW('build compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $f9f1585769a12528$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        if (release.startsWith('pre')) {
            if (!identifier && identifierBase === false) throw new Error('invalid increment argument: identifier is empty');
            // Avoid an invalid semver results
            if (identifier) {
                const match = `-${identifier}`.match(this.options.loose ? $f9f1585769a12528$require$re[$f9f1585769a12528$require$t.PRERELEASELOOSE] : $f9f1585769a12528$require$re[$f9f1585769a12528$require$t.PRERELEASE]);
                if (!match || match[1] !== identifier) throw new Error(`invalid identifier: ${identifier}`);
            }
        }
        switch(release){
            case 'premajor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'preminor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'prepatch':
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case 'prerelease':
                if (this.prerelease.length === 0) this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            case 'release':
                if (this.prerelease.length === 0) throw new Error(`version ${this.raw} is not a prerelease`);
                this.prerelease.length = 0;
                break;
            case 'major':
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'minor':
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'patch':
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case 'pre':
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === 'number') {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join('.') && identifierBase === false) throw new Error('invalid increment argument: identifier already exists');
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if ($f9f1585769a12528$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join('.')}`;
        return this;
    }
}
module.exports = $f9f1585769a12528$var$SemVer;

});
parcelRegister("l2f9c", function(module, exports) {
'use strict';
// parse out just the options we care about
const $f50588d9f65aab77$var$looseOption = Object.freeze({
    loose: true
});
const $f50588d9f65aab77$var$emptyOpts = Object.freeze({});
const $f50588d9f65aab77$var$parseOptions = (options)=>{
    if (!options) return $f50588d9f65aab77$var$emptyOpts;
    if (typeof options !== 'object') return $f50588d9f65aab77$var$looseOption;
    return options;
};
module.exports = $f50588d9f65aab77$var$parseOptions;

});

parcelRegister("1Okz0", function(module, exports) {
'use strict';
const $151a697b659b9e6c$var$numeric = /^[0-9]+$/;
const $151a697b659b9e6c$var$compareIdentifiers = (a, b)=>{
    if (typeof a === 'number' && typeof b === 'number') return a === b ? 0 : a < b ? -1 : 1;
    const anum = $151a697b659b9e6c$var$numeric.test(a);
    const bnum = $151a697b659b9e6c$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $151a697b659b9e6c$var$rcompareIdentifiers = (a, b)=>$151a697b659b9e6c$var$compareIdentifiers(b, a);
module.exports = {
    compareIdentifiers: $151a697b659b9e6c$var$compareIdentifiers,
    rcompareIdentifiers: $151a697b659b9e6c$var$rcompareIdentifiers
};

});


parcelRegister("eGdKX", function(module, exports) {
'use strict';

var $lsrf7 = parcelRequire("lsrf7");
const $aaffa8a8b35c119a$var$parse = (version, options, throwErrors = false)=>{
    if (version instanceof $lsrf7) return version;
    try {
        return new $lsrf7(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
module.exports = $aaffa8a8b35c119a$var$parse;

});

parcelRegister("2WB3r", function(module, exports) {
'use strict';

var $eGdKX = parcelRequire("eGdKX");
const $224dbdd20c19aeda$var$valid = (version, options)=>{
    const v = $eGdKX(version, options);
    return v ? v.version : null;
};
module.exports = $224dbdd20c19aeda$var$valid;

});

parcelRegister("2WaYX", function(module, exports) {
'use strict';

var $eGdKX = parcelRequire("eGdKX");
const $223984672a6e63cb$var$clean = (version, options)=>{
    const s = $eGdKX(version.trim().replace(/^[=v]+/, ''), options);
    return s ? s.version : null;
};
module.exports = $223984672a6e63cb$var$clean;

});

parcelRegister("6hJSt", function(module, exports) {
'use strict';

var $lsrf7 = parcelRequire("lsrf7");
const $012e523db2730b7e$var$inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === 'string') {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new $lsrf7(version instanceof $lsrf7 ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
module.exports = $012e523db2730b7e$var$inc;

});

parcelRegister("jpbFc", function(module, exports) {
'use strict';

var $eGdKX = parcelRequire("eGdKX");
const $e2096644ba02ec17$var$diff = (version1, version2)=>{
    const v1 = $eGdKX(version1, null, true);
    const v2 = $eGdKX(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return 'major';
        // If the main part has no difference
        if (lowVersion.compareMain(highVersion) === 0) {
            if (lowVersion.minor && !lowVersion.patch) return 'minor';
            return 'patch';
        }
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? 'pre' : '';
    if (v1.major !== v2.major) return prefix + 'major';
    if (v1.minor !== v2.minor) return prefix + 'minor';
    if (v1.patch !== v2.patch) return prefix + 'patch';
    // high and low are preleases
    return 'prerelease';
};
module.exports = $e2096644ba02ec17$var$diff;

});

parcelRegister("hJhOs", function(module, exports) {
'use strict';

var $lsrf7 = parcelRequire("lsrf7");
const $ce8474e0724f11bb$var$major = (a, loose)=>new $lsrf7(a, loose).major;
module.exports = $ce8474e0724f11bb$var$major;

});

parcelRegister("jFJyk", function(module, exports) {
'use strict';

var $lsrf7 = parcelRequire("lsrf7");
const $e5252e76710c823c$var$minor = (a, loose)=>new $lsrf7(a, loose).minor;
module.exports = $e5252e76710c823c$var$minor;

});

parcelRegister("4swJJ", function(module, exports) {
'use strict';

var $lsrf7 = parcelRequire("lsrf7");
const $33f32bbd701bf14a$var$patch = (a, loose)=>new $lsrf7(a, loose).patch;
module.exports = $33f32bbd701bf14a$var$patch;

});

parcelRegister("lC0tA", function(module, exports) {
'use strict';

var $eGdKX = parcelRequire("eGdKX");
const $fbbd8426af844b65$var$prerelease = (version, options)=>{
    const parsed = $eGdKX(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
module.exports = $fbbd8426af844b65$var$prerelease;

});

parcelRegister("igifu", function(module, exports) {
'use strict';

var $lsrf7 = parcelRequire("lsrf7");
const $d4b7e077eedd1a0d$var$compare = (a, b, loose)=>new $lsrf7(a, loose).compare(new $lsrf7(b, loose));
module.exports = $d4b7e077eedd1a0d$var$compare;

});

parcelRegister("bc5zZ", function(module, exports) {
'use strict';

var $igifu = parcelRequire("igifu");
const $021a67d136cf7a54$var$rcompare = (a, b, loose)=>$igifu(b, a, loose);
module.exports = $021a67d136cf7a54$var$rcompare;

});

parcelRegister("4lIKf", function(module, exports) {
'use strict';

var $igifu = parcelRequire("igifu");
const $32abd4fde65e4e3b$var$compareLoose = (a, b)=>$igifu(a, b, true);
module.exports = $32abd4fde65e4e3b$var$compareLoose;

});

parcelRegister("5FbVS", function(module, exports) {
'use strict';

var $lsrf7 = parcelRequire("lsrf7");
const $41fa09a77892ed76$var$compareBuild = (a, b, loose)=>{
    const versionA = new $lsrf7(a, loose);
    const versionB = new $lsrf7(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
module.exports = $41fa09a77892ed76$var$compareBuild;

});

parcelRegister("7ONNG", function(module, exports) {
'use strict';

var $5FbVS = parcelRequire("5FbVS");
const $5b13d53901910fdc$var$sort = (list, loose)=>list.sort((a, b)=>$5FbVS(a, b, loose));
module.exports = $5b13d53901910fdc$var$sort;

});

parcelRegister("9x2kx", function(module, exports) {
'use strict';

var $5FbVS = parcelRequire("5FbVS");
const $6f0900e327ee74a6$var$rsort = (list, loose)=>list.sort((a, b)=>$5FbVS(b, a, loose));
module.exports = $6f0900e327ee74a6$var$rsort;

});

parcelRegister("37Bc9", function(module, exports) {
'use strict';

var $igifu = parcelRequire("igifu");
const $245ee0b3b56eb9b2$var$gt = (a, b, loose)=>$igifu(a, b, loose) > 0;
module.exports = $245ee0b3b56eb9b2$var$gt;

});

parcelRegister("fEJAw", function(module, exports) {
'use strict';

var $igifu = parcelRequire("igifu");
const $b65df4443903ba8e$var$lt = (a, b, loose)=>$igifu(a, b, loose) < 0;
module.exports = $b65df4443903ba8e$var$lt;

});

parcelRegister("d4j3n", function(module, exports) {
'use strict';

var $igifu = parcelRequire("igifu");
const $983a6db45e909ab8$var$eq = (a, b, loose)=>$igifu(a, b, loose) === 0;
module.exports = $983a6db45e909ab8$var$eq;

});

parcelRegister("5buXb", function(module, exports) {
'use strict';

var $igifu = parcelRequire("igifu");
const $3c65fd95f6006f71$var$neq = (a, b, loose)=>$igifu(a, b, loose) !== 0;
module.exports = $3c65fd95f6006f71$var$neq;

});

parcelRegister("j0r87", function(module, exports) {
'use strict';

var $igifu = parcelRequire("igifu");
const $dd630fdfa1d419fb$var$gte = (a, b, loose)=>$igifu(a, b, loose) >= 0;
module.exports = $dd630fdfa1d419fb$var$gte;

});

parcelRegister("474UK", function(module, exports) {
'use strict';

var $igifu = parcelRequire("igifu");
const $2feba0c0869495f3$var$lte = (a, b, loose)=>$igifu(a, b, loose) <= 0;
module.exports = $2feba0c0869495f3$var$lte;

});

parcelRegister("hdkAh", function(module, exports) {
'use strict';

var $d4j3n = parcelRequire("d4j3n");

var $5buXb = parcelRequire("5buXb");

var $37Bc9 = parcelRequire("37Bc9");

var $j0r87 = parcelRequire("j0r87");

var $fEJAw = parcelRequire("fEJAw");

var $474UK = parcelRequire("474UK");
const $c8839e205ba64c9b$var$cmp = (a, op, b, loose)=>{
    switch(op){
        case '===':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a === b;
        case '!==':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a !== b;
        case '':
        case '=':
        case '==':
            return $d4j3n(a, b, loose);
        case '!=':
            return $5buXb(a, b, loose);
        case '>':
            return $37Bc9(a, b, loose);
        case '>=':
            return $j0r87(a, b, loose);
        case '<':
            return $fEJAw(a, b, loose);
        case '<=':
            return $474UK(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
module.exports = $c8839e205ba64c9b$var$cmp;

});

parcelRegister("h385f", function(module, exports) {
'use strict';

var $lsrf7 = parcelRequire("lsrf7");

var $eGdKX = parcelRequire("eGdKX");

var $2Fn7f = parcelRequire("2Fn7f");
var $c698fcb810d2953e$require$re = $2Fn7f.safeRe;
var $c698fcb810d2953e$require$t = $2Fn7f.t;
const $c698fcb810d2953e$var$coerce = (version, options)=>{
    if (version instanceof $lsrf7) return version;
    if (typeof version === 'number') version = String(version);
    if (typeof version !== 'string') return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match(options.includePrerelease ? $c698fcb810d2953e$require$re[$c698fcb810d2953e$require$t.COERCEFULL] : $c698fcb810d2953e$require$re[$c698fcb810d2953e$require$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        // With includePrerelease option set, '1.2.3.4-rc' wants to coerce '2.3.4-rc', not '2.3.4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        const coerceRtlRegex = options.includePrerelease ? $c698fcb810d2953e$require$re[$c698fcb810d2953e$require$t.COERCERTLFULL] : $c698fcb810d2953e$require$re[$c698fcb810d2953e$require$t.COERCERTL];
        let next;
        while((next = coerceRtlRegex.exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        coerceRtlRegex.lastIndex = -1;
    }
    if (match === null) return null;
    const major = match[2];
    const minor = match[3] || '0';
    const patch = match[4] || '0';
    const prerelease = options.includePrerelease && match[5] ? `-${match[5]}` : '';
    const build = options.includePrerelease && match[6] ? `+${match[6]}` : '';
    return $eGdKX(`${major}.${minor}.${patch}${prerelease}${build}`, options);
};
module.exports = $c698fcb810d2953e$var$coerce;

});

parcelRegister("45Coa", function(module, exports) {
'use strict';
const $2fa568494d3cfed3$var$ANY = Symbol('SemVer ANY');
// hoisted class for cyclic dependency
class $2fa568494d3cfed3$var$Comparator {
    static get ANY() {
        return $2fa568494d3cfed3$var$ANY;
    }
    constructor(comp, options){
        options = $l2f9c(options);
        if (comp instanceof $2fa568494d3cfed3$var$Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(' ');
        $6WnlW('comparator', comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $2fa568494d3cfed3$var$ANY) this.value = '';
        else this.value = this.operator + this.semver.version;
        $6WnlW('comp', this);
    }
    parse(comp) {
        const r = this.options.loose ? $2fa568494d3cfed3$require$re[$2fa568494d3cfed3$require$t.COMPARATORLOOSE] : $2fa568494d3cfed3$require$re[$2fa568494d3cfed3$require$t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : '';
        if (this.operator === '=') this.operator = '';
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = $2fa568494d3cfed3$var$ANY;
        else this.semver = new $lsrf7(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        $6WnlW('Comparator.test', version, this.options.loose);
        if (this.semver === $2fa568494d3cfed3$var$ANY || version === $2fa568494d3cfed3$var$ANY) return true;
        if (typeof version === 'string') try {
            version = new $lsrf7(version, this.options);
        } catch (er) {
            return false;
        }
        return $hdkAh(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof $2fa568494d3cfed3$var$Comparator)) throw new TypeError('a Comparator is required');
        if (this.operator === '') {
            if (this.value === '') return true;
            return new $kmPI0(comp.value, options).test(this.value);
        } else if (comp.operator === '') {
            if (comp.value === '') return true;
            return new $kmPI0(this.value, options).test(comp.semver);
        }
        options = $l2f9c(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === '<0.0.0-0' || comp.value === '<0.0.0-0')) return false;
        if (!options.includePrerelease && (this.value.startsWith('<0.0.0') || comp.value.startsWith('<0.0.0'))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith('>') && comp.operator.startsWith('>')) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith('<') && comp.operator.startsWith('<')) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes('=') && comp.operator.includes('=')) return true;
        // opposite directions less than
        if ($hdkAh(this.semver, '<', comp.semver, options) && this.operator.startsWith('>') && comp.operator.startsWith('<')) return true;
        // opposite directions greater than
        if ($hdkAh(this.semver, '>', comp.semver, options) && this.operator.startsWith('<') && comp.operator.startsWith('>')) return true;
        return false;
    }
}
module.exports = $2fa568494d3cfed3$var$Comparator;

var $l2f9c = parcelRequire("l2f9c");

var $2Fn7f = parcelRequire("2Fn7f");
var $2fa568494d3cfed3$require$re = $2Fn7f.safeRe;
var $2fa568494d3cfed3$require$t = $2Fn7f.t;

var $hdkAh = parcelRequire("hdkAh");

var $6WnlW = parcelRequire("6WnlW");

var $lsrf7 = parcelRequire("lsrf7");

var $kmPI0 = parcelRequire("kmPI0");

});
parcelRegister("kmPI0", function(module, exports) {
'use strict';
const $ed3df903f688c352$var$SPACE_CHARACTERS = /\s+/g;
// hoisted class for cyclic dependency
class $ed3df903f688c352$var$Range {
    constructor(range, options){
        options = $l2f9c(options);
        if (range instanceof $ed3df903f688c352$var$Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new $ed3df903f688c352$var$Range(range.raw, options);
        }
        if (range instanceof $45Coa) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.formatted = undefined;
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().replace($ed3df903f688c352$var$SPACE_CHARACTERS, ' ');
        // First, split on ||
        this.set = this.raw.split('||')// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!$ed3df903f688c352$var$isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && $ed3df903f688c352$var$isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.formatted = undefined;
    }
    get range() {
        if (this.formatted === undefined) {
            this.formatted = '';
            for(let i = 0; i < this.set.length; i++){
                if (i > 0) this.formatted += '||';
                const comps = this.set[i];
                for(let k = 0; k < comps.length; k++){
                    if (k > 0) this.formatted += ' ';
                    this.formatted += comps[k].toString().trim();
                }
            }
        }
        return this.formatted;
    }
    format() {
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && $ed3df903f688c352$require$FLAG_INCLUDE_PRERELEASE) | (this.options.loose && $ed3df903f688c352$require$FLAG_LOOSE);
        const memoKey = memoOpts + ':' + range;
        const cached = $ed3df903f688c352$var$cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? $ed3df903f688c352$require$re[$ed3df903f688c352$require$t.HYPHENRANGELOOSE] : $ed3df903f688c352$require$re[$ed3df903f688c352$require$t.HYPHENRANGE];
        range = range.replace(hr, $ed3df903f688c352$var$hyphenReplace(this.options.includePrerelease));
        $6WnlW('hyphen replace', range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace($ed3df903f688c352$require$re[$ed3df903f688c352$require$t.COMPARATORTRIM], $ed3df903f688c352$require$comparatorTrimReplace);
        $6WnlW('comparator trim', range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace($ed3df903f688c352$require$re[$ed3df903f688c352$require$t.TILDETRIM], $ed3df903f688c352$require$tildeTrimReplace);
        $6WnlW('tilde trim', range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace($ed3df903f688c352$require$re[$ed3df903f688c352$require$t.CARETTRIM], $ed3df903f688c352$require$caretTrimReplace);
        $6WnlW('caret trim', range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(' ').map((comp)=>$ed3df903f688c352$var$parseComparator(comp, this.options)).join(' ').split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>$ed3df903f688c352$var$replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            $6WnlW('loose invalid filter', comp, this.options);
            return !!comp.match($ed3df903f688c352$require$re[$ed3df903f688c352$require$t.COMPARATORLOOSE]);
        });
        $6WnlW('range list', rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new $45Coa(comp, this.options));
        for (const comp of comparators){
            if ($ed3df903f688c352$var$isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has('')) rangeMap.delete('');
        const result = [
            ...rangeMap.values()
        ];
        $ed3df903f688c352$var$cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof $ed3df903f688c352$var$Range)) throw new TypeError('a Range is required');
        return this.set.some((thisComparators)=>{
            return $ed3df903f688c352$var$isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return $ed3df903f688c352$var$isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === 'string') try {
            version = new $lsrf7(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if ($ed3df903f688c352$var$testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
module.exports = $ed3df903f688c352$var$Range;

var $9xTWv = parcelRequire("9xTWv");
const $ed3df903f688c352$var$cache = new $9xTWv();

var $l2f9c = parcelRequire("l2f9c");

var $45Coa = parcelRequire("45Coa");

var $6WnlW = parcelRequire("6WnlW");

var $lsrf7 = parcelRequire("lsrf7");

var $2Fn7f = parcelRequire("2Fn7f");
var $ed3df903f688c352$require$re = $2Fn7f.safeRe;
var $ed3df903f688c352$require$t = $2Fn7f.t;
var $ed3df903f688c352$require$comparatorTrimReplace = $2Fn7f.comparatorTrimReplace;
var $ed3df903f688c352$require$tildeTrimReplace = $2Fn7f.tildeTrimReplace;
var $ed3df903f688c352$require$caretTrimReplace = $2Fn7f.caretTrimReplace;

var $bxcIS = parcelRequire("bxcIS");
var $ed3df903f688c352$require$FLAG_INCLUDE_PRERELEASE = $bxcIS.FLAG_INCLUDE_PRERELEASE;
var $ed3df903f688c352$require$FLAG_LOOSE = $bxcIS.FLAG_LOOSE;
const $ed3df903f688c352$var$isNullSet = (c)=>c.value === '<0.0.0-0';
const $ed3df903f688c352$var$isAny = (c)=>c.value === '';
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const $ed3df903f688c352$var$isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const $ed3df903f688c352$var$parseComparator = (comp, options)=>{
    comp = comp.replace($ed3df903f688c352$require$re[$ed3df903f688c352$require$t.BUILD], '');
    $6WnlW('comp', comp, options);
    comp = $ed3df903f688c352$var$replaceCarets(comp, options);
    $6WnlW('caret', comp);
    comp = $ed3df903f688c352$var$replaceTildes(comp, options);
    $6WnlW('tildes', comp);
    comp = $ed3df903f688c352$var$replaceXRanges(comp, options);
    $6WnlW('xrange', comp);
    comp = $ed3df903f688c352$var$replaceStars(comp, options);
    $6WnlW('stars', comp);
    return comp;
};
const $ed3df903f688c352$var$isX = (id)=>!id || id.toLowerCase() === 'x' || id === '*';
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const $ed3df903f688c352$var$replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$ed3df903f688c352$var$replaceTilde(c, options)).join(' ');
};
const $ed3df903f688c352$var$replaceTilde = (comp, options)=>{
    const r = options.loose ? $ed3df903f688c352$require$re[$ed3df903f688c352$require$t.TILDELOOSE] : $ed3df903f688c352$require$re[$ed3df903f688c352$require$t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        $6WnlW('tilde', comp, _, M, m, p, pr);
        let ret;
        if ($ed3df903f688c352$var$isX(M)) ret = '';
        else if ($ed3df903f688c352$var$isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if ($ed3df903f688c352$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            $6WnlW('replaceTilde pr', pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        $6WnlW('tilde return', ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const $ed3df903f688c352$var$replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$ed3df903f688c352$var$replaceCaret(c, options)).join(' ');
};
const $ed3df903f688c352$var$replaceCaret = (comp, options)=>{
    $6WnlW('caret', comp, options);
    const r = options.loose ? $ed3df903f688c352$require$re[$ed3df903f688c352$require$t.CARETLOOSE] : $ed3df903f688c352$require$re[$ed3df903f688c352$require$t.CARET];
    const z = options.includePrerelease ? '-0' : '';
    return comp.replace(r, (_, M, m, p, pr)=>{
        $6WnlW('caret', comp, _, M, m, p, pr);
        let ret;
        if ($ed3df903f688c352$var$isX(M)) ret = '';
        else if ($ed3df903f688c352$var$isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if ($ed3df903f688c352$var$isX(p)) {
            if (M === '0') ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            $6WnlW('replaceCaret pr', pr);
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            $6WnlW('no pr');
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        $6WnlW('caret return', ret);
        return ret;
    });
};
const $ed3df903f688c352$var$replaceXRanges = (comp, options)=>{
    $6WnlW('replaceXRanges', comp, options);
    return comp.split(/\s+/).map((c)=>$ed3df903f688c352$var$replaceXRange(c, options)).join(' ');
};
const $ed3df903f688c352$var$replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? $ed3df903f688c352$require$re[$ed3df903f688c352$require$t.XRANGELOOSE] : $ed3df903f688c352$require$re[$ed3df903f688c352$require$t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        $6WnlW('xRange', comp, ret, gtlt, M, m, p, pr);
        const xM = $ed3df903f688c352$var$isX(M);
        const xm = xM || $ed3df903f688c352$var$isX(m);
        const xp = xm || $ed3df903f688c352$var$isX(p);
        const anyX = xp;
        if (gtlt === '=' && anyX) gtlt = '';
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? '-0' : '';
        if (xM) {
            if (gtlt === '>' || gtlt === '<') // nothing is allowed
            ret = '<0.0.0-0';
            else // nothing is forbidden
            ret = '*';
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === '>') {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = '>=';
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === '<=') {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = '<';
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === '<') pr = '-0';
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        $6WnlW('xRange return', ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const $ed3df903f688c352$var$replaceStars = (comp, options)=>{
    $6WnlW('replaceStars', comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($ed3df903f688c352$require$re[$ed3df903f688c352$require$t.STAR], '');
};
const $ed3df903f688c352$var$replaceGTE0 = (comp, options)=>{
    $6WnlW('replaceGTE0', comp, options);
    return comp.trim().replace($ed3df903f688c352$require$re[options.includePrerelease ? $ed3df903f688c352$require$t.GTE0PRE : $ed3df903f688c352$require$t.GTE0], '');
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
// TODO build?
const $ed3df903f688c352$var$hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr)=>{
        if ($ed3df903f688c352$var$isX(fM)) from = '';
        else if ($ed3df903f688c352$var$isX(fm)) from = `>=${fM}.0.0${incPr ? '-0' : ''}`;
        else if ($ed3df903f688c352$var$isX(fp)) from = `>=${fM}.${fm}.0${incPr ? '-0' : ''}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? '-0' : ''}`;
        if ($ed3df903f688c352$var$isX(tM)) to = '';
        else if ($ed3df903f688c352$var$isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if ($ed3df903f688c352$var$isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const $ed3df903f688c352$var$testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            $6WnlW(set[i].semver);
            if (set[i].semver === $45Coa.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};

});
parcelRegister("9xTWv", function(module, exports) {
'use strict';
class $6f329725c41fc9c2$var$LRUCache {
    constructor(){
        this.max = 1000;
        this.map = new Map();
    }
    get(key) {
        const value = this.map.get(key);
        if (value === undefined) return undefined;
        else {
            // Remove the key from the map and add it to the end
            this.map.delete(key);
            this.map.set(key, value);
            return value;
        }
    }
    delete(key) {
        return this.map.delete(key);
    }
    set(key, value) {
        const deleted = this.delete(key);
        if (!deleted && value !== undefined) {
            // If cache is full, delete the least recently used item
            if (this.map.size >= this.max) {
                const firstKey = this.map.keys().next().value;
                this.delete(firstKey);
            }
            this.map.set(key, value);
        }
        return this;
    }
}
module.exports = $6f329725c41fc9c2$var$LRUCache;

});



parcelRegister("ijgnV", function(module, exports) {
'use strict';

var $kmPI0 = parcelRequire("kmPI0");
const $d546b6087f8d96cb$var$satisfies = (version, range, options)=>{
    try {
        range = new $kmPI0(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
module.exports = $d546b6087f8d96cb$var$satisfies;

});

parcelRegister("30u73", function(module, exports) {
'use strict';

var $kmPI0 = parcelRequire("kmPI0");
// Mostly just for testing and legacy API reasons
const $2308baf316917c41$var$toComparators = (range, options)=>new $kmPI0(range, options).set.map((comp)=>comp.map((c)=>c.value).join(' ').trim().split(' '));
module.exports = $2308baf316917c41$var$toComparators;

});

parcelRegister("31c4J", function(module, exports) {
'use strict';

var $lsrf7 = parcelRequire("lsrf7");

var $kmPI0 = parcelRequire("kmPI0");
const $232ad4feae547372$var$maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $kmPI0(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $lsrf7(max, options);
            }
        }
    });
    return max;
};
module.exports = $232ad4feae547372$var$maxSatisfying;

});

parcelRegister("fR1pK", function(module, exports) {
'use strict';

var $lsrf7 = parcelRequire("lsrf7");

var $kmPI0 = parcelRequire("kmPI0");
const $b8ace714af2dc930$var$minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $kmPI0(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $lsrf7(min, options);
            }
        }
    });
    return min;
};
module.exports = $b8ace714af2dc930$var$minSatisfying;

});

parcelRegister("8KhX7", function(module, exports) {
'use strict';

var $lsrf7 = parcelRequire("lsrf7");

var $kmPI0 = parcelRequire("kmPI0");

var $37Bc9 = parcelRequire("37Bc9");
const $65e08ba16034c402$var$minVersion = (range, loose)=>{
    range = new $kmPI0(range, loose);
    let minver = new $lsrf7('0.0.0');
    if (range.test(minver)) return minver;
    minver = new $lsrf7('0.0.0-0');
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new $lsrf7(comparator.semver.version);
            switch(comparator.operator){
                case '>':
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case '':
                case '>=':
                    if (!setMin || $37Bc9(compver, setMin)) setMin = compver;
                    break;
                case '<':
                case '<=':
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || $37Bc9(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
module.exports = $65e08ba16034c402$var$minVersion;

});

parcelRegister("ddxDA", function(module, exports) {
'use strict';

var $kmPI0 = parcelRequire("kmPI0");
const $99f694f4f9c8a84e$var$validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $kmPI0(range, options).range || '*';
    } catch (er) {
        return null;
    }
};
module.exports = $99f694f4f9c8a84e$var$validRange;

});

parcelRegister("6AKEC", function(module, exports) {
'use strict';

var $lsrf7 = parcelRequire("lsrf7");

var $45Coa = parcelRequire("45Coa");
const { ANY: $4cca4b69f1be2ba9$var$ANY } = $45Coa;

var $kmPI0 = parcelRequire("kmPI0");

var $ijgnV = parcelRequire("ijgnV");

var $37Bc9 = parcelRequire("37Bc9");

var $fEJAw = parcelRequire("fEJAw");

var $474UK = parcelRequire("474UK");

var $j0r87 = parcelRequire("j0r87");
const $4cca4b69f1be2ba9$var$outside = (version, range, hilo, options)=>{
    version = new $lsrf7(version, options);
    range = new $kmPI0(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case '>':
            gtfn = $37Bc9;
            ltefn = $474UK;
            ltfn = $fEJAw;
            comp = '>';
            ecomp = '>=';
            break;
        case '<':
            gtfn = $fEJAw;
            ltefn = $j0r87;
            ltfn = $37Bc9;
            comp = '<';
            ecomp = '<=';
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($ijgnV(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === $4cca4b69f1be2ba9$var$ANY) comparator = new $45Coa('>=0.0.0');
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
module.exports = $4cca4b69f1be2ba9$var$outside;

});

parcelRegister("azTB8", function(module, exports) {
'use strict';

var $6AKEC = parcelRequire("6AKEC");
const $7b384ce068d2601b$var$gtr = (version, range, options)=>$6AKEC(version, range, '>', options);
module.exports = $7b384ce068d2601b$var$gtr;

});

parcelRegister("konvZ", function(module, exports) {
'use strict';

var $6AKEC = parcelRequire("6AKEC");
// Determine if version is less than all the versions possible in the range
const $ed884a248040aabb$var$ltr = (version, range, options)=>$6AKEC(version, range, '<', options);
module.exports = $ed884a248040aabb$var$ltr;

});

parcelRegister("5FEXN", function(module, exports) {
'use strict';

var $kmPI0 = parcelRequire("kmPI0");
const $42108e937a0c794c$var$intersects = (r1, r2, options)=>{
    r1 = new $kmPI0(r1, options);
    r2 = new $kmPI0(r2, options);
    return r1.intersects(r2, options);
};
module.exports = $42108e937a0c794c$var$intersects;

});

parcelRegister("77dzh", function(module, exports) {
'use strict';

var $ijgnV = parcelRequire("ijgnV");

var $igifu = parcelRequire("igifu");
module.exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>$igifu(a, b, options));
    for (const version of v){
        const included = $ijgnV(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push('*');
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(' || ');
    const original = typeof range.raw === 'string' ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};

});

parcelRegister("abdDP", function(module, exports) {
'use strict';

var $kmPI0 = parcelRequire("kmPI0");

var $45Coa = parcelRequire("45Coa");
const { ANY: $769583567dfc7959$var$ANY } = $45Coa;

var $ijgnV = parcelRequire("ijgnV");

var $igifu = parcelRequire("igifu");
// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const $769583567dfc7959$var$subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new $kmPI0(sub, options);
    dom = new $kmPI0(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = $769583567dfc7959$var$simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const $769583567dfc7959$var$minimumVersionWithPreRelease = [
    new $45Coa('>=0.0.0-0')
];
const $769583567dfc7959$var$minimumVersion = [
    new $45Coa('>=0.0.0')
];
const $769583567dfc7959$var$simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $769583567dfc7959$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $769583567dfc7959$var$ANY) return true;
        else if (options.includePrerelease) sub = $769583567dfc7959$var$minimumVersionWithPreRelease;
        else sub = $769583567dfc7959$var$minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === $769583567dfc7959$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = $769583567dfc7959$var$minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === '>' || c.operator === '>=') gt = $769583567dfc7959$var$higherGT(gt, c, options);
        else if (c.operator === '<' || c.operator === '<=') lt = $769583567dfc7959$var$lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = $igifu(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== '>=' || lt.operator !== '<=')) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !$ijgnV(eq, String(gt), options)) return null;
        if (lt && !$ijgnV(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!$ijgnV(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === '<' && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === '>' || c.operator === '>=';
        hasDomLT = hasDomLT || c.operator === '<' || c.operator === '<=';
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === '>' || c.operator === '>=') {
                higher = $769583567dfc7959$var$higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === '>=' && !$ijgnV(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === '<' || c.operator === '<=') {
                lower = $769583567dfc7959$var$lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === '<=' && !$ijgnV(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const $769583567dfc7959$var$higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = $igifu(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === '>' && a.operator === '>=' ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const $769583567dfc7959$var$lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = $igifu(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === '<' && a.operator === '<=' ? b : a;
};
module.exports = $769583567dfc7959$var$subset;

});



parcelRegister("dtadb", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");

var $6C34p = parcelRequire("6C34p");
module.exports = $6C34p.satisfies($4TNnu.version, '>=16.9.0');

});


parcelRegister("3YUTJ", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");

var $6C34p = parcelRequire("6C34p");
module.exports = $6C34p.satisfies($4TNnu.version, '^6.12.0 || >=8.0.0');

});


parcelRegister("hgMMB", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $c929c592920f9fe5$require$Buffer = $ihoyg.Buffer;

var $6AsMe = parcelRequire("6AsMe");

var $3YUTJ = parcelRequire("3YUTJ");

var $cKDCQ = parcelRequire("cKDCQ");

var $2TGdH = parcelRequire("2TGdH");

var $co3Xp = parcelRequire("co3Xp");

var $gh3Ao = parcelRequire("gh3Ao");

var $8KKp6 = parcelRequire("8KKp6");

var $14FDQ = parcelRequire("14FDQ");

var $9qlBU = parcelRequire("9qlBU");

var $8HHIj = parcelRequire("8HHIj");

var $6Gciw = parcelRequire("6Gciw");

var $aO8Ot = parcelRequire("aO8Ot");
var $c929c592920f9fe5$require$KeyObject = $aO8Ot.KeyObject;
var $c929c592920f9fe5$require$createSecretKey = $aO8Ot.createSecretKey;
var $c929c592920f9fe5$require$createPrivateKey = $aO8Ot.createPrivateKey;
const $c929c592920f9fe5$var$SUPPORTED_ALGS = [
    'RS256',
    'RS384',
    'RS512',
    'ES256',
    'ES384',
    'ES512',
    'HS256',
    'HS384',
    'HS512',
    'none'
];
if ($3YUTJ) $c929c592920f9fe5$var$SUPPORTED_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
const $c929c592920f9fe5$var$sign_options_schema = {
    expiresIn: {
        isValid: function(value) {
            return $8KKp6(value) || $8HHIj(value) && value;
        },
        message: '"expiresIn" should be a number of seconds or string representing a timespan'
    },
    notBefore: {
        isValid: function(value) {
            return $8KKp6(value) || $8HHIj(value) && value;
        },
        message: '"notBefore" should be a number of seconds or string representing a timespan'
    },
    audience: {
        isValid: function(value) {
            return $8HHIj(value) || Array.isArray(value);
        },
        message: '"audience" must be a string or array'
    },
    algorithm: {
        isValid: $co3Xp.bind(null, $c929c592920f9fe5$var$SUPPORTED_ALGS),
        message: '"algorithm" must be a valid string enum value'
    },
    header: {
        isValid: $9qlBU,
        message: '"header" must be an object'
    },
    encoding: {
        isValid: $8HHIj,
        message: '"encoding" must be a string'
    },
    issuer: {
        isValid: $8HHIj,
        message: '"issuer" must be a string'
    },
    subject: {
        isValid: $8HHIj,
        message: '"subject" must be a string'
    },
    jwtid: {
        isValid: $8HHIj,
        message: '"jwtid" must be a string'
    },
    noTimestamp: {
        isValid: $gh3Ao,
        message: '"noTimestamp" must be a boolean'
    },
    keyid: {
        isValid: $8HHIj,
        message: '"keyid" must be a string'
    },
    mutatePayload: {
        isValid: $gh3Ao,
        message: '"mutatePayload" must be a boolean'
    },
    allowInsecureKeySizes: {
        isValid: $gh3Ao,
        message: '"allowInsecureKeySizes" must be a boolean'
    },
    allowInvalidAsymmetricKeyTypes: {
        isValid: $gh3Ao,
        message: '"allowInvalidAsymmetricKeyTypes" must be a boolean'
    }
};
const $c929c592920f9fe5$var$registered_claims_schema = {
    iat: {
        isValid: $14FDQ,
        message: '"iat" should be a number of seconds'
    },
    exp: {
        isValid: $14FDQ,
        message: '"exp" should be a number of seconds'
    },
    nbf: {
        isValid: $14FDQ,
        message: '"nbf" should be a number of seconds'
    }
};
function $c929c592920f9fe5$var$validate(schema, allowUnknown, object, parameterName) {
    if (!$9qlBU(object)) throw new Error('Expected "' + parameterName + '" to be a plain object.');
    Object.keys(object).forEach(function(key) {
        const validator = schema[key];
        if (!validator) {
            if (!allowUnknown) throw new Error('"' + key + '" is not allowed in "' + parameterName + '"');
            return;
        }
        if (!validator.isValid(object[key])) throw new Error(validator.message);
    });
}
function $c929c592920f9fe5$var$validateOptions(options) {
    return $c929c592920f9fe5$var$validate($c929c592920f9fe5$var$sign_options_schema, false, options, 'options');
}
function $c929c592920f9fe5$var$validatePayload(payload) {
    return $c929c592920f9fe5$var$validate($c929c592920f9fe5$var$registered_claims_schema, true, payload, 'payload');
}
const $c929c592920f9fe5$var$options_to_payload = {
    'audience': 'aud',
    'issuer': 'iss',
    'subject': 'sub',
    'jwtid': 'jti'
};
const $c929c592920f9fe5$var$options_for_objects = [
    'expiresIn',
    'notBefore',
    'noTimestamp',
    'audience',
    'issuer',
    'subject',
    'jwtid'
];
module.exports = function(payload, secretOrPrivateKey, options, callback) {
    if (typeof options === 'function') {
        callback = options;
        options = {};
    } else options = options || {};
    const isObjectPayload = typeof payload === 'object' && !$c929c592920f9fe5$require$Buffer.isBuffer(payload);
    const header = Object.assign({
        alg: options.algorithm || 'HS256',
        typ: isObjectPayload ? 'JWT' : undefined,
        kid: options.keyid
    }, options.header);
    function failure(err) {
        if (callback) return callback(err);
        throw err;
    }
    if (!secretOrPrivateKey && options.algorithm !== 'none') return failure(new Error('secretOrPrivateKey must have a value'));
    if (secretOrPrivateKey != null && !(secretOrPrivateKey instanceof $c929c592920f9fe5$require$KeyObject)) try {
        secretOrPrivateKey = $c929c592920f9fe5$require$createPrivateKey(secretOrPrivateKey);
    } catch (_) {
        try {
            secretOrPrivateKey = $c929c592920f9fe5$require$createSecretKey(typeof secretOrPrivateKey === 'string' ? $c929c592920f9fe5$require$Buffer.from(secretOrPrivateKey) : secretOrPrivateKey);
        } catch (_) {
            return failure(new Error('secretOrPrivateKey is not valid key material'));
        }
    }
    if (header.alg.startsWith('HS') && secretOrPrivateKey.type !== 'secret') return failure(new Error(`secretOrPrivateKey must be a symmetric key when using ${header.alg}`));
    else if (/^(?:RS|PS|ES)/.test(header.alg)) {
        if (secretOrPrivateKey.type !== 'private') return failure(new Error(`secretOrPrivateKey must be an asymmetric key when using ${header.alg}`));
        if (!options.allowInsecureKeySizes && !header.alg.startsWith('ES') && secretOrPrivateKey.asymmetricKeyDetails !== undefined && //KeyObject.asymmetricKeyDetails is supported in Node 15+
        secretOrPrivateKey.asymmetricKeyDetails.modulusLength < 2048) return failure(new Error(`secretOrPrivateKey has a minimum key size of 2048 bits for ${header.alg}`));
    }
    if (typeof payload === 'undefined') return failure(new Error('payload is required'));
    else if (isObjectPayload) {
        try {
            $c929c592920f9fe5$var$validatePayload(payload);
        } catch (error) {
            return failure(error);
        }
        if (!options.mutatePayload) payload = Object.assign({}, payload);
    } else {
        const invalid_options = $c929c592920f9fe5$var$options_for_objects.filter(function(opt) {
            return typeof options[opt] !== 'undefined';
        });
        if (invalid_options.length > 0) return failure(new Error('invalid ' + invalid_options.join(',') + ' option for ' + typeof payload + ' payload'));
    }
    if (typeof payload.exp !== 'undefined' && typeof options.expiresIn !== 'undefined') return failure(new Error('Bad "options.expiresIn" option the payload already has an "exp" property.'));
    if (typeof payload.nbf !== 'undefined' && typeof options.notBefore !== 'undefined') return failure(new Error('Bad "options.notBefore" option the payload already has an "nbf" property.'));
    try {
        $c929c592920f9fe5$var$validateOptions(options);
    } catch (error) {
        return failure(error);
    }
    if (!options.allowInvalidAsymmetricKeyTypes) try {
        $cKDCQ(header.alg, secretOrPrivateKey);
    } catch (error) {
        return failure(error);
    }
    const timestamp = payload.iat || Math.floor(Date.now() / 1000);
    if (options.noTimestamp) delete payload.iat;
    else if (isObjectPayload) payload.iat = timestamp;
    if (typeof options.notBefore !== 'undefined') {
        try {
            payload.nbf = $6AsMe(options.notBefore, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.nbf === 'undefined') return failure(new Error('"notBefore" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    if (typeof options.expiresIn !== 'undefined' && typeof payload === 'object') {
        try {
            payload.exp = $6AsMe(options.expiresIn, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.exp === 'undefined') return failure(new Error('"expiresIn" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    Object.keys($c929c592920f9fe5$var$options_to_payload).forEach(function(key) {
        const claim = $c929c592920f9fe5$var$options_to_payload[key];
        if (typeof options[key] !== 'undefined') {
            if (typeof payload[claim] !== 'undefined') return failure(new Error('Bad "options.' + key + '" option. The payload already has an "' + claim + '" property.'));
            payload[claim] = options[key];
        }
    });
    const encoding = options.encoding || 'utf8';
    if (typeof callback === 'function') {
        callback = callback && $6Gciw(callback);
        $2TGdH.createSign({
            header: header,
            privateKey: secretOrPrivateKey,
            payload: payload,
            encoding: encoding
        }).once('error', callback).once('done', function(signature) {
            // TODO: Remove in favor of the modulus length check before signing once node 15+ is the minimum supported version
            if (!options.allowInsecureKeySizes && /^(?:RS|PS)/.test(header.alg) && signature.length < 256) return callback(new Error(`secretOrPrivateKey has a minimum key size of 2048 bits for ${header.alg}`));
            callback(null, signature);
        });
    } else {
        let signature = $2TGdH.sign({
            header: header,
            payload: payload,
            secret: secretOrPrivateKey,
            encoding: encoding
        });
        // TODO: Remove in favor of the modulus length check before signing once node 15+ is the minimum supported version
        if (!options.allowInsecureKeySizes && /^(?:RS|PS)/.test(header.alg) && signature.length < 256) throw new Error(`secretOrPrivateKey has a minimum key size of 2048 bits for ${header.alg}`);
        return signature;
    }
};

});
parcelRegister("co3Xp", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $904acbbfa44e35b1$var$INFINITY = 1 / 0, $904acbbfa44e35b1$var$MAX_SAFE_INTEGER = 9007199254740991, $904acbbfa44e35b1$var$MAX_INTEGER = 1.7976931348623157e+308, $904acbbfa44e35b1$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $904acbbfa44e35b1$var$argsTag = '[object Arguments]', $904acbbfa44e35b1$var$funcTag = '[object Function]', $904acbbfa44e35b1$var$genTag = '[object GeneratorFunction]', $904acbbfa44e35b1$var$stringTag = '[object String]', $904acbbfa44e35b1$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $904acbbfa44e35b1$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $904acbbfa44e35b1$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $904acbbfa44e35b1$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $904acbbfa44e35b1$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $904acbbfa44e35b1$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Built-in method references without a dependency on `root`. */ var $904acbbfa44e35b1$var$freeParseInt = parseInt;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $904acbbfa44e35b1$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $904acbbfa44e35b1$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $904acbbfa44e35b1$var$baseIndexOf(array, value, fromIndex) {
    if (value !== value) return $904acbbfa44e35b1$var$baseFindIndex(array, $904acbbfa44e35b1$var$baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $904acbbfa44e35b1$var$baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $904acbbfa44e35b1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $904acbbfa44e35b1$var$baseValues(object, props) {
    return $904acbbfa44e35b1$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $904acbbfa44e35b1$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $904acbbfa44e35b1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $904acbbfa44e35b1$var$hasOwnProperty = $904acbbfa44e35b1$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $904acbbfa44e35b1$var$objectToString = $904acbbfa44e35b1$var$objectProto.toString;
/** Built-in value references. */ var $904acbbfa44e35b1$var$propertyIsEnumerable = $904acbbfa44e35b1$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $904acbbfa44e35b1$var$nativeKeys = $904acbbfa44e35b1$var$overArg(Object.keys, Object), $904acbbfa44e35b1$var$nativeMax = Math.max;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $904acbbfa44e35b1$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $904acbbfa44e35b1$var$isArray(value) || $904acbbfa44e35b1$var$isArguments(value) ? $904acbbfa44e35b1$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $904acbbfa44e35b1$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || $904acbbfa44e35b1$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $904acbbfa44e35b1$var$baseKeys(object) {
    if (!$904acbbfa44e35b1$var$isPrototype(object)) return $904acbbfa44e35b1$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($904acbbfa44e35b1$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $904acbbfa44e35b1$var$isIndex(value, length) {
    length = length == null ? $904acbbfa44e35b1$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || $904acbbfa44e35b1$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $904acbbfa44e35b1$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $904acbbfa44e35b1$var$objectProto;
    return value === proto;
}
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $904acbbfa44e35b1$var$includes(collection, value, fromIndex, guard) {
    collection = $904acbbfa44e35b1$var$isArrayLike(collection) ? collection : $904acbbfa44e35b1$var$values(collection);
    fromIndex = fromIndex && !guard ? $904acbbfa44e35b1$var$toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $904acbbfa44e35b1$var$nativeMax(length + fromIndex, 0);
    return $904acbbfa44e35b1$var$isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $904acbbfa44e35b1$var$baseIndexOf(collection, value, fromIndex) > -1;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $904acbbfa44e35b1$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $904acbbfa44e35b1$var$isArrayLikeObject(value) && $904acbbfa44e35b1$var$hasOwnProperty.call(value, 'callee') && (!$904acbbfa44e35b1$var$propertyIsEnumerable.call(value, 'callee') || $904acbbfa44e35b1$var$objectToString.call(value) == $904acbbfa44e35b1$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $904acbbfa44e35b1$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $904acbbfa44e35b1$var$isArrayLike(value) {
    return value != null && $904acbbfa44e35b1$var$isLength(value.length) && !$904acbbfa44e35b1$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $904acbbfa44e35b1$var$isArrayLikeObject(value) {
    return $904acbbfa44e35b1$var$isObjectLike(value) && $904acbbfa44e35b1$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $904acbbfa44e35b1$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $904acbbfa44e35b1$var$isObject(value) ? $904acbbfa44e35b1$var$objectToString.call(value) : '';
    return tag == $904acbbfa44e35b1$var$funcTag || tag == $904acbbfa44e35b1$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $904acbbfa44e35b1$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $904acbbfa44e35b1$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $904acbbfa44e35b1$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $904acbbfa44e35b1$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $904acbbfa44e35b1$var$isString(value) {
    return typeof value == 'string' || !$904acbbfa44e35b1$var$isArray(value) && $904acbbfa44e35b1$var$isObjectLike(value) && $904acbbfa44e35b1$var$objectToString.call(value) == $904acbbfa44e35b1$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $904acbbfa44e35b1$var$isSymbol(value) {
    return typeof value == 'symbol' || $904acbbfa44e35b1$var$isObjectLike(value) && $904acbbfa44e35b1$var$objectToString.call(value) == $904acbbfa44e35b1$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $904acbbfa44e35b1$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $904acbbfa44e35b1$var$toNumber(value);
    if (value === $904acbbfa44e35b1$var$INFINITY || value === -$904acbbfa44e35b1$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $904acbbfa44e35b1$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $904acbbfa44e35b1$var$toInteger(value) {
    var result = $904acbbfa44e35b1$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $904acbbfa44e35b1$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($904acbbfa44e35b1$var$isSymbol(value)) return $904acbbfa44e35b1$var$NAN;
    if ($904acbbfa44e35b1$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $904acbbfa44e35b1$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($904acbbfa44e35b1$var$reTrim, '');
    var isBinary = $904acbbfa44e35b1$var$reIsBinary.test(value);
    return isBinary || $904acbbfa44e35b1$var$reIsOctal.test(value) ? $904acbbfa44e35b1$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $904acbbfa44e35b1$var$reIsBadHex.test(value) ? $904acbbfa44e35b1$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $904acbbfa44e35b1$var$keys(object) {
    return $904acbbfa44e35b1$var$isArrayLike(object) ? $904acbbfa44e35b1$var$arrayLikeKeys(object) : $904acbbfa44e35b1$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $904acbbfa44e35b1$var$values(object) {
    return object ? $904acbbfa44e35b1$var$baseValues(object, $904acbbfa44e35b1$var$keys(object)) : [];
}
module.exports = $904acbbfa44e35b1$var$includes;

});

parcelRegister("gh3Ao", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $bd9103f3bc01d035$var$boolTag = '[object Boolean]';
/** Used for built-in method references. */ var $bd9103f3bc01d035$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bd9103f3bc01d035$var$objectToString = $bd9103f3bc01d035$var$objectProto.toString;
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $bd9103f3bc01d035$var$isBoolean(value) {
    return value === true || value === false || $bd9103f3bc01d035$var$isObjectLike(value) && $bd9103f3bc01d035$var$objectToString.call(value) == $bd9103f3bc01d035$var$boolTag;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $bd9103f3bc01d035$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
module.exports = $bd9103f3bc01d035$var$isBoolean;

});

parcelRegister("8KKp6", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $65f69d7756681eb0$var$INFINITY = 1 / 0, $65f69d7756681eb0$var$MAX_INTEGER = 1.7976931348623157e+308, $65f69d7756681eb0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $65f69d7756681eb0$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $65f69d7756681eb0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $65f69d7756681eb0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $65f69d7756681eb0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $65f69d7756681eb0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $65f69d7756681eb0$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $65f69d7756681eb0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $65f69d7756681eb0$var$objectToString = $65f69d7756681eb0$var$objectProto.toString;
/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */ function $65f69d7756681eb0$var$isInteger(value) {
    return typeof value == 'number' && value == $65f69d7756681eb0$var$toInteger(value);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $65f69d7756681eb0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $65f69d7756681eb0$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $65f69d7756681eb0$var$isSymbol(value) {
    return typeof value == 'symbol' || $65f69d7756681eb0$var$isObjectLike(value) && $65f69d7756681eb0$var$objectToString.call(value) == $65f69d7756681eb0$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $65f69d7756681eb0$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $65f69d7756681eb0$var$toNumber(value);
    if (value === $65f69d7756681eb0$var$INFINITY || value === -$65f69d7756681eb0$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $65f69d7756681eb0$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $65f69d7756681eb0$var$toInteger(value) {
    var result = $65f69d7756681eb0$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $65f69d7756681eb0$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($65f69d7756681eb0$var$isSymbol(value)) return $65f69d7756681eb0$var$NAN;
    if ($65f69d7756681eb0$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $65f69d7756681eb0$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($65f69d7756681eb0$var$reTrim, '');
    var isBinary = $65f69d7756681eb0$var$reIsBinary.test(value);
    return isBinary || $65f69d7756681eb0$var$reIsOctal.test(value) ? $65f69d7756681eb0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $65f69d7756681eb0$var$reIsBadHex.test(value) ? $65f69d7756681eb0$var$NAN : +value;
}
module.exports = $65f69d7756681eb0$var$isInteger;

});

parcelRegister("14FDQ", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $0c86775342a1a277$var$numberTag = '[object Number]';
/** Used for built-in method references. */ var $0c86775342a1a277$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0c86775342a1a277$var$objectToString = $0c86775342a1a277$var$objectProto.toString;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0c86775342a1a277$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $0c86775342a1a277$var$isNumber(value) {
    return typeof value == 'number' || $0c86775342a1a277$var$isObjectLike(value) && $0c86775342a1a277$var$objectToString.call(value) == $0c86775342a1a277$var$numberTag;
}
module.exports = $0c86775342a1a277$var$isNumber;

});

parcelRegister("9qlBU", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $6dc74e21358faa9b$var$objectTag = '[object Object]';
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $6dc74e21358faa9b$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $6dc74e21358faa9b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $6dc74e21358faa9b$var$funcProto = Function.prototype, $6dc74e21358faa9b$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $6dc74e21358faa9b$var$funcToString = $6dc74e21358faa9b$var$funcProto.toString;
/** Used to check objects for own properties. */ var $6dc74e21358faa9b$var$hasOwnProperty = $6dc74e21358faa9b$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $6dc74e21358faa9b$var$objectCtorString = $6dc74e21358faa9b$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $6dc74e21358faa9b$var$objectToString = $6dc74e21358faa9b$var$objectProto.toString;
/** Built-in value references. */ var $6dc74e21358faa9b$var$getPrototype = $6dc74e21358faa9b$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $6dc74e21358faa9b$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $6dc74e21358faa9b$var$isPlainObject(value) {
    if (!$6dc74e21358faa9b$var$isObjectLike(value) || $6dc74e21358faa9b$var$objectToString.call(value) != $6dc74e21358faa9b$var$objectTag || $6dc74e21358faa9b$var$isHostObject(value)) return false;
    var proto = $6dc74e21358faa9b$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $6dc74e21358faa9b$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $6dc74e21358faa9b$var$funcToString.call(Ctor) == $6dc74e21358faa9b$var$objectCtorString;
}
module.exports = $6dc74e21358faa9b$var$isPlainObject;

});

parcelRegister("8HHIj", function(module, exports) {
/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $65643f865d48b1e1$var$stringTag = '[object String]';
/** Used for built-in method references. */ var $65643f865d48b1e1$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $65643f865d48b1e1$var$objectToString = $65643f865d48b1e1$var$objectProto.toString;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $65643f865d48b1e1$var$isArray = Array.isArray;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $65643f865d48b1e1$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $65643f865d48b1e1$var$isString(value) {
    return typeof value == 'string' || !$65643f865d48b1e1$var$isArray(value) && $65643f865d48b1e1$var$isObjectLike(value) && $65643f865d48b1e1$var$objectToString.call(value) == $65643f865d48b1e1$var$stringTag;
}
module.exports = $65643f865d48b1e1$var$isString;

});

parcelRegister("6Gciw", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $4dd03467af72e50f$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $4dd03467af72e50f$var$INFINITY = 1 / 0, $4dd03467af72e50f$var$MAX_INTEGER = 1.7976931348623157e+308, $4dd03467af72e50f$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $4dd03467af72e50f$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $4dd03467af72e50f$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $4dd03467af72e50f$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $4dd03467af72e50f$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $4dd03467af72e50f$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $4dd03467af72e50f$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $4dd03467af72e50f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4dd03467af72e50f$var$objectToString = $4dd03467af72e50f$var$objectProto.toString;
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $4dd03467af72e50f$var$before(n, func) {
    var result;
    if (typeof func != 'function') throw new TypeError($4dd03467af72e50f$var$FUNC_ERROR_TEXT);
    n = $4dd03467af72e50f$var$toInteger(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $4dd03467af72e50f$var$once(func) {
    return $4dd03467af72e50f$var$before(2, func);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $4dd03467af72e50f$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $4dd03467af72e50f$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $4dd03467af72e50f$var$isSymbol(value) {
    return typeof value == 'symbol' || $4dd03467af72e50f$var$isObjectLike(value) && $4dd03467af72e50f$var$objectToString.call(value) == $4dd03467af72e50f$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $4dd03467af72e50f$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $4dd03467af72e50f$var$toNumber(value);
    if (value === $4dd03467af72e50f$var$INFINITY || value === -$4dd03467af72e50f$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $4dd03467af72e50f$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $4dd03467af72e50f$var$toInteger(value) {
    var result = $4dd03467af72e50f$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $4dd03467af72e50f$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($4dd03467af72e50f$var$isSymbol(value)) return $4dd03467af72e50f$var$NAN;
    if ($4dd03467af72e50f$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $4dd03467af72e50f$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($4dd03467af72e50f$var$reTrim, '');
    var isBinary = $4dd03467af72e50f$var$reIsBinary.test(value);
    return isBinary || $4dd03467af72e50f$var$reIsOctal.test(value) ? $4dd03467af72e50f$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $4dd03467af72e50f$var$reIsBadHex.test(value) ? $4dd03467af72e50f$var$NAN : +value;
}
module.exports = $4dd03467af72e50f$var$once;

});


parcelRegister("3OSHa", function(module, exports) {

var $e4AEL = parcelRequire("e4AEL");
/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $2c8077eb8bde5057$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== 'string') return output;
    var declaration;
    var declarations = $e4AEL(style);
    var hasIterator = typeof iterator === 'function';
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
module.exports = $2c8077eb8bde5057$var$StyleToObject;

});
parcelRegister("e4AEL", function(module, exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $a3eddfa3e6ecbd63$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $a3eddfa3e6ecbd63$var$NEWLINE_REGEX = /\n/g;
var $a3eddfa3e6ecbd63$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $a3eddfa3e6ecbd63$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $a3eddfa3e6ecbd63$var$COLON_REGEX = /^:\s*/;
var $a3eddfa3e6ecbd63$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $a3eddfa3e6ecbd63$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $a3eddfa3e6ecbd63$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $a3eddfa3e6ecbd63$var$NEWLINE = '\n';
var $a3eddfa3e6ecbd63$var$FORWARD_SLASH = '/';
var $a3eddfa3e6ecbd63$var$ASTERISK = '*';
var $a3eddfa3e6ecbd63$var$EMPTY_STRING = '';
// types
var $a3eddfa3e6ecbd63$var$TYPE_COMMENT = 'comment';
var $a3eddfa3e6ecbd63$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($a3eddfa3e6ecbd63$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($a3eddfa3e6ecbd63$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($a3eddfa3e6ecbd63$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($a3eddfa3e6ecbd63$var$FORWARD_SLASH != style.charAt(0) || $a3eddfa3e6ecbd63$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($a3eddfa3e6ecbd63$var$EMPTY_STRING != style.charAt(i) && ($a3eddfa3e6ecbd63$var$ASTERISK != style.charAt(i) || $a3eddfa3e6ecbd63$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($a3eddfa3e6ecbd63$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $a3eddfa3e6ecbd63$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($a3eddfa3e6ecbd63$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($a3eddfa3e6ecbd63$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($a3eddfa3e6ecbd63$var$VALUE_REGEX);
        var ret = pos({
            type: $a3eddfa3e6ecbd63$var$TYPE_DECLARATION,
            property: $a3eddfa3e6ecbd63$var$trim(prop[0].replace($a3eddfa3e6ecbd63$var$COMMENT_REGEX, $a3eddfa3e6ecbd63$var$EMPTY_STRING)),
            value: val ? $a3eddfa3e6ecbd63$var$trim(val[0].replace($a3eddfa3e6ecbd63$var$COMMENT_REGEX, $a3eddfa3e6ecbd63$var$EMPTY_STRING)) : $a3eddfa3e6ecbd63$var$EMPTY_STRING
        });
        // ;
        match($a3eddfa3e6ecbd63$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $a3eddfa3e6ecbd63$var$trim(str) {
    return str ? str.replace($a3eddfa3e6ecbd63$var$TRIM_REGEX, $a3eddfa3e6ecbd63$var$EMPTY_STRING) : $a3eddfa3e6ecbd63$var$EMPTY_STRING;
}

});


parcelRegister("8b6Fd", function(module, exports) {

var $pUD4C = parcelRequire("pUD4C");

var $0SfdL = parcelRequire("0SfdL");
var $5f4485198618538e$var$CASE_SENSITIVE_TAG_NAMES = $pUD4C.CASE_SENSITIVE_TAG_NAMES;
var $5f4485198618538e$var$Comment = $0SfdL.Comment;
var $5f4485198618538e$var$Element = $0SfdL.Element;
var $5f4485198618538e$var$ProcessingInstruction = $0SfdL.ProcessingInstruction;
var $5f4485198618538e$var$Text = $0SfdL.Text;
var $5f4485198618538e$var$caseSensitiveTagNamesMap = {};
var $5f4485198618538e$var$tagName;
for(var $5f4485198618538e$var$i = 0, $5f4485198618538e$var$len = $5f4485198618538e$var$CASE_SENSITIVE_TAG_NAMES.length; $5f4485198618538e$var$i < $5f4485198618538e$var$len; $5f4485198618538e$var$i++){
    $5f4485198618538e$var$tagName = $5f4485198618538e$var$CASE_SENSITIVE_TAG_NAMES[$5f4485198618538e$var$i];
    $5f4485198618538e$var$caseSensitiveTagNamesMap[$5f4485198618538e$var$tagName.toLowerCase()] = $5f4485198618538e$var$tagName;
}
/**
 * Gets case-sensitive tag name.
 *
 * @param  {string}           tagName - Tag name in lowercase.
 * @return {string|undefined}         - Case-sensitive tag name.
 */ function $5f4485198618538e$var$getCaseSensitiveTagName(tagName) {
    return $5f4485198618538e$var$caseSensitiveTagNamesMap[tagName];
}
/**
 * Formats DOM attributes to a hash map.
 *
 * @param  {NamedNodeMap} attributes - List of attributes.
 * @return {object}                  - Map of attribute name to value.
 */ function $5f4485198618538e$var$formatAttributes(attributes) {
    var result = {};
    var attribute;
    // `NamedNodeMap` is array-like
    for(var i = 0, len = attributes.length; i < len; i++){
        attribute = attributes[i];
        result[attribute.name] = attribute.value;
    }
    return result;
}
/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param  {string} tagName - Lowercase tag name.
 * @return {string}         - Formatted tag name.
 */ function $5f4485198618538e$var$formatTagName(tagName) {
    tagName = tagName.toLowerCase();
    var caseSensitiveTagName = $5f4485198618538e$var$getCaseSensitiveTagName(tagName);
    if (caseSensitiveTagName) return caseSensitiveTagName;
    return tagName;
}
/**
 * Transforms DOM nodes to `domhandler` nodes.
 *
 * @param  {NodeList}     nodes         - DOM nodes.
 * @param  {Element|null} [parent=null] - Parent node.
 * @param  {string}       [directive]   - Directive.
 * @return {Array<Comment|Element|ProcessingInstruction|Text>}
 */ function $5f4485198618538e$var$formatDOM(nodes, parent, directive) {
    parent = parent || null;
    var result = [];
    for(var index = 0, len = nodes.length; index < len; index++){
        var node = nodes[index];
        var current;
        // set the node data given the type
        switch(node.nodeType){
            case 1:
                // script, style, or tag
                current = new $5f4485198618538e$var$Element($5f4485198618538e$var$formatTagName(node.nodeName), $5f4485198618538e$var$formatAttributes(node.attributes));
                current.children = $5f4485198618538e$var$formatDOM(node.childNodes, current);
                break;
            case 3:
                current = new $5f4485198618538e$var$Text(node.nodeValue);
                break;
            case 8:
                current = new $5f4485198618538e$var$Comment(node.nodeValue);
                break;
            default:
                continue;
        }
        // set previous node next
        var prev = result[index - 1] || null;
        if (prev) prev.next = current;
        // set properties for current node
        current.parent = parent;
        current.prev = prev;
        current.next = null;
        result.push(current);
    }
    if (directive) {
        current = new $5f4485198618538e$var$ProcessingInstruction(directive.substring(0, directive.indexOf(' ')).toLowerCase(), directive);
        current.next = result[0] || null;
        current.parent = parent;
        result.unshift(current);
        if (result[1]) result[1].prev = result[0];
    }
    return result;
}
/**
 * Detects if browser is Internet Explorer.
 *
 * @return {boolean} - Whether IE is detected.
 */ function $5f4485198618538e$var$isIE() {
    return /(MSIE |Trident\/|Edge\/)/.test(navigator.userAgent);
}
module.exports = {
    formatAttributes: $5f4485198618538e$var$formatAttributes,
    formatDOM: $5f4485198618538e$var$formatDOM,
    isIE: $5f4485198618538e$var$isIE
};

});
parcelRegister("pUD4C", function(module, exports) {
/**
 * SVG elements are case-sensitive.
 *
 * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#SVG_elements_A_to_Z}
 */ var $04de434c0faebde4$var$CASE_SENSITIVE_TAG_NAMES = [
    'animateMotion',
    'animateTransform',
    'clipPath',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussainBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'foreignObject',
    'linearGradient',
    'radialGradient',
    'textPath'
];
module.exports = {
    CASE_SENSITIVE_TAG_NAMES: $04de434c0faebde4$var$CASE_SENSITIVE_TAG_NAMES
};

});

parcelRegister("0SfdL", function(module, exports) {
"use strict";
var $002a1407a356b14d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $002a1407a356b14d$var$__assign = module.exports && module.exports.__assign || function() {
    $002a1407a356b14d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $002a1407a356b14d$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cloneNode = module.exports.hasChildren = module.exports.isDocument = module.exports.isDirective = module.exports.isComment = module.exports.isText = module.exports.isCDATA = module.exports.isTag = module.exports.Element = module.exports.Document = module.exports.NodeWithChildren = module.exports.ProcessingInstruction = module.exports.Comment = module.exports.Text = module.exports.DataNode = module.exports.Node = void 0;

var $4YnEc = parcelRequire("4YnEc");
var $002a1407a356b14d$var$nodeTypes = new Map([
    [
        $4YnEc.ElementType.Tag,
        1
    ],
    [
        $4YnEc.ElementType.Script,
        1
    ],
    [
        $4YnEc.ElementType.Style,
        1
    ],
    [
        $4YnEc.ElementType.Directive,
        1
    ],
    [
        $4YnEc.ElementType.Text,
        3
    ],
    [
        $4YnEc.ElementType.CDATA,
        4
    ],
    [
        $4YnEc.ElementType.Comment,
        8
    ],
    [
        $4YnEc.ElementType.Root,
        9
    ]
]);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */ var $002a1407a356b14d$var$Node = /** @class */ function() {
    /**
     *
     * @param type The type of the node.
     */ function Node(type) {
        this.type = type;
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "nodeType", {
        // Read-only aliases
        /**
         * [DOM spec](https://dom.spec.whatwg.org/#dom-node-nodetype)-compatible
         * node {@link type}.
         */ get: function() {
            var _a;
            return (_a = $002a1407a356b14d$var$nodeTypes.get(this.type)) !== null && _a !== void 0 ? _a : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.parent;
        },
        set: function(parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.prev;
        },
        set: function(prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.next;
        },
        set: function(next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ Node.prototype.cloneNode = function(recursive) {
        if (recursive === void 0) recursive = false;
        return $002a1407a356b14d$var$cloneNode(this, recursive);
    };
    return Node;
}();
module.exports.Node = $002a1407a356b14d$var$Node;
/**
 * A node that contains some data.
 */ var $002a1407a356b14d$var$DataNode = /** @class */ function(_super) {
    $002a1407a356b14d$var$__extends(DataNode, _super);
    /**
     * @param type The type of the node
     * @param data The content of the data node
     */ function DataNode(type, data) {
        var _this = _super.call(this, type) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.data;
        },
        set: function(data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}($002a1407a356b14d$var$Node);
module.exports.DataNode = $002a1407a356b14d$var$DataNode;
/**
 * Text within the document.
 */ var $002a1407a356b14d$var$Text = /** @class */ function(_super) {
    $002a1407a356b14d$var$__extends(Text, _super);
    function Text(data) {
        return _super.call(this, $4YnEc.ElementType.Text, data) || this;
    }
    return Text;
}($002a1407a356b14d$var$DataNode);
module.exports.Text = $002a1407a356b14d$var$Text;
/**
 * Comments within the document.
 */ var $002a1407a356b14d$var$Comment = /** @class */ function(_super) {
    $002a1407a356b14d$var$__extends(Comment, _super);
    function Comment(data) {
        return _super.call(this, $4YnEc.ElementType.Comment, data) || this;
    }
    return Comment;
}($002a1407a356b14d$var$DataNode);
module.exports.Comment = $002a1407a356b14d$var$Comment;
/**
 * Processing instructions, including doc types.
 */ var $002a1407a356b14d$var$ProcessingInstruction = /** @class */ function(_super) {
    $002a1407a356b14d$var$__extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, $4YnEc.ElementType.Directive, data) || this;
        _this.name = name;
        return _this;
    }
    return ProcessingInstruction;
}($002a1407a356b14d$var$DataNode);
module.exports.ProcessingInstruction = $002a1407a356b14d$var$ProcessingInstruction;
/**
 * A `Node` that can have children.
 */ var $002a1407a356b14d$var$NodeWithChildren = /** @class */ function(_super) {
    $002a1407a356b14d$var$__extends(NodeWithChildren, _super);
    /**
     * @param type Type of the node.
     * @param children Children of the node. Only certain node types can have children.
     */ function NodeWithChildren(type, children) {
        var _this = _super.call(this, type) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */ get: function() {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */ get: function() {
            return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.children;
        },
        set: function(children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}($002a1407a356b14d$var$Node);
module.exports.NodeWithChildren = $002a1407a356b14d$var$NodeWithChildren;
/**
 * The root node of the document.
 */ var $002a1407a356b14d$var$Document = /** @class */ function(_super) {
    $002a1407a356b14d$var$__extends(Document, _super);
    function Document(children) {
        return _super.call(this, $4YnEc.ElementType.Root, children) || this;
    }
    return Document;
}($002a1407a356b14d$var$NodeWithChildren);
module.exports.Document = $002a1407a356b14d$var$Document;
/**
 * An element within the DOM.
 */ var $002a1407a356b14d$var$Element = /** @class */ function(_super) {
    $002a1407a356b14d$var$__extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ function Element(name, attribs, children, type) {
        if (children === void 0) children = [];
        if (type === void 0) type = name === "script" ? $4YnEc.ElementType.Script : name === "style" ? $4YnEc.ElementType.Style : $4YnEc.ElementType.Tag;
        var _this = _super.call(this, type, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        return _this;
    }
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.name;
        },
        set: function(name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function() {
            var _this = this;
            return Object.keys(this.attribs).map(function(name) {
                var _a, _b;
                return {
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}($002a1407a356b14d$var$NodeWithChildren);
module.exports.Element = $002a1407a356b14d$var$Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */ function $002a1407a356b14d$var$isTag(node) {
    return (0, $4YnEc.isTag)(node);
}
module.exports.isTag = $002a1407a356b14d$var$isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */ function $002a1407a356b14d$var$isCDATA(node) {
    return node.type === $4YnEc.ElementType.CDATA;
}
module.exports.isCDATA = $002a1407a356b14d$var$isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */ function $002a1407a356b14d$var$isText(node) {
    return node.type === $4YnEc.ElementType.Text;
}
module.exports.isText = $002a1407a356b14d$var$isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */ function $002a1407a356b14d$var$isComment(node) {
    return node.type === $4YnEc.ElementType.Comment;
}
module.exports.isComment = $002a1407a356b14d$var$isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $002a1407a356b14d$var$isDirective(node) {
    return node.type === $4YnEc.ElementType.Directive;
}
module.exports.isDirective = $002a1407a356b14d$var$isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $002a1407a356b14d$var$isDocument(node) {
    return node.type === $4YnEc.ElementType.Root;
}
module.exports.isDocument = $002a1407a356b14d$var$isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `NodeWithChildren` (has children), `false` otherwise.
 */ function $002a1407a356b14d$var$hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
module.exports.hasChildren = $002a1407a356b14d$var$hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */ function $002a1407a356b14d$var$cloneNode(node, recursive) {
    if (recursive === void 0) recursive = false;
    var result;
    if ($002a1407a356b14d$var$isText(node)) result = new $002a1407a356b14d$var$Text(node.data);
    else if ($002a1407a356b14d$var$isComment(node)) result = new $002a1407a356b14d$var$Comment(node.data);
    else if ($002a1407a356b14d$var$isTag(node)) {
        var children = recursive ? $002a1407a356b14d$var$cloneChildren(node.children) : [];
        var clone_1 = new $002a1407a356b14d$var$Element(node.name, $002a1407a356b14d$var$__assign({}, node.attribs), children);
        children.forEach(function(child) {
            return child.parent = clone_1;
        });
        if (node.namespace != null) clone_1.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone_1["x-attribsNamespace"] = $002a1407a356b14d$var$__assign({}, node["x-attribsNamespace"]);
        if (node["x-attribsPrefix"]) clone_1["x-attribsPrefix"] = $002a1407a356b14d$var$__assign({}, node["x-attribsPrefix"]);
        result = clone_1;
    } else if ($002a1407a356b14d$var$isCDATA(node)) {
        var children = recursive ? $002a1407a356b14d$var$cloneChildren(node.children) : [];
        var clone_2 = new $002a1407a356b14d$var$NodeWithChildren($4YnEc.ElementType.CDATA, children);
        children.forEach(function(child) {
            return child.parent = clone_2;
        });
        result = clone_2;
    } else if ($002a1407a356b14d$var$isDocument(node)) {
        var children = recursive ? $002a1407a356b14d$var$cloneChildren(node.children) : [];
        var clone_3 = new $002a1407a356b14d$var$Document(children);
        children.forEach(function(child) {
            return child.parent = clone_3;
        });
        if (node["x-mode"]) clone_3["x-mode"] = node["x-mode"];
        result = clone_3;
    } else if ($002a1407a356b14d$var$isDirective(node)) {
        var instruction = new $002a1407a356b14d$var$ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error("Not implemented yet: ".concat(node.type));
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
module.exports.cloneNode = $002a1407a356b14d$var$cloneNode;
function $002a1407a356b14d$var$cloneChildren(childs) {
    var children = childs.map(function(child) {
        return $002a1407a356b14d$var$cloneNode(child, true);
    });
    for(var i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});
parcelRegister("4YnEc", function(module, exports) {

$parcel$export(module.exports, "ElementType", function () { return $39ef1bdf59853755$export$b992dc138d950e31; });
$parcel$export(module.exports, "isTag", function () { return $39ef1bdf59853755$export$3bf645f08efe3292; });
/** Types of elements found in htmlparser2's DOM */ var $39ef1bdf59853755$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($39ef1bdf59853755$export$b992dc138d950e31 || ($39ef1bdf59853755$export$b992dc138d950e31 = {}));
function $39ef1bdf59853755$export$3bf645f08efe3292(elem) {
    return elem.type === $39ef1bdf59853755$export$b992dc138d950e31.Tag || elem.type === $39ef1bdf59853755$export$b992dc138d950e31.Script || elem.type === $39ef1bdf59853755$export$b992dc138d950e31.Style;
}
const $39ef1bdf59853755$export$be92b6f5f03c0fe9 = $39ef1bdf59853755$export$b992dc138d950e31.Root;
const $39ef1bdf59853755$export$5f1af8db9871e1d6 = $39ef1bdf59853755$export$b992dc138d950e31.Text;
const $39ef1bdf59853755$export$befdefbdce210f91 = $39ef1bdf59853755$export$b992dc138d950e31.Directive;
const $39ef1bdf59853755$export$4d299b491347818a = $39ef1bdf59853755$export$b992dc138d950e31.Comment;
const $39ef1bdf59853755$export$2f8b47a141e57afc = $39ef1bdf59853755$export$b992dc138d950e31.Script;
const $39ef1bdf59853755$export$d9e45bc13d335801 = $39ef1bdf59853755$export$b992dc138d950e31.Style;
const $39ef1bdf59853755$export$3288d34c523a1192 = $39ef1bdf59853755$export$b992dc138d950e31.Tag;
const $39ef1bdf59853755$export$1f8b8f7e5c763232 = $39ef1bdf59853755$export$b992dc138d950e31.CDATA;
const $39ef1bdf59853755$export$31b44af36ff2c60f = $39ef1bdf59853755$export$b992dc138d950e31.Doctype;

});



parcelRegister("bjmdp", function(module, exports) {
"use strict";
var $83c2b3896ce9fea2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $83c2b3896ce9fea2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $83c2b3896ce9fea2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DomHandler = void 0;

var $4YnEc = parcelRequire("4YnEc");


$83c2b3896ce9fea2$var$__exportStar((parcelRequire("0SfdL")), module.exports);
var $83c2b3896ce9fea2$var$reWhitespace = /\s+/g;
// Default options
var $83c2b3896ce9fea2$var$defaultOpts = {
    normalizeWhitespace: false,
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
var $83c2b3896ce9fea2$var$DomHandler = /** @class */ function() {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (parcelRequire("0SfdL")).Document(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $83c2b3896ce9fea2$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $83c2b3896ce9fea2$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function(parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function() {
        this.dom = [];
        this.root = new (parcelRequire("0SfdL")).Document(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function(error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function() {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function(name, attribs) {
        var type = this.options.xmlMode ? $4YnEc.ElementType.Tag : undefined;
        var element = new (parcelRequire("0SfdL")).Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function(data) {
        var normalizeWhitespace = this.options.normalizeWhitespace;
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === $4YnEc.ElementType.Text) {
            if (normalizeWhitespace) lastNode.data = (lastNode.data + data).replace($83c2b3896ce9fea2$var$reWhitespace, " ");
            else lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            if (normalizeWhitespace) data = data.replace($83c2b3896ce9fea2$var$reWhitespace, " ");
            var node = new (parcelRequire("0SfdL")).Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function(data) {
        if (this.lastNode && this.lastNode.type === $4YnEc.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new (parcelRequire("0SfdL")).Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function() {
        var text = new (parcelRequire("0SfdL")).Text("");
        var node = new (parcelRequire("0SfdL")).NodeWithChildren($4YnEc.ElementType.CDATA, [
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function(name, data) {
        var node = new (parcelRequire("0SfdL")).ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    };
    DomHandler.prototype.addNode = function(node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}();
module.exports.DomHandler = $83c2b3896ce9fea2$var$DomHandler;
module.exports.default = $83c2b3896ce9fea2$var$DomHandler;

});

var $d4dab640dcbe486c$exports = {};
'use strict';

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));


var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
'use strict';
var $47cfd4084854a574$exports = {};
'use strict';
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $47cfd4084854a574$exports.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $47cfd4084854a574$exports.hydrateRoot;



parcelRequire("bh6RR");
function $ca073d81f2a471af$export$2e2bcd8739ae039(t, e) {
    return $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ca073d81f2a471af$export$2e2bcd8739ae039(t, e);
}


function $c375c92967c25393$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $ca073d81f2a471af$export$2e2bcd8739ae039)(t, o);
}



var $bh6RR = parcelRequire("bh6RR");
var $aa40b802dd2fccfc$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa40b802dd2fccfc$var$ReactIs, $aa40b802dd2fccfc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$aa40b802dd2fccfc$exports = (parcelRequire("2tbKl"))();


function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    return $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $39ab41060f0dd572$export$2e2bcd8739ae039.apply(null, arguments);
}


function $5b8b43e396b05c37$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $5b8b43e396b05c37$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $5b8b43e396b05c37$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $5b8b43e396b05c37$var$isAbsolute(to);
    var isFromAbs = from && $5b8b43e396b05c37$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $5b8b43e396b05c37$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $5b8b43e396b05c37$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $5b8b43e396b05c37$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $5b8b43e396b05c37$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$5b8b43e396b05c37$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $5b8b43e396b05c37$export$2e2bcd8739ae039 = $5b8b43e396b05c37$var$resolvePathname;


function $f06dd50279713a67$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $f06dd50279713a67$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $f06dd50279713a67$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $f06dd50279713a67$var$valueOf(a);
        var bValue = $f06dd50279713a67$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $f06dd50279713a67$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $f06dd50279713a67$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $f06dd50279713a67$export$2e2bcd8739ae039 = $f06dd50279713a67$var$valueEqual;



var $1e4fba22ff93a100$var$isProduction = true;
var $1e4fba22ff93a100$var$prefix = 'Invariant failed';
function $1e4fba22ff93a100$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($1e4fba22ff93a100$var$isProduction) throw new Error($1e4fba22ff93a100$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($1e4fba22ff93a100$var$prefix, ": ").concat(provided) : $1e4fba22ff93a100$var$prefix;
    throw new Error(value);
}


function $32e4998d9dcb6f96$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $32e4998d9dcb6f96$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $32e4998d9dcb6f96$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $32e4998d9dcb6f96$var$stripBasename(path, prefix) {
    return $32e4998d9dcb6f96$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $32e4998d9dcb6f96$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $32e4998d9dcb6f96$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $32e4998d9dcb6f96$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $32e4998d9dcb6f96$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $5b8b43e396b05c37$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $32e4998d9dcb6f96$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $f06dd50279713a67$export$2e2bcd8739ae039)(a.state, b.state);
}
function $32e4998d9dcb6f96$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $32e4998d9dcb6f96$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $32e4998d9dcb6f96$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $32e4998d9dcb6f96$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $32e4998d9dcb6f96$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $32e4998d9dcb6f96$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $32e4998d9dcb6f96$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $32e4998d9dcb6f96$var$PopStateEvent = 'popstate';
var $32e4998d9dcb6f96$var$HashChangeEvent = 'hashchange';
function $32e4998d9dcb6f96$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $32e4998d9dcb6f96$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$32e4998d9dcb6f96$var$canUseDOM && (0, $1e4fba22ff93a100$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $32e4998d9dcb6f96$var$supportsHistory();
    var needsHashChangeListener = !$32e4998d9dcb6f96$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $32e4998d9dcb6f96$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $32e4998d9dcb6f96$var$stripTrailingSlash($32e4998d9dcb6f96$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $32e4998d9dcb6f96$var$stripBasename(path, basename);
        return $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $32e4998d9dcb6f96$var$createTransitionManager();
    function setState(nextState) {
        (0, $39ab41060f0dd572$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($32e4998d9dcb6f96$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($32e4998d9dcb6f96$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($32e4998d9dcb6f96$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $32e4998d9dcb6f96$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($32e4998d9dcb6f96$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($32e4998d9dcb6f96$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($32e4998d9dcb6f96$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($32e4998d9dcb6f96$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $32e4998d9dcb6f96$var$HashChangeEvent$1 = 'hashchange';
var $32e4998d9dcb6f96$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $32e4998d9dcb6f96$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $32e4998d9dcb6f96$var$stripLeadingSlash,
        decodePath: $32e4998d9dcb6f96$var$addLeadingSlash
    },
    slash: {
        encodePath: $32e4998d9dcb6f96$var$addLeadingSlash,
        decodePath: $32e4998d9dcb6f96$var$addLeadingSlash
    }
};
function $32e4998d9dcb6f96$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $32e4998d9dcb6f96$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $32e4998d9dcb6f96$var$pushHashPath(path) {
    window.location.hash = path;
}
function $32e4998d9dcb6f96$var$replaceHashPath(path) {
    window.location.replace($32e4998d9dcb6f96$var$stripHash(window.location.href) + '#' + path);
}
function $32e4998d9dcb6f96$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$32e4998d9dcb6f96$var$canUseDOM && (0, $1e4fba22ff93a100$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $32e4998d9dcb6f96$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $32e4998d9dcb6f96$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $32e4998d9dcb6f96$var$stripTrailingSlash($32e4998d9dcb6f96$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $32e4998d9dcb6f96$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($32e4998d9dcb6f96$var$getHashPath());
        if (basename) path = $32e4998d9dcb6f96$var$stripBasename(path, basename);
        return $32e4998d9dcb6f96$export$90c043f1c57770b8(path);
    }
    var transitionManager = $32e4998d9dcb6f96$var$createTransitionManager();
    function setState(nextState) {
        (0, $39ab41060f0dd572$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $32e4998d9dcb6f96$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $32e4998d9dcb6f96$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $32e4998d9dcb6f96$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($32e4998d9dcb6f96$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($32e4998d9dcb6f96$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $32e4998d9dcb6f96$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $32e4998d9dcb6f96$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $32e4998d9dcb6f96$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $32e4998d9dcb6f96$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $32e4998d9dcb6f96$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $32e4998d9dcb6f96$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $32e4998d9dcb6f96$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $32e4998d9dcb6f96$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($32e4998d9dcb6f96$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $32e4998d9dcb6f96$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $32e4998d9dcb6f96$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $32e4998d9dcb6f96$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($32e4998d9dcb6f96$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($32e4998d9dcb6f96$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($32e4998d9dcb6f96$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $32e4998d9dcb6f96$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $32e4998d9dcb6f96$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $32e4998d9dcb6f96$var$createTransitionManager();
    function setState(nextState) {
        (0, $39ab41060f0dd572$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $32e4998d9dcb6f96$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $32e4998d9dcb6f96$export$90c043f1c57770b8(entry, undefined, createKey()) : $32e4998d9dcb6f96$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $32e4998d9dcb6f96$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $32e4998d9dcb6f96$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $eeac86488245adff$exports = {};
var $713d1c6c66d58098$exports = {};
$713d1c6c66d58098$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $eeac86488245adff$exports = $eeac86488245adff$var$pathToRegexp;
$eeac86488245adff$exports.parse = $eeac86488245adff$var$parse;
$eeac86488245adff$exports.compile = $eeac86488245adff$var$compile;
$eeac86488245adff$exports.tokensToFunction = $eeac86488245adff$var$tokensToFunction;
$eeac86488245adff$exports.tokensToRegExp = $eeac86488245adff$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $eeac86488245adff$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $eeac86488245adff$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $eeac86488245adff$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $eeac86488245adff$var$escapeGroup(pattern) : asterisk ? '.*' : $eeac86488245adff$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $eeac86488245adff$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $eeac86488245adff$var$escapeString(delimiter) + ']+?';
    return $eeac86488245adff$var$escapeString(prevText) + '|(?:(?!' + $eeac86488245adff$var$escapeString(prevText) + ')[^' + $eeac86488245adff$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $eeac86488245adff$var$compile(str, options) {
    return $eeac86488245adff$var$tokensToFunction($eeac86488245adff$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $eeac86488245adff$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $eeac86488245adff$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $eeac86488245adff$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $eeac86488245adff$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $eeac86488245adff$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($713d1c6c66d58098$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $eeac86488245adff$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $eeac86488245adff$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $eeac86488245adff$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $eeac86488245adff$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $eeac86488245adff$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $eeac86488245adff$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $eeac86488245adff$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $eeac86488245adff$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($eeac86488245adff$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $eeac86488245adff$var$flags(options));
    return $eeac86488245adff$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $eeac86488245adff$var$stringToRegexp(path, keys, options) {
    return $eeac86488245adff$var$tokensToRegExp($eeac86488245adff$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $eeac86488245adff$var$tokensToRegExp(tokens, keys, options) {
    if (!$713d1c6c66d58098$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $eeac86488245adff$var$escapeString(token);
        else {
            var prefix = $eeac86488245adff$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $eeac86488245adff$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $eeac86488245adff$var$attachKeys(new RegExp('^' + route, $eeac86488245adff$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $eeac86488245adff$var$pathToRegexp(path, keys, options) {
    if (!$713d1c6c66d58098$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $eeac86488245adff$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($713d1c6c66d58098$exports(path)) return $eeac86488245adff$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $eeac86488245adff$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $5e1a41ff7483815f$exports = {};
'use strict';

$5e1a41ff7483815f$exports = (parcelRequire("lL2uv"));


function $cd488cd9c287f883$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


var $770bbfe5492d7fd4$exports = {};
'use strict';
var $7f915642c1081607$exports = {};
'use strict';

$7f915642c1081607$exports = (parcelRequire("4aTru"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $770bbfe5492d7fd4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $770bbfe5492d7fd4$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $770bbfe5492d7fd4$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$TYPE_STATICS = {};
$770bbfe5492d7fd4$var$TYPE_STATICS[$7f915642c1081607$exports.ForwardRef] = $770bbfe5492d7fd4$var$FORWARD_REF_STATICS;
$770bbfe5492d7fd4$var$TYPE_STATICS[$7f915642c1081607$exports.Memo] = $770bbfe5492d7fd4$var$MEMO_STATICS;
function $770bbfe5492d7fd4$var$getStatics(component) {
    // React v16.11 and below
    if ($7f915642c1081607$exports.isMemo(component)) return $770bbfe5492d7fd4$var$MEMO_STATICS;
     // React v16.12 and above
    return $770bbfe5492d7fd4$var$TYPE_STATICS[component['$$typeof']] || $770bbfe5492d7fd4$var$REACT_STATICS;
}
var $770bbfe5492d7fd4$var$defineProperty = Object.defineProperty;
var $770bbfe5492d7fd4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $770bbfe5492d7fd4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $770bbfe5492d7fd4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $770bbfe5492d7fd4$var$getPrototypeOf = Object.getPrototypeOf;
var $770bbfe5492d7fd4$var$objectPrototype = Object.prototype;
function $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($770bbfe5492d7fd4$var$objectPrototype) {
            var inheritedComponent = $770bbfe5492d7fd4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $770bbfe5492d7fd4$var$objectPrototype) $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $770bbfe5492d7fd4$var$getOwnPropertyNames(sourceComponent);
        if ($770bbfe5492d7fd4$var$getOwnPropertySymbols) keys = keys.concat($770bbfe5492d7fd4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $770bbfe5492d7fd4$var$getStatics(targetComponent);
        var sourceStatics = $770bbfe5492d7fd4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$770bbfe5492d7fd4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $770bbfe5492d7fd4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $770bbfe5492d7fd4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$770bbfe5492d7fd4$exports = $770bbfe5492d7fd4$var$hoistNonReactStatics;


var $14986c2201283622$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $14986c2201283622$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $14986c2201283622$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $14986c2201283622$var$commonjsGlobal[key] = ($14986c2201283622$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $14986c2201283622$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $14986c2201283622$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $14986c2201283622$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $14986c2201283622$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $14986c2201283622$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $c375c92967c25393$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $14986c2201283622$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($14986c2201283622$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $14986c2201283622$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $c375c92967c25393$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $14986c2201283622$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $14986c2201283622$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $14986c2201283622$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $14986c2201283622$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext || $14986c2201283622$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $14986c2201283622$var$createNamedContext = function createNamedContext(name) {
    var context = $14986c2201283622$var$createContext();
    context.displayName = name;
    return context;
};
var $14986c2201283622$export$c213558b66925821 = /*#__PURE__*/ $14986c2201283622$var$createNamedContext("Router-History");
var $14986c2201283622$export$63baa8ccbe60bb07 = /*#__PURE__*/ $14986c2201283622$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $14986c2201283622$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $c375c92967c25393$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $14986c2201283622$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $c375c92967c25393$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $32e4998d9dcb6f96$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
var $14986c2201283622$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $c375c92967c25393$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $14986c2201283622$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $1e4fba22ff93a100$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $14986c2201283622$var$messageType;
var $14986c2201283622$var$cache = {};
var $14986c2201283622$var$cacheLimit = 10000;
var $14986c2201283622$var$cacheCount = 0;
function $14986c2201283622$var$compilePath(path) {
    if ($14986c2201283622$var$cache[path]) return $14986c2201283622$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($eeac86488245adff$exports))).compile(path);
    if ($14986c2201283622$var$cacheCount < $14986c2201283622$var$cacheLimit) {
        $14986c2201283622$var$cache[path] = generator;
        $14986c2201283622$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $14986c2201283622$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $14986c2201283622$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $14986c2201283622$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $1e4fba22ff93a100$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $32e4998d9dcb6f96$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $14986c2201283622$export$82476f982757e71e(to, computedMatch.params) : (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, to, {
            pathname: $14986c2201283622$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $32e4998d9dcb6f96$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $32e4998d9dcb6f96$export$c3e8bb440bd55b18)(prevLocation, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $14986c2201283622$var$cache$1 = {};
var $14986c2201283622$var$cacheLimit$1 = 10000;
var $14986c2201283622$var$cacheCount$1 = 0;
function $14986c2201283622$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $14986c2201283622$var$cache$1[cacheKey] || ($14986c2201283622$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($eeac86488245adff$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($14986c2201283622$var$cacheCount$1 < $14986c2201283622$var$cacheLimit$1) {
        pathCache[path] = result;
        $14986c2201283622$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $14986c2201283622$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $14986c2201283622$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $14986c2201283622$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.count(children) === 0;
}
function $14986c2201283622$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $14986c2201283622$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $c375c92967c25393$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $1e4fba22ff93a100$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $14986c2201283622$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $14986c2201283622$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
function $14986c2201283622$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $14986c2201283622$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, location, {
        pathname: $14986c2201283622$var$addLeadingSlash(basename) + location.pathname
    });
}
function $14986c2201283622$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $14986c2201283622$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $14986c2201283622$var$createURL(location) {
    return typeof location === "string" ? location : (0, $32e4998d9dcb6f96$export$fe53371bee54353d)(location);
}
function $14986c2201283622$var$staticHandler(methodName) {
    return function() {
        (0, $1e4fba22ff93a100$export$2e2bcd8739ae039)(false);
    };
}
function $14986c2201283622$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $14986c2201283622$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $c375c92967c25393$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $14986c2201283622$var$noop;
        };
        _this.handleBlock = function() {
            return $14986c2201283622$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $14986c2201283622$var$addBasename(basename, (0, $32e4998d9dcb6f96$export$90c043f1c57770b8)(location));
        context.url = $14986c2201283622$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $14986c2201283622$var$addLeadingSlash(basename + $14986c2201283622$var$createURL(path));
            },
            action: "POP",
            location: $14986c2201283622$var$stripBasename(basename, (0, $32e4998d9dcb6f96$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $14986c2201283622$var$staticHandler("go"),
            goBack: $14986c2201283622$var$staticHandler("goBack"),
            goForward: $14986c2201283622$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$55185c17a0fcbe46, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $14986c2201283622$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $c375c92967c25393$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $1e4fba22ff93a100$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $14986c2201283622$export$81336c211d5ff295(location.pathname, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $14986c2201283622$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $1e4fba22ff93a100$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($770bbfe5492d7fd4$exports)))(C, Component);
}
var $14986c2201283622$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext;
function $14986c2201283622$export$3420e1dc2c4a518c() {
    return $14986c2201283622$var$useContext($14986c2201283622$export$c213558b66925821);
}
function $14986c2201283622$export$45d76561a5302f2b() {
    return $14986c2201283622$var$useContext($14986c2201283622$export$63baa8ccbe60bb07).location;
}
function $14986c2201283622$export$99eaa27ddbbb95ef() {
    var match = $14986c2201283622$var$useContext($14986c2201283622$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $14986c2201283622$export$632be4bb944c1bc7(path) {
    var location = $14986c2201283622$export$45d76561a5302f2b();
    var match = $14986c2201283622$var$useContext($14986c2201283622$export$63baa8ccbe60bb07).match;
    return path ? $14986c2201283622$export$81336c211d5ff295(location.pathname, path) : match;
}
var $14986c2201283622$var$global$1, $14986c2201283622$var$key, $14986c2201283622$var$buildNames, $14986c2201283622$var$initialBuildName, $14986c2201283622$var$secondaryBuildName;




var $bh6RR = parcelRequire("bh6RR");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $235bffbda6f2a3d0$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $c375c92967c25393$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $32e4998d9dcb6f96$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $14986c2201283622$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $235bffbda6f2a3d0$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $c375c92967c25393$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $32e4998d9dcb6f96$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $14986c2201283622$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
var $235bffbda6f2a3d0$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $235bffbda6f2a3d0$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $32e4998d9dcb6f96$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $235bffbda6f2a3d0$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $235bffbda6f2a3d0$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef;
if (typeof $235bffbda6f2a3d0$var$forwardRef === "undefined") $235bffbda6f2a3d0$var$forwardRef = $235bffbda6f2a3d0$var$forwardRefShim;
function $235bffbda6f2a3d0$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $235bffbda6f2a3d0$var$LinkAnchor = $235bffbda6f2a3d0$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$235bffbda6f2a3d0$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($235bffbda6f2a3d0$var$forwardRefShim !== $235bffbda6f2a3d0$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $235bffbda6f2a3d0$export$a6c7ac8248d6e38a = $235bffbda6f2a3d0$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $235bffbda6f2a3d0$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $14986c2201283622$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $1e4fba22ff93a100$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $235bffbda6f2a3d0$var$normalizeToLocation($235bffbda6f2a3d0$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $235bffbda6f2a3d0$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $32e4998d9dcb6f96$export$fe53371bee54353d)(context.location) === (0, $32e4998d9dcb6f96$export$fe53371bee54353d)($235bffbda6f2a3d0$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($235bffbda6f2a3d0$var$forwardRefShim !== $235bffbda6f2a3d0$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(component, props);
    });
});
var $235bffbda6f2a3d0$var$toType, $235bffbda6f2a3d0$var$refType;
var $235bffbda6f2a3d0$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $235bffbda6f2a3d0$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef;
if (typeof $235bffbda6f2a3d0$var$forwardRef$1 === "undefined") $235bffbda6f2a3d0$var$forwardRef$1 = $235bffbda6f2a3d0$var$forwardRefShim$1;
function $235bffbda6f2a3d0$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $235bffbda6f2a3d0$export$b0d92dbee9b5b60d = $235bffbda6f2a3d0$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $14986c2201283622$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $1e4fba22ff93a100$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $235bffbda6f2a3d0$var$normalizeToLocation($235bffbda6f2a3d0$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $14986c2201283622$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $235bffbda6f2a3d0$var$joinClassnames(className, activeClassName);
            style = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($235bffbda6f2a3d0$var$forwardRefShim$1 !== $235bffbda6f2a3d0$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($235bffbda6f2a3d0$export$a6c7ac8248d6e38a, props);
    });
});
var $235bffbda6f2a3d0$var$ariaCurrentType;






var $bh6RR = parcelRequire("bh6RR");
var $a1f1758889d03c9e$exports = {};






$a1f1758889d03c9e$exports = {
    decode: (parcelRequire("jSyln")),
    verify: (parcelRequire("4F4V4")),
    sign: (parcelRequire("hgMMB")),
    JsonWebTokenError: (parcelRequire("k16ui")),
    NotBeforeError: (parcelRequire("dRNC5")),
    TokenExpiredError: (parcelRequire("2ptu6"))
};


const $4d1d4c8be14450d6$var$tokenName = 'auth-token';
class $4d1d4c8be14450d6$var$UserDataCache {
    /**
     * Saves a token sent from the server to the user's local machine
     * @param {JWT} token 
     * @returns 
     */ static saveToken(token) {
        if (!token) return;
        window.localStorage.setItem($4d1d4c8be14450d6$var$tokenName, JSON.stringify(token));
    }
    /**
     * decodes the token so it can be used locally in react.
     * Also removes the token if it's out of date.
     * @returns an object 
     */ static getTokenObject() {
        let candidate = window.localStorage.getItem($4d1d4c8be14450d6$var$tokenName);
        if (!candidate || candidate === 'null') {
            this.removeToken();
            return null;
        }
        let token = JSON.parse(candidate);
        let decoded = $a1f1758889d03c9e$exports.decode(token);
        if (!!decoded.exp && decoded.exp * 1000 >= Date.now()) return decoded;
        else {
            window.localStorage.removeItem($4d1d4c8be14450d6$var$tokenName);
            return null;
        }
    }
    /**
     * returns the encoded JWT
     * @returns encoded JWT
     */ static getTokenText() {
        let candidate = window.localStorage.getItem($4d1d4c8be14450d6$var$tokenName);
        if (!candidate) return null;
        return candidate;
    }
    /**
     * gives a whole auth string, including the user's JWT, in the format of `bearer xxx.yyy.zzz`
     * plug this into the `authorization` header of http requests.
     * @returns authorization header value
     */ static getAuthHeader() {
        let token = this.getTokenText();
        //console.log(token);
        if (!token) return '';
        return 'bearer ' + token;
    }
    /**
     * removes the token from the user's machine
     */ static removeToken() {
        window.localStorage.removeItem($4d1d4c8be14450d6$var$tokenName);
    // console.log('removed token');
    }
}
var $4d1d4c8be14450d6$export$2e2bcd8739ae039 = $4d1d4c8be14450d6$var$UserDataCache;




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
/**
 * @param {Object} props.user the user object (not ID) to build a link for
 */ class $6cc31eba22f67b38$var$UserInline extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    render() {
        var style = {
            display: 'inline-block',
            padding: '3px'
        };
        const user = this.props.user;
        if (user) {
            let emailhash = user.emailhash;
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                className: "UserInline",
                style: style,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("a", {
                    href: '/user/' + user._id,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                            src: 'https://www.gravatar.com/avatar/' + emailhash + '?s=15&d=retro',
                            alt: user.username + ' avatar'
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            children: [
                                " ",
                                user.username
                            ]
                        })
                    ]
                })
            });
        } else return '';
    }
}
var $6cc31eba22f67b38$export$2e2bcd8739ae039 = $6cc31eba22f67b38$var$UserInline;




var $bh6RR = parcelRequire("bh6RR");

parcelRequire("bh6RR");
function $09f16485618a5dc7$export$2e2bcd8739ae039(props) {
    let close = props.closeButtonText || 'close';
    if (!props.state[props.target]) return '';
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "modal",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "bg-button",
                onClick: props.closeModal,
                "data-target": props.target
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "pane",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                        children: props.title
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "scroll",
                        children: props.children
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "spacer"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        onClick: props.closeModal,
                        "data-target": props.target,
                        children: close
                    })
                ]
            })
        ]
    });
}



class $3f0e235e8472ecaa$var$ListTags extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            availableTags: [],
            newTag: ''
        };
    }
    getTags = ()=>{
        fetch('/api/getDocTags', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            }
        }).then((res)=>res.json()).then((info)=>{
            // console.log(info);
            if (!info) return;
            let unified = info;
            console.log(this.props.doc?.tags);
            this.props.doc?.tags.forEach((tag)=>{
                if (!info.includes(tag)) unified.push(tag);
            });
            unified.sort();
            this.setState({
                availableTags: info
            });
        });
    };
    openModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: true
        });
    };
    closeModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: false
        });
    };
    toggleTag = (e)=>{
        let checked = e.target.checked;
        let tag = e.target.name;
        if (checked) this.props.addTag(tag);
        else this.props.removeTag(tag);
    };
    addNewTag = (e)=>{
        e.preventDefault();
        // let id = this.props.doc._id;
        // console.log(e.target);
        let tag = this.state.newTag;
        this.props.addTag(tag);
        this.setState({
            newTag: '' /*, tagModal: false */ 
        });
        this.getTags();
    };
    changeNewTag = (e)=>{
        this.setState({
            newTag: e.target.value.toLowerCase()
        });
    };
    render() {
        let list = this.props.tags?.filter((x)=>!!x).filter((value, index, self)=>{
            return self.indexOf(value) === index;
        });
        // console.log(list);
        if ((!list || list?.length === 0) && this.props.inline === true) return 'none';
        if (!list || list?.length === 0) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ul", {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                children: "none"
            })
        });
        if (this.props.inline === true) return list.map((x, index)=>{
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                href: "/tag/" + x,
                className: "tag",
                children: x
            }, index);
        }).reduce((prev, curr)=>[
                prev,
                ', ',
                curr
            ]);
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
            children: [
                list.map((tag, index)=>{
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            href: "/tag/" + tag,
                            className: "tag",
                            children: tag
                        })
                    }, index);
                }),
                this.props.doc.editable && !!this.props.addTag && !!this.props.removeTag && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        onClick: (e)=>{
                            this.getTags();
                            this.openModal(e);
                        },
                        "data-target": "tagModal",
                        children: "Edit Tags"
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $09f16485618a5dc7$export$2e2bcd8739ae039), {
                    state: this.state,
                    title: "Add a Tag",
                    target: "tagModal",
                    closeModal: this.closeModal,
                    closeButtonText: "close",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("table", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                            children: [
                                this.state.availableTags.map((at)=>{
                                    let dHasTag = this.props.doc?.tags?.includes(at);
                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                                    htmlFor: at,
                                                    className: dHasTag ? 'checked' : '',
                                                    children: at
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    name: at,
                                                    id: at,
                                                    checked: dHasTag ? true : false,
                                                    onChange: this.toggleTag
                                                })
                                            })
                                        ]
                                    }, at);
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("form", {
                                                onSubmit: this.addNewTag,
                                                id: "newTagForm",
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                                    children: [
                                                        "Add a Tag:\xa0",
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                            placeholder: "new tag",
                                                            value: this.state.newTag,
                                                            onChange: this.changeNewTag
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                form: "newTagForm",
                                                type: "submit"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                (!list || list.length === 0) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                    children: "none"
                })
            ]
        });
    }
}
var $3f0e235e8472ecaa$export$2e2bcd8739ae039 = $3f0e235e8472ecaa$var$ListTags;



/**
 * Sorting function for arrays of objects, usually Entities.
 * @param {string} prop the property name on the object to sort by
 * @param {Boolean} reverse should the comparison be reversed
 * @param {Boolean} insensitive should the comparison be case insensitive
 */ function $66b1ca27b6f9c364$export$2e2bcd8739ae039(prop, reverse = false, insensitive = false) {
    let sign = reverse ? -1 : 1;
    return function(a, b) {
        let numerical = typeof a[prop] === 'number';
        a = a[prop];
        b = b[prop];
        if (insensitive === true && !numerical) {
            a = a.toString().toLowerCase();
            b = b.toString().toLowerCase();
        }
        if (a < b) return -1 * sign;
        if (a > b) return 1 * sign;
        return 0;
    };
}


class $cbb77c764daba2ff$var$TableOfCampaigns extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    render() {
        if (!this.props) return '';
        if (!this.props.campaigns) return '';
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ul", {
                    className: "mobile",
                    children: this.props.campaigns?.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)('name', false, true)).map((campaign)=>{
                        let classes = [
                            campaign.unlisted ? 'unlisted' : '',
                            campaign.trashed ? 'trashed' : ''
                        ];
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            className: classes.join(' '),
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                to: '/campaign/' + campaign._id,
                                children: [
                                    "\uD83E\uDDED ",
                                    campaign.name,
                                    "\xa0",
                                    campaign.trashed ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        title: "trashed",
                                        children: "\u274C"
                                    }) : '',
                                    campaign.unlisted ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        title: "unlisted",
                                        children: "\uD83D\uDCAC"
                                    }) : '',
                                    !!campaign.gm && ' - GM: ' + campaign.gm.username
                                ]
                            })
                        }, campaign._id);
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                    className: "desktop",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                        children: "Campaign"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                        children: "GM"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                        children: "Players"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
                            children: this.props.campaigns?.map((campaign)=>{
                                let classes = [
                                    campaign.unlisted ? 'unlisted' : '',
                                    campaign.trashed ? 'trashed' : ''
                                ];
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                    className: classes.join(' '),
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                            children: [
                                                campaign.trashed ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    title: "trashed",
                                                    children: "\u274C"
                                                }) : '',
                                                campaign.unlisted ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    title: "unlisted",
                                                    children: "\uD83D\uDCAC"
                                                }) : '',
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                                    href: '/campaign/' + campaign._id,
                                                    className: campaign.unlisted ? 'unlisted' : '',
                                                    children: campaign.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cc31eba22f67b38$export$2e2bcd8739ae039), {
                                                user: campaign.gm
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: campaign.allPlayers.map((x)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cc31eba22f67b38$export$2e2bcd8739ae039), {
                                                    user: x
                                                }, x._id))
                                        })
                                    ]
                                }, campaign._id);
                            })
                        })
                    ]
                })
            ]
        });
    }
}
var $cbb77c764daba2ff$export$2e2bcd8739ae039 = $cbb77c764daba2ff$var$TableOfCampaigns;




var $bh6RR = parcelRequire("bh6RR");



parcelRequire("bh6RR");
function $ca2a806ee569b5bf$var$IconSelector(props) {
    props = props.props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            props.type === 'draft' && "\uD83D\uDCDD",
            props.type === 'mod' && "\uD83C\uDF9B\uFE0F",
            props.type === 'game' && "\uD83C\uDF0E",
            props.type === 'gm' && "\uD83D\uDD12",
            props.type === 'campaign' && "\uD83E\uDDED",
            props.type === 'list' && "\uD83D\uDCC3",
            props.type === 'player' && "\uD83D\uDC64",
            !props.iconOnly && props.type
        ]
    });
}
function $ca2a806ee569b5bf$var$DocTypeButton(props) {
    let target = '/' + props.type + 's';
    if (props.iconOnly === true) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ca2a806ee569b5bf$var$IconSelector, {
            props: props
        })
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
        href: target,
        title: props.type,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ca2a806ee569b5bf$var$IconSelector, {
            props: props
        })
    });
}
var $ca2a806ee569b5bf$export$2e2bcd8739ae039 = $ca2a806ee569b5bf$var$DocTypeButton;




function $2bbe2292908daaa2$export$2e2bcd8739ae039(props) {
    let small = props.small === true ? ' small' : '';
    let fullpage = props.fullpage === true ? ' fullpage' : '';
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: 'spinbox' + fullpage,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: "/sgs-loading.svg",
            alt: "loading",
            className: "spinner" + small
        })
    });
}



class $dca75a4a650b1abb$var$TableOfDocs extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    render() {
        if (!this.props.docs) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bbe2292908daaa2$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ul", {
                    className: "mobile",
                    children: this.props.docs?.sort().map((doc)=>{
                        let classes = [
                            doc.unlisted ? 'unlisted' : '',
                            doc.trashed ? 'trashed' : ''
                        ];
                        let url = '/doc/' + doc._id;
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            className: classes.join(' '),
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                to: url,
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ca2a806ee569b5bf$export$2e2bcd8739ae039), {
                                        type: doc.type,
                                        iconOnly: true
                                    }),
                                    "\xa0",
                                    doc.name,
                                    "\xa0",
                                    doc.trashed ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        title: "trashed",
                                        children: "\u274C"
                                    }) : '',
                                    doc.unlisted ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        title: "unlisted",
                                        children: "\uD83D\uDCAC"
                                    }) : ''
                                ]
                            })
                        }, doc._id);
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                    className: "desktop",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                        children: "Doc"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                        children: "Type"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                        children: "Tags"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
                            children: this.props.docs?.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)('name', false, true)).map((doc)=>{
                                let classes = [
                                    doc.unlisted ? 'unlisted' : '',
                                    doc.trashed ? 'trashed' : ''
                                ];
                                let url = '/doc/' + doc._id;
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                    className: classes.join(' '),
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                            children: [
                                                doc.trashed ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    title: "trashed",
                                                    children: "\u274C"
                                                }) : '',
                                                doc.unlisted ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    title: "unlisted",
                                                    children: "\uD83D\uDCAC"
                                                }) : '',
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                                    href: url,
                                                    children: doc.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ca2a806ee569b5bf$export$2e2bcd8739ae039), {
                                                type: doc.type
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3f0e235e8472ecaa$export$2e2bcd8739ae039), {
                                                tags: doc.tags,
                                                inline: true
                                            })
                                        })
                                    ]
                                }, doc._id);
                            })
                        })
                    ]
                })
            ]
        });
    }
}
var $dca75a4a650b1abb$export$2e2bcd8739ae039 = $dca75a4a650b1abb$var$TableOfDocs;



parcelRequire("bh6RR");

const $99f60f01559927dd$var$newDoc = (type, getMyDocs)=>{
    let owner = (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject().user._id;
    fetch('/api/newDoc', {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
        },
        method: "POST",
        body: JSON.stringify({
            name: 'new game',
            // tags: this.getTags(),
            rules: {},
            type: type,
            owner: owner
        })
    }).then((res)=>res.json()).then((info)=>{
        getMyDocs();
        console.log(info);
    });
};
const $99f60f01559927dd$var$newCampaign = (getGMCampaigns)=>{
    let owner = (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject().user._id;
    fetch('/api/newCampaign', {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
        },
        method: "POST",
        body: JSON.stringify({
            name: 'new campaign',
            gm: owner
        })
    }).then((res)=>res.json()).then((info)=>{
        getGMCampaigns();
        console.log(info);
    });
};
const $99f60f01559927dd$var$newList = (getMyLists)=>{
    let user = (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject().user;
    let owner = user._id;
    let ownerName = user.username;
    fetch('/api/list/newList', {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
        },
        method: "POST",
        body: JSON.stringify({
            owner: owner,
            ownername: ownerName
        })
    }).then((res)=>res.json()).then((info)=>{
        getMyLists();
        console.log(info);
    });
};
function $99f60f01559927dd$export$d1d1a43ee3da32c(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                children: "Create"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                onClick: ()=>$99f60f01559927dd$var$newDoc('draft', props.getMyDocs),
                children: "\uD83C\uDF0ENew Game Doc"
            }),
            " ",
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                onClick: ()=>$99f60f01559927dd$var$newCampaign(props.getGMCampaigns),
                children: "\uD83E\uDDEDNew Campaign"
            }),
            " ",
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                onClick: ()=>$99f60f01559927dd$var$newList(props.getMyLists),
                children: "\uD83D\uDCC3New List"
            })
        ]
    });
}






var $bh6RR = parcelRequire("bh6RR");

class $56eb3e51d48a7263$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        // this.id = this.props.match.params.GameId
        this.state = {
            animation: ''
        };
    }
    clickSpin = (e)=>{
        let r = Math.random();
        let range = .2 + r * 4;
        this.setState({
            animation: 'spin ' + range + 's linear infinite'
        });
    };
    clear = (e)=>{
        this.setState({
            // animation: 'unspin ' + .2 + 's linear 1',
            animation: ''
        });
    };
    render() {
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "footer dink",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "foot-center",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        className: "small subtle",
                        children: [
                            "Spiral Game System \xa9 2020 \u2013 ",
                            new Date().getFullYear(),
                            "\xa0",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                href: "https://voidspiral.com",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "Voidspiral Entertainment"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        id: "fidget-spinner",
                        src: "/sgs-loading.svg",
                        alt: "spin me!",
                        title: "spinny~!",
                        className: "foot-logo printless",
                        onMouseDown: this.clickSpin,
                        onMouseUp: this.clear,
                        onMouseOut: this.clear,
                        style: {
                            animation: this.state.animation
                        }
                    })
                ]
            })
        });
    }
}




function $2f89234fad5217c6$var$list(instring) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ul", {
        children: instring.split('\n').filter((x)=>!!x).map((x)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                children: x
            }, x))
    });
}
function $2f89234fad5217c6$export$2e2bcd8739ae039(props) {
    let champions = `
    Twila, Mathew 
    `;
    let galaxies = ``;
    let cyclones = ``;
    let helixes = `
    Baylen
    `;
    let spirals = ``;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "patronList",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                children: "Patrons"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                children: [
                    "We need your support to keep the servers running! Join us at ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: "https://www.patreon.com/voidspiral",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "https://www.patreon.com/voidspiral"
                    })
                ]
            }),
            !!galaxies && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "galaxy",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                        children: "Galaxy Patrons"
                    }),
                    $2f89234fad5217c6$var$list(galaxies)
                ]
            }),
            !!cyclones && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "cyclone",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                        children: "Cyclone Patrons"
                    }),
                    $2f89234fad5217c6$var$list(cyclones)
                ]
            }),
            !!helixes && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "helix",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                        children: "Helix Patrons"
                    }),
                    $2f89234fad5217c6$var$list(helixes)
                ]
            }),
            !!spirals && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "spiral",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                        children: "Spiral Patrons"
                    }),
                    $2f89234fad5217c6$var$list(spirals)
                ]
            }),
            !!champions && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "eldritch",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                        children: "Eldritch Patrons of the Dark Past"
                    }),
                    $2f89234fad5217c6$var$list(champions)
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                children: [
                    "Join us at ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: "https://www.patreon.com/voidspiral",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "https://www.patreon.com/voidspiral"
                    })
                ]
            })
        ]
    });
}





function $2c423a1cfe3de390$export$2e2bcd8739ae039(props) {
    if (!props) return '';
    if (!props.lists) return '';
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                            children: "Docs"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                            children: "Owner"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                            children: "XP"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
                children: props.lists?.map((list)=>{
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                children: [
                                    list.trashed && "\uD83D\uDDD1\uFE0F",
                                    list.unlisted && "\uD83D\uDCAC",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                        to: '/list/' + list._id,
                                        children: list.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                children: list.rules?.map((x)=>{
                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        className: "UserInline",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                            to: '/doc/' + x._id,
                                            children: x.name
                                        }, x._id)
                                    }, x._id);
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cc31eba22f67b38$export$2e2bcd8739ae039), {
                                    user: list.owner
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                children: list.xp
                            })
                        ]
                    }, list._id);
                })
            })
        ]
    });
}


function $84a70a24242fb815$export$2e2bcd8739ae039(obj) {
    for(const prop in obj){
        if (Object.hasOwn(obj, prop)) return false;
    }
    return true;
}


class $afdd361da3e56bef$var$Home extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        // this.id = this.props.match.params.GameId
        this.state = {
            user: {},
            gmCampaigns: [],
            participatingCampaigns: [],
            mydocs: [],
            mylists: [],
            gettingDocs: true,
            gettingPcCampaigns: true,
            gettingGmCampaigns: true
        };
    }
    componentDidMount() {
        this.getUser(()=>{
            // console.log(this.state.user)
            this.getGMCampaigns();
            this.getParticipatingCampaigns();
            this.getMyDocs();
            this.getMyLists();
        });
    }
    getUser(cb) {
        let token = (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user;
        if (!token || (0, $84a70a24242fb815$export$2e2bcd8739ae039)(token)) return;
        this.setState({
            user: token
        }, ()=>cb());
    }
    getGMCampaigns = ()=>{
        if (!this.state.user) return;
        fetch('/api/getGmingCampaigns', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.state.user._id,
                requesterId: (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user._id
            })
        }).then((res)=>res.json()).then((results)=>{
            // console.log(results);
            this.setState({
                gmCampaigns: results,
                gettingGmCampaigns: false
            });
        });
    };
    getParticipatingCampaigns = ()=>{
        if (!this.state.user) return;
        fetch('/api/getParticipatingCampaigns', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.state.user._id,
                requesterId: (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user._id
            })
        }).then((res)=>res.json()).then((results)=>{
            // console.log(results);
            this.setState({
                participatingCampaigns: results,
                gettingPcCampaigns: false
            });
        });
    };
    getMyDocs = ()=>{
        if (!this.state.user) return;
        try {
            let localJson = window.localStorage.getItem('userDocs');
            // console.log(localJson);
            if (localJson) {
                let localObj = JSON.parse(localJson);
                // console.log(localObj);
                if (localObj) this.setState({
                    mydocs: localObj
                });
            }
        } catch (e) {
            console.log('Error parsing cached document json', e);
        }
        fetch('/api/getMyDocs', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.state.user._id,
                requesterId: (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user._id
            })
        }).then((res)=>res.json()).then((results)=>{
            // console.log(results);
            this.setState({
                mydocs: results,
                gettingDocs: false
            });
            // add docs to localstorage
            let ids = results.map((x)=>{
                let optimized = {};
                optimized._id = x._id;
                optimized.type = x.type;
                optimized.tags = x.tags;
                optimized.name = x.name;
                optimized.unlisted = x.unlisted;
                return optimized;
            });
            ids = JSON.stringify(ids);
            // console.log(ids);
            window.localStorage.setItem('userDocs', ids);
        });
    };
    getMyLists = ()=>{
        if (!this.state.user) return;
        fetch('/api/getMyLists', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.state.user._id,
                requesterId: (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user._id
            })
        }).then((res)=>res.json()).then((results)=>{
            // console.log(results);
            this.setState({
                mylists: results,
                gettingLists: false
            });
        });
    };
    render() {
        const token = (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject();
        const user = token?.user;
        let emailhash = user?.emailhash;
        document.title = [
            'Dashboard',
            'SGS'
        ].join(' - ');
        if (!user) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "Spiral Game System"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("blockquote", {
                    children: "Blow the lid off"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                    children: "Welcome to the new SGS homepage."
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                    children: [
                        "You probably want to either\xa0",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                            to: "/login",
                            children: "log in"
                        }),
                        "\xa0or\xa0",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                            to: "/register",
                            children: "register."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                    children: [
                        "If you just want to look around, have a check out our ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                            to: "/games",
                            children: "public games"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2f89234fad5217c6$export$2e2bcd8739ae039), {})
            ]
        });
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h1", {
                    children: [
                        "Dashboard:\xa0",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            title: user._id,
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                href: '/user/' + user._id,
                                children: user.username
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    src: 'https://www.gravatar.com/avatar/' + emailhash + '?d=retro',
                    alt: user.name + ' avatar'
                }),
                !!user?._id && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $99f60f01559927dd$export$d1d1a43ee3da32c), {
                    getMyDocs: this.getMyDocs,
                    getGMCampaigns: this.getGMCampaigns,
                    getMyLists: this.getMyLists
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                    children: "My Docs"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dca75a4a650b1abb$export$2e2bcd8739ae039), {
                    docs: this.state.mydocs
                }),
                this.state.gettingDocs && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bbe2292908daaa2$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                    children: "My GM Campaigns"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cbb77c764daba2ff$export$2e2bcd8739ae039), {
                    campaigns: this.state.gmCampaigns
                }),
                this.state.gettingGmCampaigns && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bbe2292908daaa2$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                    children: "My Player Campaigns"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cbb77c764daba2ff$export$2e2bcd8739ae039), {
                    campaigns: this.state.participatingCampaigns
                }),
                this.state.gettingPcCampaigns && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bbe2292908daaa2$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                    children: "My Army Lists"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2c423a1cfe3de390$export$2e2bcd8739ae039), {
                    lists: this.state.mylists
                }),
                this.state.gettingLists && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bbe2292908daaa2$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $afdd361da3e56bef$export$2e2bcd8739ae039 = $afdd361da3e56bef$var$Home;




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");



class $431a006feb558d99$var$LoginBox extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    // class ctor
    constructor(props){
        super(props);
        this.state = {
            email: '',
            password: '',
            error: '',
            token: {}
        };
    }
    handleInputChange = (event)=>{
        const target = event.target;
        const value = target.value;
        const name = target.name;
        // console.log(value)
        this.setState({
            [name]: value
        });
    };
    attemptLogin = (event)=>{
        event.preventDefault();
        fetch('/api/login', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                email: this.state.email,
                password: this.state.password
            })
        }).then((res)=>res.json()).then((res)=>{
            (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).saveToken(res.token);
            this.props.history.push("/");
            window.location.reload();
        }).catch((e)=>console.log(e));
    };
    // render class instance
    render() {
        let err = this.state.error ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
            children: this.state.error
        }) : '';
        let token = (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject();
        if (!!token) this.props.history.push("/");
        else return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
            name: "loginbox",
            className: "loginbox",
            onSubmit: this.attemptLogin,
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            children: "Email"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                            type: "text",
                            name: "email",
                            value: this.state.email,
                            onChange: this.handleInputChange
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            children: "Password"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                            type: "password",
                            name: "password",
                            value: this.state.password,
                            onChange: this.handleInputChange
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                    type: "submit",
                    value: "log in"
                }),
                err
            ]
        });
    }
}
var $431a006feb558d99$export$2e2bcd8739ae039 = (0, $14986c2201283622$export$369b6b2b30582e8e)($431a006feb558d99$var$LoginBox);




class $eb275368faae4e12$var$Login extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        //console.log(props)
        this.outcome = this.props.match.params.Message;
        //console.log(this.props.match.params.Message)
        this.state = {
            sessions: []
        };
    }
    render() {
        //const message = this.outcome === 'no' ? 'incorrect login or password.' : ''
        //console.log(this.outcome)
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "Login"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $431a006feb558d99$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                    href: "/ResetRequest",
                    children: "Forgot Password"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2f89234fad5217c6$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $eb275368faae4e12$export$2e2bcd8739ae039 = $eb275368faae4e12$var$Login;




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");



class $192a203a25901f87$var$LoginBox extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            email: '',
            username: '',
            password: '',
            error: '',
            token: {}
        };
    }
    handleInputChange = (event)=>{
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    };
    attemptLogin = (event)=>{
        event.preventDefault();
        fetch('/api/register', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                email: this.state.email,
                username: this.state.username,
                password: this.state.password
            })
        }).then((res)=>res.json()).then((res)=>{
            if (!res) return;
            if (res.error) {
                console.log(res.error);
                let e = JSON.stringify(res.error.keyValue) + ' already in use.';
                console.log(e);
                return this.setState({
                    error: e
                });
            }
            console.log(res);
            (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).saveToken(res.token);
            this.props.history.push("/");
        }).catch(function(e) {
            this.setState({
                error: e
            });
        });
    };
    render() {
        let err = this.state.error ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
            children: this.state.error
        }) : '';
        let token = (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject();
        if (!!token) {
            this.props.history.push("/");
            return '';
        }
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
            name: "loginbox",
            className: "loginbox",
            onSubmit: this.attemptLogin,
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            children: "Email"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                            type: "text",
                            name: "email",
                            value: this.state.email,
                            onChange: this.handleInputChange
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            children: "Username"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                            type: "text",
                            name: "username",
                            value: this.state.username,
                            onChange: this.handleInputChange
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            children: "Password"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                            type: "password",
                            name: "password",
                            value: this.state.password,
                            onChange: this.handleInputChange
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                    type: "submit",
                    value: "register"
                }),
                err
            ]
        });
    }
}
var $192a203a25901f87$export$2e2bcd8739ae039 = (0, $14986c2201283622$export$369b6b2b30582e8e)($192a203a25901f87$var$LoginBox);



class $37dae4e099f2b2e6$var$Register extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        //console.log(props)
        this.outcome = this.props.match.params.Message;
        //console.log(this.props.match.params.Message)
        this.state = {};
    }
    render() {
        document.title = [
            'Register',
            'SGS'
        ].join(' - ');
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "Register"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                    children: [
                        "We recommend ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            href: "https://www.useapassphrase.com/",
                            target: "_blank",
                            children: "using a passphrase."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                    children: "We also recommend using a password manager, such as Bitwarden or Lastpass."
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $192a203a25901f87$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $37dae4e099f2b2e6$export$2e2bcd8739ae039 = $37dae4e099f2b2e6$var$Register;



parcelRequire("bh6RR");

const $bf8ecfb2c8182fa3$var$NotFound = ()=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                children: "NotFound"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
        ]
    });
};
var $bf8ecfb2c8182fa3$export$2e2bcd8739ae039 = $bf8ecfb2c8182fa3$var$NotFound;




var $bh6RR = parcelRequire("bh6RR");
var $920954e343704e08$exports = {};
const $920954e343704e08$var$capitalize = (str)=>{
    if (!str) return '';
    if (str.length === 0) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
};
$920954e343704e08$exports = {
    capitalize: $920954e343704e08$var$capitalize
};




var $bh6RR = parcelRequire("bh6RR");
class $8d1cab1a66208337$var$DatabaseInfo extends (0, $bh6RR.Component) {
    // class ctor
    constructor(props){
        //call base constructor with props
        super(props);
        // initialize blank state var
        this.state = {
            info: {
                count: 0
            }
        };
    }
    // initializer
    componentDidMount() {
        this.getStats();
    }
    // class method
    getStats = ()=>{
        fetch('/api/getStats').then((res)=>res.json()).then((info)=>{
            if (!info) return;
            this.setState({
                info: info
            });
        });
    };
    // render class instance
    render() {
        let i = this.state.info;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                        children: [
                            i.users,
                            " users"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                        children: [
                            i.docs,
                            " docs"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                        children: [
                            i.campaigns,
                            " campaigns"
                        ]
                    })
                ]
            })
        });
    }
}
var $8d1cab1a66208337$export$2e2bcd8739ae039 = $8d1cab1a66208337$var$DatabaseInfo;



class $4afc36bb4ad0795e$var$StatusPage extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.id = this.props.match.params.DocId;
        this.state = {
            doc: {},
            campaigns: []
        };
    }
    render() {
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "Status"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d1cab1a66208337$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $4afc36bb4ad0795e$export$2e2bcd8739ae039 = $4afc36bb4ad0795e$var$StatusPage;




var $bh6RR = parcelRequire("bh6RR");







parcelRequire("bh6RR");
function $2762edc703e62f3e$export$2e2bcd8739ae039(props) {
    let content = ' ';
    let title = '';
    if (props.value === undefined || props.value === null) {
        content = ' ';
        title = props.noValueMsg || 'enter a value';
    }
    if (props.value === true) {
        content = "\u2714";
        title = 'valid';
    }
    if (props.value === false) {
        content = "\u274C";
        title = props.falseMsg || 'invalid';
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
        title: title,
        className: "validation",
        children: content
    });
}





class $f8518f49b8182f77$var$UserPage extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.id = this.props.match.params.UserId;
        // console.log(this.id)
        this.state = {
            user: {},
            gmCampaigns: false,
            bannedCampaigns: false,
            participatingCampaigns: false,
            mylists: false,
            mydocs: false,
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            oldPassword_valid: null,
            newPassword_valid: null,
            confirmPassword_valid: null
        };
    }
    componentDidMount() {
        this.getUser(()=>{
            this.getGMCampaigns();
            this.getParticipatingCampaigns();
            this.getBannedCampaigns();
            this.getMyDocs();
            this.getMyLists();
        });
    }
    getUser = (cb)=>{
        // console.log("client > get session")
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.id
            })
        };
        fetch('/api/getUser', options).then((res)=>res.json()).then((info)=>this.setState({
                user: info
            }, ()=>cb()));
    };
    getGMCampaigns = ()=>{
        if (!this.state.user) return;
        fetch('/api/getGmingCampaigns', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.id,
                requesterId: (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user._id
            })
        }).then((res)=>res.json()).then((results)=>{
            // console.log(results);
            this.setState({
                gmCampaigns: results
            });
        });
    };
    getParticipatingCampaigns = ()=>{
        if (!this.state.user) return;
        fetch('/api/getParticipatingCampaigns', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.id,
                requesterId: (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user._id
            })
        }).then((res)=>res.json()).then((results)=>{
            // console.log(results);
            this.setState({
                participatingCampaigns: results
            });
        });
    };
    getBannedCampaigns = ()=>{
        if (!this.state.user) return;
        fetch('/api/getBannedCampaigns', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.id,
                requesterId: (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user._id
            })
        }).then((res)=>res.json()).then((results)=>{
            // console.log(results);
            this.setState({
                bannedCampaigns: results
            });
        });
    };
    getMyLists = ()=>{
        if (!this.state.user) return;
        fetch('/api/getMyLists', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.state.user._id,
                requesterId: (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user._id
            })
        }).then((res)=>res.json()).then((results)=>{
            // console.log(results);
            this.setState({
                mylists: results,
                gettingLists: false
            });
        });
    };
    updatePassword = (oldpassword, newpassword)=>{
        if (!this.state.user) return;
        fetch('/api/updatePassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.id,
                newpassword: newpassword,
                oldpassword: oldpassword
            })
        }).then((res)=>res.json()).then((results)=>{
            console.log(results);
        });
    };
    banUser = ()=>{
        if (!this.state.user) return;
        fetch('/api/updateUserStatus', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.id,
                newstatus: 'BANNED'
            })
        }).then((res)=>res.json()).then((results)=>{
            this.setState({
                user: results
            });
        });
    };
    shadowbanUser = ()=>{
        if (!this.state.user) return;
        fetch('/api/updateUserStatus', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.id,
                newstatus: 'SHADOWBANNED'
            })
        }).then((res)=>res.json()).then((results)=>{
            this.setState({
                user: results
            });
        });
    };
    unbanUser = ()=>{
        if (!this.state.user) return;
        fetch('/api/updateUserStatus', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.id,
                newstatus: 'USER'
            })
        }).then((res)=>res.json()).then((results)=>{
            this.setState({
                user: results
            });
        });
    };
    getMyDocs = ()=>{
        if (!this.state.user) return;
        fetch('/api/getMyDocs', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.state.user._id,
                requesterId: (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user._id
            })
        }).then((res)=>res.json()).then((results)=>{
            // console.log(results);
            this.setState({
                mydocs: results
            });
        });
    };
    openModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: true
        });
    };
    closeModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: false,
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            oldPassword_valid: null,
            newPassword_valid: null,
            confirmPassword_valid: null
        });
    };
    handleInputChange = (event)=>{
        const target = event.target;
        const value = target.value;
        const name = target.name;
        const validation = name + '_valid';
        const valid = this.isValid(name, value);
        this.setState({
            [name]: value,
            [validation]: valid
        });
    };
    isValid = (name, value)=>{
        if (value === undefined || value === null) return null;
        if (name === 'oldPassword' && !!value) return true;
        if (name === 'newPassword' && value.length > 7) {
            if (this.state.confirmPassword !== value) this.setState({
                confirmPassword_valid: false
            });
            return true;
        }
        if (name === 'confirmPassword' && value === this.state.newPassword) return true;
        return false;
    };
    handlePasswordSubmit = (e)=>{
        e.preventDefault();
        this.updatePassword(this.state.oldPassword, this.state.newPassword);
        this.setState({
            changePassword: false,
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            oldPassword_valid: null,
            newPassword_valid: null,
            confirmPassword_valid: null
        });
    };
    render() {
        const token = (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject();
        const user = this.state.user;
        // console.log(user);
        let emailhash = user?.emailhash;
        // determine editing privelages
        const isUser = !!user && user._id === token?.user._id;
        const isAdmin = token?.user.userLevel === 'ADMIN';
        const canDemote = (token?.user.userLevel === 'MOD' || token?.user.userLevel === 'ADMIN') && user.userLevel !== 'MOD' && user.userLevel !== 'ADMIN';
        const canEdit = isUser || canDemote || isAdmin;
        // render
        if (user) {
            document.title = [
                user.username,
                'SGS'
            ].join(' - ');
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h1", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                href: "/users",
                                children: "User"
                            }),
                            ": ",
                            user.username
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: 'https://www.gravatar.com/avatar/' + emailhash + '?d=retro',
                        alt: user.username + ' avatar'
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                        children: [
                            "user id: \xa0",
                            this.id,
                            "\xa0",
                            user.userLevel
                        ]
                    }),
                    !!user.tags && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                children: "Tags"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3f0e235e8472ecaa$export$2e2bcd8739ae039), {
                                tags: user.tags,
                                inline: true
                            })
                        ]
                    }),
                    isUser && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $99f60f01559927dd$export$d1d1a43ee3da32c), {
                        getMyDocs: this.getMyDocs
                    }),
                    this.state.mydocs?.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                children: "My Docs:"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dca75a4a650b1abb$export$2e2bcd8739ae039), {
                                docs: this.state.mydocs
                            })
                        ]
                    }),
                    this.state.gmCampaigns?.length > 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                children: "Game Master In:"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cbb77c764daba2ff$export$2e2bcd8739ae039), {
                                campaigns: this.state.gmCampaigns
                            })
                        ]
                    }) : '',
                    this.state.participatingCampaigns?.length > 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                children: "Participating In:"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cbb77c764daba2ff$export$2e2bcd8739ae039), {
                                campaigns: this.state.participatingCampaigns
                            })
                        ]
                    }) : '',
                    this.state.bannedCampaigns?.length > 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                children: "Banned In:"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cbb77c764daba2ff$export$2e2bcd8739ae039), {
                                campaigns: this.state.bannedCampaigns
                            })
                        ]
                    }) : '',
                    this.state.mylists?.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                children: "My Army Lists"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2c423a1cfe3de390$export$2e2bcd8739ae039), {
                                lists: this.state.mylists
                            })
                        ]
                    }),
                    canEdit && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                children: "Edit User"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                            onClick: this.openModal,
                                            "data-target": "changePassword",
                                            children: "Change Password"
                                        })
                                    }),
                                    canDemote && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                            onClick: this.shadowbanUser,
                                            children: "Shadowban User"
                                        })
                                    }),
                                    canDemote && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                            onClick: this.banUser,
                                            children: "Ban User"
                                        })
                                    }),
                                    canDemote && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                            onClick: this.unbanUser,
                                            children: "Unban User"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $09f16485618a5dc7$export$2e2bcd8739ae039), {
                        state: this.state,
                        closeModal: this.closeModal,
                        target: "changePassword",
                        title: "Change Password",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
                            onSubmit: this.handlePasswordSubmit,
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                    children: [
                                        "Old Password \xa0",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                            type: "password",
                                            value: this.state.oldPassword,
                                            name: "oldPassword",
                                            onChange: this.handleInputChange
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2762edc703e62f3e$export$2e2bcd8739ae039), {
                                            value: this.state.oldPassword_valid
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                    children: [
                                        "New Password \xa0",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                            type: "password",
                                            value: this.state.newPassword,
                                            name: "newPassword",
                                            onChange: this.handleInputChange
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2762edc703e62f3e$export$2e2bcd8739ae039), {
                                            value: this.state.newPassword_valid
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                    children: [
                                        "Confirm New Password \xa0",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                            type: "password",
                                            value: this.state.confirmPassword,
                                            name: "confirmPassword",
                                            onChange: this.handleInputChange
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2762edc703e62f3e$export$2e2bcd8739ae039), {
                                            value: this.state.confirmPassword_valid
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                    type: "submit",
                                    disabled: !(this.state.oldPassword_valid && this.state.newPassword_valid && this.state.confirmPassword_valid)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
                ]
            });
        } else return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "User: none"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                    children: [
                        "user id: ",
                        this.id
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bbe2292908daaa2$export$2e2bcd8739ae039), {
                    fullpage: true
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $f8518f49b8182f77$export$2e2bcd8739ae039 = $f8518f49b8182f77$var$UserPage;




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");


class $974b97d1d64b8808$var$TableOfUsers extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    render() {
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                children: "User"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                children: "Tags"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
                    children: this.props.users?.map((user)=>{
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cc31eba22f67b38$export$2e2bcd8739ae039), {
                                        user: user
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3f0e235e8472ecaa$export$2e2bcd8739ae039), {
                                        tags: user.tags,
                                        inline: true
                                    })
                                })
                            ]
                        }, user._id);
                    })
                })
            ]
        });
    }
}
var $974b97d1d64b8808$export$2e2bcd8739ae039 = $974b97d1d64b8808$var$TableOfUsers;




class $ad9b06e062a32248$var$UserListPage extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.id = this.props.match.params.SessionId;
        this.state = {
            users: []
        };
    // this.getSession()
    }
    componentDidMount() {
        this.getUsers();
    }
    getUsers = ()=>{
        fetch('/api/listUsers', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            }
        }).then((res)=>res.json()).then((info)=>{
            // console.log(info);
            this.setState({
                users: info
            });
        });
    };
    render() {
        document.title = [
            'Users',
            'SGS'
        ].join(' - ');
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "Users"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $974b97d1d64b8808$export$2e2bcd8739ae039), {
                    users: this.state.users
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $ad9b06e062a32248$export$2e2bcd8739ae039 = $ad9b06e062a32248$var$UserListPage;




var $bh6RR = parcelRequire("bh6RR");

class $1fd3f84224aa9cdc$var$UniformGroup {
    constructor(diceString){
        this.dieSize = 0;
        this.numberOfDice = 0;
        this.min = 0;
        this.max = 0;
        if (!diceString) return;
        const cleanPattern = /^(?<dice>\d+)d(?<size>\d+)$/gi;
        const match = cleanPattern.exec(diceString);
        cleanPattern.lastIndex = 0;
        // console.log('match', match);
        if (!!match && !match.groups.size) {
            console.log("replaced size");
            match.groups.size = 1;
        }
        if (!match || !match.groups.size || !match.groups.dice) throw 'dice string must be in format XdY. ' + diceString;
        let parsed = parseInt(match.groups.size);
        this.dieSize = parsed;
        this.numberOfDice = parseInt(match.groups.dice);
        this.min = this.numberOfDice;
        this.max = this.numberOfDice * this.dieSize;
        this.med = (this.min + this.max) / 2;
    }
    plusGroup(dice) {
        if (!dice instanceof $1fd3f84224aa9cdc$var$UniformGroup) throw 'UniformGroup.plusGroup only takes another UniformGroup!';
        if (this.dieSize !== dice.dieSize) throw 'Die sizes of UniformGroup.plusGroup must match!';
        let newGroup = new $1fd3f84224aa9cdc$var$UniformGroup();
        newGroup.dieSize = this.dieSize;
        newGroup.numberOfDice = this.numberOfDice + dice.numberOfDice;
        return newGroup;
    }
    minusGroup(dice) {
        if (!dice instanceof $1fd3f84224aa9cdc$var$UniformGroup) throw 'UniformGroup.minusGroup only takes another UniformGroup!';
        if (this.dieSize !== dice.dieSize) throw 'Die sizes of UniformGroup.minusGroup must match!';
        let newGroup = new $1fd3f84224aa9cdc$var$UniformGroup();
        newGroup.dieSize = this.dieSize;
        newGroup.numberOfDice = this.numberOfDice - dice.numberOfDice;
        return newGroup;
    }
    isCompatableWith(dice) {
        if (!dice instanceof $1fd3f84224aa9cdc$var$UniformGroup) throw 'UniformGroup.isCompatableWith only takes another UniformGroup!';
        if (this.dieSize === dice.dieSize) return true;
        return false;
    }
    timesNumber(number) {
        if (!number instanceof Number && typeof number !== 'number') throw 'UniformGroup.timesNumber only takes a Number!';
        let newUg = new $1fd3f84224aa9cdc$var$UniformGroup();
        newUg.dieSize = this.dieSize;
        newUg.numberOfDice = this.numberOfDice * number;
        return newUg;
    }
    average() {
        let a = (this.dieSize + 1) / 2;
        return a * this.numberOfDice;
    }
    toString() {
        return this.numberOfDice + 'd' + this.dieSize;
    }
}
var $1fd3f84224aa9cdc$export$2e2bcd8739ae039 = $1fd3f84224aa9cdc$var$UniformGroup;


class $123174628c8e7fed$var$Parenthetical {
    constructor(string){
        this.parent = null;
        this.children = [];
        this.opType = '';
        this.max = 0;
        this.med = 0;
        this.min = 0;
    // this.id = (Math.random() + 1).toString(36).substring(7);
    }
    collapse() {
        if (!this.children) return;
        if (this.children.length === 1 && this.children[0] instanceof $123174628c8e7fed$var$Parenthetical && !!this.children[0].children) this.children = this.children[0].children;
        if (!this.children) return;
        for(let i = 0; i < this.children.length; i++){
            let child = this.children[i];
            if (child instanceof $123174628c8e7fed$var$Parenthetical) {
                child.collapse();
                if (!!child.children && child.children.length === 1) this.children[i] = this.children[i].children[0];
            }
        }
    }
    segment() {
        if (!this.children) return;
        // find breaks
        let lastType = '';
        let breaks = [];
        let types = [];
        let debug = '';
        for(let i = 0; i < this.children.length; i++){
            let child = this.children[i];
            let type = '';
            if (child === '+' || child === '-') type = 'a';
            else if (child === '*' || child === '/') type = 's';
            if (lastType === '' && type !== '') types.push(type);
            if (lastType !== '' && type !== '' && type !== lastType) {
                breaks.push(i);
                debug += i + ': (' + child + ') `' + lastType + '` -> `' + type + '` BREAK\n';
                lastType = '';
            } else {
                debug += i + ': (' + child + ') `' + lastType + '` -> `' + type + '`\n';
                if (type !== '') lastType = type;
            }
        }
        // console.log(debug)
        // package children
        if (breaks === []) {
            this.opType = lastType;
            return;
        }
        breaks.push(this.children.length);
        // console.log(breaks);
        // console.log(types);
        let newChildren = [];
        let lastBreak = 0;
        for(let i = 0; i < breaks.length; i++){
            let b = breaks[i];
            let n = new $123174628c8e7fed$var$Parenthetical();
            n.parent = this;
            n.opType = types[i];
            if (i === 0) n.children = this.children.slice(lastBreak, b);
            else n.children = this.children.slice(lastBreak + 1, b);
            if (i !== 0) newChildren.push(this.children[lastBreak]);
            newChildren.push(n);
            lastBreak = b;
        }
        this.children = newChildren;
    }
    reduce() {
        if (!this.children) return;
        if (this.children.length === 1) {
            let child = this.children[0];
            if (child instanceof $123174628c8e7fed$var$Parenthetical) {
                child.reduce();
                this.min = child.min;
                this.max = child.max;
            } else if (child instanceof (0, $1fd3f84224aa9cdc$export$2e2bcd8739ae039)) {
                this.min = child.min;
                this.max = child.max;
            }
            return;
        }
        let newChildren = [];
        let prev = null;
        let lastValue = 0;
        for(let i = 0; i < this.children.length; i++){
            let child = this.children[i];
            if (child instanceof $123174628c8e7fed$var$Parenthetical) child.reduce();
            // for negative starting values
            if (i === 0 && child === '-') newChildren.push(child);
            // skip normal items, only proceed on operators
            if (i === 0 || i === this.children.length - 1 || !'+-*/'.includes(child)) {
                prev = child;
                continue;
            }
            // only check operators when we can have Prev and Next
            let next = this.children[i + 1];
            let combo = prev.constructor.name + child + next.constructor.name;
            // console.log('combo: ', combo);
            // situations we CAN calculate
            if (combo === 'Number+Number') {
                prev = prev + next;
                i++;
            } else if (combo === 'Number-Number') {
                prev = prev - next;
                i++;
            } else if (combo === 'Number*Number') {
                prev = prev * next;
                i++;
            } else if (combo === 'Number/Number') {
                if (next == 0) prev = 0;
                else prev = prev / next;
                i++;
            } else if (combo === 'UniformGroup*Number') {
                prev = prev.timesNumber(next);
                i++;
            } else if (combo === 'Number*UniformGroup') {
                prev = next.timesNumber(prev);
                i++;
            } else if (combo === 'UniformGroup+UniformGroup' && prev.isCompatableWith(next)) {
                prev = prev.plusGroup(next);
                i++;
            } else if (combo === 'UniformGroup-UniformGroup' && prev.isCompatableWith(next)) {
                prev = prev.minusGroup(next);
                i++;
            } else {
                newChildren.push(prev);
                newChildren.push(child);
                prev = child;
            }
        }
        newChildren.push(prev);
        // console.log(newChildren);
        this.children = newChildren;
    }
    calculate() {
        if (!this.children || this.children.length === 0) return;
        let len = this.children.length;
        let max = undefined;
        let med = undefined;
        let min = undefined;
        let first = this.children[0];
        if (first instanceof $123174628c8e7fed$var$Parenthetical) {
            first.calculate();
            max = first.max;
            med = first.med;
            min = first.min;
        }
        if (first instanceof (0, $1fd3f84224aa9cdc$export$2e2bcd8739ae039)) {
            max = first.max;
            med = first.med;
            min = first.min;
        }
        if (first instanceof Number) {
            max = first;
            med = first;
            min = first;
        }
        for(let i = 0; i < len; i++){
            let current = this.children[i];
            let next = i + 1 < len ? this.children[i + 1] : undefined;
            if (current === '+') {
                if (next instanceof $123174628c8e7fed$var$Parenthetical) {
                    next.calculate();
                    max += next.max;
                    med += next.med;
                    min += next.min;
                }
                if (next instanceof (0, $1fd3f84224aa9cdc$export$2e2bcd8739ae039)) {
                    max += next.max;
                    med += next.med;
                    min += next.min;
                }
                if (next instanceof Number) {
                    max += next;
                    med += next;
                    min += next;
                }
            } else if (current === '-') {
                if (next instanceof $123174628c8e7fed$var$Parenthetical) {
                    next.calculate();
                    max -= next.max;
                    med -= next.med;
                    min -= next.min;
                }
                if (next instanceof (0, $1fd3f84224aa9cdc$export$2e2bcd8739ae039)) {
                    max -= next.max;
                    med -= next.med;
                    min -= next.min;
                }
                if (next instanceof Number) {
                    max -= next;
                    med -= next;
                    min -= next;
                }
            } else if (current === '*') {
                if (next instanceof $123174628c8e7fed$var$Parenthetical) {
                    next.calculate();
                    max *= next.max;
                    med *= next.med;
                    min *= next.min;
                }
                if (next instanceof (0, $1fd3f84224aa9cdc$export$2e2bcd8739ae039)) {
                    max *= next.max;
                    med *= next.med;
                    min *= next.min;
                }
                if (next instanceof Number) {
                    max *= next;
                    med *= next;
                    min *= next;
                }
            } else if (current === '/') {
                if (next instanceof $123174628c8e7fed$var$Parenthetical) {
                    next.calculate();
                    max /= next.max;
                    med /= next.med;
                    min /= next.min;
                }
                if (next instanceof (0, $1fd3f84224aa9cdc$export$2e2bcd8739ae039)) {
                    max /= next.max;
                    med /= next.med;
                    min /= next.min;
                }
                if (next instanceof Number) {
                    max /= next;
                    med /= next;
                    min /= next;
                }
            }
        }
        this.min = min;
        this.med = med;
        this.max = max;
    }
    toString() {
        // console.log(this.debugChildren());
        if (!this.children || this.children.length === 0) return 0;
        if (this.children.length === 1) return String(this.children[0]);
        let multiple = this.children.map((child)=>child.toString()).join('');
        if (this.parent === null || this.top === true) return multiple;
        return '(' + multiple + ')';
    }
    isNumber() {
        if (!!this.children && this.children.length === 1 && this.children[0] instanceof Number) return this.children[0];
        return null;
    }
    debugChildren(level = 0) {
        let out = '';
        out += $123174628c8e7fed$var$step.repeat(level);
        // out += this.id;
        out += '(\n';
        if (!!this.children) this.children.forEach((child)=>{
            if (child instanceof $123174628c8e7fed$var$Parenthetical) out += child.debugChildren(level + 1);
            else {
                out += $123174628c8e7fed$var$step.repeat(level + 1);
                out += '`';
                out += child;
                out += '`';
                out += '\n';
            }
        });
        out += $123174628c8e7fed$var$step.repeat(level);
        out += ')\n';
        return out;
    }
}
const $123174628c8e7fed$var$step = '  ';
var $123174628c8e7fed$export$2e2bcd8739ae039 = $123174628c8e7fed$var$Parenthetical;



function $4ffd9cb584b9bf7e$var$d(debug, value) {
    if (debug) console.log(value);
}
/**
 * A class for representing and calculating a pool of dice and bonuses.
 */ class $4ffd9cb584b9bf7e$var$DicePool {
    /**
     * Creates a new DicePool object
     * @param {*} string the string representation of the dice pool, such as `1d6+2d8+2`.
     * @param {Boolean} debug default false. When true, dice pool construction will emit debug messages. 
     */ constructor(string, debug = false){
        this.node = new (0, $123174628c8e7fed$export$2e2bcd8739ae039)();
        // this.string = 0;
        // this.number = 0;
        // return early for blank ctor
        if (string === undefined || string === null || string === '') return;
        this.validateCtor(string);
        this.tokenize(string, debug);
    // console.log(this);
    }
    validateCtor(string) {
        // ERROR HANDLING
        if (typeof string !== 'string' && typeof string !== 'number') throw 'DicePool wanted a number or a string, got `' + string + '` : typeof ' + typeof string;
        if (typeof string === 'number') {
            if (isNaN(string)) throw 'DicePool wanted a number or a string, got NaN';
            string = '' + string;
        // console.log('ctor string was number', string);
        }
        if (string === 'none') return;
        let leftoverParens = 0;
        [
            ...string
        ].forEach((c)=>{
            if (c === '(') leftoverParens++;
            if (c === ')') leftoverParens--;
        });
        if (string.includes('none')) string = string.replace(/none/g, 'd0');
        if (leftoverParens !== 0) {
            this.error = 'DicePool Invalid, unbalanced parens: `' + string + '`';
            console.error(this.error);
            string = '';
        }
        const invalidChars = /[^\dd+÷\-*x✕×/\s\(\)\.]/gi;
        if (!!string.match(invalidChars)) {
            this.error = 'DicePool Invalid, invalid character: `' + string + '`';
            console.error(this.error);
            string = '';
        }
        const invalidStarts = /^[\/÷\*x✕×]/im;
        const invalidEndings = /[\/÷\*x✕×+-]$/im;
        if (!!string.match(invalidStarts)) {
            this.error = 'DicePool cannot start with that char. `' + string + '`';
            console.error(this.error);
            string = '';
        }
        if (!!string.match(invalidEndings)) {
            // throw 'DicePool cannot end with that char. ' + string;
            this.error = 'DicePool cannot end with that char. `' + string + '`';
            console.error(this.error);
            string = '';
        }
        const divChars = /[\/÷]/;
        const multChars = /[\*x✕×]/;
        string = string.replace(divChars, '/');
        string = string.replace(multChars, '*');
    }
    tokenize(string, debug = false) {
        // d(debug, 'tokenize', string);
        const scaling = '*/';
        const arithmetic = '+-';
        const operators = arithmetic + scaling;
        const root = new (0, $123174628c8e7fed$export$2e2bcd8739ae039)();
        root.top = true;
        let currentNode = root;
        let currentContent = '';
        let lastOpType = '';
        for(let i = 0; i < string.length; i++){
            const char = string[i];
            // NEW PARENTHETICAL token
            if (char === '(') {
                let n = new (0, $123174628c8e7fed$export$2e2bcd8739ae039)();
                n.parent = currentNode;
                currentNode.children.push(n);
                currentNode = n;
            } else if (char === ')') {
                if (!!currentContent) currentNode.children.push($4ffd9cb584b9bf7e$var$parseContent(currentContent));
                currentContent = '';
                currentNode = currentNode.parent;
            } else if (operators.includes(char)) {
                let opType = arithmetic.includes(char) ? 'arithmetic' : 'scaling';
                if (!!currentContent) currentNode.children.push($4ffd9cb584b9bf7e$var$parseContent(currentContent));
                currentNode.children.push(char);
                currentContent = '';
                lastOpType = opType;
            } else currentContent += char;
        // d(debug, currentContent);
        }
        if (!!currentContent) // d(debug, currentContent);
        currentNode.children.push($4ffd9cb584b9bf7e$var$parseContent(currentContent));
        root.collapse();
        root.segment();
        root.reduce();
        root.calculate();
        root.collapse();
        // d(debug, root);
        this.node = root;
    // d(debug, this.node);
    // d(debug, string + '\n' + root.debugChildren());
    // this.string = root.toString();
    }
    toString() {
        return this.node.toString();
    }
    toObjectOrNumber() {
        let attempt = this.node.isNumber();
        if (attempt !== null) return attempt;
        return this;
    }
    toStringOrNumber() {
        let attempt = this.node.isNumber();
        if (attempt !== null) return attempt;
        return this.node.toString();
    }
    max() {
        return this.node.max;
    }
    min() {
        return this.node.min;
    }
    average() {
        return this.node.med;
    }
}
function $4ffd9cb584b9bf7e$var$parseContent(content) {
    // boxes number values into objects, so that we can uniformly use instanceof later.
    if (content.startsWith('d')) return new (0, $1fd3f84224aa9cdc$export$2e2bcd8739ae039)('1' + content);
    else if (content.includes('d')) try {
        return new (0, $1fd3f84224aa9cdc$export$2e2bcd8739ae039)(content);
    } catch (e) {
        console.error(e);
        return new Number(0);
    }
    let float = parseFloat(content);
    if (content.includes('.') && !isNaN(float)) return new Number(float);
    let int = parseInt(content);
    if (!isNaN(int)) return new Number(int);
    return content;
}
var $4ffd9cb584b9bf7e$export$2e2bcd8739ae039 = $4ffd9cb584b9bf7e$var$DicePool;



function $940c495002b1b7d6$export$2e2bcd8739ae039(obj) {
    return JSON.parse(JSON.stringify(obj));
}



const $97bba09a8345118b$var$groups = [
    'primaries',
    'tacticals',
    'thresholds',
    'pools',
    'skills'
];
var $97bba09a8345118b$export$2e2bcd8739ae039 = $97bba09a8345118b$var$groups;


function $95c1a39a9b9c144f$var$recurseItems(entity, search, values, rootId) {
    if (entity.inactive === true && entity._id != rootId) return;
    (0, $97bba09a8345118b$export$2e2bcd8739ae039).forEach((group)=>{
        let found = entity[group].find((x)=>{
            let statname = x.name.toLowerCase();
            return search === statname;
        });
        if (!!found) // console.log(found)
        values.push(found);
    });
    // console.log(entity.name, entity.items);
    if (!entity.items) return;
    entity.items.forEach((item)=>$95c1a39a9b9c144f$var$recurseItems(item, search, values, rootId));
}
function $95c1a39a9b9c144f$var$returnType(obj) {
    if (obj instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)) return 'DicePool';
    else if (typeof obj === 'string') return 'string';
    else if (typeof obj === 'number') return 'number';
}
const $95c1a39a9b9c144f$var$operations = {
    'none': {
        strategy: 'none',
        sep: '',
        desc: 'pick an operation',
        calc: (doc, entity, node)=>{
            // console.log(none);
            return 0;
        }
    },
    'average': {
        strategy: 'array',
        sep: ',',
        desc: 'takes the average of all children',
        calc: (doc, entity, node)=>{
            if (!node.children || node.children.length === 0) return 0;
            let total = 0;
            let count = node.children.length;
            node.children.forEach((child)=>{
                let calc = (0, $b54c3f50a8c98d0e$export$2e2bcd8739ae039)(doc, entity, child);
                // console.log(calc)
                if (calc instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)) total += calc.average();
                else if (typeof calc === 'number') total += calc;
            });
            return total / count;
        }
    },
    'max': {
        strategy: 'array',
        sep: ',',
        desc: 'takes the maximum of all children',
        calc: (doc, entity, node)=>{
            // console.log('max', node)
            if (!node.children || node.children.length === 0) return 0;
            let max1 = Number.NEGATIVE_INFINITY;
            node.children.forEach((child)=>{
                // console.log(child);
                let calc = (0, $b54c3f50a8c98d0e$export$2e2bcd8739ae039)(doc, entity, child);
                if (calc instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039) && max1 instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)) {
                    if (calc.average() > max1.average()) max1 = calc;
                } else if (calc instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039) && typeof max1 === 'number') {
                    if (calc.average() > max1) max1 = calc;
                } else if (typeof calc === 'number' && max1 instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)) {
                    if (calc > max1.average()) max1 = calc;
                } else if (typeof calc === 'number' && typeof max1 === 'number') {
                    if (calc > max1) max1 = calc;
                }
            });
            return max1;
        }
    },
    'min': {
        strategy: 'array',
        sep: ',',
        desc: 'takes the minimum of all children',
        calc: (doc, entity, node)=>{
            if (!node.children || node.children.length === 0) return 0;
            let min = Number.POSITIVE_INFINITY;
            node.children.forEach((child)=>{
                let calc = (0, $b54c3f50a8c98d0e$export$2e2bcd8739ae039)(doc, entity, child);
                // console.log(calc)
                if (calc instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039) && min instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)) {
                    if (calc.average() < min.average()) min = calc;
                } else if (calc instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039) && typeof min === 'number') {
                    if (calc.average() < min) min = calc;
                } else if (typeof calc === 'number' && min instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)) {
                    if (calc < min.average()) min = calc;
                } else if (typeof calc === 'number' && typeof min === 'number') {
                    if (calc < min) min = calc;
                }
            });
            return min;
        }
    },
    'sum': {
        strategy: 'array',
        sep: ',',
        desc: 'adds up all children',
        calc: (doc, entity, node)=>{
            let calcedChildren = node.children.map((child)=>{
                let n = (0, $b54c3f50a8c98d0e$export$2e2bcd8739ae039)(doc, entity, child);
                // console.log('\tchild', child, n);
                return n;
            });
            // console.log('sum', calcedChildren);
            // console.log(calcedChildren.join('+'));
            let pool = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)(calcedChildren.join('+'));
            return pool.toObjectOrNumber();
        }
    },
    'add': {
        strategy: 'binary',
        sep: '+',
        desc: 'adds two numbers',
        calc: (doc, entity, node)=>{
            let calcedChildren = node.children.map((child)=>(0, $b54c3f50a8c98d0e$export$2e2bcd8739ae039)(doc, entity, child));
            // console.log(calcedChildren);
            let pool = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)(calcedChildren.join('+'));
            return pool.toObjectOrNumber();
        }
    },
    'subtract': {
        strategy: 'binary',
        sep: '-',
        desc: 'subtracts b from a',
        calc: (doc, entity, node)=>{
            let calcedChildren = node.children.map((child)=>(0, $b54c3f50a8c98d0e$export$2e2bcd8739ae039)(doc, entity, child));
            // console.log(calcedChildren);
            // console.log(calcedChildren.join('-'));
            let pool = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)(calcedChildren.join('-'));
            // console.log(pool);
            return pool.toObjectOrNumber();
        }
    },
    'multiply': {
        strategy: 'binary',
        sep: "\xd7",
        desc: 'multiplies two numbers',
        calc: (doc, entity, node)=>{
            let calcedChildren = node.children.map((child)=>(0, $b54c3f50a8c98d0e$export$2e2bcd8739ae039)(doc, entity, child));
            if (calcedChildren.includes(undefined)) return 0;
            // console.log(calcedChildren)
            let pool = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)(calcedChildren.join('*'));
            return pool.toObjectOrNumber();
        }
    },
    'divide': {
        strategy: 'binary',
        sep: "\xf7",
        desc: 'divides a by b',
        calc: (doc, entity, node)=>{
            let calcedChildren = node.children.map((child)=>(0, $b54c3f50a8c98d0e$export$2e2bcd8739ae039)(doc, entity, child));
            if (calcedChildren.includes(undefined)) return 0;
            let pool = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)(calcedChildren.join('/'));
            return pool.toObjectOrNumber();
        }
    },
    'integer': {
        strategy: 'number',
        sep: '',
        desc: 'a round number',
        calc: (doc, entity, node)=>{
            let int = parseInt(node.value);
            return int;
        }
    },
    'fraction': {
        strategy: 'number',
        sep: '',
        desc: 'a fraction of two round numbers',
        calc: (doc, entity, node)=>{
            let split = node.value.split('/');
            let num = split[0];
            let den = split[1];
            let frac = num / den;
            return frac;
        }
    },
    'decimal': {
        strategy: 'number',
        sep: '',
        desc: 'a number with a decimal point',
        calc: (doc, entity, node)=>{
            let float = parseFloat(node.value);
            return float;
        }
    },
    'best': {
        strategy: 'select',
        sep: '',
        desc: "picks the best stat value from anentity and all its items",
        calc: (doc, entity, node, rootId)=>{
            let values = [];
            if (!node.value) return 0;
            let search = node.value.toLowerCase();
            $95c1a39a9b9c144f$var$recurseItems(entity, search, values, rootId);
            // console.log(entity.name, search, values);
            if (values.length === 0) return 0;
            let max1 = Number.NEGATIVE_INFINITY;
            values.forEach((child)=>{
                if (!child) return;
                // console.log(child);
                let newValue = null;
                if (!!child.dicePool) newValue = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)(child.dicePool);
                else newValue = child;
                if (!newValue) return;
                // console.log(calc)
                if (newValue instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039) && max1 instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)) {
                    if (newValue.average() > max1.average()) max1 = newValue;
                } else if (newValue instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039) && typeof max1 === 'number') {
                    if (newValue.average() > max1) max1 = newValue;
                } else if ((typeof newValue === 'number' || newValue instanceof Number) && max1 instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)) {
                    if (newValue > max1.average()) max1 = newValue;
                } else if ((typeof newValue === 'number' || newValue instanceof Number) && (typeof max1 === 'number' || max1 instanceof Number)) {
                    if (newValue > max1) max1 = newValue;
                } else if (newValue.valueType === 'dieSize' && max1 instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)) {
                    let pool = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)('1' + newValue.dieSize);
                    if (pool.average() > max1.average()) max1 = pool;
                } else if (newValue.valueType === 'dieSize' && typeof max1 === 'number') {
                    let pool = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)('1' + newValue.dieSize);
                    if (pool.average() > max1) max1 = pool;
                } else if (newValue.valueType === 'number' && (typeof max1 === 'number' || max1 instanceof Number)) {
                    if (newValue.number > max1) max1 = newValue.number;
                } else if (newValue.valueType === 'formula' && (typeof max1 === 'number' || max1 instanceof Number)) // console.log('formula in best')
                {
                    if (newValue.calculated > max1) max1 = newValue.calculated;
                } else if (newValue.valueType === 'formula' && max1 instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)) {
                    // console.log('formula in best')
                    let pool = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)('1' + max1.dieSize);
                    if (newValue.calculated > pool.average()) max1 = newValue.calculated;
                } else if (newValue.valueType === 'formula' && max1.valueType === 'formula') // console.log('formula in best')
                {
                    if (newValue.calculated > newValue.calculated) max1 = newValue.calculated;
                } else console.error('best fell through', newValue, newValue instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039), max1, typeof max1);
            });
            if (max1 === Number.NEGATIVE_INFINITY) max1 = 0;
            return max1;
        }
    },
    'statref': {
        strategy: 'select',
        sep: '',
        desc: 'picks the value of the owner\'s stat',
        calc: (doc, entity, node)=>{
            // console.log('statref');
            if (!node || !node.value) return 0;
            let value = 0;
            /** the name of the target stat to be found on the entity and replaced in the formula */ let search = node.value.toLowerCase();
            let f = null;
            (0, $97bba09a8345118b$export$2e2bcd8739ae039).forEach((group)=>{
                /** stat instance on the entity, no formula text */ let found = entity[group].find((x)=>{
                    let statname = x.name.toLowerCase();
                    let matched = search === statname;
                    return matched;
                });
                /** stat prototype from the doc, with formula text */ let prototype = doc[group].find((x)=>{
                    let statname = x.name.toLowerCase();
                    let matched = search === statname;
                    return matched;
                });
                if (!!found) {
                    f = found;
                    // console.log('found', f);
                    switch(found.valueType){
                        case "number":
                            // console.log(entity.name, found.name, 'number');
                            value = found.number;
                            break;
                        case "formula":
                            // if the target stat is a formula, then we need to calculate that formula.
                            // that means that we have to get the formula text and parse it.
                            // console.log(entity.name, found.name, 'formula');
                            if (found.calculated === undefined) {
                                // console.log('node', SnapshotObject(node));
                                // console.log('found', SnapshotObject(found));
                                // console.log('prototype', SnapshotObject(prototype));
                                let formula = prototype.formula;
                                // found.calculated = 0;
                                let newNode = (0, $b54c3f50a8c98d0e$export$2e2bcd8739ae039)(doc, entity, formula);
                                // value = newNode;
                                found.calculated = newNode;
                            }
                            value = found.calculated;
                            break;
                        case "dieSize":
                            // console.log(entity.name, found.name, 'dieSize');
                            if (found.dieSize === 'none') value = 0;
                            else value = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)('1' + found.dieSize);
                            break;
                        case "dicePool":
                            // console.log(entity.name, found.name, 'dicePool');
                            value = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)(found.dicePool);
                            break;
                        default:
                            console.error(entity.name, found.name, 'statref FELL THROUGH');
                            break;
                    }
                }
            });
            f;
            return value;
        }
    },
    'flatten': {
        strategy: 'select',
        sep: '',
        desc: 'sums the same stat on the parent and all child items',
        calc: (doc, entity, node, rootId)=>{
            let values = [];
            if (!node.value) return 0;
            let search = node.value.toLowerCase();
            $95c1a39a9b9c144f$var$recurseItems(entity, search, values, rootId);
            // console.log(entity.name, search, values);
            if (values.length === 0) return 0;
            let sum = 0;
            let temps = [];
            values.forEach((child)=>{
                if (!child) return;
                // console.log(child);
                let calc = null;
                if (!!child.dicePool) calc = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)(child.dicePool);
                else calc = child;
                if (!calc) return;
                // console.log(calc)
                if (calc instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039) && sum instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)) temps.push(calc);
                else if (calc instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039) && typeof sum === 'number') temps.push(calc);
                else if ((typeof calc === 'number' || calc instanceof Number) && max instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)) temps.push(calc);
                else if ((typeof calc === 'number' || calc instanceof Number) && (typeof sum === 'number' || sum instanceof Number)) temps.push(calc);
                else if (calc.valueType === 'dieSize' && sum instanceof (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)) {
                    let pool = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)('1' + calc.dieSize);
                    temps.push(pool);
                } else if (calc.valueType === 'dieSize' && typeof sum === 'number') {
                    let pool = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)('1' + calc.dieSize);
                    temps.push(pool);
                } else if (calc.valueType === 'number' && (typeof sum === 'number' || sum instanceof Number)) temps.push(calc.number);
            });
            let megaPool = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)(temps.join('+'));
            sum = megaPool.toStringOrNumber();
            return sum;
        }
    }
};
var $95c1a39a9b9c144f$export$2e2bcd8739ae039 = $95c1a39a9b9c144f$var$operations;


/**
 * Calculates the value of a node
 * @param {Doc} doc the document to use when calculating 
 * @param {*} entity the owner of the stat
 * @param {*} node the node to calculate
 * @param {*} rootId the ID of the root entity, for checking top-level skipping
 * @returns A number or DicePool
 */ function $b54c3f50a8c98d0e$var$calcNode(doc, entity, node, rootId) {
    // console.log(node.op);
    let op = (0, $95c1a39a9b9c144f$export$2e2bcd8739ae039)[node.op];
    // console.log(node, op)
    let calced = op.calc(doc, entity, node, rootId);
    if (calced === undefined) return 0;
    return calced;
}
var $b54c3f50a8c98d0e$export$2e2bcd8739ae039 = $b54c3f50a8c98d0e$var$calcNode;



function $10aed7e064768419$var$Xp(stat) {
    let vt = stat.valueType;
    let exponent = stat?.prototype?.exponent || 2;
    if (vt === 'number' && !!stat.number) {
        let n = parseInt(stat.number);
        let sign = Math.sign(n);
        if (!n) stat.number = 0;
        // console.log(stat.offset);
        return Math.round((n + (stat.offset || 0)) ** exponent * sign);
    }
    if (vt === 'dieSize' && !!stat.dieSize) {
        // return 1000;
        // console.log(stat.dieSize)
        if (stat.dieSize === 'none') return 0;
        let size = stat.dieSize.replace('d', '');
        size = parseInt(size);
        let value = Math.round(size / 2) + 1;
        return Math.round((value + (stat.offset || 0)) ** exponent);
    }
    if (vt === 'dicePool' && !!stat.dicePool) {
        let pool = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)(stat.dicePool);
        let total = Math.round(pool.average());
        let sign = Math.sign(total);
        // console.log(stat.dicePool, total);
        return Math.round((total + (stat.offset || 0)) ** exponent * sign);
    }
    if (vt === 'formula' && !!stat.formula) return 0;
    return 0;
}
var $10aed7e064768419$export$2e2bcd8739ae039 = $10aed7e064768419$var$Xp;




function $e5c88db7348c38fc$var$textFormula(formula) {
    let operation = (0, $95c1a39a9b9c144f$export$2e2bcd8739ae039)[formula.op];
    let contents = '';
    if (operation.strategy === 'binary') {
        contents += $e5c88db7348c38fc$var$textFormula(formula.children[0]);
        contents += ' ';
        contents += operation.sep;
        contents += ' ';
        contents += $e5c88db7348c38fc$var$textFormula(formula.children[1]);
    } else if (operation.strategy === 'array') contents += formula.children.map((x)=>$e5c88db7348c38fc$var$textFormula(x)).join(', ');
    else if (operation.strategy === 'select') contents += formula.value;
    else if (operation.strategy === 'number') contents += formula.value;
    return formula.op + '(' + contents + ')';
}
var $e5c88db7348c38fc$export$2e2bcd8739ae039 = $e5c88db7348c38fc$var$textFormula;


function $ffe4323362835b8c$var$findEntityById(doc, id) {
    if (!doc.entities) return null;
    let ids = doc.entities.map((x)=>x._id);
    // console.log(id, ids, ids.includes(id), ids.indexOf(id))
    let found = doc.entities[ids.indexOf(id)];
    // let found = doc.entities.find(entity => entity._id === id); // This doesn't work in the Build API context for some god-forksaken reason.
    // console.log("FOUND", found, f2);
    return found;
}
var $ffe4323362835b8c$export$2e2bcd8739ae039 = $ffe4323362835b8c$var$findEntityById;


function $d57594e518c4ebb1$export$2e2bcd8739ae039(stat) {
    let value = 0;
    if (stat.valueType === 'number') value = stat.number;
    else if (stat.valueType === 'dieSize') value = stat.dieSize;
    else if (stat.valueType === 'dicePool') value = stat.dicePool;
    else if (stat.valueType === 'formula') value = stat.calculated;
    if (!value) value = 0;
    return value;
}


const $c7a4f9d18d4b834a$var$maxDepth = 5;
function $c7a4f9d18d4b834a$var$storeTextFormula(prototype, stat) {
    // console.log(prototype);
    if (!prototype.formula || !stat) return;
    stat.formulaText = (0, $e5c88db7348c38fc$export$2e2bcd8739ae039)(prototype.formula);
}
function $c7a4f9d18d4b834a$export$775d6fde1b43f510(doc, depth = 0) {
    // console.log("\nCALC ALL\n==============================================\n", doc.entities.length, doc.skills.length)
    // get skillgroups
    if (!!doc.skills && doc.skills.length > 0) {
        let skillGroups = doc.skills.map((skill)=>skill.skillGroup);
        let distinct = [
            ...new Set(skillGroups)
        ];
        doc.skillGroups = distinct;
    // console.log(distinct);
    }
    doc.entities.forEach((entity)=>{
        if (!entity.calculated) $c7a4f9d18d4b834a$var$calcEntity(entity, doc, depth);
    });
    doc.total = doc.entities.reduce((prev, curr)=>{
        if (curr.xp > 0 || curr.xp < 0) // console.log(curr.xp)
        return prev + curr.xp;
        else return prev;
    }, 0);
    // console.log(doc.entities[0].skills.length)
    return doc;
}
function $c7a4f9d18d4b834a$export$92767ff84747f1f4(oldDoc, newDoc, depth = 0) {
    let doc = oldDoc;
    // console.log(doc)
    let entityId = newDoc.activeEntity.toString();
    let entity = newDoc.entities.find((x)=>x._id.toString() === entityId);
    console.log('singleEntity', entity);
    // find the index of the active entity
    let targetIndex = doc.entities.findIndex((x)=>x._id.toString() === entityId);
    console.log('index', targetIndex);
    // replace that index with the new entity
    doc.entities[targetIndex] = entity;
    // reset the calculated field on each entity
    doc.entities.forEach((x)=>x.calculated = false);
    // perform update on active entity
    $c7a4f9d18d4b834a$var$calcEntity(entity, doc, depth, true);
    doc.dirty = true;
    // return document
    return doc;
}
function $c7a4f9d18d4b834a$var$calcEntity(entity, doc, depth, recurseUpwards = false) {
    // console.log(entity.name, entity.skills.length)
    // get limits and set inactive state
    // console.log('ids', entity.limitIds.length, 'legacy', entity.limitations.length)
    let limitlog = '';
    // clear doc limits from entity
    if (entity.limitations && entity.limitations.length > 0) entity.limitations.filter((x)=>{
        let name = x.name;
        let id = x._id;
        doc.limitations.forEach((y)=>{
            if (y.name === name || y._id === id) return false;
        });
        return true;
    });
    // mark legacy limits for UI
    if (entity.limitations && entity.limitations.length > 0) doc.needsLimitReconciliation = true;
    // populate doc limits to entity
    if (entity.limitIds && entity.limitIds.length > 0) {
        limitlog += ', limitIds:' + entity.limitIds.length;
        entity.limitIds.forEach((x)=>{
            // console.log(entity.name, 'limit search', x, doc.limitations)
            let limit = doc.limitations.find((y)=>y._id.toString() === x.toString());
            if (!limit) return;
            limit.document = true;
            entity.limitations.push(limit);
        });
    }
    // cache inactive status from limits
    entity.limitations.forEach((x)=>{
        if (x.inactive) entity.inactive = true;
    });
    // get items
    if (!!entity.equipment) {
        // console.log(entity.equipment)
        entity.items = entity.equipment.map((x)=>(0, $ffe4323362835b8c$export$2e2bcd8739ae039)(doc, x));
        entity.items = entity.items.filter((x)=>!!x);
        entity.items.forEach((item)=>{
            if (depth < $c7a4f9d18d4b834a$var$maxDepth && !item.calculated) $c7a4f9d18d4b834a$var$calcEntity(item, doc, depth + 1);
        });
    // entity.items.forEach(item => console.log(item._id));
    // entity.items.forEach(x => xp += x.xp);
    }
    if (recurseUpwards) // this allows us to recalculate entities that OWN this entity
    // even when recalculating a single item
    doc.entities.forEach((e)=>{
        if (e.equipment.includes(entity._id.toString())) {
            if (depth < $c7a4f9d18d4b834a$var$maxDepth && !e.calculated) $c7a4f9d18d4b834a$var$calcEntity(e, doc, depth + 1, true);
        }
    });
    // do generated stats
    (0, $97bba09a8345118b$export$2e2bcd8739ae039).forEach((groupName)=>{
        let group = entity[groupName];
        if (!!group) group.forEach((stat)=>{
            let group = doc[groupName];
            // console.log(groupName, stat.name, stat);
            // console.log('\n\n==============', stat.name, '====================================');
            let prototype = group.find((x)=>x.name === stat.name);
            if (!!prototype) {
                stat.prototype = prototype;
                stat.offset = prototype.offset;
            }
            if (!!prototype && !!prototype.formula) {
                // console.log(prototype.name, prototype.formulaText);
                let formula = prototype.formula;
                $c7a4f9d18d4b834a$var$storeTextFormula(prototype, stat);
                // console.log(formula);
                // console.log(entity.name, prototype.name)
                let node = (0, $b54c3f50a8c98d0e$export$2e2bcd8739ae039)(doc, entity, formula, entity._id);
                if (!!node.error) stat.error = node.error;
                // if(node.toString().includes('.')) {
                //     console.log(node.toString(), node);
                // }
                // node is a number
                if (typeof node === 'number' || node instanceof Number) node = Math.round(node);
                else if (!!node?.node?.children && node.node.children.length === 1 && (node.node.children[0] instanceof Number || typeof node.node.children[0] === 'number')) // console.log('round')
                node = Math.round(node.node);
                else console.log("node doesn't have a direct number");
                // console.log('calculated', stat.name);
                stat.calculated = node;
            }
        });
    });
    // do xp
    let xpGroups = {
        aspects: 0,
        flaws: 0,
        primaries: 0,
        tacticals: 0,
        thresholds: 0,
        pools: 0,
        skills: 0,
        items: 0
    };
    let xp = 0;
    if (!!entity.aspects) {
        xp += 10 * entity.aspects.length;
        xpGroups['aspects'] += 10 * entity.aspects.length;
    }
    if (!!entity.flaws) {
        xp -= 10 * entity.flaws.length;
        xpGroups['flaws'] -= 10 * entity.flaws.length;
    }
    (0, $97bba09a8345118b$export$2e2bcd8739ae039).forEach((group)=>{
        if (!!entity[group]) entity[group].forEach((stat)=>{
            let value = (0, $10aed7e064768419$export$2e2bcd8739ae039)(stat);
            if (group === 'primaries') value *= 2;
            xp += value;
            stat.xp = value;
            xpGroups[group] += value;
        });
    });
    if (!!entity.items) // entity.items = entity.equipment.map(x =>
    //     findEntityById(doc, x));
    // entity.items = entity.items.filter(x => !!x);
    entity.items.forEach((x)=>{
        xp += x.xp;
        xpGroups['items'] += x.xp;
    });
    if (!!entity.limitations) {
        entity.xpMultiplier = 1;
        entity.limitations.forEach((x)=>{
            let split = x.multiplier.split('/');
            let numerator = split[0];
            let denominator = split.length > 1 ? split[1] : 1;
            let mult = numerator / denominator;
            xp *= mult;
            entity.xpMultiplier *= mult;
        });
    }
    xp = Math.round(xp);
    entity.xp = xp;
    // total += xp;
    entity.xpGroups = xpGroups;
    // tally up primary values
    if (!!entity.primaries && entity.primaries.length > 0 && !!entity.skills && entity.skills.length > 0) {
        let dict = {};
        entity.primaries.forEach((x)=>{
            x.skillPoints = 0;
            dict[x.name] = x;
        });
        entity.skills.forEach((skill)=>{
            let prototype = doc.skills.find((x)=>x.name === skill.name);
            if (!prototype) return;
            let primaryName = prototype.skillStat;
            let primary = dict[primaryName];
            // console.log(primaryName, dict, primary);
            if (!primary) return;
            primary.skillPoints += skill.xp > 0 ? skill.xp : 1;
            skill.totalPool = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)((0, $d57594e518c4ebb1$export$2e2bcd8739ae039)(skill) + '+' + (0, $d57594e518c4ebb1$export$2e2bcd8739ae039)(primary));
            skill.totalBonus = skill.totalPool.toString();
        });
    }
    entity.calculated = true;
}
var $c7a4f9d18d4b834a$export$2e2bcd8739ae039 = {
    calcAll: $c7a4f9d18d4b834a$export$775d6fde1b43f510,
    calcSingle: $c7a4f9d18d4b834a$export$92767ff84747f1f4
};




function $2f8939dbcf7f4160$var$prototypeFormulas(doc) {
    (0, $97bba09a8345118b$export$2e2bcd8739ae039).forEach((group)=>{
        doc[group].forEach((stat)=>{
            if (stat.valueType === 'formula' && !!stat.formula) stat.formulaText = (0, $e5c88db7348c38fc$export$2e2bcd8739ae039)(stat.formula);
        });
    });
    return doc;
}
var $2f8939dbcf7f4160$export$2e2bcd8739ae039 = $2f8939dbcf7f4160$var$prototypeFormulas;


function $462a5492b6d64346$var$collectTags(doc) {
    if (!doc.hasOwnProperty('entityTags')) doc.entityTags = [];
    if (!!doc.entities && doc.entities.length > 0) doc.entities.forEach((entity)=>{
        if (!!entity.tags && entity.tags.length > 0) entity.tags.forEach((tag)=>{
            if (!doc.entityTags.includes(tag)) doc.entityTags.push(tag);
        });
    });
    doc.entityTags.sort();
}
var $462a5492b6d64346$export$2e2bcd8739ae039 = $462a5492b6d64346$var$collectTags;




function $ec9ec355184128d6$var$setEditable(doc, editable) {
    // console.log(editable);
    let groups = [
        'primaries',
        'tacticals',
        'thresholds',
        'pools',
        'skills',
        'limitations',
        'entities'
    ];
    $ec9ec355184128d6$var$setObjectEditable(doc, editable);
    groups.forEach((group)=>{
        // console.log(group, doc[group]);
        if (!doc[group]) return;
        doc[group].forEach((element)=>{
            // console.log(element.name);
            $ec9ec355184128d6$var$setObjectEditable(element, editable);
        });
    });
}
function $ec9ec355184128d6$var$setObjectEditable(object, editable) {
    // console.log(object);
    if (!!object && !object.external && editable === true) object.editable = true;
}
var $ec9ec355184128d6$export$2e2bcd8739ae039 = $ec9ec355184128d6$var$setEditable;


const $c3695f066689408a$var$maxDepth = 50;
function $c3695f066689408a$var$mergeParents(original, doc, depth = 0) {
    // console.log("merge parents", "parent doc type:", typeof(doc), "parent doc:", doc)
    if (typeof doc === "string") console.error("parent doc passed to mergeParents as a string, not an object");
    // console.log(original, doc);
    if (!original || !doc) {
        console.warn("missing original doc or parent doc");
        return;
    }
    // console.log('depth', depth);
    if (depth > $c3695f066689408a$var$maxDepth) return console.error('max depth reached!');
    // apply elements
    let groups = [
        'primaries',
        'tacticals',
        'thresholds',
        'pools',
        'skills',
        'limitations',
        'entities',
        'tracks'
    ];
    groups.forEach((gname)=>{
        let sourceGroup = doc[gname];
        let targetGroup = original[gname];
        // console.log(gname, sourceGroup.length)
        if (!!sourceGroup && !!targetGroup) sourceGroup.forEach((sourceElement)=>{
            let foundElement = null;
            targetGroup.forEach((targetElement)=>{
                if (targetElement.name === sourceElement.name || targetElement._id === sourceElement._id) foundElement = targetElement;
            });
            if (!!foundElement) return;
            sourceElement.external = true;
            sourceElement.externalSource = doc;
            targetGroup.push(sourceElement);
        });
    });
    // recurse on children
    if (!!doc.dependencies) doc.dependencies.forEach((dep)=>{
        $c3695f066689408a$var$mergeParents(original, dep, depth + 1);
    });
}
var $c3695f066689408a$export$2e2bcd8739ae039 = $c3695f066689408a$var$mergeParents;





function $b1d87954835d0579$export$2e2bcd8739ae039(stat, entity) {
    if (!stat) // console.log('missing stat')
    return '';
    if (!entity) {
        console.log('missing entity');
        return '';
    }
    let prototype = stat.prototype;
    let mod = entity.xpMultiplier;
    let current = (0, $10aed7e064768419$export$2e2bcd8739ae039)(stat) * mod;
    if (!prototype) return '';
    let diceChain = {
        '0': 1,
        '1': 2,
        '2': 4,
        '4': 6,
        '6': 8,
        '8': 10,
        '10': 12,
        '12': 20,
        '20': 100,
        '100': 100
    };
    let vt = stat.valueType;
    let exponent = stat.prototype.exponent || 2;
    if (vt === 'number') {
        let n = parseInt(stat.number) + 1;
        let sign = Math.sign(n);
        if (!n) stat.number = 0;
        return Math.round((n + (stat.offset || 0)) ** exponent * sign) * mod - current;
    }
    if (vt === 'dieSize' && !!stat.dieSize) {
        if (stat.dieSize === 'none') return 0;
        let size = stat.dieSize.replace('d', '');
        size = diceChain[size];
        let value = Math.round(size / 2) + 1;
        return Math.round((value + (stat.offset || 0)) ** exponent) * mod - current;
    }
    if (vt === 'dicePool' && !!stat.dicePool) {
        let pool = new (0, $4ffd9cb584b9bf7e$export$2e2bcd8739ae039)(stat.dicePool);
        let total = Math.round(pool.average());
        let sign = Math.sign(total);
        // console.log(stat.dicePool, total);
        return Math.round((total + (stat.offset || 0) + 1) ** exponent * sign) * mod - current;
    }
    if (vt === 'formula' && !!stat.formula) return '';
    return '';
}


// TODO: Fix `calcSingle` for optimization.
// When overrideSingleEntity is false, new entities do not immediately trigger a save and refresh.
function $cd6dad6538e950c7$var$calculateAllXp(doc, editable = false, oldDoc = null, overrideSingleEntity = true) {
    // console.log('\n\n\n<<<<<<<<<<<<<<<\ncalculateAllXp', doc.entities.length)
    if (!doc) {
        console.error("NO DOC!");
        return null;
    }
    // this system for overriding only a single entity is not finished or is broken.
    // it needs to allow for initial loads of the save file.
    // if(overrideSingleEntity && doc.activeEntity && !!oldDoc && oldDoc != {}) {
    //     console.log('calc single', doc.entities.length)
    //     // console.log("Update Single Entity");
    //     var newDoc = doc;
    //     doc = calcSingle(oldDoc, newDoc);
    //     collectTags(doc);
    //     setEditable(doc, editable);
    // }
    // else {
    //     console.log('calc all but merge firs', doc.entities.length)
    //     mergeParents(doc, doc);
    //     // console.log("update entire doc");
    //     doc = prototypeFormulas(doc);
    //     doc = calcAll(doc);
    //     // console.log(doc.total);
    //     collectTags(doc);
    //     setEditable(doc, editable);
    // }
    // console.log('calc all but merge firs', doc.entities.length)
    // console.log('doc.dependencies', doc.dependencies)
    (0, $c3695f066689408a$export$2e2bcd8739ae039)(doc, doc);
    // console.log("update entire doc");
    doc = (0, $2f8939dbcf7f4160$export$2e2bcd8739ae039)(doc);
    doc = (0, $c7a4f9d18d4b834a$export$775d6fde1b43f510)(doc);
    // console.log(doc.total);
    (0, $462a5492b6d64346$export$2e2bcd8739ae039)(doc);
    (0, $ec9ec355184128d6$export$2e2bcd8739ae039)(doc, editable);
    // console.log('calculateAllXp', doc.entities.length)
    return doc;
}
const $cd6dad6538e950c7$export$7a64fa6786ea9a09 = {
    calculateAllXp: $cd6dad6538e950c7$var$calculateAllXp,
    operations: $95c1a39a9b9c144f$export$2e2bcd8739ae039,
    groups: $97bba09a8345118b$export$2e2bcd8739ae039,
    DicePool: $4ffd9cb584b9bf7e$export$2e2bcd8739ae039,
    Tnl: $b1d87954835d0579$export$2e2bcd8739ae039
};
var // ESM
$cd6dad6538e950c7$export$2e2bcd8739ae039 = $cd6dad6538e950c7$export$7a64fa6786ea9a09;






var $bh6RR = parcelRequire("bh6RR");


class $90c4322eecedc6d4$var$UserSelector extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            users: []
        };
    }
    componentDidMount = ()=>{
        // console.log('this.componentDidMount')
        this.getUsers();
    };
    getUsers = ()=>{
        let exclude = [];
        // console.log(this.props.doc?.editors);
        exclude = exclude.concat(this.props.campaign?.allPlayers);
        exclude.push(this.props.campaign?.gm);
        exclude = exclude.concat(this.props.doc?.editors);
        exclude.push(this.props.doc?.owner);
        exclude = exclude.filter((x)=>x !== undefined);
        // console.log(exclude);
        fetch('/api/listUsers', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                allusers: true,
                includeemail: true,
                exclude: exclude
            })
        }).then((res)=>res.json()).then((info)=>{
            // console.log(info[0].email);
            // console.log(info);
            if (!info) return;
            this.setState({
                users: info
            });
        });
    };
    render() {
        // this.getUsers();
        // console.log('render')
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09f16485618a5dc7$export$2e2bcd8739ae039), {
            state: this.props.state,
            title: "Select Doc to add",
            target: "addUserModal",
            closeModal: this.props.closeModal,
            closeButtonText: "close",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                    children: "Select User"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                    children: [
                        "Filter:",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                            name: "filter"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ol", {
                    children: this.state.users?.map((user)=>{
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    onClick: ()=>{
                                        this.props.addUser(user);
                                        this.getUsers();
                                    },
                                    children: user.username
                                }),
                                "\xa0 (",
                                user.email,
                                ")"
                            ]
                        }, user._id);
                    })
                })
            ]
        });
    }
}
var $90c4322eecedc6d4$export$2e2bcd8739ae039 = $90c4322eecedc6d4$var$UserSelector;




var $bh6RR = parcelRequire("bh6RR");

class $856fae2ccc0e87c3$var$EditContentName extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            name: props.name
        };
    }
    handleChange = (e)=>{
        let newName = e.target.value;
        this.setState({
            name: newName
        });
    };
    submitNameChange = (e)=>{
        e.preventDefault();
        let name = this.state.name;
        let id = this.props.id;
        let original = this.props.name;
        let target = this.props.target;
        // console.log(name, id);
        if (name === original || !name) return;
        this.props.renameCallback(id, name, target);
    };
    render() {
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
            onSubmit: this.submitNameChange,
            style: {
                display: 'inline'
            },
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                    value: this.state.name,
                    placeholder: this.props.name,
                    onBlur: this.submitNameChange,
                    onChange: this.handleChange,
                    style: {
                        display: 'inline'
                    }
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                    type: "submit",
                    style: {
                        display: 'none'
                    }
                })
            ]
        });
    }
}
var $856fae2ccc0e87c3$export$2e2bcd8739ae039 = $856fae2ccc0e87c3$var$EditContentName;




var $bh6RR = parcelRequire("bh6RR");



class $b1842d6e2b218b23$var$DocSelector extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            docs: []
        };
    }
    componentDidMount = ()=>{
        this.getDocs();
    };
    getDocs = ()=>{
        let exclude = [];
        exclude.push(this.props.doc?._id);
        fetch('/api/listDocs', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                alldocs: true,
                exclude: exclude
            })
        }).then((res)=>res.json()).then((info)=>{
            // console.log(info[0].email);
            // console.log(info);
            if (!info) return;
            this.setState({
                docs: info
            });
        });
    };
    render() {
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $09f16485618a5dc7$export$2e2bcd8739ae039), {
            state: this.props.state,
            title: "Select Doc to add",
            target: "addDocModal",
            closeModal: this.props.closeModal,
            closeButtonText: "close",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ol", {
                children: this.state.docs?.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)('name', false, true)).map((doc)=>{
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            onClick: ()=>this.props.addParentDoc(doc),
                            children: doc.name
                        })
                    }, doc._id);
                })
            })
        });
    }
}
var $b1842d6e2b218b23$export$2e2bcd8739ae039 = $b1842d6e2b218b23$var$DocSelector;





var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");

function $8f8e47597d7573fb$export$2e2bcd8739ae039(props) {
    let enc = props.enc;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "graph",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "good",
                style: {
                    width: enc.percentages?.pcs + '%'
                },
                children: "PCs"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "evil",
                style: {
                    width: enc.percentages?.enemy + '%'
                },
                children: "Enemy"
            }),
            !!enc.percentages.diff && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "line trivial",
                        style: {
                            width: enc.percentages.trivial + '%'
                        },
                        children: "Trivial"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "line easy",
                        style: {
                            width: enc.percentages.easy + '%'
                        },
                        children: "Easy"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "line normal",
                        style: {
                            width: enc.percentages.normal + '%'
                        },
                        children: "Normal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "line danger",
                        style: {
                            width: enc.percentages.danger + '%'
                        },
                        children: "Danger"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "line lethal",
                        style: {
                            width: enc.percentages.lethal + '%'
                        },
                        children: "Lethal"
                    })
                ]
            })
        ]
    });
}





function $3d420ddc148c09dc$export$2e2bcd8739ae039(props) {
    let enc = props.enc;
    let enemy = props.enemy;
    let setEnemyEntity = props.setEnemyEntity;
    let filter = props.campaign.enemyfilter;
    let sortOrder = props.campaign.enemysortorder;
    let includeParent = props.campaign.includeparententities;
    let list = enemy.doc?.entities.filter((x)=>{
        let tags = filter.split(',').map((x)=>x.trim());
        let match = false;
        for(let i = 0; i < tags.length; i++){
            let tag = tags[i];
            if (x.tags.includes(tag)) {
                match = true;
                break;
            }
        }
        if (includeParent) return match;
        else return match && !x.external == true;
    });
    switch(sortOrder?.toLowerCase() || sortOrder?.toLowerCase() || ''){
        case 'xp':
        case 'xp ascending':
            list = list?.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)('xp', false, true));
            break;
        case 'xp descending':
            list = list?.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)('xp', true, true));
            break;
        case 'name, reversed':
            list = list?.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)('name', true, true));
            break;
        default:
        case 'name':
            list = list?.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)('name', false, true));
            break;
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
        "data-encounterid": enc._id,
        "data-enemyid": enemy._id,
        value: enemy.entityId || "",
        onChange: setEnemyEntity,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                value: "",
                children: "none"
            }),
            list?.map((entity)=>{
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("option", {
                    value: entity._id,
                    children: [
                        entity.name,
                        " (",
                        entity.xp?.toLocaleString(),
                        ")"
                    ]
                }, entity._id);
            })
        ]
    });
}


function $68928360f2cc7dd3$export$2e2bcd8739ae039(props) {
    let enemy = props.enemy;
    let enc = props.enc;
    let xp = enemy.entity?.xp || 0;
    let quantity = enemy.quantity || 0;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                    "data-encounterid": enc._id,
                    "data-enemyid": enemy._id,
                    value: enemy.docId || "",
                    onChange: props.setEnemyDoc,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                            value: "",
                            children: "none"
                        }),
                        props.campaign.docs.map((doc)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                value: doc._id,
                                children: doc.name
                            }, doc._id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3d420ddc148c09dc$export$2e2bcd8739ae039), {
                    campaign: props.campaign,
                    enc: props.enc,
                    enemy: props.enemy,
                    setEnemyEntity: props.setEnemyEntity
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                    type: "number",
                    step: 1,
                    min: 0,
                    value: quantity,
                    "data-encounterid": enc._id,
                    "data-enemyid": enemy._id,
                    onChange: props.setEnemyQuantity
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                children: xp?.toLocaleString()
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                children: enemy?.xp.toLocaleString()
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    className: "delete",
                    "data-encounterid": enc._id,
                    "data-enemyid": enemy._id,
                    onClick: props.deleteEnemy,
                    children: "x"
                })
            })
        ]
    });
}



function $06b9cd0ec60852b2$export$2e2bcd8739ae039(props) {
    let pc = props.pc;
    let enc = props.enc;
    // let exists = !!pc && (!!pc.name || !!pc.xp);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                    placeholder: "PC Name",
                    defaultValue: pc.name,
                    "data-encounterid": enc._id,
                    "data-pcid": pc._id,
                    onBlur: props.setPcName
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                    type: "number",
                    step: 1,
                    placeholder: "XP value",
                    defaultValue: pc.xp,
                    "data-encounterid": enc._id,
                    "data-pcid": pc._id,
                    onBlur: props.setPcXp
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                    type: "number",
                    step: 1,
                    placeholder: "Quantity",
                    defaultValue: pc.quantity,
                    "data-encounterid": enc._id,
                    "data-pcid": pc._id,
                    onChange: props.setPcQty
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    className: "delete",
                    "data-encounterid": enc._id,
                    "data-pcid": pc._id,
                    onClick: props.deletePc,
                    children: "x"
                })
            })
        ]
    });
}





function $b10f60c1c4fdc48b$export$b9d539805566f3dd(entity, stat, encounterid, index) {
    if (!entity || !stat) return '';
    // console.log(entity._id, stat._id, encounter, index)
    let b = $b10f60c1c4fdc48b$export$2fc59efc98eee175(entity, stat, encounterid, index);
    // console.log('values', b)
    let max = 0;
    if (stat.valueType === 'formula') max = stat.calculated;
    if (stat.valueType === 'number') max = stat.number;
    let percent = max > 0 ? 100 - Math.round(b / max * 100) + '%' : '';
    b = b * -1;
    if (b > 0) b = '+' + b;
    return b + ', ' + percent;
}
function $b10f60c1c4fdc48b$export$1fdbb522b1c3401f(entity, stat, encounterid, index) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
        className: "poolStatus",
        "data-statid": stat._id,
        id: $b10f60c1c4fdc48b$export$a47fb462a08de82f(entity, stat, encounterid, index) + 'poolStatus',
        children: $b10f60c1c4fdc48b$export$b9d539805566f3dd(entity, stat, encounterid, index)
    });
}
function $b10f60c1c4fdc48b$export$a47fb462a08de82f(entity, stat, encounterid, index) {
    // console.log (index)
    // console.log (entity._id, stat._id, encounter, index)
    let array = [
        encounterid,
        index,
        entity._id,
        stat._id || stat
    ];
    let key = array.join('_');
    return key;
}
function $b10f60c1c4fdc48b$export$2fc59efc98eee175(entity, stat, encounterid, index) {
    // console.log (entity, stat, encounterid, index)
    if (!entity || !stat) return 0;
    let key = $b10f60c1c4fdc48b$export$a47fb462a08de82f(entity, stat, encounterid, index);
    let val = parseInt(window.localStorage.getItem(key));
    // console.log(key, val, window.localStorage.getItem(key));
    if (isNaN(val) || val === "NaN") return 0;
    return val;
}
function $b10f60c1c4fdc48b$export$cfd00fcacb54a153(entity, stat, change, encounterid, index) {
    let b = $b10f60c1c4fdc48b$export$2fc59efc98eee175(entity, stat, encounterid, index);
    // console.log(b, change, b + change);
    b = b + change;
    let key = $b10f60c1c4fdc48b$export$a47fb462a08de82f(entity, stat, encounterid, index);
    window.localStorage.setItem(key, b);
    let status = document.getElementById(key + 'poolStatus');
    // console.log(status);
    if (status) status.textContent = $b10f60c1c4fdc48b$export$b9d539805566f3dd(entity, stat, encounterid, index);
}
function $b10f60c1c4fdc48b$export$95cd95bd83442351(entity, stat, newValue, encounterid, index) {
    let b = $b10f60c1c4fdc48b$export$2fc59efc98eee175(entity, stat, encounterid, index);
    // console.log(b, newValue)
    b = newValue;
    let key = $b10f60c1c4fdc48b$export$a47fb462a08de82f(entity, stat, encounterid, index);
    window.localStorage.setItem(key, b);
    let status = document.getElementById(key + 'poolStatus');
    // console.log(status)
    status.textContent = $b10f60c1c4fdc48b$export$b9d539805566f3dd(entity, stat, encounterid, index);
}
function $b10f60c1c4fdc48b$export$91fe4b954385285c(entity, toggleName, encounterid, index, value) {
    let key = $b10f60c1c4fdc48b$export$a47fb462a08de82f(entity, toggleName, encounterid, index);
    window.localStorage.setItem(key, !!value);
}
function $b10f60c1c4fdc48b$export$b39915331bcce57f(entity, toggleName, encounterid, index) {
    let value = $b10f60c1c4fdc48b$export$eff8a958b14c081f(entity, toggleName, encounterid, index);
    // console.log("value before set", value);
    value = !value;
    // console.log("value after set", value);
    $b10f60c1c4fdc48b$export$91fe4b954385285c(entity, toggleName, encounterid, index, value);
}
function $b10f60c1c4fdc48b$export$eff8a958b14c081f(entity, toggleName, encounterid, index) {
    let key = $b10f60c1c4fdc48b$export$a47fb462a08de82f(entity, toggleName, encounterid, index);
    let value = window.localStorage.getItem(key) === "true" ? true : false;
    // console.log("get toggle value", key, value);
    return value;
}
function $b10f60c1c4fdc48b$export$cdfbca7c3259dfd9(entity, toggleName, encounterid, index) {
    let key = $b10f60c1c4fdc48b$export$a47fb462a08de82f(entity, toggleName, encounterid, index);
    window.localStorage.removeItem(key);
}





var $bh6RR = parcelRequire("bh6RR");
function $1249f3af6d8d1d25$var$attemptClearCheckboxes(entity, stat, encounterid, index) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
        // key={99999}
        onClick: ()=>{
            if (window.confirm('Are you sure you want to clear this pool?')) $1249f3af6d8d1d25$export$918b4cb17faa2b09(entity, stat, encounterid, index);
        },
        className: "delete clearboxes",
        children: "clear"
    });
}
function $1249f3af6d8d1d25$export$918b4cb17faa2b09(entity, stat, encounterid, index) {
    let sid = stat._id;
    let eid = entity._id;
    for(let key in localStorage){
        // console.log(key, eid, sid);
        let targetKey = (0, $b10f60c1c4fdc48b$export$a47fb462a08de82f)(entity, stat, encounterid, index);
        if (key === targetKey) localStorage.removeItem(key);
    }
    let boxes = document.getElementsByClassName('stressbox');
    for(let i = 0; i < boxes.length; i++){
        let box = boxes.item(i);
        if (box.dataset.statid === sid) box.checked = false;
    }
    let spinners = document.getElementsByClassName('stressspinner');
    for(let i = 0; i < spinners.length; i++){
        let spinner = spinners.item(i);
        if (spinner.dataset.statid === sid) {
            let boxes = 0;
            if (stat.valueType === 'number') boxes = stat.number;
            if (stat.valueType === 'formula') {
                if (typeof stat.calculated === 'number') boxes = stat.calculated;
                let num = parseInt(stat.calculated);
                if (!isNaN(num)) boxes = num;
            }
            spinner.value = boxes;
        }
    }
    let lskey = (0, $b10f60c1c4fdc48b$export$a47fb462a08de82f)(entity, stat, encounterid, index);
    let status = document.getElementById(lskey + 'poolStatus');
    // console.log(lskey, status)
    status.textContent = (0, $b10f60c1c4fdc48b$export$b9d539805566f3dd)(entity, stat);
    let changespinner = document.getElementById(lskey + 'changespinner');
    if (changespinner) changespinner.value = 0;
}
function $1249f3af6d8d1d25$var$applyDamage(event, entity, stat, lskey, encounterid, index) {
    let mod = parseInt(event.target.dataset.mod);
    let changespinner = document.getElementById(lskey + 'changespinner');
    let damage = changespinner.value * mod;
    let currentspinner = document.getElementById(lskey + 'currentspinner');
    let remaining = currentspinner.value - damage;
    currentspinner.value = remaining;
    // console.log(lskey, damage);
    (0, $b10f60c1c4fdc48b$export$cfd00fcacb54a153)(entity, stat, damage, encounterid, index);
    document.getElementById(lskey + 'changespinner').value = 0;
}
function $1249f3af6d8d1d25$export$2e2bcd8739ae039(entity, stat, encounterid, index) {
    if (!stat) return '';
    // console.log(stat)
    let boxes = 0;
    if (stat.valueType === 'number') boxes = stat.number;
    if (stat.valueType === 'formula') {
        if (typeof stat.calculated === 'number') boxes = stat.calculated;
        let num = parseInt(stat.calculated);
        if (!isNaN(num)) boxes = num;
    }
    if (boxes < 1) return '';
    if (boxes < 10) {
        let damage = (0, $b10f60c1c4fdc48b$export$2fc59efc98eee175)(entity, stat, encounterid, index);
        let output = [];
        for(let i = 0; i < boxes; i++){
            if (i % 5 === 0 && i != 0) output.push(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}, 'break' + i));
            output.push(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                type: "checkbox",
                className: "stressbox",
                "data-statid": stat._id,
                onChange: (e)=>{
                    damage = e.target.checked ? 1 : -1;
                    // console.log(damage)
                    (0, $b10f60c1c4fdc48b$export$cfd00fcacb54a153)(entity, stat, damage, encounterid, index);
                },
                defaultChecked: i < damage
            }, i));
        }
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                output,
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                (0, $b10f60c1c4fdc48b$export$1fdbb522b1c3401f)(entity, stat, encounterid, index),
                $1249f3af6d8d1d25$var$attemptClearCheckboxes(entity, stat, encounterid, index)
            ]
        });
    } else {
        let damage = (0, $b10f60c1c4fdc48b$export$2fc59efc98eee175)(entity, stat, encounterid, index);
        let lskey = (0, $b10f60c1c4fdc48b$export$a47fb462a08de82f)(entity, stat, encounterid, index);
        let output = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                    className: "current",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            children: "Current:"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                            type: "number",
                            "data-statid": stat._id,
                            id: lskey + 'currentspinner',
                            className: "stressspinner",
                            onChange: (e)=>{
                                // console.log(e)
                                let newValue = e.target.value;
                                let change = boxes - newValue;
                                // console.log(newValue, change);
                                (0, $b10f60c1c4fdc48b$export$95cd95bd83442351)(entity, stat, change, encounterid, index);
                            },
                            defaultValue: boxes - damage
                        }, lskey),
                        (0, $b10f60c1c4fdc48b$export$1fdbb522b1c3401f)(entity, stat, encounterid, index)
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                    className: "modify",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            children: "Modify:"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                            type: "number",
                            id: lskey + 'changespinner',
                            "data-statid": stat._id,
                            className: "changespinner",
                            onChange: (e)=>{
                            // console.log(e.target.value)
                            // deltaCheckboxValues(entity, stat, boxes - e)
                            },
                            defaultValue: 0,
                            min: 0,
                            step: 1
                        }, lskey),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            className: "heal",
                            "data-mod": -1,
                            onClick: (e)=>$1249f3af6d8d1d25$var$applyDamage(e, entity, stat, lskey, encounterid, index),
                            children: "heal"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            className: "harm",
                            "data-mod": 1,
                            onClick: (e)=>$1249f3af6d8d1d25$var$applyDamage(e, entity, stat, lskey, encounterid, index),
                            children: "harm"
                        })
                    ]
                }),
                $1249f3af6d8d1d25$var$attemptClearCheckboxes(entity, stat, encounterid, index)
            ]
        });
        return output;
    }
}



function $ff3467bccb224523$var$combatantPool(entity, com, props, type, index) {
    // console.log(index)
    return entity.pools.map((pool)=>{
        let encounter = props.enc;
        let boxes = pool.calculated;
        let filled = (0, $b10f60c1c4fdc48b$export$2fc59efc98eee175)(entity, pool, props.enc._id, index);
        // console.log(encounter)
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "stresstrack",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    children: [
                        pool.name,
                        "\xa0",
                        filled > 0 && (0, $b10f60c1c4fdc48b$export$1fdbb522b1c3401f)(entity, pool, encounter._id, index)
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "track",
                    children: (0, $1249f3af6d8d1d25$export$2e2bcd8739ae039)(entity, pool, encounter._id, index)
                })
            ]
        }, pool._id);
    });
}
function $ff3467bccb224523$var$attemptClear(props) {
    if (window.confirm('Are you sure you want to clear all the pools in this encounter?')) {
        // console.log(props);
        let encounter = props.enc;
        let encounterid = encounter._id;
        encounter.enemyTypes.forEach((enemyType)=>{
            if (!enemyType.entity) return;
            let entity = enemyType.entity;
            for(let i = 0; i < enemyType.quantity; i++){
                let index = i;
                enemyType.entity.pools.forEach((pool)=>{
                    let stat = pool;
                    // console.log(entity, stat, encounterid, index);
                    (0, $1249f3af6d8d1d25$export$918b4cb17faa2b09)(entity, stat, encounterid, index);
                    (0, $b10f60c1c4fdc48b$export$cdfbca7c3259dfd9)(entity, "toggle-dead", encounterid, index);
                });
            }
            let deads = document.querySelectorAll('.dead');
            deads.forEach((element)=>{
                element.classList.remove('dead');
            });
        });
    }
}
function $ff3467bccb224523$var$ToggleDead(e, entity, toggleName, encounterid, index) {
    (0, $b10f60c1c4fdc48b$export$b39915331bcce57f)(entity, toggleName, encounterid, index);
    // console.log(getToggle(entity, toggleName, encounterid, index));
    let target = e.target.parentElement.parentElement;
    target.classList.toggle('dead');
}
function $ff3467bccb224523$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
        children: [
            props.enc.enemyTypes.map((type, ti)=>{
                let entity = type.entity;
                let typeKey = type._id + ti;
                // console.log(typeKey, ti)
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ul", {
                        children: type.combatants.map((com, ci)=>{
                            // console.log(ci)
                            if (!entity) return null;
                            let url = '/doc/' + type.doc._id + '/Entity/' + type.entity._id;
                            let dead = (0, $b10f60c1c4fdc48b$export$eff8a958b14c081f)(entity, "toggle-dead", props.enc._id, ci);
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                className: dead ? "combatant dead" : "combatant",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h5", {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                onClick: (e)=>$ff3467bccb224523$var$ToggleDead(e, entity, "toggle-dead", props.enc._id, ci),
                                                children: "\u2620\uFE0F"
                                            }),
                                            "\xa0",
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                                to: url,
                                                children: [
                                                    entity.name,
                                                    " #",
                                                    com.index + 1
                                                ]
                                            })
                                        ]
                                    }),
                                    $ff3467bccb224523$var$combatantPool(entity, com, props, type, ci)
                                ]
                            }, ci);
                        })
                    })
                }, typeKey);
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    onClick: (e)=>$ff3467bccb224523$var$attemptClear(props),
                    children: "Clear All Enemy Pools"
                })
            })
        ]
    });
}


// import EntityCards from "../SocketDoc/PrintTab/EntityCards";



function $79f4077e96527e61$export$2e2bcd8739ae039(options, entities) {
    if (!entities) return null;
    let sortBy = options.sortBy || options.sortby || "xp";
    if (!sortBy) return entities;
    sortBy = sortBy.replace(' ', '').toLowerCase();
    if (sortBy === 'xp') entities.sort((a, b)=>{
        if (a.xp < b.xp) return -1;
        if (a.xp > b.xp) return 1;
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
    });
    else if (sortBy === 'xpreversed') entities.sort((a, b)=>{
        if (a.xp < b.xp) return 1;
        if (a.xp > b.xp) return -1;
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
    });
    else if (sortBy === 'name') entities.sort((a, b)=>{
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
    });
    else if (sortBy === 'tags') entities.sort((a, b)=>{
        let at = a.tags.sort().join(' ');
        let bt = b.tags.sort().join(' ');
        if (at < bt) return -1;
        if (at > bt) return 1;
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
    });
    return entities;
}


function $56801cf1bcc15de3$export$2e2bcd8739ae039(options, entities) {
    if (!entities) return null;
    if (!!options.includeEntities || !!options.includeentities) {
        // Name whitelist
        let included = options.includeEntities || options.includeentities;
        // console.log(included);
        let nw = [];
        if (included.includes(",,")) nw = included.split(',,').map((x)=>x.toLowerCase()).map((x)=>x.trim());
        else nw = included.split(',').map((x)=>x.toLowerCase()).map((x)=>x.trim());
        // console.log("nw", nw)
        entities = entities.filter((entity)=>{
            let match = false;
            nw.forEach((inclusion)=>{
                match = match || entity.name.toLowerCase() === inclusion;
            });
            return match;
        });
    }
    if (!!options.whitelistTags || !!options.whitelisttags) {
        // tag whitelist
        let wl = (options.whitelistTags || options.whitelisttags).split(',').map((x)=>x.toLowerCase()).map((x)=>x.replace(/#/g, '')).map((x)=>x.trim());
        entities = entities.filter((entity)=>{
            let match = false;
            wl.forEach((tag)=>{
                match = match || entity.tags.includes(tag);
            });
            return match;
        });
    }
    if (!!options.blacklistTags || !!options.blacklisttags) {
        // tag blacklist
        let bl = (options.blacklistTags || options.blacklisttags).split(',').map((x)=>x.toLowerCase()).map((x)=>x.replace(/#/g, '')).map((x)=>x.trim());
        entities = entities.filter((entity)=>{
            let match = false;
            bl.forEach((tag)=>{
                match = match || entity.tags.includes(tag);
            });
            return !match;
        });
    }
    if (!!options.excludeEntities || !!options.excludeentities) {
        // name exclusions
        let xl = (options.excludeEntities || options.excludeentities).split(',').map((x)=>x.toLowerCase()).map((x)=>x.trim());
        entities = entities.filter((entity)=>{
            let match = false;
            xl.forEach((exclusion)=>{
                match = match || entity.name.toLowerCase() === exclusion;
            });
            return !match;
        });
    }
    return entities;
}


function $98d37b25b54ca0ea$export$2e2bcd8739ae039(mult) {
    if (mult?.includes('/')) return mult + ' xp';
    return "\xd7" + mult + ' xp';
}



function $db4bc0fdc611a9d4$export$2e2bcd8739ae039(doc) {
    let prototypes = {};
    let bail = false;
    (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).groups.forEach((group)=>{
        if (!doc[group]) return bail = true;
        doc[group].forEach((stat)=>{
            prototypes[stat.name] = stat;
        });
    });
    if (bail) return null;
    // console.log(prototypes);
    return prototypes;
}


/**
 * formats a stat number for display/output.
 * @param {*} num 
 * @param {*} groupName name of the group the stat is in
 * @param {Object} stat the stat object itself, containing the prototype reference
 * @returns formatted string
 */ function $19cfbde689462999$export$2e2bcd8739ae039(num, groupName = '', stat = null) {
    if (!stat) console.error("no stat");
    if (!stat?.prototype) console.error("no prototype");
    if (!groupName) console.error("no group name");
    if (!!stat?.prototype?.displayFormat) {
        let str = stat.prototype.displayFormat;
        return str.replace("X", num);
    }
    groupName = groupName.toLocaleLowerCase();
    // guard against non-bonuses
    if (groupName === 'tacticals') return num;
    if (groupName === 'pools') return num;
    if (groupName === 'thresholds') return num;
    // check for negative
    num = num.toString();
    if (num.startsWith('-')) return num;
    // return with plus
    return '+' + num;
}


function $72ad4d1d464a8ddc$export$2e2bcd8739ae039(doc, prototype, entity, group, format) {
    if (!prototype) return '';
    let stat = entity[group].find((x)=>x.name === prototype.name);
    if (!stat) return '';
    let o = '';
    o += stat.name + ' ';
    if (!!stat.skillGroup) o += '(' + stat.skillGroup + ') ';
    if (stat.dieSize !== 'none') o += '1' + stat.dieSize;
    if (!!stat.dicePool) o += stat.dicePool;
    if (stat.valueType === 'formula') o += stat.calculated;
    if (stat.valueType === 'number') {
        let skillStatName = prototype?.skillStat;
        if (!!skillStatName) {
            let skillStat = entity.primaries.find((primary)=>primary.name === skillStatName);
            if (!!skillStat) o += (0, $19cfbde689462999$export$2e2bcd8739ae039)(stat.number + skillStat.number, group, stat);
            else o += (0, $19cfbde689462999$export$2e2bcd8739ae039)(stat.number, group, stat);
        } else o += (0, $19cfbde689462999$export$2e2bcd8739ae039)(stat.number, group, stat);
    }
    return o;
}


function $a0793168e786c181$export$2e2bcd8739ae039(doc, format, entity, group, namedTag = (x, y)=>x) {
    let thresholdList = doc.thresholds.map((x)=>x._id);
    let output = '';
    // console.log(thresholdList)
    output += format.bold.suf;
    output += format.ul.pre;
    doc.tracks.forEach((track)=>{
        // Skip track if the entity doesn't need it
        let needsTrack = false;
        let trackout = '';
        // console.log(track.layers)
        trackout += track.layers.map((layer)=>{
            if (!layer.stat) {
                console.log("no stat");
                return '';
            }
            let prototype = doc.thresholds.find((x)=>x._id.toString() === layer.stat.toString());
            if (!prototype) {
                console.log("no prototype");
                return '';
            }
            // console.log(layer.stat, prototype)
            thresholdList = thresholdList.filter((x)=>x !== prototype._id.toString());
            let stattext = (0, $72ad4d1d464a8ddc$export$2e2bcd8739ae039)(doc, prototype, entity, group, format);
            if (!stattext) return '';
            needsTrack = true;
            return namedTag(format.span.pre, 'stat') + stattext + format.span.suf;
        }).filter((x)=>!!x).join(namedTag(format.span.pre, 'arrow') + " \u25B6 " + format.span.suf);
        let targetPrototype = doc.pools.find((x)=>x._id.toString() === track.targetStat?.toString());
        if (!targetPrototype) {
            console.error('missing track', track);
            return '';
        }
        if (needsTrack === false) return '';
        // do track
        output += namedTag(format.li2.pre, [
            'track',
            track.name
        ]);
        output += namedTag(format.bold.pre, 'title');
        output += track.name;
        output += ': ';
        output += format.bold.suf;
        output += trackout;
        output += namedTag(format.span.pre, 'arrow') + " \u25B6 " + format.span.suf;
        output += namedTag(format.span.pre, [
            'stat',
            'pool',
            'target'
        ]);
        output += targetPrototype.name + ' pool';
        output += format.span.suf;
        output += namedTag(format.span.pre, 'period') + '.' + format.span.suf;
        output += format.li.suf;
    });
    // console.log(thresholdList)
    let leftovers = thresholdList.map((remaining)=>{
        let prototype = doc.thresholds.find((x)=>x._id.toString() === remaining);
        return (0, $72ad4d1d464a8ddc$export$2e2bcd8739ae039)(doc, prototype, entity, group, format);
    });
    leftovers = leftovers.filter((x)=>x !== '');
    if (leftovers.length > 0) {
        // console.log("leftovers", leftovers.length, leftovers);
        output += '\t';
        output += format.li.pre;
        output += leftovers.join(', ') + '.';
        output += format.li.suf;
    }
    output += format.ul.suf;
    return output;
}





function $39bb4030a6707a23$export$2e2bcd8739ae039(doc, owner, stat, groupName) {
    let value = (0, $d57594e518c4ebb1$export$2e2bcd8739ae039)(stat);
    // console.log(stat)
    if (groupName.toLowerCase() === 'skills') {
        let prototypeSkill = doc.skills.find((x)=>x.name === stat.name);
        // console.log(prototypeSkill)
        if (!prototypeSkill) {
            console.log("SKILL DELETED: " + stat.name);
            return 0;
        }
        let ownerStat = owner.primaries?.find((x)=>x.name === prototypeSkill.skillStat);
        // console.log(ownerStat)
        let ownerSkill = owner.skills?.find((x)=>x.name === stat.name);
        // console.log(ownerSkill)
        let poolString = (0, $d57594e518c4ebb1$export$2e2bcd8739ae039)(stat);
        if (ownerStat) poolString += '+' + (0, $d57594e518c4ebb1$export$2e2bcd8739ae039)(ownerStat);
        if (ownerSkill) poolString += '+' + (0, $d57594e518c4ebb1$export$2e2bcd8739ae039)(ownerSkill);
        // console.log(poolString)
        let pool = new (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).DicePool(poolString);
        // console.log(pool)
        // console.log(prototypeSkill.displayFormat)
        value = pool.toStringOrNumber();
    }
    return value;
}



function $b3d45acacf80454e$export$2e2bcd8739ae039(doc, owner, group, item, hideHeader = false, format, namedTag) {
    return item[group].filter((x)=>x.hasOwnProperty("prototype") && (!x.prototype.displayVisibility || x.prototype.displayVisibility === 'items')).sort((a, b)=>{
        return a.skillGroup > b.skillGroup;
    }).map((stat)=>{
        let skillString = '';
        skillString += stat.name + " ";
        let skillValue = 0;
        if (stat.dieSize !== 'none') skillValue = '1' + stat.dieSize;
        if (!!stat.dicePool) skillValue = stat.dicePool;
        if (stat.valueType === 'number') skillValue = stat.number;
        if (stat.valueType === 'formula') skillValue = stat.calculated;
        if (group === 'skills') skillValue = (0, $39bb4030a6707a23$export$2e2bcd8739ae039)(doc, owner, stat, group);
        skillString += (0, $19cfbde689462999$export$2e2bcd8739ae039)(skillValue, group, stat);
        skillString = namedTag(format.span.pre, [
            'stat',
            stat.name
        ]) + skillString + format.span.suf;
        return skillString;
    });
}











function $0f869b45f2f8c029$export$2e2bcd8739ae039(tag, content) {
    if (Array.isArray(content)) {
        // console.log(content)
        content = content.map((x)=>x.replaceAll(' ', '-').toLowerCase());
        // console.log('replaced all ', content)
        content = content.join(' ');
    } else content = content.replaceAll(' ', '-').toLowerCase();
    if (tag.includes('class')) {
        const pattern = /(?:class=["'])(.*)(?:['"])/;
        let matches = tag.match(pattern);
        let newTag = tag;
        if (matches.length > 1) newTag = tag.replace(matches[0], 'class="' + matches[1] + " " + content + '"');
        else newTag = tag.replace(matches[0], 'class="' + content + '"');
        // console.log(matches);
        return newTag;
    } else return tag.replace('>', ' class="' + content + '" >');
}


function $41374fe20d442493$export$2e2bcd8739ae039(doc, options, format) {
    let entities = (0, $79f4077e96527e61$export$2e2bcd8739ae039)(options, doc.entities);
    entities = (0, $56801cf1bcc15de3$export$2e2bcd8739ae039)(options, entities);
    // console.log("filtered entities", entities)
    let prototypes = (0, $db4bc0fdc611a9d4$export$2e2bcd8739ae039)(doc);
    if (!prototypes) return '';
    if (!entities) return '';
    let output = '';
    let hideHeader = !options.hideHeader === true && (options.hideHeader, false);
    if (hideHeader) {
        output += format.h1.pre;
        output += doc.name;
        output += ' ';
        output += doc.type;
        output += ' Entities';
        output += format.h1.suf;
    }
    entities.forEach((entity)=>{
        output += $41374fe20d442493$var$entityCard(entity, doc, prototypes, format);
    });
    return output;
}
const $41374fe20d442493$var$entityCard = (entity, doc, prototypes, format)=>{
    let output = '';
    output += '<div class="statblock ';
    output += entity.tags?.join(' ');
    output += '">\n';
    output += format.h2.pre;
    output += entity.name;
    output += ' (' + entity.xp.toLocaleString() + 'xp)';
    output += format.h2.suf;
    output += format.ul.pre;
    if (entity.limitations.length > 0) {
        output += format.li.pre;
        output += format.bold.pre;
        output += 'Limits';
        output += format.bold.suf;
        output += ': ';
        output += entity.limitations.map((limit)=>{
            let o = '';
            o += limit.name;
            o += ' (' + (0, $98d37b25b54ca0ea$export$2e2bcd8739ae039)(limit.multiplier) + ')';
            if (!!limit.notes) o += ' ' + limit.notes;
            return o;
        }).join(', ');
        output += format.li.suf;
    }
    if (entity.tags.length > 0) {
        output += format.li.pre;
        output += format.bold.pre;
        output += 'Tags';
        output += format.bold.suf;
        output += ': ';
        output += entity.tags.map((x)=>'#' + x).join(', ');
        output += format.li.suf;
    }
    if (entity.aspects.length > 0) {
        output += format.li.pre;
        output += format.bold.pre;
        output += 'Aspects';
        output += format.bold.suf;
        output += ': ';
        output += entity.aspects.join(', ');
        output += format.li.suf;
    }
    if (entity.flaws.length > 0) {
        output += format.li.pre;
        output += format.bold.pre;
        output += 'Flaws';
        output += format.bold.suf;
        output += ':+ ';
        output += entity.flaws.join(', ');
        output += format.li.suf;
    }
    (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).groups.forEach((group)=>{
        if (entity[group].length === 0) return;
        let shown = entity[group].filter((x)=>{
            if (!x.prototype) return null;
            return !x.prototype.displayVisibility || x.prototype.displayVisibility === 'owners';
        });
        if (shown.length === 0 && entity.items.length > 0) return;
        output += format.li.pre;
        output += format.bold.pre;
        output += (0, $920954e343704e08$exports.capitalize)(group);
        if (group === 'thresholds' && !!doc.tracks && doc.tracks.length > 0) output += (0, $a0793168e786c181$export$2e2bcd8739ae039)(doc, format, entity, group);
        else {
            output += format.bold.suf;
            output += ': ';
            let prototypes = doc[group];
            output += prototypes.filter((proto)=>entity[group].map((x)=>x.name).includes(proto.name)).map((prototype)=>{
                return (0, $72ad4d1d464a8ddc$export$2e2bcd8739ae039)(doc, prototype, entity, group, format);
            }).join(', ');
            output += '.';
        }
        output += format.li.suf;
    });
    // console.log(entity.equipment.length, entity.items.length);
    if (entity.items.length !== 0) // output += 'Equipment\n';
    entity.items.forEach((item)=>{
        output += format.li.pre;
        output += format.bold.pre;
        output += item.name;
        output += format.bold.suf;
        output += ' (' + item.xp + 'xp) ';
        if (item.limitations.length > 0) {
            output += 'Limits: ';
            output += item.limitations.map((limit)=>{
                let o = limit.name;
                if (limit.note) o += ' ' + limit.note;
                return o;
            }).join(', ');
            output += '. ';
        }
        if (item.aspects.length > 0) {
            output += 'Aspects: ' + item.aspects.join(', ');
            output += '. ';
        }
        if (item.flaws.length > 0) {
            output += 'Flaws: ' + item.flaws.join(', ');
            output += '. ';
        }
        (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).groups.forEach((group)=>{
            if (item[group].length === 0) return;
            output += (0, $920954e343704e08$exports.capitalize)(group) + ': ';
            output += (0, $b3d45acacf80454e$export$2e2bcd8739ae039)(doc, entity, group, item, true, format, (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)).join(', ');
            output += '. ';
        });
        output += format.li.suf;
    });
    output += format.ul.suf;
    output += '</div>\n';
    return output;
};


const $712be45d7780c927$var$HtmlFormat = {
    h1: {
        pre: "<h1>",
        suf: "</h1>\n"
    },
    h2: {
        pre: "<h2>",
        suf: "</h2>\n"
    },
    h3: {
        pre: "<h3>",
        suf: "</h3>\n"
    },
    h4: {
        pre: "<h4>",
        suf: "</h4>\n"
    },
    h5: {
        pre: "<h5>",
        suf: "</h5>\n"
    },
    h6: {
        pre: "<h6>",
        suf: "</h6>\n"
    },
    ul: {
        pre: "<ul>\n",
        suf: "</ul>\n"
    },
    li: {
        pre: "<li>",
        suf: "</li>\n"
    },
    li2: {
        pre: "<li>",
        suf: "</li>\n"
    },
    table: {
        pre: "<table>",
        suf: "</table>\n"
    },
    thead: {
        pre: "<thead>",
        suf: "</thead>\n"
    },
    tbody: {
        pre: "<tbody>",
        suf: "</tbody>\n"
    },
    tr: {
        pre: "<tr>",
        suf: "</tr>\n"
    },
    td: {
        pre: "<td>",
        suf: "</td>\n"
    },
    th: {
        pre: "<th>",
        suf: "</th>\n"
    },
    p: {
        pre: "<p>",
        suf: "</p>\n"
    },
    card: {
        pre: "<div class='card'>\n",
        suf: "</div>\n"
    },
    code: {
        pre: "<code>",
        suf: "</code>"
    },
    bold: {
        pre: "<strong>",
        suf: "</strong>"
    },
    italic: {
        pre: "<em>",
        suf: "</em>"
    },
    break: {
        pre: "<br />\n",
        suf: ""
    },
    line: {
        pre: "<hr /\n>",
        suf: ""
    },
    wrap: {
        pre: "<wrap class='name'>",
        suf: "</wrap>"
    },
    span: {
        pre: "<span>",
        suf: "</span>"
    }
};
var $712be45d7780c927$export$2e2bcd8739ae039 = $712be45d7780c927$var$HtmlFormat;


var $135ea95dbedf029f$exports = {};
var $6ef2adab05030e62$exports = {};

var $bh6RR = parcelRequire("bh6RR");
var $fa2869eaa022a51e$exports = {};
var $1cd97b80a9ac6ef3$exports = {};
'use strict';
Object.defineProperty($1cd97b80a9ac6ef3$exports, '__esModule', {
    value: true
});
function $1cd97b80a9ac6ef3$var$_slicedToArray(arr, i) {
    return $1cd97b80a9ac6ef3$var$_arrayWithHoles(arr) || $1cd97b80a9ac6ef3$var$_iterableToArrayLimit(arr, i) || $1cd97b80a9ac6ef3$var$_unsupportedIterableToArray(arr, i) || $1cd97b80a9ac6ef3$var$_nonIterableRest();
}
function $1cd97b80a9ac6ef3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1cd97b80a9ac6ef3$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1cd97b80a9ac6ef3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1cd97b80a9ac6ef3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1cd97b80a9ac6ef3$var$_arrayLikeToArray(o, minLen);
}
function $1cd97b80a9ac6ef3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1cd97b80a9ac6ef3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
var $1cd97b80a9ac6ef3$var$RESERVED = 0; // A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.
var $1cd97b80a9ac6ef3$var$STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.
var $1cd97b80a9ac6ef3$var$BOOLEANISH_STRING = 2; // A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
var $1cd97b80a9ac6ef3$var$BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.
var $1cd97b80a9ac6ef3$var$OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.
var $1cd97b80a9ac6ef3$var$NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.
var $1cd97b80a9ac6ef3$var$POSITIVE_NUMERIC = 6;
function $1cd97b80a9ac6ef3$var$getPropertyInfo(name) {
    return $1cd97b80a9ac6ef3$var$properties.hasOwnProperty(name) ? $1cd97b80a9ac6ef3$var$properties[name] : null;
}
function $1cd97b80a9ac6ef3$var$PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
    this.acceptsBooleans = type === $1cd97b80a9ac6ef3$var$BOOLEANISH_STRING || type === $1cd97b80a9ac6ef3$var$BOOLEAN || type === $1cd97b80a9ac6ef3$var$OVERLOADED_BOOLEAN;
    this.attributeName = attributeName;
    this.attributeNamespace = attributeNamespace;
    this.mustUseProperty = mustUseProperty;
    this.propertyName = name;
    this.type = type;
    this.sanitizeURL = sanitizeURL;
    this.removeEmptyString = removeEmptyString;
} // When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.
var $1cd97b80a9ac6ef3$var$properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
var $1cd97b80a9ac6ef3$var$reservedProps = [
    'children',
    'dangerouslySetInnerHTML',
    // elements (not just inputs). Now that ReactDOMInput assigns to the
    // defaultValue property -- do we need this?
    'defaultValue',
    'defaultChecked',
    'innerHTML',
    'suppressContentEditableWarning',
    'suppressHydrationWarning',
    'style'
];
$1cd97b80a9ac6ef3$var$reservedProps.forEach(function(name) {
    $1cd97b80a9ac6ef3$var$properties[name] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord(name, $1cd97b80a9ac6ef3$var$RESERVED, false, name, null, false, false);
}); // A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.
[
    [
        'acceptCharset',
        'accept-charset'
    ],
    [
        'className',
        'class'
    ],
    [
        'htmlFor',
        'for'
    ],
    [
        'httpEquiv',
        'http-equiv'
    ]
].forEach(function(_ref) {
    var _ref2 = $1cd97b80a9ac6ef3$var$_slicedToArray(_ref, 2), name = _ref2[0], attributeName = _ref2[1];
    $1cd97b80a9ac6ef3$var$properties[name] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord(name, $1cd97b80a9ac6ef3$var$STRING, false, attributeName, null, false, false);
}); // These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
[
    'contentEditable',
    'draggable',
    'spellCheck',
    'value'
].forEach(function(name) {
    $1cd97b80a9ac6ef3$var$properties[name] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord(name, $1cd97b80a9ac6ef3$var$BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
}); // These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.
[
    'autoReverse',
    'externalResourcesRequired',
    'focusable',
    'preserveAlpha'
].forEach(function(name) {
    $1cd97b80a9ac6ef3$var$properties[name] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord(name, $1cd97b80a9ac6ef3$var$BOOLEANISH_STRING, false, name, null, false, false);
}); // These are HTML boolean attributes.
[
    'allowFullScreen',
    'async',
    // on the client side because the browsers are inconsistent. Instead we call focus().
    'autoFocus',
    'autoPlay',
    'controls',
    'default',
    'defer',
    'disabled',
    'disablePictureInPicture',
    'disableRemotePlayback',
    'formNoValidate',
    'hidden',
    'loop',
    'noModule',
    'noValidate',
    'open',
    'playsInline',
    'readOnly',
    'required',
    'reversed',
    'scoped',
    'seamless',
    'itemScope'
].forEach(function(name) {
    $1cd97b80a9ac6ef3$var$properties[name] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord(name, $1cd97b80a9ac6ef3$var$BOOLEAN, false, name.toLowerCase(), null, false, false);
}); // These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.
[
    'checked',
    // disabled with `removeAttribute`. We have special logic for handling this.
    'multiple',
    'muted',
    'selected' // NOTE: if you add a camelCased prop to this list,
].forEach(function(name) {
    $1cd97b80a9ac6ef3$var$properties[name] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord(name, $1cd97b80a9ac6ef3$var$BOOLEAN, true, name, null, false, false);
}); // These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.
[
    'capture',
    'download' // NOTE: if you add a camelCased prop to this list,
].forEach(function(name) {
    $1cd97b80a9ac6ef3$var$properties[name] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord(name, $1cd97b80a9ac6ef3$var$OVERLOADED_BOOLEAN, false, name, null, false, false);
}); // These are HTML attributes that must be positive numbers.
[
    'cols',
    'rows',
    'size',
    'span' // NOTE: if you add a camelCased prop to this list,
].forEach(function(name) {
    $1cd97b80a9ac6ef3$var$properties[name] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord(name, $1cd97b80a9ac6ef3$var$POSITIVE_NUMERIC, false, name, null, false, false);
}); // These are HTML attributes that must be numbers.
[
    'rowSpan',
    'start'
].forEach(function(name) {
    $1cd97b80a9ac6ef3$var$properties[name] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord(name, $1cd97b80a9ac6ef3$var$NUMERIC, false, name.toLowerCase(), null, false, false);
});
var $1cd97b80a9ac6ef3$var$CAMELIZE = /[\-\:]([a-z])/g;
var $1cd97b80a9ac6ef3$var$capitalize = function capitalize(token) {
    return token[1].toUpperCase();
}; // This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.
[
    'accent-height',
    'alignment-baseline',
    'arabic-form',
    'baseline-shift',
    'cap-height',
    'clip-path',
    'clip-rule',
    'color-interpolation',
    'color-interpolation-filters',
    'color-profile',
    'color-rendering',
    'dominant-baseline',
    'enable-background',
    'fill-opacity',
    'fill-rule',
    'flood-color',
    'flood-opacity',
    'font-family',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-weight',
    'glyph-name',
    'glyph-orientation-horizontal',
    'glyph-orientation-vertical',
    'horiz-adv-x',
    'horiz-origin-x',
    'image-rendering',
    'letter-spacing',
    'lighting-color',
    'marker-end',
    'marker-mid',
    'marker-start',
    'overline-position',
    'overline-thickness',
    'paint-order',
    'panose-1',
    'pointer-events',
    'rendering-intent',
    'shape-rendering',
    'stop-color',
    'stop-opacity',
    'strikethrough-position',
    'strikethrough-thickness',
    'stroke-dasharray',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke-width',
    'text-anchor',
    'text-decoration',
    'text-rendering',
    'underline-position',
    'underline-thickness',
    'unicode-bidi',
    'unicode-range',
    'units-per-em',
    'v-alphabetic',
    'v-hanging',
    'v-ideographic',
    'v-mathematical',
    'vector-effect',
    'vert-adv-y',
    'vert-origin-x',
    'vert-origin-y',
    'word-spacing',
    'writing-mode',
    'xmlns:xlink',
    'x-height' // NOTE: if you add a camelCased prop to this list,
].forEach(function(attributeName) {
    var name = attributeName.replace($1cd97b80a9ac6ef3$var$CAMELIZE, $1cd97b80a9ac6ef3$var$capitalize);
    $1cd97b80a9ac6ef3$var$properties[name] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord(name, $1cd97b80a9ac6ef3$var$STRING, false, attributeName, null, false, false);
}); // String SVG attributes with the xlink namespace.
[
    'xlink:actuate',
    'xlink:arcrole',
    'xlink:role',
    'xlink:show',
    'xlink:title',
    'xlink:type' // NOTE: if you add a camelCased prop to this list,
].forEach(function(attributeName) {
    var name = attributeName.replace($1cd97b80a9ac6ef3$var$CAMELIZE, $1cd97b80a9ac6ef3$var$capitalize);
    $1cd97b80a9ac6ef3$var$properties[name] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord(name, $1cd97b80a9ac6ef3$var$STRING, false, attributeName, 'http://www.w3.org/1999/xlink', false, false);
}); // String SVG attributes with the xml namespace.
[
    'xml:base',
    'xml:lang',
    'xml:space' // NOTE: if you add a camelCased prop to this list,
].forEach(function(attributeName) {
    var name = attributeName.replace($1cd97b80a9ac6ef3$var$CAMELIZE, $1cd97b80a9ac6ef3$var$capitalize);
    $1cd97b80a9ac6ef3$var$properties[name] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord(name, $1cd97b80a9ac6ef3$var$STRING, false, attributeName, 'http://www.w3.org/XML/1998/namespace', false, false);
}); // These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.
[
    'tabIndex',
    'crossOrigin'
].forEach(function(attributeName) {
    $1cd97b80a9ac6ef3$var$properties[attributeName] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord(attributeName, $1cd97b80a9ac6ef3$var$STRING, false, attributeName.toLowerCase(), null, false, false);
}); // These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.
var $1cd97b80a9ac6ef3$var$xlinkHref = 'xlinkHref';
$1cd97b80a9ac6ef3$var$properties[$1cd97b80a9ac6ef3$var$xlinkHref] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord('xlinkHref', $1cd97b80a9ac6ef3$var$STRING, false, 'xlink:href', 'http://www.w3.org/1999/xlink', true, false);
[
    'src',
    'href',
    'action',
    'formAction'
].forEach(function(attributeName) {
    $1cd97b80a9ac6ef3$var$properties[attributeName] = new $1cd97b80a9ac6ef3$var$PropertyInfoRecord(attributeName, $1cd97b80a9ac6ef3$var$STRING, false, attributeName.toLowerCase(), null, true, true);
});
// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var $205b3d2ad28f3a54$export$7359a57b3ac1f378;
var $205b3d2ad28f3a54$export$5ab28d07cff57c11;
var $205b3d2ad28f3a54$export$bbecfff5ecf65cd8;
var $205b3d2ad28f3a54$var$SAME = 0;
$205b3d2ad28f3a54$export$7359a57b3ac1f378 = $205b3d2ad28f3a54$var$SAME;
// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var $205b3d2ad28f3a54$var$CAMELCASE = 1;
$205b3d2ad28f3a54$export$5ab28d07cff57c11 = $205b3d2ad28f3a54$var$CAMELCASE;
$205b3d2ad28f3a54$export$bbecfff5ecf65cd8 = {
    accept: 0,
    acceptCharset: 1,
    'accept-charset': 'acceptCharset',
    accessKey: 1,
    action: 0,
    allowFullScreen: 1,
    alt: 0,
    as: 0,
    async: 0,
    autoCapitalize: 1,
    autoComplete: 1,
    autoCorrect: 1,
    autoFocus: 1,
    autoPlay: 1,
    autoSave: 1,
    capture: 0,
    cellPadding: 1,
    cellSpacing: 1,
    challenge: 0,
    charSet: 1,
    checked: 0,
    children: 0,
    cite: 0,
    class: 'className',
    classID: 1,
    className: 1,
    cols: 0,
    colSpan: 1,
    content: 0,
    contentEditable: 1,
    contextMenu: 1,
    controls: 0,
    controlsList: 1,
    coords: 0,
    crossOrigin: 1,
    dangerouslySetInnerHTML: 1,
    data: 0,
    dateTime: 1,
    default: 0,
    defaultChecked: 1,
    defaultValue: 1,
    defer: 0,
    dir: 0,
    disabled: 0,
    disablePictureInPicture: 1,
    disableRemotePlayback: 1,
    download: 0,
    draggable: 0,
    encType: 1,
    enterKeyHint: 1,
    for: 'htmlFor',
    form: 0,
    formMethod: 1,
    formAction: 1,
    formEncType: 1,
    formNoValidate: 1,
    formTarget: 1,
    frameBorder: 1,
    headers: 0,
    height: 0,
    hidden: 0,
    high: 0,
    href: 0,
    hrefLang: 1,
    htmlFor: 1,
    httpEquiv: 1,
    'http-equiv': 'httpEquiv',
    icon: 0,
    id: 0,
    innerHTML: 1,
    inputMode: 1,
    integrity: 0,
    is: 0,
    itemID: 1,
    itemProp: 1,
    itemRef: 1,
    itemScope: 1,
    itemType: 1,
    keyParams: 1,
    keyType: 1,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: 0,
    low: 0,
    manifest: 0,
    marginWidth: 1,
    marginHeight: 1,
    max: 0,
    maxLength: 1,
    media: 0,
    mediaGroup: 1,
    method: 0,
    min: 0,
    minLength: 1,
    multiple: 0,
    muted: 0,
    name: 0,
    noModule: 1,
    nonce: 0,
    noValidate: 1,
    open: 0,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: 1,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 1,
    readOnly: 1,
    referrerPolicy: 1,
    rel: 0,
    required: 0,
    reversed: 0,
    role: 0,
    rows: 0,
    rowSpan: 1,
    sandbox: 0,
    scope: 0,
    scoped: 0,
    scrolling: 0,
    seamless: 0,
    selected: 0,
    shape: 0,
    size: 0,
    sizes: 0,
    span: 0,
    spellCheck: 1,
    src: 0,
    srcDoc: 1,
    srcLang: 1,
    srcSet: 1,
    start: 0,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 1,
    target: 0,
    title: 0,
    type: 0,
    useMap: 1,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,
    about: 0,
    accentHeight: 1,
    'accent-height': 'accentHeight',
    accumulate: 0,
    additive: 0,
    alignmentBaseline: 1,
    'alignment-baseline': 'alignmentBaseline',
    allowReorder: 1,
    alphabetic: 0,
    amplitude: 0,
    arabicForm: 1,
    'arabic-form': 'arabicForm',
    ascent: 0,
    attributeName: 1,
    attributeType: 1,
    autoReverse: 1,
    azimuth: 0,
    baseFrequency: 1,
    baselineShift: 1,
    'baseline-shift': 'baselineShift',
    baseProfile: 1,
    bbox: 0,
    begin: 0,
    bias: 0,
    by: 0,
    calcMode: 1,
    capHeight: 1,
    'cap-height': 'capHeight',
    clip: 0,
    clipPath: 1,
    'clip-path': 'clipPath',
    clipPathUnits: 1,
    clipRule: 1,
    'clip-rule': 'clipRule',
    color: 0,
    colorInterpolation: 1,
    'color-interpolation': 'colorInterpolation',
    colorInterpolationFilters: 1,
    'color-interpolation-filters': 'colorInterpolationFilters',
    colorProfile: 1,
    'color-profile': 'colorProfile',
    colorRendering: 1,
    'color-rendering': 'colorRendering',
    contentScriptType: 1,
    contentStyleType: 1,
    cursor: 0,
    cx: 0,
    cy: 0,
    d: 0,
    datatype: 0,
    decelerate: 0,
    descent: 0,
    diffuseConstant: 1,
    direction: 0,
    display: 0,
    divisor: 0,
    dominantBaseline: 1,
    'dominant-baseline': 'dominantBaseline',
    dur: 0,
    dx: 0,
    dy: 0,
    edgeMode: 1,
    elevation: 0,
    enableBackground: 1,
    'enable-background': 'enableBackground',
    end: 0,
    exponent: 0,
    externalResourcesRequired: 1,
    fill: 0,
    fillOpacity: 1,
    'fill-opacity': 'fillOpacity',
    fillRule: 1,
    'fill-rule': 'fillRule',
    filter: 0,
    filterRes: 1,
    filterUnits: 1,
    floodOpacity: 1,
    'flood-opacity': 'floodOpacity',
    floodColor: 1,
    'flood-color': 'floodColor',
    focusable: 0,
    fontFamily: 1,
    'font-family': 'fontFamily',
    fontSize: 1,
    'font-size': 'fontSize',
    fontSizeAdjust: 1,
    'font-size-adjust': 'fontSizeAdjust',
    fontStretch: 1,
    'font-stretch': 'fontStretch',
    fontStyle: 1,
    'font-style': 'fontStyle',
    fontVariant: 1,
    'font-variant': 'fontVariant',
    fontWeight: 1,
    'font-weight': 'fontWeight',
    format: 0,
    from: 0,
    fx: 0,
    fy: 0,
    g1: 0,
    g2: 0,
    glyphName: 1,
    'glyph-name': 'glyphName',
    glyphOrientationHorizontal: 1,
    'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
    glyphOrientationVertical: 1,
    'glyph-orientation-vertical': 'glyphOrientationVertical',
    glyphRef: 1,
    gradientTransform: 1,
    gradientUnits: 1,
    hanging: 0,
    horizAdvX: 1,
    'horiz-adv-x': 'horizAdvX',
    horizOriginX: 1,
    'horiz-origin-x': 'horizOriginX',
    ideographic: 0,
    imageRendering: 1,
    'image-rendering': 'imageRendering',
    in2: 0,
    in: 0,
    inlist: 0,
    intercept: 0,
    k1: 0,
    k2: 0,
    k3: 0,
    k4: 0,
    k: 0,
    kernelMatrix: 1,
    kernelUnitLength: 1,
    kerning: 0,
    keyPoints: 1,
    keySplines: 1,
    keyTimes: 1,
    lengthAdjust: 1,
    letterSpacing: 1,
    'letter-spacing': 'letterSpacing',
    lightingColor: 1,
    'lighting-color': 'lightingColor',
    limitingConeAngle: 1,
    local: 0,
    markerEnd: 1,
    'marker-end': 'markerEnd',
    markerHeight: 1,
    markerMid: 1,
    'marker-mid': 'markerMid',
    markerStart: 1,
    'marker-start': 'markerStart',
    markerUnits: 1,
    markerWidth: 1,
    mask: 0,
    maskContentUnits: 1,
    maskUnits: 1,
    mathematical: 0,
    mode: 0,
    numOctaves: 1,
    offset: 0,
    opacity: 0,
    operator: 0,
    order: 0,
    orient: 0,
    orientation: 0,
    origin: 0,
    overflow: 0,
    overlinePosition: 1,
    'overline-position': 'overlinePosition',
    overlineThickness: 1,
    'overline-thickness': 'overlineThickness',
    paintOrder: 1,
    'paint-order': 'paintOrder',
    panose1: 0,
    'panose-1': 'panose1',
    pathLength: 1,
    patternContentUnits: 1,
    patternTransform: 1,
    patternUnits: 1,
    pointerEvents: 1,
    'pointer-events': 'pointerEvents',
    points: 0,
    pointsAtX: 1,
    pointsAtY: 1,
    pointsAtZ: 1,
    prefix: 0,
    preserveAlpha: 1,
    preserveAspectRatio: 1,
    primitiveUnits: 1,
    property: 0,
    r: 0,
    radius: 0,
    refX: 1,
    refY: 1,
    renderingIntent: 1,
    'rendering-intent': 'renderingIntent',
    repeatCount: 1,
    repeatDur: 1,
    requiredExtensions: 1,
    requiredFeatures: 1,
    resource: 0,
    restart: 0,
    result: 0,
    results: 0,
    rotate: 0,
    rx: 0,
    ry: 0,
    scale: 0,
    security: 0,
    seed: 0,
    shapeRendering: 1,
    'shape-rendering': 'shapeRendering',
    slope: 0,
    spacing: 0,
    specularConstant: 1,
    specularExponent: 1,
    speed: 0,
    spreadMethod: 1,
    startOffset: 1,
    stdDeviation: 1,
    stemh: 0,
    stemv: 0,
    stitchTiles: 1,
    stopColor: 1,
    'stop-color': 'stopColor',
    stopOpacity: 1,
    'stop-opacity': 'stopOpacity',
    strikethroughPosition: 1,
    'strikethrough-position': 'strikethroughPosition',
    strikethroughThickness: 1,
    'strikethrough-thickness': 'strikethroughThickness',
    string: 0,
    stroke: 0,
    strokeDasharray: 1,
    'stroke-dasharray': 'strokeDasharray',
    strokeDashoffset: 1,
    'stroke-dashoffset': 'strokeDashoffset',
    strokeLinecap: 1,
    'stroke-linecap': 'strokeLinecap',
    strokeLinejoin: 1,
    'stroke-linejoin': 'strokeLinejoin',
    strokeMiterlimit: 1,
    'stroke-miterlimit': 'strokeMiterlimit',
    strokeWidth: 1,
    'stroke-width': 'strokeWidth',
    strokeOpacity: 1,
    'stroke-opacity': 'strokeOpacity',
    suppressContentEditableWarning: 1,
    suppressHydrationWarning: 1,
    surfaceScale: 1,
    systemLanguage: 1,
    tableValues: 1,
    targetX: 1,
    targetY: 1,
    textAnchor: 1,
    'text-anchor': 'textAnchor',
    textDecoration: 1,
    'text-decoration': 'textDecoration',
    textLength: 1,
    textRendering: 1,
    'text-rendering': 'textRendering',
    to: 0,
    transform: 0,
    typeof: 0,
    u1: 0,
    u2: 0,
    underlinePosition: 1,
    'underline-position': 'underlinePosition',
    underlineThickness: 1,
    'underline-thickness': 'underlineThickness',
    unicode: 0,
    unicodeBidi: 1,
    'unicode-bidi': 'unicodeBidi',
    unicodeRange: 1,
    'unicode-range': 'unicodeRange',
    unitsPerEm: 1,
    'units-per-em': 'unitsPerEm',
    unselectable: 0,
    vAlphabetic: 1,
    'v-alphabetic': 'vAlphabetic',
    values: 0,
    vectorEffect: 1,
    'vector-effect': 'vectorEffect',
    version: 0,
    vertAdvY: 1,
    'vert-adv-y': 'vertAdvY',
    vertOriginX: 1,
    'vert-origin-x': 'vertOriginX',
    vertOriginY: 1,
    'vert-origin-y': 'vertOriginY',
    vHanging: 1,
    'v-hanging': 'vHanging',
    vIdeographic: 1,
    'v-ideographic': 'vIdeographic',
    viewBox: 1,
    viewTarget: 1,
    visibility: 0,
    vMathematical: 1,
    'v-mathematical': 'vMathematical',
    vocab: 0,
    widths: 0,
    wordSpacing: 1,
    'word-spacing': 'wordSpacing',
    writingMode: 1,
    'writing-mode': 'writingMode',
    x1: 0,
    x2: 0,
    x: 0,
    xChannelSelector: 1,
    xHeight: 1,
    'x-height': 'xHeight',
    xlinkActuate: 1,
    'xlink:actuate': 'xlinkActuate',
    xlinkArcrole: 1,
    'xlink:arcrole': 'xlinkArcrole',
    xlinkHref: 1,
    'xlink:href': 'xlinkHref',
    xlinkRole: 1,
    'xlink:role': 'xlinkRole',
    xlinkShow: 1,
    'xlink:show': 'xlinkShow',
    xlinkTitle: 1,
    'xlink:title': 'xlinkTitle',
    xlinkType: 1,
    'xlink:type': 'xlinkType',
    xmlBase: 1,
    'xml:base': 'xmlBase',
    xmlLang: 1,
    'xml:lang': 'xmlLang',
    xmlns: 0,
    'xml:space': 'xmlSpace',
    xmlnsXlink: 1,
    'xmlns:xlink': 'xmlnsXlink',
    xmlSpace: 1,
    y1: 0,
    y2: 0,
    y: 0,
    yChannelSelector: 1,
    z: 0,
    zoomAndPan: 1
};


var $1cd97b80a9ac6ef3$var$CAMELCASE = $205b3d2ad28f3a54$export$5ab28d07cff57c11, $1cd97b80a9ac6ef3$var$SAME = $205b3d2ad28f3a54$export$7359a57b3ac1f378, $1cd97b80a9ac6ef3$var$possibleStandardNamesOptimized = $205b3d2ad28f3a54$export$bbecfff5ecf65cd8;
var $1cd97b80a9ac6ef3$var$ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var $1cd97b80a9ac6ef3$var$ATTRIBUTE_NAME_CHAR = $1cd97b80a9ac6ef3$var$ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
/**
 * Checks whether a property name is a custom attribute.
 *
 * @see {@link https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25}
 *
 * @param {string}
 * @return {boolean}
 */ var $1cd97b80a9ac6ef3$var$isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + $1cd97b80a9ac6ef3$var$ATTRIBUTE_NAME_CHAR + ']*$'));
var $1cd97b80a9ac6ef3$var$possibleStandardNames = Object.keys($1cd97b80a9ac6ef3$var$possibleStandardNamesOptimized).reduce(function(accumulator, standardName) {
    var propName = $1cd97b80a9ac6ef3$var$possibleStandardNamesOptimized[standardName];
    if (propName === $1cd97b80a9ac6ef3$var$SAME) accumulator[standardName] = standardName;
    else if (propName === $1cd97b80a9ac6ef3$var$CAMELCASE) accumulator[standardName.toLowerCase()] = standardName;
    else accumulator[standardName] = propName;
    return accumulator;
}, {});
$1cd97b80a9ac6ef3$exports.BOOLEAN = $1cd97b80a9ac6ef3$var$BOOLEAN;
$1cd97b80a9ac6ef3$exports.BOOLEANISH_STRING = $1cd97b80a9ac6ef3$var$BOOLEANISH_STRING;
$1cd97b80a9ac6ef3$exports.NUMERIC = $1cd97b80a9ac6ef3$var$NUMERIC;
$1cd97b80a9ac6ef3$exports.OVERLOADED_BOOLEAN = $1cd97b80a9ac6ef3$var$OVERLOADED_BOOLEAN;
$1cd97b80a9ac6ef3$exports.POSITIVE_NUMERIC = $1cd97b80a9ac6ef3$var$POSITIVE_NUMERIC;
$1cd97b80a9ac6ef3$exports.RESERVED = $1cd97b80a9ac6ef3$var$RESERVED;
$1cd97b80a9ac6ef3$exports.STRING = $1cd97b80a9ac6ef3$var$STRING;
$1cd97b80a9ac6ef3$exports.getPropertyInfo = $1cd97b80a9ac6ef3$var$getPropertyInfo;
$1cd97b80a9ac6ef3$exports.isCustomAttribute = $1cd97b80a9ac6ef3$var$isCustomAttribute;
$1cd97b80a9ac6ef3$exports.possibleStandardNames = $1cd97b80a9ac6ef3$var$possibleStandardNames;


var $887ef7e629bca856$exports = {};

var $bh6RR = parcelRequire("bh6RR");
var $87eafd44d4bf89dc$exports = {};
"use strict";
var $87eafd44d4bf89dc$var$__importDefault = $87eafd44d4bf89dc$exports && $87eafd44d4bf89dc$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
$87eafd44d4bf89dc$exports.__esModule = true;

var $87eafd44d4bf89dc$var$style_to_object_1 = $87eafd44d4bf89dc$var$__importDefault((parcelRequire("3OSHa")));
var $9bc8a42cb01f610b$export$1e511d4a378977f5;
var $9bc8a42cb01f610b$export$8a7688a96d852767;
"use strict";
$9bc8a42cb01f610b$export$1e511d4a378977f5 = true;
$9bc8a42cb01f610b$export$8a7688a96d852767 = void 0;
var $9bc8a42cb01f610b$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
var $9bc8a42cb01f610b$var$HYPHEN_REGEX = /-([a-z])/g;
var $9bc8a42cb01f610b$var$NO_HYPHEN_REGEX = /^[^-]+$/;
var $9bc8a42cb01f610b$var$VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var $9bc8a42cb01f610b$var$MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
var $9bc8a42cb01f610b$var$skipCamelCase = function(property) {
    return !property || $9bc8a42cb01f610b$var$NO_HYPHEN_REGEX.test(property) || $9bc8a42cb01f610b$var$CUSTOM_PROPERTY_REGEX.test(property);
};
var $9bc8a42cb01f610b$var$capitalize = function(match, character) {
    return character.toUpperCase();
};
var $9bc8a42cb01f610b$var$trimHyphen = function(match, prefix) {
    return "".concat(prefix, "-");
};
var $9bc8a42cb01f610b$var$camelCase = function(property, options) {
    if (options === void 0) options = {};
    if ($9bc8a42cb01f610b$var$skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) property = property.replace($9bc8a42cb01f610b$var$MS_VENDOR_PREFIX_REGEX, $9bc8a42cb01f610b$var$trimHyphen);
    else property = property.replace($9bc8a42cb01f610b$var$VENDOR_PREFIX_REGEX, $9bc8a42cb01f610b$var$trimHyphen);
    return property.replace($9bc8a42cb01f610b$var$HYPHEN_REGEX, $9bc8a42cb01f610b$var$capitalize);
};
$9bc8a42cb01f610b$export$8a7688a96d852767 = $9bc8a42cb01f610b$var$camelCase;


function $87eafd44d4bf89dc$var$StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') return output;
    (0, $87eafd44d4bf89dc$var$style_to_object_1["default"])(style, function(property, value) {
        if (property && value) output[(0, $9bc8a42cb01f610b$export$8a7688a96d852767)(property, options)] = value;
    });
    return output;
}
$87eafd44d4bf89dc$exports["default"] = $87eafd44d4bf89dc$var$StyleToJS;


var $887ef7e629bca856$require$styleToJS = $87eafd44d4bf89dc$exports.default;
/**
 * Swap key with value in an object.
 *
 * @param {object} obj - The object.
 * @param {Function} [override] - The override method.
 * @returns - The inverted object.
 */ function $887ef7e629bca856$var$invertObject(obj, override) {
    if (!obj || typeof obj !== 'object') throw new TypeError('First argument must be an object');
    var key;
    var value;
    var isOverridePresent = typeof override === 'function';
    var overrides = {};
    var result = {};
    for(key in obj){
        value = obj[key];
        if (isOverridePresent) {
            overrides = override(key, value);
            if (overrides && overrides.length === 2) {
                result[overrides[0]] = overrides[1];
                continue;
            }
        }
        if (typeof value === 'string') result[value] = key;
    }
    return result;
}
/**
 * Check if a given tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param {string} tagName - The name of the html tag.
 * @param {object} props - The props being passed to the element.
 * @returns - Whether tag is custom component.
 */ function $887ef7e629bca856$var$isCustomComponent(tagName, props) {
    if (tagName.indexOf('-') === -1) return props && typeof props.is === 'string';
    switch(tagName){
        // These are reserved SVG and MathML elements.
        // We don't mind this whitelist too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case 'annotation-xml':
        case 'color-profile':
        case 'font-face':
        case 'font-face-src':
        case 'font-face-uri':
        case 'font-face-format':
        case 'font-face-name':
        case 'missing-glyph':
            return false;
        default:
            return true;
    }
}
var $887ef7e629bca856$var$styleToJSOptions = {
    reactCompat: true
};
/**
 * Sets style prop.
 *
 * @param {null|undefined|string} style
 * @param {object} props
 */ function $887ef7e629bca856$var$setStyleProp(style, props) {
    if (style === null || style === undefined) return;
    try {
        props.style = $887ef7e629bca856$require$styleToJS(style, $887ef7e629bca856$var$styleToJSOptions);
    } catch (err) {
        props.style = {};
    }
}
/**
 * @constant {boolean}
 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
 */ var $887ef7e629bca856$var$PRESERVE_CUSTOM_ATTRIBUTES = $bh6RR.version.split('.')[0] >= 16;
// Taken from
// https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
var $887ef7e629bca856$var$elementsWithNoTextChildren = new Set([
    'tr',
    'tbody',
    'thead',
    'tfoot',
    'colgroup',
    'table',
    'head',
    'html',
    'frameset'
]);
/**
 * Checks if the given node can contain text nodes
 *
 * @param {DomElement} node - Node.
 * @returns - Whether node can contain text nodes.
 */ function $887ef7e629bca856$var$canTextBeChildOfNode(node) {
    return !$887ef7e629bca856$var$elementsWithNoTextChildren.has(node.name);
}
$887ef7e629bca856$exports = {
    PRESERVE_CUSTOM_ATTRIBUTES: $887ef7e629bca856$var$PRESERVE_CUSTOM_ATTRIBUTES,
    invertObject: $887ef7e629bca856$var$invertObject,
    isCustomComponent: $887ef7e629bca856$var$isCustomComponent,
    setStyleProp: $887ef7e629bca856$var$setStyleProp,
    canTextBeChildOfNode: $887ef7e629bca856$var$canTextBeChildOfNode,
    elementsWithNoTextChildren: $887ef7e629bca856$var$elementsWithNoTextChildren
};


/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param {object} [attributes={}] - HTML/SVG DOM attributes.
 * @returns - React props.
 */ $fa2869eaa022a51e$exports = function attributesToProps(attributes) {
    attributes = attributes || {};
    var valueOnlyInputs = {
        reset: true,
        submit: true
    };
    var attributeName;
    var attributeNameLowerCased;
    var attributeValue;
    var propName;
    var propertyInfo;
    var props = {};
    var inputIsValueOnly = attributes.type && valueOnlyInputs[attributes.type];
    for(attributeName in attributes){
        attributeValue = attributes[attributeName];
        // ARIA (aria-*) or custom data (data-*) attribute
        if ($1cd97b80a9ac6ef3$exports.isCustomAttribute(attributeName)) {
            props[attributeName] = attributeValue;
            continue;
        }
        // convert HTML/SVG attribute to React prop
        attributeNameLowerCased = attributeName.toLowerCase();
        propName = $fa2869eaa022a51e$var$getPropName(attributeNameLowerCased);
        if (propName) {
            propertyInfo = $1cd97b80a9ac6ef3$exports.getPropertyInfo(propName);
            // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
            // https://reactjs.org/docs/uncontrolled-components.html
            if ((propName === 'checked' || propName === 'value') && !inputIsValueOnly) propName = $fa2869eaa022a51e$var$getPropName('default' + attributeNameLowerCased);
            props[propName] = attributeValue;
            switch(propertyInfo && propertyInfo.type){
                case $1cd97b80a9ac6ef3$exports.BOOLEAN:
                    props[propName] = true;
                    break;
                case $1cd97b80a9ac6ef3$exports.OVERLOADED_BOOLEAN:
                    if (attributeValue === '') props[propName] = true;
                    break;
            }
            continue;
        }
        // preserve custom attribute if React >=16
        if ($887ef7e629bca856$exports.PRESERVE_CUSTOM_ATTRIBUTES) props[attributeName] = attributeValue;
    }
    // transform inline style to object
    $887ef7e629bca856$exports.setStyleProp(attributes.style, props);
    return props;
};
/**
 * Gets prop name from lowercased attribute name.
 *
 * @param {string} attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */ function $fa2869eaa022a51e$var$getPropName(attributeName) {
    return $1cd97b80a9ac6ef3$exports.possibleStandardNames[attributeName];
}



var $6ef2adab05030e62$var$setStyleProp = $887ef7e629bca856$exports.setStyleProp;
var $6ef2adab05030e62$var$canTextBeChildOfNode = $887ef7e629bca856$exports.canTextBeChildOfNode;
/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param {DomElement[]} nodes - DOM nodes.
 * @param {object} [options={}] - Options.
 * @param {Function} [options.replace] - Replacer.
 * @param {object} [options.library] - Library (React, Preact, etc.).
 * @returns - String or JSX element(s).
 */ function $6ef2adab05030e62$var$domToReact(nodes, options) {
    options = options || {};
    var library = options.library || $bh6RR;
    var cloneElement = library.cloneElement;
    var createElement = library.createElement;
    var isValidElement = library.isValidElement;
    var result = [];
    var node;
    var isWhitespace;
    var hasReplace = typeof options.replace === 'function';
    var replaceElement;
    var props;
    var children;
    var trim = options.trim;
    for(var i = 0, len = nodes.length; i < len; i++){
        node = nodes[i];
        // replace with custom React element (if present)
        if (hasReplace) {
            replaceElement = options.replace(node);
            if (isValidElement(replaceElement)) {
                // set "key" prop for sibling elements
                // https://fb.me/react-warning-keys
                if (len > 1) replaceElement = cloneElement(replaceElement, {
                    key: replaceElement.key || i
                });
                result.push(replaceElement);
                continue;
            }
        }
        if (node.type === 'text') {
            isWhitespace = !node.data.trim().length;
            if (isWhitespace && node.parent && !$6ef2adab05030e62$var$canTextBeChildOfNode(node.parent)) continue;
            if (trim && isWhitespace) continue;
            // We have a text node that's not whitespace and it can be nested
            // in its parent so add it to the results
            result.push(node.data);
            continue;
        }
        props = node.attribs;
        if ($6ef2adab05030e62$var$skipAttributesToProps(node)) $6ef2adab05030e62$var$setStyleProp(props.style, props);
        else if (props) props = $fa2869eaa022a51e$exports(props);
        children = null;
        switch(node.type){
            case 'script':
            case 'style':
                // prevent text in <script> or <style> from being escaped
                // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
                if (node.children[0]) props.dangerouslySetInnerHTML = {
                    __html: node.children[0].data
                };
                break;
            case 'tag':
                // setting textarea value in children is an antipattern in React
                // https://reactjs.org/docs/forms.html#the-textarea-tag
                if (node.name === 'textarea' && node.children[0]) props.defaultValue = node.children[0].data;
                else if (node.children && node.children.length) // continue recursion of creating React elements (if applicable)
                children = $6ef2adab05030e62$var$domToReact(node.children, options);
                break;
            // skip all other cases (e.g., comment)
            default:
                continue;
        }
        // set "key" prop for sibling elements
        // https://fb.me/react-warning-keys
        if (len > 1) props.key = i;
        result.push(createElement(node.name, props, children));
    }
    return result.length === 1 ? result[0] : result;
}
/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param {DomElement} node
 * @returns - Whether node attributes should be converted to props.
 */ function $6ef2adab05030e62$var$skipAttributesToProps(node) {
    return $887ef7e629bca856$exports.PRESERVE_CUSTOM_ATTRIBUTES && node.type === 'tag' && $887ef7e629bca856$exports.isCustomComponent(node.name, node.attribs);
}
$6ef2adab05030e62$exports = $6ef2adab05030e62$var$domToReact;



var $2dd2d54ea367c092$exports = {};

$parcel$defineInteropFlag($2dd2d54ea367c092$exports);

$parcel$export($2dd2d54ea367c092$exports, "default", function () { return $2dd2d54ea367c092$export$2e2bcd8739ae039; });
var $36f72b56fe4758b8$exports = {};
var $660594adf3fa1621$exports = {};
// constants
var $660594adf3fa1621$var$HTML = 'html';
var $660594adf3fa1621$var$HEAD = 'head';
var $660594adf3fa1621$var$BODY = 'body';
var $660594adf3fa1621$var$FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
var $660594adf3fa1621$var$HEAD_TAG_REGEX = /<head.*>/i;
var $660594adf3fa1621$var$BODY_TAG_REGEX = /<body.*>/i;
// falls back to `parseFromString` if `createHTMLDocument` cannot be used
var $660594adf3fa1621$var$parseFromDocument = function() {
    throw new Error('This browser does not support `document.implementation.createHTMLDocument`');
};
var $660594adf3fa1621$var$parseFromString = function() {
    throw new Error('This browser does not support `DOMParser.prototype.parseFromString`');
};
/**
 * DOMParser (performance: slow).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */ if (typeof window.DOMParser === 'function') {
    var $660594adf3fa1621$var$domParser = new window.DOMParser();
    var $660594adf3fa1621$var$mimeType = 'text/html';
    /**
   * Creates an HTML document using `DOMParser.parseFromString`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */ $660594adf3fa1621$var$parseFromString = function(html, tagName) {
        if (tagName) html = '<' + tagName + '>' + html + '</' + tagName + '>';
        return $660594adf3fa1621$var$domParser.parseFromString(html, $660594adf3fa1621$var$mimeType);
    };
    $660594adf3fa1621$var$parseFromDocument = $660594adf3fa1621$var$parseFromString;
}

/**
 * DOMImplementation (performance: fair).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */ if (document.implementation) {
    var $660594adf3fa1621$var$isIE = (parcelRequire("8b6Fd")).isIE;
    // title parameter is required in IE
    // https://msdn.microsoft.com/en-us/library/ff975457(v=vs.85).aspx
    var $660594adf3fa1621$var$doc = document.implementation.createHTMLDocument($660594adf3fa1621$var$isIE() ? 'html-dom-parser' : undefined);
    /**
   * Use HTML document created by `document.implementation.createHTMLDocument`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */ $660594adf3fa1621$var$parseFromDocument = function(html, tagName) {
        if (tagName) {
            $660594adf3fa1621$var$doc.documentElement.getElementsByTagName(tagName)[0].innerHTML = html;
            return $660594adf3fa1621$var$doc;
        }
        $660594adf3fa1621$var$doc.documentElement.innerHTML = html;
        return $660594adf3fa1621$var$doc;
    };
}
/**
 * Template (performance: fast).
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
 */ var $660594adf3fa1621$var$template = document.createElement('template');
var $660594adf3fa1621$var$parseFromTemplate;
if ($660594adf3fa1621$var$template.content) /**
   * Uses a template element (content fragment) to parse HTML.
   *
   * @param  {string} html - The HTML string.
   * @return {NodeList}
   */ $660594adf3fa1621$var$parseFromTemplate = function(html) {
    $660594adf3fa1621$var$template.innerHTML = html;
    return $660594adf3fa1621$var$template.content.childNodes;
};
/**
 * Parses HTML string to DOM nodes.
 *
 * @param  {string}   html - HTML markup.
 * @return {NodeList}
 */ function $660594adf3fa1621$var$domparser(html) {
    var firstTagName;
    var match = html.match($660594adf3fa1621$var$FIRST_TAG_REGEX);
    if (match && match[1]) firstTagName = match[1].toLowerCase();
    var doc;
    var element;
    var elements;
    switch(firstTagName){
        case $660594adf3fa1621$var$HTML:
            doc = $660594adf3fa1621$var$parseFromString(html);
            // the created document may come with filler head/body elements,
            // so make sure to remove them if they don't actually exist
            if (!$660594adf3fa1621$var$HEAD_TAG_REGEX.test(html)) {
                element = doc.getElementsByTagName($660594adf3fa1621$var$HEAD)[0];
                if (element) element.parentNode.removeChild(element);
            }
            if (!$660594adf3fa1621$var$BODY_TAG_REGEX.test(html)) {
                element = doc.getElementsByTagName($660594adf3fa1621$var$BODY)[0];
                if (element) element.parentNode.removeChild(element);
            }
            return doc.getElementsByTagName($660594adf3fa1621$var$HTML);
        case $660594adf3fa1621$var$HEAD:
        case $660594adf3fa1621$var$BODY:
            elements = $660594adf3fa1621$var$parseFromDocument(html).getElementsByTagName(firstTagName);
            // if there's a sibling element, then return both elements
            if ($660594adf3fa1621$var$BODY_TAG_REGEX.test(html) && $660594adf3fa1621$var$HEAD_TAG_REGEX.test(html)) return elements[0].parentNode.childNodes;
            return elements;
        // low-level tag or text
        default:
            if ($660594adf3fa1621$var$parseFromTemplate) return $660594adf3fa1621$var$parseFromTemplate(html);
            return $660594adf3fa1621$var$parseFromDocument(html, $660594adf3fa1621$var$BODY).getElementsByTagName($660594adf3fa1621$var$BODY)[0].childNodes;
    }
}
$660594adf3fa1621$exports = $660594adf3fa1621$var$domparser;



var $8b6Fd = parcelRequire("8b6Fd");
var $36f72b56fe4758b8$require$formatDOM = $8b6Fd.formatDOM;
var $36f72b56fe4758b8$var$DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
/**
 * Parses HTML string to DOM nodes in browser.
 *
 * @param  {string} html  - HTML markup.
 * @return {DomElement[]} - DOM elements.
 */ function $36f72b56fe4758b8$var$HTMLDOMParser(html) {
    if (typeof html !== 'string') throw new TypeError('First argument must be a string');
    if (html === '') return [];
    // match directive
    var match = html.match($36f72b56fe4758b8$var$DIRECTIVE_REGEX);
    var directive;
    if (match && match[1]) directive = match[1];
    return $36f72b56fe4758b8$require$formatDOM($660594adf3fa1621$exports(html), null, directive);
}
$36f72b56fe4758b8$exports = $36f72b56fe4758b8$var$HTMLDOMParser;


var $2dd2d54ea367c092$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($36f72b56fe4758b8$exports)));


var $135ea95dbedf029f$require$htmlToDOM = $2dd2d54ea367c092$exports;
// support backwards compatibility for ES Module
$135ea95dbedf029f$require$htmlToDOM = /* istanbul ignore next */ typeof $135ea95dbedf029f$require$htmlToDOM.default === 'function' ? $135ea95dbedf029f$require$htmlToDOM.default : $135ea95dbedf029f$require$htmlToDOM;
var $135ea95dbedf029f$var$domParserOptions = {
    lowerCaseAttributeNames: false
};
/**
 * Converts HTML string to React elements.
 *
 * @param {string} html - HTML string.
 * @param {object} [options] - Parser options.
 * @param {object} [options.htmlparser2] - htmlparser2 options.
 * @param {object} [options.library] - Library for React, Preact, etc.
 * @param {Function} [options.replace] - Replace method.
 * @returns {JSX.Element|JSX.Element[]|string} - React element(s), empty array, or string.
 */ function $135ea95dbedf029f$var$HTMLReactParser(html, options) {
    if (typeof html !== 'string') throw new TypeError('First argument must be a string');
    if (html === '') return [];
    options = options || {};
    return $6ef2adab05030e62$exports($135ea95dbedf029f$require$htmlToDOM(html, options.htmlparser2 || $135ea95dbedf029f$var$domParserOptions), options);
}
$135ea95dbedf029f$var$HTMLReactParser.domToReact = $6ef2adab05030e62$exports;
$135ea95dbedf029f$var$HTMLReactParser.htmlToDOM = $135ea95dbedf029f$require$htmlToDOM;
$135ea95dbedf029f$var$HTMLReactParser.attributesToProps = $fa2869eaa022a51e$exports;

$135ea95dbedf029f$var$HTMLReactParser.Element = (parcelRequire("bjmdp")).Element;
// support CommonJS and ES Modules
$135ea95dbedf029f$exports = $135ea95dbedf029f$var$HTMLReactParser;
$135ea95dbedf029f$exports.default = $135ea95dbedf029f$var$HTMLReactParser;


var $1b12927fbd2f3766$export$562c76a291853ae = (0, (/*@__PURE__*/$parcel$interopDefault($135ea95dbedf029f$exports))).domToReact;
var $1b12927fbd2f3766$export$131c6d55a47cefc8 = (0, (/*@__PURE__*/$parcel$interopDefault($135ea95dbedf029f$exports))).htmlToDOM;
var $1b12927fbd2f3766$export$af8e902ee50b21fc = (0, (/*@__PURE__*/$parcel$interopDefault($135ea95dbedf029f$exports))).attributesToProps;
var $1b12927fbd2f3766$export$db77ccec0bb4ccac = (0, (/*@__PURE__*/$parcel$interopDefault($135ea95dbedf029f$exports))).Element;
var $1b12927fbd2f3766$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($135ea95dbedf029f$exports)));




function $e62300a3d8f0a2a2$export$2e2bcd8739ae039(props) {
    if (!props.enc) return '';
    let enc = props.enc;
    let enemyTypes = enc.enemyTypes;
    let options = {
        sortBy: 'xp',
        hideHeader: true
    };
    let contents = enemyTypes.map((type)=>{
        let doc = (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).calculateAllXp(type.doc);
        if (!doc) return '';
        if ((0, $84a70a24242fb815$export$2e2bcd8739ae039)(doc)) return '';
        if (!type.entity) return '';
        options.includeEntities = type.entity.name + ",,";
        let format = (0, $712be45d7780c927$export$2e2bcd8739ae039);
        // let content = EntityCards(doc, options, format);
        let content = (0, $41374fe20d442493$export$2e2bcd8739ae039)(doc, options, format);
        // console.log(content)
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            children: (0, $1b12927fbd2f3766$export$2e2bcd8739ae039)(content)
        }, type.entity._id);
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "statblocks",
        children: contents
    });
}


function $9ffbd34428bea187$export$2e2bcd8739ae039(props) {
    let campaign = props.campaign;
    let enc = props.enc;
    let attemptRenameEncounter = props.attemptRenameEncounter;
    let attemptDeleteEncounter = props.attemptDeleteEncounter;
    let addPc = props.addPc;
    let addEnemy = props.addEnemy;
    let setEncounterNote = props.setEncounterNote;
    let setEncounterLink = props.setEncounterLink;
    (0, $bh6RR.useEffect)(()=>{
        let noteFields = document.getElementsByClassName('notes');
        Array.from(noteFields).forEach((field)=>{
            field.style.height = 'auto';
            field.style.height = field.scrollHeight + 3 + "px";
            field.addEventListener('input', (e)=>{
                e.target.style.height = 'auto';
                e.target.style.height = e.target.scrollHeight + 3 + "px";
            });
        });
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "desktop encounter",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h3", {
                children: [
                    !!enc && !!enc.percentages && !!enc.percentages.diff && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        title: enc.percentages.diff,
                        children: enc.percentages.stars
                    }),
                    !!enc && enc.name,
                    !!enc && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        className: "hidden",
                        children: [
                            "\xa0",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                "data-oldname": enc.name,
                                "data-encounterid": enc._id,
                                onClick: attemptRenameEncounter,
                                children: "\u270F\uFE0F Rename"
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                className: "delete",
                                "data-encounterid": enc._id,
                                onClick: attemptDeleteEncounter,
                                children: "x"
                            })
                        ]
                    })
                ]
            }),
            !!enc && !!enc.link && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("a", {
                        href: enc.link,
                        children: [
                            "\uD83D\uDD17",
                            enc.link
                        ]
                    }),
                    "- ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        onClick: setEncounterLink,
                        "data-encounterid": enc._id,
                        children: "\u270F\uFE0F edit notes link"
                    })
                ]
            }),
            !!enc && !enc.link && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                onClick: setEncounterLink,
                "data-encounterid": enc._id,
                children: "\uD83D\uDD17 add notes link"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("textarea", {
                placeholder: "encounter notes",
                className: "notes",
                "data-encounterid": enc._id,
                defaultValue: enc.notes || "",
                onBlur: setEncounterNote
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f8e47597d7573fb$export$2e2bcd8739ae039), {
                enc: enc
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: "PC Name"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                    children: [
                                        "XP: ",
                                        enc.pcxp.toLocaleString()
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: "Quantity"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: "Delete"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                        children: [
                            enc.pcs.map((pc)=>{
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06b9cd0ec60852b2$export$2e2bcd8739ae039), {
                                    pc: pc,
                                    enc: enc,
                                    setPcName: props.setPcName,
                                    setPcXp: props.setPcXp,
                                    setPcQty: props.setPcQty,
                                    deletePc: props.deletePc
                                }, pc._id);
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    colSpan: 4,
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: addPc,
                                        "data-encounterid": enc._id,
                                        children: "Add new PC"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: "Doc"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: "Enemy"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: "Qty"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: "XP Each"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                    children: [
                                        "XP: ",
                                        enc.enxp.toLocaleString()
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: "Delete"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                        children: [
                            enc.enemyTypes.map((enemy)=>{
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $68928360f2cc7dd3$export$2e2bcd8739ae039), {
                                    enemy: enemy,
                                    enc: enc,
                                    campaign: campaign,
                                    setEnemyDoc: props.setEnemyDoc,
                                    setEnemyEntity: props.setEnemyEntity,
                                    setEnemyQuantity: props.setEnemyQuantity,
                                    deleteEnemy: props.deleteEnemy
                                }, enemy._id);
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    colSpan: 6,
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: addEnemy,
                                        "data-encounterid": enc._id,
                                        children: "Add new enemy"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e62300a3d8f0a2a2$export$2e2bcd8739ae039), {
                enc: enc
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff3467bccb224523$export$2e2bcd8739ae039), {
                enc: enc,
                toggleBox: props.toggleBox
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "floatblock"
            })
        ]
    });
}







function $f577e561b4088924$export$2e2bcd8739ae039(props) {
    let enemy = props.enemy;
    let enc = props.enc;
    let xp = enemy.entity?.xp || 0;
    let quantity = enemy.quantity || 0;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
        className: "enli",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                    children: [
                        "Enemy Type\xa0",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            className: "delete",
                            "data-encounterid": enc._id,
                            "data-enemyid": enemy._id,
                            onClick: props.deleteEnemy,
                            children: "x"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                        children: [
                            "Doc:",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                                "data-encounterid": enc._id,
                                "data-enemyid": enemy._id,
                                value: enemy.docId || "",
                                onChange: props.setEnemyDoc,
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                        value: "",
                                        children: "none"
                                    }),
                                    props.campaign.docs.map((doc)=>{
                                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                            value: doc._id,
                                            children: doc.name
                                        }, doc._id);
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                        children: [
                            "Entity:",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3d420ddc148c09dc$export$2e2bcd8739ae039), {
                                campaign: props.campaign,
                                enc: props.enc,
                                enemy: props.enemy,
                                setEnemyEntity: props.setEnemyEntity
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                        children: [
                            "Quantity:\xa0",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                type: "number",
                                step: 1,
                                min: 0,
                                value: quantity,
                                "data-encounterid": enc._id,
                                "data-enemyid": enemy._id,
                                onChange: props.setEnemyQuantity
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                    children: [
                        "XP Each: ",
                        xp?.toLocaleString()
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                    children: [
                        "XP Subtotal: ",
                        enemy.xp?.toLocaleString()
                    ]
                })
            ]
        })
    });
}




var $bh6RR = parcelRequire("bh6RR");

function $4ed7e73c38acab0b$export$2e2bcd8739ae039(props) {
    let campaign = props.campaign;
    let enc = props.enc;
    let attemptRenameEncounter = props.attemptRenameEncounter;
    let attemptDeleteEncounter = props.attemptDeleteEncounter;
    let addPc = props.addPc;
    let addEnemy = props.addEnemy;
    let setEncounterNote = props.setEncounterNote;
    let setEncounterLink = props.setEncounterLink;
    (0, $bh6RR.useEffect)(()=>{
        let noteFields = document.getElementsByClassName('notes');
        Array.from(noteFields).forEach((field)=>{
            field.style.height = 'auto';
            field.style.height = field.scrollHeight + 3 + "px";
            field.addEventListener('input', (e)=>{
                e.target.style.height = 'auto';
                e.target.style.height = e.target.scrollHeight + 3 + "px";
            });
        });
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "mobile encounter",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h3", {
                children: [
                    !!enc && !!enc.percentages.diff && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        title: enc.percentages.diff,
                        children: enc.percentages.stars
                    }),
                    !!enc && enc.name,
                    !!enc && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        className: "hidden",
                        children: [
                            "\xa0",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                "data-oldname": enc.name,
                                "data-encounterid": enc._id,
                                onClick: attemptRenameEncounter,
                                children: "\u270F\uFE0F Rename"
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                className: "delete",
                                "data-encounterid": enc._id,
                                onClick: attemptDeleteEncounter,
                                children: "x"
                            })
                        ]
                    })
                ]
            }),
            !!enc && !!enc.link && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("a", {
                        href: enc.link,
                        children: [
                            "\uD83D\uDD17",
                            enc.link
                        ]
                    }),
                    "- ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        onClick: setEncounterLink,
                        "data-encounterid": enc._id,
                        children: "\u270F\uFE0F edit notes link"
                    })
                ]
            }),
            !!enc && !enc.link && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                onClick: setEncounterLink,
                "data-encounterid": enc._id,
                children: "\uD83D\uDD17 add notes link"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("textarea", {
                placeholder: "encounter notes",
                className: "notes",
                "data-encounterid": enc._id,
                defaultValue: enc.notes || "",
                onBlur: setEncounterNote
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f8e47597d7573fb$export$2e2bcd8739ae039), {
                enc: enc
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: "PC Name"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                    children: [
                                        "XP: ",
                                        enc.pcxp.toLocaleString()
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: "Qty"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: "\u274C"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                        children: [
                            enc.pcs.map((pc)=>{
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06b9cd0ec60852b2$export$2e2bcd8739ae039), {
                                    pc: pc,
                                    enc: enc,
                                    setPcName: props.setPcName,
                                    setPcXp: props.setPcXp,
                                    setPcQty: props.setPcQty,
                                    deletePc: props.deletePc
                                }, pc._id);
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    colSpan: 4,
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: addPc,
                                        "data-encounterid": enc._id,
                                        children: "Add new PC"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h4", {
                            children: [
                                "Enemy XP: ",
                                enc.enxp.toLocaleString()
                            ]
                        })
                    }),
                    enc.enemyTypes.map((enemy)=>{
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f577e561b4088924$export$2e2bcd8739ae039), {
                            enemy: enemy,
                            enc: enc,
                            campaign: campaign,
                            setEnemyDoc: props.setEnemyDoc,
                            setEnemyEntity: props.setEnemyEntity,
                            setEnemyQuantity: props.setEnemyQuantity,
                            deleteEnemy: props.deleteEnemy
                        }, enemy._id);
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            onClick: addEnemy,
                            "data-encounterid": enc._id,
                            children: "Add new enemy"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e62300a3d8f0a2a2$export$2e2bcd8739ae039), {
                enc: enc
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff3467bccb224523$export$2e2bcd8739ae039), {
                enc: enc,
                toggleBox: props.toggleBox
            })
        ]
    });
}


function $937a0acd9cd30227$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var $937a0acd9cd30227$var$byteLength_1 = $937a0acd9cd30227$var$byteLength;
var $937a0acd9cd30227$var$toByteArray_1 = $937a0acd9cd30227$var$toByteArray;
var $937a0acd9cd30227$var$fromByteArray_1 = $937a0acd9cd30227$var$fromByteArray;
var $937a0acd9cd30227$var$lookup = [];
var $937a0acd9cd30227$var$revLookup = [];
var $937a0acd9cd30227$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $937a0acd9cd30227$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $937a0acd9cd30227$var$i = 0, $937a0acd9cd30227$var$len = $937a0acd9cd30227$var$code.length; $937a0acd9cd30227$var$i < $937a0acd9cd30227$var$len; ++$937a0acd9cd30227$var$i){
    $937a0acd9cd30227$var$lookup[$937a0acd9cd30227$var$i] = $937a0acd9cd30227$var$code[$937a0acd9cd30227$var$i];
    $937a0acd9cd30227$var$revLookup[$937a0acd9cd30227$var$code.charCodeAt($937a0acd9cd30227$var$i)] = $937a0acd9cd30227$var$i;
} // Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$937a0acd9cd30227$var$revLookup['-'.charCodeAt(0)] = 62;
$937a0acd9cd30227$var$revLookup['_'.charCodeAt(0)] = 63;
function $937a0acd9cd30227$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
     // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
} // base64 is 4/3 + up to two characters of the original data
function $937a0acd9cd30227$var$byteLength(b64) {
    var lens = $937a0acd9cd30227$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $937a0acd9cd30227$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $937a0acd9cd30227$var$toByteArray(b64) {
    var tmp;
    var lens = $937a0acd9cd30227$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $937a0acd9cd30227$var$Arr($937a0acd9cd30227$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0; // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $937a0acd9cd30227$var$revLookup[b64.charCodeAt(i)] << 18 | $937a0acd9cd30227$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $937a0acd9cd30227$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $937a0acd9cd30227$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $937a0acd9cd30227$var$revLookup[b64.charCodeAt(i)] << 2 | $937a0acd9cd30227$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $937a0acd9cd30227$var$revLookup[b64.charCodeAt(i)] << 10 | $937a0acd9cd30227$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $937a0acd9cd30227$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $937a0acd9cd30227$var$tripletToBase64(num) {
    return $937a0acd9cd30227$var$lookup[num >> 18 & 0x3F] + $937a0acd9cd30227$var$lookup[num >> 12 & 0x3F] + $937a0acd9cd30227$var$lookup[num >> 6 & 0x3F] + $937a0acd9cd30227$var$lookup[num & 0x3F];
}
function $937a0acd9cd30227$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($937a0acd9cd30227$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $937a0acd9cd30227$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($937a0acd9cd30227$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
     // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($937a0acd9cd30227$var$lookup[tmp >> 2] + $937a0acd9cd30227$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($937a0acd9cd30227$var$lookup[tmp >> 10] + $937a0acd9cd30227$var$lookup[tmp >> 4 & 0x3F] + $937a0acd9cd30227$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}
var $937a0acd9cd30227$var$base64Js = {
    byteLength: $937a0acd9cd30227$var$byteLength_1,
    toByteArray: $937a0acd9cd30227$var$toByteArray_1,
    fromByteArray: $937a0acd9cd30227$var$fromByteArray_1
};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $937a0acd9cd30227$var$read = function read(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
var $937a0acd9cd30227$var$write = function write(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};
var $937a0acd9cd30227$var$ieee754 = {
    read: $937a0acd9cd30227$var$read,
    write: $937a0acd9cd30227$var$write
};
var $937a0acd9cd30227$var$buffer$1 = $937a0acd9cd30227$var$createCommonjsModule(function(module, exports) {
    var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
     : null;
    exports.Buffer = Buffer;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    var K_MAX_LENGTH = 0x7fffffff;
    exports.kMaxLength = K_MAX_LENGTH;
    /**
   * If `Buffer.TYPED_ARRAY_SUPPORT`:
   *   === true    Use Uint8Array implementation (fastest)
   *   === false   Print warning and recommend using `buffer` v4.x which has an Object
   *               implementation (most compatible, even IE6)
   *
   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
   * Opera 11.6+, iOS 4.2+.
   *
   * We report that the browser does not support typed arrays if the are not subclassable
   * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
   * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
   * for __proto__ and has a buggy typed array implementation.
   */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    function typedArraySupport() {
        // Can typed array instances can be augmented?
        try {
            var arr = new Uint8Array(1);
            var proto = {
                foo: function foo() {
                    return 42;
                }
            };
            Object.setPrototypeOf(proto, Uint8Array.prototype);
            Object.setPrototypeOf(arr, proto);
            return arr.foo() === 42;
        } catch (e) {
            return false;
        }
    }
    Object.defineProperty(Buffer.prototype, 'parent', {
        enumerable: true,
        get: function get() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.buffer;
        }
    });
    Object.defineProperty(Buffer.prototype, 'offset', {
        enumerable: true,
        get: function get() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.byteOffset;
        }
    });
    function createBuffer(length) {
        if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
         // Return an augmented `Uint8Array` instance
        var buf = new Uint8Array(length);
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    /**
   * The Buffer constructor returns instances of `Uint8Array` that have their
   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
   * returns a single octet.
   *
   * The `Uint8Array` prototype remains unmodified.
   */ function Buffer(arg, encodingOrOffset, length) {
        // Common case.
        if (typeof arg === 'number') {
            if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
            return allocUnsafe(arg);
        }
        return from(arg, encodingOrOffset, length);
    }
    Buffer.poolSize = 8192; // not used by this implementation
    function from(value, encodingOrOffset, length) {
        if (typeof value === 'string') return fromString(value, encodingOrOffset);
        if (ArrayBuffer.isView(value)) return fromArrayView(value);
        if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + babelHelpers["typeof"](value));
        if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
        var valueOf = value.valueOf && value.valueOf();
        if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
        var b = fromObject(value);
        if (b) return b;
        if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + babelHelpers["typeof"](value));
    }
    /**
   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
   * if value is a number.
   * Buffer.from(str[, encoding])
   * Buffer.from(array)
   * Buffer.from(buffer)
   * Buffer.from(arrayBuffer[, byteOffset[, length]])
   **/ Buffer.from = function(value, encodingOrOffset, length) {
        return from(value, encodingOrOffset, length);
    }; // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
    // https://github.com/feross/buffer/pull/148
    Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer, Uint8Array);
    function assertSize(size) {
        if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
        else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
    function alloc(size, fill, encoding) {
        assertSize(size);
        if (size <= 0) return createBuffer(size);
        if (fill !== undefined) // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpreted as a start offset.
        return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
        return createBuffer(size);
    }
    /**
   * Creates a new filled Buffer instance.
   * alloc(size[, fill[, encoding]])
   **/ Buffer.alloc = function(size, fill, encoding) {
        return alloc(size, fill, encoding);
    };
    function allocUnsafe(size) {
        assertSize(size);
        return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    /**
   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
   * */ Buffer.allocUnsafe = function(size) {
        return allocUnsafe(size);
    };
    /**
   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
   */ Buffer.allocUnsafeSlow = function(size) {
        return allocUnsafe(size);
    };
    function fromString(string, encoding) {
        if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
        if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        var length = byteLength(string, encoding) | 0;
        var buf = createBuffer(length);
        var actual = buf.write(string, encoding);
        if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        buf = buf.slice(0, actual);
        return buf;
    }
    function fromArrayLike(array) {
        var length = array.length < 0 ? 0 : checked(array.length) | 0;
        var buf = createBuffer(length);
        for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
        return buf;
    }
    function fromArrayView(arrayView) {
        if (isInstance(arrayView, Uint8Array)) {
            var copy = new Uint8Array(arrayView);
            return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
        }
        return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length) {
        if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
        if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
        var buf;
        if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
        else if (length === undefined) buf = new Uint8Array(array, byteOffset);
        else buf = new Uint8Array(array, byteOffset, length);
         // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    function fromObject(obj) {
        if (Buffer.isBuffer(obj)) {
            var len = checked(obj.length) | 0;
            var buf = createBuffer(len);
            if (buf.length === 0) return buf;
            obj.copy(buf, 0, 0, len);
            return buf;
        }
        if (obj.length !== undefined) {
            if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
            return fromArrayLike(obj);
        }
        if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
    }
    function checked(length) {
        // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
        // length is NaN (which is otherwise coerced to zero.)
        if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
        return length | 0;
    }
    function SlowBuffer(length) {
        if (+length != length) // eslint-disable-line eqeqeq
        length = 0;
        return Buffer.alloc(+length);
    }
    Buffer.isBuffer = function isBuffer(b) {
        return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
    };
    Buffer.compare = function compare(a, b) {
        if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
        if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
        if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
        if (a === b) return 0;
        var x = a.length;
        var y = b.length;
        for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    Buffer.isEncoding = function isEncoding(encoding) {
        switch(String(encoding).toLowerCase()){
            case 'hex':
            case 'utf8':
            case 'utf-8':
            case 'ascii':
            case 'latin1':
            case 'binary':
            case 'base64':
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return true;
            default:
                return false;
        }
    };
    Buffer.concat = function concat(list, length) {
        if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (list.length === 0) return Buffer.alloc(0);
        var i;
        if (length === undefined) {
            length = 0;
            for(i = 0; i < list.length; ++i)length += list[i].length;
        }
        var buffer = Buffer.allocUnsafe(length);
        var pos = 0;
        for(i = 0; i < list.length; ++i){
            var buf = list[i];
            if (isInstance(buf, Uint8Array)) {
                if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
                else Uint8Array.prototype.set.call(buffer, buf, pos);
            } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
            else buf.copy(buffer, pos);
            pos += buf.length;
        }
        return buffer;
    };
    function byteLength(string, encoding) {
        if (Buffer.isBuffer(string)) return string.length;
        if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
        if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + babelHelpers["typeof"](string));
        var len = string.length;
        var mustMatch = arguments.length > 2 && arguments[2] === true;
        if (!mustMatch && len === 0) return 0; // Use a for loop to avoid recursion
        var loweredCase = false;
        for(;;)switch(encoding){
            case 'ascii':
            case 'latin1':
            case 'binary':
                return len;
            case 'utf8':
            case 'utf-8':
                return utf8ToBytes(string).length;
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return len * 2;
            case 'hex':
                return len >>> 1;
            case 'base64':
                return base64ToBytes(string).length;
            default:
                if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
                encoding = ('' + encoding).toLowerCase();
                loweredCase = true;
        }
    }
    Buffer.byteLength = byteLength;
    function slowToString(encoding, start, end) {
        var loweredCase = false; // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
        // property of a typed array.
        // This behaves neither like String nor Uint8Array in that we set start/end
        // to their upper/lower bounds if the value passed is out of range.
        // undefined is handled specially as per ECMA-262 6th Edition,
        // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
        if (start === undefined || start < 0) start = 0;
         // Return early if start > this.length. Done here to prevent potential uint32
        // coercion fail below.
        if (start > this.length) return '';
        if (end === undefined || end > this.length) end = this.length;
        if (end <= 0) return '';
         // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
        end >>>= 0;
        start >>>= 0;
        if (end <= start) return '';
        if (!encoding) encoding = 'utf8';
        while(true)switch(encoding){
            case 'hex':
                return hexSlice(this, start, end);
            case 'utf8':
            case 'utf-8':
                return utf8Slice(this, start, end);
            case 'ascii':
                return asciiSlice(this, start, end);
            case 'latin1':
            case 'binary':
                return latin1Slice(this, start, end);
            case 'base64':
                return base64Slice(this, start, end);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return utf16leSlice(this, start, end);
            default:
                if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                encoding = (encoding + '').toLowerCase();
                loweredCase = true;
        }
    } // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
    // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
    // reliably in a browserify context because there could be multiple different
    // copies of the 'buffer' package in use. This method works even for Buffer
    // instances that were created from another copy of the `buffer` package.
    // See: https://github.com/feross/buffer/issues/154
    Buffer.prototype._isBuffer = true;
    function swap(b, n, m) {
        var i = b[n];
        b[n] = b[m];
        b[m] = i;
    }
    Buffer.prototype.swap16 = function swap16() {
        var len = this.length;
        if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
        for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
        return this;
    };
    Buffer.prototype.swap32 = function swap32() {
        var len = this.length;
        if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
        for(var i = 0; i < len; i += 4){
            swap(this, i, i + 3);
            swap(this, i + 1, i + 2);
        }
        return this;
    };
    Buffer.prototype.swap64 = function swap64() {
        var len = this.length;
        if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
        for(var i = 0; i < len; i += 8){
            swap(this, i, i + 7);
            swap(this, i + 1, i + 6);
            swap(this, i + 2, i + 5);
            swap(this, i + 3, i + 4);
        }
        return this;
    };
    Buffer.prototype.toString = function toString() {
        var length = this.length;
        if (length === 0) return '';
        if (arguments.length === 0) return utf8Slice(this, 0, length);
        return slowToString.apply(this, arguments);
    };
    Buffer.prototype.toLocaleString = Buffer.prototype.toString;
    Buffer.prototype.equals = function equals(b) {
        if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
        if (this === b) return true;
        return Buffer.compare(this, b) === 0;
    };
    Buffer.prototype.inspect = function inspect() {
        var str = '';
        var max = exports.INSPECT_MAX_BYTES;
        str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
        if (this.length > max) str += ' ... ';
        return '<Buffer ' + str + '>';
    };
    if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
    Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
        if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
        if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + babelHelpers["typeof"](target));
        if (start === undefined) start = 0;
        if (end === undefined) end = target ? target.length : 0;
        if (thisStart === undefined) thisStart = 0;
        if (thisEnd === undefined) thisEnd = this.length;
        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
        if (thisStart >= thisEnd && start >= end) return 0;
        if (thisStart >= thisEnd) return -1;
        if (start >= end) return 1;
        start >>>= 0;
        end >>>= 0;
        thisStart >>>= 0;
        thisEnd >>>= 0;
        if (this === target) return 0;
        var x = thisEnd - thisStart;
        var y = end - start;
        var len = Math.min(x, y);
        var thisCopy = this.slice(thisStart, thisEnd);
        var targetCopy = target.slice(start, end);
        for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    }; // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
        // Empty buffer means no match
        if (buffer.length === 0) return -1; // Normalize byteOffset
        if (typeof byteOffset === 'string') {
            encoding = byteOffset;
            byteOffset = 0;
        } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
        else if (byteOffset < -2147483648) byteOffset = -2147483648;
        byteOffset = +byteOffset; // Coerce to Number.
        if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : buffer.length - 1;
         // Normalize byteOffset: negative offsets start from the end of the buffer
        if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
        if (byteOffset >= buffer.length) {
            if (dir) return -1;
            else byteOffset = buffer.length - 1;
        } else if (byteOffset < 0) {
            if (dir) byteOffset = 0;
            else return -1;
        } // Normalize val
        if (typeof val === 'string') val = Buffer.from(val, encoding);
         // Finally, search either indexOf (if dir is true) or lastIndexOf
        if (Buffer.isBuffer(val)) {
            // Special case: looking for empty string/buffer always fails
            if (val.length === 0) return -1;
            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
        } else if (typeof val === 'number') {
            val = val & 0xFF; // Search for a byte value [0-255]
            if (typeof Uint8Array.prototype.indexOf === 'function') {
                if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
            return arrayIndexOf(buffer, [
                val
            ], byteOffset, encoding, dir);
        }
        throw new TypeError('val must be string, number or Buffer');
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
        var indexSize = 1;
        var arrLength = arr.length;
        var valLength = val.length;
        if (encoding !== undefined) {
            encoding = String(encoding).toLowerCase();
            if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
                if (arr.length < 2 || val.length < 2) return -1;
                indexSize = 2;
                arrLength /= 2;
                valLength /= 2;
                byteOffset /= 2;
            }
        }
        function read(buf, i) {
            if (indexSize === 1) return buf[i];
            else return buf.readUInt16BE(i * indexSize);
        }
        var i;
        if (dir) {
            var foundIndex = -1;
            for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1) foundIndex = i;
                if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
            } else {
                if (foundIndex !== -1) i -= i - foundIndex;
                foundIndex = -1;
            }
        } else {
            if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
            for(i = byteOffset; i >= 0; i--){
                var found = true;
                for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                }
                if (found) return i;
            }
        }
        return -1;
    }
    Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
        return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
        offset = Number(offset) || 0;
        var remaining = buf.length - offset;
        if (!length) length = remaining;
        else {
            length = Number(length);
            if (length > remaining) length = remaining;
        }
        var strLen = string.length;
        if (length > strLen / 2) length = strLen / 2;
        for(var i = 0; i < length; ++i){
            var parsed = parseInt(string.substr(i * 2, 2), 16);
            if (numberIsNaN(parsed)) return i;
            buf[offset + i] = parsed;
        }
        return i;
    }
    function utf8Write(buf, string, offset, length) {
        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
        return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function base64Write(buf, string, offset, length) {
        return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer.prototype.write = function write(string, offset, length, encoding) {
        // Buffer#write(string)
        if (offset === undefined) {
            encoding = 'utf8';
            length = this.length;
            offset = 0; // Buffer#write(string, encoding)
        } else if (length === undefined && typeof offset === 'string') {
            encoding = offset;
            length = this.length;
            offset = 0; // Buffer#write(string, offset[, length][, encoding])
        } else if (isFinite(offset)) {
            offset = offset >>> 0;
            if (isFinite(length)) {
                length = length >>> 0;
                if (encoding === undefined) encoding = 'utf8';
            } else {
                encoding = length;
                length = undefined;
            }
        } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
        var remaining = this.length - offset;
        if (length === undefined || length > remaining) length = remaining;
        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
        if (!encoding) encoding = 'utf8';
        var loweredCase = false;
        for(;;)switch(encoding){
            case 'hex':
                return hexWrite(this, string, offset, length);
            case 'utf8':
            case 'utf-8':
                return utf8Write(this, string, offset, length);
            case 'ascii':
            case 'latin1':
            case 'binary':
                return asciiWrite(this, string, offset, length);
            case 'base64':
                // Warning: maxLength not taken into account in base64Write
                return base64Write(this, string, offset, length);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return ucs2Write(this, string, offset, length);
            default:
                if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                encoding = ('' + encoding).toLowerCase();
                loweredCase = true;
        }
    };
    Buffer.prototype.toJSON = function toJSON() {
        return {
            type: 'Buffer',
            data: Array.prototype.slice.call(this._arr || this, 0)
        };
    };
    function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) return $937a0acd9cd30227$var$base64Js.fromByteArray(buf);
        else return $937a0acd9cd30227$var$base64Js.fromByteArray(buf.slice(start, end));
    }
    function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        var res = [];
        var i = start;
        while(i < end){
            var firstByte = buf[i];
            var codePoint = null;
            var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
            if (i + bytesPerSequence <= end) {
                var secondByte, thirdByte, fourthByte, tempCodePoint;
                switch(bytesPerSequence){
                    case 1:
                        if (firstByte < 0x80) codePoint = firstByte;
                        break;
                    case 2:
                        secondByte = buf[i + 1];
                        if ((secondByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                            if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                        }
                        break;
                    case 3:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                        }
                        break;
                    case 4:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        fourthByte = buf[i + 3];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                        }
                }
            }
            if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xFFFD;
                bytesPerSequence = 1;
            } else if (codePoint > 0xFFFF) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000;
                res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                codePoint = 0xDC00 | codePoint & 0x3FF;
            }
            res.push(codePoint);
            i += bytesPerSequence;
        }
        return decodeCodePointsArray(res);
    } // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    var MAX_ARGUMENTS_LENGTH = 0x1000;
    function decodeCodePointsArray(codePoints) {
        var len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
         // Decode in chunks to avoid "call stack size exceeded".
        var res = '';
        var i = 0;
        while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
        return res;
    }
    function asciiSlice(buf, start, end) {
        var ret = '';
        end = Math.min(buf.length, end);
        for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
        return ret;
    }
    function latin1Slice(buf, start, end) {
        var ret = '';
        end = Math.min(buf.length, end);
        for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
        return ret;
    }
    function hexSlice(buf, start, end) {
        var len = buf.length;
        if (!start || start < 0) start = 0;
        if (!end || end < 0 || end > len) end = len;
        var out = '';
        for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
        return out;
    }
    function utf16leSlice(buf, start, end) {
        var bytes = buf.slice(start, end);
        var res = ''; // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
        for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
        return res;
    }
    Buffer.prototype.slice = function slice(start, end) {
        var len = this.length;
        start = ~~start;
        end = end === undefined ? len : ~~end;
        if (start < 0) {
            start += len;
            if (start < 0) start = 0;
        } else if (start > len) start = len;
        if (end < 0) {
            end += len;
            if (end < 0) end = 0;
        } else if (end > len) end = len;
        if (end < start) end = start;
        var newBuf = this.subarray(start, end); // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(newBuf, Buffer.prototype);
        return newBuf;
    };
    /*
   * Need to make sure that buffer isn't trying to write out of bounds.
   */ function checkOffset(offset, ext, length) {
        if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
        if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
    }
    Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset];
        var mul = 1;
        var i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        return val;
    };
    Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset + --byteLength];
        var mul = 1;
        while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
        return val;
    };
    Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        return this[offset];
    };
    Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
    };
    Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
    };
    Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
    };
    Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset];
        var mul = 1;
        var i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var i = byteLength;
        var mul = 1;
        var val = this[offset + --i];
        while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        if (!(this[offset] & 0x80)) return this[offset];
        return (0xff - this[offset] + 1) * -1;
    };
    Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        var val = this[offset] | this[offset + 1] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        var val = this[offset + 1] | this[offset] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return $937a0acd9cd30227$var$ieee754.read(this, offset, true, 23, 4);
    };
    Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return $937a0acd9cd30227$var$ieee754.read(this, offset, false, 23, 4);
    };
    Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return $937a0acd9cd30227$var$ieee754.read(this, offset, true, 52, 8);
    };
    Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return $937a0acd9cd30227$var$ieee754.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
        if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
        if (offset + ext > buf.length) throw new RangeError('Index out of range');
    }
    Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        var mul = 1;
        var i = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        var i = byteLength - 1;
        var mul = 1;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            var limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        var i = 0;
        var mul = 1;
        var sub = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            var limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        var i = byteLength - 1;
        var mul = 1;
        var sub = 0;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
        if (value < 0) value = 0xff + value + 1;
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
        return offset + 4;
    };
    Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        if (value < 0) value = 0xffffffff + value + 1;
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    function checkIEEE754(buf, value, offset, ext, max, min) {
        if (offset + ext > buf.length) throw new RangeError('Index out of range');
        if (offset < 0) throw new RangeError('Index out of range');
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 4);
        $937a0acd9cd30227$var$ieee754.write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
    }
    Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 8);
        $937a0acd9cd30227$var$ieee754.write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
    }
    Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
    }; // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer.prototype.copy = function copy(target, targetStart, start, end) {
        if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
        if (!start) start = 0;
        if (!end && end !== 0) end = this.length;
        if (targetStart >= target.length) targetStart = target.length;
        if (!targetStart) targetStart = 0;
        if (end > 0 && end < start) end = start; // Copy 0 bytes; we're done
        if (end === start) return 0;
        if (target.length === 0 || this.length === 0) return 0; // Fatal error conditions
        if (targetStart < 0) throw new RangeError('targetStart out of bounds');
        if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
        if (end < 0) throw new RangeError('sourceEnd out of bounds'); // Are we oob?
        if (end > this.length) end = this.length;
        if (target.length - targetStart < end - start) end = target.length - targetStart + start;
        var len = end - start;
        if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
        this.copyWithin(targetStart, start, end);
        else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
        return len;
    }; // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer.prototype.fill = function fill(val, start, end, encoding) {
        // Handle string cases:
        if (typeof val === 'string') {
            if (typeof start === 'string') {
                encoding = start;
                start = 0;
                end = this.length;
            } else if (typeof end === 'string') {
                encoding = end;
                end = this.length;
            }
            if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
            if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
            if (val.length === 1) {
                var code = val.charCodeAt(0);
                if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
                val = code;
            }
        } else if (typeof val === 'number') val = val & 255;
        else if (typeof val === 'boolean') val = Number(val);
         // Invalid ranges are not set to a default, so can range check early.
        if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
        if (end <= start) return this;
        start = start >>> 0;
        end = end === undefined ? this.length : end >>> 0;
        if (!val) val = 0;
        var i;
        if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
        else {
            var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
            var len = bytes.length;
            if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
            for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
        }
        return this;
    }; // HELPER FUNCTIONS
    // ================
    var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
        // Node takes equal signs as end of the Base64 encoding
        str = str.split('=')[0]; // Node strips out invalid characters like \n and \t from the string, base64-js does not
        str = str.trim().replace(INVALID_BASE64_RE, ''); // Node converts strings with length < 2 to ''
        if (str.length < 2) return ''; // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
        while(str.length % 4 !== 0)str = str + '=';
        return str;
    }
    function utf8ToBytes(string, units) {
        units = units || Infinity;
        var codePoint;
        var length = string.length;
        var leadSurrogate = null;
        var bytes = [];
        for(var i = 0; i < length; ++i){
            codePoint = string.charCodeAt(i); // is surrogate component
            if (codePoint > 0xD7FF && codePoint < 0xE000) {
                // last char was a lead
                if (!leadSurrogate) {
                    // no lead yet
                    if (codePoint > 0xDBFF) {
                        // unexpected trail
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } else if (i + 1 === length) {
                        // unpaired lead
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } // valid lead
                    leadSurrogate = codePoint;
                    continue;
                } // 2 leads in a row
                if (codePoint < 0xDC00) {
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    leadSurrogate = codePoint;
                    continue;
                } // valid surrogate pair
                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
            } else if (leadSurrogate) // valid bmp char, but last char was a lead
            {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            }
            leadSurrogate = null; // encode utf8
            if (codePoint < 0x80) {
                if ((units -= 1) < 0) break;
                bytes.push(codePoint);
            } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break;
                bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break;
                bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break;
                bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else throw new Error('Invalid code point');
        }
        return bytes;
    }
    function asciiToBytes(str) {
        var byteArray = [];
        for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
        return byteArray;
    }
    function utf16leToBytes(str, units) {
        var c, hi, lo;
        var byteArray = [];
        for(var i = 0; i < str.length; ++i){
            if ((units -= 2) < 0) break;
            c = str.charCodeAt(i);
            hi = c >> 8;
            lo = c % 256;
            byteArray.push(lo);
            byteArray.push(hi);
        }
        return byteArray;
    }
    function base64ToBytes(str) {
        return $937a0acd9cd30227$var$base64Js.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
        for(var i = 0; i < length; ++i){
            if (i + offset >= dst.length || i >= src.length) break;
            dst[i + offset] = src[i];
        }
        return i;
    } // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
    // the `instanceof` check but they should be treated as of that type.
    // See: https://github.com/feross/buffer/issues/166
    function isInstance(obj, type) {
        return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
        // For IE11 support
        return obj !== obj; // eslint-disable-line no-self-compare
    } // Create lookup table for `toString('hex')`
    // See: https://github.com/feross/buffer/issues/219
    var hexSliceLookupTable = function() {
        var alphabet = '0123456789abcdef';
        var table = new Array(256);
        for(var i = 0; i < 16; ++i){
            var i16 = i * 16;
            for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
        }
        return table;
    }();
});
var $937a0acd9cd30227$var$buffer_1 = $937a0acd9cd30227$var$buffer$1.Buffer;
$937a0acd9cd30227$var$buffer$1.SlowBuffer;
$937a0acd9cd30227$var$buffer$1.INSPECT_MAX_BYTES;
$937a0acd9cd30227$var$buffer$1.kMaxLength;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $937a0acd9cd30227$var$_extendStatics = function extendStatics(d, b) {
    $937a0acd9cd30227$var$_extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $937a0acd9cd30227$var$_extendStatics(d, b);
};
function $937a0acd9cd30227$var$__extends(d, b) {
    $937a0acd9cd30227$var$_extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $937a0acd9cd30227$var$_assign = function __assign() {
    $937a0acd9cd30227$var$_assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $937a0acd9cd30227$var$_assign.apply(this, arguments);
};
/** @public */ var $937a0acd9cd30227$export$dcd4c628d4081c37 = /** @class */ function(_super) {
    $937a0acd9cd30227$var$__extends(BSONError, _super);
    function BSONError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, BSONError.prototype);
        return _this;
    }
    Object.defineProperty(BSONError.prototype, "name", {
        get: function() {
            return 'BSONError';
        },
        enumerable: false,
        configurable: true
    });
    return BSONError;
}(Error);
/** @public */ var $937a0acd9cd30227$export$5f4690e5e32707d3 = /** @class */ function(_super) {
    $937a0acd9cd30227$var$__extends(BSONTypeError, _super);
    function BSONTypeError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, BSONTypeError.prototype);
        return _this;
    }
    Object.defineProperty(BSONTypeError.prototype, "name", {
        get: function() {
            return 'BSONTypeError';
        },
        enumerable: false,
        configurable: true
    });
    return BSONTypeError;
}(TypeError);
function $937a0acd9cd30227$var$checkForMath(potentialGlobal) {
    // eslint-disable-next-line eqeqeq
    return potentialGlobal && potentialGlobal.Math == Math && potentialGlobal;
}
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
function $937a0acd9cd30227$var$getGlobal() {
    return $937a0acd9cd30227$var$checkForMath(typeof globalThis === 'object' && globalThis) || $937a0acd9cd30227$var$checkForMath(typeof window === 'object' && window) || $937a0acd9cd30227$var$checkForMath(typeof self === 'object' && self) || $937a0acd9cd30227$var$checkForMath(typeof $parcel$global === 'object' && $parcel$global) || // eslint-disable-next-line @typescript-eslint/no-implied-eval
    Function('return this')();
}
/**
 * Normalizes our expected stringified form of a function across versions of node
 * @param fn - The function to stringify
 */ function $937a0acd9cd30227$var$normalizedFunctionString(fn) {
    return fn.toString().replace('function(', 'function (');
}
function $937a0acd9cd30227$var$isReactNative() {
    var g = $937a0acd9cd30227$var$getGlobal();
    return typeof g.navigator === 'object' && g.navigator.product === 'ReactNative';
}
var $937a0acd9cd30227$var$insecureRandomBytes = function insecureRandomBytes(size) {
    var insecureWarning = $937a0acd9cd30227$var$isReactNative() ? 'BSON: For React Native please polyfill crypto.getRandomValues, e.g. using: https://www.npmjs.com/package/react-native-get-random-values.' : 'BSON: No cryptographic implementation for random bytes present, falling back to a less secure implementation.';
    console.warn(insecureWarning);
    var result = $937a0acd9cd30227$var$buffer_1.alloc(size);
    for(var i = 0; i < size; ++i)result[i] = Math.floor(Math.random() * 256);
    return result;
};
var $937a0acd9cd30227$var$detectRandomBytes = function() {
    if (typeof window !== 'undefined') {
        // browser crypto implementation(s)
        var target_1 = window.crypto || window.msCrypto; // allow for IE11
        if (target_1 && target_1.getRandomValues) return function(size) {
            return target_1.getRandomValues($937a0acd9cd30227$var$buffer_1.alloc(size));
        };
    }
    if (typeof $parcel$global !== 'undefined' && $parcel$global.crypto && $parcel$global.crypto.getRandomValues) // allow for RN packages such as https://www.npmjs.com/package/react-native-get-random-values to populate global
    return function(size) {
        return $parcel$global.crypto.getRandomValues($937a0acd9cd30227$var$buffer_1.alloc(size));
    };
    return $937a0acd9cd30227$var$insecureRandomBytes;
};
var $937a0acd9cd30227$var$randomBytes = $937a0acd9cd30227$var$detectRandomBytes();
function $937a0acd9cd30227$var$isAnyArrayBuffer(value) {
    return [
        '[object ArrayBuffer]',
        '[object SharedArrayBuffer]'
    ].includes(Object.prototype.toString.call(value));
}
function $937a0acd9cd30227$var$isUint8Array(value) {
    return Object.prototype.toString.call(value) === '[object Uint8Array]';
}
function $937a0acd9cd30227$var$isBigInt64Array(value) {
    return Object.prototype.toString.call(value) === '[object BigInt64Array]';
}
function $937a0acd9cd30227$var$isBigUInt64Array(value) {
    return Object.prototype.toString.call(value) === '[object BigUint64Array]';
}
function $937a0acd9cd30227$var$isRegExp(d) {
    return Object.prototype.toString.call(d) === '[object RegExp]';
}
function $937a0acd9cd30227$var$isMap(d) {
    return Object.prototype.toString.call(d) === '[object Map]';
}
// To ensure that 0.4 of node works correctly
function $937a0acd9cd30227$var$isDate(d) {
    return $937a0acd9cd30227$var$isObjectLike(d) && Object.prototype.toString.call(d) === '[object Date]';
}
/**
 * @internal
 * this is to solve the `'someKey' in x` problem where x is unknown.
 * https://github.com/typescript-eslint/typescript-eslint/issues/1071#issuecomment-541955753
 */ function $937a0acd9cd30227$var$isObjectLike(candidate) {
    return typeof candidate === 'object' && candidate !== null;
}
function $937a0acd9cd30227$var$deprecate(fn, message) {
    var warned = false;
    function deprecated() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!warned) {
            console.warn(message);
            warned = true;
        }
        return fn.apply(this, args);
    }
    return deprecated;
}
/**
 * Makes sure that, if a Uint8Array is passed in, it is wrapped in a Buffer.
 *
 * @param potentialBuffer - The potential buffer
 * @returns Buffer the input if potentialBuffer is a buffer, or a buffer that
 * wraps a passed in Uint8Array
 * @throws BSONTypeError If anything other than a Buffer or Uint8Array is passed in
 */ function $937a0acd9cd30227$var$ensureBuffer(potentialBuffer) {
    if (ArrayBuffer.isView(potentialBuffer)) return $937a0acd9cd30227$var$buffer_1.from(potentialBuffer.buffer, potentialBuffer.byteOffset, potentialBuffer.byteLength);
    if ($937a0acd9cd30227$var$isAnyArrayBuffer(potentialBuffer)) return $937a0acd9cd30227$var$buffer_1.from(potentialBuffer);
    throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Must use either Buffer or TypedArray');
}
// Validation regex for v4 uuid (validates with or without dashes)
var $937a0acd9cd30227$var$VALIDATION_REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|[0-9a-f]{12}4[0-9a-f]{3}[89ab][0-9a-f]{15})$/i;
var $937a0acd9cd30227$var$uuidValidateString = function(str) {
    return typeof str === 'string' && $937a0acd9cd30227$var$VALIDATION_REGEX.test(str);
};
var $937a0acd9cd30227$var$uuidHexStringToBuffer = function(hexString) {
    if (!$937a0acd9cd30227$var$uuidValidateString(hexString)) throw new $937a0acd9cd30227$export$5f4690e5e32707d3('UUID string representations must be a 32 or 36 character hex string (dashes excluded/included). Format: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx" or "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx".');
    var sanitizedHexString = hexString.replace(/-/g, '');
    return $937a0acd9cd30227$var$buffer_1.from(sanitizedHexString, 'hex');
};
var $937a0acd9cd30227$var$bufferToUuidHexString = function(buffer, includeDashes) {
    if (includeDashes === void 0) includeDashes = true;
    return includeDashes ? buffer.toString('hex', 0, 4) + '-' + buffer.toString('hex', 4, 6) + '-' + buffer.toString('hex', 6, 8) + '-' + buffer.toString('hex', 8, 10) + '-' + buffer.toString('hex', 10, 16) : buffer.toString('hex');
};
/** @internal */ var $937a0acd9cd30227$export$af352521c8649ed7 = 0x7fffffff;
/** @internal */ var $937a0acd9cd30227$export$250fc463de59e142 = -2147483648;
/** @internal */ var $937a0acd9cd30227$export$327cb7fa26f74edd = Math.pow(2, 63) - 1;
/** @internal */ var $937a0acd9cd30227$export$4a86b4076bf575d = -Math.pow(2, 63);
/**
 * Any integer up to 2^53 can be precisely represented by a double.
 * @internal
 */ var $937a0acd9cd30227$var$JS_INT_MAX = Math.pow(2, 53);
/**
 * Any integer down to -2^53 can be precisely represented by a double.
 * @internal
 */ var $937a0acd9cd30227$var$JS_INT_MIN = -Math.pow(2, 53);
/** Number BSON Type @internal */ var $937a0acd9cd30227$export$8a26a5fd67132695 = 1;
/** String BSON Type @internal */ var $937a0acd9cd30227$export$2ce63c0cc3c9284 = 2;
/** Object BSON Type @internal */ var $937a0acd9cd30227$export$5a91d81c75e64abe = 3;
/** Array BSON Type @internal */ var $937a0acd9cd30227$export$a158b7540a414b0 = 4;
/** Binary BSON Type @internal */ var $937a0acd9cd30227$export$a6d049d73c03641 = 5;
/** Binary BSON Type @internal */ var $937a0acd9cd30227$export$d4e0c9abd56073d0 = 6;
/** ObjectId BSON Type @internal */ var $937a0acd9cd30227$export$9c296bef3f2e3a80 = 7;
/** Boolean BSON Type @internal */ var $937a0acd9cd30227$export$ddfe5b18c2cb4c61 = 8;
/** Date BSON Type @internal */ var $937a0acd9cd30227$export$ff98a022f476c9f6 = 9;
/** null BSON Type @internal */ var $937a0acd9cd30227$export$a9d27ecf911c8e2d = 10;
/** RegExp BSON Type @internal */ var $937a0acd9cd30227$export$73020e19fe1a5dcb = 11;
/** Code BSON Type @internal */ var $937a0acd9cd30227$export$e22680776caf5882 = 12;
/** Code BSON Type @internal */ var $937a0acd9cd30227$export$4d96c08829372834 = 13;
/** Symbol BSON Type @internal */ var $937a0acd9cd30227$export$d18896fc584f464b = 14;
/** Code with Scope BSON Type @internal */ var $937a0acd9cd30227$export$959338844bb54803 = 15;
/** 32 bit Integer BSON Type @internal */ var $937a0acd9cd30227$export$6b19edc38baa1a8c = 16;
/** Timestamp BSON Type @internal */ var $937a0acd9cd30227$export$86ca409d085d6fb2 = 17;
/** Long BSON Type @internal */ var $937a0acd9cd30227$export$c07849652d011312 = 18;
/** Decimal128 BSON Type @internal */ var $937a0acd9cd30227$export$cde5e2a4f8adcb68 = 19;
/** MinKey BSON Type @internal */ var $937a0acd9cd30227$export$988fa02d40535509 = 0xff;
/** MaxKey BSON Type @internal */ var $937a0acd9cd30227$export$42679d8c82a5a5a0 = 0x7f;
/** Binary Default Type @internal */ var $937a0acd9cd30227$export$f0f029beb8f8c664 = 0;
/** Binary Function Type @internal */ var $937a0acd9cd30227$export$de4f3e691990aafd = 1;
/** Binary Byte Array Type @internal */ var $937a0acd9cd30227$export$48d3f182699ad59 = 2;
/** Binary Deprecated UUID Type @deprecated Please use BSON_BINARY_SUBTYPE_UUID_NEW @internal */ var $937a0acd9cd30227$export$35df332a732975a2 = 3;
/** Binary UUID Type @internal */ var $937a0acd9cd30227$export$17bbee584f46fa68 = 4;
/** Binary MD5 Type @internal */ var $937a0acd9cd30227$export$3480b2b0e04d2c71 = 5;
/** Encrypted BSON type @internal */ var $937a0acd9cd30227$export$2d0bb20574033770 = 6;
/** Column BSON type @internal */ var $937a0acd9cd30227$export$4de8045685e588e4 = 7;
/** Binary User Defined Type @internal */ var $937a0acd9cd30227$export$ae7a7cdb3769db69 = 128;
/**
 * A class representation of the BSON Binary type.
 * @public
 * @category BSONType
 */ var $937a0acd9cd30227$export$dbada097a9bd1de9 = /** @class */ function() {
    /**
     * Create a new Binary instance.
     *
     * This constructor can accept a string as its first argument. In this case,
     * this string will be encoded using ISO-8859-1, **not** using UTF-8.
     * This is almost certainly not what you want. Use `new Binary(Buffer.from(string))`
     * instead to convert the string to a Buffer using UTF-8 first.
     *
     * @param buffer - a buffer object containing the binary data.
     * @param subType - the option binary type.
     */ function Binary(buffer, subType) {
        if (!(this instanceof Binary)) return new Binary(buffer, subType);
        if (!(buffer == null) && !(typeof buffer === 'string') && !ArrayBuffer.isView(buffer) && !(buffer instanceof ArrayBuffer) && !Array.isArray(buffer)) throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Binary can only be constructed from string, Buffer, TypedArray, or Array<number>');
        this.sub_type = subType !== null && subType !== void 0 ? subType : Binary.BSON_BINARY_SUBTYPE_DEFAULT;
        if (buffer == null) {
            // create an empty binary buffer
            this.buffer = $937a0acd9cd30227$var$buffer_1.alloc(Binary.BUFFER_SIZE);
            this.position = 0;
        } else {
            if (typeof buffer === 'string') // string
            this.buffer = $937a0acd9cd30227$var$buffer_1.from(buffer, 'binary');
            else if (Array.isArray(buffer)) // number[]
            this.buffer = $937a0acd9cd30227$var$buffer_1.from(buffer);
            else // Buffer | TypedArray | ArrayBuffer
            this.buffer = $937a0acd9cd30227$var$ensureBuffer(buffer);
            this.position = this.buffer.byteLength;
        }
    }
    /**
     * Updates this binary with byte_value.
     *
     * @param byteValue - a single byte we wish to write.
     */ Binary.prototype.put = function(byteValue) {
        // If it's a string and a has more than one character throw an error
        if (typeof byteValue === 'string' && byteValue.length !== 1) throw new $937a0acd9cd30227$export$5f4690e5e32707d3('only accepts single character String');
        else if (typeof byteValue !== 'number' && byteValue.length !== 1) throw new $937a0acd9cd30227$export$5f4690e5e32707d3('only accepts single character Uint8Array or Array');
        // Decode the byte value once
        var decodedByte;
        if (typeof byteValue === 'string') decodedByte = byteValue.charCodeAt(0);
        else if (typeof byteValue === 'number') decodedByte = byteValue;
        else decodedByte = byteValue[0];
        if (decodedByte < 0 || decodedByte > 255) throw new $937a0acd9cd30227$export$5f4690e5e32707d3('only accepts number in a valid unsigned byte range 0-255');
        if (this.buffer.length > this.position) this.buffer[this.position++] = decodedByte;
        else {
            var buffer = $937a0acd9cd30227$var$buffer_1.alloc(Binary.BUFFER_SIZE + this.buffer.length);
            // Combine the two buffers together
            this.buffer.copy(buffer, 0, 0, this.buffer.length);
            this.buffer = buffer;
            this.buffer[this.position++] = decodedByte;
        }
    };
    /**
     * Writes a buffer or string to the binary.
     *
     * @param sequence - a string or buffer to be written to the Binary BSON object.
     * @param offset - specify the binary of where to write the content.
     */ Binary.prototype.write = function(sequence, offset) {
        offset = typeof offset === 'number' ? offset : this.position;
        // If the buffer is to small let's extend the buffer
        if (this.buffer.length < offset + sequence.length) {
            var buffer = $937a0acd9cd30227$var$buffer_1.alloc(this.buffer.length + sequence.length);
            this.buffer.copy(buffer, 0, 0, this.buffer.length);
            // Assign the new buffer
            this.buffer = buffer;
        }
        if (ArrayBuffer.isView(sequence)) {
            this.buffer.set($937a0acd9cd30227$var$ensureBuffer(sequence), offset);
            this.position = offset + sequence.byteLength > this.position ? offset + sequence.length : this.position;
        } else if (typeof sequence === 'string') {
            this.buffer.write(sequence, offset, sequence.length, 'binary');
            this.position = offset + sequence.length > this.position ? offset + sequence.length : this.position;
        }
    };
    /**
     * Reads **length** bytes starting at **position**.
     *
     * @param position - read from the given position in the Binary.
     * @param length - the number of bytes to read.
     */ Binary.prototype.read = function(position, length) {
        length = length && length > 0 ? length : this.position;
        // Let's return the data based on the type we have
        return this.buffer.slice(position, position + length);
    };
    /**
     * Returns the value of this binary as a string.
     * @param asRaw - Will skip converting to a string
     * @remarks
     * This is handy when calling this function conditionally for some key value pairs and not others
     */ Binary.prototype.value = function(asRaw) {
        asRaw = !!asRaw;
        // Optimize to serialize for the situation where the data == size of buffer
        if (asRaw && this.buffer.length === this.position) return this.buffer;
        // If it's a node.js buffer object
        if (asRaw) return this.buffer.slice(0, this.position);
        return this.buffer.toString('binary', 0, this.position);
    };
    /** the length of the binary sequence */ Binary.prototype.length = function() {
        return this.position;
    };
    Binary.prototype.toJSON = function() {
        return this.buffer.toString('base64');
    };
    Binary.prototype.toString = function(format) {
        return this.buffer.toString(format);
    };
    /** @internal */ Binary.prototype.toExtendedJSON = function(options) {
        options = options || {};
        var base64String = this.buffer.toString('base64');
        var subType = Number(this.sub_type).toString(16);
        if (options.legacy) return {
            $binary: base64String,
            $type: subType.length === 1 ? '0' + subType : subType
        };
        return {
            $binary: {
                base64: base64String,
                subType: subType.length === 1 ? '0' + subType : subType
            }
        };
    };
    Binary.prototype.toUUID = function() {
        if (this.sub_type === Binary.SUBTYPE_UUID) return new $937a0acd9cd30227$export$bc35efed93511c4b(this.buffer.slice(0, this.position));
        throw new $937a0acd9cd30227$export$dcd4c628d4081c37("Binary sub_type \"".concat(this.sub_type, "\" is not supported for converting to UUID. Only \"").concat(Binary.SUBTYPE_UUID, "\" is currently supported."));
    };
    /** @internal */ Binary.fromExtendedJSON = function(doc, options) {
        options = options || {};
        var data;
        var type;
        if ('$binary' in doc) {
            if (options.legacy && typeof doc.$binary === 'string' && '$type' in doc) {
                type = doc.$type ? parseInt(doc.$type, 16) : 0;
                data = $937a0acd9cd30227$var$buffer_1.from(doc.$binary, 'base64');
            } else if (typeof doc.$binary !== 'string') {
                type = doc.$binary.subType ? parseInt(doc.$binary.subType, 16) : 0;
                data = $937a0acd9cd30227$var$buffer_1.from(doc.$binary.base64, 'base64');
            }
        } else if ('$uuid' in doc) {
            type = 4;
            data = $937a0acd9cd30227$var$uuidHexStringToBuffer(doc.$uuid);
        }
        if (!data) throw new $937a0acd9cd30227$export$5f4690e5e32707d3("Unexpected Binary Extended JSON format ".concat(JSON.stringify(doc)));
        return type === $937a0acd9cd30227$export$17bbee584f46fa68 ? new $937a0acd9cd30227$export$bc35efed93511c4b(data) : new Binary(data, type);
    };
    /** @internal */ Binary.prototype[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return this.inspect();
    };
    Binary.prototype.inspect = function() {
        var asBuffer = this.value(true);
        return "new Binary(Buffer.from(\"".concat(asBuffer.toString('hex'), "\", \"hex\"), ").concat(this.sub_type, ")");
    };
    /**
     * Binary default subtype
     * @internal
     */ Binary.BSON_BINARY_SUBTYPE_DEFAULT = 0;
    /** Initial buffer default size */ Binary.BUFFER_SIZE = 256;
    /** Default BSON type */ Binary.SUBTYPE_DEFAULT = 0;
    /** Function BSON type */ Binary.SUBTYPE_FUNCTION = 1;
    /** Byte Array BSON type */ Binary.SUBTYPE_BYTE_ARRAY = 2;
    /** Deprecated UUID BSON type @deprecated Please use SUBTYPE_UUID */ Binary.SUBTYPE_UUID_OLD = 3;
    /** UUID BSON type */ Binary.SUBTYPE_UUID = 4;
    /** MD5 BSON type */ Binary.SUBTYPE_MD5 = 5;
    /** Encrypted BSON type */ Binary.SUBTYPE_ENCRYPTED = 6;
    /** Column BSON type */ Binary.SUBTYPE_COLUMN = 7;
    /** User BSON type */ Binary.SUBTYPE_USER_DEFINED = 128;
    return Binary;
}();
Object.defineProperty($937a0acd9cd30227$export$dbada097a9bd1de9.prototype, '_bsontype', {
    value: 'Binary'
});
var $937a0acd9cd30227$var$UUID_BYTE_LENGTH = 16;
/**
 * A class representation of the BSON UUID type.
 * @public
 */ var $937a0acd9cd30227$export$bc35efed93511c4b = /** @class */ function(_super) {
    $937a0acd9cd30227$var$__extends(UUID, _super);
    /**
     * Create an UUID type
     *
     * @param input - Can be a 32 or 36 character hex string (dashes excluded/included) or a 16 byte binary Buffer.
     */ function UUID(input) {
        var _this = this;
        var bytes;
        var hexStr;
        if (input == null) bytes = UUID.generate();
        else if (input instanceof UUID) {
            bytes = $937a0acd9cd30227$var$buffer_1.from(input.buffer);
            hexStr = input.__id;
        } else if (ArrayBuffer.isView(input) && input.byteLength === $937a0acd9cd30227$var$UUID_BYTE_LENGTH) bytes = $937a0acd9cd30227$var$ensureBuffer(input);
        else if (typeof input === 'string') bytes = $937a0acd9cd30227$var$uuidHexStringToBuffer(input);
        else throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Argument passed in UUID constructor must be a UUID, a 16 byte Buffer or a 32/36 character hex string (dashes excluded/included, format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx).');
        _this = _super.call(this, bytes, $937a0acd9cd30227$export$17bbee584f46fa68) || this;
        _this.__id = hexStr;
        return _this;
    }
    Object.defineProperty(UUID.prototype, "id", {
        /**
         * The UUID bytes
         * @readonly
         */ get: function() {
            return this.buffer;
        },
        set: function(value) {
            this.buffer = value;
            if (UUID.cacheHexString) this.__id = $937a0acd9cd30227$var$bufferToUuidHexString(value);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns the UUID id as a 32 or 36 character hex string representation, excluding/including dashes (defaults to 36 character dash separated)
     * @param includeDashes - should the string exclude dash-separators.
     * */ UUID.prototype.toHexString = function(includeDashes) {
        if (includeDashes === void 0) includeDashes = true;
        if (UUID.cacheHexString && this.__id) return this.__id;
        var uuidHexString = $937a0acd9cd30227$var$bufferToUuidHexString(this.id, includeDashes);
        if (UUID.cacheHexString) this.__id = uuidHexString;
        return uuidHexString;
    };
    /**
     * Converts the id into a 36 character (dashes included) hex string, unless a encoding is specified.
     */ UUID.prototype.toString = function(encoding) {
        return encoding ? this.id.toString(encoding) : this.toHexString();
    };
    /**
     * Converts the id into its JSON string representation.
     * A 36 character (dashes included) hex string in the format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
     */ UUID.prototype.toJSON = function() {
        return this.toHexString();
    };
    /**
     * Compares the equality of this UUID with `otherID`.
     *
     * @param otherId - UUID instance to compare against.
     */ UUID.prototype.equals = function(otherId) {
        if (!otherId) return false;
        if (otherId instanceof UUID) return otherId.id.equals(this.id);
        try {
            return new UUID(otherId).id.equals(this.id);
        } catch (_a) {
            return false;
        }
    };
    /**
     * Creates a Binary instance from the current UUID.
     */ UUID.prototype.toBinary = function() {
        return new $937a0acd9cd30227$export$dbada097a9bd1de9(this.id, $937a0acd9cd30227$export$dbada097a9bd1de9.SUBTYPE_UUID);
    };
    /**
     * Generates a populated buffer containing a v4 uuid
     */ UUID.generate = function() {
        var bytes = $937a0acd9cd30227$var$randomBytes($937a0acd9cd30227$var$UUID_BYTE_LENGTH);
        // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
        // Kindly borrowed from https://github.com/uuidjs/uuid/blob/master/src/v4.js
        bytes[6] = bytes[6] & 0x0f | 0x40;
        bytes[8] = bytes[8] & 0x3f | 0x80;
        return $937a0acd9cd30227$var$buffer_1.from(bytes);
    };
    /**
     * Checks if a value is a valid bson UUID
     * @param input - UUID, string or Buffer to validate.
     */ UUID.isValid = function(input) {
        if (!input) return false;
        if (input instanceof UUID) return true;
        if (typeof input === 'string') return $937a0acd9cd30227$var$uuidValidateString(input);
        if ($937a0acd9cd30227$var$isUint8Array(input)) {
            // check for length & uuid version (https://tools.ietf.org/html/rfc4122#section-4.1.3)
            if (input.length !== $937a0acd9cd30227$var$UUID_BYTE_LENGTH) return false;
            return (input[6] & 0xf0) === 0x40 && (input[8] & 0x80) === 0x80;
        }
        return false;
    };
    /**
     * Creates an UUID from a hex string representation of an UUID.
     * @param hexString - 32 or 36 character hex string (dashes excluded/included).
     */ UUID.createFromHexString = function(hexString) {
        var buffer = $937a0acd9cd30227$var$uuidHexStringToBuffer(hexString);
        return new UUID(buffer);
    };
    /**
     * Converts to a string representation of this Id.
     *
     * @returns return the 36 character hex string representation.
     * @internal
     */ UUID.prototype[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return this.inspect();
    };
    UUID.prototype.inspect = function() {
        return "new UUID(\"".concat(this.toHexString(), "\")");
    };
    return UUID;
}($937a0acd9cd30227$export$dbada097a9bd1de9);
/**
 * A class representation of the BSON Code type.
 * @public
 * @category BSONType
 */ var $937a0acd9cd30227$export$52f0f02147b12c03 = /** @class */ function() {
    /**
     * @param code - a string or function.
     * @param scope - an optional scope for the function.
     */ function Code(code, scope) {
        if (!(this instanceof Code)) return new Code(code, scope);
        this.code = code;
        this.scope = scope;
    }
    Code.prototype.toJSON = function() {
        return {
            code: this.code,
            scope: this.scope
        };
    };
    /** @internal */ Code.prototype.toExtendedJSON = function() {
        if (this.scope) return {
            $code: this.code,
            $scope: this.scope
        };
        return {
            $code: this.code
        };
    };
    /** @internal */ Code.fromExtendedJSON = function(doc) {
        return new Code(doc.$code, doc.$scope);
    };
    /** @internal */ Code.prototype[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return this.inspect();
    };
    Code.prototype.inspect = function() {
        var codeJson = this.toJSON();
        return "new Code(\"".concat(String(codeJson.code), "\"").concat(codeJson.scope ? ", ".concat(JSON.stringify(codeJson.scope)) : '', ")");
    };
    return Code;
}();
Object.defineProperty($937a0acd9cd30227$export$52f0f02147b12c03.prototype, '_bsontype', {
    value: 'Code'
});
/** @internal */ function $937a0acd9cd30227$var$isDBRefLike(value) {
    return $937a0acd9cd30227$var$isObjectLike(value) && value.$id != null && typeof value.$ref === 'string' && (value.$db == null || typeof value.$db === 'string');
}
/**
 * A class representation of the BSON DBRef type.
 * @public
 * @category BSONType
 */ var $937a0acd9cd30227$export$90e456a500235b9 = /** @class */ function() {
    /**
     * @param collection - the collection name.
     * @param oid - the reference ObjectId.
     * @param db - optional db name, if omitted the reference is local to the current db.
     */ function DBRef(collection, oid, db, fields) {
        if (!(this instanceof DBRef)) return new DBRef(collection, oid, db, fields);
        // check if namespace has been provided
        var parts = collection.split('.');
        if (parts.length === 2) {
            db = parts.shift();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            collection = parts.shift();
        }
        this.collection = collection;
        this.oid = oid;
        this.db = db;
        this.fields = fields || {};
    }
    Object.defineProperty(DBRef.prototype, "namespace", {
        // Property provided for compatibility with the 1.x parser
        // the 1.x parser used a "namespace" property, while 4.x uses "collection"
        /** @internal */ get: function() {
            return this.collection;
        },
        set: function(value) {
            this.collection = value;
        },
        enumerable: false,
        configurable: true
    });
    DBRef.prototype.toJSON = function() {
        var o = Object.assign({
            $ref: this.collection,
            $id: this.oid
        }, this.fields);
        if (this.db != null) o.$db = this.db;
        return o;
    };
    /** @internal */ DBRef.prototype.toExtendedJSON = function(options) {
        options = options || {};
        var o = {
            $ref: this.collection,
            $id: this.oid
        };
        if (options.legacy) return o;
        if (this.db) o.$db = this.db;
        o = Object.assign(o, this.fields);
        return o;
    };
    /** @internal */ DBRef.fromExtendedJSON = function(doc) {
        var copy = Object.assign({}, doc);
        delete copy.$ref;
        delete copy.$id;
        delete copy.$db;
        return new DBRef(doc.$ref, doc.$id, doc.$db, copy);
    };
    /** @internal */ DBRef.prototype[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return this.inspect();
    };
    DBRef.prototype.inspect = function() {
        // NOTE: if OID is an ObjectId class it will just print the oid string.
        var oid = this.oid === undefined || this.oid.toString === undefined ? this.oid : this.oid.toString();
        return "new DBRef(\"".concat(this.namespace, "\", new ObjectId(\"").concat(String(oid), "\")").concat(this.db ? ", \"".concat(this.db, "\"") : '', ")");
    };
    return DBRef;
}();
Object.defineProperty($937a0acd9cd30227$export$90e456a500235b9.prototype, '_bsontype', {
    value: 'DBRef'
});
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $937a0acd9cd30227$var$wasm = undefined;
try {
    $937a0acd9cd30227$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(// prettier-ignore
    new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (_a) {
// no wasm support
}
var $937a0acd9cd30227$var$TWO_PWR_16_DBL = 65536;
var $937a0acd9cd30227$var$TWO_PWR_24_DBL = 16777216;
var $937a0acd9cd30227$var$TWO_PWR_32_DBL = $937a0acd9cd30227$var$TWO_PWR_16_DBL * $937a0acd9cd30227$var$TWO_PWR_16_DBL;
var $937a0acd9cd30227$var$TWO_PWR_64_DBL = $937a0acd9cd30227$var$TWO_PWR_32_DBL * $937a0acd9cd30227$var$TWO_PWR_32_DBL;
var $937a0acd9cd30227$var$TWO_PWR_63_DBL = $937a0acd9cd30227$var$TWO_PWR_64_DBL / 2;
/** A cache of the Long representations of small integer values. */ var $937a0acd9cd30227$var$INT_CACHE = {};
/** A cache of the Long representations of small unsigned integer values. */ var $937a0acd9cd30227$var$UINT_CACHE = {};
/**
 * A class representing a 64-bit integer
 * @public
 * @category BSONType
 * @remarks
 * The internal representation of a long is the two given signed, 32-bit values.
 * We use 32-bit pieces because these are the size of integers on which
 * Javascript performs bit-operations.  For operations like addition and
 * multiplication, we split each number into 16 bit pieces, which can easily be
 * multiplied within Javascript's floating-point representation without overflow
 * or change in sign.
 * In the algorithms below, we frequently reduce the negative case to the
 * positive case by negating the input(s) and then post-processing the result.
 * Note that we must ALWAYS check specially whether those values are MIN_VALUE
 * (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
 * a positive number, it overflows back into a negative).  Not handling this
 * case would often result in infinite recursion.
 * Common constant values ZERO, ONE, NEG_ONE, etc. are found as static properties on this class.
 */ var $937a0acd9cd30227$export$12ac1d26449d9c2e = /** @class */ function() {
    /**
     * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
     *  See the from* functions below for more convenient ways of constructing Longs.
     *
     * Acceptable signatures are:
     * - Long(low, high, unsigned?)
     * - Long(bigint, unsigned?)
     * - Long(string, unsigned?)
     *
     * @param low - The low (signed) 32 bits of the long
     * @param high - The high (signed) 32 bits of the long
     * @param unsigned - Whether unsigned or not, defaults to signed
     */ function Long(low, high, unsigned) {
        if (low === void 0) low = 0;
        if (!(this instanceof Long)) return new Long(low, high, unsigned);
        if (typeof low === 'bigint') Object.assign(this, Long.fromBigInt(low, !!high));
        else if (typeof low === 'string') Object.assign(this, Long.fromString(low, !!high));
        else {
            this.low = low | 0;
            this.high = high | 0;
            this.unsigned = !!unsigned;
        }
        Object.defineProperty(this, '__isLong__', {
            value: true,
            configurable: false,
            writable: false,
            enumerable: false
        });
    }
    /**
     * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits.
     * Each is assumed to use 32 bits.
     * @param lowBits - The low 32 bits
     * @param highBits - The high 32 bits
     * @param unsigned - Whether unsigned or not, defaults to signed
     * @returns The corresponding Long value
     */ Long.fromBits = function(lowBits, highBits, unsigned) {
        return new Long(lowBits, highBits, unsigned);
    };
    /**
     * Returns a Long representing the given 32 bit integer value.
     * @param value - The 32 bit integer in question
     * @param unsigned - Whether unsigned or not, defaults to signed
     * @returns The corresponding Long value
     */ Long.fromInt = function(value, unsigned) {
        var obj, cachedObj, cache;
        if (unsigned) {
            value >>>= 0;
            if (cache = 0 <= value && value < 256) {
                cachedObj = $937a0acd9cd30227$var$UINT_CACHE[value];
                if (cachedObj) return cachedObj;
            }
            obj = Long.fromBits(value, (value | 0) < 0 ? -1 : 0, true);
            if (cache) $937a0acd9cd30227$var$UINT_CACHE[value] = obj;
            return obj;
        } else {
            value |= 0;
            if (cache = -128 <= value && value < 128) {
                cachedObj = $937a0acd9cd30227$var$INT_CACHE[value];
                if (cachedObj) return cachedObj;
            }
            obj = Long.fromBits(value, value < 0 ? -1 : 0, false);
            if (cache) $937a0acd9cd30227$var$INT_CACHE[value] = obj;
            return obj;
        }
    };
    /**
     * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
     * @param value - The number in question
     * @param unsigned - Whether unsigned or not, defaults to signed
     * @returns The corresponding Long value
     */ Long.fromNumber = function(value, unsigned) {
        if (isNaN(value)) return unsigned ? Long.UZERO : Long.ZERO;
        if (unsigned) {
            if (value < 0) return Long.UZERO;
            if (value >= $937a0acd9cd30227$var$TWO_PWR_64_DBL) return Long.MAX_UNSIGNED_VALUE;
        } else {
            if (value <= -$937a0acd9cd30227$var$TWO_PWR_63_DBL) return Long.MIN_VALUE;
            if (value + 1 >= $937a0acd9cd30227$var$TWO_PWR_63_DBL) return Long.MAX_VALUE;
        }
        if (value < 0) return Long.fromNumber(-value, unsigned).neg();
        return Long.fromBits(value % $937a0acd9cd30227$var$TWO_PWR_32_DBL | 0, value / $937a0acd9cd30227$var$TWO_PWR_32_DBL | 0, unsigned);
    };
    /**
     * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
     * @param value - The number in question
     * @param unsigned - Whether unsigned or not, defaults to signed
     * @returns The corresponding Long value
     */ Long.fromBigInt = function(value, unsigned) {
        return Long.fromString(value.toString(), unsigned);
    };
    /**
     * Returns a Long representation of the given string, written using the specified radix.
     * @param str - The textual representation of the Long
     * @param unsigned - Whether unsigned or not, defaults to signed
     * @param radix - The radix in which the text is written (2-36), defaults to 10
     * @returns The corresponding Long value
     */ Long.fromString = function(str, unsigned, radix) {
        if (str.length === 0) throw Error('empty string');
        if (str === 'NaN' || str === 'Infinity' || str === '+Infinity' || str === '-Infinity') return Long.ZERO;
        if (typeof unsigned === 'number') // For goog.math.long compatibility
        radix = unsigned, unsigned = false;
        else unsigned = !!unsigned;
        radix = radix || 10;
        if (radix < 2 || 36 < radix) throw RangeError('radix');
        var p;
        if ((p = str.indexOf('-')) > 0) throw Error('interior hyphen');
        else if (p === 0) return Long.fromString(str.substring(1), unsigned, radix).neg();
        // Do several (8) digits each time through the loop, so as to
        // minimize the calls to the very expensive emulated div.
        var radixToPower = Long.fromNumber(Math.pow(radix, 8));
        var result = Long.ZERO;
        for(var i = 0; i < str.length; i += 8){
            var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
            if (size < 8) {
                var power = Long.fromNumber(Math.pow(radix, size));
                result = result.mul(power).add(Long.fromNumber(value));
            } else {
                result = result.mul(radixToPower);
                result = result.add(Long.fromNumber(value));
            }
        }
        result.unsigned = unsigned;
        return result;
    };
    /**
     * Creates a Long from its byte representation.
     * @param bytes - Byte representation
     * @param unsigned - Whether unsigned or not, defaults to signed
     * @param le - Whether little or big endian, defaults to big endian
     * @returns The corresponding Long value
     */ Long.fromBytes = function(bytes, unsigned, le) {
        return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
    };
    /**
     * Creates a Long from its little endian byte representation.
     * @param bytes - Little endian byte representation
     * @param unsigned - Whether unsigned or not, defaults to signed
     * @returns The corresponding Long value
     */ Long.fromBytesLE = function(bytes, unsigned) {
        return new Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
    };
    /**
     * Creates a Long from its big endian byte representation.
     * @param bytes - Big endian byte representation
     * @param unsigned - Whether unsigned or not, defaults to signed
     * @returns The corresponding Long value
     */ Long.fromBytesBE = function(bytes, unsigned) {
        return new Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
    };
    /**
     * Tests if the specified object is a Long.
     */ Long.isLong = function(value) {
        return $937a0acd9cd30227$var$isObjectLike(value) && value['__isLong__'] === true;
    };
    /**
     * Converts the specified value to a Long.
     * @param unsigned - Whether unsigned or not, defaults to signed
     */ Long.fromValue = function(val, unsigned) {
        if (typeof val === 'number') return Long.fromNumber(val, unsigned);
        if (typeof val === 'string') return Long.fromString(val, unsigned);
        // Throws for non-objects, converts non-instanceof Long:
        return Long.fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
    };
    /** Returns the sum of this and the specified Long. */ Long.prototype.add = function(addend) {
        if (!Long.isLong(addend)) addend = Long.fromValue(addend);
        // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
        var a48 = this.high >>> 16;
        var a32 = this.high & 0xffff;
        var a16 = this.low >>> 16;
        var a00 = this.low & 0xffff;
        var b48 = addend.high >>> 16;
        var b32 = addend.high & 0xffff;
        var b16 = addend.low >>> 16;
        var b00 = addend.low & 0xffff;
        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
        c00 += a00 + b00;
        c16 += c00 >>> 16;
        c00 &= 0xffff;
        c16 += a16 + b16;
        c32 += c16 >>> 16;
        c16 &= 0xffff;
        c32 += a32 + b32;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c48 += a48 + b48;
        c48 &= 0xffff;
        return Long.fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
    };
    /**
     * Returns the sum of this and the specified Long.
     * @returns Sum
     */ Long.prototype.and = function(other) {
        if (!Long.isLong(other)) other = Long.fromValue(other);
        return Long.fromBits(this.low & other.low, this.high & other.high, this.unsigned);
    };
    /**
     * Compares this Long's value with the specified's.
     * @returns 0 if they are the same, 1 if the this is greater and -1 if the given one is greater
     */ Long.prototype.compare = function(other) {
        if (!Long.isLong(other)) other = Long.fromValue(other);
        if (this.eq(other)) return 0;
        var thisNeg = this.isNegative(), otherNeg = other.isNegative();
        if (thisNeg && !otherNeg) return -1;
        if (!thisNeg && otherNeg) return 1;
        // At this point the sign bits are the same
        if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
        // Both are positive if at least one is unsigned
        return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
    };
    /** This is an alias of {@link Long.compare} */ Long.prototype.comp = function(other) {
        return this.compare(other);
    };
    /**
     * Returns this Long divided by the specified. The result is signed if this Long is signed or unsigned if this Long is unsigned.
     * @returns Quotient
     */ Long.prototype.divide = function(divisor) {
        if (!Long.isLong(divisor)) divisor = Long.fromValue(divisor);
        if (divisor.isZero()) throw Error('division by zero');
        // use wasm support if present
        if ($937a0acd9cd30227$var$wasm) {
            // guard against signed division overflow: the largest
            // negative number / -1 would be 1 larger than the largest
            // positive number, due to two's complement.
            if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
            return this;
            var low = (this.unsigned ? $937a0acd9cd30227$var$wasm.div_u : $937a0acd9cd30227$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
            return Long.fromBits(low, $937a0acd9cd30227$var$wasm.get_high(), this.unsigned);
        }
        if (this.isZero()) return this.unsigned ? Long.UZERO : Long.ZERO;
        var approx, rem, res;
        if (!this.unsigned) {
            // This section is only relevant for signed longs and is derived from the
            // closure library as a whole.
            if (this.eq(Long.MIN_VALUE)) {
                if (divisor.eq(Long.ONE) || divisor.eq(Long.NEG_ONE)) return Long.MIN_VALUE;
                else if (divisor.eq(Long.MIN_VALUE)) return Long.ONE;
                else {
                    // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                    var halfThis = this.shr(1);
                    approx = halfThis.div(divisor).shl(1);
                    if (approx.eq(Long.ZERO)) return divisor.isNegative() ? Long.ONE : Long.NEG_ONE;
                    else {
                        rem = this.sub(divisor.mul(approx));
                        res = approx.add(rem.div(divisor));
                        return res;
                    }
                }
            } else if (divisor.eq(Long.MIN_VALUE)) return this.unsigned ? Long.UZERO : Long.ZERO;
            if (this.isNegative()) {
                if (divisor.isNegative()) return this.neg().div(divisor.neg());
                return this.neg().div(divisor).neg();
            } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
            res = Long.ZERO;
        } else {
            // The algorithm below has not been made for unsigned longs. It's therefore
            // required to take special care of the MSB prior to running it.
            if (!divisor.unsigned) divisor = divisor.toUnsigned();
            if (divisor.gt(this)) return Long.UZERO;
            if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
            return Long.UONE;
            res = Long.UZERO;
        }
        // Repeat the following until the remainder is less than other:  find a
        // floating-point that approximates remainder / other *from below*, add this
        // into the result, and subtract it from the remainder.  It is critical that
        // the approximate value is less than or equal to the real value so that the
        // remainder never becomes negative.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        rem = this;
        while(rem.gte(divisor)){
            // Approximate the result of division. This may be a little greater or
            // smaller than the actual value.
            approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
            // We will tweak the approximate result by changing it in the 48-th digit or
            // the smallest non-fractional digit, whichever is larger.
            var log2 = Math.ceil(Math.log(approx) / Math.LN2);
            var delta = log2 <= 48 ? 1 : Math.pow(2, log2 - 48);
            // Decrease the approximation until it is smaller than the remainder.  Note
            // that if it is too large, the product overflows and is negative.
            var approxRes = Long.fromNumber(approx);
            var approxRem = approxRes.mul(divisor);
            while(approxRem.isNegative() || approxRem.gt(rem)){
                approx -= delta;
                approxRes = Long.fromNumber(approx, this.unsigned);
                approxRem = approxRes.mul(divisor);
            }
            // We know the answer can't be zero... and actually, zero would cause
            // infinite recursion since we would make no progress.
            if (approxRes.isZero()) approxRes = Long.ONE;
            res = res.add(approxRes);
            rem = rem.sub(approxRem);
        }
        return res;
    };
    /**This is an alias of {@link Long.divide} */ Long.prototype.div = function(divisor) {
        return this.divide(divisor);
    };
    /**
     * Tests if this Long's value equals the specified's.
     * @param other - Other value
     */ Long.prototype.equals = function(other) {
        if (!Long.isLong(other)) other = Long.fromValue(other);
        if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
        return this.high === other.high && this.low === other.low;
    };
    /** This is an alias of {@link Long.equals} */ Long.prototype.eq = function(other) {
        return this.equals(other);
    };
    /** Gets the high 32 bits as a signed integer. */ Long.prototype.getHighBits = function() {
        return this.high;
    };
    /** Gets the high 32 bits as an unsigned integer. */ Long.prototype.getHighBitsUnsigned = function() {
        return this.high >>> 0;
    };
    /** Gets the low 32 bits as a signed integer. */ Long.prototype.getLowBits = function() {
        return this.low;
    };
    /** Gets the low 32 bits as an unsigned integer. */ Long.prototype.getLowBitsUnsigned = function() {
        return this.low >>> 0;
    };
    /** Gets the number of bits needed to represent the absolute value of this Long. */ Long.prototype.getNumBitsAbs = function() {
        if (this.isNegative()) // Unsigned Longs are never negative
        return this.eq(Long.MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
        var val = this.high !== 0 ? this.high : this.low;
        var bit;
        for(bit = 31; bit > 0; bit--)if ((val & 1 << bit) !== 0) break;
        return this.high !== 0 ? bit + 33 : bit + 1;
    };
    /** Tests if this Long's value is greater than the specified's. */ Long.prototype.greaterThan = function(other) {
        return this.comp(other) > 0;
    };
    /** This is an alias of {@link Long.greaterThan} */ Long.prototype.gt = function(other) {
        return this.greaterThan(other);
    };
    /** Tests if this Long's value is greater than or equal the specified's. */ Long.prototype.greaterThanOrEqual = function(other) {
        return this.comp(other) >= 0;
    };
    /** This is an alias of {@link Long.greaterThanOrEqual} */ Long.prototype.gte = function(other) {
        return this.greaterThanOrEqual(other);
    };
    /** This is an alias of {@link Long.greaterThanOrEqual} */ Long.prototype.ge = function(other) {
        return this.greaterThanOrEqual(other);
    };
    /** Tests if this Long's value is even. */ Long.prototype.isEven = function() {
        return (this.low & 1) === 0;
    };
    /** Tests if this Long's value is negative. */ Long.prototype.isNegative = function() {
        return !this.unsigned && this.high < 0;
    };
    /** Tests if this Long's value is odd. */ Long.prototype.isOdd = function() {
        return (this.low & 1) === 1;
    };
    /** Tests if this Long's value is positive. */ Long.prototype.isPositive = function() {
        return this.unsigned || this.high >= 0;
    };
    /** Tests if this Long's value equals zero. */ Long.prototype.isZero = function() {
        return this.high === 0 && this.low === 0;
    };
    /** Tests if this Long's value is less than the specified's. */ Long.prototype.lessThan = function(other) {
        return this.comp(other) < 0;
    };
    /** This is an alias of {@link Long#lessThan}. */ Long.prototype.lt = function(other) {
        return this.lessThan(other);
    };
    /** Tests if this Long's value is less than or equal the specified's. */ Long.prototype.lessThanOrEqual = function(other) {
        return this.comp(other) <= 0;
    };
    /** This is an alias of {@link Long.lessThanOrEqual} */ Long.prototype.lte = function(other) {
        return this.lessThanOrEqual(other);
    };
    /** Returns this Long modulo the specified. */ Long.prototype.modulo = function(divisor) {
        if (!Long.isLong(divisor)) divisor = Long.fromValue(divisor);
        // use wasm support if present
        if ($937a0acd9cd30227$var$wasm) {
            var low = (this.unsigned ? $937a0acd9cd30227$var$wasm.rem_u : $937a0acd9cd30227$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
            return Long.fromBits(low, $937a0acd9cd30227$var$wasm.get_high(), this.unsigned);
        }
        return this.sub(this.div(divisor).mul(divisor));
    };
    /** This is an alias of {@link Long.modulo} */ Long.prototype.mod = function(divisor) {
        return this.modulo(divisor);
    };
    /** This is an alias of {@link Long.modulo} */ Long.prototype.rem = function(divisor) {
        return this.modulo(divisor);
    };
    /**
     * Returns the product of this and the specified Long.
     * @param multiplier - Multiplier
     * @returns Product
     */ Long.prototype.multiply = function(multiplier) {
        if (this.isZero()) return Long.ZERO;
        if (!Long.isLong(multiplier)) multiplier = Long.fromValue(multiplier);
        // use wasm support if present
        if ($937a0acd9cd30227$var$wasm) {
            var low = $937a0acd9cd30227$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
            return Long.fromBits(low, $937a0acd9cd30227$var$wasm.get_high(), this.unsigned);
        }
        if (multiplier.isZero()) return Long.ZERO;
        if (this.eq(Long.MIN_VALUE)) return multiplier.isOdd() ? Long.MIN_VALUE : Long.ZERO;
        if (multiplier.eq(Long.MIN_VALUE)) return this.isOdd() ? Long.MIN_VALUE : Long.ZERO;
        if (this.isNegative()) {
            if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
            else return this.neg().mul(multiplier).neg();
        } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
        // If both longs are small, use float multiplication
        if (this.lt(Long.TWO_PWR_24) && multiplier.lt(Long.TWO_PWR_24)) return Long.fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
        // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
        // We can skip products that would overflow.
        var a48 = this.high >>> 16;
        var a32 = this.high & 0xffff;
        var a16 = this.low >>> 16;
        var a00 = this.low & 0xffff;
        var b48 = multiplier.high >>> 16;
        var b32 = multiplier.high & 0xffff;
        var b16 = multiplier.low >>> 16;
        var b00 = multiplier.low & 0xffff;
        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
        c00 += a00 * b00;
        c16 += c00 >>> 16;
        c00 &= 0xffff;
        c16 += a16 * b00;
        c32 += c16 >>> 16;
        c16 &= 0xffff;
        c16 += a00 * b16;
        c32 += c16 >>> 16;
        c16 &= 0xffff;
        c32 += a32 * b00;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c32 += a16 * b16;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c32 += a00 * b32;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
        c48 &= 0xffff;
        return Long.fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
    };
    /** This is an alias of {@link Long.multiply} */ Long.prototype.mul = function(multiplier) {
        return this.multiply(multiplier);
    };
    /** Returns the Negation of this Long's value. */ Long.prototype.negate = function() {
        if (!this.unsigned && this.eq(Long.MIN_VALUE)) return Long.MIN_VALUE;
        return this.not().add(Long.ONE);
    };
    /** This is an alias of {@link Long.negate} */ Long.prototype.neg = function() {
        return this.negate();
    };
    /** Returns the bitwise NOT of this Long. */ Long.prototype.not = function() {
        return Long.fromBits(~this.low, ~this.high, this.unsigned);
    };
    /** Tests if this Long's value differs from the specified's. */ Long.prototype.notEquals = function(other) {
        return !this.equals(other);
    };
    /** This is an alias of {@link Long.notEquals} */ Long.prototype.neq = function(other) {
        return this.notEquals(other);
    };
    /** This is an alias of {@link Long.notEquals} */ Long.prototype.ne = function(other) {
        return this.notEquals(other);
    };
    /**
     * Returns the bitwise OR of this Long and the specified.
     */ Long.prototype.or = function(other) {
        if (!Long.isLong(other)) other = Long.fromValue(other);
        return Long.fromBits(this.low | other.low, this.high | other.high, this.unsigned);
    };
    /**
     * Returns this Long with bits shifted to the left by the given amount.
     * @param numBits - Number of bits
     * @returns Shifted Long
     */ Long.prototype.shiftLeft = function(numBits) {
        if (Long.isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        else if (numBits < 32) return Long.fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
        else return Long.fromBits(0, this.low << numBits - 32, this.unsigned);
    };
    /** This is an alias of {@link Long.shiftLeft} */ Long.prototype.shl = function(numBits) {
        return this.shiftLeft(numBits);
    };
    /**
     * Returns this Long with bits arithmetically shifted to the right by the given amount.
     * @param numBits - Number of bits
     * @returns Shifted Long
     */ Long.prototype.shiftRight = function(numBits) {
        if (Long.isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        else if (numBits < 32) return Long.fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
        else return Long.fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
    };
    /** This is an alias of {@link Long.shiftRight} */ Long.prototype.shr = function(numBits) {
        return this.shiftRight(numBits);
    };
    /**
     * Returns this Long with bits logically shifted to the right by the given amount.
     * @param numBits - Number of bits
     * @returns Shifted Long
     */ Long.prototype.shiftRightUnsigned = function(numBits) {
        if (Long.isLong(numBits)) numBits = numBits.toInt();
        numBits &= 63;
        if (numBits === 0) return this;
        else {
            var high = this.high;
            if (numBits < 32) {
                var low = this.low;
                return Long.fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
            } else if (numBits === 32) return Long.fromBits(high, 0, this.unsigned);
            else return Long.fromBits(high >>> numBits - 32, 0, this.unsigned);
        }
    };
    /** This is an alias of {@link Long.shiftRightUnsigned} */ Long.prototype.shr_u = function(numBits) {
        return this.shiftRightUnsigned(numBits);
    };
    /** This is an alias of {@link Long.shiftRightUnsigned} */ Long.prototype.shru = function(numBits) {
        return this.shiftRightUnsigned(numBits);
    };
    /**
     * Returns the difference of this and the specified Long.
     * @param subtrahend - Subtrahend
     * @returns Difference
     */ Long.prototype.subtract = function(subtrahend) {
        if (!Long.isLong(subtrahend)) subtrahend = Long.fromValue(subtrahend);
        return this.add(subtrahend.neg());
    };
    /** This is an alias of {@link Long.subtract} */ Long.prototype.sub = function(subtrahend) {
        return this.subtract(subtrahend);
    };
    /** Converts the Long to a 32 bit integer, assuming it is a 32 bit integer. */ Long.prototype.toInt = function() {
        return this.unsigned ? this.low >>> 0 : this.low;
    };
    /** Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa). */ Long.prototype.toNumber = function() {
        if (this.unsigned) return (this.high >>> 0) * $937a0acd9cd30227$var$TWO_PWR_32_DBL + (this.low >>> 0);
        return this.high * $937a0acd9cd30227$var$TWO_PWR_32_DBL + (this.low >>> 0);
    };
    /** Converts the Long to a BigInt (arbitrary precision). */ Long.prototype.toBigInt = function() {
        return BigInt(this.toString());
    };
    /**
     * Converts this Long to its byte representation.
     * @param le - Whether little or big endian, defaults to big endian
     * @returns Byte representation
     */ Long.prototype.toBytes = function(le) {
        return le ? this.toBytesLE() : this.toBytesBE();
    };
    /**
     * Converts this Long to its little endian byte representation.
     * @returns Little endian byte representation
     */ Long.prototype.toBytesLE = function() {
        var hi = this.high, lo = this.low;
        return [
            lo & 0xff,
            lo >>> 8 & 0xff,
            lo >>> 16 & 0xff,
            lo >>> 24,
            hi & 0xff,
            hi >>> 8 & 0xff,
            hi >>> 16 & 0xff,
            hi >>> 24
        ];
    };
    /**
     * Converts this Long to its big endian byte representation.
     * @returns Big endian byte representation
     */ Long.prototype.toBytesBE = function() {
        var hi = this.high, lo = this.low;
        return [
            hi >>> 24,
            hi >>> 16 & 0xff,
            hi >>> 8 & 0xff,
            hi & 0xff,
            lo >>> 24,
            lo >>> 16 & 0xff,
            lo >>> 8 & 0xff,
            lo & 0xff
        ];
    };
    /**
     * Converts this Long to signed.
     */ Long.prototype.toSigned = function() {
        if (!this.unsigned) return this;
        return Long.fromBits(this.low, this.high, false);
    };
    /**
     * Converts the Long to a string written in the specified radix.
     * @param radix - Radix (2-36), defaults to 10
     * @throws RangeError If `radix` is out of range
     */ Long.prototype.toString = function(radix) {
        radix = radix || 10;
        if (radix < 2 || 36 < radix) throw RangeError('radix');
        if (this.isZero()) return '0';
        if (this.isNegative()) {
            // Unsigned Longs are never negative
            if (this.eq(Long.MIN_VALUE)) {
                // We need to change the Long value before it can be negated, so we remove
                // the bottom-most digit in this base and then recurse to do the rest.
                var radixLong = Long.fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
                return div.toString(radix) + rem1.toInt().toString(radix);
            } else return '-' + this.neg().toString(radix);
        }
        // Do several (6) digits each time through the loop, so as to
        // minimize the calls to the very expensive emulated div.
        var radixToPower = Long.fromNumber(Math.pow(radix, 6), this.unsigned);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var rem = this;
        var result = '';
        // eslint-disable-next-line no-constant-condition
        while(true){
            var remDiv = rem.div(radixToPower);
            var intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0;
            var digits = intval.toString(radix);
            rem = remDiv;
            if (rem.isZero()) return digits + result;
            else {
                while(digits.length < 6)digits = '0' + digits;
                result = '' + digits + result;
            }
        }
    };
    /** Converts this Long to unsigned. */ Long.prototype.toUnsigned = function() {
        if (this.unsigned) return this;
        return Long.fromBits(this.low, this.high, true);
    };
    /** Returns the bitwise XOR of this Long and the given one. */ Long.prototype.xor = function(other) {
        if (!Long.isLong(other)) other = Long.fromValue(other);
        return Long.fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
    };
    /** This is an alias of {@link Long.isZero} */ Long.prototype.eqz = function() {
        return this.isZero();
    };
    /** This is an alias of {@link Long.lessThanOrEqual} */ Long.prototype.le = function(other) {
        return this.lessThanOrEqual(other);
    };
    /*
     ****************************************************************
     *                  BSON SPECIFIC ADDITIONS                     *
     ****************************************************************
     */ Long.prototype.toExtendedJSON = function(options) {
        if (options && options.relaxed) return this.toNumber();
        return {
            $numberLong: this.toString()
        };
    };
    Long.fromExtendedJSON = function(doc, options) {
        var result = Long.fromString(doc.$numberLong);
        return options && options.relaxed ? result.toNumber() : result;
    };
    /** @internal */ Long.prototype[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return this.inspect();
    };
    Long.prototype.inspect = function() {
        return "new Long(\"".concat(this.toString(), "\"").concat(this.unsigned ? ', true' : '', ")");
    };
    Long.TWO_PWR_24 = Long.fromInt($937a0acd9cd30227$var$TWO_PWR_24_DBL);
    /** Maximum unsigned value. */ Long.MAX_UNSIGNED_VALUE = Long.fromBits(-1, -1, true);
    /** Signed zero */ Long.ZERO = Long.fromInt(0);
    /** Unsigned zero. */ Long.UZERO = Long.fromInt(0, true);
    /** Signed one. */ Long.ONE = Long.fromInt(1);
    /** Unsigned one. */ Long.UONE = Long.fromInt(1, true);
    /** Signed negative one. */ Long.NEG_ONE = Long.fromInt(-1);
    /** Maximum signed value. */ Long.MAX_VALUE = Long.fromBits(-1, 2147483647, false);
    /** Minimum signed value. */ Long.MIN_VALUE = Long.fromBits(0, -2147483648, false);
    return Long;
}();
Object.defineProperty($937a0acd9cd30227$export$12ac1d26449d9c2e.prototype, '__isLong__', {
    value: true
});
Object.defineProperty($937a0acd9cd30227$export$12ac1d26449d9c2e.prototype, '_bsontype', {
    value: 'Long'
});
var $937a0acd9cd30227$var$PARSE_STRING_REGEXP = /^(\+|-)?(\d+|(\d*\.\d*))?(E|e)?([-+])?(\d+)?$/;
var $937a0acd9cd30227$var$PARSE_INF_REGEXP = /^(\+|-)?(Infinity|inf)$/i;
var $937a0acd9cd30227$var$PARSE_NAN_REGEXP = /^(\+|-)?NaN$/i;
var $937a0acd9cd30227$var$EXPONENT_MAX = 6111;
var $937a0acd9cd30227$var$EXPONENT_MIN = -6176;
var $937a0acd9cd30227$var$EXPONENT_BIAS = 6176;
var $937a0acd9cd30227$var$MAX_DIGITS = 34;
// Nan value bits as 32 bit values (due to lack of longs)
var $937a0acd9cd30227$var$NAN_BUFFER = [
    0x7c,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00
].reverse();
// Infinity value bits 32 bit values (due to lack of longs)
var $937a0acd9cd30227$var$INF_NEGATIVE_BUFFER = [
    0xf8,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00
].reverse();
var $937a0acd9cd30227$var$INF_POSITIVE_BUFFER = [
    0x78,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00
].reverse();
var $937a0acd9cd30227$var$EXPONENT_REGEX = /^([-+])?(\d+)?$/;
// Extract least significant 5 bits
var $937a0acd9cd30227$var$COMBINATION_MASK = 0x1f;
// Extract least significant 14 bits
var $937a0acd9cd30227$var$EXPONENT_MASK = 0x3fff;
// Value of combination field for Inf
var $937a0acd9cd30227$var$COMBINATION_INFINITY = 30;
// Value of combination field for NaN
var $937a0acd9cd30227$var$COMBINATION_NAN = 31;
// Detect if the value is a digit
function $937a0acd9cd30227$var$isDigit(value) {
    return !isNaN(parseInt(value, 10));
}
// Divide two uint128 values
function $937a0acd9cd30227$var$divideu128(value) {
    var DIVISOR = $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(1000000000);
    var _rem = $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(0);
    if (!value.parts[0] && !value.parts[1] && !value.parts[2] && !value.parts[3]) return {
        quotient: value,
        rem: _rem
    };
    for(var i = 0; i <= 3; i++){
        // Adjust remainder to match value of next dividend
        _rem = _rem.shiftLeft(32);
        // Add the divided to _rem
        _rem = _rem.add(new $937a0acd9cd30227$export$12ac1d26449d9c2e(value.parts[i], 0));
        value.parts[i] = _rem.div(DIVISOR).low;
        _rem = _rem.modulo(DIVISOR);
    }
    return {
        quotient: value,
        rem: _rem
    };
}
// Multiply two Long values and return the 128 bit value
function $937a0acd9cd30227$var$multiply64x2(left, right) {
    if (!left && !right) return {
        high: $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(0),
        low: $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(0)
    };
    var leftHigh = left.shiftRightUnsigned(32);
    var leftLow = new $937a0acd9cd30227$export$12ac1d26449d9c2e(left.getLowBits(), 0);
    var rightHigh = right.shiftRightUnsigned(32);
    var rightLow = new $937a0acd9cd30227$export$12ac1d26449d9c2e(right.getLowBits(), 0);
    var productHigh = leftHigh.multiply(rightHigh);
    var productMid = leftHigh.multiply(rightLow);
    var productMid2 = leftLow.multiply(rightHigh);
    var productLow = leftLow.multiply(rightLow);
    productHigh = productHigh.add(productMid.shiftRightUnsigned(32));
    productMid = new $937a0acd9cd30227$export$12ac1d26449d9c2e(productMid.getLowBits(), 0).add(productMid2).add(productLow.shiftRightUnsigned(32));
    productHigh = productHigh.add(productMid.shiftRightUnsigned(32));
    productLow = productMid.shiftLeft(32).add(new $937a0acd9cd30227$export$12ac1d26449d9c2e(productLow.getLowBits(), 0));
    // Return the 128 bit result
    return {
        high: productHigh,
        low: productLow
    };
}
function $937a0acd9cd30227$var$lessThan(left, right) {
    // Make values unsigned
    var uhleft = left.high >>> 0;
    var uhright = right.high >>> 0;
    // Compare high bits first
    if (uhleft < uhright) return true;
    else if (uhleft === uhright) {
        var ulleft = left.low >>> 0;
        var ulright = right.low >>> 0;
        if (ulleft < ulright) return true;
    }
    return false;
}
function $937a0acd9cd30227$var$invalidErr(string, message) {
    throw new $937a0acd9cd30227$export$5f4690e5e32707d3("\"".concat(string, "\" is not a valid Decimal128 string - ").concat(message));
}
/**
 * A class representation of the BSON Decimal128 type.
 * @public
 * @category BSONType
 */ var $937a0acd9cd30227$export$39efe8a3f1c2d4eb = /** @class */ function() {
    /**
     * @param bytes - a buffer containing the raw Decimal128 bytes in little endian order,
     *                or a string representation as returned by .toString()
     */ function Decimal128(bytes) {
        if (!(this instanceof Decimal128)) return new Decimal128(bytes);
        if (typeof bytes === 'string') this.bytes = Decimal128.fromString(bytes).bytes;
        else if ($937a0acd9cd30227$var$isUint8Array(bytes)) {
            if (bytes.byteLength !== 16) throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Decimal128 must take a Buffer of 16 bytes');
            this.bytes = bytes;
        } else throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Decimal128 must take a Buffer or string');
    }
    /**
     * Create a Decimal128 instance from a string representation
     *
     * @param representation - a numeric string representation.
     */ Decimal128.fromString = function(representation) {
        // Parse state tracking
        var isNegative = false;
        var sawRadix = false;
        var foundNonZero = false;
        // Total number of significant digits (no leading or trailing zero)
        var significantDigits = 0;
        // Total number of significand digits read
        var nDigitsRead = 0;
        // Total number of digits (no leading zeros)
        var nDigits = 0;
        // The number of the digits after radix
        var radixPosition = 0;
        // The index of the first non-zero in *str*
        var firstNonZero = 0;
        // Digits Array
        var digits = [
            0
        ];
        // The number of digits in digits
        var nDigitsStored = 0;
        // Insertion pointer for digits
        var digitsInsert = 0;
        // The index of the first non-zero digit
        var firstDigit = 0;
        // The index of the last digit
        var lastDigit = 0;
        // Exponent
        var exponent = 0;
        // loop index over array
        var i = 0;
        // The high 17 digits of the significand
        var significandHigh = new $937a0acd9cd30227$export$12ac1d26449d9c2e(0, 0);
        // The low 17 digits of the significand
        var significandLow = new $937a0acd9cd30227$export$12ac1d26449d9c2e(0, 0);
        // The biased exponent
        var biasedExponent = 0;
        // Read index
        var index = 0;
        // Naively prevent against REDOS attacks.
        // TODO: implementing a custom parsing for this, or refactoring the regex would yield
        //       further gains.
        if (representation.length >= 7000) throw new $937a0acd9cd30227$export$5f4690e5e32707d3('' + representation + ' not a valid Decimal128 string');
        // Results
        var stringMatch = representation.match($937a0acd9cd30227$var$PARSE_STRING_REGEXP);
        var infMatch = representation.match($937a0acd9cd30227$var$PARSE_INF_REGEXP);
        var nanMatch = representation.match($937a0acd9cd30227$var$PARSE_NAN_REGEXP);
        // Validate the string
        if (!stringMatch && !infMatch && !nanMatch || representation.length === 0) throw new $937a0acd9cd30227$export$5f4690e5e32707d3('' + representation + ' not a valid Decimal128 string');
        if (stringMatch) {
            // full_match = stringMatch[0]
            // sign = stringMatch[1]
            var unsignedNumber = stringMatch[2];
            // stringMatch[3] is undefined if a whole number (ex "1", 12")
            // but defined if a number w/ decimal in it (ex "1.0, 12.2")
            var e = stringMatch[4];
            var expSign = stringMatch[5];
            var expNumber = stringMatch[6];
            // they provided e, but didn't give an exponent number. for ex "1e"
            if (e && expNumber === undefined) $937a0acd9cd30227$var$invalidErr(representation, 'missing exponent power');
            // they provided e, but didn't give a number before it. for ex "e1"
            if (e && unsignedNumber === undefined) $937a0acd9cd30227$var$invalidErr(representation, 'missing exponent base');
            if (e === undefined && (expSign || expNumber)) $937a0acd9cd30227$var$invalidErr(representation, 'missing e before exponent');
        }
        // Get the negative or positive sign
        if (representation[index] === '+' || representation[index] === '-') isNegative = representation[index++] === '-';
        // Check if user passed Infinity or NaN
        if (!$937a0acd9cd30227$var$isDigit(representation[index]) && representation[index] !== '.') {
            if (representation[index] === 'i' || representation[index] === 'I') return new Decimal128($937a0acd9cd30227$var$buffer_1.from(isNegative ? $937a0acd9cd30227$var$INF_NEGATIVE_BUFFER : $937a0acd9cd30227$var$INF_POSITIVE_BUFFER));
            else if (representation[index] === 'N') return new Decimal128($937a0acd9cd30227$var$buffer_1.from($937a0acd9cd30227$var$NAN_BUFFER));
        }
        // Read all the digits
        while($937a0acd9cd30227$var$isDigit(representation[index]) || representation[index] === '.'){
            if (representation[index] === '.') {
                if (sawRadix) $937a0acd9cd30227$var$invalidErr(representation, 'contains multiple periods');
                sawRadix = true;
                index = index + 1;
                continue;
            }
            if (nDigitsStored < 34) {
                if (representation[index] !== '0' || foundNonZero) {
                    if (!foundNonZero) firstNonZero = nDigitsRead;
                    foundNonZero = true;
                    // Only store 34 digits
                    digits[digitsInsert++] = parseInt(representation[index], 10);
                    nDigitsStored = nDigitsStored + 1;
                }
            }
            if (foundNonZero) nDigits = nDigits + 1;
            if (sawRadix) radixPosition = radixPosition + 1;
            nDigitsRead = nDigitsRead + 1;
            index = index + 1;
        }
        if (sawRadix && !nDigitsRead) throw new $937a0acd9cd30227$export$5f4690e5e32707d3('' + representation + ' not a valid Decimal128 string');
        // Read exponent if exists
        if (representation[index] === 'e' || representation[index] === 'E') {
            // Read exponent digits
            var match = representation.substr(++index).match($937a0acd9cd30227$var$EXPONENT_REGEX);
            // No digits read
            if (!match || !match[2]) return new Decimal128($937a0acd9cd30227$var$buffer_1.from($937a0acd9cd30227$var$NAN_BUFFER));
            // Get exponent
            exponent = parseInt(match[0], 10);
            // Adjust the index
            index = index + match[0].length;
        }
        // Return not a number
        if (representation[index]) return new Decimal128($937a0acd9cd30227$var$buffer_1.from($937a0acd9cd30227$var$NAN_BUFFER));
        // Done reading input
        // Find first non-zero digit in digits
        firstDigit = 0;
        if (!nDigitsStored) {
            firstDigit = 0;
            lastDigit = 0;
            digits[0] = 0;
            nDigits = 1;
            nDigitsStored = 1;
            significantDigits = 0;
        } else {
            lastDigit = nDigitsStored - 1;
            significantDigits = nDigits;
            if (significantDigits !== 1) while(digits[firstNonZero + significantDigits - 1] === 0)significantDigits = significantDigits - 1;
        }
        // Normalization of exponent
        // Correct exponent based on radix position, and shift significand as needed
        // to represent user input
        // Overflow prevention
        if (exponent <= radixPosition && radixPosition - exponent > 16384) exponent = $937a0acd9cd30227$var$EXPONENT_MIN;
        else exponent = exponent - radixPosition;
        // Attempt to normalize the exponent
        while(exponent > $937a0acd9cd30227$var$EXPONENT_MAX){
            // Shift exponent to significand and decrease
            lastDigit = lastDigit + 1;
            if (lastDigit - firstDigit > $937a0acd9cd30227$var$MAX_DIGITS) {
                // Check if we have a zero then just hard clamp, otherwise fail
                var digitsString = digits.join('');
                if (digitsString.match(/^0+$/)) {
                    exponent = $937a0acd9cd30227$var$EXPONENT_MAX;
                    break;
                }
                $937a0acd9cd30227$var$invalidErr(representation, 'overflow');
            }
            exponent = exponent - 1;
        }
        while(exponent < $937a0acd9cd30227$var$EXPONENT_MIN || nDigitsStored < nDigits){
            // Shift last digit. can only do this if < significant digits than # stored.
            if (lastDigit === 0 && significantDigits < nDigitsStored) {
                exponent = $937a0acd9cd30227$var$EXPONENT_MIN;
                significantDigits = 0;
                break;
            }
            if (nDigitsStored < nDigits) // adjust to match digits not stored
            nDigits = nDigits - 1;
            else // adjust to round
            lastDigit = lastDigit - 1;
            if (exponent < $937a0acd9cd30227$var$EXPONENT_MAX) exponent = exponent + 1;
            else {
                // Check if we have a zero then just hard clamp, otherwise fail
                var digitsString = digits.join('');
                if (digitsString.match(/^0+$/)) {
                    exponent = $937a0acd9cd30227$var$EXPONENT_MAX;
                    break;
                }
                $937a0acd9cd30227$var$invalidErr(representation, 'overflow');
            }
        }
        // Round
        // We've normalized the exponent, but might still need to round.
        if (lastDigit - firstDigit + 1 < significantDigits) {
            var endOfString = nDigitsRead;
            // If we have seen a radix point, 'string' is 1 longer than we have
            // documented with ndigits_read, so inc the position of the first nonzero
            // digit and the position that digits are read to.
            if (sawRadix) {
                firstNonZero = firstNonZero + 1;
                endOfString = endOfString + 1;
            }
            // if negative, we need to increment again to account for - sign at start.
            if (isNegative) {
                firstNonZero = firstNonZero + 1;
                endOfString = endOfString + 1;
            }
            var roundDigit = parseInt(representation[firstNonZero + lastDigit + 1], 10);
            var roundBit = 0;
            if (roundDigit >= 5) {
                roundBit = 1;
                if (roundDigit === 5) {
                    roundBit = digits[lastDigit] % 2 === 1 ? 1 : 0;
                    for(i = firstNonZero + lastDigit + 2; i < endOfString; i++)if (parseInt(representation[i], 10)) {
                        roundBit = 1;
                        break;
                    }
                }
            }
            if (roundBit) {
                var dIdx = lastDigit;
                for(; dIdx >= 0; dIdx--)if (++digits[dIdx] > 9) {
                    digits[dIdx] = 0;
                    // overflowed most significant digit
                    if (dIdx === 0) {
                        if (exponent < $937a0acd9cd30227$var$EXPONENT_MAX) {
                            exponent = exponent + 1;
                            digits[dIdx] = 1;
                        } else return new Decimal128($937a0acd9cd30227$var$buffer_1.from(isNegative ? $937a0acd9cd30227$var$INF_NEGATIVE_BUFFER : $937a0acd9cd30227$var$INF_POSITIVE_BUFFER));
                    }
                }
            }
        }
        // Encode significand
        // The high 17 digits of the significand
        significandHigh = $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(0);
        // The low 17 digits of the significand
        significandLow = $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(0);
        // read a zero
        if (significantDigits === 0) {
            significandHigh = $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(0);
            significandLow = $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(0);
        } else if (lastDigit - firstDigit < 17) {
            var dIdx = firstDigit;
            significandLow = $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(digits[dIdx++]);
            significandHigh = new $937a0acd9cd30227$export$12ac1d26449d9c2e(0, 0);
            for(; dIdx <= lastDigit; dIdx++){
                significandLow = significandLow.multiply($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(10));
                significandLow = significandLow.add($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(digits[dIdx]));
            }
        } else {
            var dIdx = firstDigit;
            significandHigh = $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(digits[dIdx++]);
            for(; dIdx <= lastDigit - 17; dIdx++){
                significandHigh = significandHigh.multiply($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(10));
                significandHigh = significandHigh.add($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(digits[dIdx]));
            }
            significandLow = $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(digits[dIdx++]);
            for(; dIdx <= lastDigit; dIdx++){
                significandLow = significandLow.multiply($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(10));
                significandLow = significandLow.add($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(digits[dIdx]));
            }
        }
        var significand = $937a0acd9cd30227$var$multiply64x2(significandHigh, $937a0acd9cd30227$export$12ac1d26449d9c2e.fromString('100000000000000000'));
        significand.low = significand.low.add(significandLow);
        if ($937a0acd9cd30227$var$lessThan(significand.low, significandLow)) significand.high = significand.high.add($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(1));
        // Biased exponent
        biasedExponent = exponent + $937a0acd9cd30227$var$EXPONENT_BIAS;
        var dec = {
            low: $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(0),
            high: $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(0)
        };
        // Encode combination, exponent, and significand.
        if (significand.high.shiftRightUnsigned(49).and($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(1)).equals($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(1))) {
            // Encode '11' into bits 1 to 3
            dec.high = dec.high.or($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(0x3).shiftLeft(61));
            dec.high = dec.high.or($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(biasedExponent).and($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(0x3fff).shiftLeft(47)));
            dec.high = dec.high.or(significand.high.and($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(0x7fffffffffff)));
        } else {
            dec.high = dec.high.or($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(biasedExponent & 0x3fff).shiftLeft(49));
            dec.high = dec.high.or(significand.high.and($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(0x1ffffffffffff)));
        }
        dec.low = significand.low;
        // Encode sign
        if (isNegative) dec.high = dec.high.or($937a0acd9cd30227$export$12ac1d26449d9c2e.fromString('9223372036854775808'));
        // Encode into a buffer
        var buffer = $937a0acd9cd30227$var$buffer_1.alloc(16);
        index = 0;
        // Encode the low 64 bits of the decimal
        // Encode low bits
        buffer[index++] = dec.low.low & 0xff;
        buffer[index++] = dec.low.low >> 8 & 0xff;
        buffer[index++] = dec.low.low >> 16 & 0xff;
        buffer[index++] = dec.low.low >> 24 & 0xff;
        // Encode high bits
        buffer[index++] = dec.low.high & 0xff;
        buffer[index++] = dec.low.high >> 8 & 0xff;
        buffer[index++] = dec.low.high >> 16 & 0xff;
        buffer[index++] = dec.low.high >> 24 & 0xff;
        // Encode the high 64 bits of the decimal
        // Encode low bits
        buffer[index++] = dec.high.low & 0xff;
        buffer[index++] = dec.high.low >> 8 & 0xff;
        buffer[index++] = dec.high.low >> 16 & 0xff;
        buffer[index++] = dec.high.low >> 24 & 0xff;
        // Encode high bits
        buffer[index++] = dec.high.high & 0xff;
        buffer[index++] = dec.high.high >> 8 & 0xff;
        buffer[index++] = dec.high.high >> 16 & 0xff;
        buffer[index++] = dec.high.high >> 24 & 0xff;
        // Return the new Decimal128
        return new Decimal128(buffer);
    };
    /** Create a string representation of the raw Decimal128 value */ Decimal128.prototype.toString = function() {
        // Note: bits in this routine are referred to starting at 0,
        // from the sign bit, towards the coefficient.
        // decoded biased exponent (14 bits)
        var biased_exponent;
        // the number of significand digits
        var significand_digits = 0;
        // the base-10 digits in the significand
        var significand = new Array(36);
        for(var i = 0; i < significand.length; i++)significand[i] = 0;
        // read pointer into significand
        var index = 0;
        // true if the number is zero
        var is_zero = false;
        // the most significant significand bits (50-46)
        var significand_msb;
        // temporary storage for significand decoding
        var significand128 = {
            parts: [
                0,
                0,
                0,
                0
            ]
        };
        // indexing variables
        var j, k;
        // Output string
        var string = [];
        // Unpack index
        index = 0;
        // Buffer reference
        var buffer = this.bytes;
        // Unpack the low 64bits into a long
        // bits 96 - 127
        var low = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
        // bits 64 - 95
        var midl = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
        // Unpack the high 64bits into a long
        // bits 32 - 63
        var midh = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
        // bits 0 - 31
        var high = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
        // Unpack index
        index = 0;
        // Create the state of the decimal
        var dec = {
            low: new $937a0acd9cd30227$export$12ac1d26449d9c2e(low, midl),
            high: new $937a0acd9cd30227$export$12ac1d26449d9c2e(midh, high)
        };
        if (dec.high.lessThan($937a0acd9cd30227$export$12ac1d26449d9c2e.ZERO)) string.push('-');
        // Decode combination field and exponent
        // bits 1 - 5
        var combination = high >> 26 & $937a0acd9cd30227$var$COMBINATION_MASK;
        if (combination >> 3 === 3) {
            // Check for 'special' values
            if (combination === $937a0acd9cd30227$var$COMBINATION_INFINITY) return string.join('') + 'Infinity';
            else if (combination === $937a0acd9cd30227$var$COMBINATION_NAN) return 'NaN';
            else {
                biased_exponent = high >> 15 & $937a0acd9cd30227$var$EXPONENT_MASK;
                significand_msb = 0x08 + (high >> 14 & 0x01);
            }
        } else {
            significand_msb = high >> 14 & 0x07;
            biased_exponent = high >> 17 & $937a0acd9cd30227$var$EXPONENT_MASK;
        }
        // unbiased exponent
        var exponent = biased_exponent - $937a0acd9cd30227$var$EXPONENT_BIAS;
        // Create string of significand digits
        // Convert the 114-bit binary number represented by
        // (significand_high, significand_low) to at most 34 decimal
        // digits through modulo and division.
        significand128.parts[0] = (high & 0x3fff) + ((significand_msb & 0xf) << 14);
        significand128.parts[1] = midh;
        significand128.parts[2] = midl;
        significand128.parts[3] = low;
        if (significand128.parts[0] === 0 && significand128.parts[1] === 0 && significand128.parts[2] === 0 && significand128.parts[3] === 0) is_zero = true;
        else for(k = 3; k >= 0; k--){
            var least_digits = 0;
            // Perform the divide
            var result = $937a0acd9cd30227$var$divideu128(significand128);
            significand128 = result.quotient;
            least_digits = result.rem.low;
            // We now have the 9 least significant digits (in base 2).
            // Convert and output to string.
            if (!least_digits) continue;
            for(j = 8; j >= 0; j--){
                // significand[k * 9 + j] = Math.round(least_digits % 10);
                significand[k * 9 + j] = least_digits % 10;
                // least_digits = Math.round(least_digits / 10);
                least_digits = Math.floor(least_digits / 10);
            }
        }
        // Output format options:
        // Scientific - [-]d.dddE(+/-)dd or [-]dE(+/-)dd
        // Regular    - ddd.ddd
        if (is_zero) {
            significand_digits = 1;
            significand[index] = 0;
        } else {
            significand_digits = 36;
            while(!significand[index]){
                significand_digits = significand_digits - 1;
                index = index + 1;
            }
        }
        // the exponent if scientific notation is used
        var scientific_exponent = significand_digits - 1 + exponent;
        // The scientific exponent checks are dictated by the string conversion
        // specification and are somewhat arbitrary cutoffs.
        //
        // We must check exponent > 0, because if this is the case, the number
        // has trailing zeros.  However, we *cannot* output these trailing zeros,
        // because doing so would change the precision of the value, and would
        // change stored data if the string converted number is round tripped.
        if (scientific_exponent >= 34 || scientific_exponent <= -7 || exponent > 0) {
            // Scientific format
            // if there are too many significant digits, we should just be treating numbers
            // as + or - 0 and using the non-scientific exponent (this is for the "invalid
            // representation should be treated as 0/-0" spec cases in decimal128-1.json)
            if (significand_digits > 34) {
                string.push("".concat(0));
                if (exponent > 0) string.push("E+".concat(exponent));
                else if (exponent < 0) string.push("E".concat(exponent));
                return string.join('');
            }
            string.push("".concat(significand[index++]));
            significand_digits = significand_digits - 1;
            if (significand_digits) string.push('.');
            for(var i = 0; i < significand_digits; i++)string.push("".concat(significand[index++]));
            // Exponent
            string.push('E');
            if (scientific_exponent > 0) string.push("+".concat(scientific_exponent));
            else string.push("".concat(scientific_exponent));
        } else {
            // Regular format with no decimal place
            if (exponent >= 0) for(var i = 0; i < significand_digits; i++)string.push("".concat(significand[index++]));
            else {
                var radix_position = significand_digits + exponent;
                // non-zero digits before radix
                if (radix_position > 0) for(var i = 0; i < radix_position; i++)string.push("".concat(significand[index++]));
                else string.push('0');
                string.push('.');
                // add leading zeros after radix
                while(radix_position++ < 0)string.push('0');
                for(var i = 0; i < significand_digits - Math.max(radix_position - 1, 0); i++)string.push("".concat(significand[index++]));
            }
        }
        return string.join('');
    };
    Decimal128.prototype.toJSON = function() {
        return {
            $numberDecimal: this.toString()
        };
    };
    /** @internal */ Decimal128.prototype.toExtendedJSON = function() {
        return {
            $numberDecimal: this.toString()
        };
    };
    /** @internal */ Decimal128.fromExtendedJSON = function(doc) {
        return Decimal128.fromString(doc.$numberDecimal);
    };
    /** @internal */ Decimal128.prototype[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return this.inspect();
    };
    Decimal128.prototype.inspect = function() {
        return "new Decimal128(\"".concat(this.toString(), "\")");
    };
    return Decimal128;
}();
Object.defineProperty($937a0acd9cd30227$export$39efe8a3f1c2d4eb.prototype, '_bsontype', {
    value: 'Decimal128'
});
/**
 * A class representation of the BSON Double type.
 * @public
 * @category BSONType
 */ var $937a0acd9cd30227$export$340e583a64e26663 = /** @class */ function() {
    /**
     * Create a Double type
     *
     * @param value - the number we want to represent as a double.
     */ function Double(value) {
        if (!(this instanceof Double)) return new Double(value);
        if (value instanceof Number) value = value.valueOf();
        this.value = +value;
    }
    /**
     * Access the number value.
     *
     * @returns returns the wrapped double number.
     */ Double.prototype.valueOf = function() {
        return this.value;
    };
    Double.prototype.toJSON = function() {
        return this.value;
    };
    Double.prototype.toString = function(radix) {
        return this.value.toString(radix);
    };
    /** @internal */ Double.prototype.toExtendedJSON = function(options) {
        if (options && (options.legacy || options.relaxed && isFinite(this.value))) return this.value;
        if (Object.is(Math.sign(this.value), -0)) // NOTE: JavaScript has +0 and -0, apparently to model limit calculations. If a user
        // explicitly provided `-0` then we need to ensure the sign makes it into the output
        return {
            $numberDouble: "-".concat(this.value.toFixed(1))
        };
        return {
            $numberDouble: Number.isInteger(this.value) ? this.value.toFixed(1) : this.value.toString()
        };
    };
    /** @internal */ Double.fromExtendedJSON = function(doc, options) {
        var doubleValue = parseFloat(doc.$numberDouble);
        return options && options.relaxed ? doubleValue : new Double(doubleValue);
    };
    /** @internal */ Double.prototype[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return this.inspect();
    };
    Double.prototype.inspect = function() {
        var eJSON = this.toExtendedJSON();
        return "new Double(".concat(eJSON.$numberDouble, ")");
    };
    return Double;
}();
Object.defineProperty($937a0acd9cd30227$export$340e583a64e26663.prototype, '_bsontype', {
    value: 'Double'
});
/**
 * A class representation of a BSON Int32 type.
 * @public
 * @category BSONType
 */ var $937a0acd9cd30227$export$493726e231866ac3 = /** @class */ function() {
    /**
     * Create an Int32 type
     *
     * @param value - the number we want to represent as an int32.
     */ function Int32(value) {
        if (!(this instanceof Int32)) return new Int32(value);
        if (value instanceof Number) value = value.valueOf();
        this.value = +value | 0;
    }
    /**
     * Access the number value.
     *
     * @returns returns the wrapped int32 number.
     */ Int32.prototype.valueOf = function() {
        return this.value;
    };
    Int32.prototype.toString = function(radix) {
        return this.value.toString(radix);
    };
    Int32.prototype.toJSON = function() {
        return this.value;
    };
    /** @internal */ Int32.prototype.toExtendedJSON = function(options) {
        if (options && (options.relaxed || options.legacy)) return this.value;
        return {
            $numberInt: this.value.toString()
        };
    };
    /** @internal */ Int32.fromExtendedJSON = function(doc, options) {
        return options && options.relaxed ? parseInt(doc.$numberInt, 10) : new Int32(doc.$numberInt);
    };
    /** @internal */ Int32.prototype[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return this.inspect();
    };
    Int32.prototype.inspect = function() {
        return "new Int32(".concat(this.valueOf(), ")");
    };
    return Int32;
}();
Object.defineProperty($937a0acd9cd30227$export$493726e231866ac3.prototype, '_bsontype', {
    value: 'Int32'
});
/**
 * A class representation of the BSON MaxKey type.
 * @public
 * @category BSONType
 */ var $937a0acd9cd30227$export$d380297cb28b8de0 = /** @class */ function() {
    function MaxKey() {
        if (!(this instanceof MaxKey)) return new MaxKey();
    }
    /** @internal */ MaxKey.prototype.toExtendedJSON = function() {
        return {
            $maxKey: 1
        };
    };
    /** @internal */ MaxKey.fromExtendedJSON = function() {
        return new MaxKey();
    };
    /** @internal */ MaxKey.prototype[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return this.inspect();
    };
    MaxKey.prototype.inspect = function() {
        return 'new MaxKey()';
    };
    return MaxKey;
}();
Object.defineProperty($937a0acd9cd30227$export$d380297cb28b8de0.prototype, '_bsontype', {
    value: 'MaxKey'
});
/**
 * A class representation of the BSON MinKey type.
 * @public
 * @category BSONType
 */ var $937a0acd9cd30227$export$aa9d11358976b3cc = /** @class */ function() {
    function MinKey() {
        if (!(this instanceof MinKey)) return new MinKey();
    }
    /** @internal */ MinKey.prototype.toExtendedJSON = function() {
        return {
            $minKey: 1
        };
    };
    /** @internal */ MinKey.fromExtendedJSON = function() {
        return new MinKey();
    };
    /** @internal */ MinKey.prototype[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return this.inspect();
    };
    MinKey.prototype.inspect = function() {
        return 'new MinKey()';
    };
    return MinKey;
}();
Object.defineProperty($937a0acd9cd30227$export$aa9d11358976b3cc.prototype, '_bsontype', {
    value: 'MinKey'
});
// Regular expression that checks for hex value
var $937a0acd9cd30227$var$checkForHexRegExp = new RegExp('^[0-9a-fA-F]{24}$');
// Unique sequence for the current process (initialized on first use)
var $937a0acd9cd30227$var$PROCESS_UNIQUE = null;
var $937a0acd9cd30227$var$kId = Symbol('id');
/**
 * A class representation of the BSON ObjectId type.
 * @public
 * @category BSONType
 */ var $937a0acd9cd30227$export$e68967d37d049767 = /** @class */ function() {
    /**
     * Create an ObjectId type
     *
     * @param inputId - Can be a 24 character hex string, 12 byte binary Buffer, or a number.
     */ function ObjectId(inputId) {
        if (!(this instanceof ObjectId)) return new ObjectId(inputId);
        // workingId is set based on type of input and whether valid id exists for the input
        var workingId;
        if (typeof inputId === 'object' && inputId && 'id' in inputId) {
            if (typeof inputId.id !== 'string' && !ArrayBuffer.isView(inputId.id)) throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Argument passed in must have an id that is of type string or Buffer');
            if ('toHexString' in inputId && typeof inputId.toHexString === 'function') workingId = $937a0acd9cd30227$var$buffer_1.from(inputId.toHexString(), 'hex');
            else workingId = inputId.id;
        } else workingId = inputId;
        // the following cases use workingId to construct an ObjectId
        if (workingId == null || typeof workingId === 'number') // The most common use case (blank id, new objectId instance)
        // Generate a new id
        this[$937a0acd9cd30227$var$kId] = ObjectId.generate(typeof workingId === 'number' ? workingId : undefined);
        else if (ArrayBuffer.isView(workingId) && workingId.byteLength === 12) // If intstanceof matches we can escape calling ensure buffer in Node.js environments
        this[$937a0acd9cd30227$var$kId] = workingId instanceof $937a0acd9cd30227$var$buffer_1 ? workingId : $937a0acd9cd30227$var$ensureBuffer(workingId);
        else if (typeof workingId === 'string') {
            if (workingId.length === 12) {
                var bytes = $937a0acd9cd30227$var$buffer_1.from(workingId);
                if (bytes.byteLength === 12) this[$937a0acd9cd30227$var$kId] = bytes;
                else throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Argument passed in must be a string of 12 bytes');
            } else if (workingId.length === 24 && $937a0acd9cd30227$var$checkForHexRegExp.test(workingId)) this[$937a0acd9cd30227$var$kId] = $937a0acd9cd30227$var$buffer_1.from(workingId, 'hex');
            else throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Argument passed in must be a string of 12 bytes or a string of 24 hex characters or an integer');
        } else throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Argument passed in does not match the accepted types');
        // If we are caching the hex string
        if (ObjectId.cacheHexString) this.__id = this.id.toString('hex');
    }
    Object.defineProperty(ObjectId.prototype, "id", {
        /**
         * The ObjectId bytes
         * @readonly
         */ get: function() {
            return this[$937a0acd9cd30227$var$kId];
        },
        set: function(value) {
            this[$937a0acd9cd30227$var$kId] = value;
            if (ObjectId.cacheHexString) this.__id = value.toString('hex');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObjectId.prototype, "generationTime", {
        /**
         * The generation time of this ObjectId instance
         * @deprecated Please use getTimestamp / createFromTime which returns an int32 epoch
         */ get: function() {
            return this.id.readInt32BE(0);
        },
        set: function(value) {
            // Encode time into first 4 bytes
            this.id.writeUInt32BE(value, 0);
        },
        enumerable: false,
        configurable: true
    });
    /** Returns the ObjectId id as a 24 character hex string representation */ ObjectId.prototype.toHexString = function() {
        if (ObjectId.cacheHexString && this.__id) return this.__id;
        var hexString = this.id.toString('hex');
        if (ObjectId.cacheHexString && !this.__id) this.__id = hexString;
        return hexString;
    };
    /**
     * Update the ObjectId index
     * @privateRemarks
     * Used in generating new ObjectId's on the driver
     * @internal
     */ ObjectId.getInc = function() {
        return ObjectId.index = (ObjectId.index + 1) % 0xffffff;
    };
    /**
     * Generate a 12 byte id buffer used in ObjectId's
     *
     * @param time - pass in a second based timestamp.
     */ ObjectId.generate = function(time) {
        if ('number' !== typeof time) time = Math.floor(Date.now() / 1000);
        var inc = ObjectId.getInc();
        var buffer = $937a0acd9cd30227$var$buffer_1.alloc(12);
        // 4-byte timestamp
        buffer.writeUInt32BE(time, 0);
        // set PROCESS_UNIQUE if yet not initialized
        if ($937a0acd9cd30227$var$PROCESS_UNIQUE === null) $937a0acd9cd30227$var$PROCESS_UNIQUE = $937a0acd9cd30227$var$randomBytes(5);
        // 5-byte process unique
        buffer[4] = $937a0acd9cd30227$var$PROCESS_UNIQUE[0];
        buffer[5] = $937a0acd9cd30227$var$PROCESS_UNIQUE[1];
        buffer[6] = $937a0acd9cd30227$var$PROCESS_UNIQUE[2];
        buffer[7] = $937a0acd9cd30227$var$PROCESS_UNIQUE[3];
        buffer[8] = $937a0acd9cd30227$var$PROCESS_UNIQUE[4];
        // 3-byte counter
        buffer[11] = inc & 0xff;
        buffer[10] = inc >> 8 & 0xff;
        buffer[9] = inc >> 16 & 0xff;
        return buffer;
    };
    /**
     * Converts the id into a 24 character hex string for printing
     *
     * @param format - The Buffer toString format parameter.
     */ ObjectId.prototype.toString = function(format) {
        // Is the id a buffer then use the buffer toString method to return the format
        if (format) return this.id.toString(format);
        return this.toHexString();
    };
    /** Converts to its JSON the 24 character hex string representation. */ ObjectId.prototype.toJSON = function() {
        return this.toHexString();
    };
    /**
     * Compares the equality of this ObjectId with `otherID`.
     *
     * @param otherId - ObjectId instance to compare against.
     */ ObjectId.prototype.equals = function(otherId) {
        if (otherId === undefined || otherId === null) return false;
        if (otherId instanceof ObjectId) return this[$937a0acd9cd30227$var$kId][11] === otherId[$937a0acd9cd30227$var$kId][11] && this[$937a0acd9cd30227$var$kId].equals(otherId[$937a0acd9cd30227$var$kId]);
        if (typeof otherId === 'string' && ObjectId.isValid(otherId) && otherId.length === 12 && $937a0acd9cd30227$var$isUint8Array(this.id)) return otherId === $937a0acd9cd30227$var$buffer_1.prototype.toString.call(this.id, 'latin1');
        if (typeof otherId === 'string' && ObjectId.isValid(otherId) && otherId.length === 24) return otherId.toLowerCase() === this.toHexString();
        if (typeof otherId === 'string' && ObjectId.isValid(otherId) && otherId.length === 12) return $937a0acd9cd30227$var$buffer_1.from(otherId).equals(this.id);
        if (typeof otherId === 'object' && 'toHexString' in otherId && typeof otherId.toHexString === 'function') {
            var otherIdString = otherId.toHexString();
            var thisIdString = this.toHexString().toLowerCase();
            return typeof otherIdString === 'string' && otherIdString.toLowerCase() === thisIdString;
        }
        return false;
    };
    /** Returns the generation date (accurate up to the second) that this ID was generated. */ ObjectId.prototype.getTimestamp = function() {
        var timestamp = new Date();
        var time = this.id.readUInt32BE(0);
        timestamp.setTime(Math.floor(time) * 1000);
        return timestamp;
    };
    /** @internal */ ObjectId.createPk = function() {
        return new ObjectId();
    };
    /**
     * Creates an ObjectId from a second based number, with the rest of the ObjectId zeroed out. Used for comparisons or sorting the ObjectId.
     *
     * @param time - an integer number representing a number of seconds.
     */ ObjectId.createFromTime = function(time) {
        var buffer = $937a0acd9cd30227$var$buffer_1.from([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]);
        // Encode time into first 4 bytes
        buffer.writeUInt32BE(time, 0);
        // Return the new objectId
        return new ObjectId(buffer);
    };
    /**
     * Creates an ObjectId from a hex string representation of an ObjectId.
     *
     * @param hexString - create a ObjectId from a passed in 24 character hexstring.
     */ ObjectId.createFromHexString = function(hexString) {
        // Throw an error if it's not a valid setup
        if (typeof hexString === 'undefined' || hexString != null && hexString.length !== 24) throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Argument passed in must be a single String of 12 bytes or a string of 24 hex characters');
        return new ObjectId($937a0acd9cd30227$var$buffer_1.from(hexString, 'hex'));
    };
    /**
     * Checks if a value is a valid bson ObjectId
     *
     * @param id - ObjectId instance to validate.
     */ ObjectId.isValid = function(id) {
        if (id == null) return false;
        try {
            new ObjectId(id);
            return true;
        } catch (_a) {
            return false;
        }
    };
    /** @internal */ ObjectId.prototype.toExtendedJSON = function() {
        if (this.toHexString) return {
            $oid: this.toHexString()
        };
        return {
            $oid: this.toString('hex')
        };
    };
    /** @internal */ ObjectId.fromExtendedJSON = function(doc) {
        return new ObjectId(doc.$oid);
    };
    /**
     * Converts to a string representation of this Id.
     *
     * @returns return the 24 character hex string representation.
     * @internal
     */ ObjectId.prototype[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return this.inspect();
    };
    ObjectId.prototype.inspect = function() {
        return "new ObjectId(\"".concat(this.toHexString(), "\")");
    };
    /** @internal */ ObjectId.index = Math.floor(Math.random() * 0xffffff);
    return ObjectId;
}();
// Deprecated methods
Object.defineProperty($937a0acd9cd30227$export$e68967d37d049767.prototype, 'generate', {
    value: $937a0acd9cd30227$var$deprecate(function(time) {
        return $937a0acd9cd30227$export$e68967d37d049767.generate(time);
    }, 'Please use the static `ObjectId.generate(time)` instead')
});
Object.defineProperty($937a0acd9cd30227$export$e68967d37d049767.prototype, 'getInc', {
    value: $937a0acd9cd30227$var$deprecate(function() {
        return $937a0acd9cd30227$export$e68967d37d049767.getInc();
    }, 'Please use the static `ObjectId.getInc()` instead')
});
Object.defineProperty($937a0acd9cd30227$export$e68967d37d049767.prototype, 'get_inc', {
    value: $937a0acd9cd30227$var$deprecate(function() {
        return $937a0acd9cd30227$export$e68967d37d049767.getInc();
    }, 'Please use the static `ObjectId.getInc()` instead')
});
Object.defineProperty($937a0acd9cd30227$export$e68967d37d049767, 'get_inc', {
    value: $937a0acd9cd30227$var$deprecate(function() {
        return $937a0acd9cd30227$export$e68967d37d049767.getInc();
    }, 'Please use the static `ObjectId.getInc()` instead')
});
Object.defineProperty($937a0acd9cd30227$export$e68967d37d049767.prototype, '_bsontype', {
    value: 'ObjectID'
});
function $937a0acd9cd30227$var$alphabetize(str) {
    return str.split('').sort().join('');
}
/**
 * A class representation of the BSON RegExp type.
 * @public
 * @category BSONType
 */ var $937a0acd9cd30227$export$f7fea3e08dc99c1d = /** @class */ function() {
    /**
     * @param pattern - The regular expression pattern to match
     * @param options - The regular expression options
     */ function BSONRegExp(pattern, options) {
        if (!(this instanceof BSONRegExp)) return new BSONRegExp(pattern, options);
        this.pattern = pattern;
        this.options = $937a0acd9cd30227$var$alphabetize(options !== null && options !== void 0 ? options : '');
        if (this.pattern.indexOf('\x00') !== -1) throw new $937a0acd9cd30227$export$dcd4c628d4081c37("BSON Regex patterns cannot contain null bytes, found: ".concat(JSON.stringify(this.pattern)));
        if (this.options.indexOf('\x00') !== -1) throw new $937a0acd9cd30227$export$dcd4c628d4081c37("BSON Regex options cannot contain null bytes, found: ".concat(JSON.stringify(this.options)));
        // Validate options
        for(var i = 0; i < this.options.length; i++){
            if (!(this.options[i] === 'i' || this.options[i] === 'm' || this.options[i] === 'x' || this.options[i] === 'l' || this.options[i] === 's' || this.options[i] === 'u')) throw new $937a0acd9cd30227$export$dcd4c628d4081c37("The regular expression option [".concat(this.options[i], "] is not supported"));
        }
    }
    BSONRegExp.parseOptions = function(options) {
        return options ? options.split('').sort().join('') : '';
    };
    /** @internal */ BSONRegExp.prototype.toExtendedJSON = function(options) {
        options = options || {};
        if (options.legacy) return {
            $regex: this.pattern,
            $options: this.options
        };
        return {
            $regularExpression: {
                pattern: this.pattern,
                options: this.options
            }
        };
    };
    /** @internal */ BSONRegExp.fromExtendedJSON = function(doc) {
        if ('$regex' in doc) {
            if (typeof doc.$regex !== 'string') {
                // This is for $regex query operators that have extended json values.
                if (doc.$regex._bsontype === 'BSONRegExp') return doc;
            } else return new BSONRegExp(doc.$regex, BSONRegExp.parseOptions(doc.$options));
        }
        if ('$regularExpression' in doc) return new BSONRegExp(doc.$regularExpression.pattern, BSONRegExp.parseOptions(doc.$regularExpression.options));
        throw new $937a0acd9cd30227$export$5f4690e5e32707d3("Unexpected BSONRegExp EJSON object form: ".concat(JSON.stringify(doc)));
    };
    return BSONRegExp;
}();
Object.defineProperty($937a0acd9cd30227$export$f7fea3e08dc99c1d.prototype, '_bsontype', {
    value: 'BSONRegExp'
});
/**
 * A class representation of the BSON Symbol type.
 * @public
 * @category BSONType
 */ var $937a0acd9cd30227$export$8251e971c2f12361 = /** @class */ function() {
    /**
     * @param value - the string representing the symbol.
     */ function BSONSymbol(value) {
        if (!(this instanceof BSONSymbol)) return new BSONSymbol(value);
        this.value = value;
    }
    /** Access the wrapped string value. */ BSONSymbol.prototype.valueOf = function() {
        return this.value;
    };
    BSONSymbol.prototype.toString = function() {
        return this.value;
    };
    /** @internal */ BSONSymbol.prototype.inspect = function() {
        return "new BSONSymbol(\"".concat(this.value, "\")");
    };
    BSONSymbol.prototype.toJSON = function() {
        return this.value;
    };
    /** @internal */ BSONSymbol.prototype.toExtendedJSON = function() {
        return {
            $symbol: this.value
        };
    };
    /** @internal */ BSONSymbol.fromExtendedJSON = function(doc) {
        return new BSONSymbol(doc.$symbol);
    };
    /** @internal */ BSONSymbol.prototype[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return this.inspect();
    };
    return BSONSymbol;
}();
Object.defineProperty($937a0acd9cd30227$export$8251e971c2f12361.prototype, '_bsontype', {
    value: 'Symbol'
});
/** @public */ var $937a0acd9cd30227$export$d76d2ce407344c9c = $937a0acd9cd30227$export$12ac1d26449d9c2e;
/**
 * @public
 * @category BSONType
 * */ var $937a0acd9cd30227$export$d9bcbd5e1ff81430 = /** @class */ function(_super) {
    $937a0acd9cd30227$var$__extends(Timestamp, _super);
    function Timestamp(low, high) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        if (!(_this instanceof Timestamp)) return new Timestamp(low, high);
        if ($937a0acd9cd30227$export$12ac1d26449d9c2e.isLong(low)) _this = _super.call(this, low.low, low.high, true) || this;
        else if ($937a0acd9cd30227$var$isObjectLike(low) && typeof low.t !== 'undefined' && typeof low.i !== 'undefined') _this = _super.call(this, low.i, low.t, true) || this;
        else _this = _super.call(this, low, high, true) || this;
        Object.defineProperty(_this, '_bsontype', {
            value: 'Timestamp',
            writable: false,
            configurable: false,
            enumerable: false
        });
        return _this;
    }
    Timestamp.prototype.toJSON = function() {
        return {
            $timestamp: this.toString()
        };
    };
    /** Returns a Timestamp represented by the given (32-bit) integer value. */ Timestamp.fromInt = function(value) {
        return new Timestamp($937a0acd9cd30227$export$12ac1d26449d9c2e.fromInt(value, true));
    };
    /** Returns a Timestamp representing the given number value, provided that it is a finite number. Otherwise, zero is returned. */ Timestamp.fromNumber = function(value) {
        return new Timestamp($937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(value, true));
    };
    /**
     * Returns a Timestamp for the given high and low bits. Each is assumed to use 32 bits.
     *
     * @param lowBits - the low 32-bits.
     * @param highBits - the high 32-bits.
     */ Timestamp.fromBits = function(lowBits, highBits) {
        return new Timestamp(lowBits, highBits);
    };
    /**
     * Returns a Timestamp from the given string, optionally using the given radix.
     *
     * @param str - the textual representation of the Timestamp.
     * @param optRadix - the radix in which the text is written.
     */ Timestamp.fromString = function(str, optRadix) {
        return new Timestamp($937a0acd9cd30227$export$12ac1d26449d9c2e.fromString(str, true, optRadix));
    };
    /** @internal */ Timestamp.prototype.toExtendedJSON = function() {
        return {
            $timestamp: {
                t: this.high >>> 0,
                i: this.low >>> 0
            }
        };
    };
    /** @internal */ Timestamp.fromExtendedJSON = function(doc) {
        return new Timestamp(doc.$timestamp);
    };
    /** @internal */ Timestamp.prototype[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return this.inspect();
    };
    Timestamp.prototype.inspect = function() {
        return "new Timestamp({ t: ".concat(this.getHighBits(), ", i: ").concat(this.getLowBits(), " })");
    };
    Timestamp.MAX_VALUE = $937a0acd9cd30227$export$12ac1d26449d9c2e.MAX_UNSIGNED_VALUE;
    return Timestamp;
}($937a0acd9cd30227$export$d76d2ce407344c9c);
function $937a0acd9cd30227$var$isBSONType(value) {
    return $937a0acd9cd30227$var$isObjectLike(value) && Reflect.has(value, '_bsontype') && typeof value._bsontype === 'string';
}
// INT32 boundaries
var $937a0acd9cd30227$var$BSON_INT32_MAX = 0x7fffffff;
var $937a0acd9cd30227$var$BSON_INT32_MIN = -2147483648;
// INT64 boundaries
// const BSON_INT64_MAX = 0x7fffffffffffffff; // TODO(NODE-4377): This number cannot be precisely represented in JS
var $937a0acd9cd30227$var$BSON_INT64_MAX = 0x8000000000000000;
var $937a0acd9cd30227$var$BSON_INT64_MIN = -9223372036854776000;
// all the types where we don't need to do any special processing and can just pass the EJSON
//straight to type.fromExtendedJSON
var $937a0acd9cd30227$var$keysToCodecs = {
    $oid: $937a0acd9cd30227$export$e68967d37d049767,
    $binary: $937a0acd9cd30227$export$dbada097a9bd1de9,
    $uuid: $937a0acd9cd30227$export$dbada097a9bd1de9,
    $symbol: $937a0acd9cd30227$export$8251e971c2f12361,
    $numberInt: $937a0acd9cd30227$export$493726e231866ac3,
    $numberDecimal: $937a0acd9cd30227$export$39efe8a3f1c2d4eb,
    $numberDouble: $937a0acd9cd30227$export$340e583a64e26663,
    $numberLong: $937a0acd9cd30227$export$12ac1d26449d9c2e,
    $minKey: $937a0acd9cd30227$export$aa9d11358976b3cc,
    $maxKey: $937a0acd9cd30227$export$d380297cb28b8de0,
    $regex: $937a0acd9cd30227$export$f7fea3e08dc99c1d,
    $regularExpression: $937a0acd9cd30227$export$f7fea3e08dc99c1d,
    $timestamp: $937a0acd9cd30227$export$d9bcbd5e1ff81430
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $937a0acd9cd30227$var$deserializeValue(value, options) {
    if (options === void 0) options = {};
    if (typeof value === 'number') {
        if (options.relaxed || options.legacy) return value;
        // if it's an integer, should interpret as smallest BSON integer
        // that can represent it exactly. (if out of range, interpret as double.)
        if (Math.floor(value) === value) {
            if (value >= $937a0acd9cd30227$var$BSON_INT32_MIN && value <= $937a0acd9cd30227$var$BSON_INT32_MAX) return new $937a0acd9cd30227$export$493726e231866ac3(value);
            if (value >= $937a0acd9cd30227$var$BSON_INT64_MIN && value <= $937a0acd9cd30227$var$BSON_INT64_MAX) return $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(value);
        }
        // If the number is a non-integer or out of integer range, should interpret as BSON Double.
        return new $937a0acd9cd30227$export$340e583a64e26663(value);
    }
    // from here on out we're looking for bson types, so bail if its not an object
    if (value == null || typeof value !== 'object') return value;
    // upgrade deprecated undefined to null
    if (value.$undefined) return null;
    var keys = Object.keys(value).filter(function(k) {
        return k.startsWith('$') && value[k] != null;
    });
    for(var i = 0; i < keys.length; i++){
        var c = $937a0acd9cd30227$var$keysToCodecs[keys[i]];
        if (c) return c.fromExtendedJSON(value, options);
    }
    if (value.$date != null) {
        var d = value.$date;
        var date = new Date();
        if (options.legacy) {
            if (typeof d === 'number') date.setTime(d);
            else if (typeof d === 'string') date.setTime(Date.parse(d));
        } else {
            if (typeof d === 'string') date.setTime(Date.parse(d));
            else if ($937a0acd9cd30227$export$12ac1d26449d9c2e.isLong(d)) date.setTime(d.toNumber());
            else if (typeof d === 'number' && options.relaxed) date.setTime(d);
        }
        return date;
    }
    if (value.$code != null) {
        var copy = Object.assign({}, value);
        if (value.$scope) copy.$scope = $937a0acd9cd30227$var$deserializeValue(value.$scope);
        return $937a0acd9cd30227$export$52f0f02147b12c03.fromExtendedJSON(value);
    }
    if ($937a0acd9cd30227$var$isDBRefLike(value) || value.$dbPointer) {
        var v = value.$ref ? value : value.$dbPointer;
        // we run into this in a "degenerate EJSON" case (with $id and $ref order flipped)
        // because of the order JSON.parse goes through the document
        if (v instanceof $937a0acd9cd30227$export$90e456a500235b9) return v;
        var dollarKeys = Object.keys(v).filter(function(k) {
            return k.startsWith('$');
        });
        var valid_1 = true;
        dollarKeys.forEach(function(k) {
            if ([
                '$ref',
                '$id',
                '$db'
            ].indexOf(k) === -1) valid_1 = false;
        });
        // only make DBRef if $ keys are all valid
        if (valid_1) return $937a0acd9cd30227$export$90e456a500235b9.fromExtendedJSON(v);
    }
    return value;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $937a0acd9cd30227$var$serializeArray(array, options) {
    return array.map(function(v, index) {
        options.seenObjects.push({
            propertyName: "index ".concat(index),
            obj: null
        });
        try {
            return $937a0acd9cd30227$var$serializeValue(v, options);
        } finally{
            options.seenObjects.pop();
        }
    });
}
function $937a0acd9cd30227$var$getISOString(date) {
    var isoStr = date.toISOString();
    // we should only show milliseconds in timestamp if they're non-zero
    return date.getUTCMilliseconds() !== 0 ? isoStr : isoStr.slice(0, -5) + 'Z';
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $937a0acd9cd30227$var$serializeValue(value, options) {
    if ((typeof value === 'object' || typeof value === 'function') && value !== null) {
        var index = options.seenObjects.findIndex(function(entry) {
            return entry.obj === value;
        });
        if (index !== -1) {
            var props = options.seenObjects.map(function(entry) {
                return entry.propertyName;
            });
            var leadingPart = props.slice(0, index).map(function(prop) {
                return "".concat(prop, " -> ");
            }).join('');
            var alreadySeen = props[index];
            var circularPart = ' -> ' + props.slice(index + 1, props.length - 1).map(function(prop) {
                return "".concat(prop, " -> ");
            }).join('');
            var current = props[props.length - 1];
            var leadingSpace = ' '.repeat(leadingPart.length + alreadySeen.length / 2);
            var dashes = '-'.repeat(circularPart.length + (alreadySeen.length + current.length) / 2 - 1);
            throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Converting circular structure to EJSON:\n' + "    ".concat(leadingPart).concat(alreadySeen).concat(circularPart).concat(current, "\n") + "    ".concat(leadingSpace, "\\").concat(dashes, "/"));
        }
        options.seenObjects[options.seenObjects.length - 1].obj = value;
    }
    if (Array.isArray(value)) return $937a0acd9cd30227$var$serializeArray(value, options);
    if (value === undefined) return null;
    if (value instanceof Date || $937a0acd9cd30227$var$isDate(value)) {
        var dateNum = value.getTime(), // is it in year range 1970-9999?
        inRange = dateNum > -1 && dateNum < 253402318800000;
        if (options.legacy) return options.relaxed && inRange ? {
            $date: value.getTime()
        } : {
            $date: $937a0acd9cd30227$var$getISOString(value)
        };
        return options.relaxed && inRange ? {
            $date: $937a0acd9cd30227$var$getISOString(value)
        } : {
            $date: {
                $numberLong: value.getTime().toString()
            }
        };
    }
    if (typeof value === 'number' && (!options.relaxed || !isFinite(value))) {
        // it's an integer
        if (Math.floor(value) === value) {
            var int32Range = value >= $937a0acd9cd30227$var$BSON_INT32_MIN && value <= $937a0acd9cd30227$var$BSON_INT32_MAX, int64Range = value >= $937a0acd9cd30227$var$BSON_INT64_MIN && value <= $937a0acd9cd30227$var$BSON_INT64_MAX;
            // interpret as being of the smallest BSON integer type that can represent the number exactly
            if (int32Range) return {
                $numberInt: value.toString()
            };
            if (int64Range) return {
                $numberLong: value.toString()
            };
        }
        return {
            $numberDouble: value.toString()
        };
    }
    if (value instanceof RegExp || $937a0acd9cd30227$var$isRegExp(value)) {
        var flags = value.flags;
        if (flags === undefined) {
            var match = value.toString().match(/[gimuy]*$/);
            if (match) flags = match[0];
        }
        var rx = new $937a0acd9cd30227$export$f7fea3e08dc99c1d(value.source, flags);
        return rx.toExtendedJSON(options);
    }
    if (value != null && typeof value === 'object') return $937a0acd9cd30227$var$serializeDocument(value, options);
    return value;
}
var $937a0acd9cd30227$var$BSON_TYPE_MAPPINGS = {
    Binary: function(o) {
        return new $937a0acd9cd30227$export$dbada097a9bd1de9(o.value(), o.sub_type);
    },
    Code: function(o) {
        return new $937a0acd9cd30227$export$52f0f02147b12c03(o.code, o.scope);
    },
    DBRef: function(o) {
        return new $937a0acd9cd30227$export$90e456a500235b9(o.collection || o.namespace, o.oid, o.db, o.fields);
    },
    Decimal128: function(o) {
        return new $937a0acd9cd30227$export$39efe8a3f1c2d4eb(o.bytes);
    },
    Double: function(o) {
        return new $937a0acd9cd30227$export$340e583a64e26663(o.value);
    },
    Int32: function(o) {
        return new $937a0acd9cd30227$export$493726e231866ac3(o.value);
    },
    Long: function(o) {
        return $937a0acd9cd30227$export$12ac1d26449d9c2e.fromBits(// underscore variants for 1.x backwards compatibility
        o.low != null ? o.low : o.low_, o.low != null ? o.high : o.high_, o.low != null ? o.unsigned : o.unsigned_);
    },
    MaxKey: function() {
        return new $937a0acd9cd30227$export$d380297cb28b8de0();
    },
    MinKey: function() {
        return new $937a0acd9cd30227$export$aa9d11358976b3cc();
    },
    ObjectID: function(o) {
        return new $937a0acd9cd30227$export$e68967d37d049767(o);
    },
    ObjectId: function(o) {
        return new $937a0acd9cd30227$export$e68967d37d049767(o);
    },
    BSONRegExp: function(o) {
        return new $937a0acd9cd30227$export$f7fea3e08dc99c1d(o.pattern, o.options);
    },
    Symbol: function(o) {
        return new $937a0acd9cd30227$export$8251e971c2f12361(o.value);
    },
    Timestamp: function(o) {
        return $937a0acd9cd30227$export$d9bcbd5e1ff81430.fromBits(o.low, o.high);
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $937a0acd9cd30227$var$serializeDocument(doc, options) {
    if (doc == null || typeof doc !== 'object') throw new $937a0acd9cd30227$export$dcd4c628d4081c37('not an object instance');
    var bsontype = doc._bsontype;
    if (typeof bsontype === 'undefined') {
        // It's a regular object. Recursively serialize its property values.
        var _doc = {};
        for(var name in doc){
            options.seenObjects.push({
                propertyName: name,
                obj: null
            });
            try {
                var value = $937a0acd9cd30227$var$serializeValue(doc[name], options);
                if (name === '__proto__') Object.defineProperty(_doc, name, {
                    value: value,
                    writable: true,
                    enumerable: true,
                    configurable: true
                });
                else _doc[name] = value;
            } finally{
                options.seenObjects.pop();
            }
        }
        return _doc;
    } else if ($937a0acd9cd30227$var$isBSONType(doc)) {
        // the "document" is really just a BSON type object
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var outDoc = doc;
        if (typeof outDoc.toExtendedJSON !== 'function') {
            // There's no EJSON serialization function on the object. It's probably an
            // object created by a previous version of this library (or another library)
            // that's duck-typing objects to look like they were generated by this library).
            // Copy the object into this library's version of that type.
            var mapper = $937a0acd9cd30227$var$BSON_TYPE_MAPPINGS[doc._bsontype];
            if (!mapper) throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Unrecognized or invalid _bsontype: ' + doc._bsontype);
            outDoc = mapper(outDoc);
        }
        // Two BSON types may have nested objects that may need to be serialized too
        if (bsontype === 'Code' && outDoc.scope) outDoc = new $937a0acd9cd30227$export$52f0f02147b12c03(outDoc.code, $937a0acd9cd30227$var$serializeValue(outDoc.scope, options));
        else if (bsontype === 'DBRef' && outDoc.oid) outDoc = new $937a0acd9cd30227$export$90e456a500235b9($937a0acd9cd30227$var$serializeValue(outDoc.collection, options), $937a0acd9cd30227$var$serializeValue(outDoc.oid, options), $937a0acd9cd30227$var$serializeValue(outDoc.db, options), $937a0acd9cd30227$var$serializeValue(outDoc.fields, options));
        return outDoc.toExtendedJSON(options);
    } else throw new $937a0acd9cd30227$export$dcd4c628d4081c37('_bsontype must be a string, but was: ' + typeof bsontype);
}
/**
 * EJSON parse / stringify API
 * @public
 */ // the namespace here is used to emulate `export * as EJSON from '...'`
// which as of now (sept 2020) api-extractor does not support
// eslint-disable-next-line @typescript-eslint/no-namespace
var $937a0acd9cd30227$export$88f9200ef2b97bb5;
(function(EJSON) {
    /**
     * Parse an Extended JSON string, constructing the JavaScript value or object described by that
     * string.
     *
     * @example
     * ```js
     * const { EJSON } = require('bson');
     * const text = '{ "int32": { "$numberInt": "10" } }';
     *
     * // prints { int32: { [String: '10'] _bsontype: 'Int32', value: '10' } }
     * console.log(EJSON.parse(text, { relaxed: false }));
     *
     * // prints { int32: 10 }
     * console.log(EJSON.parse(text));
     * ```
     */ function parse(text, options) {
        var finalOptions = Object.assign({}, {
            relaxed: true,
            legacy: false
        }, options);
        // relaxed implies not strict
        if (typeof finalOptions.relaxed === 'boolean') finalOptions.strict = !finalOptions.relaxed;
        if (typeof finalOptions.strict === 'boolean') finalOptions.relaxed = !finalOptions.strict;
        return JSON.parse(text, function(key, value) {
            if (key.indexOf('\x00') !== -1) throw new $937a0acd9cd30227$export$dcd4c628d4081c37("BSON Document field names cannot contain null bytes, found: ".concat(JSON.stringify(key)));
            return $937a0acd9cd30227$var$deserializeValue(value, finalOptions);
        });
    }
    EJSON.parse = parse;
    /**
     * Converts a BSON document to an Extended JSON string, optionally replacing values if a replacer
     * function is specified or optionally including only the specified properties if a replacer array
     * is specified.
     *
     * @param value - The value to convert to extended JSON
     * @param replacer - A function that alters the behavior of the stringification process, or an array of String and Number objects that serve as a whitelist for selecting/filtering the properties of the value object to be included in the JSON string. If this value is null or not provided, all properties of the object are included in the resulting JSON string
     * @param space - A String or Number object that's used to insert white space into the output JSON string for readability purposes.
     * @param options - Optional settings
     *
     * @example
     * ```js
     * const { EJSON } = require('bson');
     * const Int32 = require('mongodb').Int32;
     * const doc = { int32: new Int32(10) };
     *
     * // prints '{"int32":{"$numberInt":"10"}}'
     * console.log(EJSON.stringify(doc, { relaxed: false }));
     *
     * // prints '{"int32":10}'
     * console.log(EJSON.stringify(doc));
     * ```
     */ function stringify(value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    replacer, space, options) {
        if (space != null && typeof space === 'object') {
            options = space;
            space = 0;
        }
        if (replacer != null && typeof replacer === 'object' && !Array.isArray(replacer)) {
            options = replacer;
            replacer = undefined;
            space = 0;
        }
        var serializeOptions = Object.assign({
            relaxed: true,
            legacy: false
        }, options, {
            seenObjects: [
                {
                    propertyName: '(root)',
                    obj: null
                }
            ]
        });
        var doc = $937a0acd9cd30227$var$serializeValue(value, serializeOptions);
        return JSON.stringify(doc, replacer, space);
    }
    EJSON.stringify = stringify;
    /**
     * Serializes an object to an Extended JSON string, and reparse it as a JavaScript object.
     *
     * @param value - The object to serialize
     * @param options - Optional settings passed to the `stringify` function
     */ function serialize(value, options) {
        options = options || {};
        return JSON.parse(stringify(value, options));
    }
    EJSON.serialize = serialize;
    /**
     * Deserializes an Extended JSON object into a plain JavaScript object with native/BSON types
     *
     * @param ejson - The Extended JSON object to deserialize
     * @param options - Optional settings passed to the parse method
     */ function deserialize(ejson, options) {
        options = options || {};
        return parse(JSON.stringify(ejson), options);
    }
    EJSON.deserialize = deserialize;
})($937a0acd9cd30227$export$88f9200ef2b97bb5 || ($937a0acd9cd30227$export$88f9200ef2b97bb5 = {}));
/* eslint-disable @typescript-eslint/no-explicit-any */ /** @public */ var $937a0acd9cd30227$export$a5c7b93649eaf8f8;
var $937a0acd9cd30227$var$bsonGlobal = $937a0acd9cd30227$var$getGlobal();
if ($937a0acd9cd30227$var$bsonGlobal.Map) $937a0acd9cd30227$export$a5c7b93649eaf8f8 = $937a0acd9cd30227$var$bsonGlobal.Map;
else // We will return a polyfill
$937a0acd9cd30227$export$a5c7b93649eaf8f8 = /** @class */ function() {
    function Map(array) {
        if (array === void 0) array = [];
        this._keys = [];
        this._values = {};
        for(var i = 0; i < array.length; i++){
            if (array[i] == null) continue; // skip null and undefined
            var entry = array[i];
            var key = entry[0];
            var value = entry[1];
            // Add the key to the list of keys in order
            this._keys.push(key);
            // Add the key and value to the values dictionary with a point
            // to the location in the ordered keys list
            this._values[key] = {
                v: value,
                i: this._keys.length - 1
            };
        }
    }
    Map.prototype.clear = function() {
        this._keys = [];
        this._values = {};
    };
    Map.prototype.delete = function(key) {
        var value = this._values[key];
        if (value == null) return false;
        // Delete entry
        delete this._values[key];
        // Remove the key from the ordered keys list
        this._keys.splice(value.i, 1);
        return true;
    };
    Map.prototype.entries = function() {
        var _this = this;
        var index = 0;
        return {
            next: function() {
                var key = _this._keys[index++];
                return {
                    value: key !== undefined ? [
                        key,
                        _this._values[key].v
                    ] : undefined,
                    done: key !== undefined ? false : true
                };
            }
        };
    };
    Map.prototype.forEach = function(callback, self1) {
        self1 = self1 || this;
        for(var i = 0; i < this._keys.length; i++){
            var key = this._keys[i];
            // Call the forEach callback
            callback.call(self1, this._values[key].v, key, self1);
        }
    };
    Map.prototype.get = function(key) {
        return this._values[key] ? this._values[key].v : undefined;
    };
    Map.prototype.has = function(key) {
        return this._values[key] != null;
    };
    Map.prototype.keys = function() {
        var _this = this;
        var index = 0;
        return {
            next: function() {
                var key = _this._keys[index++];
                return {
                    value: key !== undefined ? key : undefined,
                    done: key !== undefined ? false : true
                };
            }
        };
    };
    Map.prototype.set = function(key, value) {
        if (this._values[key]) {
            this._values[key].v = value;
            return this;
        }
        // Add the key to the list of keys in order
        this._keys.push(key);
        // Add the key and value to the values dictionary with a point
        // to the location in the ordered keys list
        this._values[key] = {
            v: value,
            i: this._keys.length - 1
        };
        return this;
    };
    Map.prototype.values = function() {
        var _this = this;
        var index = 0;
        return {
            next: function() {
                var key = _this._keys[index++];
                return {
                    value: key !== undefined ? _this._values[key].v : undefined,
                    done: key !== undefined ? false : true
                };
            }
        };
    };
    Object.defineProperty(Map.prototype, "size", {
        get: function() {
            return this._keys.length;
        },
        enumerable: false,
        configurable: true
    });
    return Map;
}();
function $937a0acd9cd30227$var$calculateObjectSize$1(object, serializeFunctions, ignoreUndefined) {
    var totalLength = 5;
    if (Array.isArray(object)) for(var i = 0; i < object.length; i++)totalLength += $937a0acd9cd30227$var$calculateElement(i.toString(), object[i], serializeFunctions, true, ignoreUndefined);
    else {
        // If we have toBSON defined, override the current object
        if (typeof (object === null || object === void 0 ? void 0 : object.toBSON) === 'function') object = object.toBSON();
        // Calculate size
        for(var key in object)totalLength += $937a0acd9cd30227$var$calculateElement(key, object[key], serializeFunctions, false, ignoreUndefined);
    }
    return totalLength;
}
/** @internal */ function $937a0acd9cd30227$var$calculateElement(name, // eslint-disable-next-line @typescript-eslint/no-explicit-any
value, serializeFunctions, isArray, ignoreUndefined) {
    if (serializeFunctions === void 0) serializeFunctions = false;
    if (isArray === void 0) isArray = false;
    if (ignoreUndefined === void 0) ignoreUndefined = false;
    // If we have toBSON defined, override the current object
    if (typeof (value === null || value === void 0 ? void 0 : value.toBSON) === 'function') value = value.toBSON();
    switch(typeof value){
        case 'string':
            return 1 + $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 + 4 + $937a0acd9cd30227$var$buffer_1.byteLength(value, 'utf8') + 1;
        case 'number':
            if (Math.floor(value) === value && value >= $937a0acd9cd30227$var$JS_INT_MIN && value <= $937a0acd9cd30227$var$JS_INT_MAX) {
                if (value >= $937a0acd9cd30227$export$250fc463de59e142 && value <= $937a0acd9cd30227$export$af352521c8649ed7) // 32 bit
                return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 5;
                else return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 9;
            } else // 64 bit
            return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 9;
        case 'undefined':
            if (isArray || !ignoreUndefined) return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 1;
            return 0;
        case 'boolean':
            return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 2;
        case 'object':
            if (value == null || value['_bsontype'] === 'MinKey' || value['_bsontype'] === 'MaxKey') return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 1;
            else if (value['_bsontype'] === 'ObjectId' || value['_bsontype'] === 'ObjectID') return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 13;
            else if (value instanceof Date || $937a0acd9cd30227$var$isDate(value)) return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 9;
            else if (ArrayBuffer.isView(value) || value instanceof ArrayBuffer || $937a0acd9cd30227$var$isAnyArrayBuffer(value)) return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 6 + value.byteLength;
            else if (value['_bsontype'] === 'Long' || value['_bsontype'] === 'Double' || value['_bsontype'] === 'Timestamp') return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 9;
            else if (value['_bsontype'] === 'Decimal128') return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 17;
            else if (value['_bsontype'] === 'Code') {
                // Calculate size depending on the availability of a scope
                if (value.scope != null && Object.keys(value.scope).length > 0) return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 1 + 4 + 4 + $937a0acd9cd30227$var$buffer_1.byteLength(value.code.toString(), 'utf8') + 1 + $937a0acd9cd30227$var$calculateObjectSize$1(value.scope, serializeFunctions, ignoreUndefined);
                else return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 1 + 4 + $937a0acd9cd30227$var$buffer_1.byteLength(value.code.toString(), 'utf8') + 1;
            } else if (value['_bsontype'] === 'Binary') {
                var binary = value;
                // Check what kind of subtype we have
                if (binary.sub_type === $937a0acd9cd30227$export$dbada097a9bd1de9.SUBTYPE_BYTE_ARRAY) return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + (binary.position + 1 + 4 + 1 + 4);
                else return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + (binary.position + 1 + 4 + 1);
            } else if (value['_bsontype'] === 'Symbol') return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + $937a0acd9cd30227$var$buffer_1.byteLength(value.value, 'utf8') + 4 + 1 + 1;
            else if (value['_bsontype'] === 'DBRef') {
                // Set up correct object for serialization
                var ordered_values = Object.assign({
                    $ref: value.collection,
                    $id: value.oid
                }, value.fields);
                // Add db reference if it exists
                if (value.db != null) ordered_values['$db'] = value.db;
                return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 1 + $937a0acd9cd30227$var$calculateObjectSize$1(ordered_values, serializeFunctions, ignoreUndefined);
            } else if (value instanceof RegExp || $937a0acd9cd30227$var$isRegExp(value)) return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 1 + $937a0acd9cd30227$var$buffer_1.byteLength(value.source, 'utf8') + 1 + (value.global ? 1 : 0) + (value.ignoreCase ? 1 : 0) + (value.multiline ? 1 : 0) + 1;
            else if (value['_bsontype'] === 'BSONRegExp') return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 1 + $937a0acd9cd30227$var$buffer_1.byteLength(value.pattern, 'utf8') + 1 + $937a0acd9cd30227$var$buffer_1.byteLength(value.options, 'utf8') + 1;
            else return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + $937a0acd9cd30227$var$calculateObjectSize$1(value, serializeFunctions, ignoreUndefined) + 1;
        case 'function':
            // WTF for 0.4.X where typeof /someregexp/ === 'function'
            if (value instanceof RegExp || $937a0acd9cd30227$var$isRegExp(value) || String.call(value) === '[object RegExp]') return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 1 + $937a0acd9cd30227$var$buffer_1.byteLength(value.source, 'utf8') + 1 + (value.global ? 1 : 0) + (value.ignoreCase ? 1 : 0) + (value.multiline ? 1 : 0) + 1;
            else {
                if (serializeFunctions && value.scope != null && Object.keys(value.scope).length > 0) return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 1 + 4 + 4 + $937a0acd9cd30227$var$buffer_1.byteLength($937a0acd9cd30227$var$normalizedFunctionString(value), 'utf8') + 1 + $937a0acd9cd30227$var$calculateObjectSize$1(value.scope, serializeFunctions, ignoreUndefined);
                else if (serializeFunctions) return (name != null ? $937a0acd9cd30227$var$buffer_1.byteLength(name, 'utf8') + 1 : 0) + 1 + 4 + $937a0acd9cd30227$var$buffer_1.byteLength($937a0acd9cd30227$var$normalizedFunctionString(value), 'utf8') + 1;
            }
    }
    return 0;
}
var $937a0acd9cd30227$var$FIRST_BIT = 0x80;
var $937a0acd9cd30227$var$FIRST_TWO_BITS = 0xc0;
var $937a0acd9cd30227$var$FIRST_THREE_BITS = 0xe0;
var $937a0acd9cd30227$var$FIRST_FOUR_BITS = 0xf0;
var $937a0acd9cd30227$var$FIRST_FIVE_BITS = 0xf8;
var $937a0acd9cd30227$var$TWO_BIT_CHAR = 0xc0;
var $937a0acd9cd30227$var$THREE_BIT_CHAR = 0xe0;
var $937a0acd9cd30227$var$FOUR_BIT_CHAR = 0xf0;
var $937a0acd9cd30227$var$CONTINUING_CHAR = 0x80;
/**
 * Determines if the passed in bytes are valid utf8
 * @param bytes - An array of 8-bit bytes. Must be indexable and have length property
 * @param start - The index to start validating
 * @param end - The index to end validating
 */ function $937a0acd9cd30227$var$validateUtf8(bytes, start, end) {
    var continuation = 0;
    for(var i = start; i < end; i += 1){
        var byte = bytes[i];
        if (continuation) {
            if ((byte & $937a0acd9cd30227$var$FIRST_TWO_BITS) !== $937a0acd9cd30227$var$CONTINUING_CHAR) return false;
            continuation -= 1;
        } else if (byte & $937a0acd9cd30227$var$FIRST_BIT) {
            if ((byte & $937a0acd9cd30227$var$FIRST_THREE_BITS) === $937a0acd9cd30227$var$TWO_BIT_CHAR) continuation = 1;
            else if ((byte & $937a0acd9cd30227$var$FIRST_FOUR_BITS) === $937a0acd9cd30227$var$THREE_BIT_CHAR) continuation = 2;
            else if ((byte & $937a0acd9cd30227$var$FIRST_FIVE_BITS) === $937a0acd9cd30227$var$FOUR_BIT_CHAR) continuation = 3;
            else return false;
        }
    }
    return !continuation;
}
// Internal long versions
var $937a0acd9cd30227$var$JS_INT_MAX_LONG = $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber($937a0acd9cd30227$var$JS_INT_MAX);
var $937a0acd9cd30227$var$JS_INT_MIN_LONG = $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber($937a0acd9cd30227$var$JS_INT_MIN);
var $937a0acd9cd30227$var$functionCache = {};
function $937a0acd9cd30227$var$deserialize$1(buffer, options, isArray) {
    options = options == null ? {} : options;
    var index = options && options.index ? options.index : 0;
    // Read the document size
    var size = buffer[index] | buffer[index + 1] << 8 | buffer[index + 2] << 16 | buffer[index + 3] << 24;
    if (size < 5) throw new $937a0acd9cd30227$export$dcd4c628d4081c37("bson size must be >= 5, is ".concat(size));
    if (options.allowObjectSmallerThanBufferSize && buffer.length < size) throw new $937a0acd9cd30227$export$dcd4c628d4081c37("buffer length ".concat(buffer.length, " must be >= bson size ").concat(size));
    if (!options.allowObjectSmallerThanBufferSize && buffer.length !== size) throw new $937a0acd9cd30227$export$dcd4c628d4081c37("buffer length ".concat(buffer.length, " must === bson size ").concat(size));
    if (size + index > buffer.byteLength) throw new $937a0acd9cd30227$export$dcd4c628d4081c37("(bson size ".concat(size, " + options.index ").concat(index, " must be <= buffer length ").concat(buffer.byteLength, ")"));
    // Illegal end value
    if (buffer[index + size - 1] !== 0) throw new $937a0acd9cd30227$export$dcd4c628d4081c37("One object, sized correctly, with a spot for an EOO, but the EOO isn't 0x00");
    // Start deserializtion
    return $937a0acd9cd30227$var$deserializeObject(buffer, index, options, isArray);
}
var $937a0acd9cd30227$var$allowedDBRefKeys = /^\$ref$|^\$id$|^\$db$/;
function $937a0acd9cd30227$var$deserializeObject(buffer, index, options, isArray) {
    if (isArray === void 0) isArray = false;
    var evalFunctions = options['evalFunctions'] == null ? false : options['evalFunctions'];
    var cacheFunctions = options['cacheFunctions'] == null ? false : options['cacheFunctions'];
    var fieldsAsRaw = options['fieldsAsRaw'] == null ? null : options['fieldsAsRaw'];
    // Return raw bson buffer instead of parsing it
    var raw = options['raw'] == null ? false : options['raw'];
    // Return BSONRegExp objects instead of native regular expressions
    var bsonRegExp = typeof options['bsonRegExp'] === 'boolean' ? options['bsonRegExp'] : false;
    // Controls the promotion of values vs wrapper classes
    var promoteBuffers = options['promoteBuffers'] == null ? false : options['promoteBuffers'];
    var promoteLongs = options['promoteLongs'] == null ? true : options['promoteLongs'];
    var promoteValues = options['promoteValues'] == null ? true : options['promoteValues'];
    // Ensures default validation option if none given
    var validation = options.validation == null ? {
        utf8: true
    } : options.validation;
    // Shows if global utf-8 validation is enabled or disabled
    var globalUTFValidation = true;
    // Reflects utf-8 validation setting regardless of global or specific key validation
    var validationSetting;
    // Set of keys either to enable or disable validation on
    var utf8KeysSet = new Set();
    // Check for boolean uniformity and empty validation option
    var utf8ValidatedKeys = validation.utf8;
    if (typeof utf8ValidatedKeys === 'boolean') validationSetting = utf8ValidatedKeys;
    else {
        globalUTFValidation = false;
        var utf8ValidationValues = Object.keys(utf8ValidatedKeys).map(function(key) {
            return utf8ValidatedKeys[key];
        });
        if (utf8ValidationValues.length === 0) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('UTF-8 validation setting cannot be empty');
        if (typeof utf8ValidationValues[0] !== 'boolean') throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Invalid UTF-8 validation option, must specify boolean values');
        validationSetting = utf8ValidationValues[0];
        // Ensures boolean uniformity in utf-8 validation (all true or all false)
        if (!utf8ValidationValues.every(function(item) {
            return item === validationSetting;
        })) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Invalid UTF-8 validation option - keys must be all true or all false');
    }
    // Add keys to set that will either be validated or not based on validationSetting
    if (!globalUTFValidation) for(var _i = 0, _a = Object.keys(utf8ValidatedKeys); _i < _a.length; _i++){
        var key = _a[_i];
        utf8KeysSet.add(key);
    }
    // Set the start index
    var startIndex = index;
    // Validate that we have at least 4 bytes of buffer
    if (buffer.length < 5) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('corrupt bson message < 5 bytes long');
    // Read the document size
    var size = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
    // Ensure buffer is valid size
    if (size < 5 || size > buffer.length) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('corrupt bson message');
    // Create holding object
    var object = isArray ? [] : {};
    // Used for arrays to skip having to perform utf8 decoding
    var arrayIndex = 0;
    var done = false;
    var isPossibleDBRef = isArray ? false : null;
    // While we have more left data left keep parsing
    var dataview = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    while(!done){
        // Read the type
        var elementType = buffer[index++];
        // If we get a zero it's the last byte, exit
        if (elementType === 0) break;
        // Get the start search index
        var i = index;
        // Locate the end of the c string
        while(buffer[i] !== 0x00 && i < buffer.length)i++;
        // If are at the end of the buffer there is a problem with the document
        if (i >= buffer.byteLength) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Bad BSON Document: illegal CString');
        // Represents the key
        var name = isArray ? arrayIndex++ : buffer.toString('utf8', index, i);
        // shouldValidateKey is true if the key should be validated, false otherwise
        var shouldValidateKey = true;
        if (globalUTFValidation || utf8KeysSet.has(name)) shouldValidateKey = validationSetting;
        else shouldValidateKey = !validationSetting;
        if (isPossibleDBRef !== false && name[0] === '$') isPossibleDBRef = $937a0acd9cd30227$var$allowedDBRefKeys.test(name);
        var value = void 0;
        index = i + 1;
        if (elementType === $937a0acd9cd30227$export$2ce63c0cc3c9284) {
            var stringSize = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
            if (stringSize <= 0 || stringSize > buffer.length - index || buffer[index + stringSize - 1] !== 0) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('bad string length in bson');
            value = $937a0acd9cd30227$var$getValidatedString(buffer, index, index + stringSize - 1, shouldValidateKey);
            index = index + stringSize;
        } else if (elementType === $937a0acd9cd30227$export$9c296bef3f2e3a80) {
            var oid = $937a0acd9cd30227$var$buffer_1.alloc(12);
            buffer.copy(oid, 0, index, index + 12);
            value = new $937a0acd9cd30227$export$e68967d37d049767(oid);
            index = index + 12;
        } else if (elementType === $937a0acd9cd30227$export$6b19edc38baa1a8c && promoteValues === false) value = new $937a0acd9cd30227$export$493726e231866ac3(buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24);
        else if (elementType === $937a0acd9cd30227$export$6b19edc38baa1a8c) value = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
        else if (elementType === $937a0acd9cd30227$export$8a26a5fd67132695 && promoteValues === false) {
            value = new $937a0acd9cd30227$export$340e583a64e26663(dataview.getFloat64(index, true));
            index = index + 8;
        } else if (elementType === $937a0acd9cd30227$export$8a26a5fd67132695) {
            value = dataview.getFloat64(index, true);
            index = index + 8;
        } else if (elementType === $937a0acd9cd30227$export$ff98a022f476c9f6) {
            var lowBits = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
            var highBits = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
            value = new Date(new $937a0acd9cd30227$export$12ac1d26449d9c2e(lowBits, highBits).toNumber());
        } else if (elementType === $937a0acd9cd30227$export$ddfe5b18c2cb4c61) {
            if (buffer[index] !== 0 && buffer[index] !== 1) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('illegal boolean type value');
            value = buffer[index++] === 1;
        } else if (elementType === $937a0acd9cd30227$export$5a91d81c75e64abe) {
            var _index = index;
            var objectSize = buffer[index] | buffer[index + 1] << 8 | buffer[index + 2] << 16 | buffer[index + 3] << 24;
            if (objectSize <= 0 || objectSize > buffer.length - index) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('bad embedded document length in bson');
            // We have a raw value
            if (raw) value = buffer.slice(index, index + objectSize);
            else {
                var objectOptions = options;
                if (!globalUTFValidation) objectOptions = $937a0acd9cd30227$var$_assign($937a0acd9cd30227$var$_assign({}, options), {
                    validation: {
                        utf8: shouldValidateKey
                    }
                });
                value = $937a0acd9cd30227$var$deserializeObject(buffer, _index, objectOptions, false);
            }
            index = index + objectSize;
        } else if (elementType === $937a0acd9cd30227$export$a158b7540a414b0) {
            var _index = index;
            var objectSize = buffer[index] | buffer[index + 1] << 8 | buffer[index + 2] << 16 | buffer[index + 3] << 24;
            var arrayOptions = options;
            // Stop index
            var stopIndex = index + objectSize;
            // All elements of array to be returned as raw bson
            if (fieldsAsRaw && fieldsAsRaw[name]) {
                arrayOptions = {};
                for(var n in options)arrayOptions[n] = options[n];
                arrayOptions['raw'] = true;
            }
            if (!globalUTFValidation) arrayOptions = $937a0acd9cd30227$var$_assign($937a0acd9cd30227$var$_assign({}, arrayOptions), {
                validation: {
                    utf8: shouldValidateKey
                }
            });
            value = $937a0acd9cd30227$var$deserializeObject(buffer, _index, arrayOptions, true);
            index = index + objectSize;
            if (buffer[index - 1] !== 0) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('invalid array terminator byte');
            if (index !== stopIndex) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('corrupted array bson');
        } else if (elementType === $937a0acd9cd30227$export$d4e0c9abd56073d0) value = undefined;
        else if (elementType === $937a0acd9cd30227$export$a9d27ecf911c8e2d) value = null;
        else if (elementType === $937a0acd9cd30227$export$c07849652d011312) {
            // Unpack the low and high bits
            var lowBits = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
            var highBits = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
            var long = new $937a0acd9cd30227$export$12ac1d26449d9c2e(lowBits, highBits);
            // Promote the long if possible
            if (promoteLongs && promoteValues === true) value = long.lessThanOrEqual($937a0acd9cd30227$var$JS_INT_MAX_LONG) && long.greaterThanOrEqual($937a0acd9cd30227$var$JS_INT_MIN_LONG) ? long.toNumber() : long;
            else value = long;
        } else if (elementType === $937a0acd9cd30227$export$cde5e2a4f8adcb68) {
            // Buffer to contain the decimal bytes
            var bytes = $937a0acd9cd30227$var$buffer_1.alloc(16);
            // Copy the next 16 bytes into the bytes buffer
            buffer.copy(bytes, 0, index, index + 16);
            // Update index
            index = index + 16;
            // Assign the new Decimal128 value
            var decimal128 = new $937a0acd9cd30227$export$39efe8a3f1c2d4eb(bytes);
            // If we have an alternative mapper use that
            if ('toObject' in decimal128 && typeof decimal128.toObject === 'function') value = decimal128.toObject();
            else value = decimal128;
        } else if (elementType === $937a0acd9cd30227$export$a6d049d73c03641) {
            var binarySize = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
            var totalBinarySize = binarySize;
            var subType = buffer[index++];
            // Did we have a negative binary size, throw
            if (binarySize < 0) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Negative binary type element size found');
            // Is the length longer than the document
            if (binarySize > buffer.byteLength) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Binary type size larger than document size');
            // Decode as raw Buffer object if options specifies it
            if (buffer['slice'] != null) {
                // If we have subtype 2 skip the 4 bytes for the size
                if (subType === $937a0acd9cd30227$export$dbada097a9bd1de9.SUBTYPE_BYTE_ARRAY) {
                    binarySize = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
                    if (binarySize < 0) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Negative binary type element size found for subtype 0x02');
                    if (binarySize > totalBinarySize - 4) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Binary type with subtype 0x02 contains too long binary size');
                    if (binarySize < totalBinarySize - 4) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Binary type with subtype 0x02 contains too short binary size');
                }
                if (promoteBuffers && promoteValues) value = buffer.slice(index, index + binarySize);
                else {
                    value = new $937a0acd9cd30227$export$dbada097a9bd1de9(buffer.slice(index, index + binarySize), subType);
                    if (subType === $937a0acd9cd30227$export$17bbee584f46fa68) value = value.toUUID();
                }
            } else {
                var _buffer = $937a0acd9cd30227$var$buffer_1.alloc(binarySize);
                // If we have subtype 2 skip the 4 bytes for the size
                if (subType === $937a0acd9cd30227$export$dbada097a9bd1de9.SUBTYPE_BYTE_ARRAY) {
                    binarySize = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
                    if (binarySize < 0) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Negative binary type element size found for subtype 0x02');
                    if (binarySize > totalBinarySize - 4) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Binary type with subtype 0x02 contains too long binary size');
                    if (binarySize < totalBinarySize - 4) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Binary type with subtype 0x02 contains too short binary size');
                }
                // Copy the data
                for(i = 0; i < binarySize; i++)_buffer[i] = buffer[index + i];
                if (promoteBuffers && promoteValues) value = _buffer;
                else if (subType === $937a0acd9cd30227$export$17bbee584f46fa68) value = new $937a0acd9cd30227$export$dbada097a9bd1de9(buffer.slice(index, index + binarySize), subType).toUUID();
                else value = new $937a0acd9cd30227$export$dbada097a9bd1de9(buffer.slice(index, index + binarySize), subType);
            }
            // Update the index
            index = index + binarySize;
        } else if (elementType === $937a0acd9cd30227$export$73020e19fe1a5dcb && bsonRegExp === false) {
            // Get the start search index
            i = index;
            // Locate the end of the c string
            while(buffer[i] !== 0x00 && i < buffer.length)i++;
            // If are at the end of the buffer there is a problem with the document
            if (i >= buffer.length) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Bad BSON Document: illegal CString');
            // Return the C string
            var source = buffer.toString('utf8', index, i);
            // Create the regexp
            index = i + 1;
            // Get the start search index
            i = index;
            // Locate the end of the c string
            while(buffer[i] !== 0x00 && i < buffer.length)i++;
            // If are at the end of the buffer there is a problem with the document
            if (i >= buffer.length) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Bad BSON Document: illegal CString');
            // Return the C string
            var regExpOptions = buffer.toString('utf8', index, i);
            index = i + 1;
            // For each option add the corresponding one for javascript
            var optionsArray = new Array(regExpOptions.length);
            // Parse options
            for(i = 0; i < regExpOptions.length; i++)switch(regExpOptions[i]){
                case 'm':
                    optionsArray[i] = 'm';
                    break;
                case 's':
                    optionsArray[i] = 'g';
                    break;
                case 'i':
                    optionsArray[i] = 'i';
                    break;
            }
            value = new RegExp(source, optionsArray.join(''));
        } else if (elementType === $937a0acd9cd30227$export$73020e19fe1a5dcb && bsonRegExp === true) {
            // Get the start search index
            i = index;
            // Locate the end of the c string
            while(buffer[i] !== 0x00 && i < buffer.length)i++;
            // If are at the end of the buffer there is a problem with the document
            if (i >= buffer.length) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Bad BSON Document: illegal CString');
            // Return the C string
            var source = buffer.toString('utf8', index, i);
            index = i + 1;
            // Get the start search index
            i = index;
            // Locate the end of the c string
            while(buffer[i] !== 0x00 && i < buffer.length)i++;
            // If are at the end of the buffer there is a problem with the document
            if (i >= buffer.length) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Bad BSON Document: illegal CString');
            // Return the C string
            var regExpOptions = buffer.toString('utf8', index, i);
            index = i + 1;
            // Set the object
            value = new $937a0acd9cd30227$export$f7fea3e08dc99c1d(source, regExpOptions);
        } else if (elementType === $937a0acd9cd30227$export$d18896fc584f464b) {
            var stringSize = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
            if (stringSize <= 0 || stringSize > buffer.length - index || buffer[index + stringSize - 1] !== 0) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('bad string length in bson');
            var symbol = $937a0acd9cd30227$var$getValidatedString(buffer, index, index + stringSize - 1, shouldValidateKey);
            value = promoteValues ? symbol : new $937a0acd9cd30227$export$8251e971c2f12361(symbol);
            index = index + stringSize;
        } else if (elementType === $937a0acd9cd30227$export$86ca409d085d6fb2) {
            var lowBits = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
            var highBits = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
            value = new $937a0acd9cd30227$export$d9bcbd5e1ff81430(lowBits, highBits);
        } else if (elementType === $937a0acd9cd30227$export$988fa02d40535509) value = new $937a0acd9cd30227$export$aa9d11358976b3cc();
        else if (elementType === $937a0acd9cd30227$export$42679d8c82a5a5a0) value = new $937a0acd9cd30227$export$d380297cb28b8de0();
        else if (elementType === $937a0acd9cd30227$export$4d96c08829372834) {
            var stringSize = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
            if (stringSize <= 0 || stringSize > buffer.length - index || buffer[index + stringSize - 1] !== 0) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('bad string length in bson');
            var functionString = $937a0acd9cd30227$var$getValidatedString(buffer, index, index + stringSize - 1, shouldValidateKey);
            // If we are evaluating the functions
            if (evalFunctions) {
                // If we have cache enabled let's look for the md5 of the function in the cache
                if (cacheFunctions) // Got to do this to avoid V8 deoptimizing the call due to finding eval
                value = $937a0acd9cd30227$var$isolateEval(functionString, $937a0acd9cd30227$var$functionCache, object);
                else value = $937a0acd9cd30227$var$isolateEval(functionString);
            } else value = new $937a0acd9cd30227$export$52f0f02147b12c03(functionString);
            // Update parse index position
            index = index + stringSize;
        } else if (elementType === $937a0acd9cd30227$export$959338844bb54803) {
            var totalSize = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
            // Element cannot be shorter than totalSize + stringSize + documentSize + terminator
            if (totalSize < 13) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('code_w_scope total size shorter minimum expected length');
            // Get the code string size
            var stringSize = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
            // Check if we have a valid string
            if (stringSize <= 0 || stringSize > buffer.length - index || buffer[index + stringSize - 1] !== 0) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('bad string length in bson');
            // Javascript function
            var functionString = $937a0acd9cd30227$var$getValidatedString(buffer, index, index + stringSize - 1, shouldValidateKey);
            // Update parse index position
            index = index + stringSize;
            // Parse the element
            var _index = index;
            // Decode the size of the object document
            var objectSize = buffer[index] | buffer[index + 1] << 8 | buffer[index + 2] << 16 | buffer[index + 3] << 24;
            // Decode the scope object
            var scopeObject = $937a0acd9cd30227$var$deserializeObject(buffer, _index, options, false);
            // Adjust the index
            index = index + objectSize;
            // Check if field length is too short
            if (totalSize < 8 + objectSize + stringSize) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('code_w_scope total size is too short, truncating scope');
            // Check if totalSize field is too long
            if (totalSize > 8 + objectSize + stringSize) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('code_w_scope total size is too long, clips outer document');
            // If we are evaluating the functions
            if (evalFunctions) {
                // If we have cache enabled let's look for the md5 of the function in the cache
                if (cacheFunctions) // Got to do this to avoid V8 deoptimizing the call due to finding eval
                value = $937a0acd9cd30227$var$isolateEval(functionString, $937a0acd9cd30227$var$functionCache, object);
                else value = $937a0acd9cd30227$var$isolateEval(functionString);
                value.scope = scopeObject;
            } else value = new $937a0acd9cd30227$export$52f0f02147b12c03(functionString, scopeObject);
        } else if (elementType === $937a0acd9cd30227$export$e22680776caf5882) {
            // Get the code string size
            var stringSize = buffer[index++] | buffer[index++] << 8 | buffer[index++] << 16 | buffer[index++] << 24;
            // Check if we have a valid string
            if (stringSize <= 0 || stringSize > buffer.length - index || buffer[index + stringSize - 1] !== 0) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('bad string length in bson');
            // Namespace
            if (validation != null && validation.utf8) {
                if (!$937a0acd9cd30227$var$validateUtf8(buffer, index, index + stringSize - 1)) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Invalid UTF-8 string in BSON document');
            }
            var namespace = buffer.toString('utf8', index, index + stringSize - 1);
            // Update parse index position
            index = index + stringSize;
            // Read the oid
            var oidBuffer = $937a0acd9cd30227$var$buffer_1.alloc(12);
            buffer.copy(oidBuffer, 0, index, index + 12);
            var oid = new $937a0acd9cd30227$export$e68967d37d049767(oidBuffer);
            // Update the index
            index = index + 12;
            // Upgrade to DBRef type
            value = new $937a0acd9cd30227$export$90e456a500235b9(namespace, oid);
        } else throw new $937a0acd9cd30227$export$dcd4c628d4081c37("Detected unknown BSON type ".concat(elementType.toString(16), " for fieldname \"").concat(name, "\""));
        if (name === '__proto__') Object.defineProperty(object, name, {
            value: value,
            writable: true,
            enumerable: true,
            configurable: true
        });
        else object[name] = value;
    }
    // Check if the deserialization was against a valid array/object
    if (size !== index - startIndex) {
        if (isArray) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('corrupt array bson');
        throw new $937a0acd9cd30227$export$dcd4c628d4081c37('corrupt object bson');
    }
    // if we did not find "$ref", "$id", "$db", or found an extraneous $key, don't make a DBRef
    if (!isPossibleDBRef) return object;
    if ($937a0acd9cd30227$var$isDBRefLike(object)) {
        var copy = Object.assign({}, object);
        delete copy.$ref;
        delete copy.$id;
        delete copy.$db;
        return new $937a0acd9cd30227$export$90e456a500235b9(object.$ref, object.$id, object.$db, copy);
    }
    return object;
}
/**
 * Ensure eval is isolated, store the result in functionCache.
 *
 * @internal
 */ function $937a0acd9cd30227$var$isolateEval(functionString, functionCache, object) {
    // eslint-disable-next-line @typescript-eslint/no-implied-eval
    if (!functionCache) return new Function(functionString);
    // Check for cache hit, eval if missing and return cached function
    if (functionCache[functionString] == null) // eslint-disable-next-line @typescript-eslint/no-implied-eval
    functionCache[functionString] = new Function(functionString);
    // Set the object
    return functionCache[functionString].bind(object);
}
function $937a0acd9cd30227$var$getValidatedString(buffer, start, end, shouldValidateUtf8) {
    var value = buffer.toString('utf8', start, end);
    // if utf8 validation is on, do the check
    if (shouldValidateUtf8) {
        for(var i = 0; i < value.length; i++)if (value.charCodeAt(i) === 0xfffd) {
            if (!$937a0acd9cd30227$var$validateUtf8(buffer, start, end)) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('Invalid UTF-8 string in BSON document');
            break;
        }
    }
    return value;
}
var $937a0acd9cd30227$var$regexp = /\x00/; // eslint-disable-line no-control-regex
var $937a0acd9cd30227$var$ignoreKeys = new Set([
    '$db',
    '$ref',
    '$id',
    '$clusterTime'
]);
/*
 * isArray indicates if we are writing to a BSON array (type 0x04)
 * which forces the "key" which really an array index as a string to be written as ascii
 * This will catch any errors in index as a string generation
 */ function $937a0acd9cd30227$var$serializeString(buffer, key, value, index, isArray) {
    // Encode String type
    buffer[index++] = $937a0acd9cd30227$export$2ce63c0cc3c9284;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes + 1;
    buffer[index - 1] = 0;
    // Write the string
    var size = buffer.write(value, index + 4, undefined, 'utf8');
    // Write the size of the string to buffer
    buffer[index + 3] = size + 1 >> 24 & 0xff;
    buffer[index + 2] = size + 1 >> 16 & 0xff;
    buffer[index + 1] = size + 1 >> 8 & 0xff;
    buffer[index] = size + 1 & 0xff;
    // Update index
    index = index + 4 + size;
    // Write zero
    buffer[index++] = 0;
    return index;
}
var $937a0acd9cd30227$var$SPACE_FOR_FLOAT64 = new Uint8Array(8);
var $937a0acd9cd30227$var$DV_FOR_FLOAT64 = new DataView($937a0acd9cd30227$var$SPACE_FOR_FLOAT64.buffer, $937a0acd9cd30227$var$SPACE_FOR_FLOAT64.byteOffset, $937a0acd9cd30227$var$SPACE_FOR_FLOAT64.byteLength);
function $937a0acd9cd30227$var$serializeNumber(buffer, key, value, index, isArray) {
    // We have an integer value
    // TODO(NODE-2529): Add support for big int
    if (Number.isInteger(value) && value >= $937a0acd9cd30227$export$250fc463de59e142 && value <= $937a0acd9cd30227$export$af352521c8649ed7) {
        // If the value fits in 32 bits encode as int32
        // Set int type 32 bits or less
        buffer[index++] = $937a0acd9cd30227$export$6b19edc38baa1a8c;
        // Number of written bytes
        var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
        // Encode the name
        index = index + numberOfWrittenBytes;
        buffer[index++] = 0;
        // Write the int value
        buffer[index++] = value & 0xff;
        buffer[index++] = value >> 8 & 0xff;
        buffer[index++] = value >> 16 & 0xff;
        buffer[index++] = value >> 24 & 0xff;
    } else {
        // Encode as double
        buffer[index++] = $937a0acd9cd30227$export$8a26a5fd67132695;
        // Number of written bytes
        var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
        // Encode the name
        index = index + numberOfWrittenBytes;
        buffer[index++] = 0;
        // Write float
        $937a0acd9cd30227$var$DV_FOR_FLOAT64.setFloat64(0, value, true);
        buffer.set($937a0acd9cd30227$var$SPACE_FOR_FLOAT64, index);
        // Adjust index
        index = index + 8;
    }
    return index;
}
function $937a0acd9cd30227$var$serializeNull(buffer, key, _, index, isArray) {
    // Set long type
    buffer[index++] = $937a0acd9cd30227$export$a9d27ecf911c8e2d;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    return index;
}
function $937a0acd9cd30227$var$serializeBoolean(buffer, key, value, index, isArray) {
    // Write the type
    buffer[index++] = $937a0acd9cd30227$export$ddfe5b18c2cb4c61;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    // Encode the boolean value
    buffer[index++] = value ? 1 : 0;
    return index;
}
function $937a0acd9cd30227$var$serializeDate(buffer, key, value, index, isArray) {
    // Write the type
    buffer[index++] = $937a0acd9cd30227$export$ff98a022f476c9f6;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    // Write the date
    var dateInMilis = $937a0acd9cd30227$export$12ac1d26449d9c2e.fromNumber(value.getTime());
    var lowBits = dateInMilis.getLowBits();
    var highBits = dateInMilis.getHighBits();
    // Encode low bits
    buffer[index++] = lowBits & 0xff;
    buffer[index++] = lowBits >> 8 & 0xff;
    buffer[index++] = lowBits >> 16 & 0xff;
    buffer[index++] = lowBits >> 24 & 0xff;
    // Encode high bits
    buffer[index++] = highBits & 0xff;
    buffer[index++] = highBits >> 8 & 0xff;
    buffer[index++] = highBits >> 16 & 0xff;
    buffer[index++] = highBits >> 24 & 0xff;
    return index;
}
function $937a0acd9cd30227$var$serializeRegExp(buffer, key, value, index, isArray) {
    // Write the type
    buffer[index++] = $937a0acd9cd30227$export$73020e19fe1a5dcb;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    if (value.source && value.source.match($937a0acd9cd30227$var$regexp) != null) throw Error('value ' + value.source + ' must not contain null bytes');
    // Adjust the index
    index = index + buffer.write(value.source, index, undefined, 'utf8');
    // Write zero
    buffer[index++] = 0x00;
    // Write the parameters
    if (value.ignoreCase) buffer[index++] = 0x69; // i
    if (value.global) buffer[index++] = 0x73; // s
    if (value.multiline) buffer[index++] = 0x6d; // m
    // Add ending zero
    buffer[index++] = 0x00;
    return index;
}
function $937a0acd9cd30227$var$serializeBSONRegExp(buffer, key, value, index, isArray) {
    // Write the type
    buffer[index++] = $937a0acd9cd30227$export$73020e19fe1a5dcb;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    // Check the pattern for 0 bytes
    if (value.pattern.match($937a0acd9cd30227$var$regexp) != null) // The BSON spec doesn't allow keys with null bytes because keys are
    // null-terminated.
    throw Error('pattern ' + value.pattern + ' must not contain null bytes');
    // Adjust the index
    index = index + buffer.write(value.pattern, index, undefined, 'utf8');
    // Write zero
    buffer[index++] = 0x00;
    // Write the options
    index = index + buffer.write(value.options.split('').sort().join(''), index, undefined, 'utf8');
    // Add ending zero
    buffer[index++] = 0x00;
    return index;
}
function $937a0acd9cd30227$var$serializeMinMax(buffer, key, value, index, isArray) {
    // Write the type of either min or max key
    if (value === null) buffer[index++] = $937a0acd9cd30227$export$a9d27ecf911c8e2d;
    else if (value._bsontype === 'MinKey') buffer[index++] = $937a0acd9cd30227$export$988fa02d40535509;
    else buffer[index++] = $937a0acd9cd30227$export$42679d8c82a5a5a0;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    return index;
}
function $937a0acd9cd30227$var$serializeObjectId(buffer, key, value, index, isArray) {
    // Write the type
    buffer[index++] = $937a0acd9cd30227$export$9c296bef3f2e3a80;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    // Write the objectId into the shared buffer
    if (typeof value.id === 'string') buffer.write(value.id, index, undefined, 'binary');
    else if ($937a0acd9cd30227$var$isUint8Array(value.id)) // Use the standard JS methods here because buffer.copy() is buggy with the
    // browser polyfill
    buffer.set(value.id.subarray(0, 12), index);
    else throw new $937a0acd9cd30227$export$5f4690e5e32707d3('object [' + JSON.stringify(value) + '] is not a valid ObjectId');
    // Adjust index
    return index + 12;
}
function $937a0acd9cd30227$var$serializeBuffer(buffer, key, value, index, isArray) {
    // Write the type
    buffer[index++] = $937a0acd9cd30227$export$a6d049d73c03641;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    // Get size of the buffer (current write point)
    var size = value.length;
    // Write the size of the string to buffer
    buffer[index++] = size & 0xff;
    buffer[index++] = size >> 8 & 0xff;
    buffer[index++] = size >> 16 & 0xff;
    buffer[index++] = size >> 24 & 0xff;
    // Write the default subtype
    buffer[index++] = $937a0acd9cd30227$export$f0f029beb8f8c664;
    // Copy the content form the binary field to the buffer
    buffer.set($937a0acd9cd30227$var$ensureBuffer(value), index);
    // Adjust the index
    index = index + size;
    return index;
}
function $937a0acd9cd30227$var$serializeObject(buffer, key, value, index, checkKeys, depth, serializeFunctions, ignoreUndefined, isArray, path) {
    if (checkKeys === void 0) checkKeys = false;
    if (depth === void 0) depth = 0;
    if (serializeFunctions === void 0) serializeFunctions = false;
    if (ignoreUndefined === void 0) ignoreUndefined = true;
    if (isArray === void 0) isArray = false;
    if (path === void 0) path = [];
    for(var i = 0; i < path.length; i++){
        if (path[i] === value) throw new $937a0acd9cd30227$export$dcd4c628d4081c37('cyclic dependency detected');
    }
    // Push value to stack
    path.push(value);
    // Write the type
    buffer[index++] = Array.isArray(value) ? $937a0acd9cd30227$export$a158b7540a414b0 : $937a0acd9cd30227$export$5a91d81c75e64abe;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    var endIndex = $937a0acd9cd30227$var$serializeInto(buffer, value, checkKeys, index, depth + 1, serializeFunctions, ignoreUndefined, path);
    // Pop stack
    path.pop();
    return endIndex;
}
function $937a0acd9cd30227$var$serializeDecimal128(buffer, key, value, index, isArray) {
    buffer[index++] = $937a0acd9cd30227$export$cde5e2a4f8adcb68;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    // Write the data from the value
    // Prefer the standard JS methods because their typechecking is not buggy,
    // unlike the `buffer` polyfill's.
    buffer.set(value.bytes.subarray(0, 16), index);
    return index + 16;
}
function $937a0acd9cd30227$var$serializeLong(buffer, key, value, index, isArray) {
    // Write the type
    buffer[index++] = value._bsontype === 'Long' ? $937a0acd9cd30227$export$c07849652d011312 : $937a0acd9cd30227$export$86ca409d085d6fb2;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    // Write the date
    var lowBits = value.getLowBits();
    var highBits = value.getHighBits();
    // Encode low bits
    buffer[index++] = lowBits & 0xff;
    buffer[index++] = lowBits >> 8 & 0xff;
    buffer[index++] = lowBits >> 16 & 0xff;
    buffer[index++] = lowBits >> 24 & 0xff;
    // Encode high bits
    buffer[index++] = highBits & 0xff;
    buffer[index++] = highBits >> 8 & 0xff;
    buffer[index++] = highBits >> 16 & 0xff;
    buffer[index++] = highBits >> 24 & 0xff;
    return index;
}
function $937a0acd9cd30227$var$serializeInt32(buffer, key, value, index, isArray) {
    value = value.valueOf();
    // Set int type 32 bits or less
    buffer[index++] = $937a0acd9cd30227$export$6b19edc38baa1a8c;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    // Write the int value
    buffer[index++] = value & 0xff;
    buffer[index++] = value >> 8 & 0xff;
    buffer[index++] = value >> 16 & 0xff;
    buffer[index++] = value >> 24 & 0xff;
    return index;
}
function $937a0acd9cd30227$var$serializeDouble(buffer, key, value, index, isArray) {
    // Encode as double
    buffer[index++] = $937a0acd9cd30227$export$8a26a5fd67132695;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    // Write float
    $937a0acd9cd30227$var$DV_FOR_FLOAT64.setFloat64(0, value.value, true);
    buffer.set($937a0acd9cd30227$var$SPACE_FOR_FLOAT64, index);
    // Adjust index
    index = index + 8;
    return index;
}
function $937a0acd9cd30227$var$serializeFunction(buffer, key, value, index, _checkKeys, _depth, isArray) {
    buffer[index++] = $937a0acd9cd30227$export$4d96c08829372834;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    // Function string
    var functionString = $937a0acd9cd30227$var$normalizedFunctionString(value);
    // Write the string
    var size = buffer.write(functionString, index + 4, undefined, 'utf8') + 1;
    // Write the size of the string to buffer
    buffer[index] = size & 0xff;
    buffer[index + 1] = size >> 8 & 0xff;
    buffer[index + 2] = size >> 16 & 0xff;
    buffer[index + 3] = size >> 24 & 0xff;
    // Update index
    index = index + 4 + size - 1;
    // Write zero
    buffer[index++] = 0;
    return index;
}
function $937a0acd9cd30227$var$serializeCode(buffer, key, value, index, checkKeys, depth, serializeFunctions, ignoreUndefined, isArray) {
    if (checkKeys === void 0) checkKeys = false;
    if (depth === void 0) depth = 0;
    if (serializeFunctions === void 0) serializeFunctions = false;
    if (ignoreUndefined === void 0) ignoreUndefined = true;
    if (isArray === void 0) isArray = false;
    if (value.scope && typeof value.scope === 'object') {
        // Write the type
        buffer[index++] = $937a0acd9cd30227$export$959338844bb54803;
        // Number of written bytes
        var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
        // Encode the name
        index = index + numberOfWrittenBytes;
        buffer[index++] = 0;
        // Starting index
        var startIndex = index;
        // Serialize the function
        // Get the function string
        var functionString = typeof value.code === 'string' ? value.code : value.code.toString();
        // Index adjustment
        index = index + 4;
        // Write string into buffer
        var codeSize = buffer.write(functionString, index + 4, undefined, 'utf8') + 1;
        // Write the size of the string to buffer
        buffer[index] = codeSize & 0xff;
        buffer[index + 1] = codeSize >> 8 & 0xff;
        buffer[index + 2] = codeSize >> 16 & 0xff;
        buffer[index + 3] = codeSize >> 24 & 0xff;
        // Write end 0
        buffer[index + 4 + codeSize - 1] = 0;
        // Write the
        index = index + codeSize + 4;
        //
        // Serialize the scope value
        var endIndex = $937a0acd9cd30227$var$serializeInto(buffer, value.scope, checkKeys, index, depth + 1, serializeFunctions, ignoreUndefined);
        index = endIndex - 1;
        // Writ the total
        var totalSize = endIndex - startIndex;
        // Write the total size of the object
        buffer[startIndex++] = totalSize & 0xff;
        buffer[startIndex++] = totalSize >> 8 & 0xff;
        buffer[startIndex++] = totalSize >> 16 & 0xff;
        buffer[startIndex++] = totalSize >> 24 & 0xff;
        // Write trailing zero
        buffer[index++] = 0;
    } else {
        buffer[index++] = $937a0acd9cd30227$export$4d96c08829372834;
        // Number of written bytes
        var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
        // Encode the name
        index = index + numberOfWrittenBytes;
        buffer[index++] = 0;
        // Function string
        var functionString = value.code.toString();
        // Write the string
        var size = buffer.write(functionString, index + 4, undefined, 'utf8') + 1;
        // Write the size of the string to buffer
        buffer[index] = size & 0xff;
        buffer[index + 1] = size >> 8 & 0xff;
        buffer[index + 2] = size >> 16 & 0xff;
        buffer[index + 3] = size >> 24 & 0xff;
        // Update index
        index = index + 4 + size - 1;
        // Write zero
        buffer[index++] = 0;
    }
    return index;
}
function $937a0acd9cd30227$var$serializeBinary(buffer, key, value, index, isArray) {
    // Write the type
    buffer[index++] = $937a0acd9cd30227$export$a6d049d73c03641;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    // Extract the buffer
    var data = value.value(true);
    // Calculate size
    var size = value.position;
    // Add the deprecated 02 type 4 bytes of size to total
    if (value.sub_type === $937a0acd9cd30227$export$dbada097a9bd1de9.SUBTYPE_BYTE_ARRAY) size = size + 4;
    // Write the size of the string to buffer
    buffer[index++] = size & 0xff;
    buffer[index++] = size >> 8 & 0xff;
    buffer[index++] = size >> 16 & 0xff;
    buffer[index++] = size >> 24 & 0xff;
    // Write the subtype to the buffer
    buffer[index++] = value.sub_type;
    // If we have binary type 2 the 4 first bytes are the size
    if (value.sub_type === $937a0acd9cd30227$export$dbada097a9bd1de9.SUBTYPE_BYTE_ARRAY) {
        size = size - 4;
        buffer[index++] = size & 0xff;
        buffer[index++] = size >> 8 & 0xff;
        buffer[index++] = size >> 16 & 0xff;
        buffer[index++] = size >> 24 & 0xff;
    }
    // Write the data to the object
    buffer.set(data, index);
    // Adjust the index
    index = index + value.position;
    return index;
}
function $937a0acd9cd30227$var$serializeSymbol(buffer, key, value, index, isArray) {
    // Write the type
    buffer[index++] = $937a0acd9cd30227$export$d18896fc584f464b;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    // Write the string
    var size = buffer.write(value.value, index + 4, undefined, 'utf8') + 1;
    // Write the size of the string to buffer
    buffer[index] = size & 0xff;
    buffer[index + 1] = size >> 8 & 0xff;
    buffer[index + 2] = size >> 16 & 0xff;
    buffer[index + 3] = size >> 24 & 0xff;
    // Update index
    index = index + 4 + size - 1;
    // Write zero
    buffer[index++] = 0x00;
    return index;
}
function $937a0acd9cd30227$var$serializeDBRef(buffer, key, value, index, depth, serializeFunctions, isArray) {
    // Write the type
    buffer[index++] = $937a0acd9cd30227$export$5a91d81c75e64abe;
    // Number of written bytes
    var numberOfWrittenBytes = !isArray ? buffer.write(key, index, undefined, 'utf8') : buffer.write(key, index, undefined, 'ascii');
    // Encode the name
    index = index + numberOfWrittenBytes;
    buffer[index++] = 0;
    var startIndex = index;
    var output = {
        $ref: value.collection || value.namespace,
        $id: value.oid
    };
    if (value.db != null) output.$db = value.db;
    output = Object.assign(output, value.fields);
    var endIndex = $937a0acd9cd30227$var$serializeInto(buffer, output, false, index, depth + 1, serializeFunctions);
    // Calculate object size
    var size = endIndex - startIndex;
    // Write the size
    buffer[startIndex++] = size & 0xff;
    buffer[startIndex++] = size >> 8 & 0xff;
    buffer[startIndex++] = size >> 16 & 0xff;
    buffer[startIndex++] = size >> 24 & 0xff;
    // Set index
    return endIndex;
}
function $937a0acd9cd30227$var$serializeInto(buffer, object, checkKeys, startingIndex, depth, serializeFunctions, ignoreUndefined, path) {
    if (checkKeys === void 0) checkKeys = false;
    if (startingIndex === void 0) startingIndex = 0;
    if (depth === void 0) depth = 0;
    if (serializeFunctions === void 0) serializeFunctions = false;
    if (ignoreUndefined === void 0) ignoreUndefined = true;
    if (path === void 0) path = [];
    startingIndex = startingIndex || 0;
    path = path || [];
    // Push the object to the path
    path.push(object);
    // Start place to serialize into
    var index = startingIndex + 4;
    // Special case isArray
    if (Array.isArray(object)) // Get object keys
    for(var i = 0; i < object.length; i++){
        var key = "".concat(i);
        var value = object[i];
        // Is there an override value
        if (typeof (value === null || value === void 0 ? void 0 : value.toBSON) === 'function') value = value.toBSON();
        if (typeof value === 'string') index = $937a0acd9cd30227$var$serializeString(buffer, key, value, index, true);
        else if (typeof value === 'number') index = $937a0acd9cd30227$var$serializeNumber(buffer, key, value, index, true);
        else if (typeof value === 'bigint') throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Unsupported type BigInt, please use Decimal128');
        else if (typeof value === 'boolean') index = $937a0acd9cd30227$var$serializeBoolean(buffer, key, value, index, true);
        else if (value instanceof Date || $937a0acd9cd30227$var$isDate(value)) index = $937a0acd9cd30227$var$serializeDate(buffer, key, value, index, true);
        else if (value === undefined) index = $937a0acd9cd30227$var$serializeNull(buffer, key, value, index, true);
        else if (value === null) index = $937a0acd9cd30227$var$serializeNull(buffer, key, value, index, true);
        else if (value['_bsontype'] === 'ObjectId' || value['_bsontype'] === 'ObjectID') index = $937a0acd9cd30227$var$serializeObjectId(buffer, key, value, index, true);
        else if ($937a0acd9cd30227$var$isUint8Array(value)) index = $937a0acd9cd30227$var$serializeBuffer(buffer, key, value, index, true);
        else if (value instanceof RegExp || $937a0acd9cd30227$var$isRegExp(value)) index = $937a0acd9cd30227$var$serializeRegExp(buffer, key, value, index, true);
        else if (typeof value === 'object' && value['_bsontype'] == null) index = $937a0acd9cd30227$var$serializeObject(buffer, key, value, index, checkKeys, depth, serializeFunctions, ignoreUndefined, true, path);
        else if (typeof value === 'object' && $937a0acd9cd30227$var$isBSONType(value) && value._bsontype === 'Decimal128') index = $937a0acd9cd30227$var$serializeDecimal128(buffer, key, value, index, true);
        else if (value['_bsontype'] === 'Long' || value['_bsontype'] === 'Timestamp') index = $937a0acd9cd30227$var$serializeLong(buffer, key, value, index, true);
        else if (value['_bsontype'] === 'Double') index = $937a0acd9cd30227$var$serializeDouble(buffer, key, value, index, true);
        else if (typeof value === 'function' && serializeFunctions) index = $937a0acd9cd30227$var$serializeFunction(buffer, key, value, index, checkKeys, depth, true);
        else if (value['_bsontype'] === 'Code') index = $937a0acd9cd30227$var$serializeCode(buffer, key, value, index, checkKeys, depth, serializeFunctions, ignoreUndefined, true);
        else if (value['_bsontype'] === 'Binary') index = $937a0acd9cd30227$var$serializeBinary(buffer, key, value, index, true);
        else if (value['_bsontype'] === 'Symbol') index = $937a0acd9cd30227$var$serializeSymbol(buffer, key, value, index, true);
        else if (value['_bsontype'] === 'DBRef') index = $937a0acd9cd30227$var$serializeDBRef(buffer, key, value, index, depth, serializeFunctions, true);
        else if (value['_bsontype'] === 'BSONRegExp') index = $937a0acd9cd30227$var$serializeBSONRegExp(buffer, key, value, index, true);
        else if (value['_bsontype'] === 'Int32') index = $937a0acd9cd30227$var$serializeInt32(buffer, key, value, index, true);
        else if (value['_bsontype'] === 'MinKey' || value['_bsontype'] === 'MaxKey') index = $937a0acd9cd30227$var$serializeMinMax(buffer, key, value, index, true);
        else if (typeof value['_bsontype'] !== 'undefined') throw new $937a0acd9cd30227$export$5f4690e5e32707d3("Unrecognized or invalid _bsontype: ".concat(String(value['_bsontype'])));
    }
    else if (object instanceof $937a0acd9cd30227$export$a5c7b93649eaf8f8 || $937a0acd9cd30227$var$isMap(object)) {
        var iterator = object.entries();
        var done = false;
        while(!done){
            // Unpack the next entry
            var entry = iterator.next();
            done = !!entry.done;
            // Are we done, then skip and terminate
            if (done) continue;
            // Get the entry values
            var key = entry.value[0];
            var value = entry.value[1];
            // Check the type of the value
            var type = typeof value;
            // Check the key and throw error if it's illegal
            if (typeof key === 'string' && !$937a0acd9cd30227$var$ignoreKeys.has(key)) {
                if (key.match($937a0acd9cd30227$var$regexp) != null) // The BSON spec doesn't allow keys with null bytes because keys are
                // null-terminated.
                throw Error('key ' + key + ' must not contain null bytes');
                if (checkKeys) {
                    if ('$' === key[0]) throw Error('key ' + key + " must not start with '$'");
                    else if (~key.indexOf('.')) throw Error('key ' + key + " must not contain '.'");
                }
            }
            if (type === 'string') index = $937a0acd9cd30227$var$serializeString(buffer, key, value, index);
            else if (type === 'number') index = $937a0acd9cd30227$var$serializeNumber(buffer, key, value, index);
            else if (type === 'bigint' || $937a0acd9cd30227$var$isBigInt64Array(value) || $937a0acd9cd30227$var$isBigUInt64Array(value)) throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Unsupported type BigInt, please use Decimal128');
            else if (type === 'boolean') index = $937a0acd9cd30227$var$serializeBoolean(buffer, key, value, index);
            else if (value instanceof Date || $937a0acd9cd30227$var$isDate(value)) index = $937a0acd9cd30227$var$serializeDate(buffer, key, value, index);
            else if (value === null || value === undefined && ignoreUndefined === false) index = $937a0acd9cd30227$var$serializeNull(buffer, key, value, index);
            else if (value['_bsontype'] === 'ObjectId' || value['_bsontype'] === 'ObjectID') index = $937a0acd9cd30227$var$serializeObjectId(buffer, key, value, index);
            else if ($937a0acd9cd30227$var$isUint8Array(value)) index = $937a0acd9cd30227$var$serializeBuffer(buffer, key, value, index);
            else if (value instanceof RegExp || $937a0acd9cd30227$var$isRegExp(value)) index = $937a0acd9cd30227$var$serializeRegExp(buffer, key, value, index);
            else if (type === 'object' && value['_bsontype'] == null) index = $937a0acd9cd30227$var$serializeObject(buffer, key, value, index, checkKeys, depth, serializeFunctions, ignoreUndefined, false, path);
            else if (type === 'object' && value['_bsontype'] === 'Decimal128') index = $937a0acd9cd30227$var$serializeDecimal128(buffer, key, value, index);
            else if (value['_bsontype'] === 'Long' || value['_bsontype'] === 'Timestamp') index = $937a0acd9cd30227$var$serializeLong(buffer, key, value, index);
            else if (value['_bsontype'] === 'Double') index = $937a0acd9cd30227$var$serializeDouble(buffer, key, value, index);
            else if (value['_bsontype'] === 'Code') index = $937a0acd9cd30227$var$serializeCode(buffer, key, value, index, checkKeys, depth, serializeFunctions, ignoreUndefined);
            else if (typeof value === 'function' && serializeFunctions) index = $937a0acd9cd30227$var$serializeFunction(buffer, key, value, index, checkKeys, depth, serializeFunctions);
            else if (value['_bsontype'] === 'Binary') index = $937a0acd9cd30227$var$serializeBinary(buffer, key, value, index);
            else if (value['_bsontype'] === 'Symbol') index = $937a0acd9cd30227$var$serializeSymbol(buffer, key, value, index);
            else if (value['_bsontype'] === 'DBRef') index = $937a0acd9cd30227$var$serializeDBRef(buffer, key, value, index, depth, serializeFunctions);
            else if (value['_bsontype'] === 'BSONRegExp') index = $937a0acd9cd30227$var$serializeBSONRegExp(buffer, key, value, index);
            else if (value['_bsontype'] === 'Int32') index = $937a0acd9cd30227$var$serializeInt32(buffer, key, value, index);
            else if (value['_bsontype'] === 'MinKey' || value['_bsontype'] === 'MaxKey') index = $937a0acd9cd30227$var$serializeMinMax(buffer, key, value, index);
            else if (typeof value['_bsontype'] !== 'undefined') throw new $937a0acd9cd30227$export$5f4690e5e32707d3("Unrecognized or invalid _bsontype: ".concat(String(value['_bsontype'])));
        }
    } else {
        if (typeof (object === null || object === void 0 ? void 0 : object.toBSON) === 'function') {
            // Provided a custom serialization method
            object = object.toBSON();
            if (object != null && typeof object !== 'object') throw new $937a0acd9cd30227$export$5f4690e5e32707d3('toBSON function did not return an object');
        }
        // Iterate over all the keys
        for(var key in object){
            var value = object[key];
            // Is there an override value
            if (typeof (value === null || value === void 0 ? void 0 : value.toBSON) === 'function') value = value.toBSON();
            // Check the type of the value
            var type = typeof value;
            // Check the key and throw error if it's illegal
            if (typeof key === 'string' && !$937a0acd9cd30227$var$ignoreKeys.has(key)) {
                if (key.match($937a0acd9cd30227$var$regexp) != null) // The BSON spec doesn't allow keys with null bytes because keys are
                // null-terminated.
                throw Error('key ' + key + ' must not contain null bytes');
                if (checkKeys) {
                    if ('$' === key[0]) throw Error('key ' + key + " must not start with '$'");
                    else if (~key.indexOf('.')) throw Error('key ' + key + " must not contain '.'");
                }
            }
            if (type === 'string') index = $937a0acd9cd30227$var$serializeString(buffer, key, value, index);
            else if (type === 'number') index = $937a0acd9cd30227$var$serializeNumber(buffer, key, value, index);
            else if (type === 'bigint') throw new $937a0acd9cd30227$export$5f4690e5e32707d3('Unsupported type BigInt, please use Decimal128');
            else if (type === 'boolean') index = $937a0acd9cd30227$var$serializeBoolean(buffer, key, value, index);
            else if (value instanceof Date || $937a0acd9cd30227$var$isDate(value)) index = $937a0acd9cd30227$var$serializeDate(buffer, key, value, index);
            else if (value === undefined) {
                if (ignoreUndefined === false) index = $937a0acd9cd30227$var$serializeNull(buffer, key, value, index);
            } else if (value === null) index = $937a0acd9cd30227$var$serializeNull(buffer, key, value, index);
            else if (value['_bsontype'] === 'ObjectId' || value['_bsontype'] === 'ObjectID') index = $937a0acd9cd30227$var$serializeObjectId(buffer, key, value, index);
            else if ($937a0acd9cd30227$var$isUint8Array(value)) index = $937a0acd9cd30227$var$serializeBuffer(buffer, key, value, index);
            else if (value instanceof RegExp || $937a0acd9cd30227$var$isRegExp(value)) index = $937a0acd9cd30227$var$serializeRegExp(buffer, key, value, index);
            else if (type === 'object' && value['_bsontype'] == null) index = $937a0acd9cd30227$var$serializeObject(buffer, key, value, index, checkKeys, depth, serializeFunctions, ignoreUndefined, false, path);
            else if (type === 'object' && value['_bsontype'] === 'Decimal128') index = $937a0acd9cd30227$var$serializeDecimal128(buffer, key, value, index);
            else if (value['_bsontype'] === 'Long' || value['_bsontype'] === 'Timestamp') index = $937a0acd9cd30227$var$serializeLong(buffer, key, value, index);
            else if (value['_bsontype'] === 'Double') index = $937a0acd9cd30227$var$serializeDouble(buffer, key, value, index);
            else if (value['_bsontype'] === 'Code') index = $937a0acd9cd30227$var$serializeCode(buffer, key, value, index, checkKeys, depth, serializeFunctions, ignoreUndefined);
            else if (typeof value === 'function' && serializeFunctions) index = $937a0acd9cd30227$var$serializeFunction(buffer, key, value, index, checkKeys, depth, serializeFunctions);
            else if (value['_bsontype'] === 'Binary') index = $937a0acd9cd30227$var$serializeBinary(buffer, key, value, index);
            else if (value['_bsontype'] === 'Symbol') index = $937a0acd9cd30227$var$serializeSymbol(buffer, key, value, index);
            else if (value['_bsontype'] === 'DBRef') index = $937a0acd9cd30227$var$serializeDBRef(buffer, key, value, index, depth, serializeFunctions);
            else if (value['_bsontype'] === 'BSONRegExp') index = $937a0acd9cd30227$var$serializeBSONRegExp(buffer, key, value, index);
            else if (value['_bsontype'] === 'Int32') index = $937a0acd9cd30227$var$serializeInt32(buffer, key, value, index);
            else if (value['_bsontype'] === 'MinKey' || value['_bsontype'] === 'MaxKey') index = $937a0acd9cd30227$var$serializeMinMax(buffer, key, value, index);
            else if (typeof value['_bsontype'] !== 'undefined') throw new $937a0acd9cd30227$export$5f4690e5e32707d3("Unrecognized or invalid _bsontype: ".concat(String(value['_bsontype'])));
        }
    }
    // Remove the path
    path.pop();
    // Final padding byte for object
    buffer[index++] = 0x00;
    // Final size
    var size = index - startingIndex;
    // Write the size of the object
    buffer[startingIndex++] = size & 0xff;
    buffer[startingIndex++] = size >> 8 & 0xff;
    buffer[startingIndex++] = size >> 16 & 0xff;
    buffer[startingIndex++] = size >> 24 & 0xff;
    return index;
}
/** @internal */ // Default Max Size
var $937a0acd9cd30227$var$MAXSIZE = 17825792;
// Current Internal Temporary Serialization Buffer
var $937a0acd9cd30227$var$buffer = $937a0acd9cd30227$var$buffer_1.alloc($937a0acd9cd30227$var$MAXSIZE);
/**
 * Sets the size of the internal serialization buffer.
 *
 * @param size - The desired size for the internal serialization buffer
 * @public
 */ function $937a0acd9cd30227$export$da02f1c3bf0006e3(size) {
    // Resize the internal serialization buffer if needed
    if ($937a0acd9cd30227$var$buffer.length < size) $937a0acd9cd30227$var$buffer = $937a0acd9cd30227$var$buffer_1.alloc(size);
}
/**
 * Serialize a Javascript object.
 *
 * @param object - the Javascript object to serialize.
 * @returns Buffer object containing the serialized object.
 * @public
 */ function $937a0acd9cd30227$export$dfdc1655ccc5b9cb(object, options) {
    if (options === void 0) options = {};
    // Unpack the options
    var checkKeys = typeof options.checkKeys === 'boolean' ? options.checkKeys : false;
    var serializeFunctions = typeof options.serializeFunctions === 'boolean' ? options.serializeFunctions : false;
    var ignoreUndefined = typeof options.ignoreUndefined === 'boolean' ? options.ignoreUndefined : true;
    var minInternalBufferSize = typeof options.minInternalBufferSize === 'number' ? options.minInternalBufferSize : $937a0acd9cd30227$var$MAXSIZE;
    // Resize the internal serialization buffer if needed
    if ($937a0acd9cd30227$var$buffer.length < minInternalBufferSize) $937a0acd9cd30227$var$buffer = $937a0acd9cd30227$var$buffer_1.alloc(minInternalBufferSize);
    // Attempt to serialize
    var serializationIndex = $937a0acd9cd30227$var$serializeInto($937a0acd9cd30227$var$buffer, object, checkKeys, 0, 0, serializeFunctions, ignoreUndefined, []);
    // Create the final buffer
    var finishedBuffer = $937a0acd9cd30227$var$buffer_1.alloc(serializationIndex);
    // Copy into the finished buffer
    $937a0acd9cd30227$var$buffer.copy(finishedBuffer, 0, 0, finishedBuffer.length);
    // Return the buffer
    return finishedBuffer;
}
/**
 * Serialize a Javascript object using a predefined Buffer and index into the buffer,
 * useful when pre-allocating the space for serialization.
 *
 * @param object - the Javascript object to serialize.
 * @param finalBuffer - the Buffer you pre-allocated to store the serialized BSON object.
 * @returns the index pointing to the last written byte in the buffer.
 * @public
 */ function $937a0acd9cd30227$export$b6fb208a7f4c2b5b(object, finalBuffer, options) {
    if (options === void 0) options = {};
    // Unpack the options
    var checkKeys = typeof options.checkKeys === 'boolean' ? options.checkKeys : false;
    var serializeFunctions = typeof options.serializeFunctions === 'boolean' ? options.serializeFunctions : false;
    var ignoreUndefined = typeof options.ignoreUndefined === 'boolean' ? options.ignoreUndefined : true;
    var startIndex = typeof options.index === 'number' ? options.index : 0;
    // Attempt to serialize
    var serializationIndex = $937a0acd9cd30227$var$serializeInto($937a0acd9cd30227$var$buffer, object, checkKeys, 0, 0, serializeFunctions, ignoreUndefined);
    $937a0acd9cd30227$var$buffer.copy(finalBuffer, startIndex, 0, serializationIndex);
    // Return the index
    return startIndex + serializationIndex - 1;
}
/**
 * Deserialize data as BSON.
 *
 * @param buffer - the buffer containing the serialized set of BSON documents.
 * @returns returns the deserialized Javascript Object.
 * @public
 */ function $937a0acd9cd30227$export$efcd34ab6248d3cd(buffer, options) {
    if (options === void 0) options = {};
    return $937a0acd9cd30227$var$deserialize$1(buffer instanceof $937a0acd9cd30227$var$buffer_1 ? buffer : $937a0acd9cd30227$var$ensureBuffer(buffer), options);
}
/**
 * Calculate the bson size for a passed in Javascript object.
 *
 * @param object - the Javascript object to calculate the BSON byte size for
 * @returns size of BSON object in bytes
 * @public
 */ function $937a0acd9cd30227$export$fd38f60ee2e3ec4b(object, options) {
    if (options === void 0) options = {};
    options = options || {};
    var serializeFunctions = typeof options.serializeFunctions === 'boolean' ? options.serializeFunctions : false;
    var ignoreUndefined = typeof options.ignoreUndefined === 'boolean' ? options.ignoreUndefined : true;
    return $937a0acd9cd30227$var$calculateObjectSize$1(object, serializeFunctions, ignoreUndefined);
}
/**
 * Deserialize stream data as BSON documents.
 *
 * @param data - the buffer containing the serialized set of BSON documents.
 * @param startIndex - the start index in the data Buffer where the deserialization is to start.
 * @param numberOfDocuments - number of documents to deserialize.
 * @param documents - an array where to store the deserialized documents.
 * @param docStartIndex - the index in the documents array from where to start inserting documents.
 * @param options - additional options used for the deserialization.
 * @returns next index in the buffer after deserialization **x** numbers of documents.
 * @public
 */ function $937a0acd9cd30227$export$3f552121051cff1b(data, startIndex, numberOfDocuments, documents, docStartIndex, options) {
    var internalOptions = Object.assign({
        allowObjectSmallerThanBufferSize: true,
        index: 0
    }, options);
    var bufferData = $937a0acd9cd30227$var$ensureBuffer(data);
    var index = startIndex;
    // Loop over all documents
    for(var i = 0; i < numberOfDocuments; i++){
        // Find size of the document
        var size = bufferData[index] | bufferData[index + 1] << 8 | bufferData[index + 2] << 16 | bufferData[index + 3] << 24;
        // Update options with index
        internalOptions.index = index;
        // Parse the document at this point
        documents[docStartIndex + i] = $937a0acd9cd30227$var$deserialize$1(bufferData, internalOptions);
        // Adjust index by the document size
        index = index + size;
    }
    // Return object containing end index of parsing and list of documents
    return index;
}
/**
 * BSON default export
 * @deprecated Please use named exports
 * @privateRemarks
 * We want to someday deprecate the default export,
 * so none of the new TS types are being exported on the default
 * @public
 */ var $937a0acd9cd30227$var$BSON = {
    Binary: $937a0acd9cd30227$export$dbada097a9bd1de9,
    Code: $937a0acd9cd30227$export$52f0f02147b12c03,
    DBRef: $937a0acd9cd30227$export$90e456a500235b9,
    Decimal128: $937a0acd9cd30227$export$39efe8a3f1c2d4eb,
    Double: $937a0acd9cd30227$export$340e583a64e26663,
    Int32: $937a0acd9cd30227$export$493726e231866ac3,
    Long: $937a0acd9cd30227$export$12ac1d26449d9c2e,
    UUID: $937a0acd9cd30227$export$bc35efed93511c4b,
    Map: $937a0acd9cd30227$export$a5c7b93649eaf8f8,
    MaxKey: $937a0acd9cd30227$export$d380297cb28b8de0,
    MinKey: $937a0acd9cd30227$export$aa9d11358976b3cc,
    ObjectId: $937a0acd9cd30227$export$e68967d37d049767,
    ObjectID: $937a0acd9cd30227$export$e68967d37d049767,
    BSONRegExp: $937a0acd9cd30227$export$f7fea3e08dc99c1d,
    BSONSymbol: $937a0acd9cd30227$export$8251e971c2f12361,
    Timestamp: $937a0acd9cd30227$export$d9bcbd5e1ff81430,
    EJSON: $937a0acd9cd30227$export$88f9200ef2b97bb5,
    setInternalBufferSize: $937a0acd9cd30227$export$da02f1c3bf0006e3,
    serialize: $937a0acd9cd30227$export$dfdc1655ccc5b9cb,
    serializeWithBufferAndIndex: $937a0acd9cd30227$export$b6fb208a7f4c2b5b,
    deserialize: $937a0acd9cd30227$export$efcd34ab6248d3cd,
    calculateObjectSize: $937a0acd9cd30227$export$fd38f60ee2e3ec4b,
    deserializeStream: $937a0acd9cd30227$export$3f552121051cff1b,
    BSONError: $937a0acd9cd30227$export$dcd4c628d4081c37,
    BSONTypeError: $937a0acd9cd30227$export$5f4690e5e32707d3
};
var $937a0acd9cd30227$export$2e2bcd8739ae039 = $937a0acd9cd30227$var$BSON;


const $fc1134680ea8cf01$var$id = (arr, id)=>{
    return arr.find((x)=>x._id.toString() === id);
};
const $fc1134680ea8cf01$var$filter = (arr, id)=>{
    return arr.filter((x)=>x._id.toString() !== id);
};
class $fc1134680ea8cf01$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    api = (url, body)=>{
        let campaign = this.props.campaign;
        fetch('/api/' + url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            method: "POST",
            body: JSON.stringify({
                id: campaign._id,
                ...body
            })
        }).then((res)=>res.json()).then((info)=>{
            console.log('server returned.');
        // console.log(info);
        // setStateOnParent(info);
        });
    };
    performLocalChange = (campaign)=>{
        let setStateOnParent = this.props.setStateFromChild;
        setStateOnParent(campaign);
    };
    attemptRenameEncounter = (e)=>{
        let oldName = e.target.dataset.oldname;
        let encounterid = e.target.dataset.encounterid;
        let newName = window.prompt('Rename encounter `' + oldName + '` to ...', oldName);
        if (newName) this.renameEncounter(newName, encounterid);
    };
    renameEncounter = (newName, encounterid)=>{
        this.api('renameEncounter', {
            encounterid: encounterid,
            newName: newName
        });
        let campaign = this.props.campaign;
        let encounter = $fc1134680ea8cf01$var$id(campaign.encounters, encounterid);
        encounter.name = newName;
        this.performLocalChange(campaign);
    };
    attemptDeleteEncounter = (e)=>{
        if (window.confirm('Are you sure you want to delete this encounter?')) this.deleteEncounter(e.target.dataset.encounterid);
    };
    deleteEncounter = (encounterid)=>{
        this.api('deleteEncounter', {
            encounterid: encounterid
        });
        let campaign = this.props.campaign;
        campaign.encounters = $fc1134680ea8cf01$var$filter(campaign.encounters, encounterid);
        this.performLocalChange(campaign);
        this.backToRootCampaign();
    };
    addPc = (e)=>{
        let encounterid = e.target.dataset.encounterid;
        let pcid = new (0, $937a0acd9cd30227$export$e68967d37d049767)();
        this.api('addPc', {
            encounterid: encounterid,
            pcid: pcid
        });
        let campaign = this.props.campaign;
        let encounter = $fc1134680ea8cf01$var$id(campaign.encounters, encounterid);
        let pc = {
            _id: pcid,
            xp: 0,
            quantity: 0
        };
        encounter.pcs.push(pc);
        this.performLocalChange(campaign);
    };
    setPcName = (e)=>{
        let encounterid = e.target.dataset.encounterid;
        let pcid = e.target.dataset.pcid;
        let pcname = e.target.value;
        this.api('setPcName', {
            encounterid: encounterid,
            pcid: pcid,
            pcname: pcname
        });
        let campaign = this.props.campaign;
        let encounter = $fc1134680ea8cf01$var$id(campaign.encounters, encounterid);
        let pc = $fc1134680ea8cf01$var$id(encounter.pcs, pcid);
        pc.name = pcname;
        this.performLocalChange(campaign);
    };
    setPcXp = (e)=>{
        let encounterid = e.target.dataset.encounterid;
        let pcid = e.target.dataset.pcid;
        let pcxp = e.target.value;
        this.api('setPcXp', {
            encounterid: encounterid,
            pcid: pcid,
            pcxp: pcxp
        });
        let campaign = this.props.campaign;
        let encounter = $fc1134680ea8cf01$var$id(campaign.encounters, encounterid);
        let pc = $fc1134680ea8cf01$var$id(encounter.pcs, pcid);
        pc.xp = pcxp;
        this.performLocalChange(campaign);
    };
    setPcQty = (e)=>{
        let encounterid = e.target.dataset.encounterid;
        let pcid = e.target.dataset.pcid;
        let qty = e.target.value;
        this.api('setPcQty', {
            encounterid: encounterid,
            pcid: pcid,
            qty: qty
        });
        let campaign = this.props.campaign;
        let encounter = $fc1134680ea8cf01$var$id(campaign.encounters, encounterid);
        let pc = $fc1134680ea8cf01$var$id(encounter.pcs, pcid);
        pc.quantity = qty;
        this.performLocalChange(campaign);
    };
    deletePc = (e)=>{
        let encounterid = e.target.dataset.encounterid;
        let pcid = e.target.dataset.pcid;
        this.api('deletePc', {
            encounterid: encounterid,
            pcid: pcid
        });
        let campaign = this.props.campaign;
        let encounter = $fc1134680ea8cf01$var$id(campaign.encounters, encounterid);
        encounter.pcs = $fc1134680ea8cf01$var$filter(encounter.pcs, pcid);
        this.performLocalChange(campaign);
    };
    addEnemy = (e)=>{
        let encounterid = e.target.dataset.encounterid;
        let enemyid = new (0, $937a0acd9cd30227$export$e68967d37d049767)();
        this.api('addEnemy', {
            encounterid: encounterid,
            enemyid: enemyid
        });
        let campaign = this.props.campaign;
        let encounter = $fc1134680ea8cf01$var$id(campaign.encounters, encounterid);
        let enemy = {
            _id: enemyid,
            docId: undefined,
            entityId: undefined,
            quantity: 0,
            combatants: []
        };
        encounter.enemyTypes.push(enemy);
        this.performLocalChange(campaign);
    };
    setEnemyDoc = (e)=>{
        let encounterid = e.target.dataset.encounterid;
        let enemyid = e.target.dataset.enemyid;
        let enemydoc = e.target.value;
        this.api('setEnemyDoc', {
            encounterid: encounterid,
            enemyid: enemyid,
            enemydoc: enemydoc
        });
        let campaign = this.props.campaign;
        let encounter = $fc1134680ea8cf01$var$id(campaign.encounters, encounterid);
        let enemy = $fc1134680ea8cf01$var$id(encounter.enemyTypes, enemyid);
        enemy.docId = enemydoc;
        enemy.entityId = undefined;
        this.performLocalChange(campaign);
    };
    setEnemyEntity = (e)=>{
        let encounterid = e.target.dataset.encounterid;
        let enemyid = e.target.dataset.enemyid;
        let enemyentity = e.target.value;
        this.api('setEnemyEntity', {
            encounterid: encounterid,
            enemyid: enemyid,
            enemyentity: enemyentity
        });
        let campaign = this.props.campaign;
        let encounter = $fc1134680ea8cf01$var$id(campaign.encounters, encounterid);
        let enemy = $fc1134680ea8cf01$var$id(encounter.enemyTypes, enemyid);
        enemy.entityId = enemyentity;
        this.performLocalChange(campaign);
    };
    setEnemyQuantity = (e)=>{
        let encounterid = e.target.dataset.encounterid;
        let enemyid = e.target.dataset.enemyid;
        let enemyqty = e.target.value;
        this.api('setEnemyQuantity', {
            encounterid: encounterid,
            enemyid: enemyid,
            enemyqty: enemyqty
        });
        let campaign = this.props.campaign;
        let encounter = $fc1134680ea8cf01$var$id(campaign.encounters, encounterid);
        let enemy = $fc1134680ea8cf01$var$id(encounter.enemyTypes, enemyid);
        enemy.quantity = enemyqty;
        this.performLocalChange(campaign);
    };
    deleteEnemy = (e)=>{
        let encounterid = e.target.dataset.encounterid;
        let enemyid = e.target.dataset.enemyid;
        this.api('deleteEnemy', {
            encounterid: encounterid,
            enemyid: enemyid
        });
        let campaign = this.props.campaign;
        let encounter = $fc1134680ea8cf01$var$id(campaign.encounters, encounterid);
        encounter.enemyTypes = $fc1134680ea8cf01$var$filter(encounter.enemytypes, enemyid);
        this.performLocalChange(campaign);
    };
    toggleBox = (e)=>{
        let encounterid = e.target.dataset.encounterid;
        let enemyid = e.target.dataset.enemyid;
        let combid = e.target.dataset.combid;
        let poolname = e.target.dataset.pool;
        let checked = e.target.checked;
        this.api('toggleBox', {
            encounterid: encounterid,
            enemyid: enemyid,
            combid: combid,
            poolname: poolname,
            checked: checked
        });
    };
    setEncounterNote = (e)=>{
        let encounterid = e.target.dataset.encounterid;
        let notes = e.target.value;
        let def = e.target.defaultValue;
        if (notes === def) return;
        this.api('setEncounterNote', {
            encounterid: encounterid,
            notes: notes
        });
        let campaign = this.props.campaign;
        let encounter = $fc1134680ea8cf01$var$id(campaign.encounters, encounterid);
        encounter.notes = notes;
        this.performLocalChange(campaign);
    };
    attemptSetEncounterLink = (e)=>{
        let url = prompt('Enter a new URL');
        let encounterid = e.target.dataset.encounterid;
        if (url) this.setEncounterLink(encounterid, url);
    };
    setEncounterLink = (encounterid, url)=>{
        this.api('setEncounterLink', {
            encounterid: encounterid,
            url: url
        });
        let campaign = this.props.campaign;
        let encounter = $fc1134680ea8cf01$var$id(campaign.encounters, encounterid);
        encounter.link = url;
        this.performLocalChange(campaign);
    };
    backToRootCampaign = ()=>{
        // this.props.history.push('../' + campaign._id);
        this.props.history.push('../');
    };
    render() {
        let campaign = this.props.campaign;
        let encounterId = this.props.match.params.EncounterId;
        let enc = campaign.encounters.find((x)=>x._id.toString() === encounterId);
        if (!enc) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {});
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9ffbd34428bea187$export$2e2bcd8739ae039), {
                    campaign: campaign,
                    enc: enc,
                    // key={enc._id}
                    attemptDeleteEncounter: this.attemptDeleteEncounter,
                    attemptRenameEncounter: this.attemptRenameEncounter,
                    addPc: this.addPc,
                    setPcName: this.setPcName,
                    deletePc: this.deletePc,
                    setPcXp: this.setPcXp,
                    setPcQty: this.setPcQty,
                    addEnemy: this.addEnemy,
                    setEnemyDoc: this.setEnemyDoc,
                    setEnemyEntity: this.setEnemyEntity,
                    setEnemyQuantity: this.setEnemyQuantity,
                    deleteEnemy: this.deleteEnemy,
                    toggleBox: this.toggleBox,
                    setEncounterNote: this.setEncounterNote,
                    setEncounterLink: this.attemptSetEncounterLink
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4ed7e73c38acab0b$export$2e2bcd8739ae039), {
                    campaign: campaign,
                    enc: enc,
                    // key={enc._id}
                    attemptDeleteEncounter: this.attemptDeleteEncounter,
                    attemptRenameEncounter: this.attemptRenameEncounter,
                    addPc: this.addPc,
                    deletePc: this.deletePc,
                    setPcName: this.setPcName,
                    setPcXp: this.setPcXp,
                    setPcQty: this.setPcQty,
                    addEnemy: this.addEnemy,
                    setEnemyDoc: this.setEnemyDoc,
                    setEnemyEntity: this.setEnemyEntity,
                    setEnemyQuantity: this.setEnemyQuantity,
                    deleteEnemy: this.deleteEnemy,
                    toggleBox: this.toggleBox,
                    setEncounterNote: this.setEncounterNote,
                    setEncounterLink: this.attemptSetEncounterLink
                })
            ]
        });
    }
}


// import { ObjectId } from "bson";
function $b8b712a008761664$export$2e2bcd8739ae039(campaign) {
    campaign.encounters?.forEach((enc)=>{
        // combatants
        // console.log(enc)
        enc.enemyTypes.forEach((enemyType)=>{
            // console.log(enemyType)
            enemyType.combatants = [];
            let index = 0;
            while(enemyType.combatants.length < enemyType.quantity){
                // let combId = new ObjectId();
                let newComb = {
                    index: // _id: combId,
                    index
                };
                enemyType.combatants.push(newComb);
                index++;
            }
        });
        // xp
        let pcxp = 0;
        let enxp = 0;
        enc.percentages = {};
        enc.pcs?.forEach((pc)=>{
            pcxp += pc.xp * (pc.quantity || 0);
        });
        enc.pcxp = pcxp;
        enc.enemyTypes?.forEach((enemy)=>{
            enemy.doc = campaign.docs.find((x)=>x._id.toString() === enemy.docId);
            enemy.entity = enemy.doc?.entities.find((x)=>x._id === enemy.entityId);
            enemy.xp = (enemy.entity?.xp || 0) * (enemy.quantity || 0);
            enxp += enemy.xp;
        });
        enc.enxp = enxp;
        enc.percentages.max = Math.max(enc.enxp, enc.pcxp);
        if (enc.percentages.max > 0) {
            enc.percentages.pcs = enc.pcxp / enc.percentages.max * 100;
            enc.percentages.enemy = enc.enxp / enc.percentages.max * 100;
            let chunk = enc.pcxp / 4;
            enc.percentages.trivial = chunk * 1 / enc.percentages.max * 100;
            enc.percentages.easy = chunk * 2 / enc.percentages.max * 100;
            enc.percentages.normal = chunk * 3 / enc.percentages.max * 100;
            enc.percentages.danger = chunk * 4 / enc.percentages.max * 100;
            enc.percentages.lethal = chunk * 5 / enc.percentages.max * 100;
            if (enc.percentages.enemy >= 100) {
                enc.percentages.diff = 'Lethal';
                enc.percentages.stars = "\u2B50\u2B50\u2B50\u2B50\u2B50";
            }
            if (enc.percentages.enemy < 100) {
                enc.percentages.diff = 'Danger';
                enc.percentages.stars = "\u2B50\u2B50\u2B50\u2B50";
            }
            if (enc.percentages.enemy < 75) {
                enc.percentages.diff = 'Normal';
                enc.percentages.stars = "\u2B50\u2B50\u2B50";
            }
            if (enc.percentages.enemy < 50) {
                enc.percentages.diff = 'Easy';
                enc.percentages.stars = "\u2B50\u2B50";
            }
            if (enc.percentages.enemy < 25) {
                enc.percentages.diff = 'Trivial';
                enc.percentages.stars = "\u2B50";
            }
        }
    // console.log(enc.percentages);
    });
    return campaign;
}



class $fcf132517feeaa69$var$CampaignPage extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.id = this.props.match.params.CampaignId;
        this.state = {
            addUserModal: false,
            addDocModal: false,
            gettingCampaign: true
        };
    }
    componentDidMount() {
        this.getCampaign();
    }
    getCampaign = ()=>{
        fetch('/api/getCampaign', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                campaignid: this.id
            })
        }).then((res)=>res.json()).then((campaign)=>{
            if (campaign) this.setStateFromChild(campaign);
        });
    };
    setStateFromChild = (campaign)=>{
        let c = campaign;
        c.docs?.forEach((doc, index)=>{
            c.docs[index] = (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).calculateAllXp(doc);
        });
        c = (0, $b8b712a008761664$export$2e2bcd8739ae039)(c);
        this.setState({
            campaign: c,
            gettingCampaign: false
        });
    };
    changeGm = ()=>{
        alert('not implemented');
    };
    setListing = (listed)=>{
        fetch('/api/updateCampaign', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                campaignid: this.id,
                unlisted: !listed
            })
        }).then((res)=>res.json()).then((info)=>{
            if (info) this.setStateFromChild(info);
        });
    };
    setTrash = (trashed)=>{
        fetch('/api/updateCampaign', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                campaignid: this.id,
                trashed: trashed
            })
        }).then((res)=>res.json()).then((info)=>{
            if (info) this.setStateFromChild(info);
        });
    };
    removePlayer = (id)=>{
        fetch('/api/removePlayerFromCampaign', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                campaignid: this.id,
                removeuser: id
            })
        }).then((res)=>res.json()).then((info)=>{
            if (!info) return;
            // console.log(info);
            if (info) this.setStateFromChild(info);
            this.setState({
                removeUsers: false
            });
        });
    };
    confirmRemovePlayer = (player)=>{
        // console.log(player);
        if (!window.confirm('Do you really want to remove ' + player.username + ' from this campaign?')) return;
        // console.log('remove player: ' + player.username);
        this.removePlayer(player._id);
    };
    addUser = (user)=>{
        // console.log('add ' + user._id);
        let id = user._id;
        fetch('/api/addPlayerToCampaign', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                campaignid: this.id,
                adduser: id
            })
        }).then((res)=>res.json()).then((info)=>{
            if (info) this.setStateFromChild(info);
            this.setState({
                removeUsers: false,
                addUserModal: false
            });
        });
    };
    renameCampaign = (id, name, target)=>{
        fetch('/api/renameCampaign', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            method: "POST",
            body: JSON.stringify({
                id: id,
                name: name
            })
        }).then((res)=>res.json()).then((info)=>{
            if (info) this.setStateFromChild(info);
        });
    };
    toggleAddDocModal = ()=>{
        this.setState({
            addDocModal: !this.state.addDocModal
        });
    };
    addDoc = (doc)=>{
        console.log(doc);
        fetch('/api/addDocToCampaign', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            method: "POST",
            body: JSON.stringify({
                id: this.state.campaign._id,
                docid: doc._id
            })
        }).then((res)=>res.json()).then((info)=>{
            if (info) this.setStateFromChild(info);
        });
    };
    attemptDeleteDoc = (e)=>{
        let docid = e.target.dataset.docid;
        let docname = e.target.dataset.docname;
        if (window.confirm("WARNING!\n\nAre you sure you want to delete the doc " + docname + "?\n\nThis might remove entities used in your encounters!")) this.deleteDoc(docid);
    };
    deleteDoc = (docid)=>{
        fetch('/api/deleteDocFromCampaign', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            method: "POST",
            body: JSON.stringify({
                id: this.state.campaign._id,
                docid: docid
            })
        }).then((res)=>res.json()).then((info)=>{
            if (info) this.setStateFromChild(info);
        });
    };
    closeModal = (e)=>{
        console.log('closeModal');
        let target = e.target.dataset.target;
        this.setState({
            addUserModal: false,
            addDocModal: false,
            [target]: false
        });
    };
    addEncounter = (e)=>{
        fetch('/api/addEncounter', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            method: "POST",
            body: JSON.stringify({
                id: this.state.campaign._id
            })
        }).then((res)=>res.json()).then((campaign)=>{
            // console.log(info)
            if (campaign) this.setStateFromChild(campaign);
        });
    };
    setEnemyFilter = (e)=>{
        let enemyfilter = e.target.value;
        fetch('/api/updateCampaign', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                campaignid: this.id,
                enemyfilter: enemyfilter
            })
        }).then((res)=>res.json()).then((info)=>{
            if (info) this.setStateFromChild(info);
        });
    };
    setSortOrder = (e)=>{
        let enemysortorder = e.target.value;
        fetch('/api/updateCampaign', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                campaignid: this.id,
                enemysortorder: enemysortorder
            })
        }).then((res)=>res.json()).then((info)=>{
            if (info) this.setStateFromChild(info);
        });
    };
    setIncludeParent = (e)=>{
        let includeparententities = e.target.checked;
        fetch('/api/updateCampaign', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                campaignid: this.id,
                includeparententities: includeparententities
            })
        }).then((res)=>res.json()).then((info)=>{
            if (info) this.setStateFromChild(info);
        });
    };
    render() {
        const campaign = this.state.campaign;
        // console.log(campaign);
        const token = (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject();
        const canEdit = !!token && !!this.state.campaign && !!this.state.campaign.gm && this.state.campaign?.gm === token?.user._id || token?.user.userLevel === 'MOD' || token?.user.userLevel === 'ADMIN';
        const canEditUsers = token?.user.userLevel === 'MOD' || token?.user.userLevel === 'ADMIN';
        // console.log(this.state.campaign?.docs);
        // console.log(this.state.campaign?.unlisted);
        // console.log(this.state.campaign?.trashed);
        if (campaign) {
            const dir = `/campaign/${campaign._id}/`;
            document.title = [
                campaign.name,
                'SGS'
            ].join(' - ');
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $14986c2201283622$export$b5d5cf8927ab7262), {
                        children: [
                            (token?.user?._id === campaign?.gm?._id || token?.user?.userLevel === 'admin') && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                                path: dir + 'Encounter/:EncounterId',
                                component: (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h1", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                                        to: "/campaigns",
                                                        children: "Campaign"
                                                    }),
                                                    ":\xa0",
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                                        to: dir,
                                                        children: [
                                                            campaign.name,
                                                            " (back)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fc1134680ea8cf01$export$2e2bcd8739ae039), {
                                                campaign: campaign,
                                                ...props,
                                                setStateFromChild: this.setStateFromChild
                                            })
                                        ]
                                    })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                                path: "*",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h1", {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                                href: "/campaigns",
                                                children: "Campaign"
                                            }),
                                            ":\xa0",
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $856fae2ccc0e87c3$export$2e2bcd8739ae039), {
                                                name: campaign.name,
                                                id: campaign._id,
                                                renameCallback: this.renameCampaign,
                                                target: campaign
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                                        children: [
                                            "Campaign id: ",
                                            campaign._id,
                                            !!campaign.unlisted ? ", \uD83D\uDCAC unlisted" : '',
                                            !!campaign.trashed ? ", \u274C trashed" : ''
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                        children: "Players"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                                        children: [
                                            campaign.gm && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cc31eba22f67b38$export$2e2bcd8739ae039), {
                                                        user: campaign.gm
                                                    }),
                                                    "(GM)"
                                                ]
                                            }),
                                            campaign.allPlayers.map((player, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cc31eba22f67b38$export$2e2bcd8739ae039), {
                                                            user: player
                                                        }),
                                                        "\xa0",
                                                        canEditUsers && this.state.removeUsers && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                            className: "delete",
                                                            onClick: ()=>this.confirmRemovePlayer(player),
                                                            children: "x"
                                                        })
                                                    ]
                                                }, index)),
                                            canEdit && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                    onClick: ()=>this.setState({
                                                            addUserModal: !this.state.addUserModal
                                                        }),
                                                    children: "\u2795 Add User"
                                                })
                                            }),
                                            canEdit && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                    onClick: ()=>this.setState({
                                                            removeUsers: !this.state.removeUsers
                                                        }),
                                                    children: "remove users"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                        children: "Docs"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                                        children: [
                                            campaign.docs.map((doc)=>{
                                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                                            to: '/doc/' + doc._id,
                                                            children: doc.name
                                                        }),
                                                        "\xa0 (",
                                                        doc.type,
                                                        ") \xa0",
                                                        canEdit && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                            className: "delete",
                                                            onClick: this.attemptDeleteDoc,
                                                            "data-docid": doc._id,
                                                            "data-docname": doc.name,
                                                            children: "x"
                                                        })
                                                    ]
                                                }, doc._id);
                                            }),
                                            canEdit && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                    onClick: this.toggleAddDocModal,
                                                    children: "\u2795Add Doc"
                                                })
                                            })
                                        ]
                                    }),
                                    canEdit && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                                children: "Enemy Selection"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                                children: [
                                                    "Entity Tag Filter:\xa0",
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                        type: "text",
                                                        defaultValue: campaign.enemyfilter,
                                                        onBlur: this.setEnemyFilter
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                                children: [
                                                    "Sort Order:\xa0",
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                                                        onChange: this.setSortOrder,
                                                        defaultValue: campaign.enemysortorder,
                                                        children: [
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                                children: "Name"
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                                children: "Name, Reversed"
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                                children: "XP Ascending"
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                                children: "XP Descending"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                                children: [
                                                    "Include Parent Doc Entities:\xa0",
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        onChange: this.setIncludeParent,
                                                        defaultChecked: campaign.includeparententities
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    canEdit && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                                children: "Edit Campaign"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                            onClick: this.changeGm,
                                                            children: "change GM"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                            onClick: ()=>this.setListing(true),
                                                            children: "list campaign"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                            onClick: ()=>this.setListing(false),
                                                            children: "unlist campaign"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                            onClick: ()=>this.setTrash(true),
                                                            children: "trash campaign"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                            onClick: ()=>this.setTrash(false),
                                                            children: "untrash campaign"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (token?.user?._id === campaign?.gm?._id || token?.user?.userLevel === 'admin') && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                children: "Encounters"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                            onClick: this.addEncounter,
                                            children: "\u2795 Add new encounter"
                                        })
                                    }),
                                    campaign.encounters.map((enc)=>{
                                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                                to: dir + 'Encounter/' + enc._id,
                                                children: [
                                                    enc.percentages.stars,
                                                    enc.name
                                                ]
                                            })
                                        }, enc._id);
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    canEdit && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $90c4322eecedc6d4$export$2e2bcd8739ae039), {
                                closeModal: this.closeModal,
                                addUser: this.addUser,
                                campaign: this.state.campaign,
                                state: this.state,
                                setState: this.setState
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b1842d6e2b218b23$export$2e2bcd8739ae039), {
                                addParentDoc: this.addDoc,
                                // doc={null}
                                state: this.state,
                                setState: this.setState,
                                closeModal: this.closeModal
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
                ]
            });
        } else return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h1", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            href: "/campaigns",
                            children: "Campaign"
                        }),
                        ":\xa0",
                        this.props.match.params.CampaignId
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bbe2292908daaa2$export$2e2bcd8739ae039), {
                    fullpage: true
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $fcf132517feeaa69$export$2e2bcd8739ae039 = $fcf132517feeaa69$var$CampaignPage;




var $bh6RR = parcelRequire("bh6RR");





class $1fbc42e99b7590b9$var$CampaignListPage extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            campaigns: [],
            gettingCampaigns: true
        };
    }
    // initializer
    componentDidMount() {
        this.listCampaigns();
    }
    // class method
    listCampaigns = ()=>{
        fetch('/api/listCampaigns', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            method: "GET"
        }).then((res)=>res.json()).then((campaigns)=>this.setState({
                campaigns: campaigns,
                gettingCampaigns: false
            }));
    };
    makelink = (session)=>{
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
            to: {
                pathname: '/session',
                sessionid: session._id
            },
            children: session.name
        });
    };
    render() {
        document.title = [
            'Campaigns',
            'SGS'
        ].join(' - ');
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "Campaigns"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cbb77c764daba2ff$export$2e2bcd8739ae039), {
                    campaigns: this.state.campaigns
                }),
                this.state.gettingCampaigns && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bbe2292908daaa2$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $1fbc42e99b7590b9$export$2e2bcd8739ae039 = $1fbc42e99b7590b9$var$CampaignListPage;




var $bh6RR = parcelRequire("bh6RR");













var $bh6RR = parcelRequire("bh6RR");



class $60aab2f74d6f7a7e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            addModal: false,
            removeModal: false
        };
    }
    confirmRemoveEditor = (editor)=>{
        if (!window.confirm('Do you really want to remove ' + editor.username + ' from this doc?')) return;
        this.removeEditor(editor._id);
    };
    removeEditor = (editorid)=>{
        this.props.api('removeListEditor', {
            listid: this.props.list._id,
            editorid: editorid
        });
        let list = this.props.list;
        list.editors = list.editors.filter((x)=>x._id.toString() !== editorid);
        console.log(list);
        this.props.performLocalChange(list);
    };
    openModal = ()=>{
        this.setState({
            addModal: true
        });
    };
    addEditor = (user)=>{
        // console.log('add ' + user._id);
        this.props.api('addListEditor', {
            listid: this.props.list._id,
            editorid: user._id
        });
        let list = this.props.list;
        list.editors.push(user);
        this.props.performLocalChange(list);
    };
    closeModal = ()=>{
        this.setState({
            addModal: false
        });
    };
    render() {
        let list = this.props.list;
        // console.log(doc.editors);
        let canEditUsers = !!list.owner && !!(0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user._id && list.owner?._id === (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user._id;
        // console.log(doc?.owner);
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                    children: "Doc Owner"
                }),
                !!list?.owner && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cc31eba22f67b38$export$2e2bcd8739ae039), {
                    user: list?.owner
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                    children: "Doc Editors"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                    children: [
                        list?.editors?.map((editor)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cc31eba22f67b38$export$2e2bcd8739ae039), {
                                        user: editor
                                    }, editor._id),
                                    canEditUsers && this.state.removeModal && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        className: "delete",
                                        onClick: ()=>this.confirmRemoveEditor(editor),
                                        children: "x"
                                    })
                                ]
                            }, editor._id);
                        }),
                        canEditUsers && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                onClick: this.openModal,
                                children: "Add an Editor"
                            })
                        }),
                        canEditUsers && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                onClick: ()=>this.setState({
                                        removeModal: !this.state.removeModal
                                    }),
                                children: "Remove an Editor"
                            })
                        })
                    ]
                }),
                this.state.addModal && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $90c4322eecedc6d4$export$2e2bcd8739ae039), {
                    close: this.closeModal,
                    addUser: this.addEditor,
                    doc: list
                })
            ]
        });
    }
}


/**
 * shows UI to change the filter tag lists.
 * @param {Object} list
 * @param {Function} api
 * @param {Functin} performLocalChange
 */ 
function $c1392df855544c25$export$2e2bcd8739ae039(props) {
    const updateUnitFilter = (e)=>{
        let newFilter = e.target.value;
        props.api('updateListUnitFilter', {
            newfilter: newFilter
        });
        let list = props.list;
        list.unitFilter = newFilter;
        props.performLocalChange(list);
    };
    const updateUnitSortOrder = (e)=>{
        let newSort = e.target.value;
        props.api('updateListUnitSorting', {
            newsort: newSort
        });
        let list = props.list;
        list.unitSortOrder = newSort;
        props.performLocalChange(list);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                children: "Sort & Filter Entities"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                children: [
                    "Whitelist Tags",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        defaultValue: props.list.unitFilter,
                        placeholder: "unit, model",
                        onBlur: updateUnitFilter
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                children: [
                    "Sort Order",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                        value: props.list.unitSortOrder,
                        onChange: updateUnitSortOrder,
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                value: "",
                                children: "none"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                children: "name"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                children: "name, reversed"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                children: "xp descending"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                children: "xp ascending"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



class $8c394cee192ad531$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            id: this.props.match.params.ListId,
            list: undefined,
            gettingDoc: true,
            editing: false,
            addDocModal: false
        };
    }
    componentDidMount() {
        this.getList();
    }
    getList = ()=>{
        // console.log('getlist')
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                listid: this.state.id
            })
        };
        fetch('/api/list/getList', options).then((res)=>res.json()).then((info)=>{
            console.log(info);
            if (!info) return;
            let list = this.compileRules(info);
            console.log(list);
            list = this.calculateArmyCost(list);
            console.log('post cac', list);
            this.setState({
                list: list
            }, ()=>{
                // console.log('callback', this.state.list)
                document.title = [
                    info.name,
                    'List',
                    'SGS'
                ].join(' - ');
                if ((0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject().user._id) this.api('setListValue', {
                    listxp: list.xp
                });
            });
        }).catch((e)=>{
            console.error(e);
        });
    };
    api = (url, body)=>{
        let list = this.state.list;
        // console.log(this.state.list)
        // console.log(url)
        if (!list) {
            console.log("No List", this.state);
            return;
        }
        fetch('/api/list/' + url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            method: "POST",
            body: JSON.stringify({
                listid: list._id,
                ...body
            })
        }).then((res)=>res.json()).then((info)=>{
            console.log('server returned');
        });
    };
    calculateArmyCost = (direct)=>{
        console.log(direct);
        let list = direct || this.state.list;
        console.log("cac 1", list);
        let total = 0;
        list.units.forEach((unit)=>{
            // console.log("unit", unit.doc, unit.entity);
            // console.log(unit.docid, unit.entityid)
            if (!!unit.docid && !!unit.entityid && unit.qty > 0) {
                unit.doc = list.rules.find((x)=>x._id === unit.docid);
                unit.entity = unit.doc.entities.find((x)=>x._id === unit.entityid);
            }
            if (!!unit.doc && !!unit.entity && unit.qty > 0) // console.log("found")
            total = total + unit.entity.xp * unit.qty;
        });
        list.xp = total;
        console.log("cac end", list);
        return list;
    };
    performLocalChange = (list)=>{
        let newList = this.compileRules(list);
        this.setState({
            list: newList
        });
    };
    compileRules = (list)=>{
        let newList = list;
        newList.rules.forEach((doc, index)=>{
            newList.rules[index] = (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).calculateAllXp(doc);
        });
        return newList;
    };
    attemptRenameList = ()=>{
        let newName = window.prompt('rename this list');
        if (!!newName) this.renameList(newName);
    };
    renameList = (newName)=>{
        let list = this.state.list;
        this.api('renameList', {
            listid: list._id,
            newname: newName
        });
        list.name = newName;
        this.performLocalChange(list);
    };
    addDoc = (doc)=>{
        let list = this.state.list;
        this.api('addDoc', {
            docid: doc._id
        });
        list.rules.push(doc);
        this.performLocalChange(list);
    };
    toggleAddDocModal = ()=>{
        this.setState({
            addDocModal: !this.state.addDocModal
        });
    };
    closeModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: false
        });
    };
    attemptRemoveDoc = (e)=>{
        let docid = e.target.dataset.docid;
        let docname = e.target.dataset.docname;
        if (window.confirm("are you sure you want to remove this doc from your army list?\n\n" + docname)) this.removeDoc(docid);
    };
    removeDoc = (docid)=>{
        this.api('removeDoc', {
            docid: docid
        });
        let list = this.state.list;
        list.rules = list.rules.filter((x)=>x._id.toString() !== docid.toString());
        list.units = list.units.filter((x)=>x.doc._id.toString() !== docid.toString());
        this.performLocalChange(list);
    };
    addUnit = ()=>{
        console.log('add unit');
        let list = this.state.list;
        let unitid = new (0, $937a0acd9cd30227$export$e68967d37d049767)();
        if (!list.units) list.units = [];
        list.units.push({
            _id: unitid,
            name: undefined,
            doc: undefined,
            entity: undefined,
            qty: 0
        });
        this.performLocalChange(list);
        this.api('addUnit', {
            unitid: unitid
        });
    };
    attemptRemoveUnit = (unit, index)=>{
        let name = !!unit.name ? unit.name : 'Unit ' + index;
        if (window.confirm("Are you sure you want to delete this unit?\n" + name)) this.removeUnit(unit._id);
    };
    removeUnit = (unitid)=>{
        console.log('remove unit', unitid);
        let list = this.state.list;
        list = this.calculateArmyCost(list);
        this.performLocalChange(list);
        this.api('removeUnit', {
            unitid: unitid,
            listxp: list.xp
        });
        list.units = list.units.filter((x)=>x._id.toString() !== unitid.toString());
    };
    setUnitDoc = (e)=>{
        let list = this.state.list;
        let unitid = e.target.dataset.unitid;
        let docid = e.target.value;
        let unit = list.units.find((x)=>x._id.toString() === unitid);
        unit.docid = docid;
        unit.entityid = null;
        list = this.calculateArmyCost(list);
        this.performLocalChange(list);
        this.api('setUnitDoc', {
            unitid: unitid,
            docid: docid,
            listxp: list.xp
        });
    };
    setUnitEntity = (e)=>{
        let list = this.state.list;
        let unitid = e.target.dataset.unitid;
        let entityid = e.target.value;
        let unit = list.units.find((x)=>x._id.toString() === unitid);
        unit.entityid = entityid;
        list = this.calculateArmyCost(list);
        this.performLocalChange(list);
        this.api('setUnitEntity', {
            unitid: unitid,
            entityid: entityid,
            listxp: list.xp
        });
    };
    setUnitQuantity = (e)=>{
        let list = this.state.list;
        let unitid = e.target.dataset.unitid;
        let qty = e.target.value;
        let unit = list.units.find((x)=>x._id.toString() === unitid);
        unit.qty = qty;
        list = this.calculateArmyCost(list);
        this.performLocalChange(list);
        this.api('setUnitQty', {
            unitid: unitid,
            qty: qty,
            listxp: list.xp
        });
    };
    setTrashed = (e)=>{
        let list = this.state.list;
        let trashed = e.target.checked;
        this.api('setTrashed', {
            trashed: trashed
        });
        list.trashed = trashed;
        this.performLocalChange(list);
    };
    setUnlisted = (e)=>{
        let list = this.state.list;
        let unlisted = e.target.checked;
        this.api('setUnlisted', {
            unlisted: unlisted
        });
        list.unlisted = unlisted;
        this.performLocalChange(list);
    };
    refreshPage = (e)=>{
        this.getList();
    };
    render() {
        let list = this.state.list;
        // document.title = ['List', 'SGS'].join(' - ');
        let xp = !!list?.xp ? '(' + list.xp.toLocaleString() + "xp)" : "";
        let myId = (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user._id;
        let editable = !!myId && (list?.owner._id === myId || list?.editors?.map((x)=>x._id).includes(myId));
        if (!list) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "No List"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bbe2292908daaa2$export$2e2bcd8739ae039), {
                    fullpage: true
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
        list.units.forEach((unit)=>{
            unit.doc = list.rules.find((x)=>x._id.toString() === unit.docid);
            unit.entity = unit.doc?.entities.find((x)=>x._id.toString() === unit.entityid);
        });
        if (this.state.editing) {
            let tags = list.unitFilter.split(',').map((x)=>x.trim());
            document.title = [
                'Edit',
                list.name,
                'List',
                'SGS'
            ].join(' - ');
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "container ListPage",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h1", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                to: "/lists",
                                children: "List: "
                            }),
                            list?.name,
                            "\xa0",
                            xp,
                            "\xa0",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                onClick: ()=>this.setState({
                                        editing: false
                                    }),
                                children: "\uD83D\uDC41\uFE0FView List"
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                onClick: this.attemptRenameList,
                                children: "\uD83D\uDCDDRename List"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                        children: "Editors"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $60aab2f74d6f7a7e$export$2e2bcd8739ae039), {
                        list: list,
                        api: this.api,
                        performLocalChange: this.performLocalChange
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                        children: "Rules"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ul", {
                        children: list.rules.map((doc, index)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                        to: '/doc/' + doc._id,
                                        children: doc.name
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        className: "delete",
                                        onClick: this.attemptRemoveDoc,
                                        "data-docid": doc._id,
                                        "data-docname": doc.name,
                                        children: "x"
                                    })
                                ]
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        onClick: this.toggleAddDocModal,
                        children: "Add Doc"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c1392df855544c25$export$2e2bcd8739ae039), {
                        list: list,
                        api: this.api,
                        performLocalChange: this.performLocalChange
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                        children: "Units & Models"
                    }),
                    list.units.map((unit, index)=>{
                        // if(!unit.entity) return '';
                        let heading = unit.name || unit.entity?.name || '';
                        let entities = unit?.doc?.entities.filter((x)=>{
                            let match = false;
                            for(let i = 0; i < tags.length; i++){
                                let tag = tags[i];
                                if (x.tags.includes(tag)) {
                                    match = true;
                                    break;
                                }
                            }
                            return match;
                        });
                        let sortOrder = list.unitSortOrder;
                        switch(sortOrder?.toLowerCase() || sortOrder?.toLowerCase() || ''){
                            case 'xp':
                            case 'xp ascending':
                                entities = entities?.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)('xp', false, true));
                                break;
                            case 'xp descending':
                                entities = entities?.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)('xp', true, true));
                                break;
                            case 'name, reversed':
                                entities = entities?.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)('name', true, true));
                                break;
                            default:
                            case 'name':
                                entities = entities?.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)('name', false, true));
                                break;
                        }
                        if (!!heading) heading = ': ' + heading;
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "list-unit",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h3", {
                                    children: [
                                        "Unit ",
                                        index + 1,
                                        heading,
                                        "\xa0",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                            className: "delete",
                                            onClick: ()=>this.attemptRemoveUnit(unit, index),
                                            children: "x"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                    children: [
                                        "Doc",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                                            value: unit.docid || '',
                                            onChange: this.setUnitDoc,
                                            "data-unitid": unit._id,
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    value: "",
                                                    children: "none"
                                                }),
                                                list?.rules?.map((doc)=>{
                                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                        value: doc._id,
                                                        children: doc.name
                                                    }, doc._id);
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                    children: [
                                        "Entity",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                                            value: unit.entityid || '',
                                            onChange: this.setUnitEntity,
                                            "data-unitid": unit._id,
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    value: "",
                                                    children: "none"
                                                }),
                                                entities?.map((entity)=>{
                                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("option", {
                                                        value: entity._id,
                                                        children: [
                                                            entity.name,
                                                            "\xa0 (",
                                                            entity.xp,
                                                            ")"
                                                        ]
                                                    }, entity._id);
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                    children: [
                                        "Model Xp:\xa0",
                                        (unit.entity?.xp || 0).toLocaleString()
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                    children: [
                                        "Quantity\xa0",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                            value: unit.qty || 0,
                                            type: "number",
                                            step: 1,
                                            min: 0,
                                            max: 1000,
                                            placeholder: 0,
                                            "data-unitid": unit._id,
                                            onChange: this.setUnitQuantity
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                    children: [
                                        "Unit Xp:\xa0",
                                        ((unit.entity?.xp || 0) * (unit.qty || 0)).toLocaleString()
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {})
                            ]
                        }, index);
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        onClick: this.addUnit,
                        children: "Add Unit"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                        children: "Edit List"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                        children: [
                            "\uD83D\uDDD1\uFE0FTrashed \xa0",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                type: "checkbox",
                                checked: list.trashed || false,
                                onChange: this.setTrashed
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                        children: [
                            "\uD83D\uDCACUnlisted \xa0",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                type: "checkbox",
                                checked: list.unlisted || false,
                                onChange: this.setUnlisted
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b1842d6e2b218b23$export$2e2bcd8739ae039), {
                        addParentDoc: this.addDoc,
                        state: this.state,
                        setState: this.setState,
                        closeModal: this.closeModal
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
                ]
            });
        }
        document.title = [
            list.name,
            'List',
            'SGS'
        ].join(' - ');
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h1", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            className: "printless",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                to: "/lists",
                                children: "List: "
                            })
                        }),
                        list?.name,
                        "\xa0",
                        xp,
                        "\xa0",
                        editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    onClick: ()=>this.setState({
                                            editing: true
                                        }),
                                    className: "printless",
                                    children: "\uD83D\uDCDDEdit List"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    onClick: ()=>window.print(),
                                    className: "printless",
                                    children: "\uD83D\uDDA8\uFE0FPrint"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    onClick: this.refreshPage,
                                    children: "\uD83D\uDD04Refresh"
                                })
                            ]
                        })
                    ]
                }),
                list.units.map((unit, index)=>{
                    if (!unit.entity) return '';
                    let heading = unit.name || unit.entity?.name || '';
                    if (!!heading) heading = ': ' + heading;
                    if (!unit.qty || unit.qty < 1) return '';
                    let options = {
                        hideHeader: true,
                        includeEntities: unit.entity?.name
                    };
                    let format = (0, $712be45d7780c927$export$2e2bcd8739ae039);
                    let content = (0, $41374fe20d442493$export$2e2bcd8739ae039)(unit.doc, options, format);
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "list-unit",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h2", {
                                children: [
                                    "Unit ",
                                    index + 1,
                                    heading
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                                children: [
                                    unit.entity.xp.toLocaleString(),
                                    "xp \xd7 ",
                                    unit.qty,
                                    " models = ",
                                    (unit.entity.xp * unit.qty).toLocaleString(),
                                    "xp"
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "remove-heading",
                                children: (0, $1b12927fbd2f3766$export$2e2bcd8739ae039)(content)
                            })
                        ]
                    }, index);
                })
            ]
        });
    }
}




var $bh6RR = parcelRequire("bh6RR");



class $2b520f47dd43df37$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            lists: [],
            gettingLists: true
        };
    }
    // initializer
    componentDidMount() {
        this.getLists();
    }
    getLists = ()=>{
        fetch('/api/list/getLists', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            method: "GET"
        }).then((res)=>res.json()).then((lists)=>this.setState({
                lists: lists,
                gettingLists: false
            }));
    };
    render() {
        document.title = [
            'Army Lists',
            'SGS'
        ].join(' - ');
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "Army Lists"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2c423a1cfe3de390$export$2e2bcd8739ae039), {
                    lists: this.state.lists
                }),
                this.state.gettingLists && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bbe2292908daaa2$export$2e2bcd8739ae039), {})
            ]
        });
    }
}




var $bh6RR = parcelRequire("bh6RR");

class $d327ab3a7b09bc26$var$TagListPage extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {};
    }
    render() {
        document.title = [
            'Tags',
            'SGS'
        ].join(' - ');
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "Tags"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                    href: "https://gitlab.com/voidspiral/sgs-web/-/issues/69",
                    children: "task #69"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $d327ab3a7b09bc26$export$2e2bcd8739ae039 = $d327ab3a7b09bc26$var$TagListPage;




var $bh6RR = parcelRequire("bh6RR");

class $d404b76082c25d5d$var$TagPage extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.name = this.props.match.params.TagName;
        this.state = {};
    }
    render() {
        if (this.name) {
            document.title = [
                '#' + this.name,
                'SGS'
            ].join(' - ');
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "tag",
                        children: this.name
                    })
                })
            });
        } else return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "Tag: ?"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $d404b76082c25d5d$export$2e2bcd8739ae039 = $d404b76082c25d5d$var$TagPage;




var $bh6RR = parcelRequire("bh6RR");





class $99ed9bc86e0b87b0$var$DocListPage extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            docs: [],
            gettingDocs: true
        };
    }
    // initializer
    componentDidMount() {
        this.listDocs();
    }
    // class method
    listDocs = ()=>{
        fetch('/api/listDocs', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                type: this.props.type
            })
        }).then((res)=>res.json()).then((docs)=>{
            if (!docs) return;
            this.setState({
                docs: docs,
                gettingDocs: false
            });
        });
    };
    render() {
        let header = "Docs";
        if (this.props.type) header = (0, $920954e343704e08$exports.capitalize)(this.props.type) + "s";
        document.title = [
            header,
            'SGS'
        ].join(' - ');
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: header
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dca75a4a650b1abb$export$2e2bcd8739ae039), {
                    docs: this.state.docs
                }),
                this.state.gettingDocs && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bbe2292908daaa2$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $99ed9bc86e0b87b0$export$2e2bcd8739ae039 = $99ed9bc86e0b87b0$var$DocListPage;




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
const $f89c8989af59e866$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$f89c8989af59e866$export$c169aefb7330cccb["open"] = "0";
$f89c8989af59e866$export$c169aefb7330cccb["close"] = "1";
$f89c8989af59e866$export$c169aefb7330cccb["ping"] = "2";
$f89c8989af59e866$export$c169aefb7330cccb["pong"] = "3";
$f89c8989af59e866$export$c169aefb7330cccb["message"] = "4";
$f89c8989af59e866$export$c169aefb7330cccb["upgrade"] = "5";
$f89c8989af59e866$export$c169aefb7330cccb["noop"] = "6";
const $f89c8989af59e866$export$47791e8004edd485 = Object.create(null);
Object.keys($f89c8989af59e866$export$c169aefb7330cccb).forEach((key)=>{
    $f89c8989af59e866$export$47791e8004edd485[$f89c8989af59e866$export$c169aefb7330cccb[key]] = key;
});
const $f89c8989af59e866$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};


const $3644f08176c9f2bb$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $3644f08176c9f2bb$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $3644f08176c9f2bb$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $3644f08176c9f2bb$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($3644f08176c9f2bb$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $3644f08176c9f2bb$var$encodeBlobAsBase64(data, callback);
    } else if ($3644f08176c9f2bb$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $3644f08176c9f2bb$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $3644f08176c9f2bb$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $f89c8989af59e866$export$c169aefb7330cccb)[type] + (data || ""));
};
const $3644f08176c9f2bb$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $3644f08176c9f2bb$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $3644f08176c9f2bb$var$TEXT_ENCODER;
function $3644f08176c9f2bb$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($3644f08176c9f2bb$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($3644f08176c9f2bb$var$toArray).then(callback);
    else if ($3644f08176c9f2bb$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $3644f08176c9f2bb$var$isView(packet.data))) return callback($3644f08176c9f2bb$var$toArray(packet.data));
    $3644f08176c9f2bb$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$3644f08176c9f2bb$var$TEXT_ENCODER) $3644f08176c9f2bb$var$TEXT_ENCODER = new TextEncoder();
        callback($3644f08176c9f2bb$var$TEXT_ENCODER.encode(encoded));
    });
}



// imported from https://github.com/socketio/base64-arraybuffer
const $b263e77ac5d93d43$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $b263e77ac5d93d43$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $b263e77ac5d93d43$var$chars.length; i++)$b263e77ac5d93d43$var$lookup[$b263e77ac5d93d43$var$chars.charCodeAt(i)] = i;
const $b263e77ac5d93d43$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $b263e77ac5d93d43$var$chars[bytes[i] >> 2];
        base64 += $b263e77ac5d93d43$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $b263e77ac5d93d43$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $b263e77ac5d93d43$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $b263e77ac5d93d43$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $b263e77ac5d93d43$var$lookup[base64.charCodeAt(i)];
        encoded2 = $b263e77ac5d93d43$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $b263e77ac5d93d43$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $b263e77ac5d93d43$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $4e60a1440030b1e5$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $4e60a1440030b1e5$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $4e60a1440030b1e5$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $4e60a1440030b1e5$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $f89c8989af59e866$export$47791e8004edd485)[type];
    if (!packetType) return 0, $f89c8989af59e866$export$c718b5840781f8a7;
    return encodedPacket.length > 1 ? {
        type: (0, $f89c8989af59e866$export$47791e8004edd485)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $f89c8989af59e866$export$47791e8004edd485)[type]
    };
};
const $4e60a1440030b1e5$var$decodeBase64Packet = (data, binaryType)=>{
    if ($4e60a1440030b1e5$var$withNativeArrayBuffer) {
        const decoded = (0, $b263e77ac5d93d43$export$2f872c0f2117be69)(data);
        return $4e60a1440030b1e5$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $4e60a1440030b1e5$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};



const $fe27b42f62a0b23a$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $fe27b42f62a0b23a$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $3644f08176c9f2bb$export$57852049361a8e62)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($fe27b42f62a0b23a$var$SEPARATOR));
        });
    });
};
const $fe27b42f62a0b23a$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($fe27b42f62a0b23a$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $4e60a1440030b1e5$export$4647901878f33f31)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $fe27b42f62a0b23a$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $3644f08176c9f2bb$export$ec0c9b9013ee0ef5)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $fe27b42f62a0b23a$var$TEXT_DECODER;
function $fe27b42f62a0b23a$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $fe27b42f62a0b23a$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $fe27b42f62a0b23a$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$fe27b42f62a0b23a$var$TEXT_DECODER) $fe27b42f62a0b23a$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($fe27b42f62a0b23a$var$totalLength(chunks) < 1) break;
                    const header = $fe27b42f62a0b23a$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($fe27b42f62a0b23a$var$totalLength(chunks) < 2) break;
                    const headerArray = $fe27b42f62a0b23a$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($fe27b42f62a0b23a$var$totalLength(chunks) < 8) break;
                    const headerArray = $fe27b42f62a0b23a$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $f89c8989af59e866$export$c718b5840781f8a7));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($fe27b42f62a0b23a$var$totalLength(chunks) < expectedLength) break;
                    const data = $fe27b42f62a0b23a$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $4e60a1440030b1e5$export$4647901878f33f31)(isBinary ? data : $fe27b42f62a0b23a$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $f89c8989af59e866$export$c718b5840781f8a7));
                    break;
                }
            }
        }
    });
}
const $fe27b42f62a0b23a$export$a51d6b395ff4c65a = 4;


/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $5027b9ef9f081362$export$4293555f241ae35a(obj) {
    if (obj) return $5027b9ef9f081362$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $5027b9ef9f081362$var$mixin(obj) {
    for(var key in $5027b9ef9f081362$export$4293555f241ae35a.prototype)obj[key] = $5027b9ef9f081362$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $5027b9ef9f081362$export$4293555f241ae35a.prototype.on = $5027b9ef9f081362$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $5027b9ef9f081362$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $5027b9ef9f081362$export$4293555f241ae35a.prototype.off = $5027b9ef9f081362$export$4293555f241ae35a.prototype.removeListener = $5027b9ef9f081362$export$4293555f241ae35a.prototype.removeAllListeners = $5027b9ef9f081362$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $5027b9ef9f081362$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$5027b9ef9f081362$export$4293555f241ae35a.prototype.emitReserved = $5027b9ef9f081362$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $5027b9ef9f081362$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $5027b9ef9f081362$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};


const $1a33f23aee47623c$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $1a33f23aee47623c$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $1a33f23aee47623c$export$790dcbc41e2d75d5 = "arraybuffer";
function $1a33f23aee47623c$export$19413efcf2fac759() {}


function $a654872df0a37236$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $a654872df0a37236$var$NATIVE_SET_TIMEOUT = (0, $1a33f23aee47623c$export$394f9358f6231289).setTimeout;
const $a654872df0a37236$var$NATIVE_CLEAR_TIMEOUT = (0, $1a33f23aee47623c$export$394f9358f6231289).clearTimeout;
function $a654872df0a37236$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $a654872df0a37236$var$NATIVE_SET_TIMEOUT.bind((0, $1a33f23aee47623c$export$394f9358f6231289));
        obj.clearTimeoutFn = $a654872df0a37236$var$NATIVE_CLEAR_TIMEOUT.bind((0, $1a33f23aee47623c$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $1a33f23aee47623c$export$394f9358f6231289).setTimeout.bind((0, $1a33f23aee47623c$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $1a33f23aee47623c$export$394f9358f6231289).clearTimeout.bind((0, $1a33f23aee47623c$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $a654872df0a37236$var$BASE64_OVERHEAD = 1.33;
function $a654872df0a37236$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $a654872df0a37236$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $a654872df0a37236$var$BASE64_OVERHEAD);
}
function $a654872df0a37236$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $a654872df0a37236$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $37f6053cae6389f0$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $37f6053cae6389f0$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $80823453e94ee362$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $80823453e94ee362$export$86495b081fef8e52 extends (0, $5027b9ef9f081362$export$4293555f241ae35a) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $a654872df0a37236$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $80823453e94ee362$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $4e60a1440030b1e5$export$4647901878f33f31)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $37f6053cae6389f0$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}




class $d341ab83d6c3fd2c$export$265ee5eefd4c309b extends (0, $80823453e94ee362$export$86495b081fef8e52) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $fe27b42f62a0b23a$export$d10cc2e7f7566a2d)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $fe27b42f62a0b23a$export$144d64fe58dad441)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $a654872df0a37236$export$7fa8378418b4411e)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}





// imported from https://github.com/component/has-cors
let $b630d87d7a1aee8b$var$value = false;
try {
    $b630d87d7a1aee8b$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $b630d87d7a1aee8b$export$5235bbd4a1ef06e = $b630d87d7a1aee8b$var$value;


function $10b4b434dee9668d$var$empty() {}
class $10b4b434dee9668d$export$c959f2344155d309 extends (0, $d341ab83d6c3fd2c$export$265ee5eefd4c309b) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $10b4b434dee9668d$export$7fa6c5b6f8193917 extends (0, $5027b9ef9f081362$export$4293555f241ae35a) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $a654872df0a37236$export$2f67576668b97183)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $a654872df0a37236$export$357523c63a2253b9)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $10b4b434dee9668d$export$7fa6c5b6f8193917.requestsCount++;
            $10b4b434dee9668d$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $10b4b434dee9668d$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $10b4b434dee9668d$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$10b4b434dee9668d$export$7fa6c5b6f8193917.requestsCount = 0;
$10b4b434dee9668d$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $10b4b434dee9668d$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $1a33f23aee47623c$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $10b4b434dee9668d$var$unloadHandler, false);
    }
}
function $10b4b434dee9668d$var$unloadHandler() {
    for(let i in $10b4b434dee9668d$export$7fa6c5b6f8193917.requests)if ($10b4b434dee9668d$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $10b4b434dee9668d$export$7fa6c5b6f8193917.requests[i].abort();
}
const $10b4b434dee9668d$var$hasXHR2 = function() {
    const xhr = $10b4b434dee9668d$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $10b4b434dee9668d$export$a2d42eb087c10497 extends $10b4b434dee9668d$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $10b4b434dee9668d$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $10b4b434dee9668d$export$7fa6c5b6f8193917($10b4b434dee9668d$var$newRequest, this.uri(), opts);
    }
}
function $10b4b434dee9668d$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $b630d87d7a1aee8b$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $1a33f23aee47623c$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}






// detect ReactNative environment
const $27c278f171ec7d18$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $27c278f171ec7d18$export$570bf71d2367e261 extends (0, $80823453e94ee362$export$86495b081fef8e52) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $27c278f171ec7d18$var$isReactNative ? {} : (0, $a654872df0a37236$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $3644f08176c9f2bb$export$57852049361a8e62)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $1a33f23aee47623c$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $a654872df0a37236$export$7fa8378418b4411e)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $27c278f171ec7d18$var$WebSocketCtor = (0, $1a33f23aee47623c$export$394f9358f6231289).WebSocket || (0, $1a33f23aee47623c$export$394f9358f6231289).MozWebSocket;
class $27c278f171ec7d18$export$911baa0677ac404c extends $27c278f171ec7d18$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$27c278f171ec7d18$var$isReactNative ? protocols ? new $27c278f171ec7d18$var$WebSocketCtor(uri, protocols) : new $27c278f171ec7d18$var$WebSocketCtor(uri) : new $27c278f171ec7d18$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}





class $bdee58236f217b97$export$961c930859384407 extends (0, $80823453e94ee362$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $fe27b42f62a0b23a$export$552d20aac7500f47)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $fe27b42f62a0b23a$export$a525fb718e9c623a)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $1a33f23aee47623c$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}


const $2247a7bbcfd116f9$export$46dec00755c1153b = {
    websocket: (0, $27c278f171ec7d18$export$911baa0677ac404c),
    webtransport: (0, $bdee58236f217b97$export$961c930859384407),
    polling: (0, $10b4b434dee9668d$export$a2d42eb087c10497)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $39928263f1ba56b8$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $39928263f1ba56b8$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $39928263f1ba56b8$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $39928263f1ba56b8$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$39928263f1ba56b8$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $39928263f1ba56b8$var$pathNames(uri, uri['path']);
    uri.queryKey = $39928263f1ba56b8$var$queryKey(uri, uri['query']);
    return uri;
}
function $39928263f1ba56b8$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $39928263f1ba56b8$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}





const $4032f62c4c3e96e3$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $4032f62c4c3e96e3$var$OFFLINE_EVENT_LISTENERS = [];
if ($4032f62c4c3e96e3$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $4032f62c4c3e96e3$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $4032f62c4c3e96e3$export$3874118029a0ee0d extends (0, $5027b9ef9f081362$export$4293555f241ae35a) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $1a33f23aee47623c$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $39928263f1ba56b8$export$98e6a39c04603d36)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $39928263f1ba56b8$export$98e6a39c04603d36)(opts.host).host;
        (0, $a654872df0a37236$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $37f6053cae6389f0$export$2f872c0f2117be69)(this.opts.query);
        if ($4032f62c4c3e96e3$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $4032f62c4c3e96e3$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $1a33f23aee47623c$export$19413efcf2fac759)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $fe27b42f62a0b23a$export$a51d6b395ff4c65a);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $4032f62c4c3e96e3$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $4032f62c4c3e96e3$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $a654872df0a37236$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $1a33f23aee47623c$export$bdd553fddd433dcb)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $4032f62c4c3e96e3$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($4032f62c4c3e96e3$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $4032f62c4c3e96e3$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $4032f62c4c3e96e3$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
$4032f62c4c3e96e3$export$3874118029a0ee0d.protocol = (0, $fe27b42f62a0b23a$export$a51d6b395ff4c65a);
class $4032f62c4c3e96e3$export$cc521fcb1004e85c extends $4032f62c4c3e96e3$export$3874118029a0ee0d {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $4032f62c4c3e96e3$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $4032f62c4c3e96e3$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
class $4032f62c4c3e96e3$export$4798917dbf149b79 extends $4032f62c4c3e96e3$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $2247a7bbcfd116f9$export$46dec00755c1153b)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}








class $f8c0a10704525998$export$1e7deca84b429035 extends (0, $d341ab83d6c3fd2c$export$265ee5eefd4c309b) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}







const $e09054b0b0060718$export$a51d6b395ff4c65a = (0, $4032f62c4c3e96e3$export$4798917dbf149b79).protocol;


function $b60dcf3b6bdd15a1$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $39928263f1ba56b8$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}



var $63adb61906b50c52$exports = {};

$parcel$export($63adb61906b50c52$exports, "protocol", function () { return $63adb61906b50c52$export$a51d6b395ff4c65a; });
$parcel$export($63adb61906b50c52$exports, "PacketType", function () { return $63adb61906b50c52$export$84d4095e16c6fc19; });
$parcel$export($63adb61906b50c52$exports, "Encoder", function () { return $63adb61906b50c52$export$a50aceb0e02a00aa; });
$parcel$export($63adb61906b50c52$exports, "Decoder", function () { return $63adb61906b50c52$export$f9de6ca0bc043724; });

const $b035cba5787ae96b$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $b035cba5787ae96b$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $b035cba5787ae96b$var$toString = Object.prototype.toString;
const $b035cba5787ae96b$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $b035cba5787ae96b$var$toString.call(Blob) === "[object BlobConstructor]";
const $b035cba5787ae96b$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $b035cba5787ae96b$var$toString.call(File) === "[object FileConstructor]";
function $b035cba5787ae96b$export$37488ff1135b1696(obj) {
    return $b035cba5787ae96b$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $b035cba5787ae96b$var$isView(obj)) || $b035cba5787ae96b$var$withNativeBlob && obj instanceof Blob || $b035cba5787ae96b$var$withNativeFile && obj instanceof File;
}
function $b035cba5787ae96b$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($b035cba5787ae96b$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($b035cba5787ae96b$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $b035cba5787ae96b$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $b035cba5787ae96b$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}


function $cdac7b05a4bd2e81$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $cdac7b05a4bd2e81$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $cdac7b05a4bd2e81$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $b035cba5787ae96b$export$37488ff1135b1696)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $cdac7b05a4bd2e81$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $cdac7b05a4bd2e81$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $cdac7b05a4bd2e81$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $cdac7b05a4bd2e81$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $cdac7b05a4bd2e81$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $cdac7b05a4bd2e81$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $cdac7b05a4bd2e81$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}



/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $63adb61906b50c52$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $63adb61906b50c52$export$a51d6b395ff4c65a = 5;
var $63adb61906b50c52$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($63adb61906b50c52$export$84d4095e16c6fc19 || ($63adb61906b50c52$export$84d4095e16c6fc19 = {}));
class $63adb61906b50c52$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $63adb61906b50c52$export$84d4095e16c6fc19.EVENT || obj.type === $63adb61906b50c52$export$84d4095e16c6fc19.ACK) {
            if ((0, $b035cba5787ae96b$export$5234c529abdb5610)(obj)) return this.encodeAsBinary({
                type: obj.type === $63adb61906b50c52$export$84d4095e16c6fc19.EVENT ? $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_EVENT : $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $cdac7b05a4bd2e81$export$ac2edb9eb7af56f6)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $63adb61906b50c52$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $63adb61906b50c52$export$f9de6ca0bc043724 extends (0, $5027b9ef9f081362$export$4293555f241ae35a) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $63adb61906b50c52$export$84d4095e16c6fc19.EVENT : $63adb61906b50c52$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $63adb61906b50c52$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $b035cba5787ae96b$export$37488ff1135b1696)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($63adb61906b50c52$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($63adb61906b50c52$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $63adb61906b50c52$export$84d4095e16c6fc19.CONNECT:
                return $63adb61906b50c52$var$isObject(payload);
            case $63adb61906b50c52$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $63adb61906b50c52$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $63adb61906b50c52$var$isObject(payload);
            case $63adb61906b50c52$export$84d4095e16c6fc19.EVENT:
            case $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $63adb61906b50c52$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $63adb61906b50c52$export$84d4095e16c6fc19.ACK:
            case $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $63adb61906b50c52$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $cdac7b05a4bd2e81$export$a00da3b1ec037a04)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}


function $bc04b69669b9ce9d$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $8ceb1af91e646b90$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $8ceb1af91e646b90$export$4798917dbf149b79 extends (0, $5027b9ef9f081362$export$4293555f241ae35a) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $bc04b69669b9ce9d$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $bc04b69669b9ce9d$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $bc04b69669b9ce9d$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $bc04b69669b9ce9d$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($8ceb1af91e646b90$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $63adb61906b50c52$export$84d4095e16c6fc19).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $63adb61906b50c52$export$84d4095e16c6fc19).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $63adb61906b50c52$export$84d4095e16c6fc19).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $63adb61906b50c52$export$84d4095e16c6fc19).EVENT:
            case (0, $63adb61906b50c52$export$84d4095e16c6fc19).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $63adb61906b50c52$export$84d4095e16c6fc19).ACK:
            case (0, $63adb61906b50c52$export$84d4095e16c6fc19).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $63adb61906b50c52$export$84d4095e16c6fc19).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $63adb61906b50c52$export$84d4095e16c6fc19).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $63adb61906b50c52$export$84d4095e16c6fc19).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $63adb61906b50c52$export$84d4095e16c6fc19).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}




/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $83fa7bebd0a5dbe3$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $83fa7bebd0a5dbe3$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $83fa7bebd0a5dbe3$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $83fa7bebd0a5dbe3$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $83fa7bebd0a5dbe3$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $83fa7bebd0a5dbe3$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



class $d44caf2a0ad00b98$export$d0d38e7dec7a1a61 extends (0, $5027b9ef9f081362$export$4293555f241ae35a) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $a654872df0a37236$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $83fa7bebd0a5dbe3$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $63adb61906b50c52$exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $4032f62c4c3e96e3$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $bc04b69669b9ce9d$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $bc04b69669b9ce9d$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $bc04b69669b9ce9d$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $bc04b69669b9ce9d$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $bc04b69669b9ce9d$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $bc04b69669b9ce9d$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $bc04b69669b9ce9d$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $1a33f23aee47623c$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $8ceb1af91e646b90$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}





/**
 * Managers cache.
 */ const $88cc1e63c72b633d$var$cache = {};
function $88cc1e63c72b633d$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $b60dcf3b6bdd15a1$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $88cc1e63c72b633d$var$cache[id] && path in $88cc1e63c72b633d$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $d44caf2a0ad00b98$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$88cc1e63c72b633d$var$cache[id]) $88cc1e63c72b633d$var$cache[id] = new (0, $d44caf2a0ad00b98$export$d0d38e7dec7a1a61)(source, opts);
        io = $88cc1e63c72b633d$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($88cc1e63c72b633d$export$841407ceb083bd74, {
    Manager: $d44caf2a0ad00b98$export$d0d38e7dec7a1a61,
    Socket: $8ceb1af91e646b90$export$4798917dbf149b79,
    io: $88cc1e63c72b633d$export$841407ceb083bd74,
    connect: $88cc1e63c72b633d$export$841407ceb083bd74
});









var $bh6RR = parcelRequire("bh6RR");



class $401741b852153534$var$SummaryTab extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    render() {
        let doc = this.props.doc;
        // console.log(doc.total);
        if (!doc) return '';
        let rows = {
            'Owner': /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cc31eba22f67b38$export$2e2bcd8739ae039), {
                user: doc.owner
            }),
            'Editors': doc.editors?.length,
            'Parent Docs': doc.dependencies?.length,
            'Child Docs': this.props.children?.length,
            'Campaigns': this.props.campaigns?.length,
            'Primaries': doc.primaries?.length,
            'Tacticals': doc.tacticals?.length,
            'Skills': doc.skills?.length,
            'Thresholds': doc.thresholds?.length,
            'Pools': doc.pools?.length,
            'Rules': /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                href: "https://gitlab.com/voidspiral/sgs-web/-/issues/181",
                children: "task #181"
            }),
            'Entities': doc.entities?.length,
            'Tags': doc.tags?.length,
            'Xp': doc.total?.toLocaleString()
        };
        document.title = [
            'Summary',
            doc.name,
            'SGS'
        ].join(' - ');
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                    children: "Document Summary"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("table", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
                        children: Object.keys(rows).map((key)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                        children: key
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                        children: rows[key] !== undefined ? rows[key] : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bbe2292908daaa2$export$2e2bcd8739ae039), {
                                            small: true
                                        })
                                    })
                                ]
                            }, key);
                        })
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $401741b852153534$export$2e2bcd8739ae039 = $401741b852153534$var$SummaryTab;




var $bh6RR = parcelRequire("bh6RR");

parcelRequire("bh6RR");

parcelRequire("bh6RR");
function $b5e42a160c40ff96$export$2e2bcd8739ae039(props) {
    const types = {
        number: {
            examples: '3, +2, +1',
            display: 'Number Only'
        },
        dieSize: {
            examples: 'd8, d4, d20',
            display: 'Die Size'
        },
        dicePool: {
            examples: '1d6, 4d8, 3d6+6',
            display: 'Dice Pool'
        },
        formula: {
            examples: 'max(statref(agility), statref(creativity))',
            display: 'Formula'
        }
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("select", {
        title: types[props.stat.valueType].examples,
        value: props.stat.valueType,
        onChange: props.changeStatValueType,
        "data-statid": props.stat._id,
        "data-statname": props.stat.name,
        "data-statgroup": props.statGroup,
        children: Object.entries(types).map(([typeName, type])=>{
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                value: typeName,
                title: type.examples,
                children: type.display
            }, typeName);
        })
    });
}



parcelRequire("bh6RR");

parcelRequire("bh6RR");


function $04f87b44fc532309$var$statOptions(doc, groupName) {
    let label = (0, $920954e343704e08$exports.capitalize)(groupName);
    let group = groupName.toLowerCase();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("optgroup", {
        label: label,
        children: doc[group].map((stat)=>{
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                children: stat.name
            }, stat._id);
        })
    });
}
function $04f87b44fc532309$var$opOptions(doc, strategy) {
    let label = (0, $920954e343704e08$exports.capitalize)(strategy);
    let group = Object.keys((0, $cd6dad6538e950c7$export$2e2bcd8739ae039).operations).filter((v, i, s)=>{
        return (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).operations[v].strategy === strategy;
    });
    // console.log(group);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("optgroup", {
        label: label,
        children: group.map((op)=>{
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                title: (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).operations[op].desc,
                "data-op": op,
                children: op
            }, op);
        })
    }, label);
}
function $04f87b44fc532309$export$2e2bcd8739ae039(props) {
    // console.log(props.node);
    const doc = props.doc;
    const statname = props.statname;
    const statgroup = props.statgroup;
    const op = props.node?.op || 'none';
    // const parentStrat = !!props.parent
    //     ? Sgs.operations[props.parent].strategy : '';
    const strategy = (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).operations[op].strategy;
    const desc = (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).operations[op].desc;
    const index = props.index || 0;
    const children = props.node?.children;
    const value = props.node?.value;
    const classes = 'expressionNode';
    const numerator = (typeof value === 'string' || value instanceof String) && value?.includes('/') ? value.split('/')[0] : undefined;
    const denominator = (typeof value === 'string' || value instanceof String) && value?.includes('/') ? value.split('/')[1] : undefined;
    const strategies = Object.keys((0, $cd6dad6538e950c7$export$2e2bcd8739ae039).operations).map((key)=>{
        return (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).operations[key].strategy;
    }).filter((v, i, s)=>{
        return s.indexOf(v) === i;
    });
    // console.log(strategies);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
        className: classes,
        "data-op": op,
        children: [
            !props.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                children: op
            }),
            props.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                value: op,
                "data-index": index,
                "data-field": "operation",
                "data-statname": statname,
                "data-statgroup": statgroup,
                title: desc,
                className: "opDropdown",
                onChange: props.changeFormula,
                style: {
                    width: op.toString().length + 4 + 'ch'
                },
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("optgroup", {
                        label: "Modify",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                title: "wrap this operator in another",
                                "data-op": "wrap",
                                children: "wrap"
                            }),
                            strategy !== 'number' && strategy !== 'select' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                title: "remove this operator & leave children",
                                "data-op": "unwrap",
                                children: "unwrap"
                            }),
                            strategy === 'array' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                title: "add a child operator to this one",
                                "data-op": "push",
                                value: "push",
                                children: "add child"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                title: "remove this operator",
                                "data-op": "remove",
                                children: "remove"
                            })
                        ]
                    }),
                    strategies.map((x)=>$04f87b44fc532309$var$opOptions(doc, x))
                ]
            }),
            strategy === 'binary' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                children: [
                    "(",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($04f87b44fc532309$export$2e2bcd8739ae039, {
                        doc: props.doc,
                        statname: statname,
                        statgroup: statgroup,
                        node: children?.[0],
                        index: index + '.' + 0,
                        parent: op,
                        changeFormula: props.changeFormula,
                        editable: props.editable
                    }),
                    (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).operations[op].sep,
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($04f87b44fc532309$export$2e2bcd8739ae039, {
                        doc: props.doc,
                        statname: statname,
                        statgroup: statgroup,
                        node: children?.[1],
                        index: index + '.' + 1,
                        parent: op,
                        changeFormula: props.changeFormula,
                        editable: props.editable
                    }),
                    ")"
                ]
            }),
            strategy === 'array' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                className: "opArray",
                children: [
                    "(",
                    children.map((child, i)=>{
                        let level = index + '.' + i;
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($04f87b44fc532309$export$2e2bcd8739ae039, {
                            doc: props.doc,
                            statname: statname,
                            statgroup: statgroup,
                            node: child,
                            index: level,
                            parent: op,
                            changeFormula: props.changeFormula,
                            editable: props.editable
                        }, level);
                    }),
                    ")"
                ]
            }),
            strategy === 'select' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                children: [
                    "(",
                    !props.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: value
                    }),
                    props.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                        value: value,
                        onChange: props.changeFormula,
                        "data-index": index,
                        "data-field": "statname",
                        "data-statname": statname,
                        "data-statgroup": statgroup,
                        style: {
                            width: (value?.toString().length || 5) + 4 + 'ch'
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                children: "none"
                            }),
                            $04f87b44fc532309$var$statOptions(doc, 'Primaries'),
                            $04f87b44fc532309$var$statOptions(doc, 'Skills'),
                            $04f87b44fc532309$var$statOptions(doc, 'Tacticals'),
                            $04f87b44fc532309$var$statOptions(doc, 'Thresholds'),
                            $04f87b44fc532309$var$statOptions(doc, 'Pools')
                        ]
                    }),
                    ")"
                ]
            }),
            op === 'integer' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                children: [
                    "(",
                    !props.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: value
                    }),
                    props.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        type: "number",
                        step: "1",
                        style: {
                            width: value?.toString().length + 2 + 'rem'
                        },
                        value: value,
                        onChange: props.changeFormula,
                        "data-index": index,
                        "data-field": "number",
                        "data-statname": statname,
                        "data-statgroup": statgroup
                    }),
                    ")"
                ]
            }),
            op === 'decimal' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                children: [
                    "(",
                    !props.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: value
                    }),
                    props.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        type: "number",
                        style: {
                            width: value?.toString().length + 2 + 'rem'
                        },
                        value: value,
                        onChange: props.changeFormula,
                        "data-index": index,
                        "data-field": "number",
                        "data-statname": statname,
                        "data-statgroup": statgroup
                    }),
                    ")"
                ]
            }),
            op === 'fraction' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                children: [
                    "(",
                    !props.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: numerator + '/' + denominator
                    }),
                    props.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        type: "number",
                        step: "1",
                        style: {
                            width: numerator?.toString().length + 2 + 'rem'
                        },
                        value: numerator || 1,
                        onChange: props.changeFormula,
                        "data-index": index,
                        "data-field": "numerator",
                        "data-statname": statname,
                        "data-statgroup": statgroup
                    }),
                    props.editable && '/',
                    props.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        type: "number",
                        step: "1",
                        style: {
                            width: denominator?.toString().length + 2 + 'rem'
                        },
                        value: denominator || 1,
                        onChange: props.changeFormula,
                        "data-index": index,
                        "data-field": "denominator",
                        "data-statname": statname,
                        "data-statgroup": statgroup
                    }),
                    ")"
                ]
            })
        ]
    });
}



function $a7bf4dc901069f75$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "formulaEditBox",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $04f87b44fc532309$export$2e2bcd8739ae039), {
            node: props.formula,
            doc: props.doc,
            changeFormula: props.changeFormula,
            statname: props.statname,
            statgroup: props.statgroup,
            editable: props.editable
        })
    });
}



function $cd9e2ff724e3a96d$export$2e2bcd8739ae039(props) {
    const changeTacOffset = props.changeTacOffset;
    const stat = props.stat;
    const group = props.group;
    const rightType = stat.valueType !== 'formula';
    if (!stat.editable) {
        if (rightType) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            children: stat.offset
        });
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {});
    }
    if (stat.editable) {
        if (rightType) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                type: "number",
                min: "-10",
                max: "10",
                step: "1",
                "data-skillname": stat.name,
                "data-statgroup": group,
                value: stat.offset ? stat.offset : 0,
                onChange: changeTacOffset
            })
        });
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                title: "A value offset is only available on stats with a value, IE not Formulas.",
                children: "none"
            })
        });
    }
}



function $1e918e6c25b6b3a5$export$2e2bcd8739ae039(props) {
    const changeDisplayFormat = (e)=>{
        let newFormat = e.target.value;
        let oldFormat = e.target.dataset.originalvalue;
        // console.log(newFormat);
        if (newFormat === oldFormat) return;
        props.sendMessage({
            operation: 'change stat display format',
            statId: props.stat._id,
            statGroup: props.group,
            displayFormat: newFormat
        });
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
        type: "text",
        defaultValue: props.stat.displayFormat || "",
        placeholder: "+X",
        "data-originalvalue": props.stat.displayFormat,
        title: "enter any string containing `X`\n`X` will be replaced with the stat value",
        onBlur: changeDisplayFormat
    });
}



function $7775c5813ae57dec$export$2e2bcd8739ae039(props) {
    const changeDisplayVisibility = (e)=>{
        let newVis = e.target.value;
        props.sendMessage({
            operation: 'change stat display visibility',
            statId: props.stat._id,
            statGroup: props.group,
            displayVisibility: newVis
        });
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
        value: props.stat.displayVisibility || '',
        onChange: changeDisplayVisibility,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                value: "",
                children: "Always"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                value: "items",
                children: "Only On Items"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                value: "owners",
                children: "Only On Owners"
            })
        ]
    });
}


/**
 * Shows a numerical input to adjust the index of the stat in the array.
 * @param {Object} doc the document
 * @param {String} groupName the name of the group the stat is in
 * @param {Object} stat the stat object we're editing
 * @param {Number} startingIndex the original index of the stat  
 * @param {Function} sendMessage the sendMessage method that allows us to call socket server API methods
 */ 
function $1f35e42b1e742f73$export$2e2bcd8739ae039(props) {
    // let doc = props.doc;
    let stat = props.stat;
    let groupName = props.groupName;
    let startingIndex = props.startingIndex;
    const setIndex = (e)=>{
        let statName = e.target.dataset.statname;
        let newIndex = e.target.dataset.newindex;
        let oldIndex = e.target.dataset.oldindex;
        // console.log(statName, oldIndex, newIndex);
        let statid = e.target.dataset.statid;
        props.sendMessage({
            operation: 'set stat index',
            statName: statName,
            statGroup: groupName,
            statid: statid,
            newIndex: newIndex,
            oldIndex: oldIndex
        });
    };
    if (!stat.editable) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {});
    let max = props.doc[groupName].length - 1;
    console.log(max);
    let prevIndex = Math.max(0, startingIndex - 1);
    let nextIndex = Math.min(max, startingIndex + 1);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                onClick: setIndex,
                "data-oldindex": startingIndex,
                "data-newindex": prevIndex,
                "data-statname": stat.name,
                "data-statid": stat._id,
                disabled: prevIndex === startingIndex,
                children: "\u2BC5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                onClick: setIndex,
                "data-oldindex": startingIndex,
                "data-newindex": nextIndex,
                "data-statname": stat.name,
                "data-statid": stat._id,
                disabled: nextIndex === startingIndex,
                children: "\u2BC6"
            })
        ]
    });
}


/**
 * UI cell for editing the Experience Value Exponent of a Stat
 * @param {Object} stat the stat we want to edit
 * @param {Object} doc the doc containing the stat
 * @param {String} group the name of the stat group
 * @param {Function} sendMessage the sendMessage function for interacting with the SocketDoc
 */ 
function $d5a18ec77577ae55$export$2e2bcd8739ae039(props) {
    let current = props.stat?.exponent || 2;
    const setExponent = (e)=>{
        let newExponent = e.target.value;
        props.sendMessage({
            operation: 'set stat exponent',
            statName: props.stat.name,
            statGroup: props.group,
            statId: props.stat._id,
            newExponent: newExponent
        });
    };
    if (!props.doc?.editable || !props.stat?.editable) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
            value: current,
            type: "number",
            min: "0",
            max: "5",
            disabled: true
        })
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
            value: current,
            type: "number",
            min: "0",
            max: "5",
            onChange: setExponent
        })
    });
}


function $1c256cd0c9445956$export$2e2bcd8739ae039(props) {
    const doc = props.doc;
    const renameStat = props.renameStat;
    const addStat = props.addStat;
    const removeStat = props.removeStat;
    const group = 'primaries';
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "panel",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h4", {
                children: "Primary Stats"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Stat"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Skills"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Type"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Formula"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Offset"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Exponent"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Display Format"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Visibility"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Reorder"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Rename"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Delete"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                        children: [
                            doc?.primaries?.map((stat, index)=>{
                                let skills = doc?.skills?.filter((x)=>x.skillStat?.toLowerCase() === stat.name.toLowerCase());
                                let count = skills.length;
                                let xs = stat.externalSource;
                                let title = !!xs ? 'source ' + xs.type + ' doc: ' + xs.name : null;
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                                title: title,
                                                children: [
                                                    title && "\uD83D\uDD3C",
                                                    stat.name
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: count
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                            children: [
                                                !stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    children: stat.valueType
                                                }),
                                                stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b5e42a160c40ff96$export$2e2bcd8739ae039), {
                                                    stat: stat,
                                                    statGroup: group,
                                                    changeStatValueType: props.changeStatValueType
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: stat.valueType === 'formula' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a7bf4dc901069f75$export$2e2bcd8739ae039), {
                                                doc: doc,
                                                changeFormula: props.changeFormula,
                                                formula: stat.formula,
                                                statname: stat.name,
                                                statgroup: group,
                                                editable: stat.editable
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cd9e2ff724e3a96d$export$2e2bcd8739ae039), {
                                            stat: stat,
                                            changeTacOffset: props.changeTacOffset,
                                            group: group
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d5a18ec77577ae55$export$2e2bcd8739ae039), {
                                            stat: stat,
                                            doc: doc,
                                            sendMessage: props.sendMessage,
                                            group: group
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1e918e6c25b6b3a5$export$2e2bcd8739ae039), {
                                                stat: stat,
                                                sendMessage: props.sendMessage,
                                                group: group
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7775c5813ae57dec$export$2e2bcd8739ae039), {
                                                stat: stat,
                                                sendMessage: props.sendMessage,
                                                group: group
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1f35e42b1e742f73$export$2e2bcd8739ae039), {
                                            doc: doc,
                                            groupName: group,
                                            stat: stat,
                                            startingIndex: index,
                                            sendMessage: props.sendMessage
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                onClick: ()=>renameStat(group, stat.name),
                                                children: "rename"
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                className: "delete",
                                                onClick: ()=>{
                                                    removeStat(group, stat.name);
                                                },
                                                children: "x"
                                            })
                                        })
                                    ]
                                }, stat.name);
                            }),
                            doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    colSpan: "99",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: ()=>{
                                            addStat(group, 'Primary');
                                        },
                                        children: "Add New"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");







function $dcabd5cecd5fcc69$export$2e2bcd8739ae039(props) {
    const doc = props.doc;
    const renameStat = props.renameStat;
    const addStat = props.addStat;
    const removeStat = props.removeStat;
    const group = 'tacticals';
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "panel",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h4", {
                children: "Tactical Stats"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Stat"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Type"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Formula"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Offset"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Exponent"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Display Format"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Visibility"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Reorder"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Rename"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Delete"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                        children: [
                            doc?.tacticals?.map((stat, index)=>{
                                let xs = stat.externalSource;
                                let title = !!xs ? 'source ' + xs.type + ' doc: ' + xs.name : null;
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                                title: title,
                                                children: [
                                                    title && "\uD83D\uDD3C",
                                                    stat.name
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                            children: [
                                                !stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    children: stat.valueType
                                                }),
                                                stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b5e42a160c40ff96$export$2e2bcd8739ae039), {
                                                    stat: stat,
                                                    statGroup: group,
                                                    changeStatValueType: props.changeStatValueType
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: stat.valueType === 'formula' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a7bf4dc901069f75$export$2e2bcd8739ae039), {
                                                doc: doc,
                                                changeFormula: props.changeFormula,
                                                formula: stat.formula,
                                                statname: stat.name,
                                                statgroup: group,
                                                editable: stat.editable
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cd9e2ff724e3a96d$export$2e2bcd8739ae039), {
                                            stat: stat,
                                            changeTacOffset: props.changeTacOffset,
                                            group: group
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d5a18ec77577ae55$export$2e2bcd8739ae039), {
                                            stat: stat,
                                            doc: doc,
                                            sendMessage: props.sendMessage,
                                            group: group
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1e918e6c25b6b3a5$export$2e2bcd8739ae039), {
                                                stat: stat,
                                                sendMessage: props.sendMessage,
                                                group: group
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7775c5813ae57dec$export$2e2bcd8739ae039), {
                                                stat: stat,
                                                sendMessage: props.sendMessage,
                                                group: group
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1f35e42b1e742f73$export$2e2bcd8739ae039), {
                                            doc: doc,
                                            groupName: group,
                                            stat: stat,
                                            startingIndex: index,
                                            sendMessage: props.sendMessage
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                onClick: ()=>renameStat(group, stat.name),
                                                children: "rename"
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                className: "delete",
                                                onClick: ()=>{
                                                    removeStat(group, stat.name);
                                                },
                                                children: "x"
                                            })
                                        })
                                    ]
                                }, stat.name);
                            }),
                            doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    colSpan: "99",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: ()=>{
                                            addStat(group, 'Tactical');
                                        },
                                        children: "Add New"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");







function $59df28a06cae148b$export$2e2bcd8739ae039(props) {
    const doc = props.doc;
    const renameStat = props.renameStat;
    const addStat = props.addStat;
    const removeStat = props.removeStat;
    const group = 'thresholds';
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "panel",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h4", {
                children: "Thresholds"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Stat"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Type"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Formula"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Offset"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Exponent"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Display Format"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Visibility"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Reorder"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Rename"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Delete"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                        children: [
                            doc?.thresholds?.map((stat, index)=>{
                                let xs = stat.externalSource;
                                let title = !!xs ? 'source ' + xs.type + ' doc: ' + xs.name : null;
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                                title: title,
                                                children: [
                                                    title && "\uD83D\uDD3C",
                                                    stat.name
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                            children: [
                                                !stat.editable && stat.valueType,
                                                stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b5e42a160c40ff96$export$2e2bcd8739ae039), {
                                                    stat: stat,
                                                    statGroup: "thresholds",
                                                    changeStatValueType: props.changeStatValueType
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: stat.valueType === 'formula' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a7bf4dc901069f75$export$2e2bcd8739ae039), {
                                                doc: doc,
                                                changeFormula: props.changeFormula,
                                                formula: stat.formula,
                                                statname: stat.name,
                                                statgroup: group,
                                                editable: stat.editable
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cd9e2ff724e3a96d$export$2e2bcd8739ae039), {
                                            stat: stat,
                                            changeTacOffset: props.changeTacOffset,
                                            group: group
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d5a18ec77577ae55$export$2e2bcd8739ae039), {
                                            stat: stat,
                                            doc: doc,
                                            sendMessage: props.sendMessage,
                                            group: group
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1e918e6c25b6b3a5$export$2e2bcd8739ae039), {
                                                stat: stat,
                                                sendMessage: props.sendMessage,
                                                group: group
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7775c5813ae57dec$export$2e2bcd8739ae039), {
                                                stat: stat,
                                                sendMessage: props.sendMessage,
                                                group: group
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1f35e42b1e742f73$export$2e2bcd8739ae039), {
                                            doc: doc,
                                            groupName: group,
                                            stat: stat,
                                            startingIndex: index,
                                            sendMessage: props.sendMessage
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                onClick: ()=>renameStat(group, stat.name),
                                                children: "rename"
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                className: "delete",
                                                onClick: ()=>{
                                                    removeStat(group, stat.name);
                                                },
                                                children: "x"
                                            })
                                        })
                                    ]
                                }, stat.name);
                            }),
                            doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    colSpan: "99",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: ()=>{
                                            addStat(group, 'Threshold');
                                        },
                                        children: "Add New"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");







function $fc8347976e472264$export$2e2bcd8739ae039(props) {
    const doc = props.doc;
    const renameStat = props.renameStat;
    const addStat = props.addStat;
    const removeStat = props.removeStat;
    const group = 'pools';
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "panel",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h4", {
                children: "Pools"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Stat"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Type"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Formula"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Offset"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Exponent"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Display Format"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Visibility"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Reorder"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Rename"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Delete"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                        children: [
                            doc?.pools?.map((stat, index)=>{
                                let xs = stat.externalSource;
                                let title = !!xs ? 'source ' + xs.type + ' doc: ' + xs.name : null;
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                                title: title,
                                                children: [
                                                    title && "\uD83D\uDD3C",
                                                    stat.name
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                            children: [
                                                !stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    children: stat.valueType
                                                }),
                                                stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b5e42a160c40ff96$export$2e2bcd8739ae039), {
                                                    stat: stat,
                                                    statGroup: group,
                                                    changeStatValueType: props.changeStatValueType
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: stat.valueType === 'formula' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a7bf4dc901069f75$export$2e2bcd8739ae039), {
                                                doc: doc,
                                                changeFormula: props.changeFormula,
                                                formula: stat.formula,
                                                statname: stat.name,
                                                statgroup: group,
                                                editable: stat.editable
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cd9e2ff724e3a96d$export$2e2bcd8739ae039), {
                                            stat: stat,
                                            changeTacOffset: props.changeTacOffset,
                                            group: group
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d5a18ec77577ae55$export$2e2bcd8739ae039), {
                                            stat: stat,
                                            doc: doc,
                                            sendMessage: props.sendMessage,
                                            group: group
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1e918e6c25b6b3a5$export$2e2bcd8739ae039), {
                                                stat: stat,
                                                sendMessage: props.sendMessage,
                                                group: group
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1f35e42b1e742f73$export$2e2bcd8739ae039), {
                                            doc: doc,
                                            groupName: group,
                                            stat: stat,
                                            startingIndex: index,
                                            sendMessage: props.sendMessage
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7775c5813ae57dec$export$2e2bcd8739ae039), {
                                                stat: stat,
                                                sendMessage: props.sendMessage,
                                                group: group
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                onClick: ()=>renameStat(group, stat.name),
                                                children: "rename"
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: stat.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                className: "delete",
                                                onClick: ()=>{
                                                    removeStat(group, stat.name);
                                                },
                                                children: "x"
                                            })
                                        })
                                    ]
                                }, stat.name);
                            }),
                            doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    colSpan: "99",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: ()=>{
                                            addStat(group, 'Pool');
                                        },
                                        children: "Add New"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");








function $1877f7dcad7a93fa$export$2e2bcd8739ae039(props) {
    const doc = props.doc;
    const renameStat = props.renameStat;
    const addStat = props.addStat;
    const removeStat = props.removeStat;
    const changeSkillGroup = props.changeSkillGroup;
    const changeSkillStat = props.changeSkillStat;
    const sortSkills = props.sortSkills;
    const skillSortProp = props.skillSortProp;
    const groups = [
        'none',
        'Academic',
        'Combat',
        'Espionage',
        'Social',
        'Special'
    ];
    const skills = doc?.skills || [];
    skills.forEach((x, i)=>x.index = i);
    const group = 'skills';
    skills.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)(skillSortProp));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "panel",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h4", {
                children: "Skills"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: sortSkills,
                                        "data-prop": "name",
                                        title: "sort by name",
                                        children: "Skill\u25BC"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: sortSkills,
                                        "data-prop": "skillGroup",
                                        title: "sort by group",
                                        children: "Group \u25BC"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: sortSkills,
                                        "data-prop": "skillStat",
                                        title: "sort by stat",
                                        children: "Stat \u25BC"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Type"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Formula"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Offset"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Value Exponent"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Display Format"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Visibility"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Reorder"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Rename"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Delete"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                        children: [
                            skills.map((skill, index)=>{
                                let xs = skill.externalSource;
                                let title = !!xs ? 'source ' + xs.type + ' doc: ' + xs.name : null;
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                                title: title,
                                                children: [
                                                    title && "\uD83D\uDD3C",
                                                    skill.name
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                            className: "input-cell",
                                            children: [
                                                !skill.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    children: skill.skillGroup
                                                }),
                                                skill.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("select", {
                                                    "data-skillname": skill.name,
                                                    value: skill.skillGroup,
                                                    onChange: changeSkillGroup,
                                                    children: groups.map((skillGroup)=>{
                                                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                            children: skillGroup
                                                        }, skillGroup);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                            className: "input-cell",
                                            children: [
                                                !skill.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    children: skill.skillStat
                                                }),
                                                skill.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                                                    "data-skillname": skill.name,
                                                    value: skill.skillStat,
                                                    onChange: changeSkillStat,
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                            children: "none"
                                                        }),
                                                        doc.primaries.map((primary)=>{
                                                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                                children: primary.name
                                                            }, primary._id);
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                            children: [
                                                !skill.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    children: skill.valueType
                                                }),
                                                skill.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b5e42a160c40ff96$export$2e2bcd8739ae039), {
                                                    stat: skill,
                                                    statGroup: group,
                                                    changeStatValueType: props.changeStatValueType
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: skill.valueType === 'formula' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a7bf4dc901069f75$export$2e2bcd8739ae039), {
                                                doc: doc,
                                                changeFormula: props.changeFormula,
                                                formula: skill.formula,
                                                statname: skill.name,
                                                statgroup: group,
                                                editable: skill.editable
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cd9e2ff724e3a96d$export$2e2bcd8739ae039), {
                                            stat: skill,
                                            changeTacOffset: props.changeTacOffset,
                                            group: group
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d5a18ec77577ae55$export$2e2bcd8739ae039), {
                                            stat: skill,
                                            doc: doc,
                                            sendMessage: props.sendMessage,
                                            group: group
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1e918e6c25b6b3a5$export$2e2bcd8739ae039), {
                                                stat: skill,
                                                sendMessage: props.sendMessage,
                                                group: group
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7775c5813ae57dec$export$2e2bcd8739ae039), {
                                                stat: skill,
                                                sendMessage: props.sendMessage,
                                                group: group
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1f35e42b1e742f73$export$2e2bcd8739ae039), {
                                            doc: doc,
                                            groupName: group,
                                            stat: skill,
                                            startingIndex: skill.index,
                                            sendMessage: props.sendMessage
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: skill.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                onClick: ()=>renameStat(group, skill.name),
                                                children: "rename"
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: skill.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                className: "delete",
                                                onClick: ()=>{
                                                    removeStat(group, skill.name);
                                                },
                                                children: "x"
                                            })
                                        })
                                    ]
                                }, skill.name);
                            }),
                            doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    colSpan: "99",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: ()=>{
                                            addStat(group, 'Skill');
                                        },
                                        children: "Add New"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $d5119b7b8a5d679e$export$2e2bcd8739ae039(props) {
    const doc = props.doc;
    const renameStat = props.renameStat;
    const addStat = props.addStat;
    const removeStat = props.removeStat;
    const changeLimitMult = props.changeLimitMult;
    const sendMessage = props.sendMessage;
    const changeLimitInactiveBool = props.changeLimitInactiveBool;
    const multipliers = [
        'none',
        '10',
        '5',
        '3',
        '2',
        '1.5',
        '1.25',
        '1.1',
        '1',
        '3/4',
        '2/3',
        '1/2',
        '1/3',
        '1/4',
        '1/10'
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "panel",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h4", {
                children: "Limitations"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Limitation"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Multiplier"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Inactive By Default"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Reorder"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Rename"
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                    children: "Delete"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                        children: [
                            doc?.limitations?.map((limit, index)=>{
                                let xs = limit.externalSource;
                                let title = !!xs ? 'source ' + xs.type + ' doc: ' + xs.name : null;
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                                title: title,
                                                children: [
                                                    title && "\uD83D\uDD3C",
                                                    limit.name
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                            className: "input-cell",
                                            children: [
                                                !limit.editable && limit.multiplier,
                                                limit.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("select", {
                                                    "data-skillname": limit.name,
                                                    value: limit.multiplier,
                                                    onChange: changeLimitMult,
                                                    children: multipliers.map((mult)=>{
                                                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                            children: mult
                                                        }, mult);
                                                    })
                                                })
                                            ]
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: limit.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                type: "checkbox",
                                                onChange: changeLimitInactiveBool,
                                                defaultChecked: limit.inactive,
                                                "data-limit": limit._id
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1f35e42b1e742f73$export$2e2bcd8739ae039), {
                                            doc: doc,
                                            groupName: 'limitations',
                                            stat: limit,
                                            startingIndex: index,
                                            sendMessage: sendMessage
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: limit.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                onClick: ()=>renameStat('limitations', limit.name),
                                                children: "rename"
                                            })
                                        }),
                                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: limit.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                className: "delete",
                                                onClick: ()=>{
                                                    removeStat('limitations', limit.name);
                                                },
                                                children: "x"
                                            })
                                        })
                                    ]
                                }, limit.name);
                            }),
                            doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    colSpan: "99",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: ()=>{
                                            addStat('limitations', 'Limitation');
                                        },
                                        children: "Add New"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}





var $bh6RR = parcelRequire("bh6RR");
class $fca249825a05ea51$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    addNewTrack = (e)=>{
        this.props.sendMessage({
            operation: 'add new track'
        });
    };
    attemptRemoveTrack = (e)=>{
        let trackid = e.target.dataset.trackid;
        let trackname = e.target.dataset.trackname;
        if (window.confirm('Are you sure you want to delete the track: ' + trackname + '?')) this.removeTrack(trackid);
    };
    removeTrack = (trackid)=>{
        this.props.sendMessage({
            operation: 'remove track',
            trackid: trackid
        });
    };
    attemptRenameTrack = (e)=>{
        let trackid = e.target.dataset.trackid;
        let trackname = window.prompt("New Track Name");
        // console.log(trackid, trackname);
        this.renameTrack(trackid, trackname);
    };
    renameTrack = (trackid, trackname)=>{
        this.props.sendMessage({
            operation: 'rename track',
            trackid: trackid,
            trackname: trackname
        });
    };
    addNewLayer = (e)=>{
        let trackid = e.target.dataset.trackid;
        this.props.sendMessage({
            operation: 'add new layer',
            trackid: trackid
        });
    };
    removeLayer = (e)=>{
        let trackid = e.target.dataset.trackid;
        let layerid = e.target.dataset.layerid;
        this.props.sendMessage({
            operation: 'remove layer',
            trackid: trackid,
            layerid: layerid
        });
    };
    setLayerStat = (e)=>{
        let trackid = e.target.dataset.trackid;
        let layerid = e.target.dataset.layerid;
        let stat = e.target.value;
        this.props.sendMessage({
            operation: 'set layer stat',
            trackid: trackid,
            layerid: layerid,
            stat: stat
        });
    };
    setLayerEffect = (e)=>{
        let trackid = e.target.dataset.trackid;
        let layerid = e.target.dataset.layerid;
        let effect = e.target.value;
        this.props.sendMessage({
            operation: 'set layer effect',
            trackid: trackid,
            layerid: layerid,
            effect: effect
        });
    };
    setTargetStat = (e)=>{
        let trackid = e.target.dataset.trackid;
        let stat = e.target.value;
        this.props.sendMessage({
            operation: 'set target stat',
            trackid: trackid,
            stat: stat
        });
    };
    setTargetEffect = (e)=>{
        let trackid = e.target.dataset.trackid;
        let effect = e.target.value;
        this.props.sendMessage({
            operation: 'set target effect',
            trackid: trackid,
            effect: effect
        });
    };
    thresholdCell = (p)=>{
        let track = p.track;
        let index = p.index;
        let layer = '';
        let stat = '';
        if (index <= track.layers.length) {
            layer = track.layers[index];
            stat = layer.stat;
        }
        if (!track) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {});
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                value: stat,
                "data-trackid": track._id,
                "data-layerid": layer._id,
                onChange: this.setLayerStat,
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                        value: "",
                        children: "none"
                    }),
                    this.props.doc.thresholds.map((thresh)=>{
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                            value: thresh._id,
                            children: thresh.name
                        }, thresh._id);
                    })
                ]
            })
        });
    };
    render() {
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "panel",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h4", {
                    children: "Damage Tracks"
                }),
                this.props.doc.tracks?.map((track, index)=>{
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h5", {
                                children: [
                                    track.name || 'unnamed track',
                                    "\xa0",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: this.attemptRenameTrack,
                                        "data-trackid": track._id,
                                        children: "rename track"
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        className: "delete",
                                        "data-trackid": track._id,
                                        "data-trackname": track.name,
                                        onClick: this.attemptRemoveTrack,
                                        children: "x"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                                    children: "Layer"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                                    children: "Stat"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                                    children: "Effect"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
                                                    children: "Delete"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                                        children: [
                                            track.layers.map((layer, index)=>{
                                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                            children: index + 1
                                                        }),
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(this.thresholdCell, {
                                                            track: track,
                                                            index: index
                                                        }),
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                                type: "text",
                                                                placeholder: index + 1 + " damage",
                                                                defaultValue: layer.effect || '',
                                                                "data-trackid": track._id,
                                                                "data-layerid": layer._id,
                                                                onBlur: this.setLayerEffect
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                                className: "delete",
                                                                "data-trackid": track._id,
                                                                "data-layerid": layer._id,
                                                                onClick: this.removeLayer,
                                                                children: "x"
                                                            })
                                                        })
                                                    ]
                                                }, index);
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: "Target Pool"
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                                                            value: track.targetStat,
                                                            "data-trackid": track._id,
                                                            onChange: this.setTargetStat,
                                                            children: [
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                                    value: "",
                                                                    children: "none"
                                                                }),
                                                                this.props.doc.pools.map((pool)=>{
                                                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                                        value: pool._id,
                                                                        children: pool.name
                                                                    }, pool._id);
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                            type: "text",
                                                            defaultValue: track.targetEffect,
                                                            "data-trackid": track._id,
                                                            onBlur: this.setTargetEffect,
                                                            placeholder: "Damage"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                    colSpan: 99,
                                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                        onClick: this.addNewLayer,
                                                        "data-trackid": track._id,
                                                        children: "Add New Layer"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, index);
                }),
                this.props.doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    onClick: this.addNewTrack,
                    children: "Add New Damage Track"
                })
            ]
        });
    }
}


class $3324d8f10be24af7$var$StatsTab extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            skillSortProp: 'Skill'
        };
    }
    addStat = (statGroup, singular)=>{
        let name = prompt('add ' + singular);
        if (!name) return;
        this.props.sendMessage({
            operation: 'add stat',
            statGroup: statGroup,
            statName: name
        });
    };
    removeStat = (statGroup, statName)=>{
        const confirm = window.confirm('Are you sure you want to delete ' + statName + ' from ' + statGroup + '?');
        if (confirm) this.props.sendMessage({
            operation: 'remove stat',
            statGroup: statGroup,
            statName: statName
        });
    };
    renameStat = (statGroup, statName)=>{
        let newName = prompt('rename ' + statName + ' to... ');
        //console.log(statName + '->' + newName);
        if (!newName) return;
        this.props.sendMessage({
            operation: 'rename stat',
            statGroup: statGroup,
            statName: statName,
            newName: newName
        });
    };
    changeSkillGroup = (e)=>{
        const statName = e.target.dataset.skillname;
        // console.log(statName);
        const skillGroup = e.target.value;
        this.props.sendMessage({
            operation: 'set skill group',
            statGroup: 'skills',
            statName: statName,
            skillGroup: skillGroup
        });
    };
    changeSkillStat = (e)=>{
        const statName = e.target.dataset.skillname;
        // console.log(statName);
        const skillStat = e.target.value;
        this.props.sendMessage({
            operation: 'set skill stat',
            statGroup: 'skills',
            statName: statName,
            skillStat: skillStat
        });
    };
    changeLimitMult = (e)=>{
        const statName = e.target.dataset.skillname;
        // console.log(statName);
        const mult = e.target.value;
        this.props.sendMessage({
            operation: 'set limit mult',
            statGroup: 'limitations',
            statName: statName,
            mult: mult
        });
    };
    changeTacOffset = (e)=>{
        const statName = e.target.dataset.skillname;
        const offset = e.target.value;
        const statGroup = e.target.dataset.statgroup;
        console.log(offset);
        this.props.sendMessage({
            operation: 'set tac offset',
            statGroup: statGroup,
            statName: statName,
            offset: offset
        });
    };
    changeFormula = (e)=>{
        const value = e.target.value;
        const index = e.target.dataset.index;
        const field = e.target.dataset.field;
        const statName = e.target.dataset.statname;
        const statGroup = e.target.dataset.statgroup;
        this.props.sendMessage({
            operation: 'modify formula',
            statName: statName,
            statGroup: statGroup,
            opindex: index,
            opfield: field,
            opvalue: value
        });
    };
    sortSkills = (e)=>{
        const prop = e.target.dataset.prop;
        // console.log(prop);
        this.setState({
            skillSortProp: prop
        });
    };
    changeStatValueType = (e)=>{
        const statGroup = e.target.dataset.statgroup;
        const statId = e.target.dataset.statid;
        const statName = e.target.dataset.statname;
        const valueType = e.target.value;
        this.props.sendMessage({
            operation: 'change stat value type',
            statGroup: statGroup,
            statId: statId,
            valueType: valueType,
            statName: statName
        });
    };
    changeLimitInactiveBool = (e)=>{
        const limitId = e.target.dataset.limit;
        const checked = e.target.checked;
        console.log(limitId, checked);
        this.props.sendMessage({
            operation: 'change limit inactive',
            limitId: limitId,
            checked: checked
        });
    };
    render() {
        let doc = this.props.doc;
        document.title = [
            'Stats',
            doc.name,
            'SGS'
        ].join(' - ');
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1c256cd0c9445956$export$2e2bcd8739ae039), {
                    doc: doc,
                    addStat: this.addStat,
                    removeStat: this.removeStat,
                    renameStat: this.renameStat,
                    changeTacOffset: this.changeTacOffset,
                    changeStatValueType: this.changeStatValueType,
                    changeFormula: this.changeFormula,
                    sendMessage: this.props.sendMessage
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dcabd5cecd5fcc69$export$2e2bcd8739ae039), {
                    doc: doc,
                    addStat: this.addStat,
                    removeStat: this.removeStat,
                    renameStat: this.renameStat,
                    changeFormula: this.changeFormula,
                    changeTacOffset: this.changeTacOffset,
                    changeStatValueType: this.changeStatValueType,
                    sendMessage: this.props.sendMessage
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $59df28a06cae148b$export$2e2bcd8739ae039), {
                    doc: doc,
                    addStat: this.addStat,
                    removeStat: this.removeStat,
                    renameStat: this.renameStat,
                    changeType: this.changeType,
                    changeValue: this.changeValue,
                    changeTacOffset: this.changeTacOffset,
                    changeStatValueType: this.changeStatValueType,
                    changeFormula: this.changeFormula,
                    sendMessage: this.props.sendMessage
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fca249825a05ea51$export$2e2bcd8739ae039), {
                    doc: doc,
                    sendMessage: this.props.sendMessage
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fc8347976e472264$export$2e2bcd8739ae039), {
                    doc: doc,
                    addStat: this.addStat,
                    removeStat: this.removeStat,
                    renameStat: this.renameStat,
                    changeFormula: this.changeFormula,
                    changeType: this.changeType,
                    changeValue: this.changeValue,
                    changeTacOffset: this.changeTacOffset,
                    changeStatValueType: this.changeStatValueType,
                    sendMessage: this.props.sendMessage
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1877f7dcad7a93fa$export$2e2bcd8739ae039), {
                    doc: doc,
                    addStat: this.addStat,
                    removeStat: this.removeStat,
                    renameStat: this.renameStat,
                    changeSkillGroup: this.changeSkillGroup,
                    changeSkillStat: this.changeSkillStat,
                    skillSortProp: this.state.skillSortProp,
                    sortSkills: this.sortSkills,
                    changeTacOffset: this.changeTacOffset,
                    changeStatValueType: this.changeStatValueType,
                    changeFormula: this.changeFormula,
                    sendMessage: this.props.sendMessage
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d5119b7b8a5d679e$export$2e2bcd8739ae039), {
                    doc: doc,
                    addStat: this.addStat,
                    removeStat: this.removeStat,
                    renameStat: this.renameStat,
                    changeLimitMult: this.changeLimitMult,
                    changeLimitInactiveBool: this.changeLimitInactiveBool,
                    sendMessage: this.props.sendMessage
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $3324d8f10be24af7$export$2e2bcd8739ae039 = $3324d8f10be24af7$var$StatsTab;




var $bh6RR = parcelRequire("bh6RR");

class $39582558cec9d7af$var$RulesTab extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {};
    }
    render() {
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
        });
    }
}
var $39582558cec9d7af$export$2e2bcd8739ae039 = $39582558cec9d7af$var$RulesTab;




var $bh6RR = parcelRequire("bh6RR");






function $a6c7fc3d79e3fff4$export$2e2bcd8739ae039(props) {
    let doc = props.doc;
    let entities = props.entities;
    // let skillCount = props.skillCount;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ul", {
        className: "entity-list mobile",
        children: entities?.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)('name', false, true)).map((entity)=>{
            let path = '/doc/' + doc._id + '/Entity/' + entity._id;
            let a = entity.aspects?.length;
            let as = entity.aspects?.length > 1 ? 's' : '';
            let f = entity.flaws?.length;
            let fs = entity.flaws?.length > 1 ? 's' : '';
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                        to: path,
                        className: "button",
                        children: [
                            "\u25B6 ",
                            entity.name,
                            " (",
                            entity.xp.toLocaleString(),
                            " xp)"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                        children: [
                            entity.tags?.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                children: [
                                    "Tags: ",
                                    entity.tags.map((tag)=>'#' + tag).join(', ')
                                ]
                            }),
                            (!!a || !!f) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                children: [
                                    !!a && a + ' aspect',
                                    as,
                                    !!a && !!f && ', ',
                                    !!f && f + ' flaw',
                                    fs
                                ]
                            }),
                            (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).groups.map((groupName)=>{
                                let group = entity[groupName];
                                if (!group) return '';
                                if (group.length < 1) return '';
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                    children: [
                                        group.length,
                                        " ",
                                        (0, $920954e343704e08$exports.capitalize)(groupName)
                                    ]
                                }, groupName);
                            }),
                            entity.items?.length > 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                children: [
                                    entity.items.length,
                                    " Items"
                                ]
                            })
                        ]
                    })
                ]
            }, entity._id);
        })
    });
}





var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

const $3eed897e0422e1dc$var$addStat = (sendMessage, entityid, statname, statgroup, valueType)=>{
    sendMessage({
        operation: 'add entity stat',
        entityid: entityid,
        statgroup: statgroup,
        statname: statname,
        valueType: valueType
    });
};
const $3eed897e0422e1dc$var$removeStat = (sendMessage, entityid, statname, statgroup)=>{
    sendMessage({
        operation: 'remove entity stat',
        entityid: entityid,
        statgroup: statgroup,
        statname: statname
    });
};
const $3eed897e0422e1dc$var$DeleteButton = (props)=>{
    if (props.static === true) return '';
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
        className: "side bottom delete",
        onClick: (event)=>$3eed897e0422e1dc$var$removeStat(props.sendMessage, props.entityid, props.statname, props.statgroup),
        children: "x"
    });
};
const $3eed897e0422e1dc$var$changeDicePool = (e, poolText, setPoolText)=>{
    // console.log('changeDicePool event')
    // console.log(e.target);
    let value = e.target.value;
    // console.log(value);
    let regex = /[^\ddDfF+\- ]/gmi;
    if (!!value) value = value?.replaceAll(regex, '');
    setPoolText(value);
};
const $3eed897e0422e1dc$var$changeStatNumber = (e, poolText, setStatNumber, changeStat)=>{
    // console.log('changeStatNumber');
    // console.log(e.target);
    let value = e.target.value;
    // console.log(value);
    setStatNumber(value);
    changeStat(e);
};
const $3eed897e0422e1dc$var$wasChanged = (e, changeStat)=>{
    let n = e.target.value;
    let o = e.target.dataset.original;
    // console.log(o, '->', n);
    if (n !== o) changeStat(e);
};
const $3eed897e0422e1dc$var$handleKeyPress = (e, dicePool, changeStat)=>{
    let key = e.key;
    // console.log(key);
    if (key === 'Enter') {
        $3eed897e0422e1dc$var$wasChanged(e, changeStat);
        e.target.blur();
    }
    if (key === 'Escape') e.target.blur();
};
const $3eed897e0422e1dc$var$focused = (e)=>{
// console.log('focused');
// let target = e.target;
// target.type = 'text';
// target.setSelectionRange(0,100);
// target.type = 'number';
};
function $3eed897e0422e1dc$export$2e2bcd8739ae039(props) {
    let statname = props.prototype.name;
    let type = props.prototype.valueType;
    let dicePool = props.stat?.dicePool || '';
    const [poolText, setPoolText] = (0, $bh6RR.useState)(dicePool);
    const [statNumber, setStatNumber] = (0, $bh6RR.useState)(props.stat?.number || 0);
    (0, $bh6RR.useEffect)(()=>{
        if (!props.stat) return;
        let element = document.getElementById(props.stat._id);
        if (!element) return;
        // console.log(element);
        // let active = document.activeElement;
        // console.log(active);
        // if(element === active) return console.log(statname, 'element is active');
        // console.log(statname, type, props.stat)
        if (type === 'number') element.value = parseInt(props.stat.number);
        else if (type === 'dieSize') element.value = props.stat.dieSize;
        else if (type === 'dicePool') element.value = props.stat.dicePool;
        else if (type === 'formula') element.value = props.stat.calculated?.toString();
    });
    if (!props.entity.editable) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
        children: [
            props.stat && type === 'number' && props.stat.number,
            props.stat && type === 'dieSize' && props.stat.dieSize,
            props.stat && type === 'dicePool' && props.stat.dicePool,
            props.stat && type === 'formula' && props.stat.calculated?.toString()
        ]
    });
    // console.log(type);
    // return(<td>no</td>);
    if (!props.stat) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
        className: "edit-stat-box",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
            onClick: (event)=>$3eed897e0422e1dc$var$addStat(props.sendMessage, props.entity._id, statname, props.statgroup, type),
            className: "whole",
            children: "+"
        })
    });
    if (type === 'number') return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
        className: "edit-stat-box",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                id: props.stat._id,
                type: "number",
                step: "1",
                // style={{width: width}}
                // value={parseInt(props.stat.number)}
                // defaultValue={parseInt(props.stat.number)}
                value: statNumber,
                "data-entityid": props.entity._id,
                "data-statgroup": props.statgroup,
                "data-statid": props.stat._id,
                "data-valuetype": type,
                "data-original": parseInt(props.stat.number),
                onBlur: (e)=>$3eed897e0422e1dc$var$wasChanged(e, props.changeStat),
                onKeyDown: (e)=>$3eed897e0422e1dc$var$handleKeyPress(e, statNumber, props.changeStat),
                onChange: (event)=>$3eed897e0422e1dc$var$changeStatNumber(event, statNumber, setStatNumber, props.changeStat),
                onFocus: $3eed897e0422e1dc$var$focused
            }, props.stat._id),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($3eed897e0422e1dc$var$DeleteButton, {
                sendMessage: props.sendMessage,
                entityid: props.entity._id,
                statname: statname,
                statgroup: props.statgroup,
                static: props.static
            })
        ]
    });
    if (type === 'dieSize') return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
        className: "edit-stat-box",
        style: {
            minWidth: '8ch'
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                id: props.stat._id,
                value: props.stat.dieSize,
                onChange: props.changeStat,
                "data-entityid": props.entity._id,
                "data-statgroup": props.statgroup,
                "data-statid": props.stat._id,
                "data-valuetype": type,
                "data-original": props.stat.dieSize,
                onKeyDown: (e)=>$3eed897e0422e1dc$var$handleKeyPress(e, dicePool, props.changeStat),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                        children: "none"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                        children: "d4"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                        children: "d6"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                        children: "d8"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                        children: "d10"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                        children: "d12"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                        children: "d20"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                        children: "d100"
                    })
                ]
            }, props.stat._id),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($3eed897e0422e1dc$var$DeleteButton, {
                sendMessage: props.sendMessage,
                entityid: props.entity._id,
                statname: statname,
                statgroup: props.statgroup,
                static: props.static
            })
        ]
    });
    if (type === 'dicePool') return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
        className: "edit-stat-box",
        style: {
            minWidth: props.stat.dicePool.toString().length + 1 + 'ch'
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                id: props.stat._id,
                type: "text",
                // pattern={pattern}
                // title='xdy+z'
                placeholder: "XdY+Z",
                value: poolText,
                "data-entityid": props.entity._id,
                "data-statgroup": props.statgroup,
                "data-statid": props.stat._id,
                "data-valuetype": type,
                "data-original": props.stat.dicePool.toString(),
                onBlur: (e)=>$3eed897e0422e1dc$var$wasChanged(e, props.changeStat),
                onKeyDown: (e)=>$3eed897e0422e1dc$var$handleKeyPress(e, dicePool, props.changeStat),
                onChange: (event)=>$3eed897e0422e1dc$var$changeDicePool(event, poolText, setPoolText)
            }, props.stat._id),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($3eed897e0422e1dc$var$DeleteButton, {
                sendMessage: props.sendMessage,
                entityid: props.entity._id,
                statname: statname,
                statgroup: props.statgroup,
                static: props.static
            })
        ]
    });
    if (type === 'formula' && props.static) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
        className: "edit-stat-box",
        style: {
            minWidth: props.stat.calculated?.toString().length + 1 + 'ch'
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
            title: props.stat.formulaText,
            children: props.stat.calculated?.toString()
        })
    });
    if (type === 'formula' && !props.static) {
        let errorClass = !!props.stat.error ? ' error' : '';
        // console.log(props.stat)
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
            className: 'edit-stat-box' + errorClass,
            style: {
                minWidth: props.stat.calculated?.toString().length + 1 + 'ch'
            },
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                    id: props.stat._id,
                    // type='number'
                    // style={{width: width}}
                    value: props.stat.calculated?.toString(),
                    "data-entityid": props.entity._id,
                    "data-statgroup": props.statgroup,
                    "data-statid": props.stat._id,
                    "data-valuetype": props.stat.valueType,
                    "data-original": props.stat.calculated?.toString(),
                    // onChange={props.changeStat}
                    title: props.stat.error || props.stat.formulaText,
                    readOnly: true
                }, props.stat._id),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($3eed897e0422e1dc$var$DeleteButton, {
                    sendMessage: props.sendMessage,
                    entityid: props.entity._id,
                    statname: statname,
                    statgroup: props.statgroup,
                    static: props.static
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
        children: "none"
    });
}




var $bh6RR = parcelRequire("bh6RR");

class $230c908a78eed90f$var$NameField extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            value: this.props.entity.name
        };
    }
    handleKeyPress = (e)=>{
        // console.log(e.key);
        if (e.key === 'Enter') {
            e.preventDefault();
            // console.log('submit');
            this.props.changeName(this.props.id, this.state.value);
        } else this.setState({
            value: e.target.value
        });
    };
    handleChange = (e)=>{
        this.setState({
            value: e.target.value
        });
    };
    handleBlur = (e)=>{
        // console.log(this.state.value, this.props.entity.name);
        if (this.state.value !== this.props.entity.name) this.props.changeName(this.props.entity._id, this.state.value);
    };
    renderStatic() {
        let xs = this.props.entity.externalSource;
        let title = !!xs ? 'source ' + xs.type + ' doc: ' + xs.name : null;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            title: title,
            children: [
                title && "\uD83D\uDD3C",
                this.props.entity.name
            ]
        });
    }
    renderEditable() {
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
            defaultValue: this.state.value,
            "data-entityid": this.props.id,
            title: this.props.id,
            onKeyPress: this.handleKeyPress,
            onChange: (e)=>this.handleChange(e),
            onBlur: this.handleBlur,
            // wrap='soft'
            style: {
                flexBasis: this.state.value.length * .8 + 5 + 'ch'
            },
            size: this.state.value.length * .8
        });
    }
    render() {
        let entity = this.props.entity;
        if (entity.editable) return this.renderEditable();
        return this.renderStatic();
    }
}
var $230c908a78eed90f$export$2e2bcd8739ae039 = $230c908a78eed90f$var$NameField;




var $bh6RR = parcelRequire("bh6RR");


class $91ee78d31df4b15a$var$TagList extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            tagpicker: false,
            doctags: [],
            newTag: ''
        };
    }
    addNewTag = (e)=>{
        e.preventDefault();
        let id = this.props.entity._id;
        // console.log(e.target);
        let tag = this.state.newTag;
        this.props.addTag(id, tag);
        this.setState({
            newTag: ''
        });
    };
    changeNewTag = (e)=>{
        this.setState({
            newTag: e.target.value.toLowerCase()
        });
    };
    addTag = (tag)=>{
        let id = this.props.entity._id;
        // let tag = e.target.dataset.tag;
        this.props.addTag(id, tag);
    // this.setState({ tagpicker: false })
    };
    removeTag = (tag)=>{
        let id = this.props.entity._id;
        // let tag = e.target.dataset.tag;
        this.props.removeTag(id, tag);
    };
    toggleTag = (e)=>{
        let checked = e.target.checked;
        let tag = e.target.name;
        if (checked) this.addTag(tag);
        else this.removeTag(tag);
    };
    openModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: true
        });
    };
    closeModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: false
        });
    };
    renderStatic() {
        let entity = this.props.entity;
        let etags = entity?.tags;
        let taglist = etags?.map((tag)=>'#' + tag).join(', ');
        let contents = taglist || '-';
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            className: "listCell",
            children: contents
        });
    }
    renderEditable() {
        let entity = this.props.entity;
        let doc = this.props.doc;
        let dtags = doc.entityTags;
        let etags = entity?.tags;
        let taglist = etags?.map((tag)=>'#' + tag).join(', ');
        let contents = taglist || '+';
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
            className: "listCell",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    className: "tagList",
                    onClick: this.openModal,
                    "data-target": "tagModal",
                    children: contents
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $09f16485618a5dc7$export$2e2bcd8739ae039), {
                    state: this.state,
                    title: "Select Tags",
                    target: "tagModal",
                    closeModal: this.closeModal,
                    closeButtonText: "close",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("table", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                            children: [
                                dtags.map((dt)=>{
                                    let eHasTag = entity.tags?.includes(dt);
                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                                    htmlFor: dt,
                                                    className: eHasTag ? 'checked' : '',
                                                    children: dt
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    name: dt,
                                                    id: dt,
                                                    checked: eHasTag ? true : false,
                                                    onChange: this.toggleTag
                                                })
                                            })
                                        ]
                                    }, dt);
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("form", {
                                                onSubmit: this.addNewTag,
                                                id: "newTagForm",
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                                    children: [
                                                        "Add a Tag:\xa0",
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                            placeholder: "new tag",
                                                            value: this.state.newTag,
                                                            onChange: this.changeNewTag
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                form: "newTagForm",
                                                type: "submit"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        });
    }
    render() {
        let entity = this.props.entity;
        if (entity.editable) return this.renderEditable();
        return this.renderStatic();
    }
}
var $91ee78d31df4b15a$export$2e2bcd8739ae039 = $91ee78d31df4b15a$var$TagList;




var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");



class $524f98070c7f627f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        let checkedTag = window.localStorage.getItem('checkedTag');
        let filterName = window.localStorage.getItem('filterName');
        let sortKey = window.localStorage.getItem('sortKey');
        let sortDir = window.localStorage.getItem('sortDir') === 'true';
        if (!sortKey) sortKey = 'name';
        if (!sortDir) sortDir = false;
        this.state = {
            checkedTag: checkedTag,
            filterName: filterName,
            sortKey: sortKey,
            sortDir: sortDir
        };
    }
    changedSortTag = (e)=>{
        // window.sessionStorage.setItem('itemListTagFilter', e.target.value);
        let v = e.target.value;
        this.setState({
            checkedTag: v
        });
        window.localStorage.setItem('checkedTag', v);
    };
    changedFilterName = (e)=>{
        let v = e.target.value;
        this.setState({
            filterName: v
        });
        window.localStorage.setItem('filterName', v);
    };
    clearFilter = ()=>{
        this.setState({
            filterName: ''
        });
        window.localStorage.setItem('filterName', '');
        document.getElementById('item-selector-filter-name-box').value = '';
    };
    changedSortKey = (e)=>{
        let v = e.target.value;
        this.setState({
            sortKey: v
        });
        window.localStorage.setItem('sortKey', v);
    };
    changedSortDir = (e)=>{
        let v = e.target.value;
        if (v === 'true') v = true;
        else v = false;
        this.setState({
            sortDir: v
        });
        window.localStorage.setItem('sortDir', v);
    };
    addItem = (e)=>{
        let entityid = e.target.dataset.entityid;
        let itemid = e.target.dataset.itemid;
        this.props.sendMessage({
            operation: 'add entity item',
            entityid: entityid,
            itemid: itemid
        });
    };
    removeItem = (e)=>{
        let entityid = e.target.dataset.entityid;
        let itemid = e.target.dataset.itemid;
        this.props.sendMessage({
            operation: 'remove entity item',
            entityid: entityid,
            itemid: itemid
        });
    };
    render() {
        let parentState = this.props.parentState;
        let closeModal = this.props.closeModal;
        let doc = this.props.doc;
        let entity = this.props.entity;
        // let addItem = this.props.addItem;
        // let sendMessage = this.props.sendMessage;
        // let removeItem = this.props.removeItem;
        let available = doc.entities.filter((x)=>!entity.equipment.includes(x._id));
        if (!!this.state.checkedTag) available = available.filter((x)=>x.tags.includes(this.state.checkedTag));
        if (!!this.state.filterName) available = available.filter((x)=>x.name.toLowerCase().includes(this.state.filterName.toLowerCase()));
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09f16485618a5dc7$export$2e2bcd8739ae039), {
            state: parentState,
            title: "Select Items",
            target: "itemModal",
            closeModal: closeModal,
            closeButtonText: "close",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h4", {
                    children: "Filter by Tag"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                            type: "radio",
                            name: "itemListTagFilter",
                            checked: '' === this.state.checkedTag,
                            value: "",
                            onChange: this.changedSortTag
                        }),
                        "\xa0 none"
                    ]
                }),
                doc.entityTags.map((x)=>{
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                type: "radio",
                                name: "itemListTagFilter",
                                value: x,
                                checked: x === this.state.checkedTag,
                                onChange: this.changedSortTag
                            }),
                            "\xa0",
                            x
                        ]
                    }, x);
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h4", {
                    children: "Filter by Name"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                    children: [
                        "Filter:",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                            type: "text",
                            placeholder: "sword, armor, etc",
                            onChange: this.changedFilterName,
                            defaultValue: this.state.filterName,
                            id: "item-selector-filter-name-box"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            className: "delete",
                            onClick: this.clearFilter,
                            disabled: !this.state.filterName,
                            children: "x"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h4", {
                    children: "Sorting"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "inline",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                    type: "radio",
                                    name: "sortKey",
                                    value: "name",
                                    checked: this.state.sortKey === 'name',
                                    onChange: this.changedSortKey
                                }),
                                "\xa0 Name"
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                    type: "radio",
                                    name: "sortKey",
                                    value: "xp",
                                    checked: this.state.sortKey === 'xp',
                                    onChange: this.changedSortKey
                                }),
                                "\xa0 XP"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "inline",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                    type: "radio",
                                    name: "sortDir",
                                    value: false,
                                    checked: !this.state.sortDir,
                                    onChange: this.changedSortDir
                                }),
                                "\xa0 Ascending"
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                    type: "radio",
                                    name: "sortDir",
                                    value: true,
                                    checked: this.state.sortDir,
                                    onChange: this.changedSortDir
                                }),
                                "\xa0 Descending"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h4", {
                    children: "Add Items"
                }),
                available.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)(this.state.sortKey, this.state.sortDir, true)).map((x)=>{
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                        onClick: this.addItem,
                        "data-entityid": entity._id,
                        "data-itemid": x._id,
                        className: "inlineList",
                        children: [
                            "\u2795 ",
                            x.name,
                            " (",
                            x.xp,
                            "xp)"
                        ]
                    }, x._id);
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h4", {
                    children: "Remove Items"
                }),
                entity.items?.map((x)=>{
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                        onClick: this.removeItem,
                        "data-entityid": entity._id,
                        "data-itemid": x._id,
                        className: "delete inlineList",
                        children: [
                            "\u274C ",
                            x.name,
                            " (",
                            x.xp,
                            "xp)"
                        ]
                    }, x._id);
                })
            ]
        });
    }
}


class $6bbfe4d95fa87243$var$ItemList extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            itempicker: false,
            doctags: []
        };
    }
    closeItemPicker = ()=>{
        this.setState({
            itempicker: false
        });
    };
    openModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: true
        });
    };
    closeModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: false
        });
    };
    renderStatic() {
        let entity = this.props.entity;
        let items = entity?.items;
        let itemList = items.map((x)=>x.name).join(', ') || '+';
        let max = itemList.length / 3;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            className: "listCell",
            style: {
                minWidth: max + 'ch'
            },
            children: itemList
        });
    }
    renderEditable() {
        let entity = this.props.entity;
        let doc = this.props.doc;
        let items = entity?.items;
        let itemList = items.map((x)=>x.name).join(', ') || '+';
        let max = itemList.length / 3;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
            className: "listCell",
            style: {
                minWidth: max + 'ch'
            },
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    onClick: this.openModal,
                    "data-target": "itemModal",
                    className: "tagList",
                    children: itemList
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $524f98070c7f627f$export$2e2bcd8739ae039), {
                    parentState: this.state,
                    sendMessage: this.props.sendMessage,
                    closeModal: this.closeModal,
                    doc: doc,
                    entity: entity
                })
            ]
        });
    }
    render() {
        let entity = this.props.entity;
        if (entity.editable) return this.renderEditable();
        return this.renderStatic();
    }
}
var $6bbfe4d95fa87243$export$2e2bcd8739ae039 = $6bbfe4d95fa87243$var$ItemList;




var $bh6RR = parcelRequire("bh6RR");



class $f2d3eea0c6204b22$var$LimitList extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            limitpicker: false,
            doctags: [],
            note: ''
        };
    }
    openLimitPicker = ()=>{
        let dt = [];
        let rt = this.props.entity.tags || [];
        this.props.doc.entities.forEach((entity)=>{
            entity.tags?.forEach((tag)=>{
                if (!dt.includes(tag) && !rt.includes(tag)) dt.push(tag);
            });
        });
        dt.sort();
        this.setState({
            limitpicker: true,
            doctags: dt
        });
    };
    closeItemPicker = ()=>{
        this.setState({
            limitpicker: false
        });
    };
    addLimit = (entityId, name, multiplier, limitId)=>{
        // let entityId = this.props.entity._id;
        // let name = e.target.dataset.name;
        // let multiplier = e.target.dataset.multiplier;
        // let note = this.state.note;
        this.props.addLimit(entityId, name, multiplier, limitId);
    // this.setState({ limitpicker: false })
    };
    removeLimit = (entityId, name, limitId)=>{
        // let entityId = this.props.entity._id;
        // let name = e.target.dataset.name;
        this.props.removeLimit(entityId, name, limitId);
    };
    onNoteChange = (e)=>{
        this.setState({
            note: e.target.value
        });
    };
    toggleLimit = (e)=>{
        let checked = e.target.checked;
        let entityId = this.props.entity._id;
        let name = e.target.dataset.name;
        let multiplier = e.target.dataset.multiplier;
        let limitId = e.target.dataset.limitid;
        // let note = this.state.note;
        // console.log(limitId)
        if (checked) this.addLimit(entityId, name, multiplier, limitId);
        else this.removeLimit(entityId, name, limitId);
    };
    openModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: true
        });
    };
    closeModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: false
        });
    };
    renderStatic() {
        let entity = this.props.entity;
        let limits = entity?.limitations;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
            className: "listCell",
            children: [
                limits?.map((limit)=>{
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        "data-target": "limitModal",
                        onClick: this.openModal,
                        children: [
                            limit.name,
                            "\xa0\xd7",
                            limit.multiplier,
                            !!limit.note && ' ' + limit.note
                        ]
                    }, limit.name);
                }),
                (!limits || limits.length === 0) && '-'
            ]
        });
    }
    renderEditable() {
        let entity = this.props.entity;
        let limits = entity?.limitations;
        let doc = this.props.doc;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
            className: "listCell",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                    className: "tagList",
                    onClick: this.openModal,
                    "data-target": "limitModal",
                    children: [
                        limits?.map((limit)=>{
                            return limit.name + " (\xd7" + limit.multiplier + ')' + (!!limit.note ? ' ' + limit.note : '') + (!!limit.legacy ? "\u26A0\uFE0F" : '');
                        }).join(', '),
                        (!limits || limits.length === 0) && '+'
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $09f16485618a5dc7$export$2e2bcd8739ae039), {
                    state: this.state,
                    title: "Select Limtations",
                    target: "limitModal",
                    closeModal: this.closeModal,
                    closeButtonText: "close",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: "Limit"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: "Multiplier"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: "Enabled"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
                                children: doc.limitations.map((limit)=>{
                                    let entityLimit = entity.limitations?.find((x)=>x.name === limit.name);
                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                className: "button-takes-whole-cell",
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                                    htmlFor: limit.name,
                                                    className: !!entityLimit ? 'checked' : '',
                                                    children: limit.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: limit.multiplier
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    id: limit.name,
                                                    type: "checkbox",
                                                    checked: !!entityLimit,
                                                    onChange: this.toggleLimit,
                                                    "data-name": limit.name,
                                                    "data-multiplier": limit.multiplier,
                                                    "data-limitid": limit._id
                                                })
                                            })
                                        ]
                                    }, limit.name);
                                })
                            })
                        ]
                    })
                })
            ]
        });
    }
    render() {
        let entity = this.props.entity;
        if (entity.editable) return this.renderEditable();
        return this.renderStatic();
    }
}
var $f2d3eea0c6204b22$export$2e2bcd8739ae039 = $f2d3eea0c6204b22$var$LimitList;




var $bh6RR = parcelRequire("bh6RR");


class $092814106b66cfa7$var$AspectList extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            tagpicker: false,
            aspects: []
        };
    }
    openModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: true,
            aspects: this.props.aspects
        });
    };
    closeModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: false
        });
        this.checkUpdate();
    };
    checkUpdate = ()=>{
        let inputs = document.querySelectorAll(".pane ol li input.aspect");
        console.log(inputs);
        inputs = Array.from(inputs);
        let aspects = inputs.map((x)=>x.value);
        console.log(this.props.aspects, aspects);
        if (this.props.aspects !== aspects) this.props.setAspects(this.props.entity._id, aspects);
    };
    addAspect = ()=>{
        this.setState({
            aspects: [
                ...this.state.aspects,
                ''
            ]
        });
    };
    removeAspect = (e)=>{
        let target = e.target.dataset.aspect;
        let arr = this.state.aspects.filter((x)=>x !== target);
        this.setState({
            aspects: arr
        });
    };
    renderStatic() {
        let aspectList = this.props.aspects?.join(', ');
        let contents = aspectList || '-';
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            className: "listCell",
            children: contents
        });
    }
    renderEditable() {
        // let entity = this.props.entity;
        // let doc = this.props.doc;
        let type = this.props.aspectType.slice(0, -1);
        let aspects = this.state.aspects;
        let aspectList = this.props.aspects?.join(', ');
        let contents = aspectList || '+';
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
            className: "listCell",
            style: {
                minWidth: aspectList.length / 4 + 'ch'
            },
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    className: "tagList",
                    onClick: this.openModal,
                    "data-target": "tagModal",
                    children: contents
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09f16485618a5dc7$export$2e2bcd8739ae039), {
                    state: this.state,
                    title: 'Assign ' + type + 's',
                    target: "tagModal",
                    closeModal: this.closeModal,
                    closeButtonText: "close",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ol", {
                            children: aspects?.map((aspect, index)=>{
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                            defaultValue: aspect,
                                            placeholder: type,
                                            // onChange={this.handleChange}
                                            className: "aspect"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                            className: "delete",
                                            "data-aspect": aspect,
                                            onClick: this.removeAspect,
                                            children: "x"
                                        })
                                    ]
                                }, aspect);
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                            onClick: this.addAspect,
                            children: [
                                "\u2795Add ",
                                type
                            ]
                        })
                    ]
                })
            ]
        });
    }
    render() {
        let entity = this.props.entity;
        if (entity.editable) return this.renderEditable();
        return this.renderStatic();
    }
}
var $092814106b66cfa7$export$2e2bcd8739ae039 = $092814106b66cfa7$var$AspectList;



function $de911c4aad4e62e0$export$2e2bcd8739ae039(entity, sendMessage) {
    let url = window.prompt('Enter a new image URL for ' + entity.name);
    console.log(url);
    if (url !== null && url !== undefined) sendMessage({
        operation: 'change entity image url',
        entityid: entity._id,
        url: url
    });
}


function $29c8113ae79ce063$export$2e2bcd8739ae039(props) {
    let entity = props.entity;
    let editable = entity.editable;
    let sendMessage = props.sendMessage;
    let url = entity.imageurl;
    // url = 'https://imgur.com/WpMjj3S.png';
    const imgurPattern = /^https:\/\/imgur.com\/\w+$/gm;
    if (url && url.match(imgurPattern)) url += '.png';
    if (!editable && !url) return '';
    if (!editable) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
        src: url,
        alt: "entity portrait",
        className: "portrait icon"
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
        onClick: ()=>(0, $de911c4aad4e62e0$export$2e2bcd8739ae039)(entity, sendMessage),
        className: "icon",
        children: [
            url && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                src: url,
                alt: "entity portrait",
                className: "portrait icon"
            }),
            !url && "\uD83D\uDCF8"
        ]
    });
}


function $e3358109f073a34c$export$2e2bcd8739ae039(props) {
    let doc = props.doc;
    let entities = props.entities;
    let skillCount = props.skillCount;
    let sortEntities = props.sortEntities;
    let changeColumnSort = props.changeColumnSort;
    let skillGroups = props.skillGroups;
    let openModal = props.openModal;
    let addNewEntity = props.addNewEntity;
    let changeName = props.changeName;
    let removeTag = props.removeTag;
    let addTag = props.addTag;
    let removeLimit = props.removeLimit;
    let addLimit = props.addLimit;
    // let modifyLimit = props.modifyLimit;
    let setAspects = props.setAspects;
    let setFlaws = props.setFlaws;
    let changeStat = props.changeStat;
    let sendMessage = props.sendMessage;
    let addItem = props.addItem;
    let confirmRemoveEntity = props.confirmRemoveEntity;
    let removeItem = props.removeItem;
    let sortColumn = props.sortColumn;
    let sortType = props.sortType;
    let sortGroup = props.sortGroup;
    let editable = doc.editable;
    (0, $bh6RR.useEffect)(()=>{
        let table = document.getElementById('entity-table');
        // console.log(table.scrollWidth)
        table.style.width = table.scrollWidth + 'px';
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
        className: "entity-table desktop",
        id: "entity-table",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("thead", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                        className: "meta",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                className: "freeze-col",
                                rowSpan: "2",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: sortEntities,
                                        "data-prop": "name",
                                        title: "sort by name",
                                        children: "Name"
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: sortEntities,
                                        "data-prop": "xp",
                                        title: "sort by xp value",
                                        children: "Xp"
                                    }),
                                    editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                            entities.length,
                                            " entities in view",
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                onClick: addNewEntity,
                                                children: "add new"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                colSpan: "2",
                                children: "Vitals"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                colSpan: "2",
                                children: "Aspects"
                            }),
                            doc.primaries?.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                colSpan: doc.primaries?.length,
                                children: "Primaries"
                            }),
                            doc.tacticals?.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                colSpan: doc.tacticals?.length,
                                children: "Tactical"
                            }),
                            doc.thresholds?.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                colSpan: doc.thresholds?.length,
                                children: "Thresholds"
                            }),
                            doc.pools?.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                colSpan: doc.pools?.length,
                                children: "Pools"
                            }),
                            skillGroups.filter((x)=>skillCount[x] > 0).map((skillGroup)=>{
                                let count = skillCount[skillGroup];
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                    colSpan: count,
                                    children: [
                                        skillGroup,
                                        " Skills"
                                    ]
                                }, skillGroup);
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                rowSpan: "2",
                                className: "listHead",
                                children: "Equip"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                rowSpan: "2",
                                children: "Remove"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                className: "listHead",
                                style: {
                                    minWidth: '25ch'
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    onClick: openModal,
                                    "data-target": "tagModal",
                                    children: "Tags"
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                className: "listHead",
                                style: {
                                    minWidth: '30ch'
                                },
                                children: "Limits"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                children: "Aspects"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                children: "Flaws"
                            }),
                            doc.primaries?.map((x)=>{
                                return $e3358109f073a34c$var$statHeader(x, 'primaries', sortColumn, changeColumnSort, sortType, sortGroup);
                            }),
                            doc.tacticals?.map((x)=>{
                                return $e3358109f073a34c$var$statHeader(x, 'tacticals', sortColumn, changeColumnSort, sortType, sortGroup);
                            }),
                            doc.thresholds?.map((x)=>{
                                return $e3358109f073a34c$var$statHeader(x, 'thresholds', sortColumn, changeColumnSort, sortType, sortGroup);
                            }),
                            doc.pools?.map((x)=>{
                                return $e3358109f073a34c$var$statHeader(x, 'pools', sortColumn, changeColumnSort, sortType, sortGroup);
                            }),
                            skillGroups.map((skillGroup)=>{
                                return doc.skills?.filter((x)=>x.skillGroup === skillGroup).map((x)=>{
                                    return $e3358109f073a34c$var$statHeader(x, 'skills', sortColumn, changeColumnSort, sortType, sortGroup);
                                });
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
                children: entities.map((entity)=>{
                    let path = '/doc/' + doc._id + '/Entity/' + entity._id;
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                className: "freeze-col keycell",
                                style: {
                                    minWidth: (entity.name.length + entity.xp.toLocaleString().length) * .8 + 15 + 'ch'
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $29c8113ae79ce063$export$2e2bcd8739ae039), {
                                            entity: entity,
                                            sendMessage: sendMessage
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                            to: path,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: "\uD83D\uDD17"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $230c908a78eed90f$export$2e2bcd8739ae039), {
                                            entity: entity,
                                            changeName: changeName
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            children: entity.xp.toLocaleString()
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ee78d31df4b15a$export$2e2bcd8739ae039), {
                                entity: entity,
                                removeTag: removeTag,
                                addTag: addTag,
                                doc: doc
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f2d3eea0c6204b22$export$2e2bcd8739ae039), {
                                entity: entity,
                                removeLimit: removeLimit,
                                addLimit: addLimit,
                                // modifyLimit={modifyLimit}
                                doc: doc
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $092814106b66cfa7$export$2e2bcd8739ae039), {
                                entity: entity,
                                aspects: entity.aspects,
                                doc: doc,
                                aspectType: "aspects",
                                setAspects: setAspects
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $092814106b66cfa7$export$2e2bcd8739ae039), {
                                entity: entity,
                                aspects: entity.flaws,
                                doc: doc,
                                aspectType: "flaws",
                                setAspects: setFlaws
                            }),
                            doc.primaries.map((prototype)=>{
                                let stat = entity.primaries.find((x)=>x.name === prototype.name);
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3eed897e0422e1dc$export$2e2bcd8739ae039), {
                                    prototype: prototype,
                                    stat: stat,
                                    entity: entity,
                                    statgroup: 'primaries',
                                    changeStat: changeStat,
                                    sendMessage: sendMessage
                                }, prototype.name);
                            }),
                            doc.tacticals.map((prototype)=>{
                                let stat = entity.tacticals.find((x)=>x.name === prototype.name);
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3eed897e0422e1dc$export$2e2bcd8739ae039), {
                                    prototype: prototype,
                                    stat: stat,
                                    entity: entity,
                                    statgroup: 'tacticals',
                                    changeStat: changeStat,
                                    sendMessage: sendMessage
                                }, prototype.name);
                            }),
                            doc.thresholds.map((prototype)=>{
                                let stat = entity.thresholds.find((x)=>x.name === prototype.name);
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3eed897e0422e1dc$export$2e2bcd8739ae039), {
                                    prototype: prototype,
                                    stat: stat,
                                    entity: entity,
                                    statgroup: 'thresholds',
                                    changeStat: changeStat,
                                    sendMessage: sendMessage
                                }, prototype.name);
                            }),
                            doc.pools.map((prototype)=>{
                                let stat = entity.pools.find((x)=>x.name === prototype.name);
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3eed897e0422e1dc$export$2e2bcd8739ae039), {
                                    prototype: prototype,
                                    stat: stat,
                                    entity: entity,
                                    statgroup: 'pools',
                                    changeStat: changeStat,
                                    sendMessage: sendMessage
                                }, prototype.name);
                            }),
                            skillGroups.map((skillGroup)=>{
                                return doc.skills.filter((x)=>x.skillGroup === skillGroup).map((prototype)=>{
                                    let stat = entity.skills.find((x)=>x.name === prototype.name);
                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3eed897e0422e1dc$export$2e2bcd8739ae039), {
                                        prototype: prototype,
                                        stat: stat,
                                        entity: entity,
                                        statgroup: 'skills',
                                        changeStat: changeStat,
                                        sendMessage: sendMessage
                                    }, prototype.name);
                                });
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6bbfe4d95fa87243$export$2e2bcd8739ae039), {
                                entity: entity,
                                removeItem: removeItem,
                                addItem: addItem,
                                doc: doc,
                                sendMessage: sendMessage
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    onClick: confirmRemoveEntity,
                                    "data-id": entity._id,
                                    "data-name": entity.name,
                                    className: "delete",
                                    children: "x"
                                })
                            })
                        ]
                    }, entity._id);
                })
            })
        ]
    });
}
function $e3358109f073a34c$var$statHeader(stat, group, sortColumn, changeColumnSort, sortType, sortGroup) {
    let icon = '';
    if (stat.name === sortColumn && sortGroup === group) switch(sortType){
        case 1:
            icon = "\uD83D\uDCDA\uD83D\uDD3C";
            break;
        case 2:
            icon = "\uD83D\uDCDA\uD83D\uDD3D";
            break;
        case 3:
            icon = "\uD83D\uDEAB\uD83D\uDD3C";
            break;
        case 4:
            icon = "\uD83D\uDEAB\uD83D\uDD3D";
            break;
        default:
            icon = '';
            break;
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
        onClick: (e)=>changeColumnSort(e, stat, group),
        title: "click to sort or filter",
        style: {
            userSelect: 'none'
        },
        children: [
            stat.name,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            icon
        ]
    }, stat._id);
}



var $d1ffd40e86b7fa1f$exports = {};

$parcel$export($d1ffd40e86b7fa1f$exports, "extract", function () { return $d1ffd40e86b7fa1f$export$f9380c9a627682d3; }, function (v) { return $d1ffd40e86b7fa1f$export$f9380c9a627682d3 = v; });
$parcel$export($d1ffd40e86b7fa1f$exports, "parse", function () { return $d1ffd40e86b7fa1f$export$98e6a39c04603d36; }, function (v) { return $d1ffd40e86b7fa1f$export$98e6a39c04603d36 = v; });
$parcel$export($d1ffd40e86b7fa1f$exports, "stringify", function () { return $d1ffd40e86b7fa1f$export$fac44ee5b035f737; }, function (v) { return $d1ffd40e86b7fa1f$export$fac44ee5b035f737 = v; });
var $d1ffd40e86b7fa1f$export$f9380c9a627682d3;
var $d1ffd40e86b7fa1f$export$98e6a39c04603d36;
var $d1ffd40e86b7fa1f$export$fac44ee5b035f737;
'use strict';
var $294d26d8a99a3ff6$exports = {};
'use strict';
$294d26d8a99a3ff6$exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};


var $3512c7c00a4083d8$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $3512c7c00a4083d8$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3512c7c00a4083d8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $3512c7c00a4083d8$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $3512c7c00a4083d8$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $3512c7c00a4083d8$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$3512c7c00a4083d8$exports = $3512c7c00a4083d8$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $3512c7c00a4083d8$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($3512c7c00a4083d8$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($3512c7c00a4083d8$var$getOwnPropertySymbols) {
            symbols = $3512c7c00a4083d8$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($3512c7c00a4083d8$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


function $d1ffd40e86b7fa1f$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $d1ffd40e86b7fa1f$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $d1ffd40e86b7fa1f$var$encode(key, opts),
                    '[',
                    $d1ffd40e86b7fa1f$var$encode(index, opts),
                    ']=',
                    $d1ffd40e86b7fa1f$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $d1ffd40e86b7fa1f$var$encode(key, opts) : [
                    $d1ffd40e86b7fa1f$var$encode(key, opts),
                    '[]=',
                    $d1ffd40e86b7fa1f$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $d1ffd40e86b7fa1f$var$encode(key, opts) : [
                    $d1ffd40e86b7fa1f$var$encode(key, opts),
                    '=',
                    $d1ffd40e86b7fa1f$var$encode(value, opts)
                ].join('');
            };
    }
}
function $d1ffd40e86b7fa1f$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $d1ffd40e86b7fa1f$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $294d26d8a99a3ff6$exports(value) : encodeURIComponent(value);
    return value;
}
function $d1ffd40e86b7fa1f$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $d1ffd40e86b7fa1f$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
$d1ffd40e86b7fa1f$export$f9380c9a627682d3 = function(str) {
    return str.split('?')[1] || '';
};
$d1ffd40e86b7fa1f$export$98e6a39c04603d36 = function(str, opts) {
    opts = $3512c7c00a4083d8$exports({
        arrayFormat: 'none'
    }, opts);
    var formatter = $d1ffd40e86b7fa1f$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^(\?|#|&)/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : decodeURIComponent(val);
        formatter(decodeURIComponent(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $d1ffd40e86b7fa1f$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
};
$d1ffd40e86b7fa1f$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $3512c7c00a4083d8$exports(defaults, opts);
    var formatter = $d1ffd40e86b7fa1f$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort().map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $d1ffd40e86b7fa1f$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $d1ffd40e86b7fa1f$var$encode(key, opts) + '=' + $d1ffd40e86b7fa1f$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};





function $183949e9dc239839$export$2e2bcd8739ae039(statName, group, reverse = false, insensitive = false) {
    let sign = reverse ? -1 : 1;
    return function(a, b) {
        // console.log(a)
        a = a[group].find((x)=>x.name === statName);
        b = b[group].find((x)=>x.name === statName);
        if (!a) return 1;
        if (!b) return -1;
        a = $183949e9dc239839$var$getStatNumber(a);
        b = $183949e9dc239839$var$getStatNumber(b);
        if (a < b) return -1 * sign;
        if (a > b) return 1 * sign;
        return 0;
    };
}
function $183949e9dc239839$var$getStatNumber(stat) {
    // console.log(stat);
    if (!stat) return Number.NEGATIVE_INFINITY;
    let number = 0;
    switch(stat.prototype.valueType){
        case 'formula':
        case 'number':
            number = (0, $d57594e518c4ebb1$export$2e2bcd8739ae039)(stat);
            break;
        case 'dieSize':
        case 'dicePool':
            number = (0, $10aed7e064768419$export$2e2bcd8739ae039)(stat);
            break;
    }
    return number;
}



class $dd2c8f04fdc944d9$var$EntityListTab extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        let options = (0, (/*@__PURE__*/$parcel$interopDefault($d1ffd40e86b7fa1f$exports))).parse(this.props.location.search);
        // console.log(options)
        this.state = {
            entitySortProp: 'name',
            sortReverse: false,
            tagSelector: false,
            tagList: [],
            operation: 'all',
            logic: 'or',
            columnSort: options.columnSort || '',
            colSortType: parseInt(options.colSortType) || 0,
            colSortGroup: options.colSortGroup || ''
        };
    }
    fields = [
        'parent-op',
        'white-op',
        'whitelistTags',
        'black-op',
        'blacklistTags',
        'columnSort',
        'colSortType',
        'colSortGroup'
    ];
    skillGroups = [
        'none',
        'Academic',
        'Combat',
        'Espionage',
        'Social',
        'Special'
    ];
    columnSortMethods = [
        'none',
        'sort-asc',
        'sort-desc',
        'filter-asc',
        'filter-desc'
    ];
    componentDidMount = ()=>{
        this.pushHistory();
    };
    /**
     * Gets the intended URL params from the body options
     * @param {*} e the event
     */ pushHistory = (e, colsort)=>{
        let target = e?.target;
        // console.log(this.state)
        // console.log(e, target);
        let options = (0, (/*@__PURE__*/$parcel$interopDefault($d1ffd40e86b7fa1f$exports))).parse(this.props.location.search);
        let tagSettings = {};
        this.fields.forEach((field)=>{
            let value = '';
            let element = document.getElementById(field);
            if (!!element) value = element.value;
            else if (!!options[field]) value = options[field];
            tagSettings[field] = value;
        });
        tagSettings['columnSort'] = this.state.columnSort;
        tagSettings['colSortType'] = this.state.colSortType;
        tagSettings['colSortGroup'] = this.state.colSortGroup;
        // tagSettings['columnSort'] = options.columnSort;
        // tagSettings['colSortType'] = options.colSortType;
        // tagSettings['colSortGroup'] = options.colSortGroup;
        // if(!!colsort) {
        //     tagSettings['columnSort'] = colsort.columnSort;
        //     tagSettings['colSortType'] = colsort.colSortType;
        //     tagSettings['colSortGroup'] = colsort.colSortGroup;
        // }
        // console.log(options['white-op'], tagSettings['white-op']);
        tagSettings['parent-op'] = tagSettings['parent-op'] || 'doc';
        tagSettings['white-op'] = tagSettings['white-op'] || 'any';
        tagSettings['black-op'] = tagSettings['black-op'] || 'any';
        let whitelist = options.whitelistTags?.split(',') || [];
        let blacklist = options.blacklistTags?.split(',') || [];
        if (!!target) {
            let listname = target.dataset.list;
            // console.log(target.checked)
            if (target.checked) {
                if (listname === 'whitelist') whitelist.push(target.value);
                if (listname === 'blacklist') blacklist.push(target.value);
            }
            if (!target.checked) {
                // console.log(target.value)
                // console.log(listname)
                if (listname === 'whitelist') whitelist = whitelist.filter((x)=>x !== target.value);
                if (listname === 'blacklist') blacklist = blacklist.filter((x)=>x !== target.value);
            }
        }
        whitelist = whitelist.filter((x)=>!!x);
        blacklist = blacklist.filter((x)=>!!x);
        tagSettings['whitelistTags'] = whitelist.join(',');
        tagSettings['blacklistTags'] = blacklist.join(',');
        // console.log(tagSettings);
        let newSubpath = '?';
        this.fields.forEach((field)=>{
            newSubpath += field + '=' + tagSettings[field] + '&';
        });
        newSubpath = newSubpath.substring(0, newSubpath.length - 1);
        // console.log(newSubpath);
        this.props.history.push(newSubpath);
    };
    addNewEntity = (e)=>{
        let options = (0, (/*@__PURE__*/$parcel$interopDefault($d1ffd40e86b7fa1f$exports))).parse(this.props.location.search);
        let whitelist = options.whitelistTags?.split(',');
        whitelist = whitelist.filter((x)=>!!x);
        this.props.sendMessage({
            operation: 'add new entity',
            tags: whitelist
        });
    };
    confirmRemoveEntity = (e)=>{
        let id = e.target.dataset.id;
        let name = e.target.dataset.name;
        if (window.confirm('Are you sure you want to permanently delete ' + name + '?')) this.removeEntity(id);
    };
    removeEntity = (id)=>{
        this.props.sendMessage({
            operation: 'remove entity',
            entityid: id
        });
    };
    changeStat = (e)=>{
        let entityid = e.target.dataset.entityid;
        let statid = e.target.dataset.statid;
        let statgroup = e.target.dataset.statgroup;
        let value = e.target.value;
        let valueType = e.target.dataset.valuetype;
        // console.log(valueType);
        this.props.sendMessage({
            operation: 'change entity stat value',
            entityid: entityid,
            statgroup: statgroup,
            statid: statid,
            value: value,
            valueType: valueType
        });
    };
    changeName = (id, name)=>{
        let entityid = id;
        let value = name;
        this.props.sendMessage({
            operation: 'change entity name',
            entityid: entityid,
            value: value
        });
    };
    removeTag = (id, tagName)=>{
        let entityid = id;
        let tag = tagName;
        this.props.sendMessage({
            operation: 'remove entity tag',
            entityid: entityid,
            tag: tag
        });
    };
    addTag = (id, tagName)=>{
        let entityid = id;
        let tag = tagName;
        this.props.sendMessage({
            operation: 'add entity tag',
            entityid: entityid,
            tag: tag
        });
    };
    addItem = (id, itemid)=>{
        let entityid = id;
        this.props.sendMessage({
            operation: 'add entity item',
            entityid: entityid,
            itemid: itemid
        });
    };
    removeItem = (id, itemid)=>{
        let entityid = id;
        this.props.sendMessage({
            operation: 'remove entity item',
            entityid: entityid,
            itemid: itemid
        });
    };
    addLimit = (entityid, name, multiplier, limitid)=>{
        this.props.sendMessage({
            operation: 'add entity limit',
            entityid: entityid,
            limitid: limitid,
            name: name,
            multiplier: multiplier
        });
    };
    removeLimit = (entityid, name, limitid)=>{
        this.props.sendMessage({
            operation: 'remove entity limit',
            entityid: entityid,
            limitid: limitid,
            name: name
        });
    };
    setAspects = (id, list)=>{
        this.props.sendMessage({
            operation: 'set entity aspects',
            entityid: id,
            type: 'aspects',
            list: list,
            source: 'EntityListTab'
        });
    };
    setFlaws = (id, list)=>{
        this.props.sendMessage({
            operation: 'set entity aspects',
            entityid: id,
            type: 'flaws',
            list: list
        });
    };
    sortEntities = (e)=>{
        const prop = e.target.dataset.prop;
        let reverse = false;
        if (this.state.entitySortProp === prop) reverse = !this.state.sortReverse;
        this.setState({
            entitySortProp: prop,
            sortReverse: reverse
        });
    };
    openTagSelector = (e)=>{
        this.setState({
            tagSelector: true
        });
    };
    changeTagOperation = (e)=>{
        this.setState({
            operation: e.target.value
        });
    };
    changeTagLogic = (e)=>{
        this.setState({
            logic: e.target.value
        });
    };
    changeColumnSort = (e, stat, group)=>{
        console.log(e, stat, group);
        let sortColumn = stat.name;
        let sortTypeIndex = 0;
        if (sortColumn === this.state.columnSort || this.state.columnSort == '') {
            // console.log('increment')
            sortTypeIndex = (this.state.colSortType + 1) % 5;
            if (sortTypeIndex === 0) sortColumn = '';
        } else sortTypeIndex = 1;
        this.setState({
            columnSort: sortColumn,
            colSortType: sortTypeIndex,
            colSortGroup: group
        }, ()=>{
            // let colsort = {
            //     columnSort: sortColumn,
            //     colSortType: sortTypeIndex,
            //     colSortGroup: group,
            // }
            // this.pushHistory(e, colsort);
            this.pushHistory(e);
        // console.log(sortTypeIndex, sortColumn);
        });
    };
    filterEntities = (entities, options)=>{
        // console.log(this.state.tagList)
        if (options['parent-op'] === 'doc') entities = entities.filter((x)=>!x.external);
        if (options['parent-op'] === 'parent') entities = entities.filter((x)=>x.external);
        let whitelist = options.whitelistTags?.split(',').filter((x)=>!!x) || [];
        let blacklist = options.blacklistTags?.split(',').filter((x)=>!!x) || [];
        if (whitelist.length > 0) {
            if (options['white-op'] === 'any') entities = entities.filter((x)=>this.any(x.tags, whitelist));
            if (options['white-op'] === 'all') entities = entities.filter((x)=>this.all(x.tags, whitelist));
        }
        if (blacklist.length > 0) {
            if (options['white-op'] === 'any') entities = entities.filter((x)=>!this.any(x.tags, blacklist));
            if (options['white-op'] === 'all') entities = entities.filter((x)=>!this.all(x.tags, blacklist));
        }
        // filter entities based on colsort
        let colName = this.state.columnSort;
        if (this.state.columnSort != '') {
            if (this.state.colSortType === 3 || this.state.colSortType === 4) {
                let group = this.state.colSortGroup;
                // console.log(group)
                entities = entities.filter((x)=>{
                    if (x[group].length === 0) return false;
                    return !!x[group].find((y)=>y.name === colName);
                });
            }
        }
        return entities;
    };
    any = (a, b)=>{
        let success = false;
        b.forEach((x)=>{
            if (a.includes(x)) return success = true;
        });
        return success;
    };
    all = (a, b)=>{
        let success = true;
        b.forEach((x)=>{
            if (!a.includes(x)) return success = false;
        });
        return success;
    };
    openModal = (e)=>{
        let target = e.target.dataset.target;
        // console.log(target)
        this.setState({
            [target]: true
        });
    };
    closeModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: false,
            tagSelector: false
        });
    };
    render() {
        let options = (0, (/*@__PURE__*/$parcel$interopDefault($d1ffd40e86b7fa1f$exports))).parse(this.props.location.search);
        if (!options) options = {
            'parent-op': 'doc'
        };
        let whitelistTags = options.whitelistTags?.split(',').map((x)=>x.trim()) || [];
        let blacklistTags = options.blacklistTags?.split(',').map((x)=>x.trim()) || [];
        let doc = this.props.doc;
        let entities = doc.entities || [];
        entities = this.filterEntities(entities, options);
        entities.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)(this.state.entitySortProp, this.state.sortReverse, true));
        // colsort
        if (!!this.state.columnSort && this.state.colSortType > 0) {
            // console.log('column sort', options.columnSort)
            let reverse = this.state.colSortType === 1 || this.state.colSortType === 3;
            entities.sort((0, $183949e9dc239839$export$2e2bcd8739ae039)(this.state.columnSort, this.state.colSortGroup, reverse, false));
        }
        // component setup
        let skillCount = {};
        this.skillGroups.forEach((skillGroup)=>skillCount[skillGroup] = 0);
        doc.skills?.forEach((skill)=>{
            skillCount[skill.skillGroup]++;
        });
        document.title = [
            'Entity List',
            doc.name,
            'SGS'
        ].join(' - ');
        // Sgs.calculateAllXp(doc);
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "entity-table-wrapper",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e3358109f073a34c$export$2e2bcd8739ae039), {
                    doc: doc,
                    entities: entities,
                    skillCount: skillCount,
                    skillGroups: this.skillGroups,
                    sortEntities: this.sortEntities,
                    openModal: this.openModal,
                    addNewEntity: this.addNewEntity,
                    confirmRemoveEntity: this.confirmRemoveEntity,
                    removeTag: this.removeTag,
                    addTag: this.addTag,
                    removeLimit: this.removeLimit,
                    addLimit: this.addLimit,
                    // modifyLimit = {this.modifyLimit}
                    setAspects: this.setAspects,
                    setFlaws: this.setFlaws,
                    changeStat: this.changeStat,
                    sendMessage: this.props.sendMessage,
                    addItem: this.addItem,
                    removeItem: this.removeItem,
                    changeName: this.changeName,
                    changeColumnSort: this.changeColumnSort,
                    sortColumn: this.state.columnSort,
                    sortType: this.state.colSortType,
                    sortGroup: this.state.colSortGroup
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a6c7fc3d79e3fff4$export$2e2bcd8739ae039), {
                    doc: doc,
                    entities: entities,
                    skillCount: skillCount
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09f16485618a5dc7$export$2e2bcd8739ae039), {
                    state: this.state,
                    title: "Filter entities by Tag",
                    target: "tagModal",
                    closeModal: this.closeModal,
                    closeButtonText: "close",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                            children: "Parent Doc"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                            id: "parent-op",
                            onChange: this.pushHistory,
                            value: options['parent-op'],
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                    value: "doc",
                                    children: "Doc only"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                    value: "both",
                                    children: "Include both"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                    value: "parent",
                                    children: "Parent only"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                            children: "Whitelist Tags"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                            id: "white-op",
                            onChange: this.pushHistory,
                            value: options['white-op'],
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                    value: "any",
                                    children: "Any of the following tags"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                    value: "all",
                                    children: "All of the following tags"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        doc.entityTags?.map((tag)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                children: [
                                    tag,
                                    "\xa0",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                        type: "checkbox",
                                        value: tag,
                                        "data-list": "whitelist",
                                        checked: whitelistTags.includes(tag),
                                        onChange: this.pushHistory
                                    })
                                ]
                            }, tag);
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                            children: "Blacklist Tags"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                            id: "black-op",
                            onChange: this.pushHistory,
                            value: options['black-op'],
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                    value: "any",
                                    children: "Any of the following tags"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                    value: "all",
                                    children: "All of the following tags"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        doc.entityTags?.map((tag)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                children: [
                                    tag,
                                    "\xa0",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                        type: "checkbox",
                                        value: tag,
                                        "data-list": "blacklist",
                                        checked: blacklistTags.includes(tag),
                                        onChange: this.pushHistory
                                    })
                                ]
                            }, tag);
                        })
                    ]
                })
            ]
        });
    }
}
var $dd2c8f04fdc944d9$export$2e2bcd8739ae039 = (0, $14986c2201283622$export$369b6b2b30582e8e)($dd2c8f04fdc944d9$var$EntityListTab);




var $bh6RR = parcelRequire("bh6RR");





function $aa0be55d5669d56e$var$addLimit(id, name, multiplier, note, limitid, sendMessage) {
    console.log(id, name, multiplier, note);
    sendMessage({
        operation: 'add entity limit',
        entityid: id,
        limitid: limitid,
        name: name,
        multiplier: multiplier,
        note: note
    });
}
function $aa0be55d5669d56e$var$removeLimit(id, name, limitid, sendMessage) {
    // console.log(id, name);
    sendMessage({
        operation: 'remove entity limit',
        entityid: id,
        limitid: limitid,
        name: name
    });
}
function $aa0be55d5669d56e$var$toggleLimit(e, sendMessage) {
    let checked = e.target.checked;
    let entityid = e.target.dataset.entityid;
    let limitid = e.target.dataset.limitid;
    let name = e.target.dataset.name;
    let multiplier = e.target.dataset.multiplier;
    let note = e.target.dataset.note;
    // let sendMessage = e.target.dataset.sendmessage;
    // let note = this.state.note;
    if (checked) $aa0be55d5669d56e$var$addLimit(entityid, name, multiplier, note, limitid, sendMessage);
    else $aa0be55d5669d56e$var$removeLimit(entityid, name, limitid, sendMessage);
}
function $aa0be55d5669d56e$var$onNoteChange(e) {
    console.error('never implemented');
}
function $aa0be55d5669d56e$var$removeTag(entityid, tag, sendMessage) {
    sendMessage({
        operation: 'remove entity tag',
        entityid: entityid,
        tag: tag
    });
}
function $aa0be55d5669d56e$var$addTag(entityid, tag, sendMessage) {
    sendMessage({
        operation: 'add entity tag',
        entityid: entityid,
        tag: tag
    });
}
function $aa0be55d5669d56e$var$toggleTag(e, sendMessage) {
    let checked = e.target.checked;
    let tag = e.target.name;
    let entityid = e.target.dataset.entityid;
    if (checked) $aa0be55d5669d56e$var$addTag(entityid, tag, sendMessage);
    else $aa0be55d5669d56e$var$removeTag(entityid, tag, sendMessage);
}
function $aa0be55d5669d56e$var$addNewTag(e) {
    console.error('never implemented');
}
function $aa0be55d5669d56e$var$changeNewTag(e) {
    console.error('never implemented');
}
function $aa0be55d5669d56e$var$promptNameChange(name, id, changeName) {
    let newName = prompt('Rename ' + name + ' to...', name);
    if (newName) {
        console.log(name, newName);
        if (newName !== name) changeName(id, newName);
    }
}
function $aa0be55d5669d56e$export$2e2bcd8739ae039(props) {
    let doc = props.doc;
    let entity = props.entity;
    let editable = entity.editable;
    let dtags = doc.entityTags;
    let openModal = props.openModal;
    let closeModal = props.closeModal;
    let state = props.state;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "panel namepanel",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                children: entity.name
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("em", {
                    children: entity._id
                })
            }),
            editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                onClick: ()=>$aa0be55d5669d56e$var$promptNameChange(entity.name, entity._id, props.changeName),
                children: "Rename"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h3", {
                children: [
                    entity.xp.toLocaleString(),
                    " xp"
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                children: [
                    entity.limitations.map((limit)=>{
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            children: [
                                limit.name,
                                " (\xd7",
                                limit.multiplier,
                                !!limit.note && ', ',
                                limit.note,
                                ") \xa0",
                                editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    className: "delete",
                                    onClick: ()=>$aa0be55d5669d56e$var$removeLimit(entity._id, limit.name, limit._id, props.sendMessage),
                                    children: "x"
                                })
                            ]
                        }, limit.name);
                    }),
                    editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                onClick: openModal,
                                "data-target": "limitModal",
                                children: "\u2795Add Limit"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $09f16485618a5dc7$export$2e2bcd8739ae039), {
                                state: state,
                                title: "Select Limtations",
                                target: "limitModal",
                                closeModal: closeModal,
                                closeButtonText: "close",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: "Limit"
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: "Multiplier"
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: "Enabled"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
                                            children: doc.limitations.map((limit)=>{
                                                let entityLimit = entity.limitations?.find((x)=>x.name === limit.name);
                                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                            className: "button-takes-whole-cell",
                                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                                                htmlFor: limit.name,
                                                                className: !!entityLimit ? 'checked' : '',
                                                                children: limit.name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                            children: limit.multiplier
                                                        }),
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                                id: limit.name,
                                                                type: "checkbox",
                                                                checked: !!entityLimit,
                                                                onChange: (e)=>$aa0be55d5669d56e$var$toggleLimit(e, props.sendMessage),
                                                                "data-name": limit.name,
                                                                "data-multiplier": limit.multiplier,
                                                                "data-entityid": entity._id,
                                                                "data-limitid": limit._id
                                                            })
                                                        })
                                                    ]
                                                }, limit.name);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                children: "Tags"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                children: [
                    entity.tags.map((tag)=>{
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            children: [
                                "#",
                                tag,
                                "\xa0",
                                editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    className: "delete",
                                    onClick: ()=>$aa0be55d5669d56e$var$removeTag(entity._id, tag, props.sendMessage),
                                    children: "x"
                                })
                            ]
                        }, tag);
                    }),
                    editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                onClick: openModal,
                                "data-target": "tagModal",
                                children: "\u2795Add Tag"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $09f16485618a5dc7$export$2e2bcd8739ae039), {
                                state: state,
                                title: "Select Tags",
                                target: "tagModal",
                                closeModal: closeModal,
                                closeButtonText: "close",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("table", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                                        children: [
                                            dtags.map((dt)=>{
                                                let eHasTag = entity.tags?.includes(dt);
                                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                                                htmlFor: dt,
                                                                className: eHasTag ? 'checked' : '',
                                                                children: dt
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                                type: "checkbox",
                                                                name: dt,
                                                                id: dt,
                                                                checked: eHasTag ? true : false,
                                                                onChange: (e)=>$aa0be55d5669d56e$var$toggleTag(e, props.sendMessage),
                                                                "data-entityid": entity._id
                                                            })
                                                        })
                                                    ]
                                                }, dt);
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("form", {
                                                            onSubmit: $aa0be55d5669d56e$var$addNewTag,
                                                            id: "newTagForm",
                                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                                                children: [
                                                                    "Add a Tag:\xa0",
                                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                                        placeholder: "new tag",
                                                                        value: state.newTag,
                                                                        onChange: $aa0be55d5669d56e$var$changeNewTag
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                            form: "newTagForm",
                                                            type: "submit"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
} // function Editable(props){
 //     let entity = props.entity;
 //     return (
 //         <div className='panel'>
 //         <h2>{entity.name}</h2>
 //         <p><em>{entity._id}</em></p>
 //         <h3>Xp</h3>
 //         <ul>
 //             <li>{entity.xp.toLocaleString()} xp</li>
 //             {entity.limitations.map(limit => {return(
 //                 <li key={limit.name}>
 //                     Limitation: {limit.name} (×{limit.multiplier}{!!limit.note && ', '}{limit.note})
 //                 </li>
 //             )})}
 //         </ul>
 //         <h3>Tags</h3>
 //         <ul>
 //             {entity.tags.map(tag => {return(
 //                 <li key={tag}>
 //                     #{tag}
 //                     &nbsp;
 //                 </li>
 //             )})}
 //         </ul>
 //     </div>
 //     )
 // }




function $25316acd805bdad7$export$2e2bcd8739ae039(input, decimalPlaces = 2) {
    decimalPlaces = Math.floor(Math.max(1, decimalPlaces));
    let places = 10 ** decimalPlaces;
    return Math.round(input * places) / places;
}


function $5df81a6b18f4f72a$var$addAspect(e, sendMessage) {
    // console.log('add aspect')
    let entityid = e.target.dataset.entityid;
    let type = e.target.dataset.type;
    let name = e.target.dataset.name;
    sendMessage({
        operation: 'add entity aspect',
        entityid: entityid,
        type: type,
        name: name
    });
}
function $5df81a6b18f4f72a$var$setAspect(e, sendMessage) {
    console.log('set aspect');
    let entityid = e.target.dataset.entityid;
    let type = e.target.dataset.type;
    let oldname = e.target.dataset.oldname;
    let name = e.target.value.replace(/\n|\r/g, '');
    sendMessage({
        operation: 'set entity aspect',
        entityid: entityid,
        type: type,
        oldname: oldname,
        name: name,
        source: 'aspects panel'
    });
}
function $5df81a6b18f4f72a$var$removeAspect(e, sendMessage) {
    // console.log('remove aspect')
    let entityid = e.target.dataset.entityid;
    let type = e.target.dataset.type;
    let name = e.target.dataset.name;
    sendMessage({
        operation: 'remove entity aspect',
        entityid: entityid,
        type: type,
        name: name
    });
}
function $5df81a6b18f4f72a$export$2e2bcd8739ae039(props) {
    let entity = props.entity;
    let editable = entity.editable;
    let singular = props.singular;
    let group = props.group;
    let sendMessage = props.sendMessage;
    let hasAspects = entity[group].length > 0;
    // console.log(entity[group])
    let hide = !hasAspects ? ' noprint' : '';
    // console.log(entity);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: '' + hide,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h3", {
                children: [
                    (0, $920954e343704e08$exports.capitalize)(group),
                    " (",
                    (0, $25316acd805bdad7$export$2e2bcd8739ae039)(entity.xpGroups[group].toLocaleString() * entity.xpMultiplier),
                    " xp)"
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: singular
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: "Xp"
                                }),
                                editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: "Delete"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                        children: [
                            entity[group].map((aspect, index)=>{
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                            children: [
                                                editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("textarea", {
                                                    defaultValue: aspect,
                                                    onBlur: (e)=>$5df81a6b18f4f72a$var$setAspect(e, sendMessage),
                                                    "data-entityid": entity._id,
                                                    "data-type": group,
                                                    "data-oldname": aspect
                                                }, index),
                                                !editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    children: aspect
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: (0, $25316acd805bdad7$export$2e2bcd8739ae039)(10 * entity.xpMultiplier)
                                        }),
                                        editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                className: "delete",
                                                onClick: (e)=>$5df81a6b18f4f72a$var$removeAspect(e, sendMessage),
                                                "data-entityid": entity._id,
                                                "data-type": group,
                                                "data-name": aspect,
                                                children: "x"
                                            })
                                        })
                                    ]
                                }, index);
                            }),
                            editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    colSpan: "3",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        onClick: (e)=>$5df81a6b18f4f72a$var$addAspect(e, sendMessage),
                                        "data-entityid": entity._id,
                                        "data-type": group,
                                        "data-name": 'new ' + singular,
                                        children: "\u2795Add New Aspect"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}








var $bh6RR = parcelRequire("bh6RR");




function $d4112654b9b1a385$var$toggleStat(e, sendMessage) {
    let target = e.target;
    let enabled = target.checked;
    let statname = target.dataset.statname;
    let statgroup = target.dataset.statgroup;
    let entityid = target.dataset.entityid;
    let valueType = target.dataset.valuetype;
    if (enabled) sendMessage({
        operation: 'add entity stat',
        entityid: entityid,
        statgroup: statgroup,
        statname: statname,
        valueType: valueType
    });
    else sendMessage({
        operation: 'remove entity stat',
        entityid: entityid,
        statgroup: statgroup,
        statname: statname
    });
}
function $d4112654b9b1a385$var$changeStat(e, sendMessage) {
    // console.log('changestat')
    let entityid = e.target.dataset.entityid;
    let statid = e.target.dataset.statid;
    let statgroup = e.target.dataset.statgroup;
    let value = e.target.value;
    let valueType = e.target.dataset.valuetype;
    // console.log(valueType);
    sendMessage({
        operation: 'change entity stat value',
        entityid: entityid,
        statgroup: statgroup,
        statid: statid,
        value: value,
        valueType: valueType
    });
}
function $d4112654b9b1a385$var$changeSort(e, setSortKey) {
    let newSortKey = e.target.dataset.sortkey;
    // console.log(newSortKey);
    setSortKey(newSortKey);
    window.localStorage.setItem('skillSort', newSortKey);
}
function $d4112654b9b1a385$var$changeFilter(e, setFilterSkills) {
    let newFilterState = e.target.dataset.sortkey;
    setFilterSkills(newFilterState);
    window.localStorage.setItem('filterSkills', newFilterState);
}
function $d4112654b9b1a385$export$2e2bcd8739ae039(props) {
    let entity = props.entity;
    let doc = props.doc;
    let editable = entity.editable;
    let groupName = props.groupName;
    let sendMessage = props.sendMessage;
    let entityGroup = entity[groupName];
    let docGroup = doc[groupName];
    let isPrimary = groupName === 'primaries';
    let isSkill = groupName === 'skills';
    let isPool = groupName === 'pools';
    const [sortKey, setSortKey] = (0, $bh6RR.useState)(window.localStorage.getItem('skillSort') || 'name');
    const [filterSkills, setFilterSkills] = (0, $bh6RR.useState)(window.localStorage.getItem('filterSkills') || false);
    let sortedGroup = docGroup;
    if (isSkill) sortedGroup = docGroup.sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)('name')).sort((0, $66b1ca27b6f9c364$export$2e2bcd8739ae039)(sortKey));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: 'panel statspanel ' + groupName + 'panel',
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h3", {
                children: [
                    (0, $920954e343704e08$exports.capitalize)(groupName),
                    " (",
                    (0, $25316acd805bdad7$export$2e2bcd8739ae039)(entity.xpGroups[groupName].toLocaleString() * entity.xpMultiplier),
                    " xp)"
                ]
            }, groupName),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                className: groupName,
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                            children: [
                                isSkill && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        "data-sortkey": "name",
                                        onClick: (e)=>$d4112654b9b1a385$var$changeSort(e, setSortKey),
                                        children: (0, $920954e343704e08$exports.capitalize)(groupName)
                                    })
                                }),
                                !isSkill && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: (0, $920954e343704e08$exports.capitalize)(groupName)
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    title: 'whether ' + entity.name + ' owns this stat',
                                    className: "printhide",
                                    children: "\u2714"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    className: "valtrim",
                                    children: "Value"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    children: "Xp"
                                }),
                                isPrimary && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    title: "sum of all skill XP tied to this stat",
                                    children: "\uD83D\uDCCA"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    title: "XP To Next Level",
                                    children: "TNL"
                                }),
                                isSkill && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    title: "Skill Group",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        "data-sortkey": "skillGroup",
                                        onClick: (e)=>$d4112654b9b1a385$var$changeSort(e, setSortKey),
                                        children: "Grp"
                                    })
                                }),
                                isSkill && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    title: "Associated Primary Stat",
                                    children: "Stat"
                                }),
                                isSkill && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                    title: "Total Bonus: Skill + Primary",
                                    children: "Total"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
                        children: sortedGroup.map((prototype)=>{
                            let stat = entityGroup.find((x)=>x.name === prototype.name);
                            let classes = !stat ? 'muted' : '';
                            let tnl = (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).Tnl(stat, entity);
                            // console.log(tnl)
                            let untrainedValue = '-';
                            if (groupName.toLowerCase() === 'skills') {
                                // console.log(prototype, stat);
                                let skillStatName = prototype.skillStat;
                                // console.log(entity.primaries);
                                let skillStat = entity.primaries.find((x)=>x.name == skillStatName);
                                // console.log(skillStat);
                                // console.log(value);
                                untrainedValue = skillStat?.number || 0;
                            }
                            if (groupName === 'primaries' && !!tnl) tnl *= 2;
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                        className: classes,
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                title: 'value type: ' + prototype.valueType,
                                                children: prototype.name
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                                className: "printhide",
                                                children: [
                                                    editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: !!stat,
                                                        onChange: (e)=>$d4112654b9b1a385$var$toggleStat(e, sendMessage),
                                                        "data-entityid": entity._id,
                                                        "data-statname": prototype.name,
                                                        "data-statgroup": groupName,
                                                        "data-valuetype": prototype.valueType
                                                    }),
                                                    !editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: !!stat,
                                                        "data-entityid": entity._id,
                                                        "data-statname": prototype.name,
                                                        "data-statgroup": groupName,
                                                        "data-valuetype": prototype.valueType,
                                                        readOnly: true,
                                                        disabled: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3eed897e0422e1dc$export$2e2bcd8739ae039), {
                                                prototype: prototype,
                                                stat: stat,
                                                entity: entity,
                                                statgroup: groupName,
                                                changeStat: (e)=>$d4112654b9b1a385$var$changeStat(e, sendMessage),
                                                sendMessage: sendMessage,
                                                static: true
                                            }, prototype.name),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: !!stat && !(stat.valueType === 'formula') && (0, $25316acd805bdad7$export$2e2bcd8739ae039)(stat.xp * entity.xpMultiplier)
                                            }),
                                            isPrimary && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: stat?.skillPoints
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: (0, $25316acd805bdad7$export$2e2bcd8739ae039)(tnl)
                                            }),
                                            isSkill && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                title: prototype?.skillGroup,
                                                children: prototype?.skillGroup?.substring(0, 3)
                                            }),
                                            isSkill && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                title: prototype?.skillStat,
                                                children: prototype?.skillStat?.substring(0, 3)
                                            }),
                                            isSkill && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                                children: [
                                                    !!stat?.totalBonus && '+',
                                                    stat?.totalBonus,
                                                    !stat && untrainedValue > -1 && '+',
                                                    !stat && untrainedValue
                                                ]
                                            })
                                        ]
                                    }, prototype._id),
                                    isPool && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                            colSpan: 5,
                                            className: "boxcell",
                                            children: (0, $1249f3af6d8d1d25$export$2e2bcd8739ae039)(entity, stat)
                                        })
                                    })
                                ]
                            }, prototype._id);
                        })
                    })
                ]
            })
        ]
    }, groupName);
}










function $ba441cc1366075a1$var$newEntity(e, sendMessage) {
    let entityid = e.target.dataset.entityid;
    let owner = e.target.dataset.owner;
    sendMessage({
        operation: 'add new entity as item',
        entityid: entityid,
        owner: owner
    });
}
function $ba441cc1366075a1$var$removeItem(e, sendMessage) {
    let entityid = e.target.dataset.entityid;
    let itemid = e.target.dataset.itemid;
    sendMessage({
        operation: 'remove entity item',
        entityid: entityid,
        itemid: itemid
    });
}
function $ba441cc1366075a1$var$moveItem(e, sendMessage) {
    let entityid = e.target.dataset.entityid;
    let itemid = e.target.dataset.itemid;
    let index = parseInt(e.target.dataset.index);
    let delta = parseInt(e.target.dataset.delta);
    let max = parseInt(e.target.dataset.max) - 1;
    let oldindex = index;
    let newindex = index + delta;
    newindex = Math.min(newindex, max);
    newindex = Math.max(newindex, 0);
    // return;
    sendMessage({
        operation: 'move entity item',
        entityid: entityid,
        itemid: itemid,
        oldindex: oldindex,
        newindex: newindex
    });
}
function $ba441cc1366075a1$var$StatLi(props) {
    let groupName = props.groupName;
    let group = props.group;
    let owner = props.owner;
    let doc = props.doc;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
        children: [
            (0, $920954e343704e08$exports.capitalize)(groupName),
            ":",
            group.map((stat)=>{
                let prototypeSkill = doc[groupName].find((x)=>x.name === stat.name);
                if (!prototypeSkill) // console.log("no prototype for " + stat.name);
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            title: "This skill was removed from the game. Please remove the skill from the item.",
                            children: "\u274C"
                        }),
                        stat.name
                    ]
                }, stat._id);
                let value = (0, $d57594e518c4ebb1$export$2e2bcd8739ae039)(stat);
                if (groupName.toLowerCase() === 'skills') {
                    value = (0, $39bb4030a6707a23$export$2e2bcd8739ae039)(doc, owner, stat, groupName);
                    value = (0, $19cfbde689462999$export$2e2bcd8739ae039)(value, groupName, stat);
                }
                value = (0, $19cfbde689462999$export$2e2bcd8739ae039)(value, groupName, stat);
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    children: [
                        "\xa0",
                        value,
                        "\xa0",
                        stat.name
                    ]
                }, stat._id);
            })
        ]
    }, groupName);
}
function $ba441cc1366075a1$export$2e2bcd8739ae039(props) {
    // let [checkedTag, setCheckedTag] = useState('');
    let entity = props.entity;
    let doc = props.doc;
    let editable = entity.editable;
    let sendMessage = props.sendMessage;
    let openModal = props.openModal;
    let closeModal = props.closeModal;
    let state = props.state;
    // console.log(entity.equipment)
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "panel equipmentpanel",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h3", {
                children: [
                    "Equipment (",
                    entity.xpGroups['items'].toLocaleString(),
                    " xp)"
                ]
            }),
            entity.items.length === 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "muted",
                children: "none"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                className: "equipment",
                children: [
                    entity.items.map((item, index)=>{
                        let path = '/doc/' + doc._id + '/Entity/' + item._id;
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                    to: path,
                                    children: item.name
                                }),
                                "\xa0 (",
                                item.xp.toLocaleString(),
                                "xp)",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                                    children: [
                                        editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                            className: "modify",
                                            children: [
                                                editable && index !== 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                    onClick: (e)=>$ba441cc1366075a1$var$moveItem(e, sendMessage),
                                                    "data-entityid": entity._id,
                                                    "data-itemid": item._id,
                                                    "data-index": index,
                                                    "data-delta": -1,
                                                    "data-max": entity.items.length,
                                                    title: "move item up",
                                                    children: "\u25B2"
                                                }),
                                                "\xa0",
                                                editable && index !== entity.items.length - 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                    onClick: (e)=>$ba441cc1366075a1$var$moveItem(e, sendMessage),
                                                    "data-entityid": entity._id,
                                                    "data-itemid": item._id,
                                                    "data-index": index,
                                                    "data-delta": 1,
                                                    "data-max": entity.items.length,
                                                    title: "move item down",
                                                    children: "\u25BC"
                                                }),
                                                "\xa0",
                                                editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                    className: "delete",
                                                    onClick: (e)=>$ba441cc1366075a1$var$removeItem(e, sendMessage),
                                                    "data-entityid": entity._id,
                                                    "data-itemid": item._id,
                                                    title: "delete item",
                                                    children: "x"
                                                })
                                            ]
                                        }),
                                        item.limitations.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                            children: [
                                                "Limits: ",
                                                item.limitations.map((x)=>x.name).join(', ')
                                            ]
                                        }),
                                        item.aspects.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                            children: [
                                                "Aspects: ",
                                                item.aspects.join(', ')
                                            ]
                                        }),
                                        item.flaws.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                            children: [
                                                "Flaws: ",
                                                item.flaws.join(', ')
                                            ]
                                        }),
                                        (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).groups.map((groupName)=>{
                                            let group = item[groupName];
                                            if (group.length === 0) return '';
                                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ba441cc1366075a1$var$StatLi, {
                                                doc: doc,
                                                group: group,
                                                groupName: groupName,
                                                owner: entity
                                            }, groupName);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {})
                            ]
                        }, item._id);
                    }),
                    editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                onClick: openModal,
                                "data-target": "itemModal",
                                children: "\u2795Add Existing Item"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                onClick: (e)=>$ba441cc1366075a1$var$newEntity(e, sendMessage),
                                "data-entityid": entity._id,
                                "data-owner": entity.name,
                                children: "\u2795Add New Entity"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $524f98070c7f627f$export$2e2bcd8739ae039), {
                                parentState: state,
                                sendMessage: sendMessage,
                                closeModal: closeModal,
                                doc: doc,
                                entity: entity
                            })
                        ]
                    })
                ]
            })
        ]
    });
}






function $abe8d7886d902c6a$export$2e2bcd8739ae039(props) {
    let entity = props.entity;
    let doc = props.doc;
    // let editable = entity.editable;
    let owners = doc.entities.filter((x)=>x.equipment.includes(entity._id));
    if (owners.length === 0) return '';
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "panel ownerspanel",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                children: "Owners"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ul", {
                className: "equipment",
                children: owners.map((owner)=>{
                    let path = '/doc/' + doc._id + '/Entity/' + owner._id;
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                to: path,
                                children: owner.name
                            }),
                            "\xa0 (",
                            owner.xp.toLocaleString(),
                            "xp)",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                                children: [
                                    owner.limitations.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                        children: [
                                            "Limits: ",
                                            owner.limitations.map((x)=>x.name).join(', ')
                                        ]
                                    }),
                                    owner.aspects.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                        children: [
                                            "Aspects: ",
                                            owner.aspects.join(', ')
                                        ]
                                    }),
                                    owner.flaws.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                        children: [
                                            "Flaws: ",
                                            owner.flaws.join(', ')
                                        ]
                                    }),
                                    (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).groups.map((groupName)=>{
                                        let group = owner[groupName];
                                        if (group.length === 0) return '';
                                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                            children: [
                                                (0, $920954e343704e08$exports.capitalize)(groupName),
                                                ":",
                                                group.map((stat)=>{
                                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                                        children: [
                                                            "\xa0",
                                                            stat.valueType === 'number' && stat.number?.toString(),
                                                            stat.valueType === 'dieSize' && '1' + stat.dieSize?.toString(),
                                                            stat.valueType === 'dicePool' && stat.dicePool?.toString(),
                                                            stat.valueType === 'formula' && stat.calculated?.toString(),
                                                            "\xa0",
                                                            stat.name
                                                        ]
                                                    }, stat.name);
                                                })
                                            ]
                                        }, groupName);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {})
                        ]
                    }, owner._id);
                })
            })
        ]
    });
}





function $1d9c3e74b1c820fa$export$2e2bcd8739ae039(props) {
    let entity = props.entity;
    let editable = entity.editable;
    let sendMessage = props.sendMessage;
    let url = entity.imageurl;
    let hasImage = !url ? ' noprint' : '';
    // url = 'https://imgur.com/WpMjj3S.png';
    const imgurPattern = /^https:\/\/imgur.com\/\w+$/gm;
    if (url && url.match(imgurPattern)) url += '.png';
    if (!editable && !url) return '';
    if (!editable && url) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "panel",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: url,
            alt: "entity portrait",
            className: "portrait"
        })
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "panel portraitpanel" + hasImage,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
            onClick: ()=>(0, $de911c4aad4e62e0$export$2e2bcd8739ae039)(entity, sendMessage),
            children: [
                url && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    alt: "entity portrait",
                    src: url,
                    className: "portrait"
                }),
                !url && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    title: "Change Image Url",
                    children: "\uD83D\uDCF8"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                "Change Image Url"
            ]
        })
    });
}




var $bh6RR = parcelRequire("bh6RR");
function $09f353560cb4ffa2$var$setDescription(e, sendMessage) {
    let entityid = e.target.dataset.entityid;
    console.log(entityid);
    let description = e.target.value;
    sendMessage({
        operation: 'set entity description',
        entityid: entityid,
        description: description
    });
}
function $09f353560cb4ffa2$var$setNotes(e, sendMessage) {
    let entityid = e.target.dataset.entityid;
    let notes = e.target.value;
    sendMessage({
        operation: 'set entity notes',
        entityid: entityid,
        notes: notes
    });
}
function $09f353560cb4ffa2$export$2e2bcd8739ae039(props) {
    // let [checkedTag, setCheckedTag] = useState('');
    let entity = props.entity;
    let editable = entity.editable;
    let sendMessage = props.sendMessage;
    // let doc = props.doc;
    // let userNotesId = doc._id + "_" + entity._id;
    // let openModal = props.openModal;
    // let closeModal = props.closeModal;
    // let state = props.state;
    let noprint = !entity.notes && !entity.description ? ' noprint' : '';
    (0, $bh6RR.useEffect)(()=>{
        let noteFields = document.getElementsByClassName('notes');
        Array.from(noteFields).forEach((field)=>{
            field.style.height = 'auto';
            field.style.height = field.scrollHeight + 3 + "px";
            field.addEventListener('input', (e)=>{
                e.target.style.height = 'auto';
                e.target.style.height = e.target.scrollHeight + 3 + "px";
            });
        });
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: 'panel infopanel' + noprint,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                children: "Description"
            }),
            editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("textarea", {
                className: "notes",
                defaultValue: entity.description,
                onBlur: (e)=>$09f353560cb4ffa2$var$setDescription(e, sendMessage),
                "data-entityid": entity._id
            }, "description"),
            !editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: entity.description
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                children: "Entity Notes"
            }),
            editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("textarea", {
                className: "notes",
                defaultValue: entity.notes,
                onBlur: (e)=>$09f353560cb4ffa2$var$setNotes(e, sendMessage),
                "data-entityid": entity._id
            }, "notes"),
            !editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: entity.notes
            })
        ]
    });
}


class $d240eace9648c3d7$var$EntityEditTab extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            id: this.props.match.params.EntityId
        };
    }
    openModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: true
        });
    };
    closeModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: false
        });
    };
    changeName = (id, name)=>{
        let entityid = id;
        let value = name;
        this.props.sendMessage({
            operation: 'change entity name',
            entityid: entityid,
            value: value
        });
    };
    render() {
        // console.log('render')
        const entity = this.props.doc.entities?.find((x)=>x._id === this.state.id);
        if (!entity) return 'Searching for entity: ' + this.state.id;
        document.title = [
            entity.name,
            this.props.doc.name,
            'SGS'
        ].join(' - ');
        // console.log('aspects', entity.aspects)
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "EntityEditTab",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $aa0be55d5669d56e$export$2e2bcd8739ae039), {
                    doc: this.props.doc,
                    entity: entity,
                    openModal: this.openModal,
                    closeModal: this.closeModal,
                    changeName: this.changeName,
                    state: this.state,
                    sendMessage: this.props.sendMessage
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d9c3e74b1c820fa$export$2e2bcd8739ae039), {
                    entity: entity,
                    sendMessage: this.props.sendMessage
                }),
                !this.props.doc?.options?.disableAspects && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "panel aspectspanel",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5df81a6b18f4f72a$export$2e2bcd8739ae039), {
                            doc: this.props.doc,
                            entity: entity,
                            group: "aspects",
                            singular: "aspect",
                            openModal: this.openModal,
                            closeModal: this.closeModal,
                            sendMessage: this.props.sendMessage
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5df81a6b18f4f72a$export$2e2bcd8739ae039), {
                            doc: this.props.doc,
                            entity: entity,
                            group: "flaws",
                            singular: "flaw",
                            openModal: this.openModal,
                            closeModal: this.closeModal,
                            sendMessage: this.props.sendMessage
                        })
                    ]
                }),
                (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).groups.map((groupName)=>{
                    if (this.props.doc[groupName]?.length === 0) return '';
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4112654b9b1a385$export$2e2bcd8739ae039), {
                        doc: this.props.doc,
                        entity: entity,
                        groupName: groupName,
                        sendMessage: this.props.sendMessage
                    }, groupName);
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ba441cc1366075a1$export$2e2bcd8739ae039), {
                    doc: this.props.doc,
                    entity: entity,
                    openModal: this.openModal,
                    closeModal: this.closeModal,
                    sendMessage: this.props.sendMessage,
                    state: this.state
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $abe8d7886d902c6a$export$2e2bcd8739ae039), {
                    doc: this.props.doc,
                    entity: entity
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $09f353560cb4ffa2$export$2e2bcd8739ae039), {
                    doc: this.props.doc,
                    entity: entity,
                    // openModal={this.openModal}
                    // closeModal={this.closeModal}
                    sendMessage: this.props.sendMessage
                })
            ]
        }, entity._id);
    }
}
var $d240eace9648c3d7$export$2e2bcd8739ae039 = $d240eace9648c3d7$var$EntityEditTab;





var $bh6RR = parcelRequire("bh6RR");



class $72da5c55c7d96c3f$var$EditorsSection extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            addUserModal: false,
            removeModal: false
        };
    }
    confirmRemoveEditor = (editor)=>{
        if (!window.confirm('Do you really want to remove ' + editor.username + ' from this doc?')) return;
        this.removeEditor(editor._id);
    };
    removeEditor = (editorid)=>{
        this.props.sendMessage({
            operation: 'remove doc editor',
            docid: this.props.doc._id,
            editorid: editorid
        });
    };
    openModal = ()=>{
        this.setState({
            addUserModal: true
        });
    };
    addEditor = (user)=>{
        // console.log('add ' + user._id);
        this.props.sendMessage({
            operation: 'add doc editor',
            docid: this.props.doc._id,
            editorid: user._id
        });
    };
    closeModal = ()=>{
        this.setState({
            addUserModal: false
        });
    };
    render() {
        let doc = this.props.doc;
        // console.log(doc.editors);
        let canEditUsers = !!this.props.doc.owner && !!(0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user._id && this.props.doc.owner?._id === (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject()?.user._id;
        // console.log(doc?.owner);
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                    children: "Doc Owner"
                }),
                !!doc?.owner && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cc31eba22f67b38$export$2e2bcd8739ae039), {
                    user: doc?.owner
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                    children: "Doc Editors"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                    children: [
                        doc?.editors?.map((editor)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cc31eba22f67b38$export$2e2bcd8739ae039), {
                                        user: editor
                                    }, editor._id),
                                    canEditUsers && this.state.removeModal && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        className: "delete",
                                        onClick: ()=>this.confirmRemoveEditor(editor),
                                        children: "x"
                                    })
                                ]
                            }, editor._id);
                        }),
                        canEditUsers && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                onClick: this.openModal,
                                children: "Add an Editor"
                            })
                        }),
                        canEditUsers && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                onClick: ()=>this.setState({
                                        removeModal: !this.state.removeModal
                                    }),
                                children: "Remove an Editor"
                            })
                        })
                    ]
                }),
                canEditUsers && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $90c4322eecedc6d4$export$2e2bcd8739ae039), {
                    closeModal: this.closeModal,
                    addUser: this.addEditor,
                    doc: doc,
                    state: this.state,
                    setState: this.setState
                })
            ]
        });
    }
}
var $72da5c55c7d96c3f$export$2e2bcd8739ae039 = $72da5c55c7d96c3f$var$EditorsSection;




var $bh6RR = parcelRequire("bh6RR");
class $60372699c4262070$var$DocEditSection extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {};
    }
    listDoc = ()=>{
        this.props.sendMessage({
            operation: 'set state',
            stateName: 'unlisted',
            stateValue: 'false'
        });
    };
    unlistDoc = ()=>{
        this.props.sendMessage({
            operation: 'set state',
            stateName: 'unlisted',
            stateValue: 'true'
        });
    };
    trashDoc = ()=>{
        this.props.sendMessage({
            operation: 'set state',
            stateName: 'trashed',
            stateValue: 'true'
        });
    };
    untrashDoc = ()=>{
        this.props.sendMessage({
            operation: 'set state',
            stateName: 'trashed',
            stateValue: 'false'
        });
    };
    changeDocType = (e)=>{
        let docType = e.target.value;
        console.log(docType);
        this.props.sendMessage({
            operation: 'set doc type',
            docType: docType
        });
    };
    render() {
        let doc = this.props.doc;
        document.title = [
            'Edit Doc',
            doc.name,
            'SGS'
        ].join(' - ');
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                    children: "Edit Doc"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            children: [
                                !doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                    children: [
                                        "Doc Type: ",
                                        doc.type
                                    ]
                                }),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                    className: "transparent",
                                    children: [
                                        "Doc Type:",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                                            value: doc.type,
                                            onChange: this.changeDocType,
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    children: "draft"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    children: "game"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    children: "mod"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    children: "list"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    children: "gm"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    children: "player"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    children: "campaign"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        doc.unlisted && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            children: [
                                "doc is unlisted.",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    onClick: this.listDoc,
                                    children: "list doc"
                                })
                            ]
                        }),
                        !doc.unlisted && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            children: [
                                "doc is publicly listed.",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    onClick: this.unlistDoc,
                                    children: "unlist doc"
                                })
                            ]
                        }),
                        !doc.trashed && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            children: [
                                "doc is not in the trash.",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    onClick: this.trashDoc,
                                    children: "trash doc"
                                })
                            ]
                        }),
                        doc.trashed && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            children: [
                                "doc is in the trash.",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    onClick: this.untrashDoc,
                                    children: "untrash doc"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
var $60372699c4262070$export$2e2bcd8739ae039 = $60372699c4262070$var$DocEditSection;




var $bh6RR = parcelRequire("bh6RR");


class $311a0706fa98776a$var$RelationshipsSection extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            addDocModal: false,
            removeParentModal: false
        };
    }
    removeParentDoc = (doc)=>{
        console.log('removeParentDoc', doc);
        this.props.sendMessage({
            operation: 'remove dependency',
            target: doc._id,
            targetName: doc.name
        });
        // console.log('RPD 2');
        this.setState({
            removeParentModal: false
        });
    // console.log('RPD 3');
    };
    confirmRemoveParentDoc = (doc)=>{
        console.log('confirmRemoveParent');
        if (!window.confirm('Do you really want to remove the dependency ' + doc.name + ' from this doc?')) return;
        // console.log('remove doc ' + doc._id);
        this.removeParentDoc(doc);
    };
    addParentDoc = (doc)=>{
        console.log('add' + doc._id);
        // let id = doc._id;
        this.props.sendMessage({
            operation: 'add dependency',
            target: doc._id,
            targetName: doc.name
        });
        this.setState({
            removeParentModal: false
        });
    };
    openModal = (e)=>{
        let target = e.target.dataset.target;
        this.setState({
            [target]: true
        });
    };
    closeModal = ()=>{
        this.setState({
            addDocModal: false,
            removeParentModal: false
        });
    };
    toggleaddDocModal = ()=>{
        this.setState({
            addDocModal: !this.state.addDocModal
        });
    };
    toggleRemoveMode = ()=>{
        this.setState({
            removeParentModal: !this.state.removeParentModal
        });
    };
    render() {
        // let doc = this.props.doc;
        // console.log(doc?.dependencies);
        const doc = this.props.doc;
        const children = this.props.children;
        const campaigns = this.props.campaigns;
        // console.log(campaigns);
        // console.log(children);
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                    children: "Parent Docs"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                    children: [
                        doc?.dependencies?.map((dep)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("a", {
                                        href: '/doc/' + dep._id,
                                        children: [
                                            (0, $920954e343704e08$exports.capitalize)(dep.type),
                                            ": ",
                                            dep.name
                                        ]
                                    }),
                                    "\xa0",
                                    this.state.removeParentModal && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        className: "delete",
                                        onClick: ()=>this.confirmRemoveParentDoc(dep),
                                        children: "x"
                                    })
                                ]
                            }, dep._id);
                        }),
                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                onClick: this.toggleaddDocModal,
                                children: "Add Parent Doc"
                            })
                        }),
                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                onClick: this.toggleRemoveMode,
                                children: "Remove a Parent Doc"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                    children: "Child Docs"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                    children: [
                        children?.map((child)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("a", {
                                    href: '/doc/' + child._id,
                                    children: [
                                        (0, $920954e343704e08$exports.capitalize)(child.type),
                                        ": ",
                                        child.name
                                    ]
                                })
                            }, child._id);
                        }),
                        (!children || children.length === 0) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            children: "none"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                    children: "Campaigns"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                    children: [
                        campaigns?.map((campaign)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                    href: '/campaign/' + campaign._id,
                                    children: campaign.name
                                })
                            }, campaign._id);
                        }),
                        (!campaigns || campaigns.length === 0) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            children: "none"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b1842d6e2b218b23$export$2e2bcd8739ae039), {
                    addParentDoc: this.addParentDoc,
                    doc: doc,
                    state: this.state,
                    setState: this.setState,
                    closeModal: this.closeModal
                })
            ]
        });
    }
}
var $311a0706fa98776a$export$2e2bcd8739ae039 = $311a0706fa98776a$var$RelationshipsSection;




var $bh6RR = parcelRequire("bh6RR");

class $81f9b8bf49c80071$var$TagSection extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    addTag = (tag)=>{
        let id = this.props.doc._id;
        // console.log(tag);
        this.props.sendMessage({
            operation: 'add doc tag',
            id: id,
            tag: tag
        });
    };
    removeTag = (tag)=>{
        let id = this.props.doc._id;
        console.log(tag);
        this.props.sendMessage({
            operation: 'remove doc tag',
            id: id,
            tag: tag
        });
    };
    render() {
        const doc = this.props.doc;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                    children: "Doc Tags"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3f0e235e8472ecaa$export$2e2bcd8739ae039), {
                    tags: doc?.tags,
                    addTag: this.addTag,
                    removeTag: this.removeTag,
                    doc: this.props.doc
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                    children: "Entity Tags"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                    children: [
                        doc?.entityTags?.map((tag)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                children: [
                                    "#",
                                    tag
                                ]
                            }, tag);
                        }),
                        (!doc?.entityTags || doc?.entityTags.length === 0) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            children: "none"
                        })
                    ]
                })
            ]
        });
    }
}
var $81f9b8bf49c80071$export$2e2bcd8739ae039 = $81f9b8bf49c80071$var$TagSection;




var $bh6RR = parcelRequire("bh6RR");


class $44b892c1055b4ccb$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            show: false
        };
    }
    render() {
        let doc = this.props.doc;
        let apiKey = this.props.apiKey;
        let RegenerateApiKey = this.props.RegenerateApiKey;
        let RemoveApiKey = this.props.RemoveApiKey;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "api",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h3", {
                    children: [
                        !doc.unlisted ? 'Public' : 'Private',
                        " Api"
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                    children: "This is your document's API key. Use it when creating API calls for build processes."
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                    children: "The API key allows you to download any set of filtered data from the server, already processed through the SGS calculator. Read below for usage instructions."
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                    children: [
                        "Be aware that API access to this document is ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                            children: !doc.unlisted ? 'public' : 'private'
                        }),
                        ". To change the privacy of the API, change the doc's listing status above."
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("blockquote", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                            children: "Private Api Key: the key is hidden on this page to everyone who is not a document editor or owner."
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                            children: "Public Api Key: the key is not hidden. Anyone can see the key and use it to get the entire document."
                        })
                    ]
                }),
                !apiKey && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                            children: "This doc doesn't have an API Key. Press the button to generate one."
                        }),
                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            onClick: RegenerateApiKey,
                            children: "Generate Api Key"
                        })
                    ]
                }),
                apiKey && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                    children: [
                        !this.state.show && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                            type: "password",
                            value: apiKey,
                            readOnly: true
                        }),
                        this.state.show && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                            type: "text",
                            value: apiKey,
                            onBlur: ()=>{
                                this.setState({
                                    show: false
                                });
                            },
                            readOnly: true
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            onClick: ()=>{
                                this.setState({
                                    show: !this.state.show
                                });
                            },
                            children: "\uD83D\uDC41"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            onClick: ()=>{
                                navigator.clipboard.writeText(apiKey);
                            },
                            children: "Copy"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                            children: "Edit Key"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                            children: "If your API key has been compromised, hit regenerate to get a new one and invalidate the old one."
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                            children: "You will need to update any build scripts or environment variables that use the old API key."
                        }),
                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            onClick: RegenerateApiKey,
                            children: "Regenerate"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                            children: "You may also remove your API key, thus preventing anyone from accessing this doc through the Build API system."
                        }),
                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            onClick: RemoveApiKey,
                            children: "Remove API Key"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {})
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                    children: "API Usage"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                    children: "The build API allows you to sort, filter, and format the data of your document from a single HTML POST call over HTTPS."
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                    children: "Here's an example API call:"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("code", {
                    className: "block",
                    children: "https://sgs-web.herokuapp.com/api/build?docid=60f33bc010dfb3517c9db6ce&key=b5a8a7ec-a824-4b23-af13-2c2285279de9&content=statblocks&format=json&sort=xp&whitelisttags=monster,item&blacklisttags=incomplete,pc&whitelistentities=cloud,squall&blacklistentities=kevin,bob"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h4", {
                    children: "Fields"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            children: [
                                "request type: ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("code", {
                                    children: "POST"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            children: [
                                "docId: the ID of this doc, ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("code", {
                                    children: doc._id
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            children: "key: the above API Key"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            children: [
                                "contentFormat: ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("code", {
                                    children: "json | markdown | html"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            children: [
                                "contentType: ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("code", {
                                    children: "statBlocks | entityCards | itemTable | rules"
                                }),
                                ".",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                "The content type is only used with the markdown and html formats.",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                "With json, you're expected to do the processing/formatting yourself when you consume the data."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            children: "whitelistTags: only include entities with these tags. Comma separated, no spaces."
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            children: "blacklistTags: exclude entities with these tags. Comma separated, no spaces."
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            children: "includeEntities: only include these entities. Comma separated, no spaces."
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            children: "excludeEntities: exclude these entitites. Comma separated, no spaces."
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            children: [
                                "sortBy: ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("code", {
                                    children: "xp | xpReversed | name | tags"
                                }),
                                ". Changes the order of output entities."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                            children: "Note:"
                        }),
                        " You can construct API calls in the ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                            to: '/doc/' + doc._id + '/Print',
                            children: "Print Tab"
                        }),
                        " and then click the button to copy the API call. This will let you preview the content before you make the call."
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {})
            ]
        });
    }
}



const $049d8a57e9aefb61$var$SendReconcileMessage = (sendMessage, doc)=>{
    console.log('send reconcile');
    sendMessage({
        operation: 'reconcile document'
    });
};
function $049d8a57e9aefb61$export$2e2bcd8739ae039(props) {
    let sendMessage = props.sendMessage;
    let doc = props.doc;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                children: "Document Reconciliation"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: "In the course of building and upgrading the app, we've changed some things that may have altered how the document's data is used. Reconciliation forces the app to automatically update everything that can be done without user input. Warning characters (\u26A0\uFE0F) indicate elements that the system couldn't figure out by itself. You will need to manually update or re-apply these elements yourself."
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                        children: "Note:"
                    }),
                    " This may take a moment to process on the server, during which the app will not change. Please be patient."
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                onClick: ()=>$049d8a57e9aefb61$var$SendReconcileMessage(sendMessage, doc),
                children: "Reconcile Document Data"
            })
        ]
    });
}


function $f00ac48bfdebdc7f$export$2e2bcd8739ae039(props) {
    let doc = props.doc;
    let docId = doc._id;
    let sendMessage = props.sendMessage;
    let children = props.children;
    let campaigns = props.campaigns;
    let apiKey = props.apiKey;
    let RegenerateApiKey = props.RegenerateApiKey;
    let RemoveApiKey = props.RemoveApiKey;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $72da5c55c7d96c3f$export$2e2bcd8739ae039), {
                sendMessage: sendMessage,
                doc: doc
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $60372699c4262070$export$2e2bcd8739ae039), {
                sendMessage: sendMessage,
                doc: doc
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $311a0706fa98776a$export$2e2bcd8739ae039), {
                sendMessage: sendMessage,
                doc: doc,
                children: children,
                campaigns: campaigns
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $81f9b8bf49c80071$export$2e2bcd8739ae039), {
                sendMessage: sendMessage,
                doc: doc
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $049d8a57e9aefb61$export$2e2bcd8739ae039), {
                sendMessage: sendMessage,
                doc: doc
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $44b892c1055b4ccb$export$2e2bcd8739ae039), {
                docId: docId,
                doc: doc,
                apiKey: apiKey,
                RegenerateApiKey: RegenerateApiKey,
                RemoveApiKey: RemoveApiKey
            })
        ]
    });
}




var $bh6RR = parcelRequire("bh6RR");




// import { capitalize } from '../../TextUtils';
// import Sgs from 'sgs';










function $bbc34fb3a5042e83$export$2e2bcd8739ae039(doc, options, format) {
    let entities = (0, $79f4077e96527e61$export$2e2bcd8739ae039)(options, doc.entities);
    entities = (0, $56801cf1bcc15de3$export$2e2bcd8739ae039)(options, entities);
    let prototypes = (0, $db4bc0fdc611a9d4$export$2e2bcd8739ae039)(doc);
    if (!prototypes) return '';
    if (!entities) return '';
    let output = '';
    entities.forEach((entity)=>{
        output += $bbc34fb3a5042e83$var$entityCard(entity, doc, prototypes, format);
    });
    return output;
}
const $bbc34fb3a5042e83$var$sep = (format, char)=>{
    return (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'comma') + char + ' ' + format.span.suf;
};
const $bbc34fb3a5042e83$var$entityCard = (entity, doc, prototypes, format)=>{
    // console.log(entity.name);
    let output = '';
    output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.card.pre, [
        entity.name,
        ...entity.tags,
        ...entity.limitations.map((x)=>x.name)
    ]);
    output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.h5.pre, 'name');
    output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'name');
    output += entity.name;
    output += format.span.suf;
    output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'xp');
    output += ' (' + entity.xp.toLocaleString() + 'xp)';
    output += format.span.suf;
    output += format.h5.suf;
    if (entity.limitations.length > 0) {
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.p.pre, 'limits');
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'title');
        output += format.bold.pre;
        output += 'Limits: ';
        output += format.bold.suf;
        output += format.span.suf;
        output += entity.limitations.map((limit)=>{
            let o = '';
            o += limit.name;
            o += ' (' + (0, $98d37b25b54ca0ea$export$2e2bcd8739ae039)(limit.multiplier) + ')';
            if (!!limit.notes) o += ' ' + limit.notes;
            return (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'limit') + o + format.span.suf;
        }).join((0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'comma') + ', ' + format.span.suf);
        output += format.p.suf;
    }
    if (entity.tags.length > 0) {
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.p.pre, 'tags');
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'title');
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'tag-header');
        output += format.bold.pre;
        output += 'Tags: ';
        output += format.bold.suf;
        output += format.span.suf;
        output += format.span.suf;
        output += entity.tags.map((x)=>(0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, [
                'tag',
                x
            ]) + x + format.span.suf).join($bbc34fb3a5042e83$var$sep(format, ','));
        output += format.p.suf;
    }
    if (entity.aspects.length > 0) {
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.p.pre, 'aspects');
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'title');
        output += format.bold.pre;
        output += 'Aspects: ';
        output += format.bold.suf;
        output += format.span.suf;
        output += entity.aspects.map((x)=>(0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'aspect') + x + format.span.suf).join($bbc34fb3a5042e83$var$sep(format, ','));
        output += format.p.suf;
    }
    if (entity.flaws.length > 0) {
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.p.pre, 'flaws');
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'title');
        output += format.bold.pre;
        output += 'Flaws: ';
        output += format.bold.suf;
        output += format.span.suf;
        output += entity.flaws.map((x)=>(0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'aspect') + x + format.span.suf).join($bbc34fb3a5042e83$var$sep(format, ','));
        output += format.p.suf;
    }
    // output += format.line.pre;
    (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).groups.forEach((group)=>{
        if (entity[group].length === 0) return;
        // entity[group].forEach(x => {if(!x.prototype) {
        //     console.log(group, x)
        // }});
        let shown = entity[group].filter((x)=>!!x.prototype && (!x.prototype.displayVisibility || x.prototype.displayVisibility === 'owners'));
        if (shown.length === 0 && entity.items.length > 0) return;
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.p.pre, [
            group,
            'section'
        ]);
        output += format.bold.pre;
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'title');
        output += (0, $920954e343704e08$exports.capitalize)(group);
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'colon');
        output += ':';
        output += format.span.suf;
        output += format.span.suf;
        if (group === 'thresholds' && !!doc.tracks && doc.tracks.length > 0) output += (0, $a0793168e786c181$export$2e2bcd8739ae039)(doc, format, entity, group, (0, $0f869b45f2f8c029$export$2e2bcd8739ae039));
        else {
            output += format.bold.suf;
            output += ' ';
            let prototypes = doc[group];
            output += prototypes.filter((proto)=>entity[group].map((x)=>x.name).includes(proto.name)).map((prototype)=>{
                let stat = entity[group].find((x)=>x.name === prototype.name);
                let o = '';
                o += stat.name + ' ';
                if (!!stat.skillGroup) o += '(' + stat.skillGroup + ') ';
                if (stat.dieSize !== 'none') o += '1' + stat.dieSize;
                if (!!stat.dicePool) o += stat.dicePool;
                if (stat.valueType === 'formula') o += stat.calculated;
                if (stat.valueType === 'number') {
                    let skillStatName = prototype?.skillStat;
                    if (!!skillStatName) {
                        let skillStat = entity.primaries.find((primary)=>primary.name === skillStatName);
                        if (!!skillStat) o += (0, $19cfbde689462999$export$2e2bcd8739ae039)(stat.number + skillStat.number, group, stat);
                        else o += (0, $19cfbde689462999$export$2e2bcd8739ae039)(stat.number, group, stat);
                    } else o += (0, $19cfbde689462999$export$2e2bcd8739ae039)(stat.number, group, stat);
                }
                o = (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, [
                    'stat',
                    prototype.name
                ]) + o + format.span.suf;
                return o;
            }).join($bbc34fb3a5042e83$var$sep(format, ','));
            output += $bbc34fb3a5042e83$var$sep(format, '.');
        }
        output += format.p.suf;
    });
    if (entity.items.length !== 0) // output += 'Equipment\n';
    entity.items.forEach((item)=>{
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.p.pre, [
            'item section',
            item.name,
            ...item.tags,
            ...entity.limitations.map((x)=>x.name)
        ]);
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'title');
        output += format.bold.pre;
        output += item.name;
        output += format.bold.suf;
        output += format.span.suf;
        output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'xp');
        output += ' (' + item.xp + 'xp) ';
        output += format.span.suf;
        if (item.limitations.length > 0) {
            output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'limits');
            output += 'Limits: ';
            output += item.limitations.map((limit)=>{
                let o = limit.name;
                if (limit.note) o += ' ' + limit.note;
                return o;
            }).join($bbc34fb3a5042e83$var$sep(format, ','));
            output += $bbc34fb3a5042e83$var$sep(format, '.');
            output += format.span.suf;
        }
        if (item.aspects.length > 0) {
            output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'aspects');
            output += 'Aspects: ' + item.aspects.map((x)=>(0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'aspect') + x + format.span.suf).join($bbc34fb3a5042e83$var$sep(format, ','));
            output += format.span.suf;
            output += $bbc34fb3a5042e83$var$sep(format, '.');
        }
        if (item.flaws.length > 0) {
            output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'flaws');
            output += 'Flaws: ' + item.flaws.map((x)=>(0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'flaw') + x + format.span.suf).join($bbc34fb3a5042e83$var$sep(format, ','));
            output += format.span.suf;
            output += $bbc34fb3a5042e83$var$sep(format, '.');
        }
        (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).groups.forEach((group)=>{
            if (item[group].length === 0) return;
            // output += capitalize(group) + ': ';
            output += (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)(format.span.pre, 'item-stats');
            output += (0, $b3d45acacf80454e$export$2e2bcd8739ae039)(doc, entity, group, item, true, format, (0, $0f869b45f2f8c029$export$2e2bcd8739ae039)).join($bbc34fb3a5042e83$var$sep(format, ','));
            output += format.span.suf;
            output += $bbc34fb3a5042e83$var$sep(format, '.');
        });
        output += format.p.suf;
    });
    output += format.card.suf;
    return output;
};


// import { capitalize } from '../../TextUtils';
// import Sgs from 'sgs';




function $ebc47c6262812840$export$2e2bcd8739ae039(doc, options, format) {
    let cols = [
        {
            title: 'Name',
            align: ':-',
            content: (e)=>e.name
        },
        {
            title: 'XP',
            align: '-:',
            content: (e)=>e.xp.toLocaleString()
        },
        {
            title: 'Tags',
            align: '-',
            content: (e)=>e.tags?.sort().join(', ')
        },
        {
            title: 'Limits, Aspects, & Flaws',
            align: '-',
            content: (e)=>{
                let limits = e.limitations?.map((l)=>{
                    let lim = "\uD83D\uDEC7 " + l.name + ' ' + (0, $98d37b25b54ca0ea$export$2e2bcd8739ae039)(l.multiplier);
                    if (!!l.notes) lim += ' (' + l.notes + ')';
                    return lim;
                });
                let aspects = e.aspects.map((a)=>"\u25B2 " + a);
                let flaws = e.flaws.map((a)=>"\u25BC " + a);
                return limits.concat(aspects).concat(flaws).join(', ');
            }
        },
        {
            title: 'Tacticals',
            align: '-',
            content: (e)=>{
                return e.tacticals.map((stat)=>{
                    let value = '';
                    switch(stat.valueType.toLowerCase()){
                        case 'number':
                            value = stat.number;
                            break;
                        case 'diesize':
                            value = stat.dieSize;
                            break;
                        case 'dicepool':
                            value = stat.dicePool;
                            break;
                        case 'formula':
                            value = stat.calculated;
                            break;
                        default:
                            break;
                    }
                    return stat.name + ": " + (0, $19cfbde689462999$export$2e2bcd8739ae039)(value, 'tacticals', stat);
                }).join(', ');
            }
        },
        {
            title: 'Skills',
            align: '-',
            content: (e)=>{
                return e.skills.map((stat)=>{
                    let value = '';
                    switch(stat.valueType.toLowerCase()){
                        case 'number':
                            value = stat.number;
                            break;
                        case 'diesize':
                            value = stat.dieSize;
                            break;
                        case 'dicepool':
                            value = stat.dicePool;
                            break;
                        case 'formula':
                            value = stat.calculated;
                            break;
                        default:
                            break;
                    }
                    return stat.name + ": " + (0, $19cfbde689462999$export$2e2bcd8739ae039)(value, 'skills', stat);
                }).join(', ');
            }
        }
    ];
    let entities = (0, $79f4077e96527e61$export$2e2bcd8739ae039)(options, doc.entities);
    entities = (0, $56801cf1bcc15de3$export$2e2bcd8739ae039)(options, entities);
    let output = '';
    output += format.table.pre;
    output += format.thead.pre;
    output += format.tr.pre;
    cols.forEach((col)=>{
        output += format.td.pre;
        output += col.title;
        output += format.td.suf;
    });
    output += format.tr.suf;
    output += format.thead.suf;
    if (options.contentFormat === 'Markdown') {
        output += format.tr.pre;
        cols.forEach((col)=>{
            output += format.td.pre;
            output += col.align;
            output += format.td.suf;
        });
        output += format.tr.suf;
    }
    output += format.tbody.pre;
    entities?.forEach((entity)=>{
        output += format.tr.pre;
        cols.forEach((col)=>{
            output += format.td.pre;
            output += col.content(entity);
            output += format.td.suf;
        });
        output += format.tr.suf;
    });
    output += format.tbody.suf;
    output += format.table.suf;
    return output;
}





function $b15e485f6d0969ee$export$2e2bcd8739ae039(stat, format, group) {
    let output = '';
    if (stat.valueType !== 'formula') {
        output += format.li.pre;
        output += 'XP Cost: ';
        output += format.code.pre;
        if (stat.valueType === 'number') {
            output += '(stat value';
            if (stat.offset !== 0) {
                output += ' ';
                output += stat.offset > 0 ? '+' : '';
                output += stat.offset;
            }
            output += ")\xb2";
        } else if (stat.valueType === 'dieSize') output += "(die size / 2, rounded up)\xb2";
        else if (stat.valueType === 'dicePool') output += "(pool average, rounded up)\xb2";
        if (group === 'primaries') output += " \xd7 2";
        output += format.code.suf;
        output += format.li.suf;
    }
    if (stat.valueType === 'formula') {
        output += format.li.pre;
        output += 'XP Cost: ';
        output += format.code.pre;
        output += 'free';
        output += format.code.suf;
        output += format.li.suf;
    }
    return output;
}



function $64fe69f93e9ba494$export$2e2bcd8739ae039(doc, options, format) {
    let output = '';
    output += format.h1.pre;
    output += doc.name;
    output += ' ';
    output += (0, $920954e343704e08$exports.capitalize)(doc.type);
    output += ' Rules';
    output += format.h1.suf;
    (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).groups.forEach((group)=>{
        output += format.h2.pre;
        output += (0, $920954e343704e08$exports.capitalize)(group);
        output += format.h2.suf;
        output += format.ul.pre;
        if (group !== 'skills') doc[group]?.sort((a, b)=>{
            return a.skillGroup > b.skillGroup;
        }).forEach((stat)=>{
            output += format.p.pre;
            output += format.bold.pre;
            output += stat.name;
            output += format.bold.suf;
            output += format.p.suf;
            output += format.ul.pre;
            output += format.li.pre;
            output += 'Type: ' + stat.valueType;
            output += format.li.suf;
            if (group === 'primaries') {
                let skills = doc?.skills?.filter((x)=>x.skillStat?.toLowerCase() === stat.name.toLowerCase());
                output += format.li.pre;
                output += 'Skills: ';
                output += skills.length;
                output += format.li.suf;
            }
            if (stat.offset !== 0) {
                output += format.li.pre;
                output += 'Offset: ' + stat.offset;
                output += format.li.suf;
            }
            if (!!stat.formula) {
                output += format.li.pre;
                output += 'Formula: ';
                output += format.code.pre;
                output += stat.formulaText;
                output += format.code.suf;
                output += format.li.suf;
            }
            if (!!stat.displayFormat) {
                output += format.li.pre;
                output += 'Display Format: ';
                output += format.code.pre;
                output += stat.displayFormat;
                output += format.code.suf;
                output += format.li.suf;
            }
            if (!!stat.displayVisibility) {
                output += format.li.pre;
                output += 'Display Visibility: ';
                output += stat.displayVisibility;
                output += format.li.suf;
            }
            output += (0, $b15e485f6d0969ee$export$2e2bcd8739ae039)(stat, format, group);
            output += format.ul.suf;
        });
        else {
            if (!doc.skills || doc.skills.length === 0) return;
            let skills = doc.skills.sort((a, b)=>{
                if (a.name > b.name) return 1;
                if (a.name < b.name) return -1;
                return 0;
            });
            doc.skillGroups.forEach((groupName)=>{
                output += format.h3.pre;
                output += (0, $920954e343704e08$exports.capitalize)(groupName);
                output += format.h3.suf;
                skills.forEach((skill)=>{
                    if (skill.skillGroup.toLowerCase() !== groupName.toLowerCase()) return;
                    output += format.p.pre;
                    output += format.bold.pre;
                    output += skill.name;
                    output += format.bold.suf;
                    output += format.p.suf;
                    output += format.ul.pre;
                    if (!!skill.skillStat) {
                        output += format.li.pre;
                        output += 'Stat: ';
                        output += skill.skillStat;
                        output += format.li.suf;
                    }
                    if (!!skill.displayFormat) {
                        output += format.li.pre;
                        output += 'Display Format: ';
                        output += format.code.pre;
                        output += skill.displayFormat;
                        output += format.code.suf;
                        output += format.li.suf;
                    }
                    if (!!skill.displayVisibility) {
                        output += format.li.pre;
                        output += 'Display Visibility: ';
                        output += skill.displayVisibility;
                        output += format.li.suf;
                    }
                    output += (0, $b15e485f6d0969ee$export$2e2bcd8739ae039)(skill, format, 'skills');
                    output += format.ul.suf;
                });
            });
        }
        output += format.ul.suf;
    });
    output += format.h2.pre;
    if (doc.limitations && doc.limitations.length > 0) {
        output += 'Limits';
        output += format.h2.suf;
        output += format.ul.pre;
        doc.limitations.forEach((limit)=>{
            output += format.li.pre;
            output += limit.name;
            output += ': ';
            output += (0, $98d37b25b54ca0ea$export$2e2bcd8739ae039)(limit.multiplier);
            output += format.li.suf;
        });
        output += format.ul.suf;
    }
    return output;
}


// import addPlus from '../addPlus.js';



function $529efa84b5149afa$export$2e2bcd8739ae039(doc, options) {
    let entities = (0, $79f4077e96527e61$export$2e2bcd8739ae039)(options, doc.entities);
    entities = (0, $56801cf1bcc15de3$export$2e2bcd8739ae039)(options, entities);
    let prototypes = (0, $db4bc0fdc611a9d4$export$2e2bcd8739ae039)(doc);
    doc.entities = entities;
    // let groups = Sgs.groups;
    // groups.forEach(group => {
    //     doc[group]?.forEach(stat => {
    //         if(!!stat.formula) {
    //             stat.formula = null;
    //         }
    //     })
    // })
    doc.entities?.forEach((entity)=>{
        delete entity.editable;
    // groups.forEach(group => {
    //     entity[group]?.forEach(stat => {
    //         if(!!stat.formula) {
    //             stat.formula = null;
    //         }
    //     })
    // })
    // if(entity.items.length > 0) {
    //     entity.items = entity.items
    //     .filter(x => !!x)
    //     .map(x => x._id);
    // }
    });
    doc.prototypes = prototypes;
    return doc;
}



const $867288a7d6913326$var$MdFormat = {
    h1: {
        pre: "\n\n# ",
        suf: "\n"
    },
    h2: {
        pre: "\n\n## ",
        suf: "\n"
    },
    h3: {
        pre: "\n\n### ",
        suf: "\n"
    },
    h4: {
        pre: "\n\n#### ",
        suf: "\n"
    },
    h5: {
        pre: "\n\n##### ",
        suf: "\n"
    },
    h6: {
        pre: "\n\n###### ",
        suf: "\n"
    },
    ul: {
        pre: "",
        suf: ""
    },
    li: {
        pre: "\n- ",
        suf: ""
    },
    li2: {
        pre: "\n\t- ",
        suf: ""
    },
    table: {
        pre: "\n",
        suf: "\n"
    },
    thead: {
        pre: "",
        suf: ""
    },
    tbody: {
        pre: "",
        suf: ""
    },
    tr: {
        pre: "",
        suf: "|\n"
    },
    td: {
        pre: "|",
        suf: ""
    },
    th: {
        pre: "|",
        suf: ""
    },
    p: {
        pre: "\n",
        suf: ""
    },
    card: {
        pre: "\n<span class='card'>\n",
        suf: "\n\n</span>\n"
    },
    code: {
        pre: "`",
        suf: "`"
    },
    bold: {
        pre: "**",
        suf: "**"
    },
    italic: {
        pre: "*",
        suf: "*"
    },
    break: {
        pre: "\n\n",
        suf: ""
    },
    line: {
        pre: "\n---\n",
        suf: ""
    },
    wrap: {
        pre: "<wrap class='name'>",
        suf: "</wrap>"
    },
    span: {
        pre: "<span>",
        suf: "</span>"
    }
};
var $867288a7d6913326$export$2e2bcd8739ae039 = $867288a7d6913326$var$MdFormat;


const $e9abd01472524a63$var$generateOutput = (options, doc)=>{
    // console.log(doc)
    if (!doc) return "";
    if (Object.keys(doc).length === 0) return "";
    let format = (0, $712be45d7780c927$export$2e2bcd8739ae039);
    let contentFormat = options.contentformat?.toLowerCase() || options.contentFormat?.toLowerCase();
    if (contentFormat === 'markdown' || options.contentFormat === 'md') format = (0, $867288a7d6913326$export$2e2bcd8739ae039);
    else if (contentFormat === 'json') return (0, $529efa84b5149afa$export$2e2bcd8739ae039)(doc, options);
    let contentType = options.contenttype?.replace(' ', '').toLowerCase() || options.contentType?.replace(' ', '').toLowerCase();
    // console.log(contentType)
    switch(contentType){
        case 'entitycards':
            return (0, $bbc34fb3a5042e83$export$2e2bcd8739ae039)(doc, options, format);
        case 'itemtable':
            return (0, $ebc47c6262812840$export$2e2bcd8739ae039)(doc, options, format);
        case 'statblocks':
            return (0, $41374fe20d442493$export$2e2bcd8739ae039)(doc, options, format);
        case 'rules':
            return (0, $64fe69f93e9ba494$export$2e2bcd8739ae039)(doc, options, format);
        default:
            return 'incorrect content type: ' + contentType;
    }
};
var $e9abd01472524a63$export$2e2bcd8739ae039 = $e9abd01472524a63$var$generateOutput;



class $35e4f4a24e1e8d91$var$EditorsTab extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            output: ''
        };
    }
    fields = [
        'contentFormat',
        'contentType',
        'whitelistTags',
        'blacklistTags',
        'includeEntities',
        'excludeEntities',
        'sortBy'
    ];
    componentDidMount = ()=>{
        this.pushHistory();
    };
    generateHeadingUrl = (heading)=>{
        let url = heading.toLowerCase().replaceAll(' ', '-');
        return url;
    };
    subPath = ()=>{
        let printSettings = {};
        this.fields.forEach((field)=>{
            let value = '';
            if (!!document.getElementById(field)) value = document.getElementById(field).value;
            printSettings[field] = value;
        });
        // console.log(printSettings);
        let newSubpath = '?';
        this.fields.forEach((field)=>{
            newSubpath += field + '=' + printSettings[field] + '&';
        });
        newSubpath = newSubpath.substring(0, newSubpath.length - 1);
        return newSubpath;
    };
    pushHistory = ()=>{
        let newSubpath = this.subPath();
        // console.log(newSubpath);
        this.props.history.push(newSubpath);
    };
    copyToClipboard = (content)=>{
        navigator.clipboard.writeText(content).then(()=>{
            console.log("copied");
        }, ()=>{
            console.log("did not copy");
        });
    };
    GetApiCall = ()=>{
        let apiKey = this.props.apiKey;
        let newSubpath = encodeURI(this.subPath());
        // let path = "https://sgs-web.herokuapp.com/api/build";
        let path = "http://localhost:3000/api/build";
        path += newSubpath;
        path += "&docId=" + this.props.doc._id;
        path += "&key=" + apiKey;
        console.log(path);
        navigator.clipboard.writeText(newSubpath).then(()=>{
            console.log("copied");
        }, ()=>{
            console.log("did not copy");
        });
    };
    render() {
        let options = (0, (/*@__PURE__*/$parcel$interopDefault($d1ffd40e86b7fa1f$exports))).parse(this.props.location.search);
        // console.log(options);
        if (!options || Object.keys(options).length === 0) options = {
            contentFormat: 'HTML',
            contentType: 'Entity Cards',
            sortBy: 'Xp'
        };
        let doc = this.props.doc;
        let output = (0, $e9abd01472524a63$export$2e2bcd8739ae039)(options, doc);
        if (options.contentFormat === 'JSON') try {
            output = JSON.stringify(output, null, 2);
        } catch (e) {
            console.error(e);
        }
        // console.log(output)
        document.title = [
            'Print ' + options.contentFormat + ' ' + options.contentType,
            doc.name,
            'SGS'
        ].join(' - ');
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "printSettings",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                            children: "Print"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                    children: [
                                        "Content Format",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                                            id: "contentFormat",
                                            value: options.contentFormat,
                                            onChange: this.pushHistory,
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    children: "HTML"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    children: "Markdown"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    children: "JSON"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                    children: [
                                        "Content Type",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("select", {
                                            id: "contentType",
                                            value: options.contentType,
                                            onChange: this.pushHistory,
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    children: "Entity Cards"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    children: "Item Table"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    children: "Stat Blocks"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                    children: "Rules"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                options.contentType !== 'Rules' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                            children: [
                                                "Sort By:",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("select", {
                                                    id: "sortBy",
                                                    value: options.sortBy,
                                                    onChange: this.pushHistory,
                                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("optgroup", {
                                                        label: "Vitals",
                                                        children: [
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                                children: "Xp"
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                                children: "Xp Reversed"
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                                children: "Name"
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                                                children: "Tags"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                                            children: 'If the entity or tag name you\'re looking for has a comma in it, separate your list with a double comma: "Soldier, Veteran,, Soldier, Newbie". If you\'re only looking for one with a comma in it, end the line with a double comma: "Soldier, Veteran,," Alternatively, ensure there are no commas in your entity & tag names.'
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                            title: 'comma separated, no #, if your target contains a comma, separate with two commas: ",,"',
                                            children: [
                                                "Whitelist Tags:",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    id: "whitelistTags",
                                                    value: options.whitelistTags || '',
                                                    onChange: this.pushHistory,
                                                    placeholder: "monster, villain, npc"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                            title: 'comma separated, no #, if your target contains a comma, separate with two commas: ",,"',
                                            children: [
                                                "Blacklist Tags:",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    id: "blacklistTags",
                                                    value: options.blacklistTags || '',
                                                    onChange: this.pushHistory,
                                                    placeholder: "item, power"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            children: [
                                                "Tags: ",
                                                doc?.entityTags?.sort().join(', ')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                            title: 'comma separated, if your target contains a comma, separate with two commas: ",,"',
                                            children: [
                                                "Include Entities:",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    id: "includeEntities",
                                                    value: options.includeEntities || '',
                                                    onChange: this.pushHistory,
                                                    placeholder: "Cloud, Squall, Terra"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                            title: 'comma separated, if your target contains a comma, separate with two commas: ",,"',
                                            children: [
                                                "Exclude Entities:",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    id: "excludeEntities",
                                                    value: options.excludeEntities || '',
                                                    onChange: this.pushHistory,
                                                    placeholder: "super secret superweapon, edge case entity, kevin"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                            htmlFor: "name-toggle",
                                            children: [
                                                "Show Entity Names (",
                                                doc?.entities?.length,
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                            id: "name-toggle",
                                            type: "checkbox",
                                            defaultChecked: true
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "entity-name-list",
                                            children: [
                                                doc?.entities?.map((x)=>x.name).sort().join(', '),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {})
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            onClick: ()=>this.copyToClipboard(output),
                            children: "Copy All"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            onClick: ()=>window.print(),
                            children: "Print"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            onClick: this.GetApiCall,
                            children: "Copy API call"
                        })
                    ]
                }),
                options.contentFormat === 'Markdown' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("pre", {
                    id: "content-output",
                    children: output
                }),
                options.contentFormat === 'HTML' && output && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    id: "content-output",
                    className: options.contentType,
                    children: (0, $1b12927fbd2f3766$export$2e2bcd8739ae039)(output || "")
                }),
                options.contentFormat === 'JSON' && output && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    id: "content-output",
                    className: options.contentType + ' ' + options.contentFormat,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("pre", {
                        children: output
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $35e4f4a24e1e8d91$export$2e2bcd8739ae039 = (0, $14986c2201283622$export$369b6b2b30582e8e)($35e4f4a24e1e8d91$var$EditorsTab);



parcelRequire("bh6RR");

function $feb1a49769fae5e2$export$2e2bcd8739ae039(props) {
    // console.log(props.isModified);
    let states = {
        'noStatus': "\uD83D\uDCBE\u274C",
        'saved': "\uD83D\uDCBE\u2705",
        'unsaved': "\uD83D\uDCBE\u26A0\uFE0F"
    };
    let current = 'noStatus';
    if (props.dirty === false) current = 'saved';
    if (props.dirty === true) current = 'unsaved';
    let icon = states[current];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "docSave",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
            onClick: ()=>props.sendMessage({
                    operation: 'save doc'
                }),
            title: current + '\nNote: documents are automatically\nsaved on exit.',
            children: icon
        })
    });
}



//if you have another AudioContext class use that one, as some browsers have a limit
// var audioCtx = new (window.AudioContext || window.webkitAudioContext || window.audioContext);
// var audioCtx = window.AudioContext;
// var audioCtx = window.webkitAudioContext;
// var audioCtx = window.audioContext;
// var audioCtx;
//All arguments are optional:
//duration of the tone in milliseconds. Default is 500
//frequency of the tone in hertz. default is 440
//volume of the tone. Default is 1, off is 0.
//type of tone. Possible values are sine, square, sawtooth, triangle, and custom. Default is sine.
//callback to use on end of tone
function $e5d0ec51251be932$var$beep(duration, frequency, volume, type, callback) {
    var location = window.location.hostname;
    if (location !== 'localhost') return;
    var snd = new Audio("data:audio/wav;base64,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");
    snd.play();
}
var $e5d0ec51251be932$export$2e2bcd8739ae039 = $e5d0ec51251be932$var$beep;


const $865db2aeddff72c0$var$EDIT_MESSAGE_EVENT = 'editMessageEvent';
const $865db2aeddff72c0$var$CHANGE_PUBLISH_EVENT = 'changePublishEvent';
const $865db2aeddff72c0$var$INITIAL_PAYLOAD_EVENT = 'initialPayloadEvent';
class $865db2aeddff72c0$var$SocketDocEdit extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            doc: {},
            activeTab: 'RelationshipsTab',
            header: 'Docs',
            hlink: '/docs',
            validated: false,
            apiKey: false
        };
        this.docId = this.props.docId;
        this.socketRef = /*#__PURE__*/ (0, $bh6RR.createRef)();
    }
    componentDidMount() {
        // console.log("component did mount")
        const docId = this.docId;
        const connectionType = 'document';
        const hostname = window.location.hostname;
        const hostport = window.location.port;
        // console.log(hostname, hostport);
        if (hostname === "localhost") this.socketRef.current = (0, $88cc1e63c72b633d$export$841407ceb083bd74)("http://localhost:5000", {
            query: {
                docId: docId,
                connectionType: connectionType,
                token: (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenText()
            }
        });
        else this.socketRef.current = (0, $88cc1e63c72b633d$export$841407ceb083bd74)({
            query: {
                docId: docId,
                connectionType: connectionType,
                token: (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenText()
            }
        });
        // console.log(this.socketRef.current);
        // get document on initial connection
        this.socketRef.current.on($865db2aeddff72c0$var$INITIAL_PAYLOAD_EVENT, (message)=>{
            // beep(10, 440, 1, 'sawtooth')
            // console.log('initial', message);
            this.setState({
                doc: (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).calculateAllXp(message.doc, message.validated, this.state.doc, true),
                validated: message.validated
            }, this.determineType);
        });
        // listens for incoming messages
        this.socketRef.current.on($865db2aeddff72c0$var$CHANGE_PUBLISH_EVENT, (message)=>{
            // beep(10, 440, 1, 'sawtooth')
            // console.log('change', message);
            // console.log('deps', message.doc.dependencies)
            // console.log('skills:', message.doc.skills.length, message.doc.skills[2])
            this.setState({
                doc: (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).calculateAllXp(message.doc, this.state.validated, this.state.doc)
            }, this.determineType);
        });
        this.GetApiKey();
    }
    componentWillUnmount() {
        // destroys the socket reference when connection closed
        this.socketRef.current?.disconnect();
    }
    // sends a message to the server that forwards it to all users in the room
    sendMessage = (request, callback = ()=>{})=>{
        // console.log('sendMessage');
        // beep(50, 220, 1, 'sine');
        this.socketRef.current.emit($865db2aeddff72c0$var$EDIT_MESSAGE_EVENT, {
            senderId: this.socketRef.current.id,
            request: request
        }, callback());
    };
    getTabName = (dir)=>{
        dir = dir.replace(/\/+$/, "");
        // console.log(dir);
        const loc = this.props.location.pathname;
        let tabName = loc.replace(dir, '');
        if (tabName === '') tabName = 'Summary';
        else tabName = tabName.replace('/', '');
        // console.log(tabName);
        return tabName;
    };
    renameDoc = (id, name, target)=>{
        this.sendMessage({
            operation: 'set doc name',
            name: name
        });
    };
    determineType = ()=>{
        // beep(10, 880, 1, 'sawtooth');
        let doc = this.state.doc;
        // console.log('determine type', doc.type);
        if (doc && doc.type) {
            let header = (0, $920954e343704e08$exports.capitalize)(doc.type);
            let hlink = '/' + doc.type + 's';
            // let docLink = `/${doc.type}/${doc._id}/`;
            // this.props.history.push(docLink);
            this.setState({
                header: header,
                hlink: hlink
            });
        }
    };
    apiCallOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
        },
        body: JSON.stringify({
            docId: this.props.docId
        })
    };
    GetApiKey = ()=>{
        // console.log('doc id', this.props.docId)
        fetch('/api/getapikey', this.apiCallOptions).then((res)=>res.json()).then((info)=>{
            // console.log('api key', info)
            this.setState({
                apiKey: info
            });
        });
    };
    RegenerateApiKey = ()=>{
        fetch('/api/regenerateapikey', this.apiCallOptions).then((res)=>res.json()).then((info)=>{
            // console.log(info)
            this.setState({
                apiKey: info
            });
        });
    };
    RemoveApiKey = ()=>{
        fetch('/api/removeapikey', this.apiCallOptions).then((res)=>res.json()).then((info)=>{
            // console.log(info)
            this.setState({
                apiKey: info
            });
        });
    };
    render() {
        const doc = this.state.doc;
        const tabs = [
            'Summary',
            'Edit',
            'Stats',
            'Entities',
            // 'Entity',
            'Print'
        ];
        const dir = `/doc/${this.docId}/`;
        const tabName = this.getTabName(dir);
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "SocketDocEdit",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h1", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            href: this.state.hlink,
                            children: this.state.header
                        }),
                        ":\xa0",
                        !doc.editable && doc.name,
                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $856fae2ccc0e87c3$export$2e2bcd8739ae039), {
                            name: doc.name || this.props.initialName,
                            id: doc._id,
                            renameCallback: this.renameDoc,
                            target: doc
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "docEditor",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "docNav",
                            children: tabs.map((key)=>{
                                let classes = 'button';
                                // console.log(tabName + ' vs ' + key);
                                if (tabName.toLowerCase() === key.toLowerCase() || tabName.toLowerCase() === '' && key === 'Summary') // console.log('active!');
                                classes += ' active';
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                    className: classes,
                                    to: dir + key,
                                    children: key
                                }, key);
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "docTab",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $14986c2201283622$export$b5d5cf8927ab7262), {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                                        exact: true,
                                        path: dir + 'Edit',
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f00ac48bfdebdc7f$export$2e2bcd8739ae039), {
                                            sendMessage: this.sendMessage,
                                            doc: doc,
                                            children: this.props.children,
                                            campaigns: this.props.campaigns,
                                            apiKey: this.state.apiKey,
                                            RegenerateApiKey: this.RegenerateApiKey,
                                            RemoveApiKey: this.RemoveApiKey
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                                        exact: true,
                                        path: dir + 'Stats',
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3324d8f10be24af7$export$2e2bcd8739ae039), {
                                            sendMessage: this.sendMessage,
                                            doc: doc
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                                        exact: true,
                                        path: dir + 'Rules',
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $39582558cec9d7af$export$2e2bcd8739ae039), {
                                            sendMessage: this.sendMessage,
                                            doc: doc
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                                        exact: true,
                                        path: dir + 'Entities',
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dd2c8f04fdc944d9$export$2e2bcd8739ae039), {
                                            sendMessage: this.sendMessage,
                                            doc: doc
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                                        path: dir + 'Entity/:EntityId',
                                        render: (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d240eace9648c3d7$export$2e2bcd8739ae039), {
                                                ...props,
                                                doc: doc,
                                                sendMessage: this.sendMessage
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                                        exact: true,
                                        path: dir + 'Print',
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $35e4f4a24e1e8d91$export$2e2bcd8739ae039), {
                                            sendMessage: this.sendMessage,
                                            doc: doc,
                                            apiKey: this.state.apiKey
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                                        path: "/",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $401741b852153534$export$2e2bcd8739ae039), {
                                            doc: doc,
                                            children: this.props.children,
                                            campaigns: this.props.campaigns
                                        })
                                    })
                                ]
                            })
                        }),
                        doc.editable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $feb1a49769fae5e2$export$2e2bcd8739ae039), {
                            dirty: doc.dirty,
                            sendMessage: this.sendMessage
                        })
                    ]
                })
            ]
        });
    }
}
var $865db2aeddff72c0$export$2e2bcd8739ae039 = $865db2aeddff72c0$var$SocketDocEdit;





// import Footer from "../Components/Footer";
class $7c0c76837a8d4d92$var$DocPage extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.id = this.props.match.params.DocId;
        this.state = {
            doc: undefined,
            campaigns: [],
            children: [],
            gettingDoc: true
        };
        this._isMounted = false;
    }
    componentDidMount() {
        this._isMounted = true;
        if (this._isMounted) {
            this.getDoc();
            this.getCampaigns();
            this.getChildDocs();
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    getDoc = ()=>{
        // console.log("client > get session")
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                gameid: this.id
            })
        };
        fetch('/api/getDoc', options).then((res)=>res.json()).then((info)=>{
            if (!info) return;
            let d = (0, $cd6dad6538e950c7$export$2e2bcd8739ae039).calculateAllXp(info, false);
            this.setState({
                doc: d
            }, this.determineType);
        }).catch((e)=>{
            console.error(e);
        });
    };
    getCampaigns = ()=>{
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                docid: this.id
            })
        };
        fetch('/api/getCampaignsUsingDoc', options).then((res)=>res.json()).then((info)=>{
            if (!info) return;
            this.setState({
                campaigns: info
            });
        });
    };
    getChildDocs = ()=>{
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                docid: this.id
            })
        };
        fetch('/api/getChildDocs', options).then((res)=>res.json()).then((info)=>{
            if (!info) return;
            this.setState({
                children: info
            });
        });
    };
    render() {
        const doc = this.state.doc;
        if (doc) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "container DocPage",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $865db2aeddff72c0$export$2e2bcd8739ae039), {
                docId: this.id,
                initialName: doc.name,
                children: this.state.children,
                campaigns: this.state.campaigns,
                location: this.props.location,
                determineType: this.determineType
            })
        });
        else return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "No Doc"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bbe2292908daaa2$export$2e2bcd8739ae039), {
                    fullpage: true
                })
            ]
        });
    }
}
var $7c0c76837a8d4d92$export$2e2bcd8739ae039 = $7c0c76837a8d4d92$var$DocPage;



parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

class $5b85aae29dd17ea2$var$HeadBranding extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    render() {
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "HeadBranding",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    src: "/sgs-logo-darkbg.svg",
                    alt: "Spiral Game System logo img",
                    onClick: this.props.ToggleNav,
                    className: "mobile"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                    to: "/",
                    className: "desktop darkbg",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: "/sgs-logo-darkbg.svg",
                        alt: "Spiral Game System logo 1"
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                    to: "/",
                    className: "desktop lightbg",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: "/sgs-logo-lightbg.svg",
                        alt: "Spiral Game System logo 2"
                    })
                })
            ]
        });
    }
}
var $5b85aae29dd17ea2$export$2e2bcd8739ae039 = $5b85aae29dd17ea2$var$HeadBranding;




const $dc6411c45f43b8c4$var$ToggleNav = ()=>{
    let nav = document.getElementById('nav');
    let hasShow = nav.classList.contains('show');
    if (hasShow) nav.classList.remove('show');
    else nav.classList.add('show');
};
function $dc6411c45f43b8c4$export$2e2bcd8739ae039(props) {
    let token = (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject();
    if (!!token) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5b85aae29dd17ea2$export$2e2bcd8739ae039), {
                ToggleNav: $dc6411c45f43b8c4$var$ToggleNav
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                id: "nav",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: "Dashboard"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                            to: "/user/" + token.user._id,
                                            children: "My Account"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            onClick: (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).removeToken,
                                            children: "logout"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                            to: "/docs",
                            children: "Docs"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                            to: "/campaigns",
                            children: "Campaigns"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                            to: "/lists",
                            children: "Lists"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                            to: "/users",
                            children: "Users"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            href: "https://voidspiral.gitlab.io/sgs-apps/docs/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "System Rules"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            href: "https://gitlab.com/voidspiral/sgs-web",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Bugs"
                        })
                    }),
                    (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject().user.userLevel === 'ADMIN' && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                            to: "/admin",
                            children: "Admin"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            href: "/ResetRequest",
                            children: "Reset Password"
                        })
                    })
                ]
            })
        ]
    });
    else return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5b85aae29dd17ea2$export$2e2bcd8739ae039), {
                ToggleNav: $dc6411c45f43b8c4$var$ToggleNav
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                id: "nav",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                            to: "/register",
                            children: "register"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                            to: "/login",
                            children: "login"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            href: "/ResetRequest",
                            children: "Reset Password"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                            to: "/Docs",
                            children: "Docs"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                            to: "/campaigns",
                            children: "Campaigns"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $235bffbda6f2a3d0$export$a6c7ac8248d6e38a), {
                            to: "/tags",
                            children: "tags"
                        })
                    })
                ]
            })
        ]
    });
}




var $bh6RR = parcelRequire("bh6RR");


var $0eafb92c9b65136c$exports = {};
'use strict';
const $0eafb92c9b65136c$var$BYTE_UNITS = [
    'B',
    'kB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB'
];
const $0eafb92c9b65136c$var$BIBYTE_UNITS = [
    'B',
    'kiB',
    'MiB',
    'GiB',
    'TiB',
    'PiB',
    'EiB',
    'ZiB',
    'YiB'
];
const $0eafb92c9b65136c$var$BIT_UNITS = [
    'b',
    'kbit',
    'Mbit',
    'Gbit',
    'Tbit',
    'Pbit',
    'Ebit',
    'Zbit',
    'Ybit'
];
const $0eafb92c9b65136c$var$BIBIT_UNITS = [
    'b',
    'kibit',
    'Mibit',
    'Gibit',
    'Tibit',
    'Pibit',
    'Eibit',
    'Zibit',
    'Yibit'
];
/*
Formats the given number using `Number#toLocaleString`.
- If locale is a string, the value is expected to be a locale-key (for example: `de`).
- If locale is true, the system default locale is used for translation.
- If no value for locale is specified, the number is returned unmodified.
*/ const $0eafb92c9b65136c$var$toLocaleString = (number, locale, options)=>{
    let result = number;
    if (typeof locale === 'string' || Array.isArray(locale)) result = number.toLocaleString(locale, options);
    else if (locale === true || options !== undefined) result = number.toLocaleString(undefined, options);
    return result;
};
$0eafb92c9b65136c$exports = (number, options)=>{
    if (!Number.isFinite(number)) throw new TypeError(`Expected a finite number, got ${typeof number}: ${number}`);
    options = Object.assign({
        bits: false,
        binary: false
    }, options);
    const UNITS = options.bits ? options.binary ? $0eafb92c9b65136c$var$BIBIT_UNITS : $0eafb92c9b65136c$var$BIT_UNITS : options.binary ? $0eafb92c9b65136c$var$BIBYTE_UNITS : $0eafb92c9b65136c$var$BYTE_UNITS;
    if (options.signed && number === 0) return ` 0 ${UNITS[0]}`;
    const isNegative = number < 0;
    const prefix = isNegative ? '-' : options.signed ? '+' : '';
    if (isNegative) number = -number;
    let localeOptions;
    if (options.minimumFractionDigits !== undefined) localeOptions = {
        minimumFractionDigits: options.minimumFractionDigits
    };
    if (options.maximumFractionDigits !== undefined) localeOptions = Object.assign({
        maximumFractionDigits: options.maximumFractionDigits
    }, localeOptions);
    if (number < 1) {
        const numberString = $0eafb92c9b65136c$var$toLocaleString(number, options.locale, localeOptions);
        return prefix + numberString + ' ' + UNITS[0];
    }
    const exponent = Math.min(Math.floor(options.binary ? Math.log(number) / Math.log(1024) : Math.log10(number) / 3), UNITS.length - 1);
    // eslint-disable-next-line unicorn/prefer-exponentiation-operator
    number /= Math.pow(options.binary ? 1024 : 1000, exponent);
    if (!localeOptions) number = number.toPrecision(3);
    const numberString = $0eafb92c9b65136c$var$toLocaleString(Number(number), options.locale, localeOptions);
    const unit = UNITS[exponent];
    return prefix + numberString + ' ' + unit;
};



class $b87c385142ef443b$var$AdminPage extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            data: {},
            admin: false
        };
    }
    componentDidMount() {
        const token = (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject();
        const isAdmin = token?.user.userLevel === 'ADMIN';
        this.setState({
            admin: isAdmin
        });
        if (isAdmin) this.getAdminData();
    }
    getAdminData = ()=>{
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.id
            })
        };
        fetch('/api/getAdminData', options).then((res)=>res.json()).then((info)=>{
            console.log(info);
            this.setState({
                data: info
            });
        });
    };
    deleteAllEventLogs = ()=>{
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getAuthHeader()
            },
            body: JSON.stringify({
                userId: this.id
            })
        };
        fetch('/api/deleteAllEventLogs', options).then((res)=>res.json()).then((info)=>{
            console.log(info);
            this.getAdminData();
        });
    };
    render() {
        const token = (0, $4d1d4c8be14450d6$export$2e2bcd8739ae039).getTokenObject();
        const data = this.state.data;
        // determine editing privelages
        const isAdmin = token?.user.userLevel === 'ADMIN';
        document.title = [
            'Admin',
            'SGS'
        ].join(' - ');
        if (!isAdmin) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                children: "Unauthorized"
            })
        });
        else {
            let totalSize = 0;
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                        children: "Site Administration"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                        children: "General Stats"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                children: [
                                    "Total Users: ",
                                    data.users
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                children: [
                                    "Logged In Users: ",
                                    data.loggedInUsers
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                children: [
                                    "Documents: ",
                                    data.docs
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                children: [
                                    "Open Documents: ",
                                    data.openDocs
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                children: [
                                    "Unsaved Documents: ",
                                    data.unsavedDocs
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                        children: "Doc Event Logs"
                    }),
                    !!data.eventStacks && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "eventList",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                className: "delete",
                                onClick: this.deleteAllEventLogs,
                                children: "Delete All Doc Event Logs"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                                children: [
                                    Object.keys(data.eventStacks).sort((a, b)=>{
                                        return data.eventStacks[a].size - data.eventStacks[b].size;
                                    }).map((key)=>{
                                        let eventStack = data.eventStacks[key];
                                        totalSize += eventStack.filesize;
                                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                            children: [
                                                eventStack.docName,
                                                ": ",
                                                (0, (/*@__PURE__*/$parcel$interopDefault($0eafb92c9b65136c$exports)))(eventStack.filesize)
                                            ]
                                        }, eventStack.docId);
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                                        children: [
                                            "Total Log Size: ",
                                            (0, (/*@__PURE__*/$parcel$interopDefault($0eafb92c9b65136c$exports)))(totalSize)
                                        ]
                                    })
                                ]
                            }),
                            Object.keys(data.eventStacks).map((key)=>{
                                let eventStack = data.eventStacks[key];
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h3", {
                                            children: [
                                                eventStack.docName,
                                                " (",
                                                (0, (/*@__PURE__*/$parcel$interopDefault($0eafb92c9b65136c$exports)))(eventStack.filesize),
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("pre", {
                                            children: eventStack.content
                                        })
                                    ]
                                }, eventStack.docId);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
                ]
            });
        }
    }
}
var $b87c385142ef443b$export$2e2bcd8739ae039 = $b87c385142ef443b$var$AdminPage;




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

var $b78ad8c31746b96b$var$_excluded = [
    "sitekey",
    "onChange",
    "theme",
    "type",
    "tabindex",
    "onExpired",
    "onErrored",
    "size",
    "stoken",
    "grecaptcha",
    "badge",
    "hl",
    "isolated"
];
function $b78ad8c31746b96b$var$_extends() {
    $b78ad8c31746b96b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b78ad8c31746b96b$var$_extends.apply(this, arguments);
}
function $b78ad8c31746b96b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b78ad8c31746b96b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b78ad8c31746b96b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $b78ad8c31746b96b$var$_setPrototypeOf(subClass, superClass);
}
function $b78ad8c31746b96b$var$_setPrototypeOf(o, p) {
    $b78ad8c31746b96b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b78ad8c31746b96b$var$_setPrototypeOf(o, p);
}
var $b78ad8c31746b96b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    $b78ad8c31746b96b$var$_inheritsLoose(ReCAPTCHA, _React$Component);
    function ReCAPTCHA() {
        var _this;
        _this = _React$Component.call(this) || this;
        _this.handleExpired = _this.handleExpired.bind($b78ad8c31746b96b$var$_assertThisInitialized(_this));
        _this.handleErrored = _this.handleErrored.bind($b78ad8c31746b96b$var$_assertThisInitialized(_this));
        _this.handleChange = _this.handleChange.bind($b78ad8c31746b96b$var$_assertThisInitialized(_this));
        _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind($b78ad8c31746b96b$var$_assertThisInitialized(_this));
        return _this;
    }
    var _proto = ReCAPTCHA.prototype;
    _proto.getCaptchaFunction = function getCaptchaFunction(fnName) {
        if (this.props.grecaptcha) {
            if (this.props.grecaptcha.enterprise) return this.props.grecaptcha.enterprise[fnName];
            return this.props.grecaptcha[fnName];
        }
        return null;
    };
    _proto.getValue = function getValue() {
        var getResponse = this.getCaptchaFunction("getResponse");
        if (getResponse && this._widgetId !== undefined) return getResponse(this._widgetId);
        return null;
    };
    _proto.getWidgetId = function getWidgetId() {
        if (this.props.grecaptcha && this._widgetId !== undefined) return this._widgetId;
        return null;
    };
    _proto.execute = function execute() {
        var execute = this.getCaptchaFunction("execute");
        if (execute && this._widgetId !== undefined) return execute(this._widgetId);
        else this._executeRequested = true;
    };
    _proto.executeAsync = function executeAsync() {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.executionResolve = resolve;
            _this2.executionReject = reject;
            _this2.execute();
        });
    };
    _proto.reset = function reset() {
        var resetter = this.getCaptchaFunction("reset");
        if (resetter && this._widgetId !== undefined) resetter(this._widgetId);
    };
    _proto.forceReset = function forceReset() {
        var resetter = this.getCaptchaFunction("reset");
        if (resetter) resetter();
    };
    _proto.handleExpired = function handleExpired() {
        if (this.props.onExpired) this.props.onExpired();
        else this.handleChange(null);
    };
    _proto.handleErrored = function handleErrored() {
        if (this.props.onErrored) this.props.onErrored();
        if (this.executionReject) {
            this.executionReject();
            delete this.executionResolve;
            delete this.executionReject;
        }
    };
    _proto.handleChange = function handleChange(token) {
        if (this.props.onChange) this.props.onChange(token);
        if (this.executionResolve) {
            this.executionResolve(token);
            delete this.executionReject;
            delete this.executionResolve;
        }
    };
    _proto.explicitRender = function explicitRender() {
        var render = this.getCaptchaFunction("render");
        if (render && this._widgetId === undefined) {
            var wrapper = document.createElement("div");
            this._widgetId = render(wrapper, {
                sitekey: this.props.sitekey,
                callback: this.handleChange,
                theme: this.props.theme,
                type: this.props.type,
                tabindex: this.props.tabindex,
                "expired-callback": this.handleExpired,
                "error-callback": this.handleErrored,
                size: this.props.size,
                stoken: this.props.stoken,
                hl: this.props.hl,
                badge: this.props.badge,
                isolated: this.props.isolated
            });
            this.captcha.appendChild(wrapper);
        }
        if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
            this._executeRequested = false;
            this.execute();
        }
    };
    _proto.componentDidMount = function componentDidMount() {
        this.explicitRender();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        this.explicitRender();
    };
    _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
        this.captcha = elem;
    };
    _proto.render = function render() {
        // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
        /* eslint-disable no-unused-vars */ var _this$props = this.props, sitekey = _this$props.sitekey, onChange = _this$props.onChange, theme = _this$props.theme, type = _this$props.type, tabindex = _this$props.tabindex, onExpired = _this$props.onExpired, onErrored = _this$props.onErrored, size = _this$props.size, stoken = _this$props.stoken, grecaptcha = _this$props.grecaptcha, badge = _this$props.badge, hl = _this$props.hl, isolated = _this$props.isolated, childProps = $b78ad8c31746b96b$var$_objectWithoutPropertiesLoose(_this$props, $b78ad8c31746b96b$var$_excluded);
        /* eslint-enable no-unused-vars */ return /*#__PURE__*/ $bh6RR.createElement("div", $b78ad8c31746b96b$var$_extends({}, childProps, {
            ref: this.handleRecaptchaRef
        }));
    };
    return ReCAPTCHA;
}($bh6RR.Component);
$b78ad8c31746b96b$export$2e2bcd8739ae039.displayName = "ReCAPTCHA";
$b78ad8c31746b96b$export$2e2bcd8739ae039.propTypes = {
    sitekey: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    grecaptcha: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        "dark",
        "light"
    ]),
    type: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        "image",
        "audio"
    ]),
    tabindex: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
    onExpired: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    onErrored: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        "compact",
        "normal",
        "invisible"
    ]),
    stoken: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    hl: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    badge: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        "bottomright",
        "bottomleft",
        "inline"
    ]),
    isolated: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool
};
$b78ad8c31746b96b$export$2e2bcd8739ae039.defaultProps = {
    onChange: function onChange() {},
    theme: "light",
    type: "image",
    tabindex: 0,
    size: "normal",
    badge: "bottomright"
};



var $bh6RR = parcelRequire("bh6RR");


function $a94f79e37dbd7b36$var$_extends() {
    $a94f79e37dbd7b36$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a94f79e37dbd7b36$var$_extends.apply(this, arguments);
}
function $a94f79e37dbd7b36$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a94f79e37dbd7b36$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $a94f79e37dbd7b36$var$SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
var $a94f79e37dbd7b36$var$idCount = 0;
function $a94f79e37dbd7b36$export$2e2bcd8739ae039(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var AsyncScriptLoader = /*#__PURE__*/ function(_Component) {
            $a94f79e37dbd7b36$var$_inheritsLoose(AsyncScriptLoader, _Component);
            function AsyncScriptLoader(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.state = {};
                _this.__scriptURL = "";
                return _this;
            }
            var _proto = AsyncScriptLoader.prototype;
            _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
                if (!this.__scriptLoaderID) this.__scriptLoaderID = "async-script-loader-" + $a94f79e37dbd7b36$var$idCount++;
                return this.__scriptLoaderID;
            };
            _proto.setupScriptURL = function setupScriptURL() {
                this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
                return this.__scriptURL;
            };
            _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
                var _this2 = this;
                // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
                this.setState(state, function() {
                    return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
                });
            };
            _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
                var mapEntry = $a94f79e37dbd7b36$var$SCRIPT_MAP[this.__scriptURL];
                if (!mapEntry || !mapEntry.loaded) throw new Error("Script is not loaded.");
                for(var obsKey in mapEntry.observers)mapEntry.observers[obsKey](mapEntry);
                delete window[options.callbackName];
            };
            _proto.componentDidMount = function componentDidMount() {
                var _this3 = this;
                var scriptURL = this.setupScriptURL();
                var key = this.asyncScriptLoaderGetScriptLoaderID();
                var _options = options, globalName = _options.globalName, callbackName = _options.callbackName, scriptId = _options.scriptId; // check if global object already attached to window
                if (globalName && typeof window[globalName] !== "undefined") $a94f79e37dbd7b36$var$SCRIPT_MAP[scriptURL] = {
                    loaded: true,
                    observers: {}
                };
                 // check if script loading already
                if ($a94f79e37dbd7b36$var$SCRIPT_MAP[scriptURL]) {
                    var entry = $a94f79e37dbd7b36$var$SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
                    if (entry && (entry.loaded || entry.errored)) {
                        this.asyncScriptLoaderHandleLoad(entry);
                        return;
                    } // if still loading then callback to observer queue
                    entry.observers[key] = function(entry) {
                        return _this3.asyncScriptLoaderHandleLoad(entry);
                    };
                    return;
                }
                /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */ var observers = {};
                observers[key] = function(entry) {
                    return _this3.asyncScriptLoaderHandleLoad(entry);
                };
                $a94f79e37dbd7b36$var$SCRIPT_MAP[scriptURL] = {
                    loaded: false,
                    observers: observers
                };
                var script = document.createElement("script");
                script.src = scriptURL;
                script.async = true;
                for(var attribute in options.attributes)script.setAttribute(attribute, options.attributes[attribute]);
                if (scriptId) script.id = scriptId;
                var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
                    if ($a94f79e37dbd7b36$var$SCRIPT_MAP[scriptURL]) {
                        var mapEntry = $a94f79e37dbd7b36$var$SCRIPT_MAP[scriptURL];
                        var observersMap = mapEntry.observers;
                        for(var obsKey in observersMap)if (func(observersMap[obsKey])) delete observersMap[obsKey];
                    }
                };
                if (callbackName && typeof window !== "undefined") window[callbackName] = function() {
                    return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
                };
                script.onload = function() {
                    var mapEntry = $a94f79e37dbd7b36$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.loaded = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            if (callbackName) return false;
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                script.onerror = function() {
                    var mapEntry = $a94f79e37dbd7b36$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.errored = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                document.body.appendChild(script);
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                // Remove tag script
                var scriptURL = this.__scriptURL;
                if (options.removeOnUnmount === true) {
                    var allScripts = document.getElementsByTagName("script");
                    for(var i = 0; i < allScripts.length; i += 1){
                        if (allScripts[i].src.indexOf(scriptURL) > -1) {
                            if (allScripts[i].parentNode) allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                } // Clean the observer entry
                var mapEntry = $a94f79e37dbd7b36$var$SCRIPT_MAP[scriptURL];
                if (mapEntry) {
                    delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
                    if (options.removeOnUnmount === true) delete $a94f79e37dbd7b36$var$SCRIPT_MAP[scriptURL];
                }
            };
            _proto.render = function render() {
                var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
                var _this$props = this.props, asyncScriptOnLoad = _this$props.asyncScriptOnLoad, forwardedRef = _this$props.forwardedRef, childProps = $a94f79e37dbd7b36$var$_objectWithoutPropertiesLoose(_this$props, [
                    "asyncScriptOnLoad",
                    "forwardedRef"
                ]); // eslint-disable-line no-unused-vars
                if (globalName && typeof window !== "undefined") childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
                childProps.ref = forwardedRef;
                return (0, $bh6RR.createElement)(WrappedComponent, childProps);
            };
            return AsyncScriptLoader;
        }((0, $bh6RR.Component)); // Note the second param "ref" provided by React.forwardRef.
        // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
        // And it can then be attached to the Component.
        var ForwardedComponent = (0, $bh6RR.forwardRef)(function(props, ref) {
            return (0, $bh6RR.createElement)(AsyncScriptLoader, $a94f79e37dbd7b36$var$_extends({}, props, {
                forwardedRef: ref
            }));
        });
        ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
        ForwardedComponent.propTypes = {
            asyncScriptOnLoad: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($770bbfe5492d7fd4$exports)))(ForwardedComponent, WrappedComponent);
    };
}


var $e062157bcde27df9$var$callbackName = "onloadcallback";
var $e062157bcde27df9$var$globalName = "grecaptcha";
function $e062157bcde27df9$var$getOptions() {
    return typeof window !== "undefined" && window.recaptchaOptions || {};
}
function $e062157bcde27df9$var$getURL() {
    var dynamicOptions = $e062157bcde27df9$var$getOptions();
    var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
    if (dynamicOptions.enterprise) return "https://" + hostname + "/recaptcha/enterprise.js?onload=" + $e062157bcde27df9$var$callbackName + "&render=explicit";
    return "https://" + hostname + "/recaptcha/api.js?onload=" + $e062157bcde27df9$var$callbackName + "&render=explicit";
}
var $e062157bcde27df9$export$2e2bcd8739ae039 = (0, $a94f79e37dbd7b36$export$2e2bcd8739ae039)($e062157bcde27df9$var$getURL, {
    callbackName: $e062157bcde27df9$var$callbackName,
    globalName: $e062157bcde27df9$var$globalName,
    attributes: $e062157bcde27df9$var$getOptions().nonce ? {
        nonce: $e062157bcde27df9$var$getOptions().nonce
    } : {}
})((0, $b78ad8c31746b96b$export$2e2bcd8739ae039));



var $7d6f7afecbe65fd6$export$2e2bcd8739ae039 = (0, $e062157bcde27df9$export$2e2bcd8739ae039);



const $3b515eba02333c6f$var$captchaKey = '6LdDpN0pAAAAADkNidzIco4X8lWzI4ZH7MmY_AWY';
const $3b515eba02333c6f$var$captchaRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createRef();
function $3b515eba02333c6f$var$onChange(value, setCompleted) {
    console.log('captcha:', value);
    let email = document.getElementById('emailAddress').value;
    console.log(email);
    setCompleted(true);
    fetch('/api/resetpasswordrequest', {
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
            email: email,
            captcha: value
        })
    }).then((res)=>{
        console.log('completed');
        res.json();
    });
}
function $3b515eba02333c6f$export$2e2bcd8739ae039(props) {
    const [completed, setCompleted] = (0, $bh6RR.useState)(false);
    if (completed) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                children: "Password Reset Request Sent"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: "You should receive an email from Voidspiral.com in a few minutes with instructions to reset your password."
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
        ]
    });
    else return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                children: "Request Password Reset"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7d6f7afecbe65fd6$export$2e2bcd8739ae039), {
                ref: $3b515eba02333c6f$var$captchaRef,
                sitekey: $3b515eba02333c6f$var$captchaKey,
                size: "invisible",
                onChange: (e)=>$3b515eba02333c6f$var$onChange(e, setCompleted)
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
                className: "reset",
                onSubmit: (e)=>{
                    e.preventDefault();
                    $3b515eba02333c6f$var$captchaRef.current.execute();
                },
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                        children: [
                            "Email\xa0",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                type: "email",
                                required: true,
                                id: "emailAddress"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        type: "submit",
                        children: "Request Password Reset"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
        ]
    });
}




var $bh6RR = parcelRequire("bh6RR");



var $aO8Ot = parcelRequire("aO8Ot");
function $eb38a0ddc5a5991b$var$validateMatch(e, setMatch, setTimeValid, setEmailValid, setPassLong, setEnableButton, expirationDate, emailHash) {
    let passwordA = document.getElementById('passworda').value;
    let passwordB = document.getElementById('passwordb').value;
    let email = document.getElementById('email').value;
    let now = new Date();
    console.log(document.getElementById('email').validity);
    let ready = true;
    let enteredEmailHash = (0, (/*@__PURE__*/$parcel$interopDefault($aO8Ot))).createHash('sha256').update(email).digest('hex');
    let emailHashesMatch = emailHash === enteredEmailHash;
    if (passwordA === passwordB && passwordA.length > 0) setMatch(true);
    else {
        setMatch(false);
        ready = false;
    }
    if (expirationDate >= now) setTimeValid(true);
    else {
        setTimeValid(false);
        ready = false;
    }
    if (email.includes('.') && email.includes('@') && emailHashesMatch) setEmailValid(true);
    else {
        setEmailValid(false);
        ready = false;
    }
    if (passwordA.length >= 10 && passwordA.length <= 64) setPassLong(true);
    else {
        setPassLong(false);
        ready = false;
    }
    setEnableButton(ready);
}
function $eb38a0ddc5a5991b$var$submit(setSubmitted, setCompletionMessage, token, email) {
    let password = document.getElementById('passworda').value;
    setSubmitted(true);
    password = btoa(password);
    email = btoa(email);
    console.log();
    fetch('/api/performpasswordchange', {
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
            email: email,
            password: password,
            token: token
        })
    }).then((res)=>res.json()).then((res)=>{
        console.log(res);
        setCompletionMessage(res);
    });
}
function $eb38a0ddc5a5991b$export$2e2bcd8739ae039(props) {
    const urlsearch = window.location.search;
    // console.log(urlsearch);
    const params = new URLSearchParams(urlsearch);
    // console.log(params);
    const emailHash = params.get('etoken');
    const tokenText = params.get('ttoken');
    let now = new Date();
    const expirationDate = Date.parse(params.get('exp'));
    let expired = now > expirationDate;
    let email = document.getElementById('email')?.value;
    const [match, setMatch] = (0, $bh6RR.useState)(false);
    const [timeValid, setTimeValid] = (0, $bh6RR.useState)(!expired);
    const [emailValid, setEmailValid] = (0, $bh6RR.useState)(false);
    const [passLong, setPassLong] = (0, $bh6RR.useState)(false);
    const [enableButton, setEnableButton] = (0, $bh6RR.useState)(false);
    const [submitted, setSubmitted] = (0, $bh6RR.useState)(false);
    const [completionMessage, setCompletionMessage] = (0, $bh6RR.useState)(null);
    // console.log(emailHash, tokenHash, expirationDate);
    if (!emailHash || !tokenText) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                children: "Malformed Request"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                children: [
                    "There was an error with your request. Please try again: ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: "/ResetRequest",
                        children: "Reset Password"
                    })
                ]
            })
        ]
    });
    if (!expirationDate || expired) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                children: "Password Reset"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                children: [
                    "This reset token has expired. Please try again: ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: "/ResetRequest",
                        children: "Reset Password"
                    })
                ]
            })
        ]
    });
    if (completionMessage) {
        if (completionMessage.completion === true) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "Password Reset Completed"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                    children: "Password Reset."
                })
            ]
        });
        else return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    children: "Password Reset Failed"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                    children: [
                        "Please try again: ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            href: "/ResetRequest",
                            children: "Reset Password"
                        })
                    ]
                })
            ]
        });
    }
    if (submitted) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                children: "Password Reset Submitted"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: "Waiting for server confirmation."
            })
        ]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                children: "Reset Password"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                children: [
                    "We recommend ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: "https://www.useapassphrase.com/",
                        target: "_blank",
                        children: "using a passphrase."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: "We also recommend using a password manager, such as Bitwarden or Lastpass."
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
                className: "reset",
                onSubmit: ()=>$eb38a0ddc5a5991b$var$submit(setSubmitted, setCompletionMessage, tokenText, email),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                        children: [
                            "Email\xa0",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                id: "email",
                                type: "email",
                                required: true,
                                onChange: (e)=>$eb38a0ddc5a5991b$var$validateMatch(e, setMatch, setTimeValid, setEmailValid, setPassLong, setEnableButton, expirationDate, emailHash)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                        children: [
                            "New Password\xa0",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                id: "passworda",
                                type: "text",
                                required: true,
                                onChange: (e)=>$eb38a0ddc5a5991b$var$validateMatch(e, setMatch, setTimeValid, setEmailValid, setPassLong, setEnableButton, expirationDate, emailHash)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                        children: [
                            "Confirm New Password\xa0",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                id: "passwordb",
                                type: "text",
                                required: true,
                                onChange: (e)=>$eb38a0ddc5a5991b$var$validateMatch(e, setMatch, setTimeValid, setEmailValid, setPassLong, setEnableButton, expirationDate, emailHash)
                            })
                        ]
                    }),
                    emailValid && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: "\u2714\uFE0F Email is Valid"
                    }),
                    !emailValid && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: "\u274C Email is Invalid"
                    }),
                    match && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: "\u2714\uFE0F Passwords Match"
                    }),
                    !match && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: "\u274C Passwords Don't Match"
                    }),
                    passLong && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: "\u2714\uFE0F Password is is between 10 and 64"
                    }),
                    !passLong && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: "\u274C Password Length not between 10 and 64"
                    }),
                    timeValid && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: "\u2714\uFE0F Token Hasn't Expired"
                    }),
                    !timeValid && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: "\u274C Passwords Has Expired"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        type: "submit",
                        disabled: !enableButton,
                        children: "Submit Password Change"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $56eb3e51d48a7263$export$2e2bcd8739ae039), {})
        ]
    });
}


function $aa831a3b70830250$var$App() {
    // redirect to secure HTTPS connection if insecure
    let isHttps = document.location.protocol === 'https:';
    if (!isHttps && !window.location.href.startsWith('http://localhost') && !window.location.href.startsWith('http://192.168')) {
        let newUrl = window.location.href.replace('http:', 'https:');
        console.log('connection insecure. Redirecting to ' + newUrl);
        window.location.replace(newUrl);
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                        children: "Connection Insecure \u26A0\uFE0F"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                        children: "You are connected by HTTP instead of HTTPS. We're redirecting you for security."
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $235bffbda6f2a3d0$export$9ba4e89fdfa1fc54), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $14986c2201283622$export$b5d5cf8927ab7262), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/",
                            component: (0, $afdd361da3e56bef$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/Login",
                            component: (0, $eb275368faae4e12$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/Register",
                            component: (0, $37dae4e099f2b2e6$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/Users",
                            component: (0, $ad9b06e062a32248$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            path: "/User/:UserId",
                            component: (0, $f8518f49b8182f77$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/Campaigns",
                            component: (0, $1fbc42e99b7590b9$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            path: "/Campaign/:CampaignId",
                            component: (0, $fcf132517feeaa69$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/Lists",
                            component: (0, $2b520f47dd43df37$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            path: "/List/:ListId",
                            component: (0, $8c394cee192ad531$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/Docs",
                            render: (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $99ed9bc86e0b87b0$export$2e2bcd8739ae039), {
                                    ...props,
                                    type: ""
                                })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            path: "/Doc/:DocId",
                            component: (0, $7c0c76837a8d4d92$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/Games",
                            render: (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $99ed9bc86e0b87b0$export$2e2bcd8739ae039), {
                                    ...props,
                                    type: "game"
                                })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            path: [
                                "/Game/:DocId",
                                "/Doc/:DocId"
                            ],
                            component: (0, $7c0c76837a8d4d92$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/Mods",
                            render: (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $99ed9bc86e0b87b0$export$2e2bcd8739ae039), {
                                    ...props,
                                    type: "mod"
                                })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            path: [
                                "/Mod/:DocId",
                                "/Doc/:DocId"
                            ],
                            component: (0, $7c0c76837a8d4d92$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/Drafts",
                            render: (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $99ed9bc86e0b87b0$export$2e2bcd8739ae039), {
                                    ...props,
                                    type: "draft"
                                })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            path: [
                                "/Draft/:DocId",
                                "/Doc/:DocId"
                            ],
                            component: (0, $7c0c76837a8d4d92$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/Tags",
                            component: (0, $d327ab3a7b09bc26$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            path: "/Tag/:TagName",
                            component: (0, $d404b76082c25d5d$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/Status",
                            component: (0, $4afc36bb4ad0795e$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/Admin",
                            component: (0, $b87c385142ef443b$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/ResetRequest",
                            component: (0, $3b515eba02333c6f$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: "/ResetExecution",
                            component: (0, $eb38a0ddc5a5991b$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $14986c2201283622$export$e7b0ac011bb776c6), {
                            component: (0, $bf8ecfb2c8182fa3$export$2e2bcd8739ae039)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "navpane",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dc6411c45f43b8c4$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
}
var $aa831a3b70830250$export$2e2bcd8739ae039 = $aa831a3b70830250$var$App;


const $1add8a326c740301$var$container = document.getElementById("app");
const $1add8a326c740301$var$root = (0, $6fc264ec92100d3a$export$882461b6382ed46c)($1add8a326c740301$var$container);
$1add8a326c740301$var$root.render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $aa831a3b70830250$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=client.4f6e995c.js.map
